// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./error.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./number-scrollbar.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./kbb-book-sheet.css";
import ___CSS_LOADER_AT_RULE_IMPORT_3___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./kbb-all-values.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAATCAQAAADYWf5HAAAAkElEQVQoz7X QMQ5AQBCF4dWQSJxC5wwax1Cq1e7BAdxD5SL+Tq/QCM1oNiJidwox0355mXnG/DrEtIQ6azioNZQxI0ykPhTQIwhCR+BmBYtlK7kLJYwWCcJA9M4qdrZrd8pPjZWPtOqdRQy320YSV17OatFC4euts6z39GYMKRPCTKY9UnPQ6P+GtMRfGtPnBCiqhAeJPmkqAAAAAElFTkSuQmCC", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAATCAYAAAByUDbMAAAAZ0lEQVQ4y2NgGLKgquEuFxBPAGI2ahhWCsS/gDibUoO0gPgxEP8H4ttArEyuQYxAPBdqEAxPBImTY5gjEL9DM+wTENuQahAvEO9DMwiGdwAxOymGJQLxTyD+jgWDxCMZRsEoGAVoAADeemwtPcZI2wAAAABJRU5ErkJggg==", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAATCAYAAAByUDbMAAAAZUlEQVQ4y2NgGAWjYBSggaqGu5FA/BOIv2PBIPFEUgxjB+IdQPwfC94HxLykus4GiD+hGfQOiB3J8SojEE9EM2wuSJzcsFMG4ttQgx4DsRalkZENxL+AuJQaMcsGxBOAmGvopk8AVz1sLZgg0bsAAAAASUVORK5CYII=", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/gif;base64,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", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("assets/fonts/nucleo-icons.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("assets/fonts/nucleo-icons.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("assets/fonts/nucleo-icons.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("assets/fonts/nucleo-icons.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/*!

 =========================================================
 * DealerClick 2.0 React - v1.2.0 based on Paper Dashboard 2 Pro - v2.0.1
 =========================================================

 * Product Page: https://dealerclick.com
 * Copyright 2020 DealerClick (http://dealerclick.com)

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

 */
.bootstrap-switch {
	display: inline-block;
	direction: ltr;
	cursor: pointer;
	border-radius: 30px;
	border: 0;
	position: relative;
	text-align: left;
	overflow: hidden;
	margin-bottom: 5px;
	line-height: 8px;
	width: 61px !important;
	height: 26px;
	outline: none;
	z-index: 0;
	margin-right: 1px;
	-webkit-user-select: none;
	user-select: none;
	vertical-align: middle;
	transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
}

.bootstrap-switch .bootstrap-switch-container {
	display: inline-flex;
	top: 0;
	height: 26px;
	border-radius: 4px;
	transform: translate3d(0, 0, 0);
	width: 100px !important;
}

.bootstrap-switch .bootstrap-switch-handle-on,
.bootstrap-switch .bootstrap-switch-handle-off,
.bootstrap-switch .bootstrap-switch-label {
	box-sizing: border-box;
	cursor: pointer;
	display: inline-block !important;
	height: 100%;
	color: #fff;
	padding: 6px 10px;
	font-size: 11px;
	text-indent: -5px;
	line-height: 15px;
	transition: 0.25s ease-out;
}
.bootstrap-switch .bootstrap-switch-handle-on i,
.bootstrap-switch .bootstrap-switch-handle-off i,
.bootstrap-switch .bootstrap-switch-label i {
	font-size: 12px;
	line-height: 14px;
}

.bootstrap-switch .bootstrap-switch-handle-on,
.bootstrap-switch .bootstrap-switch-handle-off {
	text-align: center;
	z-index: 1;
	float: left;
	width: 50% !important;
	background-color: #66615b;
}

.bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-primary,
.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-primary {
	color: #fff;
	background: #7a9e9f;
}

.bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-info,
.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-info {
	color: #fff;
	background: #68b3c8;
}

.bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-success,
.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-success {
	color: #fff;
	background: #7ac29a;
}

.bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-warning,
.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-warning {
	background: #f3bb45;
	color: #fff;
}

.bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-danger,
.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-danger {
	color: #fff;
	background: #eb5e28;
}

.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-default {
	color: #fff;
	background: #cfcfca;
}

.bootstrap-switch .bootstrap-switch-label {
	text-align: center;
	z-index: 100;
	color: #333333;
	background: #ffffff;
	width: 22px !important;
	height: 22px;
	margin: 2px -11px;
	border-radius: 12px;
	position: relative;
	float: left;
	padding: 0;
	background-color: #ffffff;
	box-shadow: 0 1px 1px #ffffff inset, 0 1px 1px rgba(0, 0, 0, 0.25);
}

.bootstrap-switch .bootstrap-switch-handle-on {
	border-bottom-left-radius: 3px;
	border-top-left-radius: 3px;
}

.bootstrap-switch .bootstrap-switch-handle-off {
	text-indent: 6px;
}

.bootstrap-switch input[type="radio"],
.bootstrap-switch input[type="checkbox"] {
	position: absolute !important;
	top: 0;
	left: 0;
	opacity: 0;
	filter: alpha(opacity=0);
	z-index: -1;
}

.bootstrap-switch input[type="radio"].form-control,
.bootstrap-switch input[type="checkbox"].form-control {
	height: auto;
}

.bootstrap-switch.bootstrap-switch-mini .bootstrap-switch-handle-on,
.bootstrap-switch.bootstrap-switch-mini .bootstrap-switch-handle-off,
.bootstrap-switch.bootstrap-switch-mini .bootstrap-switch-label {
	padding: 1px 5px;
	font-size: 12px;
	line-height: 1.5;
}

.bootstrap-switch.bootstrap-switch-small .bootstrap-switch-handle-on,
.bootstrap-switch.bootstrap-switch-small .bootstrap-switch-handle-off,
.bootstrap-switch.bootstrap-switch-small .bootstrap-switch-label {
	padding: 5px 10px;
	font-size: 12px;
	line-height: 1.5;
}

.bootstrap-switch.bootstrap-switch-large .bootstrap-switch-handle-on,
.bootstrap-switch.bootstrap-switch-large .bootstrap-switch-handle-off,
.bootstrap-switch.bootstrap-switch-large .bootstrap-switch-label {
	padding: 6px 16px;
	font-size: 18px;
	line-height: 1.33;
}

.bootstrap-switch.bootstrap-switch-disabled,
.bootstrap-switch.bootstrap-switch-readonly,
.bootstrap-switch.bootstrap-switch-indeterminate {
	cursor: default !important;
}

.bootstrap-switch.bootstrap-switch-disabled .bootstrap-switch-handle-on,
.bootstrap-switch.bootstrap-switch-readonly .bootstrap-switch-handle-on,
.bootstrap-switch.bootstrap-switch-indeterminate .bootstrap-switch-handle-on,
.bootstrap-switch.bootstrap-switch-disabled .bootstrap-switch-handle-off,
.bootstrap-switch.bootstrap-switch-readonly .bootstrap-switch-handle-off,
.bootstrap-switch.bootstrap-switch-indeterminate .bootstrap-switch-handle-off,
.bootstrap-switch.bootstrap-switch-disabled .bootstrap-switch-label,
.bootstrap-switch.bootstrap-switch-readonly .bootstrap-switch-label,
.bootstrap-switch.bootstrap-switch-indeterminate .bootstrap-switch-label {
	opacity: 0.5;
	filter: alpha(opacity=50);
	cursor: default !important;
}

.bootstrap-switch.bootstrap-switch-animate .bootstrap-switch-container {
	transition: margin-left 0.5s;
}

.bootstrap-switch.bootstrap-switch-inverse .bootstrap-switch-handle-on {
	border-bottom-left-radius: 0;
	border-top-left-radius: 0;
	border-bottom-right-radius: 3px;
	border-top-right-radius: 3px;
}

.bootstrap-switch.bootstrap-switch-inverse .bootstrap-switch-handle-off {
	border-bottom-right-radius: 0;
	border-top-right-radius: 0;
	border-bottom-left-radius: 3px;
	border-top-left-radius: 3px;
}

.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-container {
	margin-left: -2px !important;
}

.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-container {
	margin-left: -37px !important;
}

.bootstrap-switch.bootstrap-switch-on:hover .bootstrap-switch-label {
	width: 26px !important;
	margin: 2px -15px;
}

.bootstrap-switch.bootstrap-switch-off:hover .bootstrap-switch-label {
	width: 26px !important;
	margin: 2px -15px -13px -11px;
}

.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-handle-off {
	background-color: #66615b;
}

.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-handle-on {
	background-color: #cfcfca;
}

.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-danger {
	background-color: #eb5e28;
}

.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-warning {
	background-color: #f3bb45;
}

.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-success {
	background-color: #7ac29a;
}

.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-primary {
	background-color: #7a9e9f;
}

.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-info {
	background-color: #68b3c8;
}

.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-default {
	background-color: #66615b;
}

.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-danger,
.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-primary,
.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-info,
.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-warning,
.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-success {
	background-color: #cfcfca;
}

/**
 * @author zhixin wen <wenzhixin2010@gmail.com>
 * version: 1.12.1
 * https://github.com/wenzhixin/bootstrap-table/
 */
.bootstrap-table .table {
	margin-bottom: 0 !important;
	border-bottom: 1px solid #dddddd;
	border-collapse: collapse !important;
	border-radius: 1px;
}

.bootstrap-table .table:not(.table-condensed),
.bootstrap-table .table:not(.table-condensed) > tbody > tr > th,
.bootstrap-table .table:not(.table-condensed) > tfoot > tr > th,
.bootstrap-table .table:not(.table-condensed) > thead > tr > td,
.bootstrap-table .table:not(.table-condensed) > tbody > tr > td,
.bootstrap-table .table:not(.table-condensed) > tfoot > tr > td {
	padding: 8px;
}

.bootstrap-table .table.table-no-bordered > thead > tr > th,
.bootstrap-table .table.table-no-bordered > tbody > tr > td {
	border-right: 2px solid transparent;
}

.bootstrap-table .table.table-no-bordered > tbody > tr > td:last-child {
	border-right: none;
}

.fixed-table-container {
	position: relative;
	clear: both;
	border: 1px solid #dddddd;
	border-radius: 4px;
	-webkit-border-radius: 4px;
	-moz-border-radius: 4px;
}

.fixed-table-container.table-no-bordered {
	border: 1px solid transparent;
}

.fixed-table-footer,
.fixed-table-header {
	overflow: hidden;
}

.fixed-table-footer {
	border-top: 1px solid #dddddd;
}

.fixed-table-body {
	overflow-x: auto;
	overflow-y: auto;
	height: 100%;
}

.fixed-table-container table {
	width: 100%;
}

.fixed-table-container thead th {
	height: 0;
	padding: 0;
	margin: 0;
	border-left: 1px solid #dddddd;
}

.fixed-table-container thead th:focus {
	outline: 0 solid transparent;
}

.fixed-table-container thead th:first-child:not([data-not-first-th]) {
	border-left: none;
	border-top-left-radius: 4px;
	-webkit-border-top-left-radius: 4px;
	-moz-border-radius-topleft: 4px;
}

.fixed-table-container thead th .th-inner,
.fixed-table-container tbody td .th-inner {
	padding: 8px;
	line-height: 24px;
	vertical-align: top;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.fixed-table-container thead th .sortable {
	cursor: pointer;
	background-position: right;
	background-repeat: no-repeat;
	padding-right: 30px;
}

.fixed-table-container thead th .both {
	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.fixed-table-container thead th .asc {
	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.fixed-table-container thead th .desc {
	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

.fixed-table-container th.detail {
	width: 30px;
}

.fixed-table-container tbody td {
	border-left: 1px solid #dddddd;
}

.fixed-table-container tbody tr:first-child td {
	border-top: none;
}

.fixed-table-container tbody td:first-child {
	border-left: none;
}

/* the same color with .active */
.fixed-table-container tbody .selected td {
	background-color: #f5f5f5;
}

.fixed-table-container .bs-checkbox {
	text-align: center;
}

.fixed-table-container input[type="radio"],
.fixed-table-container input[type="checkbox"] {
	margin: 0 auto !important;
}

.fixed-table-container .no-records-found {
	text-align: center;
}

.fixed-table-pagination div.pagination,
.fixed-table-pagination .pagination-detail {
	margin-top: 10px;
	margin-bottom: 10px;
}

.fixed-table-pagination div.pagination .pagination {
	margin: 0;
}

.fixed-table-pagination .pagination a {
	padding: 6px 12px;
	line-height: 1.428571429;
}

.fixed-table-pagination .pagination-info {
	line-height: 34px;
	margin-right: 5px;
}

.fixed-table-pagination .btn-group {
	position: relative;
	display: inline-block;
	vertical-align: middle;
}

.fixed-table-pagination .dropup .dropdown-menu {
	margin-bottom: 0;
}

.fixed-table-pagination .page-list {
	display: inline-block;
}

.fixed-table-toolbar .columns-left {
	margin-right: 5px;
}

.fixed-table-toolbar .columns-right {
	margin-left: 5px;
}

.fixed-table-toolbar .columns label {
	display: block;
	padding: 3px 20px;
	clear: both;
	font-weight: normal;
	line-height: 1.428571429;
}

.fixed-table-toolbar .bs-bars,
.fixed-table-toolbar .search,
.fixed-table-toolbar .columns {
	position: relative;
	margin-top: 10px;
	margin-bottom: 10px;
	line-height: 34px;
}

.fixed-table-pagination li.disabled a {
	pointer-events: none;
	cursor: default;
}

.fixed-table-loading {
	display: none;
	position: absolute;
	top: 42px;
	right: 0;
	bottom: 0;
	left: 0;
	z-index: 99;
	background-color: #fff;
	text-align: center;
}

.fixed-table-body .card-view .title {
	font-weight: bold;
	display: inline-block;
	min-width: 30%;
	text-align: left !important;
}

/* support bootstrap 2 */
.fixed-table-body thead th .th-inner {
	box-sizing: border-box;
}

.table th,
.table td {
	vertical-align: middle;
	box-sizing: border-box;
}

.fixed-table-toolbar .dropdown-menu {
	text-align: left;
	max-height: 300px;
	overflow: auto;
}

.fixed-table-toolbar .btn-group > .btn-group {
	display: inline-block;
	margin-left: -1px !important;
}

.fixed-table-toolbar .btn-group > .btn-group > .btn {
	border-radius: 0;
}

.fixed-table-toolbar .btn-group > .btn-group:first-child > .btn {
	border-top-left-radius: 4px;
	border-bottom-left-radius: 4px;
}

.fixed-table-toolbar .btn-group > .btn-group:last-child > .btn {
	border-top-right-radius: 4px;
	border-bottom-right-radius: 4px;
}

.bootstrap-table .table > thead > tr > th {
	vertical-align: bottom;
	border-bottom: 1px solid #ddd;
}

/* support bootstrap 3 */
.bootstrap-table .table thead > tr > th {
	padding: 0;
	margin: 0;
}

.bootstrap-table .fixed-table-footer tbody > tr > td {
	padding: 0 !important;
}

.bootstrap-table .fixed-table-footer .table {
	border-bottom: none;
	border-radius: 0;
	padding: 0 !important;
}

.bootstrap-table .pull-right .dropdown-menu {
	right: 0;
	left: auto;
}

/* calculate scrollbar width */
p.fixed-table-scroll-inner {
	width: 100%;
	height: 200px;
}

div.fixed-table-scroll-outer {
	top: 0;
	left: 0;
	visibility: hidden;
	width: 200px;
	height: 150px;
	overflow: hidden;
}

/* for get correct heights  */
.fixed-table-toolbar:after,
.fixed-table-pagination:after {
	content: "";
	display: block;
	clear: both;
}

.fullscreen {
	position: fixed;
	top: 0;
	left: 0;
	z-index: 1050;
	width: 100% !important;
	background: #fff;
}

.bootstrap-table .btn-group:last-child .btn {
	border-top-right-radius: 30px !important;
	border-bottom-right-radius: 30px !important;
	margin-left: -2px;
}

/*! nouislider - 9.1.0 - 2016-12-10 16:00:32 */
/* Functional styling;
 * These styles are required for noUiSlider to function.
 * You don't need to change these rules to apply your design.
 */
.noUi-target,
.noUi-target * {
	-webkit-touch-callout: none;
	-webkit-tap-highlight-color: rgba(0, 0, 0, 0);
	-webkit-user-select: none;
	touch-action: none;
	user-select: none;
	box-sizing: border-box;
}

.noUi-target {
	position: relative;
	direction: ltr;
}

.noUi-base {
	width: 100%;
	height: 100%;
	position: relative;
	z-index: 1;
	/* Fix 401 */
}

.noUi-connect {
	position: absolute;
	right: 0;
	top: 0;
	left: 0;
	bottom: 0;
}

.noUi-origin {
	position: absolute;
	height: 0;
	width: 0;
}

.noUi-handle {
	position: relative;
	z-index: 1;
}

.noUi-state-tap .noUi-connect,
.noUi-state-tap .noUi-origin {
	transition: top 0.3s, right 0.3s, bottom 0.3s, left 0.3s;
}

.noUi-state-drag * {
	cursor: inherit !important;
}

/* Painting and performance;
 * Browsers can paint handles in their own layer.
 */
.noUi-base,
.noUi-handle {
	transform: translate3d(0, 0, 0);
}

/* Slider size and handle placement;
 */
.noUi-horizontal {
	height: 8px;
}

.noUi-horizontal .noUi-handle {
	background: white;
	/* Old browsers */
	/* FF3.6+ */
	/* Chrome,Safari4+ */
	/* Chrome10+,Safari5.1+ */
	/* Opera 11.10+ */
	/* IE10+ */
	background: linear-gradient(to bottom, white 0%, #f1f1f2 100%);
	/* W3C */
	filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="\$white-color", endColorstr="#f1f1f2",GradientType=0 );
	/* IE6-9 */
	border-radius: 50%;
	box-shadow: 0 1px 1px #ffffff inset, 0 1px 2px rgba(0, 0, 0, 0.4);
	height: 15px;
	width: 15px;
	cursor: pointer;
	margin-left: -10px;
	margin-top: -4px;
}

.noUi-vertical {
	width: 18px;
}

.noUi-vertical .noUi-handle {
	width: 28px;
	height: 34px;
	left: -6px;
	top: -17px;
}

/* Styling;
 */
.noUi-target {
	background-color: #e5e5e5;
	border-radius: 3px;
}

.noUi-connect {
	background: #3fb8af;
	border-radius: 3px;
	transition: background 450ms;
}

/* Handles and cursors;
 */
.noUi-draggable {
	cursor: ew-resize;
}

.noUi-vertical .noUi-draggable {
	cursor: ns-resize;
}

.noUi-handle {
	border-radius: 3px;
	background: #fff;
	cursor: default;
	box-shadow: inset 0 0 1px #fff, inset 0 1px 7px #ebebeb, 0 3px 6px -3px #bbb;
}

.noUi-active {
	box-shadow: inset 0 0 1px #fff, inset 0 1px 7px #ddd, 0 3px 6px -3px #bbb;
}

/* Handle stripes;
 */
/* Disabled state;
 */
[disabled] .noUi-connect {
	background: #b8b8b8;
}

[disabled].noUi-target,
[disabled].noUi-handle,
[disabled] .noUi-handle {
	cursor: not-allowed;
}

/* Base;
 *
 */
.noUi-pips,
.noUi-pips * {
	box-sizing: border-box;
}

.noUi-pips {
	position: absolute;
	color: #999;
}

/* Values;
 *
 */
.noUi-value {
	position: absolute;
	text-align: center;
}

.noUi-value-sub {
	color: #ccc;
	font-size: 10px;
}

/* Markings;
 *
 */
.noUi-marker {
	position: absolute;
	background: #ccc;
}

.noUi-marker-sub {
	background: #aaa;
}

.noUi-marker-large {
	background: #aaa;
}

/* Horizontal layout;
 *
 */
.noUi-pips-horizontal {
	padding: 10px 0;
	height: 80px;
	top: 100%;
	left: 0;
	width: 100%;
}

.noUi-value-horizontal {
	transform: translate3d(-50%, 50%, 0);
}

.noUi-marker-horizontal.noUi-marker {
	margin-left: -1px;
	width: 2px;
	height: 5px;
}

.noUi-marker-horizontal.noUi-marker-sub {
	height: 10px;
}

.noUi-marker-horizontal.noUi-marker-large {
	height: 15px;
}

/* Vertical layout;
 *
 */
.noUi-pips-vertical {
	padding: 0 10px;
	height: 100%;
	top: 0;
	left: 100%;
}

.noUi-value-vertical {
	transform: translate3d(0, 50%, 0);
	padding-left: 25px;
}

.noUi-marker-vertical.noUi-marker {
	width: 5px;
	height: 2px;
	margin-top: -1px;
}

.noUi-marker-vertical.noUi-marker-sub {
	width: 10px;
}

.noUi-marker-vertical.noUi-marker-large {
	width: 15px;
}

.noUi-tooltip {
	display: block;
	position: absolute;
	border: 1px solid #d9d9d9;
	border-radius: 3px;
	background: #fff;
	color: #000;
	padding: 5px;
	text-align: center;
}

.noUi-horizontal .noUi-tooltip {
	transform: translate(-50%, 0);
	left: 50%;
	bottom: 120%;
}

.noUi-vertical .noUi-tooltip {
	transform: translate(0, -50%);
	top: 50%;
	right: 120%;
}

.slider.slider-info .noUi-connect,
.slider.slider-info.noUi-connect {
	background-color: #39a9db;
}
.slider.slider-info .noUi-handle {
	border-color: #39a9db;
}
.slider.slider-success .noUi-connect,
.slider.slider-success.noUi-connect {
	background-color: #28a745;
}
.slider.slider-success .noUi-handle {
	border-color: #28a745;
}
.slider.slider-warning .noUi-connect,
.slider.slider-warning.noUi-connect {
	background-color: #ffc759;
}
.slider.slider-warning .noUi-handle {
	border-color: #ffc759;
}
.slider.slider-danger .noUi-connect,
.slider.slider-danger.noUi-connect {
	background-color: #c1292e;
}
.slider.slider-danger .noUi-handle {
	border-color: #c1292e;
}

/*!
Animate.css - http://daneden.me/animate
Licensed under the MIT license - http://opensource.org/licenses/MIT

Copyright (c) 2015 Daniel Eden
*/
.animated {
	animation-duration: 1s;
	animation-fill-mode: both;
}

.animated.infinite {
	animation-iteration-count: infinite;
}

.animated.hinge {
	animation-duration: 2s;
}

.animated.bounceIn,
.animated.bounceOut {
	animation-duration: 0.75s;
}

.animated.flipOutX,
.animated.flipOutY {
	animation-duration: 0.75s;
}
@keyframes shake {
	from,
	to {
		transform: translate3d(0, 0, 0);
	}
	10%,
	30%,
	50%,
	70%,
	90% {
		transform: translate3d(-10px, 0, 0);
	}
	20%,
	40%,
	60%,
	80% {
		transform: translate3d(10px, 0, 0);
	}
}
.shake {
	animation-name: shake;
}
@keyframes fadeInDown {
	from {
		opacity: 0;
		transform: translate3d(0, -100%, 0);
	}
	to {
		opacity: 1;
		transform: none;
	}
}
.fadeInDown {
	animation-name: fadeInDown;
}
@keyframes fadeOut {
	from {
		opacity: 1;
	}
	to {
		opacity: 0;
	}
}
.fadeOut {
	animation-name: fadeOut;
}
@keyframes fadeOutDown {
	from {
		opacity: 1;
	}
	to {
		opacity: 0;
		transform: translate3d(0, 100%, 0);
	}
}
.fadeOutDown {
	animation-name: fadeOutDown;
}
@keyframes fadeOutUp {
	from {
		opacity: 1;
	}
	to {
		opacity: 0;
		transform: translate3d(0, -100%, 0);
	}
}
.fadeOutUp {
	animation-name: fadeOutUp;
}

/* perfect-scrollbar v0.6.13 */
.ps-container {
	touch-action: auto;
	overflow: hidden !important;
	-ms-overflow-style: none;
}

@supports (-ms-overflow-style: none) {
	.ps-container {
		overflow: auto !important;
	}
}
@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
	.ps-container {
		overflow: auto !important;
	}
}
.ps-container.ps-active-x > .ps-scrollbar-x-rail,
.ps-container.ps-active-y > .ps-scrollbar-y-rail {
	display: block;
	background-color: transparent;
}

.ps-container.ps-in-scrolling.ps-x > .ps-scrollbar-x-rail {
	background-color: #eee;
	opacity: 0.9;
}

.ps-container.ps-in-scrolling.ps-x > .ps-scrollbar-x-rail > .ps-scrollbar-x {
	background-color: #999;
	height: 11px;
}

.ps-container.ps-in-scrolling.ps-y > .ps-scrollbar-y-rail {
	background-color: #eee;
	opacity: 0.9;
}

.ps-container.ps-in-scrolling.ps-y > .ps-scrollbar-y-rail > .ps-scrollbar-y {
	background-color: #999;
	width: 11px;
}

.ps-container > .ps-scrollbar-x-rail {
	display: none;
	position: absolute;
	/* please don't change 'position' */
	opacity: 0;
	transition: background-color 0.2s linear, opacity 0.2s linear;
	bottom: 0px;
	/* there must be 'bottom' for ps-scrollbar-x-rail */
	height: 15px;
}

.ps-container > .ps-scrollbar-x-rail > .ps-scrollbar-x {
	position: absolute;
	/* please don't change 'position' */
	background-color: #aaa;
	border-radius: 6px;
	transition: background-color 0.2s linear, height 0.2s linear,
		width 0.2s ease-in-out, border-radius 0.2s ease-in-out;
	bottom: 2px;
	/* there must be 'bottom' for ps-scrollbar-x */
	height: 6px;
}

.ps-container > .ps-scrollbar-x-rail:hover > .ps-scrollbar-x,
.ps-container > .ps-scrollbar-x-rail:active > .ps-scrollbar-x {
	height: 11px;
}

.ps-container > .ps-scrollbar-y-rail {
	display: none;
	position: absolute;
	/* please don't change 'position' */
	opacity: 0;
	transition: background-color 0.2s linear, opacity 0.2s linear;
	right: 0;
	/* there must be 'right' for ps-scrollbar-y-rail */
	width: 15px;
}

.ps-container > .ps-scrollbar-y-rail > .ps-scrollbar-y {
	position: absolute;
	/* please don't change 'position' */
	background-color: #aaa;
	border-radius: 6px;
	transition: background-color 0.2s linear, height 0.2s linear,
		width 0.2s ease-in-out, border-radius 0.2s ease-in-out;
	right: 2px;
	/* there must be 'right' for ps-scrollbar-y */
	width: 6px;
}

.ps-container > .ps-scrollbar-y-rail:hover > .ps-scrollbar-y,
.ps-container > .ps-scrollbar-y-rail:active > .ps-scrollbar-y {
	width: 11px;
}

.ps-container:hover.ps-in-scrolling.ps-x > .ps-scrollbar-x-rail {
	background-color: #eee;
	opacity: 0.9;
}

.ps-container:hover.ps-in-scrolling.ps-x
	> .ps-scrollbar-x-rail
	> .ps-scrollbar-x {
	background-color: #999;
	height: 11px;
}

.ps-container:hover.ps-in-scrolling.ps-y > .ps-scrollbar-y-rail {
	background-color: #eee;
	opacity: 0.9;
}

.ps-container:hover.ps-in-scrolling.ps-y
	> .ps-scrollbar-y-rail
	> .ps-scrollbar-y {
	background-color: #999;
	width: 11px;
}

.ps-container:hover > .ps-scrollbar-x-rail,
.ps-container:hover > .ps-scrollbar-y-rail {
	opacity: 0.6;
}

.ps-container:hover > .ps-scrollbar-x-rail:hover {
	background-color: #eee;
	opacity: 0.9;
}

.ps-container:hover > .ps-scrollbar-x-rail:hover > .ps-scrollbar-x {
	background-color: #999;
}

.ps-container:hover > .ps-scrollbar-y-rail:hover {
	background-color: #eee;
	opacity: 0.9;
}

.ps-container:hover > .ps-scrollbar-y-rail:hover > .ps-scrollbar-y {
	background-color: #999;
}

body.swal2-shown {
	overflow-y: hidden;
}

body.swal2-iosfix {
	position: fixed;
	left: 0;
	right: 0;
}

.swal2-container {
	display: flex;
	align-items: center;
	position: fixed;
	top: 0;
	left: 0;
	bottom: 0;
	right: 0;
	padding: 10px;
	background-color: transparent;
	z-index: 1060;
}

.swal2-container.swal2-fade {
	transition: background-color 0.1s;
}

.swal2-container.swal2-shown {
	background-color: rgba(0, 0, 0, 0.4);
}

.swal2-modal {
	background-color: #fff;
	font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
	border-radius: 5px;
	box-sizing: border-box;
	text-align: center;
	margin: auto;
	box-shadow: 0 2px 2px rgba(204, 197, 185, 0.5);
	overflow-x: hidden;
	overflow-y: auto;
	display: none;
	position: relative;
	max-width: 100%;
}

.swal2-modal:focus {
	outline: none;
}

.swal2-modal.swal2-loading {
	overflow-y: hidden;
}

.swal2-modal .swal2-title {
	color: #595959;
	font-size: 30px;
	text-align: center;
	font-weight: 600;
	text-transform: none;
	position: relative;
	margin: 0 0 0.4em;
	padding: 0;
	display: block;
	word-wrap: break-word;
}

.swal2-modal .swal2-buttonswrapper {
	margin-top: 15px;
}

.swal2-modal .swal2-buttonswrapper:not(.swal2-loading) .swal2-styled[disabled] {
	opacity: 0.4;
	cursor: no-drop;
}

.swal2-modal .swal2-buttonswrapper.swal2-loading .swal2-styled.swal2-confirm {
	box-sizing: border-box;
	border: 4px solid transparent;
	border-color: transparent;
	width: 40px;
	height: 40px;
	padding: 0;
	margin: 7.5px;
	vertical-align: top;
	background-color: transparent !important;
	color: transparent;
	cursor: default;
	border-radius: 100%;
	animation: rotate-loading 1.5s linear 0s infinite normal;
	-webkit-user-select: none;
	user-select: none;
}

.swal2-modal .swal2-buttonswrapper.swal2-loading .swal2-styled.swal2-cancel {
	margin-left: 30px;
	margin-right: 30px;
}

.swal2-modal
	.swal2-buttonswrapper.swal2-loading
	:not(.swal2-styled).swal2-confirm::after {
	display: inline-block;
	content: "";
	margin-left: 5px;
	vertical-align: -1px;
	height: 15px;
	width: 15px;
	border: 3px solid #999999;
	box-shadow: 1px 1px 1px #fff;
	border-right-color: transparent;
	border-radius: 50%;
	animation: rotate-loading 1.5s linear 0s infinite normal;
}

.swal2-modal .swal2-styled {
	border: 0;
	border-radius: 3px;
	box-shadow: none;
	color: #fff;
	cursor: pointer;
	font-size: 17px;
	font-weight: 500;
	margin: 15px 5px 0;
	padding: 10px 32px;
}

.swal2-modal .swal2-styled:focus {
	outline: none;
	box-shadow: 0 0 0 2px #fff, 0 0 0 4px rgba(50, 100, 150, 0.4);
}

.swal2-modal .swal2-image {
	margin: 20px auto;
	max-width: 100%;
}

.swal2-modal .swal2-close {
	background: transparent;
	border: 0;
	margin: 0;
	padding: 0;
	width: 38px;
	height: 40px;
	font-size: 36px;
	line-height: 40px;
	font-family: serif;
	position: absolute;
	top: 5px;
	right: 8px;
	cursor: pointer;
	color: #cccccc;
	transition: color 0.1s ease;
}

.swal2-modal .swal2-close:hover {
	color: #d55;
}

.swal2-modal > .swal2-input,
.swal2-modal > .swal2-file,
.swal2-modal > .swal2-textarea,
.swal2-modal > .swal2-select,
.swal2-modal > .swal2-radio,
.swal2-modal > .swal2-checkbox {
	display: none;
}

.swal2-modal .swal2-content {
	font-size: 18px;
	text-align: center;
	font-weight: 300;
	position: relative;
	float: none;
	margin: 0;
	padding: 0;
	line-height: normal;
	color: #545454;
	word-wrap: break-word;
}

.swal2-modal .swal2-input,
.swal2-modal .swal2-file,
.swal2-modal .swal2-textarea,
.swal2-modal .swal2-select,
.swal2-modal .swal2-radio,
.swal2-modal .swal2-checkbox {
	margin: 20px auto;
}

.swal2-modal .swal2-input,
.swal2-modal .swal2-file,
.swal2-modal .swal2-textarea {
	width: 100%;
	box-sizing: border-box;
	font-size: 18px;
	border-radius: 3px;
	border: 1px solid #d9d9d9;
	box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.06);
	transition: border-color 0.3s, box-shadow 0.3s;
}

.swal2-modal .swal2-input.swal2-inputerror,
.swal2-modal .swal2-file.swal2-inputerror,
.swal2-modal .swal2-textarea.swal2-inputerror {
	border-color: #f27474 !important;
	box-shadow: 0 0 2px #f27474 !important;
}

.swal2-modal .swal2-input:focus,
.swal2-modal .swal2-file:focus,
.swal2-modal .swal2-textarea:focus {
	outline: none;
	border: 1px solid #b4dbed;
	box-shadow: 0 0 3px #c4e6f5;
}

.swal2-modal .swal2-input::placeholder,
.swal2-modal .swal2-file::placeholder,
.swal2-modal .swal2-textarea::placeholder {
	color: #cccccc;
}

.swal2-modal .swal2-range input {
	float: left;
	width: 80%;
}

.swal2-modal .swal2-range output {
	float: right;
	width: 20%;
	font-size: 20px;
	font-weight: 600;
	text-align: center;
}

.swal2-modal .swal2-range input,
.swal2-modal .swal2-range output {
	height: 43px;
	line-height: 43px;
	vertical-align: middle;
	margin: 20px auto;
	padding: 0;
}

.swal2-modal .swal2-input {
	height: 43px;
	padding: 0 12px;
}

.swal2-modal .swal2-input[type="number"] {
	max-width: 150px;
}

.swal2-modal .swal2-file {
	font-size: 20px;
}

.swal2-modal .swal2-textarea {
	height: 108px;
	padding: 12px;
}

.swal2-modal .swal2-select {
	color: #545454;
	font-size: inherit;
	padding: 5px 10px;
	min-width: 40%;
	max-width: 100%;
}

.swal2-modal .swal2-radio {
	border: 0;
}

.swal2-modal .swal2-radio label:not(:first-child) {
	margin-left: 20px;
}

.swal2-modal .swal2-radio input,
.swal2-modal .swal2-radio span {
	vertical-align: middle;
}

.swal2-modal .swal2-radio input {
	margin: 0 3px 0 0;
}

.swal2-modal .swal2-checkbox {
	color: #545454;
}

.swal2-modal .swal2-checkbox input,
.swal2-modal .swal2-checkbox span {
	vertical-align: middle;
}

.swal2-modal .swal2-validationerror {
	background-color: #f0f0f0;
	margin: 0 -20px;
	overflow: hidden;
	padding: 10px;
	color: gray;
	font-size: 16px;
	font-weight: 300;
	display: none;
}

.swal2-modal .swal2-validationerror::before {
	content: "!";
	display: inline-block;
	width: 24px;
	height: 24px;
	border-radius: 50%;
	background-color: #ea7d7d;
	color: #fff;
	line-height: 24px;
	text-align: center;
	margin-right: 10px;
}

@supports (-ms-accelerator: true) {
	.swal2-range input {
		width: 100% !important;
	}

	.swal2-range output {
		display: none;
	}
}
@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
	.swal2-range input {
		width: 100% !important;
	}

	.swal2-range output {
		display: none;
	}
}
.swal2-icon {
	width: 80px;
	height: 80px;
	border: 4px solid transparent;
	border-radius: 50%;
	margin: 20px auto 30px;
	padding: 0;
	position: relative;
	box-sizing: content-box;
	cursor: default;
	-webkit-user-select: none;
	user-select: none;
}

.swal2-icon.swal2-error {
	border-color: rgba(255, 54, 54, 0.3);
}

.swal2-icon.swal2-error .swal2-x-mark {
	position: relative;
	display: block;
}

.swal2-icon.swal2-error [class^="swal2-x-mark-line"] {
	position: absolute;
	height: 5px;
	width: 47px;
	background-color: #ff3636;
	display: block;
	top: 37px;
	border-radius: 2px;
}

.swal2-icon.swal2-error [class^="swal2-x-mark-line"][class\$="left"] {
	transform: rotate(45deg);
	left: 17px;
}

.swal2-icon.swal2-error [class^="swal2-x-mark-line"][class\$="right"] {
	transform: rotate(-45deg);
	right: 16px;
}

.swal2-icon.swal2-warning {
	font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
	color: #ffb236;
	border-color: #ffb236;
	font-size: 20px;
	line-height: 120px;
	text-align: center;
}

.swal2-icon.swal2-info {
	font-family: "Open Sans", sans-serif;
	color: #3fc3ee;
	border-color: #9de0f6;
	font-size: 60px;
	line-height: 80px;
	text-align: center;
}

.swal2-icon.swal2-question {
	font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
	color: #87adbd;
	border-color: #c9dae1;
	font-size: 60px;
	line-height: 80px;
	text-align: center;
}

.swal2-icon.swal2-success {
	border-color: #a5dc86;
}

.swal2-icon.swal2-success [class^="swal2-success-circular-line"] {
	border-radius: 50%;
	position: absolute;
	width: 60px;
	height: 120px;
	transform: rotate(45deg);
}

.swal2-icon.swal2-success
	[class^="swal2-success-circular-line"][class\$="left"] {
	border-radius: 120px 0 0 120px;
	top: -7px;
	left: -33px;
	transform: rotate(-45deg);
	transform-origin: 60px 60px;
}

.swal2-icon.swal2-success
	[class^="swal2-success-circular-line"][class\$="right"] {
	border-radius: 0 120px 120px 0;
	top: -11px;
	left: 30px;
	transform: rotate(-45deg);
	transform-origin: 0 60px;
}

.swal2-icon.swal2-success .swal2-success-ring {
	width: 80px;
	height: 80px;
	border: 4px solid rgba(24, 206, 15, 0.3);
	border-radius: 50%;
	box-sizing: content-box;
	position: absolute;
	left: -4px;
	top: -4px;
	z-index: 2;
}

.swal2-icon.swal2-success .swal2-success-fix {
	width: 7px;
	height: 90px;
	position: absolute;
	left: 28px;
	top: 8px;
	z-index: 1;
	transform: rotate(-45deg);
}

.swal2-icon.swal2-success [class^="swal2-success-line"] {
	height: 5px;
	background-color: #18ce0f;
	display: block;
	border-radius: 2px;
	position: absolute;
	z-index: 2;
}

.swal2-icon.swal2-success [class^="swal2-success-line"][class\$="tip"] {
	width: 25px;
	left: 14px;
	top: 46px;
	transform: rotate(45deg);
}

.swal2-icon.swal2-success [class^="swal2-success-line"][class\$="long"] {
	width: 47px;
	right: 8px;
	top: 38px;
	transform: rotate(-45deg);
}

.swal2-progresssteps {
	font-weight: 600;
	margin: 0 0 20px;
	padding: 0;
}

.swal2-progresssteps li {
	display: inline-block;
	position: relative;
}

.swal2-progresssteps .swal2-progresscircle {
	background: #3085d6;
	border-radius: 2em;
	color: #fff;
	height: 2em;
	line-height: 2em;
	text-align: center;
	width: 2em;
	z-index: 20;
}

.swal2-progresssteps .swal2-progresscircle:first-child {
	margin-left: 0;
}

.swal2-progresssteps .swal2-progresscircle:last-child {
	margin-right: 0;
}

.swal2-progresssteps .swal2-progresscircle.swal2-activeprogressstep {
	background: #3085d6;
}

.swal2-progresssteps
	.swal2-progresscircle.swal2-activeprogressstep
	~ .swal2-progresscircle {
	background: #add8e6;
}

.swal2-progresssteps
	.swal2-progresscircle.swal2-activeprogressstep
	~ .swal2-progressline {
	background: #add8e6;
}

.swal2-progresssteps .swal2-progressline {
	background: #3085d6;
	height: 0.4em;
	margin: 0 -1px;
	z-index: 10;
}

[class^="swal2"] {
	-webkit-tap-highlight-color: transparent;
}
@keyframes showSweetAlert {
	0% {
		transform: scale(0.7);
	}
	45% {
		transform: scale(1.05);
	}
	80% {
		transform: scale(0.95);
	}
	100% {
		transform: scale(1);
	}
}
@keyframes hideSweetAlert {
	0% {
		transform: scale(1);
		opacity: 1;
	}
	100% {
		transform: scale(0.5);
		opacity: 0;
	}
}
.swal2-show {
	animation: showSweetAlert 0.3s;
}

.swal2-show.swal2-noanimation {
	animation: none;
}

.swal2-hide {
	animation: hideSweetAlert 0.15s forwards;
}

.swal2-hide.swal2-noanimation {
	animation: none;
}
@keyframes animate-success-tip {
	0% {
		width: 0;
		left: 1px;
		top: 19px;
	}
	54% {
		width: 0;
		left: 1px;
		top: 19px;
	}
	70% {
		width: 50px;
		left: -8px;
		top: 37px;
	}
	84% {
		width: 17px;
		left: 21px;
		top: 48px;
	}
	100% {
		width: 25px;
		left: 14px;
		top: 45px;
	}
}
@keyframes animate-success-long {
	0% {
		width: 0;
		right: 46px;
		top: 54px;
	}
	65% {
		width: 0;
		right: 46px;
		top: 54px;
	}
	84% {
		width: 55px;
		right: 0;
		top: 35px;
	}
	100% {
		width: 47px;
		right: 8px;
		top: 38px;
	}
}
@keyframes rotatePlaceholder {
	0% {
		transform: rotate(-45deg);
	}
	5% {
		transform: rotate(-45deg);
	}
	12% {
		transform: rotate(-405deg);
	}
	100% {
		transform: rotate(-405deg);
	}
}
.swal2-animate-success-line-tip {
	animation: animate-success-tip 0.75s;
}

.swal2-animate-success-line-long {
	animation: animate-success-long 0.75s;
}

.swal2-success.swal2-animate-success-icon .swal2-success-circular-line-right {
	animation: rotatePlaceholder 4.25s ease-in;
}
@keyframes animate-error-icon {
	0% {
		transform: rotateX(100deg);
		opacity: 0;
	}
	100% {
		transform: rotateX(0deg);
		opacity: 1;
	}
}
.swal2-animate-error-icon {
	animation: animate-error-icon 0.5s;
}
@keyframes animate-x-mark {
	0% {
		transform: scale(0.4);
		margin-top: 26px;
		opacity: 0;
	}
	50% {
		transform: scale(0.4);
		margin-top: 26px;
		opacity: 0;
	}
	80% {
		transform: scale(1.15);
		margin-top: -6px;
	}
	100% {
		transform: scale(1);
		margin-top: 0;
		opacity: 1;
	}
}
.swal2-animate-x-mark {
	animation: animate-x-mark 0.5s;
}
@keyframes rotate-loading {
	0% {
		transform: rotate(0deg);
	}
	100% {
		transform: rotate(360deg);
	}
}
.card-wizard {
	min-height: 410px;
	box-shadow: 0 2px 2px rgba(204, 197, 185, 0.5);
	opacity: 0;
	transition: all 300ms linear;
}
.card-wizard.active {
	opacity: 1;
}
.card-wizard .card-header {
	padding: 15px 0 !important;
	padding-bottom: 40px;
}
.card-wizard .nav-pills .nav-item .nav-link {
	padding: 12px;
}
.card-wizard .nav-pills .nav-item .nav-link,
.card-wizard .nav-pills .nav-item .nav-link.active,
.card-wizard .nav-pills .nav-item .nav-link:hover,
.card-wizard .nav-pills .nav-item .nav-link:focus,
.card-wizard .nav-pills .nav-item .nav-link.active:focus,
.card-wizard .nav-pills .nav-item .nav-link.active:hover {
	background-color: transparent;
	box-shadow: none;
}
.card-wizard .picture-container {
	position: relative;
	cursor: pointer;
	text-align: center;
}
.card-wizard .wizard-navigation {
	position: relative;
}
.card-wizard .wizard-navigation .nav-link {
	display: flex;
	align-items: center;
	justify-content: center;
}
.card-wizard .wizard-navigation .nav-link i,
.card-wizard .moving-tab i {
	display: inline-block;
	font-size: 19px;
	line-height: normal;
	line-height: initial;
	margin-right: 6px;
	padding: 0;
	vertical-align: bottom;
}
.card-wizard .picture {
	width: 106px;
	height: 106px;
	background-color: #999999;
	border: 1px solid #e3e3e3;
	color: #ffffff;
	border-radius: 50%;
	margin: 5px auto;
	overflow: hidden;
	transition: all 0.2s;
	-webkit-transition: all 0.2s;
}
.card-wizard .picture:hover {
	border-color: #2ca8ff;
}
.card-wizard .moving-tab {
	position: absolute;
	text-align: center;
	padding: 12px;
	font-size: 12px;
	text-transform: uppercase;
	-webkit-font-smoothing: subpixel-antialiased;
	top: 0px;
	left: 0px;
	background-color: #65adff;
	box-shadow: 0 2px 2px rgba(204, 197, 185, 0.5);
	color: #ffffff !important;
	cursor: pointer;
	font-weight: 500;
}
.card-wizard[data-color="primary"] .moving-tab {
	color: #1c77c3;
}
.card-wizard[data-color="primary"] .picture:hover {
	border-color: #1c77c3;
}
.card-wizard[data-color="primary"] .choice:hover .icon,
.card-wizard[data-color="primary"] .choice.active .icon {
	border-color: #1c77c3;
	color: #1c77c3;
}
.card-wizard[data-color="primary"]
	.checkbox
	input[type="checkbox"]:checked
	+ .checkbox-material
	.check {
	background-color: #1c77c3;
}
.card-wizard[data-color="primary"] .radio input[type="radio"]:checked ~ .check {
	background-color: #1c77c3;
}
.card-wizard[data-color="primary"]
	.radio
	input[type="radio"]:checked
	~ .circle {
	border-color: #1c77c3;
}
.card-wizard[data-color="white"] .moving-tab {
	color: #ffffff;
}
.card-wizard[data-color="white"] .picture:hover {
	border-color: #ffffff;
}
.card-wizard[data-color="white"] .choice:hover .icon,
.card-wizard[data-color="white"] .choice.active .icon {
	border-color: #ffffff;
	color: #ffffff;
}
.card-wizard[data-color="white"]
	.checkbox
	input[type="checkbox"]:checked
	+ .checkbox-material
	.check {
	background-color: #ffffff;
}
.card-wizard[data-color="white"] .radio input[type="radio"]:checked ~ .check {
	background-color: #ffffff;
}
.card-wizard[data-color="white"] .radio input[type="radio"]:checked ~ .circle {
	border-color: #ffffff;
}
.card-wizard[data-color="green"] .moving-tab {
	color: #28a745;
}
.card-wizard[data-color="green"] .picture:hover {
	border-color: #28a745;
}
.card-wizard[data-color="green"] .choice:hover .icon,
.card-wizard[data-color="green"] .choice.active .icon {
	border-color: #28a745;
	color: #28a745;
}
.card-wizard[data-color="green"]
	.checkbox
	input[type="checkbox"]:checked
	+ .checkbox-material
	.check {
	background-color: #28a745;
}
.card-wizard[data-color="green"] .radio input[type="radio"]:checked ~ .check {
	background-color: #28a745;
}
.card-wizard[data-color="green"] .radio input[type="radio"]:checked ~ .circle {
	border-color: #28a745;
}
.card-wizard[data-color="blue"] .moving-tab {
	color: #39a9db;
}
.card-wizard[data-color="blue"] .picture:hover {
	border-color: #39a9db;
}
.card-wizard[data-color="blue"] .choice:hover .icon,
.card-wizard[data-color="blue"] .choice.active .icon {
	border-color: #39a9db;
	color: #39a9db;
}
.card-wizard[data-color="blue"]
	.checkbox
	input[type="checkbox"]:checked
	+ .checkbox-material
	.check {
	background-color: #39a9db;
}
.card-wizard[data-color="blue"] .radio input[type="radio"]:checked ~ .check {
	background-color: #39a9db;
}
.card-wizard[data-color="blue"] .radio input[type="radio"]:checked ~ .circle {
	border-color: #39a9db;
}
.card-wizard[data-color="orange"] .moving-tab {
	color: #ffc759;
}
.card-wizard[data-color="orange"] .picture:hover {
	border-color: #ffc759;
}
.card-wizard[data-color="orange"] .choice:hover .icon,
.card-wizard[data-color="orange"] .choice.active .icon {
	border-color: #ffc759;
	color: #ffc759;
}
.card-wizard[data-color="orange"]
	.checkbox
	input[type="checkbox"]:checked
	+ .checkbox-material
	.check {
	background-color: #ffc759;
}
.card-wizard[data-color="orange"] .radio input[type="radio"]:checked ~ .check {
	background-color: #ffc759;
}
.card-wizard[data-color="orange"] .radio input[type="radio"]:checked ~ .circle {
	border-color: #ffc759;
}
.card-wizard[data-color="red"] .moving-tab {
	color: #c1292e;
}
.card-wizard[data-color="red"] .picture:hover {
	border-color: #c1292e;
}
.card-wizard[data-color="red"] .choice:hover .icon,
.card-wizard[data-color="red"] .choice.active .icon {
	border-color: #c1292e;
	color: #c1292e;
}
.card-wizard[data-color="red"]
	.checkbox
	input[type="checkbox"]:checked
	+ .checkbox-material
	.check {
	background-color: #c1292e;
}
.card-wizard[data-color="red"] .radio input[type="radio"]:checked ~ .check {
	background-color: #c1292e;
}
.card-wizard[data-color="red"] .radio input[type="radio"]:checked ~ .circle {
	border-color: #c1292e;
}
.card-wizard .picture input[type="file"] {
	cursor: pointer;
	display: block;
	height: 100%;
	left: 0;
	opacity: 0 !important;
	position: absolute;
	top: 0;
	width: 100%;
}
.card-wizard .picture-src {
	width: 100%;
}
.card-wizard .tab-content {
	min-height: 355px;
	padding: 20px 0;
}
.card-wizard .wizard-footer {
	padding: 0 15px;
}
.card-wizard .wizard-footer .checkbox {
	margin-top: 16px;
}
.card-wizard .disabled {
	display: none;
}
.card-wizard .wizard-header {
	text-align: center;
	padding: 25px 0 35px;
}
.card-wizard .wizard-header h5 {
	margin: 5px 0 0;
}
.card-wizard .nav-pills > li {
	text-align: center;
}
.card-wizard .btn {
	text-transform: uppercase;
}
.card-wizard .info-text {
	text-align: center;
	font-weight: 300;
	margin: 10px 0 30px;
}
.card-wizard .choice {
	text-align: center;
	cursor: pointer;
	margin-top: 20px;
}
.card-wizard .choice[disabled] {
	pointer-events: none;
	cursor: not-allowed;
	opacity: 0.5;
}
.card-wizard .choice .icon {
	text-align: center;
	vertical-align: middle;
	height: 116px;
	width: 116px;
	border-radius: 50%;
	color: #65adff;
	margin: 0 auto 20px;
	border: 1px solid #e3e3e3;
	transition: all 0.2s;
	-webkit-transition: all 0.2s;
}
.card-wizard .choice i {
	font-size: 30px;
	line-height: 116px;
	position: absolute;
	left: 0;
	right: 0;
}
.card-wizard .choice:hover .icon,
.card-wizard .choice.active .icon {
	border-color: #2ca8ff;
}
.card-wizard .choice input[type="radio"],
.card-wizard .choice input[type="checkbox"] {
	position: absolute;
	left: -10000px;
	z-index: -1;
}
.card-wizard .btn-finish {
	display: none;
}
.card-wizard .card-title + .description {
	font-size: 17px;
	margin-bottom: 32px;
}
.card-wizard .wizard-title {
	margin: 0;
}
.card-wizard .nav-pills {
	background-color: #292929 !important;
}
.card-wizard .nav-pills > li + li {
	margin-left: 0;
}
.card-wizard .nav-pills > li > a {
	border: 0 !important;
	border-radius: 0;
	line-height: 18px;
	text-transform: uppercase;
	font-size: 12px;
	font-weight: 500;
	min-width: 100px;
	text-align: center;
	color: #ffffff !important;
}
.card-wizard .nav-pills > li.active > a,
.card-wizard .nav-pills > li.active > a:hover,
.card-wizard .nav-pills > li.active > a:focus,
.card-wizard .nav-pills > li > a:hover,
.card-wizard .nav-pills > li > a:focus {
	background-color: inherit;
	box-shadow: none;
}
.card-wizard .nav-pills > li i {
	display: block;
	font-size: 30px;
	padding: 15px 0;
}
.card-wizard .form-group.select-wizard {
	margin-top: 15px;
}
.card-wizard .dropdown.show .dropdown-menu,
.card-wizard .dropup.show .dropdown-menu {
	transform: translate3d(0, 0px, 0) !important;
}

/*!
 * Datetimepicker for Bootstrap 3
 * ! version : 4.7.14
 * https://github.com/Eonasdan/bootstrap-datetimepicker/
 */
.sr-only,
.bootstrap-datetimepicker-widget .btn[data-action="incrementHours"]::after,
.bootstrap-datetimepicker-widget .btn[data-action="incrementMinutes"]::after,
.bootstrap-datetimepicker-widget .btn[data-action="decrementHours"]::after,
.bootstrap-datetimepicker-widget .btn[data-action="decrementMinutes"]::after,
.bootstrap-datetimepicker-widget .btn[data-action="showHours"]::after,
.bootstrap-datetimepicker-widget .btn[data-action="showMinutes"]::after,
.bootstrap-datetimepicker-widget .btn[data-action="togglePeriod"]::after,
.bootstrap-datetimepicker-widget .btn[data-action="clear"]::after,
.bootstrap-datetimepicker-widget .btn[data-action="today"]::after,
.bootstrap-datetimepicker-widget .picker-switch::after,
.bootstrap-datetimepicker-widget table th.prev::after,
.bootstrap-datetimepicker-widget table th.next::after {
	position: absolute;
	width: 1px;
	height: 1px;
	margin: -1px;
	padding: 0;
	overflow: hidden;
	clip: rect(0, 0, 0, 0);
	border: 0;
}

.bootstrap-datetimepicker-widget {
	list-style: none;
}

.bootstrap-datetimepicker-widget a .btn:hover {
	background-color: transparent;
}

.bootstrap-datetimepicker-widget.dropdown-menu {
	padding: 4px;
	width: 16em;
}

@media (min-width: 768px) {
	.bootstrap-datetimepicker-widget.dropdown-menu.timepicker-sbs {
		width: 38em;
	}
}
@media (min-width: 992px) {
	.bootstrap-datetimepicker-widget.dropdown-menu.timepicker-sbs {
		width: 38em;
	}
}
@media (min-width: 1200px) {
	.bootstrap-datetimepicker-widget.dropdown-menu.timepicker-sbs {
		width: 38em;
	}
}
.bootstrap-datetimepicker-widget.dropdown-menu.bottom:before {
	border-bottom: 11px solid #f1eae0;
	border-left: 11px solid transparent;
	border-right: 11px solid transparent;
	content: "";
	display: inline-block;
	position: absolute;
	right: 12px;
	left: auto;
	top: -12px;
}

.bootstrap-datetimepicker-widget.dropdown-menu.bottom:after {
	border-bottom: 11px solid #ffffff;
	border-left: 11px solid transparent;
	border-right: 11px solid transparent;
	content: "";
	display: inline-block;
	position: absolute;
	right: 12px;
	left: auto;
	top: -11px;
}

.bootstrap-datetimepicker-widget.dropdown-menu.top {
	margin-top: auto;
	margin-bottom: -20px;
}

.bootstrap-datetimepicker-widget.dropdown-menu.top.open {
	margin-top: auto;
	margin-bottom: 5px;
}

.bootstrap-datetimepicker-widget.dropdown-menu.pull-right:before {
	left: auto;
	right: 6px;
}

.bootstrap-datetimepicker-widget.dropdown-menu.pull-right:after {
	left: auto;
	right: 7px;
}

.bootstrap-datetimepicker-widget .list-unstyled {
	margin: 0;
}

.bootstrap-datetimepicker-widget a[data-action] {
	padding: 6px 0;
	border-width: 0;
	color: #66615b;
	background-color: transparent;
}

.bootstrap-datetimepicker-widget a[data-action="togglePicker"],
.bootstrap-datetimepicker-widget a[data-action="togglePicker"]:hover {
	color: #429cb6 !important;
}

.bootstrap-datetimepicker-widget a[data-action]:hover {
	background-color: transparent;
	color: rgba(255, 255, 255, 0.85);
}

.bootstrap-datetimepicker-widget a[data-action]:active {
	box-shadow: none;
}

.bootstrap-datetimepicker-widget .timepicker-hour,
.bootstrap-datetimepicker-widget .timepicker-minute,
.bootstrap-datetimepicker-widget .timepicker-second {
	width: 40px;
	height: 40px;
	line-height: 40px;
	font-weight: 300;
	font-size: 1.5em;
	margin: 3px;
	border-radius: 50%;
}

.bootstrap-datetimepicker-widget button[data-action] {
	width: 38px;
	height: 38px;
	padding: 0;
}

.bootstrap-datetimepicker-widget .btn[data-action="incrementHours"]::after {
	content: "Increment Hours";
}

.bootstrap-datetimepicker-widget .btn[data-action="incrementMinutes"]::after {
	content: "Increment Minutes";
}

.bootstrap-datetimepicker-widget .btn[data-action="decrementHours"]::after {
	content: "Decrement Hours";
}

.bootstrap-datetimepicker-widget .btn[data-action="decrementMinutes"]::after {
	content: "Decrement Minutes";
}

.bootstrap-datetimepicker-widget .btn[data-action="showHours"]::after {
	content: "Show Hours";
}

.bootstrap-datetimepicker-widget .btn[data-action="showMinutes"]::after {
	content: "Show Minutes";
}

.bootstrap-datetimepicker-widget .btn[data-action="togglePeriod"]::after {
	content: "Toggle AM/PM";
}

.bootstrap-datetimepicker-widget .btn[data-action="clear"]::after {
	content: "Clear the picker";
}

.bootstrap-datetimepicker-widget .btn[data-action="today"]::after {
	content: "Set the date to today";
}

.bootstrap-datetimepicker-widget .picker-switch {
	text-align: center;
	border-radius: 4px;
}

.bootstrap-datetimepicker-widget .picker-switch::after {
	content: "Toggle Date and Time Screens";
}

.bootstrap-datetimepicker-widget .picker-switch td {
	padding: 0;
	margin: 0;
	height: auto;
	width: auto;
	line-height: inherit;
}

.bootstrap-datetimepicker-widget .picker-switch td span {
	line-height: 2.5;
	height: 2.5em;
	width: 100%;
	border-radius: 4px;
	margin: 2px 0px !important;
}

.bootstrap-datetimepicker-widget table {
	width: 100%;
	margin: 0;
}

.bootstrap-datetimepicker-widget table td > div,
.bootstrap-datetimepicker-widget table th > div {
	text-align: center;
}

.bootstrap-datetimepicker-widget table th {
	height: 20px;
	line-height: 20px;
	width: 20px;
}

.bootstrap-datetimepicker-widget table th.picker-switch {
	width: 145px;
}

.bootstrap-datetimepicker-widget table th.disabled,
.bootstrap-datetimepicker-widget table th.disabled:hover {
	background: none;
	color: #cfcfca;
	cursor: not-allowed;
}

.bootstrap-datetimepicker-widget table th.prev span,
.bootstrap-datetimepicker-widget table th.next span {
	border-radius: 4px;
	height: 27px;
	width: 27px;
	line-height: 28px;
	font-size: 12px;
	border-radius: 50%;
	text-align: center;
}

.bootstrap-datetimepicker-widget table th.prev::after {
	content: "Previous Month";
}

.bootstrap-datetimepicker-widget table th.next::after {
	content: "Next Month";
}

.bootstrap-datetimepicker-widget table th.dow {
	text-align: center;
	border-bottom: 1px solid #e3e3e3;
	font-size: 12px;
	text-transform: uppercase;
	color: #292929 !important;
	font-weight: 400;
	padding-bottom: 5px;
	padding-top: 10px;
}

.bootstrap-datetimepicker-widget table thead tr:first-child th {
	cursor: pointer;
}

.bootstrap-datetimepicker-widget table thead tr:first-child th:hover span,
.bootstrap-datetimepicker-widget
	table
	thead
	tr:first-child
	th.picker-switch:hover {
	background: #e3e3e3;
}

.bootstrap-datetimepicker-widget table td > div {
	border-radius: 4px;
	height: 54px;
	line-height: 54px;
	width: 54px;
	text-align: center;
}

.bootstrap-datetimepicker-widget table td.cw > div {
	font-size: 0.8em;
	height: 20px;
	line-height: 20px;
	color: #cfcfca;
}

.bootstrap-datetimepicker-widget table td.day > div {
	height: 30px;
	line-height: 31px;
	width: 30px;
	text-align: center;
	padding: 0px;
	border-radius: 50%;
	margin: 0 auto;
	z-index: -1;
	position: relative;
}

.table-condensed .day:hover div {
	transition: all 150ms linear;
}

.bootstrap-datetimepicker-widget table td.minute > div,
.bootstrap-datetimepicker-widget table td.hour > div {
	border-radius: 50%;
}

.bootstrap-datetimepicker-widget table td.day:hover > div,
.bootstrap-datetimepicker-widget table td.hour:hover > div,
.bootstrap-datetimepicker-widget table td.minute:hover > div,
.bootstrap-datetimepicker-widget table td.second:hover > div {
	background: #e3e3e3;
	cursor: pointer;
}

.bootstrap-datetimepicker-widget table td.old > div,
.bootstrap-datetimepicker-widget table td.new > div {
	color: #cfcfca;
}

.bootstrap-datetimepicker-widget table td.today > div:before {
	content: "";
	display: inline-block;
	border: 0 0 7px 7px solid transparent;
	border-bottom-color: #68b3c8;
	border-top-color: rgba(0, 0, 0, 0.2);
	position: absolute;
	bottom: 4px;
	right: 4px;
}

.bootstrap-datetimepicker-widget table td.active > div,
.bootstrap-datetimepicker-widget table td.active:hover > div {
	background-color: #68b3c8;
	color: #ffffff;
}

.bootstrap-datetimepicker-widget table td.active.today:before > div {
	border-bottom-color: #ffffff;
}

.bootstrap-datetimepicker-widget table td.disabled > div,
.bootstrap-datetimepicker-widget table td.disabled:hover > div {
	background: none;
	color: #cfcfca;
	cursor: not-allowed;
}

.bootstrap-datetimepicker-widget table td span {
	display: inline-block;
	width: 40px;
	height: 40px;
	line-height: 40px;
	margin: 3px 3px;
	cursor: pointer;
	border-radius: 50%;
	text-align: center;
}

.bootstrap-datetimepicker-widget table td span:hover {
	background: #e3e3e3;
}

.bootstrap-datetimepicker-widget table td span.active {
	background-color: #68b3c8;
	color: #ffffff;
}

.bootstrap-datetimepicker-widget table td span.old {
	color: #cfcfca;
}

.bootstrap-datetimepicker-widget table td span.disabled,
.bootstrap-datetimepicker-widget table td span.disabled:hover {
	background: none;
	color: #cfcfca;
	cursor: not-allowed;
}

.bootstrap-datetimepicker-widget .timepicker-picker span,
.bootstrap-datetimepicker-widget .timepicker-hours span,
.bootstrap-datetimepicker-widget .timepicker-minutes span {
	border-radius: 50% !important;
}

.bootstrap-datetimepicker-widget.usetwentyfour td.hour {
	height: 27px;
	line-height: 27px;
}

.input-group.date .input-group-addon {
	cursor: pointer;
}

.table-condensed > tbody > tr > td,
.table-condensed > tbody > tr > th,
.table-condensed > tfoot > tr > td,
.table-condensed > tfoot > tr > th,
.table-condensed > thead > tr > td,
.table-condensed > thead > tr > th {
	padding: 1px;
	text-align: center;
	z-index: 1;
	cursor: pointer;
}

.bootstrap-datetimepicker-widget {
	opacity: 0;
	box-shadow: 0 2px rgba(17, 16, 15, 0.1), 0 2px 10px rgba(17, 16, 15, 0.1);
	transform: translate3d(0, -10px, 0) !important;
}
.bootstrap-datetimepicker-widget.top {
	transform: translate3d(0, 10px, 0) !important;
	opacity: 0;
}
.bootstrap-datetimepicker-widget.open {
	opacity: 1;
	transition: transform 0.5s cubic-bezier(0.215, 0.61, 0.355, 1) 0s;
	transform: translate3d(0, 2px, 0) !important;
}

.bootstrap-datetimepicker-widget.top.open {
	opacity: 1;
	transform: translate3d(0, -7px, 0) !important;
	transition: transform 0.5s cubic-bezier(0.215, 0.61, 0.355, 1) 0s;
}
.bootstrap-datetimepicker-widget.top.open:before {
	border-top: 11px solid #dcd9d1;
	border-left: 11px solid transparent;
	border-right: 11px solid transparent;
	content: "";
	display: inline-block;
	position: absolute;
	right: 12px;
	bottom: -12px;
}
.bootstrap-datetimepicker-widget.top.open:after {
	border-top: 11px solid #ffffff;
	border-left: 11px solid transparent;
	border-right: 11px solid transparent;
	content: "";
	display: inline-block;
	position: absolute;
	right: 12px;
	bottom: -11px;
}

/*!
 * Bootstrap-select v1.12.2 (http://silviomoreto.github.io/bootstrap-select)
 *
 * Copyright 2013-2017 bootstrap-select
 * Licensed under MIT (https://github.com/silviomoreto/bootstrap-select/blob/master/LICENSE)
 */
select.bs-select-hidden,
select.selectpicker {
	display: none !important;
}

.bootstrap-select {
	width: 220px;
	/*IE9 and below*/
}
.bootstrap-select > .dropdown-toggle {
	width: 100%;
	padding-right: 25px;
	z-index: 1;
}
.bootstrap-select > select {
	position: absolute !important;
	bottom: 0;
	left: 50%;
	display: block !important;
	width: 0.5px !important;
	height: 100% !important;
	padding: 0 !important;
	opacity: 0 !important;
	border: none;
}
.bootstrap-select > select.mobile-device {
	top: 0;
	left: 0;
	display: block !important;
	width: 100% !important;
	z-index: 2;
}
.has-error .bootstrap-select .dropdown-toggle,
.error .bootstrap-select .dropdown-toggle {
	border-color: #b94a48;
}
.bootstrap-select.fit-width {
	width: auto !important;
}
.bootstrap-select:not([class*="col-"]):not([class*="form-control"]):not(
		.input-group-btn
	) {
	width: 150px;
}

.bootstrap-select.form-control {
	margin-bottom: 0;
	padding: 0;
	border: none;
}
.bootstrap-select.form-control:not([class*="col-"]) {
	width: 100%;
}
.bootstrap-select.form-control.input-group-btn {
	z-index: auto;
}
.bootstrap-select.form-control.input-group-btn:not(:first-child):not(
		:last-child
	)
	> .btn {
	border-radius: 0;
}

.bootstrap-select.btn-group:not(.input-group-btn),
.bootstrap-select.btn-group[class*="col-"] {
	float: none;
	display: inline-block;
	margin-left: 0;
}
.bootstrap-select.btn-group.dropdown-menu-right,
.bootstrap-select.btn-group[class*="col-"].dropdown-menu-right,
.row .bootstrap-select.btn-group[class*="col-"].dropdown-menu-right {
	float: right;
}
.form-inline .bootstrap-select.btn-group,
.form-horizontal .bootstrap-select.btn-group,
.form-group .bootstrap-select.btn-group {
	margin-bottom: 0;
}
.form-group-lg .bootstrap-select.btn-group.form-control,
.form-group-sm .bootstrap-select.btn-group.form-control {
	padding: 0;
}
.form-group-lg .bootstrap-select.btn-group.form-control .dropdown-toggle,
.form-group-sm .bootstrap-select.btn-group.form-control .dropdown-toggle {
	height: 100%;
	font-size: inherit;
	line-height: inherit;
	border-radius: inherit;
}
.form-inline .bootstrap-select.btn-group .form-control {
	width: 100%;
}
.bootstrap-select.btn-group.disabled,
.bootstrap-select.btn-group > .disabled {
	cursor: not-allowed;
}
.bootstrap-select.btn-group.disabled:focus,
.bootstrap-select.btn-group > .disabled:focus {
	outline: none !important;
}
.bootstrap-select.btn-group.bs-container {
	position: absolute;
	height: 0 !important;
	padding: 0 !important;
}
.bootstrap-select.btn-group.bs-container .dropdown-menu {
	z-index: 1060;
}
.bootstrap-select.btn-group .dropdown-toggle .filter-option {
	display: inline-block;
	overflow: hidden;
	width: 100%;
	text-align: left;
}
.bootstrap-select.btn-group[class*="col-"] .dropdown-toggle {
	width: 100%;
}
.bootstrap-select.btn-group .dropdown-menu {
	min-width: 100%;
	box-sizing: border-box;
}
.bootstrap-select.btn-group .dropdown-menu.inner {
	position: static;
	float: none;
	border: 0;
	padding: 0;
	margin: 0;
}
.bootstrap-select.btn-group .dropdown-menu li {
	position: relative;
}
.bootstrap-select.btn-group .dropdown-menu li.active small {
	color: #fff;
}
.bootstrap-select.btn-group .dropdown-menu li.disabled a {
	cursor: not-allowed;
}
.bootstrap-select.btn-group .dropdown-menu li a {
	color: #66615b;
	font-size: 16px;
	padding: 5px 45px 5px 15px;
	clear: both;
	white-space: nowrap;
	width: 100%;
	display: block;
}
.bootstrap-select.btn-group .dropdown-menu li a:hover {
	background-color: #66615b;
	color: rgba(255, 255, 255, 0.7);
	opacity: 1;
	text-decoration: none;
}
.bootstrap-select.btn-group .dropdown-menu li a.opt {
	position: relative;
	padding-left: 2.25em;
}
.bootstrap-select.btn-group .dropdown-menu li a span.check-mark {
	display: none;
}
.bootstrap-select.btn-group .dropdown-menu li a span.text {
	display: inline-block;
}
.bootstrap-select.btn-group .dropdown-menu li small {
	padding-left: 0.5em;
}
.bootstrap-select.btn-group .dropdown-menu .notify {
	position: absolute;
	bottom: 5px;
	width: 96%;
	margin: 0 2%;
	min-height: 26px;
	padding: 3px 5px;
	background: whitesmoke;
	border: 1px solid #e3e3e3;
	box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.05);
	pointer-events: none;
	opacity: 0.9;
	box-sizing: border-box;
}
.bootstrap-select.btn-group .no-results {
	padding: 3px;
	background: #f5f5f5;
	margin: 0 5px;
	white-space: nowrap;
}
.bootstrap-select.btn-group.fit-width .dropdown-toggle .filter-option {
	position: static;
}
.bootstrap-select.btn-group.show-tick
	.dropdown-menu
	li.selected
	a
	span.check-mark {
	position: absolute;
	display: inline-block;
	right: 15px;
	margin-top: 5px;
}
.bootstrap-select.btn-group.show-tick .dropdown-menu li a span.text {
	margin-right: 34px;
}

.bootstrap-select.show-menu-arrow.show > .dropdown-toggle {
	z-index: 1061;
}
.bootstrap-select.show-menu-arrow .dropdown-toggle:before {
	content: "";
	border-left: 7px solid transparent;
	border-right: 7px solid transparent;
	border-bottom: 7px solid rgba(204, 204, 204, 0.2);
	position: absolute;
	bottom: -4px;
	left: 9px;
	display: none;
}
.bootstrap-select.show-menu-arrow .dropdown-toggle:after {
	content: "";
	border-left: 6px solid transparent;
	border-right: 6px solid transparent;
	border-bottom: 6px solid white;
	position: absolute;
	bottom: -4px;
	left: 10px;
	display: none;
}
.bootstrap-select.show-menu-arrow.dropup .dropdown-toggle:before {
	bottom: auto;
	top: -3px;
	border-top: 7px solid rgba(204, 204, 204, 0.2);
	border-bottom: 0;
}
.bootstrap-select.show-menu-arrow.dropup .dropdown-toggle:after {
	bottom: auto;
	top: -3px;
	border-top: 6px solid white;
	border-bottom: 0;
}
.bootstrap-select.show-menu-arrow.pull-right .dropdown-toggle:before {
	right: 12px;
	left: auto;
}
.bootstrap-select.show-menu-arrow.pull-right .dropdown-toggle:after {
	right: 13px;
	left: auto;
}
.bootstrap-select.show-menu-arrow.show > .dropdown-toggle:before,
.bootstrap-select.show-menu-arrow.show > .dropdown-toggle:after {
	display: block;
}

.bs-searchbox,
.bs-actionsbox,
.bs-donebutton {
	padding: 4px 8px;
}

.bs-actionsbox {
	width: 100%;
	box-sizing: border-box;
}
.bs-actionsbox .btn-group button {
	width: 50%;
}

.bs-donebutton {
	float: left;
	width: 100%;
	box-sizing: border-box;
}
.bs-donebutton .btn-group button {
	width: 100%;
}

.bs-searchbox + .bs-actionsbox {
	padding: 0 8px 4px;
}
.bs-searchbox .form-control {
	margin-bottom: 0;
	width: 100%;
	float: none;
}

.bootstrap-select.show:before {
	border-bottom: 11px solid #f1eae0;
	border-left: 11px solid transparent;
	border-right: 11px solid transparent;
	content: "";
	display: inline-block;
	position: absolute;
	right: 15px;
	top: 50px;
}

.bootstrap-select.show:after {
	border-bottom: 11px solid #fffcf5;
	border-left: 11px solid transparent;
	border-right: 11px solid transparent;
	content: "";
	display: inline-block;
	position: absolute;
	right: 15px;
	top: 51px;
}

.bootstrap-select.dropup.show:before {
	border-top: 11px solid #dcd9d1;
	border-left: 11px solid transparent;
	border-right: 11px solid transparent;
	border-bottom: none;
	right: 15px;
	top: -11px;
}

.bootstrap-select.dropup.show:after {
	border-top: 11px solid #ffffff;
	border-left: 11px solid transparent;
	border-right: 11px solid transparent;
	border-bottom: none;
	right: 15px;
	top: -12px;
}

.bootstrap-select .dropdown-menu .dropdown-menu {
	transform: translate3d(0, 0, 0) !important;
}
.bootstrap-select .dropdown-menu .dropdown-menu:after,
.bootstrap-select .dropdown-menu .dropdown-menu:before {
	display: none;
}
.bootstrap-select.dropup .dropdown-menu.show {
	transform: translate3d(0, -60px, 0) !important;
}

.btn-file {
	position: relative;
	overflow: hidden;
	vertical-align: middle;
}

.btn-file > input {
	position: absolute;
	top: 0;
	right: 0;
	width: 100%;
	height: 100%;
	margin: 0;
	font-size: 23px;
	cursor: pointer;
	filter: alpha(opacity=0);
	opacity: 0;
	direction: ltr;
}

.fileinput {
	display: inline-block;
	margin-bottom: 9px;
}

.fileinput .form-control {
	display: inline-block;
	padding-top: 7px;
	padding-bottom: 5px;
	margin-bottom: 0;
	vertical-align: middle;
	cursor: text;
}

.fileinput .thumbnail {
	display: inline-block;
	margin-bottom: 10px;
	overflow: hidden;
	text-align: center;
	vertical-align: middle;
	max-width: 250px;
	box-shadow: 0 2px 2px rgba(204, 197, 185, 0.5);
}
.fileinput .thumbnail.img-circle {
	border-radius: 50%;
	max-width: 100px;
}

.fileinput .thumbnail > img {
	max-height: 100%;
}

.fileinput .btn {
	vertical-align: middle;
}

.fileinput-exists .fileinput-new,
.fileinput-new .fileinput-exists {
	display: none;
}

.fileinput-inline .fileinput-controls {
	display: inline;
}

.fileinput-filename {
	display: inline-block;
	overflow: hidden;
	vertical-align: middle;
}

.form-control .fileinput-filename {
	vertical-align: bottom;
}

.fileinput.input-group {
	display: table;
}

.fileinput.input-group > * {
	position: relative;
	z-index: 2;
}

.fileinput.input-group > .btn-file {
	z-index: 1;
}

.fileinput-new.input-group .btn-file,
.fileinput-new .input-group .btn-file {
	border-radius: 0 4px 4px 0;
}

.fileinput-new.input-group .btn-file.btn-xs,
.fileinput-new .input-group .btn-file.btn-xs,
.fileinput-new.input-group .btn-file.btn-sm,
.fileinput-new .input-group .btn-file.btn-sm {
	border-radius: 0 3px 3px 0;
}

.fileinput-new.input-group .btn-file.btn-lg,
.fileinput-new .input-group .btn-file.btn-lg {
	border-radius: 0 6px 6px 0;
}

.form-group.has-warning .fileinput .fileinput-preview {
	color: #ffc759;
}

.form-group.has-warning .fileinput .thumbnail {
	border-color: #ffc759;
}

.form-group.has-error .fileinput .fileinput-preview {
	color: #c1292e;
}

.form-group.has-error .fileinput .thumbnail {
	border-color: #c1292e;
}

.form-group.has-success .fileinput .fileinput-preview {
	color: #28a745;
}

.form-group.has-success .fileinput .thumbnail {
	border-color: #28a745;
}

.input-group-addon:not(:first-child) {
	border-left: 0;
}

.thumbnail {
	border: 0 none;
	border-radius: 3px;
	padding: 0;
}

.bootstrap-tagsinput {
	background-color: transparent;
	display: inline-block;
	padding: 4px 6px;
	vertical-align: middle;
	border-radius: 4px;
	width: 100%;
	line-height: 22px;
	cursor: text;
}
.bootstrap-tagsinput input {
	border: none;
	box-shadow: none;
	outline: none;
	background-color: transparent;
	padding: 0 6px;
	margin: 0;
	width: auto;
	max-width: inherit;
}
.bootstrap-tagsinput input:focus {
	border: none;
	box-shadow: none;
}
.bootstrap-tagsinput input::-moz-placeholder {
	color: #999;
	opacity: 1;
}
.bootstrap-tagsinput input:-ms-input-placeholder {
	color: #999;
}
.bootstrap-tagsinput input::-webkit-input-placeholder {
	color: #999;
}
.bootstrap-tagsinput.form-control input::-moz-placeholder {
	color: #999;
}
.bootstrap-tagsinput.form-control input:-ms-input-placeholder {
	color: #999;
}
.bootstrap-tagsinput.form-control input::-webkit-input-placeholder {
	color: #999;
}
.bootstrap-tagsinput .badge {
	transition: all 170ms linear;
}
.bootstrap-tagsinput .badge {
	cursor: pointer;
	margin: 5px 3px 5px 0;
	position: relative;
	padding: 4px 8px 3px 0.8em;
	border-radius: 12px;
	color: #fff;
	font-size: 0.75em;
	font-weight: 500;
	display: inline-block;
	line-height: 1.5em;
	text-transform: uppercase;
}
.bootstrap-tagsinput .badge:hover {
	padding-right: 25px;
}
.bootstrap-tagsinput .badge:hover [data-role="remove"] {
	opacity: 1;
	padding-right: 6px;
}
.bootstrap-tagsinput .badge [data-role="remove"] {
	cursor: pointer;
	position: absolute;
	top: 3.5px;
	right: 0;
	opacity: 0;
}
.bootstrap-tagsinput .badge [data-role="remove"]:after {
	content: "\\f00d";
	padding: 0px 4px;
	font-size: 18px;
	font: normal normal normal 10px/1 FontAwesome;
}
.bootstrap-tagsinput .badge [data-role="remove"]:hover:active {
	box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
	opacity: 1;
}

.badge-success {
	background-color: #7ac29a;
}

/*
 * This combined file was created by the DataTables downloader builder:
 *   https://datatables.net/download
 *
 * To rebuild or modify this file with the latest versions of the included
 * software please visit:
 *   https://datatables.net/download/#bs4/dt-1.10.16/cr-1.4.1/fc-3.2.3/fh-3.1.3/r-2.2.0/rg-1.0.2/rr-1.2.3/sc-1.4.3/sl-1.2.3
 *
 * Included libraries:
 *   DataTables 1.10.16, ColReorder 1.4.1, FixedColumns 3.2.3, FixedHeader 3.1.3, Responsive 2.2.0, RowGroup 1.0.2, RowReorder 1.2.3, Scroller 1.4.3, Select 1.2.3
 */
table.dataTable {
	clear: both;
	margin-top: 6px !important;
	margin-bottom: 6px !important;
	max-width: none !important;
	border-collapse: separate !important;
}

table.dataTable td,
table.dataTable th {
	box-sizing: content-box;
}

table.dataTable td.dataTables_empty,
table.dataTable th.dataTables_empty {
	text-align: center;
}

table.dataTable.nowrap th,
table.dataTable.nowrap td {
	white-space: nowrap;
}

div.dataTables_wrapper div.dataTables_length label {
	font-weight: normal;
	text-align: left;
	white-space: nowrap;
}

div.dataTables_wrapper div.dataTables_length select {
	width: 75px;
	display: inline-block;
}

div.dataTables_wrapper div.dataTables_filter {
	text-align: right;
}

div.dataTables_wrapper div.dataTables_filter label {
	font-weight: normal;
	white-space: nowrap;
	text-align: left;
}

div.dataTables_wrapper div.dataTables_filter input {
	margin-left: 0.5em;
	display: inline-block;
	width: auto;
}

div.dataTables_wrapper div.dataTables_info {
	padding-top: 8px;
	white-space: nowrap;
}

div.dataTables_wrapper div.dataTables_paginate {
	margin: 0;
	white-space: nowrap;
	text-align: right;
}

div.dataTables_wrapper div.dataTables_paginate ul.pagination {
	margin: 2px 0;
	white-space: nowrap;
}

div.dataTables_wrapper div.dataTables_processing {
	position: absolute;
	top: 50%;
	left: 50%;
	width: 200px;
	margin-left: -100px;
	margin-top: -26px;
	text-align: center;
	padding: 1em 0;
}

table.dataTable thead > tr > th.sorting_asc,
table.dataTable thead > tr > th.sorting_desc,
table.dataTable thead > tr > th.sorting,
table.dataTable thead > tr > td.sorting_asc,
table.dataTable thead > tr > td.sorting_desc,
table.dataTable thead > tr > td.sorting {
	padding-right: 30px;
}

table.dataTable thead > tr > th:active,
table.dataTable thead > tr > td:active {
	outline: none;
}

table.dataTable thead .sorting,
table.dataTable thead .sorting_asc,
table.dataTable thead .sorting_desc,
table.dataTable thead .sorting_asc_disabled,
table.dataTable thead .sorting_desc_disabled {
	cursor: pointer;
	position: relative;
}

table.dataTable thead .sorting:after,
table.dataTable thead .sorting_asc:after,
table.dataTable thead .sorting_desc:after,
table.dataTable thead .sorting_asc_disabled:after,
table.dataTable thead .sorting_desc_disabled:after {
	position: absolute;
	bottom: 8px;
	right: 8px;
	display: block;
	font-family: "Glyphicons Halflings";
	opacity: 0.5;
}

table.dataTable thead .sorting:after {
	opacity: 0.2;
	content: "\\e150";
	/* sort */
}

table.dataTable thead .sorting_asc:after {
	content: "\\e155";
	/* sort-by-attributes */
}

table.dataTable thead .sorting_desc:after {
	content: "\\e156";
	/* sort-by-attributes-alt */
}

table.dataTable thead .sorting_asc_disabled:after,
table.dataTable thead .sorting_desc_disabled:after {
	color: #eee;
}

div.dataTables_scrollHead table.dataTable {
	margin-bottom: 0 !important;
}

div.dataTables_scrollBody table {
	border-top: none;
	margin-top: 0 !important;
	margin-bottom: 0 !important;
}

div.dataTables_scrollBody table thead .sorting:after,
div.dataTables_scrollBody table thead .sorting_asc:after,
div.dataTables_scrollBody table thead .sorting_desc:after {
	display: none;
}

div.dataTables_scrollBody table tbody tr:first-child th,
div.dataTables_scrollBody table tbody tr:first-child td {
	border-top: none;
}

div.dataTables_scrollFoot table {
	margin-top: 0 !important;
	border-top: none;
}

@media screen and (max-width: 767px) {
	div.dataTables_wrapper div.dataTables_length,
	div.dataTables_wrapper div.dataTables_filter,
	div.dataTables_wrapper div.dataTables_info,
	div.dataTables_wrapper div.dataTables_paginate {
		text-align: center;
	}
}
table.dataTable.table-condensed > thead > tr > th {
	padding-right: 20px;
}

table.dataTable.table-condensed .sorting:after,
table.dataTable.table-condensed .sorting_asc:after,
table.dataTable.table-condensed .sorting_desc:after {
	top: 6px;
	right: 6px;
}

table.table-bordered.dataTable th,
table.table-bordered.dataTable td {
	border-left-width: 0;
}

table.table-bordered.dataTable th:last-child,
table.table-bordered.dataTable th:last-child,
table.table-bordered.dataTable td:last-child,
table.table-bordered.dataTable td:last-child {
	border-right-width: 0;
}

table.table-bordered.dataTable tbody th,
table.table-bordered.dataTable tbody td {
	border-bottom-width: 0;
}

div.dataTables_scrollHead table.table-bordered {
	border-bottom-width: 0;
}

div.table-responsive > div.dataTables_wrapper > div.row {
	margin: 0;
}

div.table-responsive
	> div.dataTables_wrapper
	> div.row
	> div[class^="col-"]:first-child {
	padding-left: 0;
}

div.table-responsive
	> div.dataTables_wrapper
	> div.row
	> div[class^="col-"]:last-child {
	padding-right: 0;
}

table.dataTable thead .sorting:after,
table.dataTable thead .sorting_asc:after,
table.dataTable thead .sorting_desc:after,
table.dataTable thead .sorting_asc_disabled:after,
table.dataTable thead .sorting_desc_disabled:after {
	position: relative;
	display: inline-block;
	bottom: 0px;
	right: -7px;
	font-family: "FontAwesome";
	opacity: 0.8;
}
table.dataTable thead .disabled-sorting.sorting:after,
table.dataTable thead .disabled-sorting.sorting_asc:after,
table.dataTable thead .disabled-sorting.sorting_desc:after,
table.dataTable thead .disabled-sorting.sorting_asc_disabled:after,
table.dataTable thead .disabled-sorting.sorting_desc_disabled:after {
	display: none;
}
table.dataTable thead .sorting:after {
	opacity: 0.4;
	content: "\\f0dc";
}
table.dataTable thead .sorting_asc:after {
	content: "\\f0de";
	top: 3px;
}
table.dataTable thead .sorting_desc:after {
	content: "\\f0dd";
	top: -3px;
}
table.dataTable .table-hover > tbody > tr:hover {
	background-color: #fff4dc;
}
table.dataTable .table > thead > tr > th,
table.dataTable .table > tbody > tr > th,
table.dataTable .table > tfoot > tr > th,
table.dataTable .table > thead > tr > td,
table.dataTable .table > tbody > tr > td,
table.dataTable .table > tfoot > tr > td {
	padding: 8px !important;
	outline: 0;
}
table.dataTable .btn.btn-icon {
	margin: 0 3px;
	padding: 5px 8px;
}

.dataTables_paginate a {
	outline: 0;
}

table.dataTable.dtr-inline.collapsed > tbody > tr > td.child,
table.dataTable.dtr-inline.collapsed > tbody > tr > th.child,
table.dataTable.dtr-inline.collapsed > tbody > tr > td.dataTables_empty {
	cursor: default !important;
}
table.dataTable.dtr-inline.collapsed > tbody > tr > td.child:before,
table.dataTable.dtr-inline.collapsed > tbody > tr > th.child:before,
table.dataTable.dtr-inline.collapsed > tbody > tr > td.dataTables_empty:before {
	display: none !important;
}
table.dataTable.dtr-inline.collapsed > tbody > tr > td:first-child,
table.dataTable.dtr-inline.collapsed > tbody > tr > th:first-child {
	position: relative;
	padding-left: 30px;
	cursor: pointer;
}
table.dataTable.dtr-inline.collapsed > tbody > tr > td:first-child:before,
table.dataTable.dtr-inline.collapsed > tbody > tr > th:first-child:before {
	top: 50%;
	margin-top: -9px;
	left: 4px;
	height: 18px;
	width: 18px;
	display: block;
	position: absolute;
	color: #518607;
	border: 0px solid white;
	border-radius: 14px;
	box-shadow: 0 0 3px #444;
	box-sizing: content-box;
	text-align: center;
	font-family: "Courier New", Courier, monospace;
	line-height: 18px;
	content: "+";
	background-color: #fff;
}
table.dataTable.dtr-inline.collapsed
	> tbody
	> tr.parent
	> td:first-child:before,
table.dataTable.dtr-inline.collapsed
	> tbody
	> tr.parent
	> th:first-child:before {
	content: "-";
	color: #ed362c;
}
table.dataTable.dtr-inline.collapsed > tbody > tr.child td:before {
	display: none;
}

table.dataTable.dtr-inline.collapsed.compact > tbody > tr > td:first-child,
table.dataTable.dtr-inline.collapsed.compact > tbody > tr > th:first-child {
	padding-left: 27px;
}
table.dataTable.dtr-inline.collapsed.compact
	> tbody
	> tr
	> td:first-child:before,
table.dataTable.dtr-inline.collapsed.compact
	> tbody
	> tr
	> th:first-child:before {
	top: 5px;
	left: 4px;
	height: 14px;
	width: 14px;
	border-radius: 14px;
	line-height: 14px;
	text-indent: 3px;
}

table.dataTable.dtr-column > tbody > tr > td.control,
table.dataTable.dtr-column > tbody > tr > th.control {
	position: relative;
	cursor: pointer;
}
table.dataTable.dtr-column > tbody > tr > td.control:before,
table.dataTable.dtr-column > tbody > tr > th.control:before {
	top: 50%;
	left: 50%;
	height: 16px;
	width: 16px;
	margin-top: -10px;
	margin-left: -10px;
	display: block;
	position: absolute;
	color: white;
	border: 2px solid white;
	border-radius: 14px;
	box-shadow: 0 0 3px #444;
	box-sizing: content-box;
	text-align: center;
	font-family: "Courier New", Courier, monospace;
	line-height: 14px;
	content: "+";
	background-color: #31b131;
}
table.dataTable.dtr-column > tbody > tr.parent td.control:before,
table.dataTable.dtr-column > tbody > tr.parent th.control:before {
	content: "-";
	background-color: #d33333;
}

table.dataTable > tbody > tr.child {
	padding: 0.5em 1em;
}
table.dataTable > tbody > tr.child:hover {
	background: transparent !important;
}
table.dataTable > tbody > tr.child ul {
	display: inline-block;
	list-style-type: none;
	margin: 0;
	padding: 0;
}
table.dataTable > tbody > tr.child ul li {
	border-bottom: 1px solid #004e89;
	padding: 0.5em 0;
}
table.dataTable > tbody > tr.child ul li:first-child {
	padding-top: 0;
}
table.dataTable > tbody > tr.child ul li:last-child {
	border-bottom: none;
}
table.dataTable > tbody > tr.child span.dtr-title {
	display: inline-block;
	min-width: 75px;
	font-weight: bold;
}

div.dtr-modal {
	position: fixed;
	box-sizing: border-box;
	top: 0;
	left: 0;
	height: 100%;
	width: 100%;
	z-index: 100;
	padding: 10em 1em;
}
div.dtr-modal div.dtr-modal-display {
	position: absolute;
	top: 0;
	left: 0;
	bottom: 0;
	right: 0;
	width: 50%;
	height: 50%;
	overflow: auto;
	margin: auto;
	z-index: 102;
	overflow: auto;
	background-color: #f5f5f7;
	border: 1px solid black;
	border-radius: 0.5em;
	box-shadow: 0 12px 30px rgba(0, 0, 0, 0.6);
}
div.dtr-modal div.dtr-modal-content {
	position: relative;
	padding: 1em;
}
div.dtr-modal div.dtr-modal-close {
	position: absolute;
	top: 6px;
	right: 6px;
	width: 22px;
	height: 22px;
	border: 1px solid #eaeaea;
	background-color: #f9f9f9;
	text-align: center;
	border-radius: 3px;
	cursor: pointer;
	z-index: 12;
}
div.dtr-modal div.dtr-modal-close:hover {
	background-color: #eaeaea;
}
div.dtr-modal div.dtr-modal-background {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	z-index: 101;
	background: rgba(0, 0, 0, 0.6);
}

@media screen and (max-width: 767px) {
	div.dtr-modal div.dtr-modal-display {
		width: 95%;
	}
}
svg {
	touch-action: none;
}

.jvectormap-container {
	width: 100%;
	height: 100%;
	position: relative;
	overflow: hidden;
	touch-action: none;
}

.jvectormap-tip {
	position: absolute;
	display: none;
	border: solid 1px #cdcdcd;
	border-radius: 3px;
	background: #292929 !important;
	color: white;
	font-family: sans-serif, Verdana;
	font-size: smaller;
	padding: 3px;
}

.jvectormap-zoomin,
.jvectormap-zoomout,
.jvectormap-goback {
	position: absolute;
	left: 10px;
	border-radius: 3px;
	background: #292929 !important;
	padding: 3px;
	color: white;
	cursor: pointer;
	line-height: 10px;
	text-align: center;
	box-sizing: content-box;
}

.jvectormap-zoomin,
.jvectormap-zoomout {
	width: 10px;
	height: 10px;
}

.jvectormap-zoomin {
	top: 10px;
}

.jvectormap-zoomout {
	top: 30px;
}

.jvectormap-goback {
	bottom: 10px;
	z-index: 1000;
	padding: 6px;
}

.jvectormap-spinner {
	position: absolute;
	left: 0;
	top: 0;
	right: 0;
	bottom: 0;
	background: center no-repeat
		url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}

.jvectormap-legend-title {
	font-weight: bold;
	font-size: 14px;
	text-align: center;
}

.jvectormap-legend-cnt {
	position: absolute;
}

.jvectormap-legend-cnt-h {
	bottom: 0;
	right: 0;
}

.jvectormap-legend-cnt-v {
	top: 0;
	right: 0;
}

.jvectormap-legend {
	background: black;
	color: white;
	border-radius: 3px;
}

.jvectormap-legend-cnt-h .jvectormap-legend {
	float: left;
	margin: 0 10px 10px 0;
	padding: 3px 3px 1px 3px;
}

.jvectormap-legend-cnt-h .jvectormap-legend .jvectormap-legend-tick {
	float: left;
}

.jvectormap-legend-cnt-v .jvectormap-legend {
	margin: 10px 10px 0 0;
	padding: 3px;
}

.jvectormap-legend-cnt-h .jvectormap-legend-tick {
	width: 40px;
}

.jvectormap-legend-cnt-h .jvectormap-legend-tick-sample {
	height: 15px;
}

.jvectormap-legend-cnt-v .jvectormap-legend-tick-sample {
	height: 20px;
	width: 20px;
	display: inline-block;
	vertical-align: middle;
}

.jvectormap-legend-tick-text {
	font-size: 12px;
}

.jvectormap-legend-cnt-h .jvectormap-legend-tick-text {
	text-align: center;
}

.jvectormap-legend-cnt-v .jvectormap-legend-tick-text {
	display: inline-block;
	vertical-align: middle;
	line-height: 20px;
	padding-left: 3px;
}

/*!
 * FullCalendar v3.1.0 Stylesheet
 * Docs & License: http://fullcalendar.io/
 * (c) 2016 Adam Shaw
 */
.fc {
	direction: ltr;
	text-align: left;
}

.fc-rtl {
	text-align: right;
}

body .fc {
	/* extra precedence to overcome jqui */
	font-size: 1em;
}

/* Colors
--------------------------------------------------------------------------------------------------*/
.fc-unthemed th,
.fc-unthemed td,
.fc-unthemed thead,
.fc-unthemed tbody,
.fc-unthemed .fc-divider,
.fc-unthemed .fc-row,
.fc-unthemed .fc-popover {
	border-color: #ddd;
}

.fc-unthemed .fc-popover {
	background-color: #ffffff;
}

.fc-unthemed .fc-divider,
.fc-unthemed .fc-popover .fc-header {
	background: #e3e3e3;
}

.fc-unthemed .fc-popover .fc-header .fc-close {
	color: #666666;
}

.fc-unthemed .fc-today {
	background: #f5f5f5;
}

.fc-highlight {
	/* when user is selecting cells */
	background: #bce8f1;
	opacity: 0.3;
	filter: alpha(opacity=30);
	/* for IE */
}

.fc-bgevent {
	/* default look for background events */
	background: #8fdf82;
	opacity: 0.3;
	filter: alpha(opacity=30);
	/* for IE */
}

.fc-nonbusiness {
	/* default look for non-business-hours areas */
	/* will inherit .fc-bgevent's styles */
	background: #d7d7d7;
}

/* Icons (inline elements with styled text that mock arrow icons)
--------------------------------------------------------------------------------------------------*/
.fc-icon {
	display: inline-block;
	width: 1em;
	height: 1em;
	line-height: 1em;
	font-size: 1em;
	text-align: center;
	overflow: hidden;
	font-family: "Courier New", Courier, monospace;
	/* don't allow browser text-selection */
	-webkit-touch-callout: none;
	-webkit-user-select: none;
	user-select: none;
}

/*
Acceptable font-family overrides for individual icons:
	"Arial", sans-serif
	"Times New Roman", serif

NOTE: use percentage font sizes or else old IE chokes
*/
.fc-icon:after {
	position: relative;
	margin: 0 -1em;
	/* ensures character will be centered, regardless of width */
}

.fc-icon-left-single-arrow:after {
	content: "‹";
	font-weight: bold;
	font-size: 200%;
	top: -7%;
	left: 3%;
}

.fc-icon-right-single-arrow:after {
	content: "›";
	font-weight: bold;
	font-size: 200%;
	top: -7%;
	left: -3%;
}

.fc-icon-left-double-arrow:after {
	content: "«";
	font-size: 160%;
	top: -7%;
}

.fc-icon-right-double-arrow:after {
	content: "»";
	font-size: 160%;
	top: -7%;
}

.fc-icon-left-triangle:after {
	content: "◄";
	font-size: 125%;
	top: 3%;
	left: -2%;
}

.fc-icon-right-triangle:after {
	content: "►";
	font-size: 125%;
	top: 3%;
	left: 2%;
}

.fc-icon-down-triangle:after {
	content: "▼";
	font-size: 125%;
	top: 2%;
}

.fc-icon-x:after {
	content: "×";
	font-size: 200%;
	top: 6%;
}

/* Buttons (styled <button> tags, normalized to work cross-browser)
--------------------------------------------------------------------------------------------------*/
.fc button {
	border-radius: 20px;
	box-sizing: border-box;
	border-width: 2px;
	background-color: transparent;
	font-size: 12px;
	font-weight: 600;
	padding: 0.5rem 0.7rem;
	background-color: #65adff;
	color: #ffffff;
	transition: all 150ms linear;
}
.fc button:hover,
.fc button:focus,
.fc button:active,
.fc button.active,
.fc button:active:focus,
.fc button:active:hover,
.fc button.active:focus,
.fc button.active:hover,
.show > .fc button.dropdown-toggle,
.show > .fc button.dropdown-toggle:focus,
.show > .fc button.dropdown-toggle:hover {
	background-color: #403d39 !important;
	color: #ffffff !important;
	box-shadow: none !important;
}
.fc button:not([data-action]):hover {
	box-shadow: none;
}
.fc button.disabled,
.fc button.disabled:hover,
.fc button.disabled:focus,
.fc button.disabled.focus,
.fc button.disabled:active,
.fc button.disabled.active,
.fc button:disabled,
.fc button:disabled:hover,
.fc button:disabled:focus,
.fc button:disabled.focus,
.fc button:disabled:active,
.fc button:disabled.active,
.fc button[disabled],
.fc button[disabled]:hover,
.fc button[disabled]:focus,
.fc button[disabled].focus,
.fc button[disabled]:active,
.fc button[disabled].active,
fieldset[disabled] .fc button,
fieldset[disabled] .fc button:hover,
fieldset[disabled] .fc button:focus,
fieldset[disabled] .fc button.focus,
fieldset[disabled] .fc button:active,
fieldset[disabled] .fc button.active {
	background-color: #65adff;
	border-color: #65adff;
}
.fc button.btn-simple {
	color: #65adff;
	border-color: #65adff;
}
.fc button.btn-simple:hover,
.fc button.btn-simple:focus,
.fc button.btn-simple:active {
	background-color: transparent;
	color: #403d39;
	border-color: #403d39;
	box-shadow: none;
}
.fc button.btn-link {
	color: #65adff;
}

.fc button:hover,
.fc button:focus {
	outline: 0 !important;
}
.fc button:active,
.fc button.active,
.open > .fc button.dropdown-toggle {
	box-shadow: none;
	outline: 0 !important;
}
.fc button.btn-icon {
	border-radius: 25px;
	padding: 6px 10px;
}
.fc button.btn-icon i {
	margin-right: 0px;
}

/* Firefox has an annoying inner border */
.fc button::-moz-focus-inner {
	margin: 0;
	padding: 0;
}

.fc-state-default {
	/* non-theme */
	border: 1px solid;
}

/* icons in buttons */
.fc button .fc-icon {
	/* non-theme */
	position: relative;
	top: -0.05em;
	/* seems to be a good adjustment across browsers */
	margin: 0 0.2em;
	vertical-align: middle;
}

/*
  button states
  borrowed from twitter bootstrap (http://twitter.github.com/bootstrap/)
*/
.fc-state-hover,
.fc-state-active,
.fc-state-disabled {
	color: #2c2c2c;
	background-color: #e6e6e6;
}

.fc button[disabled],
.fc button[disabled]:focus,
.fc button[disabled]:hover {
	background-color: #e3e3e3;
	border-color: #e3e3e3;
	cursor: default;
	opacity: 0.65;
	filter: alpha(opacity=65);
	color: #292929 !important;
}

.fc-state-hover {
	background-color: #f5f5f5;
}

.fc .fc-state-active,
.fc .fc-state-active:focus,
.fc .fc-state-active:hover,
.fc .fc-state-active:active:focus,
.fc .fc-state-active:active:hover,
.fc .fc-state-active:active {
	background-color: #65adff;
	color: #ffffff;
}

/* Buttons Groups
--------------------------------------------------------------------------------------------------*/
.fc-button-group {
	display: inline-block;
}

/*
every button that is not first in a button group should scootch over one pixel and cover the
previous button's border...
*/
.fc .fc-button-group > * {
	/* extra precedence b/c buttons have margin set to zero */
	float: left;
	margin: 0 2px 0 0;
}

.fc .fc-button-group > :first-child {
	/* same */
	margin-left: 0;
}

/* Popover
--------------------------------------------------------------------------------------------------*/
.fc-popover {
	position: absolute;
	box-shadow: 1px 2px 7px 1px rgba(0, 0, 0, 0.125);
}

.fc-popover .fc-header {
	/* TODO: be more consistent with fc-head/fc-body */
	padding: 2px 4px;
}

.fc-popover .fc-header .fc-title {
	margin: 0 2px;
}

.fc-popover .fc-header .fc-close {
	cursor: pointer;
}

.fc-ltr .fc-popover .fc-header .fc-title,
.fc-rtl .fc-popover .fc-header .fc-close {
	float: left;
}

.fc-rtl .fc-popover .fc-header .fc-title,
.fc-ltr .fc-popover .fc-header .fc-close {
	float: right;
}

/* unthemed */
.fc-unthemed .fc-popover {
	border-width: 1px;
	border-style: solid;
}

.fc-unthemed .fc-popover .fc-header .fc-close {
	font-size: 0.9em;
	margin-top: 2px;
}

/* jqui themed */
.fc-popover > .ui-widget-header + .ui-widget-content {
	border-top: 0;
	/* where they meet, let the header have the border */
}

/* Misc Reusable Components
--------------------------------------------------------------------------------------------------*/
.fc-divider {
	border-style: solid;
	border-width: 1px;
}

hr.fc-divider {
	height: 0;
	margin: 0;
	padding: 0 0 2px;
	/* height is unreliable across browsers, so use padding */
	border-width: 1px 0;
}

.fc-clear {
	clear: both;
}

.fc-bg,
.fc-bgevent-skeleton,
.fc-highlight-skeleton,
.fc-helper-skeleton {
	/* these element should always cling to top-left/right corners */
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
}

.fc-bg {
	bottom: 0;
	/* strech bg to bottom edge */
}

.fc-bg table {
	height: 100%;
	/* strech bg to bottom edge */
}

/* Tables
--------------------------------------------------------------------------------------------------*/
.fc table {
	width: 100%;
	table-layout: fixed;
	border-collapse: collapse;
	border-spacing: 0;
	font-size: 1em;
	/* normalize cross-browser */
}

.fc th {
	text-align: right;
	border-bottom-width: 1px;
	font-size: 1em;
	text-transform: uppercase;
	color: #292929 !important;
	font-weight: 400;
	padding-bottom: 3px;
}

.fc td {
	border-style: solid;
	border-width: 1px;
	padding: 0;
	vertical-align: top;
}

.fc td.fc-today {
	border-style: double;
	/* overcome neighboring borders */
}

.fc .fc-widget-header {
	border: 0;
}

.fc .fc-head .fc-widget-header {
	margin-top: 15px;
}

/* Fake Table Rows
--------------------------------------------------------------------------------------------------*/
.fc .fc-row {
	/* extra precedence to overcome themes w/ .ui-widget-content forcing a 1px border */
	/* no visible border by default. but make available if need be (scrollbar width compensation) */
	border-style: solid;
	border-width: 0;
}

.fc-row table {
	/* don't put left/right border on anything within a fake row.
     the outer tbody will worry about this */
	border-left: 0 hidden transparent;
	border-right: 0 hidden transparent;
	/* no bottom borders on rows */
	border-bottom: 0 hidden transparent;
}

.fc-row:first-child table {
	border-top: 0 hidden transparent;
	/* no top border on first row */
}

/* Day Row (used within the header and the DayGrid)
--------------------------------------------------------------------------------------------------*/
.fc-row {
	position: relative;
}

.fc-row .fc-bg {
	z-index: 1;
}

/* highlighting cells & background event skeleton */
.fc-row .fc-bgevent-skeleton,
.fc-row .fc-highlight-skeleton {
	bottom: 0;
	/* stretch skeleton to bottom of row */
}

.fc-row .fc-bgevent-skeleton table,
.fc-row .fc-highlight-skeleton table {
	height: 100%;
	/* stretch skeleton to bottom of row */
}

.fc-row .fc-highlight-skeleton td,
.fc-row .fc-bgevent-skeleton td {
	border-color: transparent;
}

.fc-row .fc-bgevent-skeleton {
	z-index: 2;
}

.fc-row .fc-highlight-skeleton {
	z-index: 3;
}

/*
row content (which contains day/week numbers and events) as well as "helper" (which contains
temporary rendered events).
*/
.fc-row .fc-content-skeleton {
	position: relative;
	z-index: 4;
	padding-bottom: 2px;
	/* matches the space above the events */
}

.fc-row .fc-helper-skeleton {
	z-index: 5;
}

.fc-row .fc-content-skeleton td,
.fc-row .fc-helper-skeleton td {
	/* see-through to the background below */
	background: none;
	/* in case <td>s are globally styled */
	border-color: transparent;
	/* don't put a border between events and/or the day number */
	border-bottom: 0;
}

.fc-row .fc-content-skeleton tbody td,
.fc-row .fc-helper-skeleton tbody td {
	/* don't put a border between event cells */
	border-top: 0;
}

/* Scrolling Container
--------------------------------------------------------------------------------------------------*/
.fc-scroller {
	/* this class goes on elements for guaranteed vertical scrollbars */
	overflow-y: scroll;
	overflow-x: hidden;
}

.fc-scroller > * {
	/* we expect an immediate inner element */
	position: relative;
	/* re-scope all positions */
	width: 100%;
	/* hack to force re-sizing this inner element when scrollbars appear/disappear */
	overflow: hidden;
	/* don't let negative margins or absolute positioning create further scroll */
}

/* Global Event Styles
--------------------------------------------------------------------------------------------------*/
.fc-event {
	position: relative;
	/* for resize handle and other inner positioning */
	display: block;
	/* make the <a> tag block */
	font-size: 0.85em;
	line-height: 1.3;
	border-radius: 2px;
	background-color: rgba(28, 119, 195, 0.2);
	/* default BACKGROUND color */
	font-weight: normal;
	/* undo jqui's ui-widget-header bold */
}
.fc-event.event-azure {
	background-color: rgba(57, 169, 219, 0.2);
}
.fc-event.event-green {
	background-color: rgba(19, 117, 71, 0.2);
}
.fc-event.event-orange {
	background-color: rgba(255, 199, 89, 0.2);
}
.fc-event.event-red {
	background-color: rgba(193, 41, 46, 0.2);
}

/* overpower some of bootstrap's and jqui's styles on <a> tags */
.fc-event,
.fc-event:hover,
.ui-widget .fc-event {
	color: #2c2c2c;
	/* default TEXT color */
	text-decoration: none;
	/* if <a> has an href */
}

.fc-event[href],
.fc-event.fc-draggable {
	cursor: pointer;
	/* give events with links and draggable events a hand mouse pointer */
}

.fc-not-allowed,
.fc-not-allowed .fc-event {
	/* to override an event's custom cursor */
	cursor: not-allowed;
}

.fc-event .fc-bg {
	/* the generic .fc-bg already does position */
	z-index: 1;
	background: #ffffff;
	opacity: 0.25;
	filter: alpha(opacity=25);
	/* for IE */
}

.fc-event .fc-content {
	position: relative;
	z-index: 2;
}

.fc-event .fc-resizer {
	position: absolute;
	z-index: 3;
}

/* Horizontal Events
--------------------------------------------------------------------------------------------------*/
/* events that are continuing to/from another week. kill rounded corners and butt up against edge */
.fc-ltr .fc-h-event.fc-not-start,
.fc-rtl .fc-h-event.fc-not-end {
	margin-left: 0;
	border-left-width: 0;
	padding-left: 1px;
	/* replace the border with padding */
	border-top-left-radius: 0;
	border-bottom-left-radius: 0;
}

.fc-ltr .fc-h-event.fc-not-end,
.fc-rtl .fc-h-event.fc-not-start {
	margin-right: 0;
	border-right-width: 0;
	padding-right: 1px;
	/* replace the border with padding */
	border-top-right-radius: 0;
	border-bottom-right-radius: 0;
}

/* resizer */
.fc-h-event .fc-resizer {
	/* positioned it to overcome the event's borders */
	top: -1px;
	bottom: -1px;
	left: -1px;
	right: -1px;
	width: 5px;
}

/* left resizer  */
.fc-ltr .fc-h-event .fc-start-resizer,
.fc-ltr .fc-h-event .fc-start-resizer:before,
.fc-ltr .fc-h-event .fc-start-resizer:after,
.fc-rtl .fc-h-event .fc-end-resizer,
.fc-rtl .fc-h-event .fc-end-resizer:before,
.fc-rtl .fc-h-event .fc-end-resizer:after {
	right: auto;
	/* ignore the right and only use the left */
	cursor: w-resize;
}

/* right resizer */
.fc-ltr .fc-h-event .fc-end-resizer,
.fc-ltr .fc-h-event .fc-end-resizer:before,
.fc-ltr .fc-h-event .fc-end-resizer:after,
.fc-rtl .fc-h-event .fc-start-resizer,
.fc-rtl .fc-h-event .fc-start-resizer:before,
.fc-rtl .fc-h-event .fc-start-resizer:after {
	left: auto;
	/* ignore the left and only use the right */
	cursor: e-resize;
}

/* DayGrid events
----------------------------------------------------------------------------------------------------
We use the full "fc-day-grid-event" class instead of using descendants because the event won't
be a descendant of the grid when it is being dragged.
*/
.fc-day-grid-event {
	margin: 2px 5px 0;
	/* spacing between events and edges */
	padding: 1px 2px;
}

.fc-day-grid-event .fc-content {
	/* force events to be one-line tall */
	white-space: nowrap;
	overflow: hidden;
}

.fc-day-grid-event .fc-time {
	font-weight: bold;
}

.fc-day-grid-event .fc-resizer {
	/* enlarge the default hit area */
	left: -3px;
	right: -3px;
	width: 7px;
}

/* Event Limiting
--------------------------------------------------------------------------------------------------*/
/* "more" link that represents hidden events */
a.fc-more {
	margin: 1px 3px;
	font-size: 0.85em;
	cursor: pointer;
	text-decoration: none;
}

a.fc-more:hover {
	text-decoration: none;
}

.fc-limited {
	/* rows and cells that are hidden because of a "more" link */
	display: none;
}

/* popover that appears when "more" link is clicked */
.fc-day-grid .fc-row {
	z-index: 1;
	/* make the "more" popover one higher than this */
}

.fc-more-popover {
	z-index: 2;
	width: 220px;
}

.fc-more-popover .fc-event-container {
	padding: 10px;
}

/* Toolbar
--------------------------------------------------------------------------------------------------*/
.fc-toolbar {
	text-align: center;
	margin-bottom: 1em;
}

.fc-toolbar .fc-left {
	float: left;
	min-width: 260px;
}

.fc-toolbar .fc-right {
	float: right;
}

.fc-toolbar .fc-center {
	display: inline-block;
}

/* the things within each left/right/center section */
.fc .fc-toolbar > * > * {
	/* extra precedence to override button border margins */
	float: left;
	margin-left: 0.75em;
}

/* the first thing within each left/center/right section */
.fc .fc-toolbar > * > :first-child {
	/* extra precedence to override button border margins */
	margin-left: 0;
}

/* title text */
.fc-toolbar h2 {
	margin: 0;
}

/* button layering (for border precedence) */
.fc-toolbar button {
	position: relative;
}

.fc-toolbar .fc-state-hover,
.fc-toolbar .ui-state-hover {
	z-index: 2;
}

.fc-toolbar .fc-state-down {
	z-index: 3;
}

.fc-toolbar .fc-state-active,
.fc-toolbar .ui-state-active {
	z-index: 4;
}

.fc-toolbar button:focus {
	z-index: 5;
}

/* View Structure
--------------------------------------------------------------------------------------------------*/
/* undo twitter bootstrap's box-sizing rules. normalizes positioning techniques */
/* don't do this for the toolbar because we'll want bootstrap to style those buttons as some pt */
.fc-view-container *,
.fc-view-container *:before,
.fc-view-container *:after {
	box-sizing: content-box;
}

.fc-view,
.fc-view > table {
	/* so dragged elements can be above the view's main element */
	position: relative;
	z-index: 1;
}

/* BasicView
--------------------------------------------------------------------------------------------------*/
/* day row structure */
.fc-basicWeek-view .fc-content-skeleton,
.fc-basicDay-view .fc-content-skeleton {
	/* we are sure there are no day numbers in these views, so... */
	padding-top: 1px;
	/* add a pixel to make sure there are 2px padding above events */
	padding-bottom: 1em;
	/* ensure a space at bottom of cell for user selecting/clicking */
}

.fc-basic-view .fc-body .fc-row {
	min-height: 4em;
	/* ensure that all rows are at least this tall */
}

/* a "rigid" row will take up a constant amount of height because content-skeleton is absolute */
.fc-row.fc-rigid {
	overflow: hidden;
}

.fc-row.fc-rigid .fc-content-skeleton {
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
}

/* week and day number styling */
.fc-basic-view .fc-week-number,
.fc-basic-view .fc-day-number {
	padding: 0 2px;
}

.fc-basic-view td.fc-week-number span,
.fc-basic-view td.fc-day-number {
	padding: 8px;
}

.fc-basic-view .fc-week-number {
	text-align: center;
}

.fc-basic-view .fc-week-number span {
	/* work around the way we do column resizing and ensure a minimum width */
	display: inline-block;
	min-width: 1.25em;
}

.fc-ltr .fc-basic-view .fc-day-number {
	text-align: right;
}

.fc-rtl .fc-basic-view .fc-day-number {
	text-align: left;
}

.fc-day-number.fc-other-month {
	opacity: 0.3;
	filter: alpha(opacity=30);
	/* for IE */
	/* opacity with small font can sometimes look too faded
     might want to set the 'color' property instead
     making day-numbers bold also fixes the problem */
}

/* AgendaView all-day area
--------------------------------------------------------------------------------------------------*/
.fc-agenda-view .fc-day-grid {
	position: relative;
	z-index: 2;
	/* so the "more.." popover will be over the time grid */
}

.fc-agenda-view .fc-day-grid .fc-row {
	min-height: 3em;
	/* all-day section will never get shorter than this */
}

.fc-agenda-view .fc-day-grid .fc-row .fc-content-skeleton {
	padding-top: 1px;
	/* add a pixel to make sure there are 2px padding above events */
	padding-bottom: 1em;
	/* give space underneath events for clicking/selecting days */
}

/* TimeGrid axis running down the side (for both the all-day area and the slot area)
--------------------------------------------------------------------------------------------------*/
.fc .fc-axis {
	/* .fc to overcome default cell styles */
	vertical-align: middle;
	padding: 0 4px;
	white-space: nowrap;
}

.fc-ltr .fc-axis {
	text-align: right;
}

.fc-rtl .fc-axis {
	text-align: left;
}

.ui-widget td.fc-axis {
	font-weight: normal;
	/* overcome jqui theme making it bold */
}

/* TimeGrid Structure
--------------------------------------------------------------------------------------------------*/
.fc-time-grid-container,
.fc-time-grid {
	/* so slats/bg/content/etc positions get scoped within here */
	position: relative;
	z-index: 1;
}

.fc-time-grid {
	min-height: 100%;
	/* so if height setting is 'auto', .fc-bg stretches to fill height */
}

.fc-time-grid table {
	/* don't put outer borders on slats/bg/content/etc */
	border: 0 hidden transparent;
}

.fc-time-grid > .fc-bg {
	z-index: 1;
}

.fc-time-grid .fc-slats,
.fc-time-grid > hr {
	/* the <hr> AgendaView injects when grid is shorter than scroller */
	position: relative;
	z-index: 2;
}

.fc-time-grid .fc-bgevent-skeleton,
.fc-time-grid .fc-content-skeleton {
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
}

.fc-time-grid .fc-bgevent-skeleton {
	z-index: 3;
}

.fc-time-grid .fc-highlight-skeleton {
	z-index: 4;
}

.fc-time-grid .fc-content-skeleton {
	z-index: 5;
}

.fc-time-grid .fc-helper-skeleton {
	z-index: 6;
}

/* TimeGrid Slats (lines that run horizontally)
--------------------------------------------------------------------------------------------------*/
.fc-time-grid .fc-slats td {
	height: 1.5em;
	border-bottom: 0;
	/* each cell is responsible for its top border */
}

.fc-time-grid .fc-slats .fc-minor td {
	border-top-style: dotted;
}

.fc-time-grid .fc-slats .ui-widget-content {
	/* for jqui theme */
	background: none;
	/* see through to fc-bg */
}

/* TimeGrid Highlighting Slots
--------------------------------------------------------------------------------------------------*/
.fc-time-grid .fc-highlight-container {
	/* a div within a cell within the fc-highlight-skeleton */
	position: relative;
	/* scopes the left/right of the fc-highlight to be in the column */
}

.fc-time-grid .fc-highlight {
	position: absolute;
	left: 0;
	right: 0;
	/* top and bottom will be in by JS */
}

/* TimeGrid Event Containment
--------------------------------------------------------------------------------------------------*/
.fc-time-grid .fc-event-container,
.fc-time-grid .fc-bgevent-container {
	/* a div within a cell within the fc-bgevent-skeleton */
	position: relative;
}

.fc-ltr .fc-time-grid .fc-event-container {
	/* space on the sides of events for LTR (default) */
	margin: 0 2.5% 0 2px;
}

.fc-rtl .fc-time-grid .fc-event-container {
	/* space on the sides of events for RTL */
	margin: 0 2px 0 2.5%;
}

.fc-time-grid .fc-event,
.fc-time-grid .fc-bgevent {
	position: absolute;
	z-index: 1;
	/* scope inner z-index's */
}

.fc-time-grid .fc-bgevent {
	/* background events always span full width */
	left: 0;
	right: 0;
}

/* Generic Vertical Event
--------------------------------------------------------------------------------------------------*/
.fc-v-event.fc-not-start {
	/* events that are continuing from another day */
	/* replace space made by the top border with padding */
	border-top-width: 0;
	padding-top: 1px;
	/* remove top rounded corners */
	border-top-left-radius: 0;
	border-top-right-radius: 0;
}

.fc-v-event.fc-not-end {
	/* replace space made by the top border with padding */
	border-bottom-width: 0;
	padding-bottom: 1px;
	/* remove bottom rounded corners */
	border-bottom-left-radius: 0;
	border-bottom-right-radius: 0;
}

/* TimeGrid Event Styling
----------------------------------------------------------------------------------------------------
We use the full "fc-time-grid-event" class instead of using descendants because the event won't
be a descendant of the grid when it is being dragged.
*/
.fc-time-grid-event {
	overflow: hidden;
	/* don't let the bg flow over rounded corners */
}

.fc-time-grid-event .fc-time,
.fc-time-grid-event .fc-title {
	padding: 0 1px;
}

.fc-time-grid-event .fc-time {
	font-size: 0.85em;
	white-space: nowrap;
}

/* short mode, where time and title are on the same line */
.fc-time-grid-event.fc-short .fc-content {
	/* don't wrap to second line (now that contents will be inline) */
	white-space: nowrap;
}

.fc-time-grid-event.fc-short .fc-time,
.fc-time-grid-event.fc-short .fc-title {
	/* put the time and title on the same line */
	display: inline-block;
	vertical-align: top;
}

.fc-time-grid-event.fc-short .fc-time span {
	display: none;
	/* don't display the full time text... */
}

.fc-time-grid-event.fc-short .fc-time:before {
	content: attr(data-start);
	/* ...instead, display only the start time */
}

.fc-time-grid-event.fc-short .fc-time:after {
	content: " - ";
	/* seperate with a dash, wrapped in nbsp's */
}

.fc-time-grid-event.fc-short .fc-title {
	font-size: 0.85em;
	/* make the title text the same size as the time */
	padding: 0;
	/* undo padding from above */
}

/* resizer */
.fc-time-grid-event .fc-resizer {
	left: 0;
	right: 0;
	bottom: 0;
	height: 8px;
	overflow: hidden;
	line-height: 8px;
	font-size: 11px;
	font-family: monospace;
	text-align: center;
	cursor: s-resize;
}

.fc-time-grid-event .fc-resizer:after {
	content: "=";
}

.card-calendar .content {
	padding: 0 !important;
}
.card-calendar .fc-toolbar {
	padding-top: 15px;
	padding-left: 15px;
	padding-right: 15px;
}
.card-calendar .fc td:first-child {
	border-left: 0;
}
.card-calendar .fc td:last-child {
	border-right: 0;
}
.card-calendar .fc-basic-view td:last-child.fc-week-number span,
.card-calendar .fc-basic-view td:last-child.fc-day-number {
	padding-right: 15px;
}
.card-calendar .fc .fc-day-header:last-child {
	padding-right: 15px;
}
.card-calendar .fc .fc-row:last-child td {
	border-bottom: 0;
}
.card-calendar .fc .fc-body .fc-widget-content {
	border-bottom: 0;
}

/*--------------------------------

nucleo-icons Web Font - built using nucleoapp.com
License - nucleoapp.com/license/

-------------------------------- */
@font-face {
	font-family: "nucleo-icons";
	src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
	src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("embedded-opentype"),
		url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("woff2"),
		url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("woff"),
		url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("truetype");
	font-weight: normal;
	font-style: normal;
}
/*------------------------
	base class definition
-------------------------*/
.nc-icon {
	display: inline-block;
	font: normal normal normal 14px/1 "nucleo-icons";
	font-size: inherit;
	text-transform: none;
	/* Better Font Rendering */
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
}

/*------------------------
  change icon size
-------------------------*/
.nc-icon.lg {
	font-size: 1.33333333em;
	vertical-align: -16%;
}

.nc-icon.x2 {
	font-size: 2em;
}

.nc-icon.x3 {
	font-size: 3em;
}

/*----------------------------------
  add a square/circle background
-----------------------------------*/
.nc-icon.square,
.nc-icon.circle {
	padding: 0.33333333em;
	vertical-align: -16%;
	background-color: #eee;
}

.nc-icon.circle {
	border-radius: 50%;
}

/*------------------------
  list icons
-------------------------*/
.nc-icon-ul {
	padding-left: 0;
	margin-left: 2.14285714em;
	list-style-type: none;
}

.nc-icon-ul > li {
	position: relative;
}

.nc-icon-ul > li > .nc-icon {
	position: absolute;
	left: -1.57142857em;
	top: 0.14285714em;
	text-align: center;
}

.nc-icon-ul > li > .nc-icon.lg {
	top: 0;
	left: -1.35714286em;
}

.nc-icon-ul > li > .nc-icon.circle,
.nc-icon-ul > li > .nc-icon.square {
	top: -0.19047619em;
	left: -1.9047619em;
}

/*------------------------
  spinning icons
-------------------------*/
.nc-icon.spin {
	animation: nc-icon-spin 2s infinite linear;
}
@keyframes nc-icon-spin {
	0% {
		transform: rotate(0deg);
	}
	100% {
		transform: rotate(360deg);
	}
}
/*------------------------
  rotated/flipped icons
-------------------------*/
.nc-icon.rotate-90 {
	filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=1);
	transform: rotate(90deg);
}

.nc-icon.rotate-180 {
	filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);
	transform: rotate(180deg);
}

.nc-icon.rotate-270 {
	filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3);
	transform: rotate(270deg);
}

.nc-icon.flip-y {
	filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=0);
	transform: scale(-1, 1);
}

.nc-icon.flip-x {
	filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);
	transform: scale(1, -1);
}

/*------------------------
	font icons
-------------------------*/
.nc-air-baloon::before {
	content: "\\ea01";
}

.nc-album-2::before {
	content: "\\ea02";
}

.nc-alert-circle-i::before {
	content: "\\ea04";
}

.nc-align-center::before {
	content: "\\ea03";
}

.nc-align-left-2::before {
	content: "\\ea05";
}

.nc-ambulance::before {
	content: "\\ea06";
}

.nc-app::before {
	content: "\\ea07";
}

.nc-atom::before {
	content: "\\ea08";
}

.nc-badge::before {
	content: "\\ea09";
}

.nc-bag-16::before {
	content: "\\ea0a";
}

.nc-bank::before {
	content: "\\ea0b";
}

.nc-basket::before {
	content: "\\ea0c";
}

.nc-bell-55::before {
	content: "\\ea0d";
}

.nc-bold::before {
	content: "\\ea0e";
}

.nc-book-bookmark::before {
	content: "\\ea0f";
}

.nc-bookmark-2::before {
	content: "\\ea10";
}

.nc-box-2::before {
	content: "\\ea11";
}

.nc-box::before {
	content: "\\ea12";
}

.nc-briefcase-24::before {
	content: "\\ea13";
}

.nc-bulb-63::before {
	content: "\\ea14";
}

.nc-bullet-list-67::before {
	content: "\\ea15";
}

.nc-bus-front-12::before {
	content: "\\ea16";
}

.nc-button-pause::before {
	content: "\\ea17";
}

.nc-button-play::before {
	content: "\\ea18";
}

.nc-button-power::before {
	content: "\\ea19";
}

.nc-calendar-60::before {
	content: "\\ea1a";
}

.nc-camera-compact::before {
	content: "\\ea1b";
}

.nc-caps-small::before {
	content: "\\ea1c";
}

.nc-cart-simple::before {
	content: "\\ea1d";
}

.nc-chart-bar-32::before {
	content: "\\ea1e";
}

.nc-chart-pie-36::before {
	content: "\\ea1f";
}

.nc-chat-33::before {
	content: "\\ea20";
}

.nc-check-2::before {
	content: "\\ea21";
}

.nc-circle-10::before {
	content: "\\ea22";
}

.nc-cloud-download-93::before {
	content: "\\ea23";
}

.nc-cloud-upload-94::before {
	content: "\\ea24";
}

.nc-compass-05::before {
	content: "\\ea25";
}

.nc-controller-modern::before {
	content: "\\ea26";
}

.nc-credit-card::before {
	content: "\\ea27";
}

.nc-delivery-fast::before {
	content: "\\ea28";
}

.nc-diamond::before {
	content: "\\ea29";
}

.nc-email-85::before {
	content: "\\ea2a";
}

.nc-favourite-28::before {
	content: "\\ea2b";
}

.nc-glasses-2::before {
	content: "\\ea2c";
}

.nc-globe-2::before {
	content: "\\ea2d";
}

.nc-globe::before {
	content: "\\ea2e";
}

.nc-hat-3::before {
	content: "\\ea2f";
}

.nc-headphones::before {
	content: "\\ea30";
}

.nc-html5::before {
	content: "\\ea31";
}

.nc-image::before {
	content: "\\ea32";
}

.nc-istanbul::before {
	content: "\\ea33";
}

.nc-key-25::before {
	content: "\\ea34";
}

.nc-laptop::before {
	content: "\\ea35";
}

.nc-layout-11::before {
	content: "\\ea36";
}

.nc-lock-circle-open::before {
	content: "\\ea37";
}

.nc-map-big::before {
	content: "\\ea38";
}

.nc-minimal-down::before {
	content: "\\ea39";
}

.nc-minimal-left::before {
	content: "\\ea3a";
}

.nc-minimal-right::before {
	content: "\\ea3b";
}

.nc-minimal-up::before {
	content: "\\ea3c";
}

.nc-mobile::before {
	content: "\\ea3d";
}

.nc-money-coins::before {
	content: "\\ea3e";
}

.nc-note-03::before {
	content: "\\ea3f";
}

.nc-palette::before {
	content: "\\ea40";
}

.nc-paper::before {
	content: "\\ea41";
}

.nc-pin-3::before {
	content: "\\ea42";
}

.nc-planet::before {
	content: "\\ea43";
}

.nc-refresh-69::before {
	content: "\\ea44";
}

.nc-ruler-pencil::before {
	content: "\\ea45";
}

.nc-satisfied::before {
	content: "\\ea46";
}

.nc-scissors::before {
	content: "\\ea47";
}

.nc-send::before {
	content: "\\ea48";
}

.nc-settings-gear-65::before {
	content: "\\ea49";
}

.nc-settings::before {
	content: "\\ea4a";
}

.nc-share-66::before {
	content: "\\ea4b";
}

.nc-shop::before {
	content: "\\ea4c";
}

.nc-simple-add::before {
	content: "\\ea4d";
}

.nc-simple-delete::before {
	content: "\\ea4e";
}

.nc-simple-remove::before {
	content: "\\ea4f";
}

.nc-single-02::before {
	content: "\\ea50";
}

.nc-single-copy-04::before {
	content: "\\ea51";
}

.nc-sound-wave::before {
	content: "\\ea52";
}

.nc-spaceship::before {
	content: "\\ea53";
}

.nc-sun-fog-29::before {
	content: "\\ea54";
}

.nc-support-17::before {
	content: "\\ea55";
}

.nc-tablet-2::before {
	content: "\\ea56";
}

.nc-tag-content::before {
	content: "\\ea57";
}

.nc-tap-01::before {
	content: "\\ea58";
}

.nc-tie-bow::before {
	content: "\\ea59";
}

.nc-tile-56::before {
	content: "\\ea5a";
}

.nc-time-alarm::before {
	content: "\\ea5b";
}

.nc-touch-id::before {
	content: "\\ea5c";
}

.nc-trophy::before {
	content: "\\ea5d";
}

.nc-tv-2::before {
	content: "\\ea5e";
}

.nc-umbrella-13::before {
	content: "\\ea5f";
}

.nc-user-run::before {
	content: "\\ea60";
}

.nc-vector::before {
	content: "\\ea61";
}

.nc-watch-time::before {
	content: "\\ea62";
}

.nc-world-2::before {
	content: "\\ea63";
}

.nc-zoom-split::before {
	content: "\\ea64";
}

.nc-search-icon::before {
	content: "\\1F50E"; /* Unicode for horizontal bar with circle */
}

.btn:hover,
.btn:focus,
.btn:active,
.btn.active,
.btn:active:focus,
.btn:active:hover,
.btn.active:focus,
.btn.active:hover,
.show > .btn.dropdown-toggle,
.show > .btn.dropdown-toggle:focus,
.show > .btn.dropdown-toggle:hover,
.navbar .navbar-nav > a.btn:hover,
.navbar .navbar-nav > a.btn:focus,
.navbar .navbar-nav > a.btn:active,
.navbar .navbar-nav > a.btn.active,
.navbar .navbar-nav > a.btn:active:focus,
.navbar .navbar-nav > a.btn:active:hover,
.navbar .navbar-nav > a.btn.active:focus,
.navbar .navbar-nav > a.btn.active:hover,
.show > .navbar .navbar-nav > a.btn.dropdown-toggle,
.show > .navbar .navbar-nav > a.btn.dropdown-toggle:focus,
.show > .navbar .navbar-nav > a.btn.dropdown-toggle:hover {
	box-shadow: none;
}
.btn:not([data-action]):hover,
.navbar .navbar-nav > a.btn:not([data-action]):hover {
	box-shadow: none;
}
.btn.disabled,
.btn.disabled:hover,
.btn.disabled:focus,
.btn.disabled.focus,
.btn.disabled:active,
.btn.disabled.active,
.btn:disabled,
.btn:disabled:hover,
.btn:disabled:focus,
.btn:disabled.focus,
.btn:disabled:active,
.btn:disabled.active,
.btn[disabled],
.btn[disabled]:hover,
.btn[disabled]:focus,
.btn[disabled].focus,
.btn[disabled]:active,
.btn[disabled].active,
fieldset[disabled] .btn,
fieldset[disabled] .btn:hover,
fieldset[disabled] .btn:focus,
fieldset[disabled] .btn.focus,
fieldset[disabled] .btn:active,
fieldset[disabled] .btn.active,
.navbar .navbar-nav > a.btn.disabled,
.navbar .navbar-nav > a.btn.disabled:hover,
.navbar .navbar-nav > a.btn.disabled:focus,
.navbar .navbar-nav > a.btn.disabled.focus,
.navbar .navbar-nav > a.btn.disabled:active,
.navbar .navbar-nav > a.btn.disabled.active,
.navbar .navbar-nav > a.btn:disabled,
.navbar .navbar-nav > a.btn:disabled:hover,
.navbar .navbar-nav > a.btn:disabled:focus,
.navbar .navbar-nav > a.btn:disabled.focus,
.navbar .navbar-nav > a.btn:disabled:active,
.navbar .navbar-nav > a.btn:disabled.active,
.navbar .navbar-nav > a.btn[disabled],
.navbar .navbar-nav > a.btn[disabled]:hover,
.navbar .navbar-nav > a.btn[disabled]:focus,
.navbar .navbar-nav > a.btn[disabled].focus,
.navbar .navbar-nav > a.btn[disabled]:active,
.navbar .navbar-nav > a.btn[disabled].active,
fieldset[disabled] .navbar .navbar-nav > a.btn,
fieldset[disabled] .navbar .navbar-nav > a.btn:hover,
fieldset[disabled] .navbar .navbar-nav > a.btn:focus,
fieldset[disabled] .navbar .navbar-nav > a.btn.focus,
fieldset[disabled] .navbar .navbar-nav > a.btn:active,
fieldset[disabled] .navbar .navbar-nav > a.btn.active {
	background-color: #1c77c3;
	border-color: #1c77c3;
}
.btn.btn-simple,
.navbar .navbar-nav > a.btn.btn-simple {
	color: #1c77c3;
	border-color: #1c77c3;
}

.btn:hover,
.btn:focus,
.navbar .navbar-nav > a.btn:hover,
.navbar .navbar-nav > a.btn:focus {
	opacity: 1;
	filter: alpha(opacity=100);
	outline: 0 !important;
}
.btn:active,
.btn.active,
.open > .btn.dropdown-toggle,
.navbar .navbar-nav > a.btn:active,
.navbar .navbar-nav > a.btn.active,
.open > .navbar .navbar-nav > a.btn.dropdown-toggle {
	box-shadow: none;
	outline: 0 !important;
}
.btn .badge,
.navbar .navbar-nav > a.btn .badge {
	margin: 0;
}
.btn.btn-icon,
.navbar .navbar-nav > a.btn.btn-icon {
	height: 2rem;
	min-width: 2rem;
	width: 2rem;
	padding: 0;
	font-size: 0.9375rem;
	overflow: hidden;
	position: relative;
	line-height: normal;
}
.btn.btn-icon.btn-simple,
.navbar .navbar-nav > a.btn.btn-icon.btn-simple {
	padding: 0;
}
.btn.btn-icon.btn-sm,
.navbar .navbar-nav > a.btn.btn-icon.btn-sm {
	height: 1.875rem;
	min-width: 1.875rem;
	width: 1.875rem;
}
.btn.btn-icon.btn-sm .fa,
.btn.btn-icon.btn-sm .far,
.btn.btn-icon.btn-sm .fas,
.btn.btn-icon.btn-sm .nc-icon,
.navbar .navbar-nav > a.btn.btn-icon.btn-sm .fa,
.navbar .navbar-nav > a.btn.btn-icon.btn-sm .far,
.navbar .navbar-nav > a.btn.btn-icon.btn-sm .fas,
.navbar .navbar-nav > a.btn.btn-icon.btn-sm .nc-icon {
	font-size: 0.6875rem;
}
.btn.btn-icon.btn-lg,
.navbar .navbar-nav > a.btn.btn-icon.btn-lg {
	height: 3.6rem;
	min-width: 3.6rem;
	width: 3.6rem;
}
.btn.btn-icon.btn-lg .fa,
.btn.btn-icon.btn-lg .far,
.btn.btn-icon.btn-lg .fas,
.btn.btn-icon.btn-lg .nc-icon,
.navbar .navbar-nav > a.btn.btn-icon.btn-lg .fa,
.navbar .navbar-nav > a.btn.btn-icon.btn-lg .far,
.navbar .navbar-nav > a.btn.btn-icon.btn-lg .fas,
.navbar .navbar-nav > a.btn.btn-icon.btn-lg .nc-icon {
	font-size: 1.325rem;
}
.btn.btn-icon:not(.btn-footer) .nc-icon,
.btn.btn-icon:not(.btn-footer) .fa,
.btn.btn-icon:not(.btn-footer) .far,
.btn.btn-icon:not(.btn-footer) .fas,
.navbar .navbar-nav > a.btn.btn-icon:not(.btn-footer) .nc-icon,
.navbar .navbar-nav > a.btn.btn-icon:not(.btn-footer) .fa,
.navbar .navbar-nav > a.btn.btn-icon:not(.btn-footer) .far,
.navbar .navbar-nav > a.btn.btn-icon:not(.btn-footer) .fas {
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-12px, -12px);
	line-height: 1.5626rem;
	width: 24px;
}
.btn.btn-icon.btn-neutral,
.navbar .navbar-nav > a.btn.btn-icon.btn-neutral {
	font-size: 20px;
}
.btn:not(.btn-icon) .nc-icon,
.navbar .navbar-nav > a.btn:not(.btn-icon) .nc-icon {
	position: relative;
	top: 1px;
}

.btn-default {
	background-color: #65adff;
	color: #ffffff;
}
.btn-default:hover,
.btn-default:focus,
.btn-default:active,
.btn-default.active,
.btn-default:active:focus,
.btn-default:active:hover,
.btn-default.active:focus,
.btn-default.active:hover,
.show > .btn-default.dropdown-toggle,
.show > .btn-default.dropdown-toggle:focus,
.show > .btn-default.dropdown-toggle:hover {
	background-color: #403d39 !important;
	color: #ffffff !important;
	box-shadow: none !important;
}
.btn-default:not([data-action]):hover {
	box-shadow: none;
}
.btn-default.disabled,
.btn-default.disabled:hover,
.btn-default.disabled:focus,
.btn-default.disabled.focus,
.btn-default.disabled:active,
.btn-default.disabled.active,
.btn-default:disabled,
.btn-default:disabled:hover,
.btn-default:disabled:focus,
.btn-default:disabled.focus,
.btn-default:disabled:active,
.btn-default:disabled.active,
.btn-default[disabled],
.btn-default[disabled]:hover,
.btn-default[disabled]:focus,
.btn-default[disabled].focus,
.btn-default[disabled]:active,
.btn-default[disabled].active,
fieldset[disabled] .btn-default,
fieldset[disabled] .btn-default:hover,
fieldset[disabled] .btn-default:focus,
fieldset[disabled] .btn-default.focus,
fieldset[disabled] .btn-default:active,
fieldset[disabled] .btn-default.active {
	background-color: #65adff;
	border-color: #65adff;
}
.btn-default.btn-simple {
	color: #65adff;
	border-color: #65adff;
}
.btn-default.btn-simple:hover,
.btn-default.btn-simple:focus,
.btn-default.btn-simple:active {
	background-color: transparent;
	color: #403d39;
	border-color: #403d39;
	box-shadow: none;
}

.btn-default.btn-link:focus,
.btn-default.btn-link:active,
.btn-default.btn-link:active:focus {
	background-color: transparent;
	color: #403d39;
	text-decoration: none;
	box-shadow: none;
}

.btn-primary {
	background-color: #1c77c3;
	color: #ffffff;
}
.btn-primary:hover,
.btn-primary:focus,
.btn-primary:active,
.btn-primary.active,
.btn-primary:active:focus,
.btn-primary:active:hover,
.btn-primary.active:focus,
.btn-primary.active:hover,
.show > .btn-primary.dropdown-toggle,
.show > .btn-primary.dropdown-toggle:focus,
.show > .btn-primary.dropdown-toggle:hover {
	background-color: #1c68a6 !important;
	color: #ffffff !important;
	box-shadow: none !important;
}
.btn-primary:not([data-action]):hover {
	box-shadow: none;
}
.btn-primary.disabled,
.btn-primary.disabled:hover,
.btn-primary.disabled:focus,
.btn-primary.disabled.focus,
.btn-primary.disabled:active,
.btn-primary.disabled.active,
.btn-primary:disabled,
.btn-primary:disabled:hover,
.btn-primary:disabled:focus,
.btn-primary:disabled.focus,
.btn-primary:disabled:active,
.btn-primary:disabled.active,
.btn-primary[disabled],
.btn-primary[disabled]:hover,
.btn-primary[disabled]:focus,
.btn-primary[disabled].focus,
.btn-primary[disabled]:active,
.btn-primary[disabled].active,
fieldset[disabled] .btn-primary,
fieldset[disabled] .btn-primary:hover,
fieldset[disabled] .btn-primary:focus,
fieldset[disabled] .btn-primary.focus,
fieldset[disabled] .btn-primary:active,
fieldset[disabled] .btn-primary.active {
	background-color: #1c77c3;
	border-color: #1c77c3;
}
.btn-primary.btn-simple {
	color: #1c77c3;
	border-color: #1c77c3;
}
.btn-primary.btn-simple:hover,
.btn-primary.btn-simple:focus,
.btn-primary.btn-simple:active {
	background-color: transparent;
	color: #165c96;
	border-color: #165c96;
	box-shadow: none;
}
.btn-primary.btn-link {
	color: #1c77c3;
}
.btn-primary.btn-link:focus,
.btn-primary.btn-link:active,
.btn-primary.btn-link:active:focus {
	background-color: transparent;
	color: #165c96;
	text-decoration: none;
	box-shadow: none;
}

.btn-primary-dark {
	background-color: #004e89;
	color: #ffffff;
}
.btn-primary-dark:hover,
.btn-primary-dark:focus,
.btn-primary-dark:active,
.btn-primary-dark.active,
.btn-primary-dark:active:focus,
.btn-primary-dark:active:hover,
.btn-primary-dark.active:focus,
.btn-primary-dark.active:hover,
.show > .btn-primary-dark.dropdown-toggle,
.show > .btn-primary-dark.dropdown-toggle:focus,
.show > .btn-primary-dark.dropdown-toggle:hover {
	background-color: #0a3253 !important;
	color: #ffffff !important;
	box-shadow: none !important;
}
.btn-primary-dark:not([data-action]):hover {
	box-shadow: none;
}
.btn-primary-dark.disabled,
.btn-primary-dark.disabled:hover,
.btn-primary-dark.disabled:focus,
.btn-primary-dark.disabled.focus,
.btn-primary-dark.disabled:active,
.btn-primary-dark.disabled.active,
.btn-primary-dark:disabled,
.btn-primary-dark:disabled:hover,
.btn-primary-dark:disabled:focus,
.btn-primary-dark:disabled.focus,
.btn-primary-dark:disabled:active,
.btn-primary-dark:disabled.active,
.btn-primary-dark[disabled],
.btn-primary-dark[disabled]:hover,
.btn-primary-dark[disabled]:focus,
.btn-primary-dark[disabled].focus,
.btn-primary-dark[disabled]:active,
.btn-primary-dark[disabled].active,
fieldset[disabled] .btn-primary-dark,
fieldset[disabled] .btn-primary-dark:hover,
fieldset[disabled] .btn-primary-dark:focus,
fieldset[disabled] .btn-primary-dark.focus,
fieldset[disabled] .btn-primary-dark:active,
fieldset[disabled] .btn-primary-dark.active {
	background-color: #004e89;
	border-color: #004e89;
}
.btn-primary-dark.btn-simple {
	color: #004e89;
	border-color: #004e89;
}
.btn-primary-dark.btn-simple:hover,
.btn-primary-dark.btn-simple:focus,
.btn-primary-dark.btn-simple:active {
	background-color: transparent;
	color: #0a3253;
	border-color: #0a3253;
	box-shadow: none;
}
.btn-primary-dark.btn-link {
	color: #004e89;
}
.btn-primary-dark.btn-link:hover,
.btn-primary-dark.btn-link:focus,
.btn-primary-dark.btn-link:active,
.btn-primary-dark.btn-link:active:focus {
	background-color: transparent;
	color: #0a3253;
	text-decoration: none;
	box-shadow: none;
}

.btn-secondary {
	background-color: #1f84d6;
	color: #ffffff;
}
.btn-secondary:hover,
.btn-secondary:focus,
.btn-secondary:active,
.btn-secondary.active,
.btn-secondary:active:focus,
.btn-secondary:active:hover,
.btn-secondary.active:focus,
.btn-secondary.active:hover,
.show > .btn-secondary.dropdown-toggle,
.show > .btn-secondary.dropdown-toggle:focus,
.show > .btn-secondary.dropdown-toggle:hover {
	background-color: inherit;
	color: inherit;
	box-shadow: none;
}
.btn-secondary:not([data-action]):hover {
	box-shadow: none;
}
.btn-secondary.disabled,
.btn-secondary.disabled:hover,
.btn-secondary.disabled:focus,
.btn-secondary.disabled.focus,
.btn-secondary.disabled:active,
.btn-secondary.disabled.active,
.btn-secondary:disabled,
.btn-secondary:disabled:hover,
.btn-secondary:disabled:focus,
.btn-secondary:disabled.focus,
.btn-secondary:disabled:active,
.btn-secondary:disabled.active,
.btn-secondary[disabled],
.btn-secondary[disabled]:hover,
.btn-secondary[disabled]:focus,
.btn-secondary[disabled].focus,
.btn-secondary[disabled]:active,
.btn-secondary[disabled].active,
fieldset[disabled] .btn-secondary,
fieldset[disabled] .btn-secondary:hover,
fieldset[disabled] .btn-secondary:focus,
fieldset[disabled] .btn-secondary.focus,
fieldset[disabled] .btn-secondary:active,
fieldset[disabled] .btn-secondary.active {
	background-color: #1f84d6;
	border-color: #1f84d6;
}
.btn-secondary.btn-simple {
	color: #1f84d6;
	border-color: #1f84d6;
}
.btn-secondary.btn-simple:hover,
.btn-secondary.btn-simple:focus,
.btn-secondary.btn-simple:active {
	background-color: transparent;
	color: #1969a9;
	border-color: #1969a9;
	box-shadow: none;
}
.btn-secondary.btn-link {
	color: #5a5a5a;
}
.btn-secondary.btn-link:hover,
.btn-secondary.btn-link:focus,
.btn-secondary.btn-link:active,
.btn-secondary.btn-link:active:focus {
	background-color: transparent;
	color: #1969a9;
	text-decoration: none;
	box-shadow: none;
}

.btn-success {
	background-color: #28a745;
	color: #ffffff;
}
.btn-success:hover,
.btn-success:focus,
.btn-success:active,
.btn-success.active,
.btn-success:active:focus,
.btn-success:active:hover,
.btn-success.active:focus,
.btn-success.active:hover,
.show > .btn-success.dropdown-toggle,
.show > .btn-success.dropdown-toggle:focus,
.show > .btn-success.dropdown-toggle:hover {
	background-color: #146f43;
	color: #ffffff !important;
	box-shadow: none !important;
}
.btn-success:not([data-action]):hover {
	box-shadow: none;
}
.btn-success.disabled,
.btn-success.disabled:hover,
.btn-success.disabled:focus,
.btn-success.disabled.focus,
.btn-success.disabled:active,
.btn-success.disabled.active,
.btn-success:disabled,
.btn-success:disabled:hover,
.btn-success:disabled:focus,
.btn-success:disabled.focus,
.btn-success:disabled:active,
.btn-success:disabled.active,
.btn-success[disabled],
.btn-success[disabled]:hover,
.btn-success[disabled]:focus,
.btn-success[disabled].focus,
.btn-success[disabled]:active,
.btn-success[disabled].active,
fieldset[disabled] .btn-success,
fieldset[disabled] .btn-success:hover,
fieldset[disabled] .btn-success:focus,
fieldset[disabled] .btn-success.focus,
fieldset[disabled] .btn-success:active,
fieldset[disabled] .btn-success.active {
	background-color: #28a745;
	border-color: #28a745;
}
.btn-success.btn-simple {
	color: #28a745;
	border-color: #28a745;
}
.btn-success.btn-simple:hover,
.btn-success.btn-simple:focus,
.btn-success.btn-simple:active {
	background-color: transparent;
	color: #0c492c;
	border-color: #0c492c;
	box-shadow: none;
}
.btn-success.btn-link {
	color: #28a745;
}
.btn-success.btn-link:hover,
.btn-success.btn-link:focus,
.btn-success.btn-link:active,
.btn-success.btn-link:active:focus {
	background-color: transparent;
	color: #0c492c;
	text-decoration: none;
	box-shadow: none;
}

.btn-info {
	background-color: #39a9db;
	color: #ffffff;
}
.btn-info:hover,
.btn-info:focus,
.btn-info:active,
.btn-info.active,
.btn-info:active:focus,
.btn-info:active:hover,
.btn-info.active:focus,
.btn-info.active:hover,
.show > .btn-info.dropdown-toggle,
.show > .btn-info.dropdown-toggle:focus,
.show > .btn-info.dropdown-toggle:hover {
	background-color: #238ebe !important;
	color: #ffffff !important;
	box-shadow: none !important;
}
.btn-info:not([data-action]):hover {
	box-shadow: none;
}
.btn-info.disabled,
.btn-info.disabled:hover,
.btn-info.disabled:focus,
.btn-info.disabled.focus,
.btn-info.disabled:active,
.btn-info.disabled.active,
.btn-info:disabled,
.btn-info:disabled:hover,
.btn-info:disabled:focus,
.btn-info:disabled.focus,
.btn-info:disabled:active,
.btn-info:disabled.active,
.btn-info[disabled],
.btn-info[disabled]:hover,
.btn-info[disabled]:focus,
.btn-info[disabled].focus,
.btn-info[disabled]:active,
.btn-info[disabled].active,
fieldset[disabled] .btn-info,
fieldset[disabled] .btn-info:hover,
fieldset[disabled] .btn-info:focus,
fieldset[disabled] .btn-info.focus,
fieldset[disabled] .btn-info:active,
fieldset[disabled] .btn-info.active {
	background-color: #39a9db;
	border-color: #39a9db;
}
.btn-info.btn-simple {
	color: #39a9db;
	border-color: #39a9db;
}
.btn-info.btn-simple:hover,
.btn-info.btn-simple:focus,
.btn-info.btn-simple:active {
	background-color: transparent;
	color: #238ebe;
	border-color: #238ebe;
	box-shadow: none;
}
.btn-info.btn-link {
	color: #39a9db;
}
.btn-info.btn-link:hover,
.btn-info.btn-link:focus,
.btn-info.btn-link:active,
.btn-info.btn-link:active:focus {
	background-color: transparent;
	color: #238ebe;
	text-decoration: none;
	box-shadow: none;
}

.btn-warning:hover,
.btn-warning:focus,
.btn-warning:active,
.btn-warning.active,
.btn-warning:active:focus,
.btn-warning:active:hover,
.btn-warning.active:focus,
.btn-warning.active:hover,
.show > .btn-warning.dropdown-toggle,
.show > .btn-warning.dropdown-toggle:focus,
.show > .btn-warning.dropdown-toggle:hover {
	background-color: #ffb626 !important;
	color: #ffffff !important;
	box-shadow: none !important;
}
.btn-warning:not([data-action]):hover {
	box-shadow: none;
}
.btn-warning.disabled,
.btn-warning.disabled:hover,
.btn-warning.disabled:focus,
.btn-warning.disabled.focus,
.btn-warning.disabled:active,
.btn-warning.disabled.active,
.btn-warning:disabled,
.btn-warning:disabled:hover,
.btn-warning:disabled:focus,
.btn-warning:disabled.focus,
.btn-warning:disabled:active,
.btn-warning:disabled.active,
.btn-warning[disabled],
.btn-warning[disabled]:hover,
.btn-warning[disabled]:focus,
.btn-warning[disabled].focus,
.btn-warning[disabled]:active,
.btn-warning[disabled].active,
fieldset[disabled] .btn-warning,
fieldset[disabled] .btn-warning:hover,
fieldset[disabled] .btn-warning:focus,
fieldset[disabled] .btn-warning.focus,
fieldset[disabled] .btn-warning:active,
fieldset[disabled] .btn-warning.active {
	background-color: #ffc759;
	border-color: #ffc759;
}
.btn-warning.btn-simple {
	color: #ffc759;
	border-color: #ffc759;
}
.btn-warning.btn-simple:hover,
.btn-warning.btn-simple:focus,
.btn-warning.btn-simple:active {
	background-color: transparent;
	color: #ffb626;
	border-color: #ffb626;
	box-shadow: none;
}
.btn-warning.btn-link {
	color: #ffc759;
}
.btn-warning.btn-link:hover,
.btn-warning.btn-link:focus,
.btn-warning.btn-link:active,
.btn-warning.btn-link:active:focus {
	background-color: transparent;
	color: #ffb626;
	text-decoration: none;
	box-shadow: none;
}

.btn-danger {
	background-color: #c1292e;
	color: #ffffff;
}
.btn-danger:hover,
.btn-danger:focus,
.btn-danger:active,
.btn-danger.active,
.btn-danger:active:focus,
.btn-danger:active:hover,
.btn-danger.active:focus,
.btn-danger.active:hover,
.show > .btn-danger.dropdown-toggle,
.show > .btn-danger.dropdown-toggle:focus,
.show > .btn-danger.dropdown-toggle:hover {
	background-color: #9f2226 !important;
	color: #ffffff !important;
	box-shadow: none !important;
}
.btn-danger:not([data-action]):hover {
	box-shadow: none;
}
.btn-danger.disabled,
.btn-danger.disabled:hover,
.btn-danger.disabled:focus,
.btn-danger.disabled.focus,
.btn-danger.disabled:active,
.btn-danger.disabled.active,
.btn-danger:disabled,
.btn-danger:disabled:hover,
.btn-danger:disabled:focus,
.btn-danger:disabled.focus,
.btn-danger:disabled:active,
.btn-danger:disabled.active,
.btn-danger[disabled],
.btn-danger[disabled]:hover,
.btn-danger[disabled]:focus,
.btn-danger[disabled].focus,
.btn-danger[disabled]:active,
.btn-danger[disabled].active,
fieldset[disabled] .btn-danger,
fieldset[disabled] .btn-danger:hover,
fieldset[disabled] .btn-danger:focus,
fieldset[disabled] .btn-danger.focus,
fieldset[disabled] .btn-danger:active,
fieldset[disabled] .btn-danger.active {
	background-color: #c1292e;
	border-color: #c1292e;
}
.btn-danger.btn-simple {
	color: #c1292e;
	border-color: #c1292e;
}
.btn-danger.btn-simple:hover,
.btn-danger.btn-simple:focus,
.btn-danger.btn-simple:active {
	background-color: transparent;
	color: #9f2226;
	border-color: #9f2226;
	box-shadow: none;
}
.btn-danger.btn-link {
	color: #c1292e;
}
.btn-danger.btn-link:hover,
.btn-danger.btn-link:focus,
.btn-danger.btn-link:active,
.btn-danger.btn-link:active:focus {
	background-color: transparent;
	color: #9f2226;
	text-decoration: none;
	box-shadow: none;
}

.btn-neutral {
	background-color: #ffffff;
	color: #1c77c3;
}
.btn-neutral:hover,
.btn-neutral:focus,
.btn-neutral:active,
.btn-neutral.active,
.btn-neutral:active:focus,
.btn-neutral:active:hover,
.btn-neutral.active:focus,
.btn-neutral.active:hover,
.show > .btn-neutral.dropdown-toggle,
.show > .btn-neutral.dropdown-toggle:focus,
.show > .btn-neutral.dropdown-toggle:hover {
	background-color: #ffffff !important;
	color: #ffffff !important;
	box-shadow: none !important;
}
.btn-neutral:not([data-action]):hover {
	box-shadow: none;
}
.btn-neutral.disabled,
.btn-neutral.disabled:hover,
.btn-neutral.disabled:focus,
.btn-neutral.disabled.focus,
.btn-neutral.disabled:active,
.btn-neutral.disabled.active,
.btn-neutral:disabled,
.btn-neutral:disabled:hover,
.btn-neutral:disabled:focus,
.btn-neutral:disabled.focus,
.btn-neutral:disabled:active,
.btn-neutral:disabled.active,
.btn-neutral[disabled],
.btn-neutral[disabled]:hover,
.btn-neutral[disabled]:focus,
.btn-neutral[disabled].focus,
.btn-neutral[disabled]:active,
.btn-neutral[disabled].active,
fieldset[disabled] .btn-neutral,
fieldset[disabled] .btn-neutral:hover,
fieldset[disabled] .btn-neutral:focus,
fieldset[disabled] .btn-neutral.focus,
fieldset[disabled] .btn-neutral:active,
fieldset[disabled] .btn-neutral.active {
	background-color: #ffffff;
	border-color: #ffffff;
}
.btn-neutral.btn-danger {
	color: #c1292e;
}
.btn-neutral.btn-danger:hover,
.btn-neutral.btn-danger:focus,
.btn-neutral.btn-danger:active,
.btn-neutral.btn-danger:active:focus {
	color: #9f2226 !important;
}
.btn-neutral.btn-info {
	color: #39a9db !important;
}
.btn-neutral.btn-info:hover,
.btn-neutral.btn-info:focus,
.btn-neutral.btn-info:active,
.btn-neutral.btn-info:active:focus {
	color: #238ebe !important;
}
.btn-neutral.btn-warning {
	color: #ffc759 !important;
}
.btn-neutral.btn-warning:hover,
.btn-neutral.btn-warning:focus,
.btn-neutral.btn-warning:active,
.btn-neutral.btn-warning:active:focus {
	color: #ffb626 !important;
}
.btn-neutral.btn-success {
	color: #28a745 !important;
}
.btn-neutral.btn-success:hover,
.btn-neutral.btn-success:focus,
.btn-neutral.btn-success:active,
.btn-neutral.btn-success:active:focus {
	color: #0c492c !important;
}
.btn-neutral.btn-default {
	color: #65adff !important;
}
.btn-neutral.btn-default:hover,
.btn-neutral.btn-default:focus,
.btn-neutral.btn-default:active,
.btn-neutral.btn-default:active:focus {
	color: #403d39 !important;
}
.btn-neutral.active,
.btn-neutral:active,
.btn-neutral:active:focus,
.btn-neutral:active:hover,
.btn-neutral.active:focus,
.btn-neutral.active:hover,
.show > .btn-neutral.dropdown-toggle,
.show > .btn-neutral.dropdown-toggle:focus,
.show > .btn-neutral.dropdown-toggle:hover {
	background-color: #ffffff !important;
	color: #165c96 !important;
	box-shadow: none !important;
}
.btn-neutral:hover,
.btn-neutral:focus {
	color: #165c96 !important;
}
.btn-neutral:hover:not(.nav-link),
.btn-neutral:focus:not(.nav-link) {
	box-shadow: none;
}
.btn-neutral.btn-simple {
	color: #ffffff;
	border-color: #ffffff;
}
.btn-neutral.btn-simple:hover,
.btn-neutral.btn-simple:focus,
.btn-neutral.btn-simple:active {
	background-color: transparent;
	color: #ffffff;
	border-color: #ffffff;
	box-shadow: none;
}
.btn-neutral.btn-link {
	color: #ffffff;
}
.btn-neutral.btn-link:hover,
.btn-neutral.btn-link:focus,
.btn-neutral.btn-link:active,
.btn-neutral.btn-link:active:focus {
	background-color: transparent;
	color: #ffffff;
	text-decoration: none;
	box-shadow: none;
}

.btn-outline-default {
	background: transparent;
	border: 2px solid #65adff !important;
	color: #65adff;
	opacity: 1;
	filter: alpha(opacity=100);
}
.btn-outline-default:hover,
.btn-outline-default:focus,
.btn-outline-default:active,
.btn-outline-default:focus:active,
.btn-outline-default.active,
.open > .btn-outline-default.dropdown-toggle {
	background-color: #65adff !important;
	color: rgba(255, 255, 255, 0.8) !important;
	border-color: #65adff !important;
}
.btn-outline-default:hover .caret,
.btn-outline-default:focus .caret,
.btn-outline-default:active .caret,
.btn-outline-default:focus:active .caret,
.btn-outline-default.active .caret,
.open > .btn-outline-default.dropdown-toggle .caret {
	border-top-color: rgba(255, 255, 255, 0.8) !important;
}
.btn-outline-default .caret {
	border-top-color: #ffffff !important;
}
.btn-outline-default.disabled,
.btn-outline-default.disabled:hover,
.btn-outline-default.disabled:focus,
.btn-outline-default.disabled.focus,
.btn-outline-default.disabled:active,
.btn-outline-default.disabled.active,
.btn-outline-default:disabled,
.btn-outline-default:disabled:hover,
.btn-outline-default:disabled:focus,
.btn-outline-default:disabled.focus,
.btn-outline-default:disabled:active,
.btn-outline-default:disabled.active,
.btn-outline-default[disabled],
.btn-outline-default[disabled]:hover,
.btn-outline-default[disabled]:focus,
.btn-outline-default[disabled].focus,
.btn-outline-default[disabled]:active,
.btn-outline-default[disabled].active,
fieldset[disabled] .btn-outline-default,
fieldset[disabled] .btn-outline-default:hover,
fieldset[disabled] .btn-outline-default:focus,
fieldset[disabled] .btn-outline-default.focus,
fieldset[disabled] .btn-outline-default:active,
fieldset[disabled] .btn-outline-default.active {
	background-color: transparent !important;
	border-color: #65adff !important;
}

.btn-outline-primary {
	background: transparent;
	border: 2px solid #1c77c3 !important;
	color: #1c77c3;
	opacity: 1;
	filter: alpha(opacity=100);
}
.btn-outline-primary:hover,
.btn-outline-primary:focus,
.btn-outline-primary:active,
.btn-outline-primary:focus:active,
.btn-outline-primary.active,
.open > .btn-outline-primary.dropdown-toggle {
	background-color: #1c77c3 !important;
	color: rgba(255, 255, 255, 0.8) !important;
	border-color: #1c77c3 !important;
}
.btn-outline-primary:hover .caret,
.btn-outline-primary:focus .caret,
.btn-outline-primary:active .caret,
.btn-outline-primary:focus:active .caret,
.btn-outline-primary.active .caret,
.open > .btn-outline-primary.dropdown-toggle .caret {
	border-top-color: rgba(255, 255, 255, 0.8) !important;
}
.btn-outline-primary .caret {
	border-top-color: #ffffff !important;
}
.btn-outline-primary.disabled,
.btn-outline-primary.disabled:hover,
.btn-outline-primary.disabled:focus,
.btn-outline-primary.disabled.focus,
.btn-outline-primary.disabled:active,
.btn-outline-primary.disabled.active,
.btn-outline-primary:disabled,
.btn-outline-primary:disabled:hover,
.btn-outline-primary:disabled:focus,
.btn-outline-primary:disabled.focus,
.btn-outline-primary:disabled:active,
.btn-outline-primary:disabled.active,
.btn-outline-primary[disabled],
.btn-outline-primary[disabled]:hover,
.btn-outline-primary[disabled]:focus,
.btn-outline-primary[disabled].focus,
.btn-outline-primary[disabled]:active,
.btn-outline-primary[disabled].active,
fieldset[disabled] .btn-outline-primary,
fieldset[disabled] .btn-outline-primary:hover,
fieldset[disabled] .btn-outline-primary:focus,
fieldset[disabled] .btn-outline-primary.focus,
fieldset[disabled] .btn-outline-primary:active,
fieldset[disabled] .btn-outline-primary.active {
	background-color: transparent !important;
	border-color: #1c77c3 !important;
}

.btn-outline-secondary {
	background: transparent;
	border: 2px solid #1f84d6 !important;
	color: #1f84d6;
	opacity: 1;
	filter: alpha(opacity=100);
}
.btn-outline-secondary:hover,
.btn-outline-secondary:focus,
.btn-outline-secondary:active,
.btn-outline-secondary:focus:active,
.btn-outline-secondary.active,
.open > .btn-outline-secondary.dropdown-toggle {
	background-color: #1f84d6 !important;
	color: rgba(255, 255, 255, 0.8) !important;
	border-color: #1f84d6 !important;
}
.btn-outline-secondary:hover .caret,
.btn-outline-secondary:focus .caret,
.btn-outline-secondary:active .caret,
.btn-outline-secondary:focus:active .caret,
.btn-outline-secondary.active .caret,
.open > .btn-outline-secondary.dropdown-toggle .caret {
	border-top-color: rgba(255, 255, 255, 0.8) !important;
}
.btn-outline-secondary .caret {
	border-top-color: #ffffff !important;
}
.btn-outline-secondary.disabled,
.btn-outline-secondary.disabled:hover,
.btn-outline-secondary.disabled:focus,
.btn-outline-secondary.disabled.focus,
.btn-outline-secondary.disabled:active,
.btn-outline-secondary.disabled.active,
.btn-outline-secondary:disabled,
.btn-outline-secondary:disabled:hover,
.btn-outline-secondary:disabled:focus,
.btn-outline-secondary:disabled.focus,
.btn-outline-secondary:disabled:active,
.btn-outline-secondary:disabled.active,
.btn-outline-secondary[disabled],
.btn-outline-secondary[disabled]:hover,
.btn-outline-secondary[disabled]:focus,
.btn-outline-secondary[disabled].focus,
.btn-outline-secondary[disabled]:active,
.btn-outline-secondary[disabled].active,
fieldset[disabled] .btn-outline-secondary,
fieldset[disabled] .btn-outline-secondary:hover,
fieldset[disabled] .btn-outline-secondary:focus,
fieldset[disabled] .btn-outline-secondary.focus,
fieldset[disabled] .btn-outline-secondary:active,
fieldset[disabled] .btn-outline-secondary.active {
	background-color: transparent !important;
	border-color: #1f84d6 !important;
}

.btn-outline-success {
	background: transparent;
	border: 2px solid #28a745 !important;
	color: #28a745;
	opacity: 1;
	filter: alpha(opacity=100);
}
.btn-outline-success:hover,
.btn-outline-success:focus,
.btn-outline-success:active,
.btn-outline-success:focus:active,
.btn-outline-success.active,
.open > .btn-outline-success.dropdown-toggle {
	background-color: #28a745 !important;
	color: rgba(255, 255, 255, 0.8) !important;
	border-color: #28a745 !important;
}
.btn-outline-success:hover .caret,
.btn-outline-success:focus .caret,
.btn-outline-success:active .caret,
.btn-outline-success:focus:active .caret,
.btn-outline-success.active .caret,
.open > .btn-outline-success.dropdown-toggle .caret {
	border-top-color: rgba(255, 255, 255, 0.8) !important;
}
.btn-outline-success .caret {
	border-top-color: #ffffff !important;
}
.btn-outline-success.disabled,
.btn-outline-success.disabled:hover,
.btn-outline-success.disabled:focus,
.btn-outline-success.disabled.focus,
.btn-outline-success.disabled:active,
.btn-outline-success.disabled.active,
.btn-outline-success:disabled,
.btn-outline-success:disabled:hover,
.btn-outline-success:disabled:focus,
.btn-outline-success:disabled.focus,
.btn-outline-success:disabled:active,
.btn-outline-success:disabled.active,
.btn-outline-success[disabled],
.btn-outline-success[disabled]:hover,
.btn-outline-success[disabled]:focus,
.btn-outline-success[disabled].focus,
.btn-outline-success[disabled]:active,
.btn-outline-success[disabled].active,
fieldset[disabled] .btn-outline-success,
fieldset[disabled] .btn-outline-success:hover,
fieldset[disabled] .btn-outline-success:focus,
fieldset[disabled] .btn-outline-success.focus,
fieldset[disabled] .btn-outline-success:active,
fieldset[disabled] .btn-outline-success.active {
	background-color: transparent !important;
	border-color: #28a745 !important;
}

.btn-outline-info {
	background: transparent;
	border: 2px solid #39a9db !important;
	color: #39a9db;
	opacity: 1;
	filter: alpha(opacity=100);
}
.btn-outline-info:hover,
.btn-outline-info:focus,
.btn-outline-info:active,
.btn-outline-info:focus:active,
.btn-outline-info.active,
.open > .btn-outline-info.dropdown-toggle {
	background-color: #39a9db !important;
	color: rgba(255, 255, 255, 0.8) !important;
	border-color: #39a9db !important;
}
.btn-outline-info:hover .caret,
.btn-outline-info:focus .caret,
.btn-outline-info:active .caret,
.btn-outline-info:focus:active .caret,
.btn-outline-info.active .caret,
.open > .btn-outline-info.dropdown-toggle .caret {
	border-top-color: rgba(255, 255, 255, 0.8) !important;
}
.btn-outline-info .caret {
	border-top-color: #ffffff !important;
}
.btn-outline-info.disabled,
.btn-outline-info.disabled:hover,
.btn-outline-info.disabled:focus,
.btn-outline-info.disabled.focus,
.btn-outline-info.disabled:active,
.btn-outline-info.disabled.active,
.btn-outline-info:disabled,
.btn-outline-info:disabled:hover,
.btn-outline-info:disabled:focus,
.btn-outline-info:disabled.focus,
.btn-outline-info:disabled:active,
.btn-outline-info:disabled.active,
.btn-outline-info[disabled],
.btn-outline-info[disabled]:hover,
.btn-outline-info[disabled]:focus,
.btn-outline-info[disabled].focus,
.btn-outline-info[disabled]:active,
.btn-outline-info[disabled].active,
fieldset[disabled] .btn-outline-info,
fieldset[disabled] .btn-outline-info:hover,
fieldset[disabled] .btn-outline-info:focus,
fieldset[disabled] .btn-outline-info.focus,
fieldset[disabled] .btn-outline-info:active,
fieldset[disabled] .btn-outline-info.active {
	background-color: transparent !important;
	border-color: #39a9db !important;
}

.btn-outline-warning {
	background: transparent;
	border: 2px solid #ffc759 !important;
	color: #ffc759;
	opacity: 1;
	filter: alpha(opacity=100);
}
.btn-outline-warning:hover,
.btn-outline-warning:focus,
.btn-outline-warning:active,
.btn-outline-warning:focus:active,
.btn-outline-warning.active,
.open > .btn-outline-warning.dropdown-toggle {
	background-color: #ffc759 !important;
	color: rgba(255, 255, 255, 0.8) !important;
	border-color: #ffc759 !important;
}
.btn-outline-warning:hover .caret,
.btn-outline-warning:focus .caret,
.btn-outline-warning:active .caret,
.btn-outline-warning:focus:active .caret,
.btn-outline-warning.active .caret,
.open > .btn-outline-warning.dropdown-toggle .caret {
	border-top-color: rgba(255, 255, 255, 0.8) !important;
}
.btn-outline-warning .caret {
	border-top-color: #ffffff !important;
}
.btn-outline-warning.disabled,
.btn-outline-warning.disabled:hover,
.btn-outline-warning.disabled:focus,
.btn-outline-warning.disabled.focus,
.btn-outline-warning.disabled:active,
.btn-outline-warning.disabled.active,
.btn-outline-warning:disabled,
.btn-outline-warning:disabled:hover,
.btn-outline-warning:disabled:focus,
.btn-outline-warning:disabled.focus,
.btn-outline-warning:disabled:active,
.btn-outline-warning:disabled.active,
.btn-outline-warning[disabled],
.btn-outline-warning[disabled]:hover,
.btn-outline-warning[disabled]:focus,
.btn-outline-warning[disabled].focus,
.btn-outline-warning[disabled]:active,
.btn-outline-warning[disabled].active,
fieldset[disabled] .btn-outline-warning,
fieldset[disabled] .btn-outline-warning:hover,
fieldset[disabled] .btn-outline-warning:focus,
fieldset[disabled] .btn-outline-warning.focus,
fieldset[disabled] .btn-outline-warning:active,
fieldset[disabled] .btn-outline-warning.active {
	background-color: transparent !important;
	border-color: #ffc759 !important;
}

.btn-outline-danger {
	background: transparent;
	border: 2px solid #c1292e !important;
	color: #c1292e;
	opacity: 1;
	filter: alpha(opacity=100);
}
.btn-outline-danger:hover,
.btn-outline-danger:focus,
.btn-outline-danger:active,
.btn-outline-danger:focus:active,
.btn-outline-danger.active,
.open > .btn-outline-danger.dropdown-toggle {
	background-color: #c1292e !important;
	color: rgba(255, 255, 255, 0.8) !important;
	border-color: #c1292e !important;
}
.btn-outline-danger:hover .caret,
.btn-outline-danger:focus .caret,
.btn-outline-danger:active .caret,
.btn-outline-danger:focus:active .caret,
.btn-outline-danger.active .caret,
.open > .btn-outline-danger.dropdown-toggle .caret {
	border-top-color: rgba(255, 255, 255, 0.8) !important;
}
.btn-outline-danger .caret {
	border-top-color: #ffffff !important;
}
.btn-outline-danger.disabled,
.btn-outline-danger.disabled:hover,
.btn-outline-danger.disabled:focus,
.btn-outline-danger.disabled.focus,
.btn-outline-danger.disabled:active,
.btn-outline-danger.disabled.active,
.btn-outline-danger:disabled,
.btn-outline-danger:disabled:hover,
.btn-outline-danger:disabled:focus,
.btn-outline-danger:disabled.focus,
.btn-outline-danger:disabled:active,
.btn-outline-danger:disabled.active,
.btn-outline-danger[disabled],
.btn-outline-danger[disabled]:hover,
.btn-outline-danger[disabled]:focus,
.btn-outline-danger[disabled].focus,
.btn-outline-danger[disabled]:active,
.btn-outline-danger[disabled].active,
fieldset[disabled] .btn-outline-danger,
fieldset[disabled] .btn-outline-danger:hover,
fieldset[disabled] .btn-outline-danger:focus,
fieldset[disabled] .btn-outline-danger.focus,
fieldset[disabled] .btn-outline-danger:active,
fieldset[disabled] .btn-outline-danger.active {
	background-color: transparent !important;
	border-color: #c1292e !important;
}

.btn-outline-neutral {
	background: transparent;
	border: 2px solid #ffffff !important;
	color: #ffffff;
	opacity: 1;
	filter: alpha(opacity=100);
}
.btn-outline-neutral:hover,
.btn-outline-neutral:focus,
.btn-outline-neutral:active,
.btn-outline-neutral:focus:active,
.btn-outline-neutral.active,
.open > .btn-outline-neutral.dropdown-toggle {
	background-color: #ffffff !important;
	color: rgba(255, 255, 255, 0.8) !important;
	border-color: #ffffff !important;
}
.btn-outline-neutral:hover .caret,
.btn-outline-neutral:focus .caret,
.btn-outline-neutral:active .caret,
.btn-outline-neutral:focus:active .caret,
.btn-outline-neutral.active .caret,
.open > .btn-outline-neutral.dropdown-toggle .caret {
	border-top-color: rgba(255, 255, 255, 0.8) !important;
}
.btn-outline-neutral .caret {
	border-top-color: #ffffff !important;
}
.btn-outline-neutral.disabled,
.btn-outline-neutral.disabled:hover,
.btn-outline-neutral.disabled:focus,
.btn-outline-neutral.disabled.focus,
.btn-outline-neutral.disabled:active,
.btn-outline-neutral.disabled.active,
.btn-outline-neutral:disabled,
.btn-outline-neutral:disabled:hover,
.btn-outline-neutral:disabled:focus,
.btn-outline-neutral:disabled.focus,
.btn-outline-neutral:disabled:active,
.btn-outline-neutral:disabled.active,
.btn-outline-neutral[disabled],
.btn-outline-neutral[disabled]:hover,
.btn-outline-neutral[disabled]:focus,
.btn-outline-neutral[disabled].focus,
.btn-outline-neutral[disabled]:active,
.btn-outline-neutral[disabled].active,
fieldset[disabled] .btn-outline-neutral,
fieldset[disabled] .btn-outline-neutral:hover,
fieldset[disabled] .btn-outline-neutral:focus,
fieldset[disabled] .btn-outline-neutral.focus,
fieldset[disabled] .btn-outline-neutral:active,
fieldset[disabled] .btn-outline-neutral.active {
	background-color: transparent !important;
	border-color: #ffffff !important;
}
.btn-outline-neutral:hover,
.btn-outline-neutral:focus {
	color: #403d39;
	background-color: #ffffff;
}

.btn-neutral {
	background-color: #ffffff;
	color: #1c77c3;
	color: #65adff;
}
.btn-neutral:hover,
.btn-neutral:focus,
.btn-neutral:active,
.btn-neutral.active,
.btn-neutral:active:focus,
.btn-neutral:active:hover,
.btn-neutral.active:focus,
.btn-neutral.active:hover,
.show > .btn-neutral.dropdown-toggle,
.show > .btn-neutral.dropdown-toggle:focus,
.show > .btn-neutral.dropdown-toggle:hover {
	background-color: #ffffff !important;
	color: #ffffff !important;
	box-shadow: none !important;
}
.btn-neutral:not([data-action]):hover {
	box-shadow: none;
}
.btn-neutral.disabled,
.btn-neutral.disabled:hover,
.btn-neutral.disabled:focus,
.btn-neutral.disabled.focus,
.btn-neutral.disabled:active,
.btn-neutral.disabled.active,
.btn-neutral:disabled,
.btn-neutral:disabled:hover,
.btn-neutral:disabled:focus,
.btn-neutral:disabled.focus,
.btn-neutral:disabled:active,
.btn-neutral:disabled.active,
.btn-neutral[disabled],
.btn-neutral[disabled]:hover,
.btn-neutral[disabled]:focus,
.btn-neutral[disabled].focus,
.btn-neutral[disabled]:active,
.btn-neutral[disabled].active,
fieldset[disabled] .btn-neutral,
fieldset[disabled] .btn-neutral:hover,
fieldset[disabled] .btn-neutral:focus,
fieldset[disabled] .btn-neutral.focus,
fieldset[disabled] .btn-neutral:active,
fieldset[disabled] .btn-neutral.active {
	background-color: #ffffff;
	border-color: #ffffff;
}
.btn-neutral.btn-danger {
	color: #c1292e;
}
.btn-neutral.btn-danger:hover,
.btn-neutral.btn-danger:focus,
.btn-neutral.btn-danger:active,
.btn-neutral.btn-danger:active:focus {
	color: #9f2226 !important;
}
.btn-neutral.btn-info {
	color: #39a9db !important;
}
.btn-neutral.btn-info:hover,
.btn-neutral.btn-info:focus,
.btn-neutral.btn-info:active,
.btn-neutral.btn-info:active:focus {
	color: #238ebe !important;
}
.btn-neutral.btn-warning {
	color: #ffc759 !important;
}
.btn-neutral.btn-warning:hover,
.btn-neutral.btn-warning:focus,
.btn-neutral.btn-warning:active,
.btn-neutral.btn-warning:active:focus {
	color: #ffb626 !important;
}
.btn-neutral.btn-success {
	color: #28a745 !important;
}
.btn-neutral.btn-success:hover,
.btn-neutral.btn-success:focus,
.btn-neutral.btn-success:active,
.btn-neutral.btn-success:active:focus {
	color: #0c492c !important;
}
.btn-neutral.btn-default {
	color: #65adff !important;
}
.btn-neutral.btn-default:hover,
.btn-neutral.btn-default:focus,
.btn-neutral.btn-default:active,
.btn-neutral.btn-default:active:focus {
	color: #403d39 !important;
}
.btn-neutral.active,
.btn-neutral:active,
.btn-neutral:active:focus,
.btn-neutral:active:hover,
.btn-neutral.active:focus,
.btn-neutral.active:hover,
.show > .btn-neutral.dropdown-toggle,
.show > .btn-neutral.dropdown-toggle:focus,
.show > .btn-neutral.dropdown-toggle:hover {
	background-color: #ffffff !important;
	color: #165c96 !important;
	box-shadow: none !important;
}
.btn-neutral:hover,
.btn-neutral:focus {
	color: #165c96 !important;
}
.btn-neutral:hover:not(.nav-link),
.btn-neutral:focus:not(.nav-link) {
	box-shadow: none;
}
.btn-neutral.btn-simple {
	color: #ffffff;
	border-color: #ffffff;
}
.btn-neutral.btn-simple:hover,
.btn-neutral.btn-simple:focus,
.btn-neutral.btn-simple:active {
	background-color: transparent;
	color: #ffffff;
	border-color: #ffffff;
	box-shadow: none;
}
.btn-neutral.btn-link {
	color: #ffffff;
}
.btn-neutral.btn-link:hover,
.btn-neutral.btn-link:focus,
.btn-neutral.btn-link:active,
.btn-neutral.btn-link:active:focus {
	background-color: transparent;
	color: #ffffff;
	text-decoration: none;
	box-shadow: none;
}
.btn-neutral:hover,
.btn-neutral:focus {
	color: #403d39;
}
.btn-neutral.btn-border:hover,
.btn-neutral.btn-border:focus {
	color: #65adff;
}
.btn-neutral.btn-border:active,
.btn-neutral.btn-border.active,
.open > .btn-neutral.btn-border.dropdown-toggle {
	background-color: #ffffff;
	color: #65adff;
}
.btn-neutral.btn-link:active,
.btn-neutral.btn-link.active {
	background-color: transparent;
}

.btn:disabled,
.btn[disabled],
.btn.disabled {
	opacity: 0.5;
	filter: alpha(opacity=50);
	pointer-events: none;
}

.btn-simple {
	border: 1px solid;
	border-color: #65adff;
	padding: 10px 22px;
	background-color: transparent;
}

.btn-simple.disabled,
.btn-simple.disabled:hover,
.btn-simple.disabled:focus,
.btn-simple.disabled.focus,
.btn-simple.disabled:active,
.btn-simple.disabled.active,
.btn-simple:disabled,
.btn-simple:disabled:hover,
.btn-simple:disabled:focus,
.btn-simple:disabled.focus,
.btn-simple:disabled:active,
.btn-simple:disabled.active,
.btn-simple[disabled],
.btn-simple[disabled]:hover,
.btn-simple[disabled]:focus,
.btn-simple[disabled].focus,
.btn-simple[disabled]:active,
.btn-simple[disabled].active,
fieldset[disabled] .btn-simple,
fieldset[disabled] .btn-simple:hover,
fieldset[disabled] .btn-simple:focus,
fieldset[disabled] .btn-simple.focus,
fieldset[disabled] .btn-simple:active,
fieldset[disabled] .btn-simple.active,
.btn-link.disabled,
.btn-link.disabled:hover,
.btn-link.disabled:focus,
.btn-link.disabled.focus,
.btn-link.disabled:active,
.btn-link.disabled.active,
.btn-link:disabled,
.btn-link:disabled:hover,
.btn-link:disabled:focus,
.btn-link:disabled.focus,
.btn-link:disabled:active,
.btn-link:disabled.active,
.btn-link[disabled],
.btn-link[disabled]:hover,
.btn-link[disabled]:focus,
.btn-link[disabled].focus,
.btn-link[disabled]:active,
.btn-link[disabled].active,
fieldset[disabled] .btn-link,
fieldset[disabled] .btn-link:hover,
fieldset[disabled] .btn-link:focus,
fieldset[disabled] .btn-link.focus,
fieldset[disabled] .btn-link:active,
fieldset[disabled] .btn-link.active {
	background-color: #1c77c3;
}

.btn-link {
	background-color: transparent;
	color: inherit;
}
.btn-link:hover {
	background-color: #1c77c3;
	color: white;
	text-decoration: none;
}

.btn-lg {
	font-size: 1rem;
	border-radius: 6px;
	padding: 15px 35px;
}
.btn-lg.btn-simple {
	padding: 14px 34px;
}

.btn-sm {
	font-size: 0.8571em;
	border-radius: 3px;
	padding: 5px 7px;
}
.btn-md {
	font-size: 0.8871em;
	border-radius: 3px;
	padding: 7px 9px;
}
.btn-sm.btn-simple {
	padding: 4px 14px;
}

.btn-wd {
	min-width: 140px;
}

.btn-group.select {
	width: 100%;
}

.btn-group.select .btn {
	text-align: left;
}

.btn-group.select .caret {
	position: absolute;
	top: 50%;
	margin-top: -1px;
	right: 8px;
}

.btn-group .btn + .btn {
	margin-left: -3px;
}
.btn-group .btn:focus {
	background-color: #1f84d6 !important;
}

.btn-round {
	border-width: 1px;
	border-radius: 30px;
}
.btn-round.btn-simple {
	padding: 10px 22px;
}

.no-caret.dropdown-toggle::after {
	display: none;
}

.btn.btn-facebook {
	background-color: #3b5998;
	color: #ffffff;
}
.btn.btn-facebook:focus,
.btn.btn-facebook:active,
.btn.btn-facebook:hover {
	background-color: #344e86 !important;
	color: #ffffff !important;
}
.btn.btn-facebook.btn-simple {
	color: #3b5998;
	background-color: transparent;
	box-shadow: none;
	border-color: #3b5998;
}
.btn.btn-facebook.btn-simple:hover,
.btn.btn-facebook.btn-simple:focus,
.btn.btn-facebook.btn-simple:active {
	color: #344e86;
	border-color: #344e86;
}
.btn.btn-facebook.btn-neutral {
	color: #3b5998;
	background-color: #ffffff;
}
.btn.btn-facebook.btn-neutral:hover,
.btn.btn-facebook.btn-neutral:focus,
.btn.btn-facebook.btn-neutral:active {
	color: #344e86 !important;
}
.btn.btn-twitter {
	background-color: #55acee;
	color: #ffffff;
}
.btn.btn-twitter:focus,
.btn.btn-twitter:active,
.btn.btn-twitter:hover {
	background-color: #3ea1ec !important;
	color: #ffffff !important;
}
.btn.btn-twitter.btn-simple {
	color: #55acee;
	background-color: transparent;
	box-shadow: none;
	border-color: #55acee;
}
.btn.btn-twitter.btn-simple:hover,
.btn.btn-twitter.btn-simple:focus,
.btn.btn-twitter.btn-simple:active {
	color: #3ea1ec;
	border-color: #3ea1ec;
}
.btn.btn-twitter.btn-neutral {
	color: #55acee;
	background-color: #ffffff;
}
.btn.btn-twitter.btn-neutral:hover,
.btn.btn-twitter.btn-neutral:focus,
.btn.btn-twitter.btn-neutral:active {
	color: #3ea1ec !important;
}
.btn.btn-pinterest {
	background-color: #cc2127;
	color: #ffffff;
}
.btn.btn-pinterest:focus,
.btn.btn-pinterest:active,
.btn.btn-pinterest:hover {
	background-color: #dd2e34 !important;
	color: #ffffff !important;
}
.btn.btn-pinterest.btn-simple {
	color: #cc2127;
	background-color: transparent;
	box-shadow: none;
	border-color: #cc2127;
}
.btn.btn-pinterest.btn-simple:hover,
.btn.btn-pinterest.btn-simple:focus,
.btn.btn-pinterest.btn-simple:active {
	color: #dd2e34;
	border-color: #dd2e34;
}
.btn.btn-pinterest.btn-neutral {
	color: #cc2127;
	background-color: #ffffff;
}
.btn.btn-pinterest.btn-neutral:hover,
.btn.btn-pinterest.btn-neutral:focus,
.btn.btn-pinterest.btn-neutral:active {
	color: #dd2e34 !important;
}
.btn.btn-google {
	background-color: #dd4b39;
	color: #ffffff;
}
.btn.btn-google:focus,
.btn.btn-google:active,
.btn.btn-google:hover {
	background-color: #d73925 !important;
	color: #ffffff !important;
}
.btn.btn-google.btn-simple {
	color: #dd4b39;
	background-color: transparent;
	box-shadow: none;
	border-color: #dd4b39;
}
.btn.btn-google.btn-simple:hover,
.btn.btn-google.btn-simple:focus,
.btn.btn-google.btn-simple:active {
	color: #d73925;
	border-color: #d73925;
}
.btn.btn-google.btn-neutral {
	color: #dd4b39;
	background-color: #ffffff;
}
.btn.btn-google.btn-neutral:hover,
.btn.btn-google.btn-neutral:focus,
.btn.btn-google.btn-neutral:active {
	color: #d73925 !important;
}
.btn.btn-linkedin {
	background-color: #0077b5;
	color: #ffffff;
}
.btn.btn-linkedin:focus,
.btn.btn-linkedin:active,
.btn.btn-linkedin:hover {
	background-color: #00669c !important;
	color: #ffffff !important;
}
.btn.btn-linkedin.btn-simple {
	color: #0077b5;
	background-color: transparent;
	box-shadow: none;
	border-color: #0077b5;
}
.btn.btn-linkedin.btn-simple:hover,
.btn.btn-linkedin.btn-simple:focus,
.btn.btn-linkedin.btn-simple:active {
	color: #00669c;
	border-color: #00669c;
}
.btn.btn-linkedin.btn-neutral {
	color: #0077b5;
	background-color: #ffffff;
}
.btn.btn-linkedin.btn-neutral:hover,
.btn.btn-linkedin.btn-neutral:focus,
.btn.btn-linkedin.btn-neutral:active {
	color: #00669c !important;
}
.btn.btn-dribbble {
	background-color: #ea4c89;
	color: #ffffff;
}
.btn.btn-dribbble:focus,
.btn.btn-dribbble:active,
.btn.btn-dribbble:hover {
	background-color: #ed679b !important;
	color: #ffffff !important;
}
.btn.btn-dribbble.btn-simple {
	color: #ea4c89;
	background-color: transparent;
	box-shadow: none;
	border-color: #ea4c89;
}
.btn.btn-dribbble.btn-simple:hover,
.btn.btn-dribbble.btn-simple:focus,
.btn.btn-dribbble.btn-simple:active {
	color: #ed679b;
	border-color: #ed679b;
}
.btn.btn-dribbble.btn-neutral {
	color: #ea4c89;
	background-color: #ffffff;
}
.btn.btn-dribbble.btn-neutral:hover,
.btn.btn-dribbble.btn-neutral:focus,
.btn.btn-dribbble.btn-neutral:active {
	color: #ed679b !important;
}
.btn.btn-github {
	background-color: #333333;
	color: #ffffff;
}
.btn.btn-github:focus,
.btn.btn-github:active,
.btn.btn-github:hover {
	background-color: #424242 !important;
	color: #ffffff !important;
}
.btn.btn-github.btn-simple {
	color: #333333;
	background-color: transparent;
	box-shadow: none;
	border-color: #333333;
}
.btn.btn-github.btn-simple:hover,
.btn.btn-github.btn-simple:focus,
.btn.btn-github.btn-simple:active {
	color: #424242;
	border-color: #424242;
}
.btn.btn-github.btn-neutral {
	color: #333333;
	background-color: #ffffff;
}
.btn.btn-github.btn-neutral:hover,
.btn.btn-github.btn-neutral:focus,
.btn.btn-github.btn-neutral:active {
	color: #424242 !important;
}
.btn.btn-youtube {
	background-color: #e52d27;
	color: #ffffff;
}
.btn.btn-youtube:focus,
.btn.btn-youtube:active,
.btn.btn-youtube:hover {
	background-color: #e84842 !important;
	color: #ffffff !important;
}
.btn.btn-youtube.btn-simple {
	color: #e52d27;
	background-color: transparent;
	box-shadow: none;
	border-color: #e52d27;
}
.btn.btn-youtube.btn-simple:hover,
.btn.btn-youtube.btn-simple:focus,
.btn.btn-youtube.btn-simple:active {
	color: #e84842;
	border-color: #e84842;
}
.btn.btn-youtube.btn-neutral {
	color: #e52d27;
	background-color: #ffffff;
}
.btn.btn-youtube.btn-neutral:hover,
.btn.btn-youtube.btn-neutral:focus,
.btn.btn-youtube.btn-neutral:active {
	color: #e84842 !important;
}
.btn.btn-instagram {
	background-color: #125688;
	color: #ffffff;
}
.btn.btn-instagram:focus,
.btn.btn-instagram:active,
.btn.btn-instagram:hover {
	background-color: #1667a3 !important;
	color: #ffffff !important;
}
.btn.btn-instagram.btn-simple {
	color: #125688;
	background-color: transparent;
	box-shadow: none;
	border-color: #125688;
}
.btn.btn-instagram.btn-simple:hover,
.btn.btn-instagram.btn-simple:focus,
.btn.btn-instagram.btn-simple:active {
	color: #1667a3;
	border-color: #1667a3;
}
.btn.btn-instagram.btn-neutral {
	color: #125688;
	background-color: #ffffff;
}
.btn.btn-instagram.btn-neutral:hover,
.btn.btn-instagram.btn-neutral:focus,
.btn.btn-instagram.btn-neutral:active {
	color: #1667a3 !important;
}
.btn.btn-reddit {
	background-color: #ff4500;
	color: #ffffff;
}
.btn.btn-reddit:focus,
.btn.btn-reddit:active,
.btn.btn-reddit:hover {
	background-color: #ff5b1f !important;
	color: #ffffff !important;
}
.btn.btn-reddit.btn-simple {
	color: #ff4500;
	background-color: transparent;
	box-shadow: none;
	border-color: #ff4500;
}
.btn.btn-reddit.btn-simple:hover,
.btn.btn-reddit.btn-simple:focus,
.btn.btn-reddit.btn-simple:active {
	color: #ff5b1f;
	border-color: #ff5b1f;
}
.btn.btn-reddit.btn-neutral {
	color: #ff4500;
	background-color: #ffffff;
}
.btn.btn-reddit.btn-neutral:hover,
.btn.btn-reddit.btn-neutral:focus,
.btn.btn-reddit.btn-neutral:active {
	color: #ff5b1f !important;
}
.btn.btn-tumblr {
	background-color: #35465c;
	color: #ffffff;
}
.btn.btn-tumblr:focus,
.btn.btn-tumblr:active,
.btn.btn-tumblr:hover {
	background-color: #40556f !important;
	color: #ffffff !important;
}
.btn.btn-tumblr.btn-simple {
	color: #35465c;
	background-color: transparent;
	box-shadow: none;
	border-color: #35465c;
}
.btn.btn-tumblr.btn-simple:hover,
.btn.btn-tumblr.btn-simple:focus,
.btn.btn-tumblr.btn-simple:active {
	color: #40556f;
	border-color: #40556f;
}
.btn.btn-tumblr.btn-neutral {
	color: #35465c;
	background-color: #ffffff;
}
.btn.btn-tumblr.btn-neutral:hover,
.btn.btn-tumblr.btn-neutral:focus,
.btn.btn-tumblr.btn-neutral:active {
	color: #40556f !important;
}
.btn.btn-behance {
	background-color: #1769ff;
	color: #ffffff;
}
.btn.btn-behance:focus,
.btn.btn-behance:active,
.btn.btn-behance:hover {
	background-color: #367dff !important;
	color: #ffffff !important;
}
.btn.btn-behance.btn-simple {
	color: #1769ff;
	background-color: transparent;
	box-shadow: none;
	border-color: #1769ff;
}
.btn.btn-behance.btn-simple:hover,
.btn.btn-behance.btn-simple:focus,
.btn.btn-behance.btn-simple:active {
	color: #367dff;
	border-color: #367dff;
}
.btn.btn-behance.btn-neutral {
	color: #1769ff;
	background-color: #ffffff;
}
.btn.btn-behance.btn-neutral:hover,
.btn.btn-behance.btn-neutral:focus,
.btn.btn-behance.btn-neutral:active {
	color: #367dff !important;
}

.icon-property,
.btn-move-right i,
.btn-move-left i,
.btn-magnify i,
.btn-rotate i {
	transition: all 370ms cubic-bezier(0.34, 1.61, 0.7, 1);
	position: relative;
	display: inline-block;
}

#animated-buttons .btn i {
	position: relative;
	top: 3px;
	margin-top: -3px;
}

.btn-rotate:hover i,
.btn-rotate:focus i {
	filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);
	transform: rotate(53deg);
}

.btn-magnify:hover i,
.btn-magnify:focus i {
	transform: scale(1.22);
}

.btn-move-left i {
	margin-right: 0;
}
.btn-move-left:hover i,
.btn-move-left:focus i {
	transform: translate3d(-5px, 0, 0);
}

.btn-move-right i {
	margin-right: 0;
}
.btn-move-right:hover i,
.btn-move-right:focus i {
	transform: translate3d(5px, 0, 0);
}

button,
input,
optgroup,
select,
textarea {
	font-family: "Montserrat", "Helvetica Neue", Arial, sans-serif;
}

h1,
h2,
h3,
h4,
h5,
h6 {
	font-weight: 400;
}

a {
	color: inherit;
}
a:hover,
a:focus {
	color: #1c77c3;
}

h1,
.h1 {
	font-size: 3em;
	line-height: 2.15;
	margin-bottom: 30px;
}
h1 small,
.h1 small {
	font-weight: 600;
	text-transform: uppercase;
	opacity: 0.8;
}

h2,
.h2 {
	font-size: 2.3em;
	margin-bottom: 25px;
}

h3,
.h3 {
	font-size: 1.8em;
	margin-bottom: 25px;
	line-height: 1.6em;
}

h4,
.h4 {
	font-size: 1.6em;
	line-height: 1.45em;
	margin-top: 15px;
	margin-bottom: 10px;
}
h4 + .category,
h4.title + .category,
.h4 + .category,
.h4.title + .category {
	margin-top: -10px;
}

h5,
.h5 {
	font-size: 1.47em;
	line-height: 1.3em;
	margin-bottom: 15px;
}

h6,
.h6 {
	font-size: 1em;
	font-weight: 600;
	text-transform: uppercase;
	line-height: 1.5em;
}

p.description {
	font-size: 1.14em;
}

.title {
	font-weight: 600;
}
.title.title-up {
	text-transform: uppercase;
}
.title.title-up a {
	color: #2c2c2c;
	text-decoration: none;
}
.title + .category {
	margin-top: -10px;
}

.description,
.card-description,
.footer-big p,
.card .footer .stats {
	color: #292929 !important;
	font-weight: 300;
}

.category,
.card-category {
	text-transform: capitalize;
	font-weight: 400;
	color: inherit;
	font-size: 0.7142em;
}

.text-primary,
a.text-primary:focus,
a.text-primary:hover {
	color: #1c77c3 !important;
}

.text-info,
a.text-info:focus,
a.text-info:hover {
	color: #39a9db !important;
}

.text-success,
a.text-success:focus,
a.text-success:hover {
	color: #28a745 !important;
}

.text-warning,
a.text-warning:focus,
a.text-warning:hover {
	color: #ffc759 !important;
}

.text-danger,
a.text-danger:focus,
a.text-danger:hover {
	color: #c1292e !important;
}

.text-gray,
a.text-gray:focus,
a.text-gray:hover {
	color: #e3e3e3 !important;
}

.blockquote {
	border-left: none;
	border: 1px solid #65adff;
	padding: 20px;
	font-size: 1.1em;
	line-height: 1.8;
}
.blockquote small {
	color: #65adff;
	font-size: 0.8571em;
	text-transform: uppercase;
}
.blockquote.blockquote-primary {
	border-color: #1c77c3;
	color: #1c77c3;
}
.blockquote.blockquote-primary small {
	color: #1c77c3;
}
.blockquote.blockquote-danger {
	border-color: #c1292e;
	color: #c1292e;
}
.blockquote.blockquote-danger small {
	color: #c1292e;
}
.blockquote.blockquote-white {
	border-color: rgba(255, 255, 255, 0.8);
	color: #ffffff;
}
.blockquote.blockquote-white small {
	color: rgba(255, 255, 255, 0.8);
}

:root {
	--base-font-size: 14px;
}

body {
	color: #2c2c2c;
	font-size: 14px;
	font-size: var(--base-font-size);
	font-family: "Montserrat", "Helvetica Neue", Arial, sans-serif;
	-moz-osx-font-smoothing: grayscale;
	-webkit-font-smoothing: antialiased;
}

.main {
	position: relative;
	background: #ffffff;
}

.btn-surface,
.nav-pill-bar .nav-item a {
	background-color: transparent;
	color: inherit;
}

.btn-surface:hover,
.nav-pill-bar .nav-item a:hover {
	background-color: #efefefd1;
	color: black;
	text-decoration: none;
}

.btn-surface.active {
	background-color: #f7f7f7;
}
.btn-surface:focus {
	color: inherit;
}

/* Animations */
.nav-pills .nav-link,
.navbar,
.nav-tabs .nav-link,
.sidebar .nav a,
.sidebar .nav a i,
.animation-transition-general,
.card-collapse .card .card-header a[data-toggle="collapse"] i,
.sidebar .user .info > a > span,
.off-canvas-sidebar .user .info > a > span,
.sidebar .user a,
.off-canvas-sidebar .user a,
.sidebar .user .photo,
.off-canvas-sidebar .user .photo,
.sidebar .logo a.logo-mini,
.sidebar .logo a.logo-normal,
.off-canvas-sidebar,
.logo-mini,
.off-canvas-sidebar .logo a.logo-normal,
.sidebar .nav p,
.off-canvas-sidebar .nav p,
.sidebar .navbar-minimize,
.off-canvas-sidebar .navbar-minimize,
.sidebar
	.sidebar-wrapper
	> .nav
	[data-toggle="collapse"]
	~ div
	> ul
	> li
	> a
	span,
.sidebar
	.sidebar-wrapper
	.user
	.info
	[data-toggle="collapse"]
	~ div
	> ul
	> li
	> a
	span,
.off-canvas-sidebar
	.sidebar-wrapper
	> .nav
	[data-toggle="collapse"]
	~ div
	> ul
	> li
	> a
	span,
.off-canvas-sidebar
	.sidebar-wrapper
	.user
	.info
	[data-toggle="collapse"]
	~ div
	> ul
	> li
	> a
	span,
.tag,
.tag [data-role="remove"],
.animation-transition-general,
.sidebar .user .info > a > span,
.off-canvas-sidebar .user .info > a > span,
.sidebar .user a,
.off-canvas-sidebar .user a,
.sidebar .user .photo,
.off-canvas-sidebar .user .photo,
.sidebar .logo a.logo-mini,
.sidebar .logo a.logo-normal,
.off-canvas-sidebar .logo a.logo-mini,
.off-canvas-sidebar .logo a.logo-normal,
.sidebar .nav p,
.off-canvas-sidebar .nav p,
.sidebar .navbar-minimize,
.off-canvas-sidebar .navbar-minimize {
	transition: all 300ms ease 0s;
}

.dropdown-toggle:after,
.bootstrap-switch-label:before,
.caret {
	transition: all 150ms ease 0s;
}

.dropdown-toggle[aria-expanded="true"]:after,
a[data-toggle="collapse"][aria-expanded="true"] .caret,
.card-collapse .card a[data-toggle="collapse"][aria-expanded="true"] i,
.card-collapse .card a[data-toggle="collapse"].expanded i {
	filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);
	transform: rotate(180deg);
}

.button-bar {
	display: block;
	position: relative;
	width: 22px;
	height: 1px;
	border-radius: 1px;
	background: #ffffff;
}
.button-bar + .button-bar {
	margin-top: 7px;
}
.button-bar:nth-child(2) {
	width: 17px;
}

.caret {
	display: inline-block;
	width: 0;
	height: 0;
	margin-left: 2px;
	vertical-align: middle;
	border-top: 4px dashed;
	border-top: 4px solid\\9;
	border-right: 4px solid transparent;
	border-left: 4px solid transparent;
}

.pull-left {
	float: left;
}

.pull-right {
	float: right;
}

.offline-doc .navbar.navbar-transparent {
	padding-top: 25px;
	border-bottom: none;
}
.offline-doc .navbar.navbar-transparent .navbar-minimize {
	display: none;
}
.offline-doc .navbar.navbar-transparent .navbar-brand,
.offline-doc .navbar.navbar-transparent .collapse .navbar-nav .nav-link {
	color: #ffffff !important;
}
.offline-doc .footer {
	z-index: 3 !important;
}
.offline-doc .page-header .container {
	z-index: 3;
}
.offline-doc .page-header:after {
	background-color: rgba(0, 0, 0, 0.5);
	content: "";
	display: block;
	height: 100%;
	left: 0;
	position: absolute;
	top: 0;
	width: 100%;
	z-index: 2;
}

.fixed-plugin .dropdown-menu li {
	padding: 2px !important;
}

.badge.badge-default {
	border-color: #65adff;
	background-color: #65adff;
}
.badge.badge-primary {
	border-color: #1c77c3;
	background-color: #1c77c3;
}
.badge.badge-info {
	border-color: #39a9db;
	background-color: #39a9db;
}
.badge.badge-success {
	border-color: #28a745;
	background-color: #28a745;
}
.badge.badge-warning {
	border-color: #ffc759;
	background-color: #ffc759;
}
.badge.badge-danger {
	border-color: #c1292e;
	background-color: #c1292e;
}
.badge.badge-neutral {
	border-color: #ffffff;
	background-color: #ffffff;
	color: inherit;
}

.card-user form .form-group {
	margin-bottom: 20px;
}

.ct-label.ct-horizontal.ct-end,
.ct-label.ct-vertical.ct-start {
	font-size: 14px;
}

.ct-chart.ct-perfect-fourth .ct-chart-pie .ct-label {
	font-size: 14px;
}

.card .card-footer .footer-line {
	padding-top: 3px;
}
.card.bootstrap-table .dropdown-item.active {
	background-color: #65adff;
	color: #ffffff;
}
.card .team-members .avatar {
	margin-top: 5px;
}
.card .team-members .text-right .btn {
	margin-top: 5px;
}

.btn-group-sm .btn-round {
	border-radius: 30px;
}

.heart {
	color: #eb5e28;
	animation: hearthing 1s ease infinite;
}

@keyframes hearthing {
	0% {
		transform: scale(0.75);
	}
	20% {
		transform: scale(1);
	}
	40% {
		transform: scale(0.75);
	}
	60% {
		transform: scale(1);
	}
	80% {
		transform: scale(0.75);
	}
	100% {
		transform: scale(0.75);
	}
}
.datepicker .table-condensed tbody > tr:first-of-type .day {
	padding-top: 5px;
}

.navbar {
	padding-top: 0.625rem;
	padding-bottom: 0.4rem;
	min-height: 53px;
	margin-bottom: 20px;
}
.navbar a {
	vertical-align: middle;
}
.navbar a:not(.btn):not(.dropdown-item) {
	color: #ffffff;
}
.navbar a.dropdown-item {
	color: #65adff;
}
.navbar.bg-white .input-group .form-control,
.navbar.bg-white .input-group.no-border .form-control {
	color: #65adff;
}
.navbar.bg-white .input-group .form-control::-moz-placeholder,
.navbar.bg-white .input-group.no-border .form-control::-moz-placeholder {
	color: #65adff;
}
.navbar.bg-white .input-group .form-control:-ms-input-placeholder,
.navbar.bg-white .input-group.no-border .form-control:-ms-input-placeholder {
	color: #65adff;
}
.navbar.bg-white .input-group .form-control::-webkit-input-placeholder,
.navbar.bg-white
	.input-group.no-border
	.form-control::-webkit-input-placeholder {
	color: #65adff;
}
.navbar.bg-white .input-group-prepend .input-group-text i,
.navbar.bg-white .input-group-append .input-group-text i {
	color: #65adff;
	opacity: 0.5;
}
.navbar .form-group,
.navbar .input-group {
	margin: 0;
	margin-left: -3px;
	margin-right: 5px;
}
.navbar .form-group .form-group-addon,
.navbar .form-group .input-group-prepend .input-group-text,
.navbar .form-group .input-group-append .input-group-text,
.navbar .input-group .form-group-addon,
.navbar .input-group .input-group-prepend .input-group-text,
.navbar .input-group .input-group-append .input-group-text {
	color: #65adff;
}
.navbar .form-group .form-group-addon i,
.navbar .form-group .input-group-prepend .input-group-text i,
.navbar .form-group .input-group-append .input-group-text i,
.navbar .input-group .form-group-addon i,
.navbar .input-group .input-group-prepend .input-group-text i,
.navbar .input-group .input-group-append .input-group-text i {
	opacity: 1;
}
.navbar .form-group.no-border .form-control,
.navbar .input-group.no-border .form-control {
	color: #65adff;
}
.navbar .form-group.no-border .form-control::-moz-placeholder,
.navbar .input-group.no-border .form-control::-moz-placeholder {
	color: #65adff;
}
.navbar .form-group.no-border .form-control:-ms-input-placeholder,
.navbar .input-group.no-border .form-control:-ms-input-placeholder {
	color: #65adff;
}
.navbar .form-group.no-border .form-control::-webkit-input-placeholder,
.navbar .input-group.no-border .form-control::-webkit-input-placeholder {
	color: #65adff;
}
.navbar p {
	display: inline-block;
	margin: 0;
	line-height: 0.2em;
	font-size: 1em;
	font-weight: 400;
}
.navbar.navbar-absolute {
	position: absolute;
	width: 100%;
	padding-top: 10px;
	z-index: 1029;
	top: 0;
}
.documentation .navbar.fixed-top {
	left: 0;
	width: auto;
	width: initial;
}
.navbar .navbar-wrapper {
	display: inline-flex;
	align-items: center;
}
.navbar .navbar-wrapper .navbar-minimize {
	padding-right: 10px;
}
.navbar .navbar-wrapper .navbar-minimize .btn {
	margin: 0;
}
.navbar .navbar-wrapper .navbar-toggle .navbar-toggler {
	padding-left: 0;
}
.navbar .navbar-wrapper .navbar-toggle:hover .navbar-toggler-bar.bar2 {
	width: 22px;
}
.navbar .navbar-nav.navbar-logo {
	position: absolute;
	left: 0;
	right: 0;
	margin: 0 auto;
	width: 49px;
	top: -4px;
}
.navbar .navbar-nav .nav-link.btn {
	padding: 11px 22px;
}
.navbar .navbar-nav .nav-link.btn.btn-lg {
	padding: 15px 35px;
}
.navbar .navbar-nav .nav-link.btn.btn-sm {
	padding: 5px 15px;
}
.navbar .navbar-nav .nav-link {
	text-transform: uppercase;
	font-size: 0.7142em;
	padding: 0.5rem 0.7rem;
	line-height: 1.625rem;
	margin-right: 3px;
}
.navbar .navbar-nav .nav-link i.fa + p,
.navbar .navbar-nav .nav-link i.nc-icon + p {
	margin-left: 3px;
}
.navbar .navbar-nav .nav-link i.fa,
.navbar .navbar-nav .nav-link i.nc-icon {
	font-size: 18px;
	position: relative;
	top: 3px;
	text-align: center;
	width: 21px;
}
.navbar .navbar-nav .nav-link i.nc-icon {
	top: 4px;
	font-size: 16px;
}
.navbar .navbar-nav .nav-link.profile-photo .profile-photo-small {
	width: 27px;
	height: 27px;
}
.navbar .navbar-nav .nav-link.disabled {
	opacity: 0.5;
	color: #ffffff;
}
.navbar .navbar-nav .nav-item.active .nav-link:not(.btn),
.navbar .navbar-nav .nav-item .nav-link:not(.btn):focus,
.navbar .navbar-nav .nav-item .nav-link:not(.btn):hover,
.navbar .navbar-nav .nav-item .nav-link:not(.btn):active {
	border-radius: 3px;
	color: #65adff;
}
.navbar .logo-container {
	width: 27px;
	height: 27px;
	overflow: hidden;
	margin: 0 auto;
	border-radius: 50%;
	border: 1px solid transparent;
}
.navbar .navbar-brand {
	text-transform: capitalize;
	font-size: 20px;
	padding-top: 0.5rem;
	padding-bottom: 0.5rem;
	line-height: 1.625rem;
}
.navbar .navbar-toggler {
	width: 37px;
	height: 27px;
	vertical-align: middle;
	outline: 0;
	cursor: pointer;
}
.navbar .navbar-toggler .navbar-toggler-bar.navbar-kebab {
	width: 3px;
	height: 3px;
	border-radius: 50%;
	margin: 0 auto;
}
.navbar .button-dropdown .navbar-toggler-bar:nth-child(2) {
	width: 17px;
}
.navbar.navbar-transparent {
	background-color: transparent !important;
	box-shadow: none;
	border-bottom: 1px solid #ddd;
}
.navbar.navbar-transparent a:not(.dropdown-item):not(.btn) {
	color: #65adff;
}
.navbar.navbar-transparent a:not(.dropdown-item):not(.btn).disabled {
	opacity: 0.5;
	color: #65adff;
}
.navbar.navbar-transparent .button-bar {
	background: #65adff;
}
.navbar.navbar-transparent .nav-item .nav-link:not(.btn) {
	color: #65adff;
}
.navbar.navbar-transparent .nav-item.active .nav-link:not(.btn),
.navbar.navbar-transparent .nav-item .nav-link:not(.btn):focus,
.navbar.navbar-transparent .nav-item .nav-link:not(.btn):hover,
.navbar.navbar-transparent .nav-item .nav-link:not(.btn):focus:hover,
.navbar.navbar-transparent .nav-item .nav-link:not(.btn):active {
	color: #1c77c3;
}
.navbar.bg-white a:not(.dropdown-item):not(.btn) {
	color: #65adff;
}
.navbar.bg-white a:not(.dropdown-item):not(.btn).disabled {
	opacity: 0.5;
	color: #65adff;
}
.navbar.bg-white .button-bar {
	background: #65adff;
}
.navbar.bg-white .nav-item.active .nav-link:not(.btn),
.navbar.bg-white .nav-item .nav-link:not(.btn):focus,
.navbar.bg-white .nav-item .nav-link:not(.btn):hover,
.navbar.bg-white .nav-item .nav-link:not(.btn):active {
	color: #39a9db;
}
.navbar.bg-white .logo-container {
	border: 1px solid #65adff;
}
.navbar .navbar-collapse .nav-item a {
	font-size: 14px;
}

.bg-default {
	background-color: #65adff !important;
}

.bg-primary {
	background-color: #1c77c3 !important;
}

.bg-info {
	background-color: #39a9db !important;
}

.bg-success {
	background-color: #28a745 !important;
}

.bg-danger {
	background-color: #c1292e !important;
}

.bg-warning {
	background-color: #ffc759 !important;
}

.bg-white {
	background-color: #ffffff !important;
}

.dropdown .dropdown-menu,
.dropup .dropdown-menu,
.bootstrap-select .dropdown-menu {
	display: block;
	margin-top: 2rem;
	opacity: 0;
	filter: alpha(opacity=0);
	box-shadow: 1px 2px 7px 1px rgba(0, 0, 0, 0.125);
	visibility: hidden;
	position: absolute;
	transition: all 0.3s cubic-bezier(0.215, 0.61, 0.355, 1) 0s,
		opacity 0.3s ease 0s, height 0s linear 0.35s;
}
.dropdown .dropdown-menu[x-placement="top-start"],
.dropup .dropdown-menu[x-placement="top-start"],
.bootstrap-select .dropdown-menu[x-placement="top-start"] {
	transform: translate3d(-20px, 0px, 0) !important;
}
.dropdown .dropdown-menu[x-placement="bottom-start"],
.dropup .dropdown-menu[x-placement="bottom-start"],
.bootstrap-select .dropdown-menu[x-placement="bottom-start"] {
	transform: translate3d(-20px, 0px, 0) !important;
}
.dropdown.show .dropdown-menu,
.dropup.show .dropdown-menu,
.bootstrap-select.show .dropdown-menu {
	opacity: 1;
	filter: alpha(opacity=100);
	visibility: visible;
}
.dropdown.show .dropdown-menu[x-placement="top-start"],
.dropup.show .dropdown-menu[x-placement="top-start"],
.bootstrap-select.show .dropdown-menu[x-placement="top-start"] {
	transform: translate3d(-20px, -50px, 0) !important;
	top: auto !important;
	bottom: 0 !important;
}
.dropdown.show .dropdown-menu[x-placement="bottom-start"],
.dropup.show .dropdown-menu[x-placement="bottom-start"],
.bootstrap-select.show .dropdown-menu[x-placement="bottom-start"] {
	transform: translate3d(-20px, 50px, 0) !important;
	bottom: auto !important;
	top: 0 !important;
}

.dropup .dropdown-menu,
.dropdown-btn .dropdown-menu {
	transform: translate3d(-20px, 0px, 0) !important;
	top: auto !important;
	bottom: 0 !important;
}

.dropup.show .dropdown-menu,
.dropdown-btn.show .dropdown-menu {
	opacity: 1;
	visibility: visible;
}
.dropup.show .dropdown-menu .dropdown-menu.inner,
.dropdown-btn.show .dropdown-menu .dropdown-menu.inner {
	transform: translate3d(0, 0px, 0) !important;
}

.bootstrap-select.show .dropdown-menu.show[x-placement="top-start"] {
	transform: translate3d(-20px, -60px, 0) !important;
	top: auto !important;
	bottom: 0 !important;
}
.bootstrap-select.show .dropdown-menu.show li:last-child a:hover {
	border-radius: 0 0 12px 12px;
}

.bootstrap-select.dropup.show:before {
	top: -1px !important;
}
.bootstrap-select.dropup.show:after {
	top: -2px !important;
}

.dropdown-menu {
	background-color: #ffffff;
	border: 0 none;
	border-radius: 12px;
	margin-top: 10px;
	padding: 0px;
}
.dropdown-menu .divider {
	background-color: #f1eae0;
	margin: 0px;
}
.dropdown-menu .dropdown-header {
	color: #292929 !important;
	font-size: 0.8571em;
	padding: 10px 15px;
}
.dropdown-menu .no-notification {
	color: #292929 !important;
	font-size: 1.2em;
	padding: 30px 30px;
	text-align: center;
}
.dropdown-menu .dropdown-item {
	color: #292929;
	font-size: 14px;
	padding: 10px;
	clear: both;
	white-space: nowrap;
	width: 100%;
	display: block;
}
.dropdown-menu .dropdown-item img {
	margin-top: -3px;
}
.dropdown-menu .dropdown-item:focus {
	outline: 0 !important;
}
.btn-group.select .dropdown-menu {
	min-width: 100%;
}
.dropdown-menu .dropdown-item:first-child {
	border-top-left-radius: 12px;
	border-top-right-radius: 12px;
}
.dropdown-menu .dropdown-item:last-child {
	border-bottom-left-radius: 12px;
	border-bottom-right-radius: 12px;
}
.select .dropdown-menu .dropdown-item:first-child {
	border-radius: 0;
	border-bottom: 0 none;
}
.dropdown-menu .dropdown-item:hover,
.dropdown-menu .dropdown-item:focus {
	color: #ffffff !important;
	opacity: 1;
	text-decoration: none;
}
.dropdown-menu .dropdown-item:hover,
.dropdown-menu .dropdown-item:focus {
	background-color: #1c77c3;
}
.dropdown-menu.dropdown-primary .dropdown-item:hover,
.dropdown-menu.dropdown-primary .dropdown-item:focus {
	background-color: #238adf;
}
.dropdown-menu.dropdown-info .dropdown-item:hover,
.dropdown-menu.dropdown-info .dropdown-item:focus {
	background-color: #57b6e0;
}
.dropdown-menu.dropdown-success .dropdown-item:hover,
.dropdown-menu.dropdown-success .dropdown-item:focus {
	background-color: #18945a;
}
.dropdown-menu.dropdown-warning .dropdown-item:hover,
.dropdown-menu.dropdown-warning .dropdown-item:focus {
	background-color: #ffd37d;
}
.dropdown-menu.dropdown-danger .dropdown-item:hover,
.dropdown-menu.dropdown-danger .dropdown-item:focus {
	background-color: #d5393e;
}

.dropdown-divider {
	margin: 0 !important;
}

.btn-group.select.open {
	overflow: visible;
}

.dropdown-menu-right {
	right: -2px;
	left: auto;
}

.navbar-nav .dropdown-menu:before,
.dropdown .dropdown-menu[x-placement="bottom-start"]:before,
.dropdown .dropdown-menu[x-placement="bottom-end"]:before,
.card.card-just-text .dropdown .dropdown-menu:before,
.card-just-text .dropdown .dropdown-menu:before,
.dropdown-btn .dropdown-menu:before {
	border-bottom: 11px solid #f1eae0;
	border-left: 11px solid rgba(0, 0, 0, 0);
	border-right: 11px solid rgba(0, 0, 0, 0);
	content: "";
	display: inline-block;
	position: absolute;
	right: 12px;
	top: -12px;
}

.navbar-nav .dropdown-menu:after,
.dropdown .dropdown-menu[x-placement="bottom-start"]:after,
.dropdown .dropdown-menu[x-placement="bottom-end"]:after,
.card.card-just-text .dropdown .dropdown-menu:after,
.card-just-text .dropdown .dropdown-menu:after,
.dropdown-btn .dropdown-menu:after {
	border-bottom: 11px solid #ffffff;
	border-left: 11px solid rgba(0, 0, 0, 0);
	border-right: 11px solid rgba(0, 0, 0, 0);
	content: "";
	display: inline-block;
	position: absolute;
	right: 12px;
	top: -11px;
}

.dropdown .dropdown-menu.dropdown-notification[x-placement="top-start"]:before,
.dropdown
	.dropdown-menu.dropdown-notification[x-placement="bottom-start"]:before {
	left: 30px !important;
	right: auto;
}

.dropdown .dropdown-menu.dropdown-notification[x-placement="top-start"]:after,
.dropdown
	.dropdown-menu.dropdown-notification[x-placement="bottom-start"]:after {
	left: 30px !important;
	right: auto;
}

@media screen and (min-width: 768px) {
	.navbar-form {
		margin-top: 21px;
		margin-bottom: 21px;
		padding-left: 5px;
		padding-right: 5px;
	}

	.navbar-search-form {
		display: none;
	}

	.navbar-nav .dropdown-item .dropdown-menu,
	.dropdown .dropdown-menu,
	.dropdown-btn .dropdown-menu {
		transform: translate3d(0px, -40px, 0px);
		transition: all 0.3s cubic-bezier(0.215, 0.61, 0.355, 1) 0s,
			opacity 0.3s ease 0s, height 0s linear 0.35s;
	}

	.navbar-nav .dropdown-item.show .dropdown-menu,
	.dropdown.show .dropdown-menu,
	.dropdown-btn.show .dropdown-menu {
		transform: translate3d(0px, 0px, 0px);
		visibility: visible !important;
	}

	.bootstrap-select .dropdown-menu {
		transition: all 150ms linear;
	}

	.bootstrap-datetimepicker-widget {
		visibility: visible !important;
	}

	.bootstrap-select .show .dropdown-menu {
		transition: all 0.3s cubic-bezier(0.215, 0.61, 0.355, 1) 0s,
			opacity 0.3s ease 0s, height 0s linear 0.35s;
		transform: translate3d(0px, 0px, 0px);
	}

	.navbar-nav.navbar-right li .dropdown-menu:before,
	.navbar-nav.navbar-right li .dropdown-menu:after {
		left: auto;
		right: 12px;
	}

	.footer:not(.footer-big) nav ul li:first-child {
		margin-left: 0;
	}

	body > .navbar-collapse.collapse {
		display: none !important;
	}
}
.dropdown-sharing .dropup-item {
	color: #292929 !important;
	font-size: 14px;
}
.dropdown-sharing .dropup-item .social-line {
	line-height: 28px;
	padding: 10px 20px 5px 20px !important;
}
.dropdown-sharing .dropup-item .social-line [class*="icon-"] {
	font-size: 20px;
}
.dropdown-sharing .dropup-item:last-child {
	margin: 0 13px;
	display: block;
}
.dropdown-sharing .dropup-item .btn {
	margin: 10px;
}
.dropdown-sharing .dropup-item:hover .social-line,
.dropdown-sharing .dropup-item:hover .action-line,
.dropdown-sharing .dropup-item:focus .social-line,
.dropdown-sharing .dropup-item:focus .action-line {
	background-color: #ffffff;
	color: #292929 !important;
	opacity: 1;
	text-decoration: none;
}

.show .dropdown-sharing,
.show .dropdown-actions {
	margin-bottom: 1px;
}

.dropdown-actions .dropdown-item {
	margin: -15px 35px;
}
.dropdown-actions .dropdown-item .action-line {
	padding: 5px 10px;
	line-height: 24px;
	font-weight: bold;
}
.dropdown-actions .dropdown-item .action-line [class*="icon-"] {
	font-size: 24px;
}
.dropdown-actions .dropdown-item .action-line .col-sm-9 {
	line-height: 34px;
}
.dropdown-actions .dropdown-item .link-danger {
	color: #c1292e;
}
.dropdown-actions .dropdown-item .link-danger:hover,
.dropdown-actions .dropdown-item .link-danger:active,
.dropdown-actions .dropdown-item .link-danger:focus {
	color: #c1292e;
}
.dropdown-actions li:hover a,
.dropdown-actions li:focus a {
	color: #292929 !important;
	opacity: 1;
	text-decoration: none;
}
.dropdown-actions .action-line .icon-simple {
	margin-left: -15px;
}

.dropdown .dropdown-menu[x-placement="top-start"]:before,
.dropdown .dropdown-menu[x-placement="top-end"]:before,
.dropup .dropdown-menu:before {
	border-top: 11px solid #dcd9d1;
	border-left: 11px solid transparent;
	border-right: 11px solid transparent;
	content: "";
	display: inline-block;
	position: absolute;
	right: 12px;
	bottom: -12px;
}

.dropdown .dropdown-menu[x-placement="top-start"]:after,
.dropdown .dropdown-menu[x-placement="top-end"]:after,
.dropup .dropdown-menu:after {
	border-top: 11px solid #fff;
	border-left: 11px solid transparent;
	border-right: 11px solid transparent;
	content: "";
	display: inline-block;
	position: absolute;
	right: 12px;
	bottom: -11px;
}

.dropup .dropdown-toggle:after,
.dropdown .dropdown-toggle:after {
	margin-left: 0;
}

.dropdown-notification .dropdown-notification-list .notification-item {
	border-bottom: 1px solid #f1eae0;
	font-size: 16px;
	color: #66615b;
}
.dropdown-notification
	.dropdown-notification-list
	.notification-item
	.notification-text {
	padding-left: 40px;
	position: relative;
	min-width: 330px;
	min-height: 70px;
	white-space: normal;
}
.dropdown-notification
	.dropdown-notification-list
	.notification-item
	.notification-text
	.label {
	display: block;
	position: absolute;
	top: 50%;
	margin-top: -12px;
	left: 7px;
}
.dropdown-notification
	.dropdown-notification-list
	.notification-item
	.notification-text
	.message {
	font-size: 0.9em;
	line-height: 0.7;
	margin-left: 10px;
}
.dropdown-notification
	.dropdown-notification-list
	.notification-item
	.notification-text
	.time {
	color: #292929 !important;
	font-size: 0.7em;
	margin-left: 10px;
}
.dropdown-notification
	.dropdown-notification-list
	.notification-item
	.read-notification {
	font-size: 12px;
	opacity: 0;
	position: absolute;
	right: 5px;
	top: 50%;
	margin-top: -12px;
}
.dropdown-notification .dropdown-notification-list .notification-item:hover {
	text-decoration: none;
}
.dropdown-notification
	.dropdown-notification-list
	.notification-item:hover
	.notification-text {
	color: #66615b;
	background-color: #f0efeb !important;
}
.dropdown-notification
	.dropdown-notification-list
	.notification-item:hover
	.read-notification {
	opacity: 1 !important;
}
.dropdown-notification .dropdown-footer {
	background-color: #e8e7e3;
	border-radius: 0 0 8px 8px;
}
.dropdown-notification .dropdown-footer .dropdown-footer-menu {
	list-style: outside none none;
	padding: 0px 5px;
}
.dropdown-notification .dropdown-footer .dropdown-footer-menu li {
	display: inline-block;
	text-align: left;
	padding: 0 10px;
}
.dropdown-notification .dropdown-footer .dropdown-footer-menu li a {
	color: #9c9b99;
	font-size: 0.9em;
	line-height: 35px;
}

.alert {
	border: 0;
	border-radius: 3px;
	color: #ffffff;
	padding-top: 0.9rem;
	padding-bottom: 0.9rem;
	position: relative;
}
.alert.alert-success {
	background-color: #178b54;
}
.alert.alert-danger {
	background-color: #d33036;
}
.alert.alert-warning {
	background-color: #ffd073;
}
.alert.alert-info {
	background-color: #4fb2df;
}
.alert.alert-primary {
	background-color: #1f85d9;
}
.alert .close {
	color: #ffffff;
	opacity: 0.9;
	text-shadow: none;
	line-height: 0;
	outline: 0;
}
.alert .close i.fa,
.alert .close i.nc-icon {
	font-size: 14px !important;
}
.alert .close:hover,
.alert .close:focus {
	opacity: 1;
}
.alert span[data-notify="icon"] {
	font-size: 27px;
	display: block;
	left: 19px;
	position: absolute;
	top: 50%;
	margin-top: -11px;
}
.alert button.close {
	position: absolute;
	right: 10px;
	top: 50%;
	margin-top: -13px;
	width: 25px;
	height: 25px;
	padding: 3px;
}
.alert .close ~ span {
	display: block;
	max-width: 89%;
}
.alert.alert-with-icon {
	padding-left: 65px;
}

img {
	max-width: 100%;
	border-radius: 3px;
}

.img-raised {
	box-shadow: 0px 10px 25px 0px rgba(0, 0, 0, 0.3);
}

.table .img-wrapper {
	width: 40px;
	height: 40px;
	border-radius: 50%;
	overflow: hidden;
	margin: 0 auto;
}
.table .img-row {
	max-width: 60px;
	width: 60px;
}
.table .form-check {
	margin: 0;
}
.table .form-check label .form-check-sign::before,
.table .form-check label .form-check-sign::after {
	top: -17px;
	left: 4px;
}
.table .btn {
	margin: 0;
}
.table small,
.table .small {
	font-weight: 300;
}
.card-tasks .card-body .table {
	margin-bottom: 0;
}
.card-tasks .card-body .table > thead > tr > th,
.card-tasks .card-body .table > tbody > tr > th,
.card-tasks .card-body .table > tfoot > tr > th,
.card-tasks .card-body .table > thead > tr > td,
.card-tasks .card-body .table > tbody > tr > td,
.card-tasks .card-body .table > tfoot > tr > td {
	padding-top: 0;
	padding-bottom: 0;
}
.table > thead > tr > th {
	font-size: 14px;
	font-weight: 600;
	padding-bottom: 0;
	text-transform: uppercase;
	border: 0;
}
.table .radio,
.table .checkbox {
	margin-top: 0;
	margin-bottom: 0;
	padding: 0;
	width: 15px;
}
.table .radio .icons,
.table .checkbox .icons {
	position: relative;
}
.table .radio label:after,
.table .radio label:before,
.table .checkbox label:after,
.table .checkbox label:before {
	top: -17px;
	left: -3px;
}
.table > thead > tr > th,
.table > tbody > tr > th,
.table > tfoot > tr > th,
.table > thead > tr > td,
.table > tbody > tr > td,
.table > tfoot > tr > td {
	padding: 12px 7px;
	vertical-align: middle;
}
.table .th-description {
	max-width: 150px;
}
.table .td-price {
	font-size: 26px;
	font-weight: 300;
	margin-top: 5px;
	position: relative;
	top: 4px;
	text-align: right;
}
.table .td-total {
	font-weight: 600;
	font-size: 1.57em;
	padding-top: 20px;
	text-align: right;
}
.table .td-actions .btn {
	margin: 0px;
}
.table > tbody > tr {
	position: relative;
}

.table-shopping > thead > tr > th {
	font-size: 1em;
	text-transform: uppercase;
}
.table-shopping > tbody > tr > td {
	font-size: 1em;
}
.table-shopping > tbody > tr > td b {
	display: block;
	margin-bottom: 5px;
}
.table-shopping .td-name {
	font-weight: 400;
	font-size: 1.5em;
}
.table-shopping .td-name small {
	color: #292929 !important;
	font-size: 0.75em;
	font-weight: 300;
}
.table-shopping .td-number {
	font-weight: 300;
	font-size: 1.714em;
}
.table-shopping .td-name {
	min-width: 200px;
}
.table-shopping .td-number {
	text-align: right;
	min-width: 170px;
}
.table-shopping .td-number small {
	margin-right: 3px;
}
.table-shopping .img-container {
	width: 120px;
	max-height: 160px;
	overflow: hidden;
	display: block;
}
.table-shopping .img-container img {
	width: 100%;
}

.table-responsive {
	overflow: scroll;
	padding-bottom: 10px;
}

#tables .table-responsive {
	margin-bottom: 30px;
}

.table-hover > tbody > tr:hover {
	background-color: #e1f0ff;
}

.footer {
	margin-top: 25px;
	padding: 4px 0;
}
.footer.footer-default {
	background-color: #f2f2f2;
}
.footer nav {
	display: inline-block;
	padding-left: 0;
}
.footer ul {
	margin-bottom: 0;
	padding: 0;
	list-style: none;
}
.footer ul li {
	display: inline-block;
}
.footer ul li a {
	color: inherit;
	padding: 0.5rem;
	font-size: 0.8571em;
	text-transform: uppercase;
	text-decoration: none;
}
.footer ul li a:hover {
	text-decoration: none;
}
.footer .copyright {
	font-size: 0.8571em;
	line-height: 1.8;
}
.footer:after {
	display: table;
	clear: both;
	content: " ";
}

.fixed-plugin {
	position: fixed;
	right: 0;
	width: 64px;
	background: rgba(0, 0, 0, 0.3);
	z-index: 1031;
	border-radius: 8px 0 0 8px;
	text-align: center;
	top: 120px;
}
.fixed-plugin li > a,
.fixed-plugin .badge {
	transition: all 0.34s;
	-webkit-transition: all 0.34s;
	-moz-transition: all 0.34s;
}
.fixed-plugin .fa-cog {
	color: #ffffff;
	padding: 10px;
	border-radius: 0 0 6px 6px;
	width: auto;
}
.fixed-plugin .dropdown-menu {
	right: 80px;
	left: auto !important;
	top: -52px !important;
	width: 290px;
	border-radius: 10px;
	padding: 0 10px;
}
.fixed-plugin .dropdown .dropdown-menu .nc-icon {
	top: 2px;
	right: 10px;
	font-size: 14px;
}
.fixed-plugin .dropdown-menu:after,
.fixed-plugin .dropdown-menu:before {
	right: 10px;
	margin-left: auto;
	left: auto;
}
.fixed-plugin .fa-circle-thin {
	color: #ffffff;
}
.fixed-plugin .active .fa-circle-thin {
	color: #00bbff;
}
.fixed-plugin .dropdown-menu > .active > a,
.fixed-plugin .dropdown-menu > .active > a:hover,
.fixed-plugin .dropdown-menu > .active > a:focus {
	color: #777777;
	text-align: center;
}
.fixed-plugin img {
	border-radius: 0;
	width: 100%;
	height: 100px;
	margin: 0 auto;
}
.fixed-plugin .dropdown-menu li > a:hover,
.fixed-plugin .dropdown-menu li > a:focus {
	box-shadow: none;
}
.fixed-plugin .badge {
	border: 3px solid #ffffff;
	border-radius: 50%;
	cursor: pointer;
	display: inline-block;
	height: 23px;
	margin-right: 5px;
	position: relative;
	width: 23px;
}
.fixed-plugin .badge.badge-light {
	border: 1px solid #e3e3e3;
}
.fixed-plugin .badge.badge-light.active,
.fixed-plugin .badge.badge-light:hover {
	border: 3px solid #0bf;
}
.fixed-plugin .badge.active,
.fixed-plugin .badge:hover {
	border-color: #00bbff;
}
.fixed-plugin .badge-blue {
	background-color: #39a9db;
}
.fixed-plugin .badge-green {
	background-color: #28a745;
}
.fixed-plugin .badge-orange {
	background-color: #1c77c3;
}
.fixed-plugin .badge-yellow {
	background-color: #ffc759;
}
.fixed-plugin .badge-red {
	background-color: #c1292e;
}
.fixed-plugin h5 {
	font-size: 14px;
	margin: 10px;
}
.fixed-plugin .dropdown-menu li {
	display: block;
	padding: 15px 2px;
	width: 25%;
	float: left;
}
.fixed-plugin li.adjustments-line,
.fixed-plugin li.header-title,
.fixed-plugin li.button-container {
	width: 100%;
	height: 35px;
	min-height: inherit;
}
.fixed-plugin li.button-container {
	height: auto;
}
.fixed-plugin li.button-container div {
	margin-bottom: 5px;
}
.fixed-plugin #sharrreTitle {
	text-align: center;
	padding: 10px 0;
	height: 50px;
}
.fixed-plugin li.header-title {
	height: 30px;
	line-height: 25px;
	font-size: 12px;
	font-weight: 600;
	text-align: center;
	text-transform: uppercase;
}
.fixed-plugin .adjustments-line p {
	display: inline-block;
	margin-bottom: 0;
	font-size: 1em;
	color: #3c4858;
}
.fixed-plugin .adjustments-line a {
	color: transparent;
}
.fixed-plugin .adjustments-line a .badge-colors {
	position: relative;
	top: -2px;
}
.fixed-plugin .adjustments-line a a:hover,
.fixed-plugin .adjustments-line a a:focus {
	color: transparent;
}
.fixed-plugin .adjustments-line .togglebutton {
	text-align: center;
}
.fixed-plugin .adjustments-line .togglebutton .label-switch {
	position: relative;
	left: -10px;
	font-size: 0.7142em;
	color: #65adff;
}
.fixed-plugin .adjustments-line .togglebutton .label-switch.label-right {
	left: 10px;
}
.fixed-plugin .adjustments-line .togglebutton .toggle {
	margin-right: 0;
}
.fixed-plugin .adjustments-line .dropdown-menu > li.adjustments-line > a {
	padding-right: 0;
	padding-left: 0;
	border-bottom: 1px solid #ddd;
	border-radius: 0;
	margin: 0;
}
.fixed-plugin .dropdown-menu > li > a.img-holder {
	font-size: 16px;
	text-align: center;
	border-radius: 10px;
	background-color: #fff;
	border: 3px solid #fff;
	padding-left: 0;
	padding-right: 0;
	opacity: 1;
	cursor: pointer;
	display: block;
	max-height: 100px;
	overflow: hidden;
	padding: 0;
}
.fixed-plugin .dropdown-menu > li > a.img-holder img {
	margin-top: auto;
}
.fixed-plugin .dropdown-menu > li a.switch-trigger:hover,
.fixed-plugin .dropdown-menu > li > a.switch-trigger:focus {
	background-color: transparent;
}
.fixed-plugin .dropdown-menu > li:hover > a.img-holder,
.fixed-plugin .dropdown-menu > li:focus > a.img-holder {
	border-color: rgba(0, 187, 255, 0.53);
}
.fixed-plugin .dropdown-menu > .active > a.img-holder,
.fixed-plugin .dropdown-menu > .active > a.img-holder {
	border-color: #00bbff;
	background-color: #ffffff;
}
.fixed-plugin .btn-social {
	width: 50%;
	display: block;
	width: 48%;
	float: left;
	font-weight: 600;
}
.fixed-plugin .btn-social i {
	margin-right: 5px;
}
.fixed-plugin .btn-social:first-child {
	margin-right: 2%;
}
.fixed-plugin .dropdown .dropdown-menu {
	transform-origin: 0 0;
}
.fixed-plugin .dropdown .dropdown-menu:before {
	border-bottom: 16px solid rgba(0, 0, 0, 0);
	border-left: 16px solid rgba(0, 0, 0, 0.2);
	border-top: 16px solid rgba(0, 0, 0, 0);
	right: -27px;
	bottom: 425px;
}
.fixed-plugin .dropdown .dropdown-menu:after {
	border-bottom: 16px solid rgba(0, 0, 0, 0);
	border-left: 16px solid #ffffff;
	border-top: 16px solid rgba(0, 0, 0, 0);
	right: -26px;
	bottom: 425px;
}
.fixed-plugin .dropdown .dropdown-menu:before,
.fixed-plugin .dropdown .dropdown-menu:after {
	content: "";
	display: inline-block;
	position: absolute;
	width: 16px;
	transform: translateY(-50px);
	-webkit-transform: translateY(-50px);
	-moz-transform: translateY(-50px);
}
.fixed-plugin .dropdown.show-dropdown .show .dropdown-menu .show {
	transform: translate3d(0, -60px, 0) !important;
	bottom: auto !important;
	top: 0 !important;
}
.fixed-plugin .bootstrap-switch {
	margin: 0;
}

.fixed-plugin .show-dropdown .dropdown-menu[x-placement="bottom-start"] {
	transform: translate3d(0, -100px, 0) !important;
}
.fixed-plugin .show-dropdown .dropdown-menu[x-placement="bottom-start"]:before,
.fixed-plugin .show-dropdown .dropdown-menu[x-placement="bottom-start"]:after {
	top: 100px;
}
.fixed-plugin .show-dropdown .dropdown-menu[x-placement="top-start"] {
	transform: translate3d(0, 100px, 0) !important;
}
.fixed-plugin
	.show-dropdown.show
	.dropdown-menu.show[x-placement="bottom-start"] {
	transform: translate3d(0, -60px, 0) !important;
}
.fixed-plugin .show-dropdown.show .dropdown-menu.show[x-placement="top-start"] {
	transform: translate3d(0, 470px, 0) !important;
}

.from-check,
.form-check-radio {
	margin-bottom: 12px;
	position: relative;
}

.form-check {
	padding-left: 0;
	margin-bottom: 0.5rem;
}
.form-check .form-check-label {
	display: inline-block;
	position: relative;
	cursor: pointer;
	padding-left: 35px;
	line-height: 26px;
	margin-bottom: 0;
}
.form-check .form-check-sign::before,
.form-check .form-check-sign::after {
	content: " ";
	display: inline-block;
	position: absolute;
	width: 24px;
	height: 24px;
	left: 0;
	cursor: pointer;
	border-radius: 6px;
	top: 0;
	background-color: #aaa7a4;
	transition: opacity 0.3s linear;
}
.form-check .form-check-sign::after {
	font-family: "FontAwesome";
	content: "\\f00c";
	top: -1px;
	text-align: center;
	font-size: 15px;
	opacity: 0;
	color: #fff;
	border: 0;
	background-color: inherit;
}
.form-check.disabled .form-check-label {
	color: #292929 !important;
	opacity: 0.5;
	cursor: not-allowed;
}

.form-check input[type="checkbox"]:checked + .form-check-sign::after {
	opacity: 1;
}

.form-control input[type="checkbox"]:disabled + .form-check-sign::before,
.checkbox input[type="checkbox"]:disabled + .form-check-sign::after {
	cursor: not-allowed;
}

.form-check
	.form-check-label
	input[type="checkbox"]:disabled
	+ .form-check-sign,
.form-check-radio input[type="radio"]:disabled + .form-check-sign {
	pointer-events: none !important;
}

.form-check-radio {
	margin-left: -3px;
}
.form-check-radio .form-check-label {
	padding-left: 2rem;
}
.form-check-radio.disabled .form-check-label {
	color: #292929 !important;
	opacity: 0.5;
	cursor: not-allowed;
}

.form-check-radio .form-check-sign::before {
	font-family: "FontAwesome";
	content: "\\f10c";
	font-size: 22px;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	display: inline-block;
	position: absolute;
	opacity: 0.5;
	left: 5px;
	top: -5px;
}

.form-check-label input[type="checkbox"]:checked + .form-check-sign:before {
	background-color: #66615b;
}

.form-check-radio input[type="radio"] + .form-check-sign:after,
.form-check-radio input[type="radio"] {
	opacity: 0;
	transition: opacity 0.3s linear;
	content: " ";
	display: block;
}

.form-check-radio input[type="radio"]:checked + .form-check-sign::after {
	font-family: "FontAwesome";
	content: "\\f192";
	top: -5px;
	position: absolute;
	left: 5px;
	opacity: 1;
	font-size: 22px;
}

.form-check-radio input[type="radio"]:checked + .form-check-sign::after {
	opacity: 1;
}

.form-check-radio input[type="radio"]:disabled + .form-check-sign::before,
.form-check-radio input[type="radio"]:disabled + .form-check-sign::after {
	color: #292929 !important;
}

.progress {
	background-color: #dddddd;
	border-radius: 3px;
	box-shadow: none;
	height: 14px;
}

.progress-thin {
	height: 4px;
}

.progress-bar {
	background-color: #1c77c3;
}

.progress-bar-primary {
	background-color: #1c77c3;
}

.progress-bar-info {
	background-color: #39a9db;
}

.progress-bar-success {
	background-color: #28a745;
}

.progress-bar-warning {
	background-color: #ffc759;
}

.progress-bar-danger {
	background-color: #c1292e;
}

/*           badges             */
.badge {
	padding: 4px 8px;
	text-transform: uppercase;
	font-size: 0.7142em;
	line-height: 12px;
	background-color: transparent;
	border: 1px solid;
	text-decoration: none;
	color: #ffffff;
	margin-bottom: 5px;
}
.badge:hover,
.badge:focus {
	text-decoration: none;
}

.badge-icon {
	padding: 0.4em 0.55em;
}
.badge-icon i {
	font-size: 0.8em;
}

.badge-default {
	border-color: #65adff;
	background-color: #65adff;
}

.badge-primary {
	border-color: #1c77c3;
	background-color: #1c77c3;
}

.badge-info {
	border-color: #39a9db;
	background-color: #39a9db;
}

.badge-success {
	border-color: #28a745;
	background-color: #28a745;
}

.badge-warning {
	border-color: #ffc759;
	background-color: #ffc759;
}

.badge-danger {
	border-color: #c1292e;
	background-color: #c1292e;
}

.badge-neutral {
	border-color: #ffffff;
	background-color: #ffffff;
	color: inherit;
}

.badge-primary[href]:focus,
.badge-primary[href]:hover {
	color: #ffffff;
	background-color: #1a6fb6;
	border-color: #1a6fb6;
}

.badge-warning[href]:focus,
.badge-warning[href]:hover {
	color: #ffffff;
	background-color: #ffc24a;
	border-color: #ffc24a;
}

.badge-info[href]:focus,
.badge-info[href]:hover {
	color: #ffffff;
	background-color: #2ca3d9;
	border-color: #2ca3d9;
}

.badge-danger[href]:focus,
.badge-danger[href]:hover {
	color: #ffffff;
	background-color: #b4262b;
	border-color: #b4262b;
}

.badge-success[href]:focus,
.badge-success[href]:hover {
	color: #ffffff;
	background-color: #11683f;
	border-color: #11683f;
}

.badge-default[href]:focus,
.badge-default[href]:hover {
	color: #ffffff;
	background-color: #9ed9d1;
	border-color: #9ed9d1;
}

.pagination .page-item .page-link {
	border: 0;
	border-radius: 30px !important;
	transition: all 0.3s;
	padding: 0px 11px;
	margin: 0 3px;
	min-width: 30px;
	text-align: center;
	height: 30px;
	line-height: 30px;
	color: #2c2c2c;
	cursor: pointer;
	font-size: 14px;
	text-transform: uppercase;
	background: transparent;
	outline: none;
}
.pagination .page-item .page-link:hover,
.pagination .page-item .page-link:focus {
	color: #2c2c2c;
	background-color: rgba(222, 222, 222, 0.3);
	border: none;
}
.pagination .page-item .page-link:focus,
.pagination .page-item .page-link:active:focus {
	box-shadow: none;
}
.pagination .arrow-margin-left,
.pagination .arrow-margin-right {
	position: absolute;
}
.pagination .arrow-margin-right {
	right: 0;
}
.pagination .arrow-margin-left {
	left: 0;
}
.pagination .page-item.active > .page-link {
	color: #ffffff;
	box-shadow: 0 2px 2px rgba(204, 197, 185, 0.5);
}
.pagination .page-item.active > .page-link,
.pagination .page-item.active > .page-link:focus,
.pagination .page-item.active > .page-link:hover {
	background-color: #1c77c3;
	border-color: #1c77c3;
	color: #ffffff;
}
.pagination .page-item.disabled > .page-link {
	opacity: 0.5;
}
.pagination.pagination-info .page-item.active > .page-link,
.pagination.pagination-info .page-item.active > .page-link:focus,
.pagination.pagination-info .page-item.active > .page-link:hover {
	background-color: #39a9db;
	border-color: #39a9db;
}
.pagination.pagination-success .page-item.active > .page-link,
.pagination.pagination-success .page-item.active > .page-link:focus,
.pagination.pagination-success .page-item.active > .page-link:hover {
	background-color: #28a745;
	border-color: #28a745;
}
.pagination.pagination-primary .page-item.active > .page-link,
.pagination.pagination-primary .page-item.active > .page-link:focus,
.pagination.pagination-primary .page-item.active > .page-link:hover {
	background-color: #1c77c3;
	border-color: #1c77c3;
}
.pagination.pagination-warning .page-item.active > .page-link,
.pagination.pagination-warning .page-item.active > .page-link:focus,
.pagination.pagination-warning .page-item.active > .page-link:hover {
	background-color: #ffc759;
	border-color: #ffc759;
}
.pagination.pagination-danger .page-item.active > .page-link,
.pagination.pagination-danger .page-item.active > .page-link:focus,
.pagination.pagination-danger .page-item.active > .page-link:hover {
	background-color: #c1292e;
	border-color: #c1292e;
}
.pagination.pagination-neutral .page-item > .page-link {
	color: #ffffff;
}
.pagination.pagination-neutral .page-item > .page-link:focus,
.pagination.pagination-neutral .page-item > .page-link:hover {
	background-color: rgba(255, 255, 255, 0.2);
	color: #ffffff;
}
.pagination.pagination-neutral .page-item.active > .page-link,
.pagination.pagination-neutral .page-item.active > .page-link:focus,
.pagination.pagination-neutral .page-item.active > .page-link:hover {
	background-color: #ffffff;
	border-color: #ffffff;
	color: #1c77c3;
}

.info.info-hover .info-title {
	transition: color 0.4s;
}
.info.info-hover:hover .icon {
	transform: translate3d(0, -0.5rem, 0) !important;
}
.info.info-hover:hover .icon.icon-primary.icon-circle {
	box-shadow: 0px 15px 30px 0px rgba(249, 99, 50, 0.3);
}
.info.info-hover:hover .icon.icon-info.icon-circle {
	box-shadow: 0px 15px 35px 0px rgba(44, 168, 255, 0.3);
}
.info.info-hover:hover .icon.icon-success.icon-circle {
	box-shadow: 0px 15px 35px 0px rgba(24, 206, 15, 0.3);
}
.info.info-hover:hover .icon.icon-warning.icon-circle {
	box-shadow: 0px 15px 35px 0px rgba(255, 178, 54, 0.3);
}
.info.info-hover:hover .icon.icon-danger.icon-circle {
	box-shadow: 0px 15px 35px 0px rgba(255, 54, 54, 0.3);
}
.info.info-hover:hover .icon.icon-info + .info-title {
	color: #39a9db;
}
.info.info-hover:hover .icon.icon-warning + .info-title {
	color: #ffc759;
}
.info.info-hover:hover .icon.icon-danger + .info-title {
	color: #c1292e;
}
.info.info-hover:hover .icon.icon-primary + .info-title {
	color: #1c77c3;
}
.info.info-hover:hover .icon.icon-success + .info-title {
	color: #28a745;
}
.info .icon {
	color: #65adff;
	transition: transform 0.4s, box-shadow 0.4s;
}
.info .icon > i {
	font-size: 2.3em;
}
.info .icon.icon-circle {
	max-width: 70px;
	width: 70px;
	height: 70px;
	margin: 0 auto;
	border-radius: 50%;
	box-shadow: 0px 9px 35px -6px rgba(0, 0, 0, 0.3);
	font-size: 0.7142em;
	background-color: #ffffff;
	position: relative;
}
.info .icon.icon-circle i {
	line-height: 2.6em;
}
.info .info-title {
	margin: 15px 0 5px;
	padding: 0 15px;
	color: #2c2c2c;
	font-weight: 600;
}
.info p {
	color: #65adff;
	padding: 0 15px;
	font-size: 1.1em;
}

.info-horizontal {
	text-align: left !important;
}
.info-horizontal .icon {
	float: left;
	margin-top: 23px;
	margin-right: 10px;
}
.info-horizontal .icon > i {
	font-size: 2em;
}
.info-horizontal .icon.icon-circle {
	width: 65px;
	height: 65px;
	max-width: 65px;
	margin-top: 8px;
}
.info-horizontal .icon.icon-circle i {
	display: table;
	margin: 0 auto;
	line-height: 3.5;
	font-size: 1.9em;
}
.info-horizontal .description {
	overflow: hidden;
}

.icon.icon-primary {
	color: #1c77c3;
}
.icon.icon-primary.icon-circle {
	box-shadow: 0px 9px 30px -6px rgba(28, 119, 195, 0.5);
}
.icon.icon-info {
	color: #39a9db;
}
.icon.icon-info.icon-circle {
	box-shadow: 0px 9px 30px -6px rgba(57, 169, 219, 0.5);
}
.icon.icon-success {
	color: #28a745;
}
.icon.icon-success.icon-circle {
	box-shadow: 0px 9px 30px -6px rgba(19, 117, 71, 0.5);
}
.icon.icon-warning {
	color: #ffc759;
}
.icon.icon-warning.icon-circle {
	box-shadow: 0px 9px 30px -6px rgba(255, 199, 89, 0.5);
}
.icon.icon-danger {
	color: #c1292e;
}
.icon.icon-danger.icon-circle {
	box-shadow: 0px 9px 30px -6px rgba(193, 41, 46, 0.5);
}
.icon.icon-white {
	color: #ffffff;
}

/*             Navigation Pills               */
.nav-pills .nav-item + .nav-link {
	margin-left: 0;
}
.nav-pills .nav-item .nav-link {
	border: none;
	border-radius: 0;
	font-size: 0.8em;
	color: #ffffff;
	padding: 5px 10px;
}
.nav-pills .nav-item.active .nav-link,
.nav-pills .nav-item.active .nav-link:hover,
.nav-pills .nav-item.active .nav-link:focus {
	background-color: #65adff;
	color: #ffffff;
	font-weight: 600;
}
.nav-pills .nav-item .nav-link.active {
	background-color: #65adff;
	color: #ffffff;
	font-weight: 600;
}

.nav-pills-primary {
	padding-bottom: 0;
	margin-bottom: 0.4rem;
}
.nav-pills-primary .nav-item .nav-link {
	border: none;
	color: gray;
}
.nav-pills-primary .nav-item .nav-link.active {
	border: none;
	background: #004e89;
	color: #ffffff;
}

.nav-pills-primary-dark {
	padding-top: 1rem;
	padding-bottom: 1rem;
	border-bottom: 1px solid lightgray;
}
.nav-pills-primary-dark .nav-item .nav-link {
	border: none;
	color: gray;
}
.nav-pills-primary-dark .nav-item .nav-link.active {
	border: none;
	background: #004e89;
	color: #ffffff;
}

.nav-pills-secondary {
	padding-top: 1rem;
	padding-bottom: 1rem;
	border-bottom: 1px solid lightgray;
}
.nav-pills-secondary .nav-item .nav-link {
	border: none;
	color: gray;
}
.nav-pills-secondary .nav-item .nav-link.active {
	border: none;
	background: #1f84d6;
	color: #ffffff;
}

.nav-pills-danger .nav-item .nav-link {
	border: 1px solid #c1292e;
	color: #c1292e;
}
.nav-pills-danger .nav-item .nav-link.active {
	border: 1px solid #c1292e;
	background: #c1292e;
	color: #ffffff;
}

.nav-pills-info .nav-item .nav-link {
	border: 1px solid #39a9db;
	color: #39a9db;
}
.nav-pills-info .nav-item .nav-link.active {
	border: 1px solid #39a9db;
	background: #39a9db;
	color: #ffffff;
}

.nav-pills-success .nav-item .nav-link {
	border: 1px solid #28a745;
	color: #28a745;
}
.nav-pills-success .nav-item .nav-link.active {
	border: 1px solid #28a745;
	background: #28a745;
	color: #ffffff;
}

.nav-pills-warning .nav-item .nav-link {
	border: 1px solid #ffc759;
	color: #ffc759;
}
.nav-pills-warning .nav-item .nav-link.active {
	border: 1px solid #ffc759;
	background: #ffc759;
	color: #ffffff;
}

.page-item:first-child .page-link,
.page-item:last-child .page-link {
	border-bottom-left-radius: 20px;
	border-top-left-radius: 20px;
	border-bottom-right-radius: 20px;
	border-top-right-radius: 20px;
}

.nav-pills-default .nav-item.show .nav-link,
.nav-pills-default .nav-link.active {
	background-color: #65adff !important;
}

.nav-pills-primary .nav-item.show .nav-link,
.nav-pills-primary .nav-link.active {
	background-color: #1c77c3 !important;
}

.nav-pills-primary-dark .nav-item.show .nav-link,
.nav-pills-primary-dark .nav-link.active {
	background-color: #004e89 !important;
}

.nav-pills-secondary .nav-item.show .nav-link,
.nav-pills-secondary .nav-link.active {
	background-color: #1f84d6 !important;
}

.nav-pills-info .nav-item.show .nav-link,
.nav-pills-info .nav-link.active {
	background-color: #39a9db !important;
}

.nav-pills-warning .nav-item.show .nav-link,
.nav-pills-warning .nav-link.active {
	background-color: #ffc759 !important;
}

.nav-pills-success .nav-item.show .nav-link,
.nav-pills-success .nav-link.active {
	background-color: #28a745 !important;
}

.nav-pills-danger .nav-item.show .nav-link,
.nav-pills-danger .nav-link.active {
	background-color: #c1292e !important;
}

/*             Navigation Tabs                 */
.nav-tabs-navigation {
	text-align: center;
	border-bottom: 1px solid #f1eae0;
	margin-bottom: 30px;
}
.nav-tabs-navigation .nav > .nav-item > .nav-link {
	padding-bottom: 20px;
}

.nav-tabs-wrapper {
	display: inline-block;
	margin-bottom: -6px;
	margin-left: 1.25%;
	margin-right: 1.25%;
	position: relative;
	width: auto;
}

.nav-tabs {
	border-bottom: 0 none;
	font-size: 14px;
	font-weight: 400;
}
.nav-tabs .nav-item .nav-link {
	border: 0 none;
	color: #a49e93;
	background-color: transparent;
}
.nav-tabs .nav-item .nav-link:hover {
	color: #292929 !important;
}
.nav-tabs .nav-item .nav-link.active {
	color: #292929 !important;
}
.nav-tabs .nav-item {
	color: #292929 !important;
	position: relative;
}
.nav-tabs .nav-item .nav-link.active,
.nav-tabs .nav-item .nav-link.active:hover,
.nav-tabs .nav-item .nav-link.active:focus {
	background-color: transparent;
	border: 0 none;
}
.nav-tabs .nav-item .nav-link.active:after,
.nav-tabs .nav-item .nav-link.active:hover:after,
.nav-tabs .nav-item .nav-link.active:focus:after {
	border-bottom: 11px solid #ffffff;
	border-left: 11px solid rgba(0, 0, 0, 0);
	border-right: 11px solid rgba(0, 0, 0, 0);
	content: "";
	display: inline-block;
	position: absolute;
	right: 40%;
	bottom: 5px;
}
.nav-tabs .nav-item .nav-link.active:before,
.nav-tabs .nav-item .nav-link.active:hover:before,
.nav-tabs .nav-item .nav-link.active:focus:before {
	border-bottom: 11px solid #f1eae0;
	border-left: 11px solid rgba(0, 0, 0, 0);
	border-right: 11px solid rgba(0, 0, 0, 0);
	content: "";
	display: inline-block;
	position: absolute;
	right: 40%;
	bottom: 6px;
}
.nav-tabs .nav-item.show .nav-link {
	background-color: transparent;
}
.nav-tabs .dropdown-menu {
	margin-top: -6px;
	margin-left: -46px;
	border-radius: 8px;
}
.nav-tabs .dropdown-menu .dropdown-item:hover,
.nav-tabs .dropdown-menu .dropdown-item.active {
	color: #ffffff;
	background-color: #68b3c8;
}
.nav-tabs .dropdown-menu :before {
	border-bottom: 11px solid #f1eae0;
	border-left: 11px solid rgba(0, 0, 0, 0);
	border-right: 11px solid rgba(0, 0, 0, 0);
	content: "";
	display: inline-block;
	position: absolute;
	right: 12px;
	top: -11px;
}
.nav-tabs .dropdown-menu :after {
	border-bottom: 11px solid #fffcf5;
	border-left: 11px solid rgba(0, 0, 0, 0);
	border-right: 11px solid rgba(0, 0, 0, 0);
	content: "";
	display: inline-block;
	position: absolute;
	right: 12px;
	top: -10px;
}

.profile-content .tab-content .tab-pane {
	min-height: 200px;
}
.profile-content .tab-content #tweets,
.profile-content .tab-content #connections,
.profile-content .tab-content #media {
	height: 100%;
}

.nav-text,
.nav-icons {
	margin: 0 0 10px 0;
}
.nav-text > li > a,
.nav-icons > li > a {
	display: block;
	padding: 0px 0.7rem;
	color: #292929 !important;
	text-align: center;
	opacity: 0.8;
	filter: alpha(opacity=80);
}
.nav-text > li > a:hover,
.nav-text > li > a:focus,
.nav-icons > li > a:hover,
.nav-icons > li > a:focus {
	background-color: transparent;
	opacity: 1;
	filter: alpha(opacity=100);
}
.nav-text > li:first-child a,
.nav-icons > li:first-child a {
	padding-left: 0;
}
.nav-text > li.active a,
.nav-icons > li.active a {
	color: #39a9db;
}

.nav-icons > li {
	display: inline-block;
}
.nav-icons > li > a {
	padding: 0 10px;
	margin-bottom: 10px;
}
.nav-icons > li > a i {
	font-size: 1.714em;
	margin-bottom: 10px;
	width: 1.714em;
}

.nav-icons.nav-stacked > li {
	display: block;
}
.nav-icons.nav-stacked > li > a {
	margin-bottom: 20px;
}

.nav-blue > li.active a {
	color: #1c77c3;
}

.nav-azure > li.active a {
	color: #39a9db;
}

.nav-green > li.active a {
	color: #28a745;
}

.nav-orange > li.active a {
	color: #ffc759;
}

.nav-red > li.active a {
	color: #c1292e;
}

.nav-text {
	margin: 0 0 10px 0;
}
.nav-text > li > a {
	font-size: 1em;
	text-transform: uppercase;
	padding: 3px 0;
	text-align: left;
	font-weight: 600;
}
.nav-text > li:first-child > a {
	padding-top: 0;
}
.nav-text h4 {
	margin-top: 0;
}

.nav-text:not(.nav-stacked) > li {
	display: inline-block;
}
.nav-text:not(.nav-stacked) > li > a {
	margin-right: 15px;
}

.verical-navs .nav-stacked .nav-link.active:before,
.verical-navs .nav-stacked .nav-link.active:hover:before,
.verical-navs .nav-stacked .nav-link.active.show:before {
	border-right: 11px solid #f1eae0;
	border-top: 11px solid transparent;
	border-bottom: 11px solid transparent;
	content: "";
	display: inline-block;
	position: absolute;
	right: 0;
	bottom: 20px;
}

.verical-navs .nav-stacked .nav-link.active:after,
.verical-navs .nav-stacked .nav-link.active:hover:after,
.verical-navs .nav-stacked .nav-link.active.show:after {
	border-right: 11px solid #ffffff;
	border-top: 11px solid transparent;
	border-bottom: 11px solid transparent;
	content: "";
	display: inline-block;
	position: absolute;
	right: -1px;
	bottom: 20px;
}

#second-tabs {
	margin-left: 20px;
}

.nav-tabs-navigation.verical-navs {
	border-right: 1px solid #f1eae0;
	font-size: 16px;
	padding: 0 37px;
	border-bottom: none;
}

.popover {
	font-size: 14px;
	box-shadow: 0px 10px 50px 0px rgba(0, 0, 0, 0.2);
	border: none;
	line-height: 1.7;
	max-width: 240px;
}
.popover.bs-popover-top .arrow:before,
.popover.bs-popover-left .arrow:before,
.popover.bs-popover-right .arrow:before,
.popover.bs-popover-bottom .arrow:before {
	border-top-color: transparent;
	border-left-color: transparent;
	border-right-color: transparent;
	border-bottom-color: transparent;
}
.popover .popover-header {
	color: rgba(182, 182, 182, 0.6);
	font-size: 14px;
	text-transform: capitalize;
	font-weight: 600;
	margin: 0;
	margin-top: 5px;
	border: none;
	background-color: transparent;
}
.popover:before {
	display: none;
}
.popover.bs-tether-element-attached-top:after {
	border-bottom-color: #ffffff;
	top: -9px;
}
.popover.popover-primary {
	background-color: #1c77c3;
}
.popover.popover-primary .popover-body {
	color: #ffffff;
}
.popover.popover-primary.bs-popover-right .arrow:after {
	border-right-color: #1c77c3;
}
.popover.popover-primary.bs-popover-top .arrow:after {
	border-top-color: #1c77c3;
}
.popover.popover-primary.bs-popover-bottom .arrow:after {
	border-bottom-color: #1c77c3;
}
.popover.popover-primary.bs-popover-left .arrow:after {
	border-left-color: #1c77c3;
}
.popover.popover-primary .popover-header {
	color: #ffffff;
	opacity: 0.6;
}
.popover.popover-info {
	background-color: #39a9db;
}
.popover.popover-info .popover-body {
	color: #ffffff;
}
.popover.popover-info.bs-popover-right .arrow:after {
	border-right-color: #39a9db;
}
.popover.popover-info.bs-popover-top .arrow:after {
	border-top-color: #39a9db;
}
.popover.popover-info.bs-popover-bottom .arrow:after {
	border-bottom-color: #39a9db;
}
.popover.popover-info.bs-popover-left .arrow:after {
	border-left-color: #39a9db;
}
.popover.popover-info .popover-header {
	color: #ffffff;
	opacity: 0.6;
}
.popover.popover-warning {
	background-color: #ffc759;
}
.popover.popover-warning .popover-body {
	color: #ffffff;
}
.popover.popover-warning.bs-popover-right .arrow:after {
	border-right-color: #ffc759;
}
.popover.popover-warning.bs-popover-top .arrow:after {
	border-top-color: #ffc759;
}
.popover.popover-warning.bs-popover-bottom .arrow:after {
	border-bottom-color: #ffc759;
}
.popover.popover-warning.bs-popover-left .arrow:after {
	border-left-color: #ffc759;
}
.popover.popover-warning .popover-header {
	color: #ffffff;
	opacity: 0.6;
}
.popover.popover-danger {
	background-color: #c1292e;
}
.popover.popover-danger .popover-body {
	color: #ffffff;
}
.popover.popover-danger.bs-popover-right .arrow:after {
	border-right-color: #c1292e;
}
.popover.popover-danger.bs-popover-top .arrow:after {
	border-top-color: #c1292e;
}
.popover.popover-danger.bs-popover-bottom .arrow:after {
	border-bottom-color: #c1292e;
}
.popover.popover-danger.bs-popover-left .arrow:after {
	border-left-color: #c1292e;
}
.popover.popover-danger .popover-header {
	color: #ffffff;
	opacity: 0.6;
}
.popover.popover-success {
	background-color: #28a745;
}
.popover.popover-success .popover-body {
	color: #ffffff;
}
.popover.popover-success.bs-popover-right .arrow:after {
	border-right-color: #28a745;
}
.popover.popover-success.bs-popover-top .arrow:after {
	border-top-color: #28a745;
}
.popover.popover-success.bs-popover-bottom .arrow:after {
	border-bottom-color: #28a745;
}
.popover.popover-success.bs-popover-left .arrow:after {
	border-left-color: #28a745;
}
.popover.popover-success .popover-header {
	color: #ffffff;
	opacity: 0.6;
}

.tooltip.bs-tooltip-right .arrow:before {
	border-right-color: #ffffff;
}
.tooltip.bs-tooltip-top .arrow:before {
	border-top-color: #ffffff;
}
.tooltip.bs-tooltip-bottom .arrow:before {
	border-bottom-color: #ffffff;
}
.tooltip.bs-tooltip-left .arrow:before {
	border-left-color: #ffffff;
}

.tooltip-inner {
	padding: 0.5rem 0.7rem;
	min-width: 130px;
	background-color: #ffffff;
	font-size: 14px;
	color: inherit;
	box-shadow: 0px 5px 25px 0px rgba(0, 0, 0, 0.2);
}

.modal-header {
	border-bottom: 1px solid #dddddd;
	padding: 10px;
	text-align: center;
	display: block !important;
}
.modal-header.no-border-header {
	border-bottom: 0 none !important;
}
.modal-header.no-border-header .modal-title {
	margin-top: 20px;
}
.modal-header button.close:focus {
	outline: none;
}
.modal-header .modal-profile {
	width: 70px;
	height: 70px;
	border-radius: 50%;
	text-align: center;
	line-height: 6.4;
	border: 1px solid rgba(0, 0, 0, 0.3);
}
.modal-header .modal-profile i {
	font-size: 30px;
}

.modal-dialog.modal-sm .modal-header button.close,
.modal-dialog.modal-register .modal-header button.close {
	margin-top: 0;
}

.modal-content {
	border: 0 none;
	border-radius: 10px;
	box-shadow: 0 0 15px rgba(0, 0, 0, 0.15), 0 0 1px 1px rgba(0, 0, 0, 0.1);
}
.modal-content .modal-header h6 {
	margin-top: 10px;
}

.modal-dialog {
	padding-top: 60px;
}

.modal-footer {
	border-top: 1px solid #dddddd;
	padding: 0px;
}
.modal-footer.no-border-footer {
	border-top: 0 none;
}

.modal-footer .left-side,
.modal-footer .right-side {
	display: inline-block;
	text-align: center;
	width: 50%;
	padding: 5px;
}

.modal-footer .btn-link {
	padding: 20px;
	width: 100%;
	margin: 0;
}

.modal-footer .divider {
	background-color: #dddddd;
	display: inline-block;
	height: 63px;
	margin: 0px -3px;
	width: 1px;
}

.modal-register .modal-footer {
	text-align: center;
	margin-bottom: 25px;
	padding: 20px 0 15px;
}
.modal-register .modal-footer span {
	width: 100%;
}

.carousel-item-next,
.carousel-item-prev,
.carousel-item.active {
	display: block;
}

.carousel .carousel-inner {
	box-shadow: 0px 10px 25px 0px rgba(0, 0, 0, 0.3);
}
.carousel .nc-icon {
	font-size: 2em;
}

.wrapper {
	position: relative;
	top: 0;
	height: 100vh;
}
.wrapper.wrapper-full-page {
	min-height: 100vh;
	height: auto;
}

.sidebar,
.off-canvas-sidebar {
	position: fixed;
	top: 0;
	height: 100%;
	bottom: 0;
	width: 260px;
	left: 0;
	z-index: 999;
}
.sidebar .sidebar-wrapper,
.off-canvas-sidebar .sidebar-wrapper {
	position: relative;
	height: calc(100vh - 75px);
	overflow: auto;
	width: 260px;
	z-index: 4;
	padding-bottom: 100px;
}
.sidebar .sidebar-wrapper .dropdown .dropdown-backdrop,
.off-canvas-sidebar .sidebar-wrapper .dropdown .dropdown-backdrop {
	display: none !important;
}
.sidebar .sidebar-wrapper .navbar-form,
.off-canvas-sidebar .sidebar-wrapper .navbar-form {
	border: none;
}
.sidebar
	.sidebar-wrapper
	> .nav
	[data-toggle="collapse"]
	~ div
	> ul
	> li
	> a
	span,
.sidebar
	.sidebar-wrapper
	.user
	.info
	[data-toggle="collapse"]
	~ div
	> ul
	> li
	> a
	span,
.off-canvas-sidebar
	.sidebar-wrapper
	> .nav
	[data-toggle="collapse"]
	~ div
	> ul
	> li
	> a
	span,
.off-canvas-sidebar
	.sidebar-wrapper
	.user
	.info
	[data-toggle="collapse"]
	~ div
	> ul
	> li
	> a
	span {
	display: inline-block;
}
.sidebar
	.sidebar-wrapper
	> .nav
	[data-toggle="collapse"]
	~ div
	> ul
	> li
	> a
	.sidebar-normal,
.sidebar
	.sidebar-wrapper
	.user
	.info
	[data-toggle="collapse"]
	~ div
	> ul
	> li
	> a
	.sidebar-normal,
.off-canvas-sidebar
	.sidebar-wrapper
	> .nav
	[data-toggle="collapse"]
	~ div
	> ul
	> li
	> a
	.sidebar-normal,
.off-canvas-sidebar
	.sidebar-wrapper
	.user
	.info
	[data-toggle="collapse"]
	~ div
	> ul
	> li
	> a
	.sidebar-normal {
	margin: 0;
	position: relative;
	transform: translateX(0px);
	opacity: 1;
	white-space: nowrap;
	display: block;
	line-height: 30px;
	z-index: 1;
}
.sidebar
	.sidebar-wrapper
	> .nav
	[data-toggle="collapse"]
	~ div
	> ul
	> li
	> a
	.sidebar-mini-icon,
.sidebar
	.sidebar-wrapper
	.user
	.info
	[data-toggle="collapse"]
	~ div
	> ul
	> li
	> a
	.sidebar-mini-icon,
.off-canvas-sidebar
	.sidebar-wrapper
	> .nav
	[data-toggle="collapse"]
	~ div
	> ul
	> li
	> a
	.sidebar-mini-icon,
.off-canvas-sidebar
	.sidebar-wrapper
	.user
	.info
	[data-toggle="collapse"]
	~ div
	> ul
	> li
	> a
	.sidebar-mini-icon {
	text-transform: uppercase;
	width: 34px;
	margin-right: 10px;
	margin-left: 0px;
	font-size: 12px;
	text-align: center;
	line-height: 30px;
	position: relative;
	float: left;
	z-index: 1;
	display: inherit;
}
.sidebar
	.sidebar-wrapper
	> .nav
	[data-toggle="collapse"]
	~ div
	> ul
	> li
	> a
	.sidebar-normal,
.sidebar
	.sidebar-wrapper
	.user
	.info
	[data-toggle="collapse"]
	~ div
	> ul
	> li
	> a
	.sidebar-normal,
.off-canvas-sidebar
	.sidebar-wrapper
	> .nav
	[data-toggle="collapse"]
	~ div
	> ul
	> li
	> a
	.sidebar-normal,
.off-canvas-sidebar
	.sidebar-wrapper
	.user
	.info
	[data-toggle="collapse"]
	~ div
	> ul
	> li
	> a
	.sidebar-normal {
	text-transform: capitalize;
}
.sidebar .sidebar-wrapper > .nav [data-toggle="collapse"] ~ div > ul > li > a i,
.sidebar
	.sidebar-wrapper
	.user
	.info
	[data-toggle="collapse"]
	~ div
	> ul
	> li
	> a
	i,
.off-canvas-sidebar
	.sidebar-wrapper
	> .nav
	[data-toggle="collapse"]
	~ div
	> ul
	> li
	> a
	i,
.off-canvas-sidebar
	.sidebar-wrapper
	.user
	.info
	[data-toggle="collapse"]
	~ div
	> ul
	> li
	> a
	i {
	font-size: 17px;
	line-height: 30px;
	width: 26px;
}
.sidebar .navbar-minimize,
.off-canvas-sidebar .navbar-minimize {
	position: absolute;
	right: 20px;
	top: 2px;
	opacity: 1;
}
.sidebar .nav,
.off-canvas-sidebar .nav {
	margin-top: 20px;
	display: block;
}
.sidebar .nav .caret,
.off-canvas-sidebar .nav .caret {
	top: 14px;
	position: absolute;
	right: 10px;
}
.sidebar .nav li > a + div .nav li > a,
.off-canvas-sidebar .nav li > a + div .nav li > a {
	margin-top: 7px;
}
.sidebar .nav li > a,
.off-canvas-sidebar .nav li > a {
	margin: 10px 15px 0;
	color: #ffffff;
	display: block;
	text-decoration: none;
	position: relative;
	text-transform: uppercase;
	cursor: pointer;
	font-size: 12px;
	padding: 10px 8px;
	line-height: 30px;
	opacity: 0.9;
}
.sidebar .nav li .nav > li > a,
.off-canvas-sidebar .nav li .nav > li > a {
	padding: 5px 8px;
}
.sidebar .nav li.active > a,
.sidebar .nav li.active > a > i,
.off-canvas-sidebar .nav li.active > a,
.off-canvas-sidebar .nav li.active > a > i {
	opacity: 1;
	color: #f7f7f7 !important;
}
.sidebar .nav li:hover:not(.active) > a,
.sidebar .nav li:focus:not(.active) > a,
.off-canvas-sidebar .nav li:hover:not(.active) > a,
.off-canvas-sidebar .nav li:focus:not(.active) > a {
	opacity: 1;
}
.sidebar .nav li.active > a[data-toggle="collapse"] >,
.off-canvas-sidebar .nav li.active > a[data-toggle="collapse"] > {
	box-shadow: 0 2px 2px rgba(204, 197, 185, 0.5);
}
.sidebar .nav li.active > a[data-toggle="collapse"],
.sidebar .nav li.active > a[data-toggle="collapse"] i,
.sidebar .nav li.active > a[data-toggle="collapse"] ~ div > ul > li.active i,
.sidebar .nav li.active > a[data-toggle="collapse"] ~ div > ul > li.active > a,
.off-canvas-sidebar .nav li.active > a[data-toggle="collapse"],
.off-canvas-sidebar .nav li.active > a[data-toggle="collapse"] i,
.off-canvas-sidebar
	.nav
	li.active
	> a[data-toggle="collapse"]
	~ div
	> ul
	> li.active
	i,
.off-canvas-sidebar
	.nav
	li.active
	> a[data-toggle="collapse"]
	~ div
	> ul
	> li.active
	> a {
	color: #f7f7f7 !important;
}
.sidebar .nav li.active > a[data-toggle="collapse"] + div .nav .active a,
.sidebar .nav li.active > a[data-toggle="collapse"] i + div .nav .active a,
.sidebar
	.nav
	li.active
	> a[data-toggle="collapse"]
	~ div
	> ul
	> li.active
	i
	+ div
	.nav
	.active
	a,
.sidebar
	.nav
	li.active
	> a[data-toggle="collapse"]
	~ div
	> ul
	> li.active
	> a
	+ div
	.nav
	.active
	a,
.off-canvas-sidebar
	.nav
	li.active
	> a[data-toggle="collapse"]
	+ div
	.nav
	.active
	a,
.off-canvas-sidebar
	.nav
	li.active
	> a[data-toggle="collapse"]
	i
	+ div
	.nav
	.active
	a,
.off-canvas-sidebar
	.nav
	li.active
	> a[data-toggle="collapse"]
	~ div
	> ul
	> li.active
	i
	+ div
	.nav
	.active
	a,
.off-canvas-sidebar
	.nav
	li.active
	> a[data-toggle="collapse"]
	~ div
	> ul
	> li.active
	> a
	+ div
	.nav
	.active
	a {
	background-color: transparent;
	box-shadow: none;
}
.sidebar .nav li.active > a[data-toggle="collapse"] + div .nav .active a:after,
.sidebar
	.nav
	li.active
	> a[data-toggle="collapse"]
	i
	+ div
	.nav
	.active
	a:after,
.sidebar
	.nav
	li.active
	> a[data-toggle="collapse"]
	~ div
	> ul
	> li.active
	i
	+ div
	.nav
	.active
	a:after,
.sidebar
	.nav
	li.active
	> a[data-toggle="collapse"]
	~ div
	> ul
	> li.active
	> a
	+ div
	.nav
	.active
	a:after,
.off-canvas-sidebar
	.nav
	li.active
	> a[data-toggle="collapse"]
	+ div
	.nav
	.active
	a:after,
.off-canvas-sidebar
	.nav
	li.active
	> a[data-toggle="collapse"]
	i
	+ div
	.nav
	.active
	a:after,
.off-canvas-sidebar
	.nav
	li.active
	> a[data-toggle="collapse"]
	~ div
	> ul
	> li.active
	i
	+ div
	.nav
	.active
	a:after,
.off-canvas-sidebar
	.nav
	li.active
	> a[data-toggle="collapse"]
	~ div
	> ul
	> li.active
	> a
	+ div
	.nav
	.active
	a:after {
	content: "";
	position: absolute;
	width: calc(100% - 5px);
	z-index: 0;
}
.sidebar .nav li.active > a[data-toggle="collapse"] ~ div > .nav,
.off-canvas-sidebar .nav li.active > a[data-toggle="collapse"] ~ div > .nav {
	margin-top: 0;
}
.sidebar .nav p,
.off-canvas-sidebar .nav p {
	margin: 0;
	line-height: 30px;
	position: relative;
	display: block;
	height: auto;
	white-space: nowrap;
	font-weight: 600;
}
.sidebar .nav i,
.off-canvas-sidebar .nav i {
	font-size: 24px;
	float: left;
	margin-right: 12px;
	line-height: 30px;
	width: 34px;
	text-align: center;
	color: rgba(255, 255, 255, 0.5);
	position: relative;
}
.sidebar .nav .collapse .nav,
.sidebar .nav .collapsing .nav,
.off-canvas-sidebar .nav .collapse .nav,
.off-canvas-sidebar .nav .collapsing .nav {
	margin-top: 0;
	background-color: #1c77c3;
	padding-top: 0.3rem;
	padding-bottom: 0.5rem;
}
.sidebar .sidebar-background,
.off-canvas-sidebar .sidebar-background {
	position: absolute;
	z-index: 1;
	height: 100%;
	width: 100%;
	display: block;
	top: 0;
	left: 0;
	background-size: cover;
	background-position: center center;
}
.sidebar .sidebar-background:after,
.off-canvas-sidebar .sidebar-background:after {
	position: absolute;
	z-index: 3;
	width: 100%;
	height: 100%;
	content: "";
	display: block;
	background: #ffffff;
	opacity: 1;
}
.sidebar .logo,
.off-canvas-sidebar .logo {
	position: relative;
	padding: 7px 0.7rem;
	z-index: 4;
	max-width: 100% !important;
}
.sidebar .logo a.logo-mini,
.off-canvas-sidebar .logo a.logo-mini {
	opacity: 0;
	float: left;
	width: 34px;
	text-align: center;
	margin-left: 10px;
	margin-right: 12px;
}
.sidebar .logo a.logo-normal,
.off-canvas-sidebar .logo a.logo-normal {
	display: block;
	opacity: 1;
	padding: 5px 10px 5px 0px;
	transform: translate3d(0px, 0, 0);
}
.sidebar .logo:after,
.off-canvas-sidebar .logo:after {
	content: "";
	position: absolute;
	bottom: 0;
	right: 15px;
	height: 1px;
	width: calc(100% - 30px);
	background-color: rgba(255, 255, 255, 0.5);
}
.sidebar .logo p,
.off-canvas-sidebar .logo p {
	float: left;
	font-size: 20px;
	margin: 10px 10px;
	color: #ffffff;
	line-height: 30px;
	font-family: "Muli", "Helvetica", Arial, sans-serif;
}
.sidebar .logo .simple-text,
.off-canvas-sidebar .logo .simple-text {
	text-transform: uppercase;
	padding: 0.5rem 0;
	display: block;
	white-space: nowrap;
	font-size: 1rem;
	color: #ffffff;
	text-decoration: none;
	font-weight: 400;
	line-height: 30px;
	overflow: hidden;
}
.sidebar[data-color="white"]:after,
.off-canvas-sidebar[data-color="white"]:after {
	background: #ffffff;
}
.sidebar[data-color="white"] .nav li a,
.sidebar[data-color="white"] .nav li a i,
.sidebar[data-color="white"] .nav li a[data-toggle="collapse"],
.sidebar[data-color="white"] .nav li a[data-toggle="collapse"] i,
.sidebar[data-color="white"]
	.nav
	li
	a[data-toggle="collapse"]
	~ div
	> ul
	> li
	.sidebar-mini-icon,
.sidebar[data-color="white"]
	.nav
	li
	a[data-toggle="collapse"]
	~ div
	> ul
	> li
	> a,
.off-canvas-sidebar[data-color="white"] .nav li a,
.off-canvas-sidebar[data-color="white"] .nav li a i,
.off-canvas-sidebar[data-color="white"] .nav li a[data-toggle="collapse"],
.off-canvas-sidebar[data-color="white"] .nav li a[data-toggle="collapse"] i,
.off-canvas-sidebar[data-color="white"]
	.nav
	li
	a[data-toggle="collapse"]
	~ div
	> ul
	> li
	.sidebar-mini-icon,
.off-canvas-sidebar[data-color="white"]
	.nav
	li
	a[data-toggle="collapse"]
	~ div
	> ul
	> li
	> a {
	color: #65adff;
	opacity: 0.7;
}
.sidebar[data-color="white"] .nav li:hover:not(.active) > a,
.sidebar[data-color="white"] .nav li:focus:not(.active) > a,
.off-canvas-sidebar[data-color="white"] .nav li:hover:not(.active) > a,
.off-canvas-sidebar[data-color="white"] .nav li:focus:not(.active) > a {
	opacity: 1;
}
.sidebar[data-color="white"] .logo .simple-text,
.off-canvas-sidebar[data-color="white"] .logo .simple-text {
	color: #65adff;
}
.sidebar[data-color="white"] .logo:after,
.off-canvas-sidebar[data-color="white"] .logo:after {
	background-color: #65adff;
	opacity: 0.4;
}
.sidebar[data-color="white"] .user .info a span,
.sidebar[data-color="white"] .user .nav .sidebar-mini-icon,
.sidebar[data-color="white"] .user .nav .sidebar-normal,
.off-canvas-sidebar[data-color="white"] .user .info a span,
.off-canvas-sidebar[data-color="white"] .user .nav .sidebar-mini-icon,
.off-canvas-sidebar[data-color="white"] .user .nav .sidebar-normal {
	color: #65adff !important;
}
.sidebar[data-color="white"] .user:after,
.off-canvas-sidebar[data-color="white"] .user:after {
	background-color: #65adff;
	opacity: 0.4;
}
.sidebar[data-color="sidebar"]:after,
.off-canvas-sidebar[data-color="sidebar"]:after {
	background: #004e89;
}
.sidebar[data-color="sidebar"] .nav li a,
.sidebar[data-color="sidebar"] .nav li a i,
.sidebar[data-color="sidebar"] .nav li a[data-toggle="collapse"],
.sidebar[data-color="sidebar"] .nav li a[data-toggle="collapse"] i,
.sidebar[data-color="sidebar"]
	.nav
	li
	a[data-toggle="collapse"]
	~ div
	> ul
	> li
	.sidebar-mini-icon,
.sidebar[data-color="sidebar"]
	.nav
	li
	a[data-toggle="collapse"]
	~ div
	> ul
	> li
	> a,
.off-canvas-sidebar[data-color="sidebar"] .nav li a,
.off-canvas-sidebar[data-color="sidebar"] .nav li a i,
.off-canvas-sidebar[data-color="sidebar"] .nav li a[data-toggle="collapse"],
.off-canvas-sidebar[data-color="sidebar"] .nav li a[data-toggle="collapse"] i,
.off-canvas-sidebar[data-color="sidebar"]
	.nav
	li
	a[data-toggle="collapse"]
	~ div
	> ul
	> li
	.sidebar-mini-icon,
.off-canvas-sidebar[data-color="sidebar"]
	.nav
	li
	a[data-toggle="collapse"]
	~ div
	> ul
	> li
	> a {
	color: #ffffff;
	opacity: 0.7;
}
.sidebar[data-color="sidebar"] .nav li:hover:not(.active) > a,
.sidebar[data-color="sidebar"] .nav li:focus:not(.active) > a,
.off-canvas-sidebar[data-color="sidebar"] .nav li:hover:not(.active) > a,
.off-canvas-sidebar[data-color="sidebar"] .nav li:focus:not(.active) > a {
	opacity: 1;
}
.sidebar[data-color="sidebar"] .logo .simple-text,
.off-canvas-sidebar[data-color="sidebar"] .logo .simple-text {
	color: #ffffff;
}
.sidebar[data-color="sidebar"] .logo:after,
.off-canvas-sidebar[data-color="sidebar"] .logo:after {
	background-color: #ffffff;
	opacity: 0.4;
}
.sidebar[data-color="sidebar"] .user .info a span,
.sidebar[data-color="sidebar"] .user .nav .sidebar-mini-icon,
.sidebar[data-color="sidebar"] .user .nav .sidebar-normal,
.off-canvas-sidebar[data-color="sidebar"] .user .info a span,
.off-canvas-sidebar[data-color="sidebar"] .user .nav .sidebar-mini-icon,
.off-canvas-sidebar[data-color="sidebar"] .user .nav .sidebar-normal {
	color: #ffffff !important;
}
.sidebar[data-color="sidebar"] .user:after,
.off-canvas-sidebar[data-color="sidebar"] .user:after {
	background-color: #ffffff;
	opacity: 0.4;
}
.sidebar[data-color="brown"]:after,
.off-canvas-sidebar[data-color="brown"]:after {
	background: #65adff;
}
.sidebar[data-active-color="primary"] .nav li.active > a,
.sidebar[data-active-color="primary"] .nav li.active > a i,
.sidebar[data-active-color="primary"]
	.nav
	li.active
	> a[data-toggle="collapse"],
.sidebar[data-active-color="primary"]
	.nav
	li.active
	> a[data-toggle="collapse"]
	i,
.sidebar[data-active-color="primary"]
	.nav
	li.active
	> a[data-toggle="collapse"]
	~ div
	> ul
	> li.active
	.sidebar-mini-icon,
.sidebar[data-active-color="primary"]
	.nav
	li.active
	> a[data-toggle="collapse"]
	~ div
	> ul
	> li.active
	> a,
.off-canvas-sidebar[data-active-color="primary"] .nav li.active > a,
.off-canvas-sidebar[data-active-color="primary"] .nav li.active > a i,
.off-canvas-sidebar[data-active-color="primary"]
	.nav
	li.active
	> a[data-toggle="collapse"],
.off-canvas-sidebar[data-active-color="primary"]
	.nav
	li.active
	> a[data-toggle="collapse"]
	i,
.off-canvas-sidebar[data-active-color="primary"]
	.nav
	li.active
	> a[data-toggle="collapse"]
	~ div
	> ul
	> li.active
	.sidebar-mini-icon,
.off-canvas-sidebar[data-active-color="primary"]
	.nav
	li.active
	> a[data-toggle="collapse"]
	~ div
	> ul
	> li.active
	> a {
	color: #1c77c3;
	opacity: 1;
}
.sidebar[data-active-color="info"] .nav li.active > a,
.sidebar[data-active-color="info"] .nav li.active > a i,
.sidebar[data-active-color="info"] .nav li.active > a[data-toggle="collapse"],
.sidebar[data-active-color="info"] .nav li.active > a[data-toggle="collapse"] i,
.sidebar[data-active-color="info"]
	.nav
	li.active
	> a[data-toggle="collapse"]
	~ div
	> ul
	> li.active
	.sidebar-mini-icon,
.sidebar[data-active-color="info"]
	.nav
	li.active
	> a[data-toggle="collapse"]
	~ div
	> ul
	> li.active
	> a,
.off-canvas-sidebar[data-active-color="info"] .nav li.active > a,
.off-canvas-sidebar[data-active-color="info"] .nav li.active > a i,
.off-canvas-sidebar[data-active-color="info"]
	.nav
	li.active
	> a[data-toggle="collapse"],
.off-canvas-sidebar[data-active-color="info"]
	.nav
	li.active
	> a[data-toggle="collapse"]
	i,
.off-canvas-sidebar[data-active-color="info"]
	.nav
	li.active
	> a[data-toggle="collapse"]
	~ div
	> ul
	> li.active
	.sidebar-mini-icon,
.off-canvas-sidebar[data-active-color="info"]
	.nav
	li.active
	> a[data-toggle="collapse"]
	~ div
	> ul
	> li.active
	> a {
	color: #39a9db;
	opacity: 1;
}
.sidebar[data-active-color="success"] .nav li.active > a,
.sidebar[data-active-color="success"] .nav li.active > a i,
.sidebar[data-active-color="success"]
	.nav
	li.active
	> a[data-toggle="collapse"],
.sidebar[data-active-color="success"]
	.nav
	li.active
	> a[data-toggle="collapse"]
	i,
.sidebar[data-active-color="success"]
	.nav
	li.active
	> a[data-toggle="collapse"]
	~ div
	> ul
	> li.active
	.sidebar-mini-icon,
.sidebar[data-active-color="success"]
	.nav
	li.active
	> a[data-toggle="collapse"]
	~ div
	> ul
	> li.active
	> a,
.off-canvas-sidebar[data-active-color="success"] .nav li.active > a,
.off-canvas-sidebar[data-active-color="success"] .nav li.active > a i,
.off-canvas-sidebar[data-active-color="success"]
	.nav
	li.active
	> a[data-toggle="collapse"],
.off-canvas-sidebar[data-active-color="success"]
	.nav
	li.active
	> a[data-toggle="collapse"]
	i,
.off-canvas-sidebar[data-active-color="success"]
	.nav
	li.active
	> a[data-toggle="collapse"]
	~ div
	> ul
	> li.active
	.sidebar-mini-icon,
.off-canvas-sidebar[data-active-color="success"]
	.nav
	li.active
	> a[data-toggle="collapse"]
	~ div
	> ul
	> li.active
	> a {
	color: #28a745;
	opacity: 1;
}
.sidebar[data-active-color="warning"] .nav li.active > a,
.sidebar[data-active-color="warning"] .nav li.active > a i,
.sidebar[data-active-color="warning"]
	.nav
	li.active
	> a[data-toggle="collapse"],
.sidebar[data-active-color="warning"]
	.nav
	li.active
	> a[data-toggle="collapse"]
	i,
.sidebar[data-active-color="warning"]
	.nav
	li.active
	> a[data-toggle="collapse"]
	~ div
	> ul
	> li.active
	.sidebar-mini-icon,
.sidebar[data-active-color="warning"]
	.nav
	li.active
	> a[data-toggle="collapse"]
	~ div
	> ul
	> li.active
	> a,
.off-canvas-sidebar[data-active-color="warning"] .nav li.active > a,
.off-canvas-sidebar[data-active-color="warning"] .nav li.active > a i,
.off-canvas-sidebar[data-active-color="warning"]
	.nav
	li.active
	> a[data-toggle="collapse"],
.off-canvas-sidebar[data-active-color="warning"]
	.nav
	li.active
	> a[data-toggle="collapse"]
	i,
.off-canvas-sidebar[data-active-color="warning"]
	.nav
	li.active
	> a[data-toggle="collapse"]
	~ div
	> ul
	> li.active
	.sidebar-mini-icon,
.off-canvas-sidebar[data-active-color="warning"]
	.nav
	li.active
	> a[data-toggle="collapse"]
	~ div
	> ul
	> li.active
	> a {
	color: #ffc759;
	opacity: 1;
}
.sidebar[data-active-color="danger"] .nav li.active > a,
.sidebar[data-active-color="danger"] .nav li.active > a i,
.sidebar[data-active-color="danger"] .nav li.active > a[data-toggle="collapse"],
.sidebar[data-active-color="danger"]
	.nav
	li.active
	> a[data-toggle="collapse"]
	i,
.sidebar[data-active-color="danger"]
	.nav
	li.active
	> a[data-toggle="collapse"]
	~ div
	> ul
	> li.active
	.sidebar-mini-icon,
.sidebar[data-active-color="danger"]
	.nav
	li.active
	> a[data-toggle="collapse"]
	~ div
	> ul
	> li.active
	> a,
.off-canvas-sidebar[data-active-color="danger"] .nav li.active > a,
.off-canvas-sidebar[data-active-color="danger"] .nav li.active > a i,
.off-canvas-sidebar[data-active-color="danger"]
	.nav
	li.active
	> a[data-toggle="collapse"],
.off-canvas-sidebar[data-active-color="danger"]
	.nav
	li.active
	> a[data-toggle="collapse"]
	i,
.off-canvas-sidebar[data-active-color="danger"]
	.nav
	li.active
	> a[data-toggle="collapse"]
	~ div
	> ul
	> li.active
	.sidebar-mini-icon,
.off-canvas-sidebar[data-active-color="danger"]
	.nav
	li.active
	> a[data-toggle="collapse"]
	~ div
	> ul
	> li.active
	> a {
	color: #28a745;
	opacity: 1;
}
.sidebar .user,
.off-canvas-sidebar .user {
	padding-bottom: 20px;
	margin: 20px auto 0;
	position: relative;
}
.sidebar .user:after,
.off-canvas-sidebar .user:after {
	content: "";
	position: absolute;
	bottom: 0;
	right: 15px;
	height: 1px;
	width: calc(100% - 30px);
	background-color: rgba(255, 255, 255, 0.3);
}
.sidebar .user .photo,
.off-canvas-sidebar .user .photo {
	width: 34px;
	height: 34px;
	overflow: hidden;
	float: left;
	z-index: 5;
	margin-right: 10px;
	border-radius: 50%;
	margin-left: 23px;
}
.sidebar .user .photo img,
.off-canvas-sidebar .user .photo img {
	width: 100%;
}
.sidebar .user a,
.off-canvas-sidebar .user a {
	color: #ffffff;
	text-decoration: none;
	padding: 0.5rem 15px;
	white-space: nowrap;
}
.sidebar .user .info > a,
.off-canvas-sidebar .user .info > a {
	display: block;
	line-height: 18px;
}
.sidebar .user .info > a > span,
.off-canvas-sidebar .user .info > a > span {
	display: block;
	position: relative;
	opacity: 1;
}
.sidebar .user .info .caret,
.off-canvas-sidebar .user .info .caret {
	position: absolute;
	top: 8px;
	right: 18px;
}

.visible-on-sidebar-regular {
	display: inline-block !important;
}

.visible-on-sidebar-mini {
	display: none !important;
}

.off-canvas-sidebar .nav > li > a,
.off-canvas-sidebar .nav > li > a:hover {
	color: #ffffff;
}
.off-canvas-sidebar .nav > li > a:focus {
	background: rgba(200, 200, 200, 0.2);
}

.main-panel {
	position: relative;
	float: right;
	width: calc(100% - 260px);
	background-color: #f7f7f7;
	transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);
}
.main-panel > .content {
	padding: 0 30px 30px;
	min-height: calc(100vh - 123px);
	margin-top: 93px;
}
.main-panel > .navbar {
	margin-bottom: 0;
}
.main-panel .header {
	margin-bottom: 50px;
}

.perfect-scrollbar-on .sidebar,
.perfect-scrollbar-on .main-panel {
	height: 100%;
	max-height: 100%;
}

@media (min-width: 991px) {
	.sidebar,
	.main-panel,
	.sidebar-wrapper {
		transition-property: top, bottom, width;
		transition-duration: 0.2s, 0.2s, 0.35s;
		transition-timing-function: linear, linear, ease;
		-webkit-overflow-scrolling: touch;
	}

	.sidebar-mini .visible-on-sidebar-regular {
		display: none !important;
	}
	.sidebar-mini .visible-on-sidebar-mini {
		display: inline-block !important;
	}
	.sidebar-mini .sidebar,
	.sidebar-mini .sidebar .sidebar-wrapper {
		width: 80px;
	}
	.sidebar-mini .main-panel {
		width: calc(100% - 80px);
	}
	.sidebar-mini .sidebar {
		display: block;
		z-index: 1030;
	}
	.sidebar-mini .sidebar .logo a.logo-normal {
		opacity: 1;
		transform: translate3d(-25px, 0, 0);
	}
	.sidebar-mini .sidebar .logo a.logo-mini {
		opacity: 0;
	}
	.sidebar-mini
		.sidebar
		.sidebar-wrapper
		> .nav
		[data-toggle="collapse"]
		~ div
		> ul
		> li
		> a
		.sidebar-normal,
	.sidebar-mini
		.sidebar
		.sidebar-wrapper
		.user
		.info
		[data-toggle="collapse"]
		~ div
		> ul
		> li
		> a
		.sidebar-normal,
	.sidebar-mini .sidebar .sidebar-wrapper .user .info > a > span,
	.sidebar-mini .sidebar .sidebar-wrapper > .nav li > a p {
		transform: translate3d(-25px, 0, 0);
		opacity: 0;
	}
	.sidebar-mini .sidebar:hover {
		width: 260px;
	}
	.sidebar:hover .logo a.logo-mini {
		opacity: 0;
		transform: translate3d(0, 0, 0);
	}
	.sidebar-mini .sidebar:hover .logo a.logo-normal {
		opacity: 1;
		transform: translate3d(0, 0, 0);
	}
	.sidebar-mini .sidebar:hover .navbar-minimize {
		opacity: 1;
	}
	.sidebar-mini .sidebar:hover .sidebar-wrapper {
		width: 260px;
	}
	.sidebar-mini .sidebar:hover .sidebar-wrapper > .nav li > a p,
	.sidebar-mini
		.sidebar:hover
		.sidebar-wrapper
		> .nav
		[data-toggle="collapse"]
		~ div
		> ul
		> li
		> a
		.sidebar-normal,
	.sidebar-mini
		.sidebar:hover
		.sidebar-wrapper
		.user
		.info
		[data-toggle="collapse"]
		~ div
		> ul
		> li
		> a
		.sidebar-normal,
	.sidebar-mini .sidebar:hover .sidebar-wrapper .user .info > a > span {
		transform: translate3d(0px, 0, 0);
		opacity: 0;
	}
}
.panel-header {
	height: 260px;
	padding-top: 80px;
	padding-bottom: 45px;
	background: #141e30;
	/* fallback for old browsers */
	background: linear-gradient(to right, #0c2646 0%, #204065 60%, #2a5788 100%);
	position: relative;
	overflow: hidden;
}
.panel-header .header .title {
	color: #ffffff;
}
.panel-header .header .category {
	max-width: 600px;
	color: rgba(255, 255, 255, 0.5);
	margin: 0 auto;
	font-size: 13px;
}
.panel-header .header .category a {
	color: #ffffff;
}

.panel-header-sm {
	height: 135px;
}

.panel-header-lg {
	height: 380px;
}

.sidebar .logo .simple-text .logo-img {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	height: 34px;
	width: 34px;
	border-radius: 50%;
	text-align: center;
	overflow: hidden;
}

.sidebar[data-color="white"] {
	border-right: 1px solid #ddd;
}

.card-timeline .timeline {
	list-style: none;
	padding: 20px 0 20px;
	position: relative;
}
.card-timeline .timeline:before {
	top: 0;
	bottom: 0;
	position: absolute;
	content: " ";
	width: 3px;
	background-color: #dbdbdb;
	left: 50%;
	margin-left: -1.5px;
}
.card-timeline .timeline .timeline-footer .btn {
	margin: 0;
}
.card-timeline .timeline h6 {
	color: #292929 !important;
	font-weight: 400;
	margin: 10px 0px 0px;
}
.card-timeline .timeline.timeline-simple:before {
	left: 5%;
}
.card-timeline .timeline.timeline-simple > li > .timeline-panel {
	width: 86%;
}
.card-timeline .timeline.timeline-simple > li > .timeline-badge {
	left: 5%;
}
.card-timeline .timeline > li {
	margin-bottom: 20px;
	position: relative;
}
.card-timeline .timeline > li:before,
.card-timeline .timeline > li:after {
	content: " ";
	display: table;
}
.card-timeline .timeline > li:after {
	clear: both;
}
.card-timeline .timeline > li > .timeline-panel {
	width: 45%;
	float: left;
	padding: 20px;
	border-radius: 3px;
	box-shadow: 0 2px 2px rgba(204, 197, 185, 0.5);
	background-color: #ffffff;
	color: #2c2c2c;
	margin-bottom: 20px;
	position: relative;
}
.card-timeline .timeline > li > .timeline-panel:before {
	position: absolute;
	top: 26px;
	right: -15px;
	display: inline-block;
	border-top: 15px solid transparent;
	border-left: 15px solid #e3e3e3;
	border-right: 0 solid #e3e3e3;
	border-bottom: 15px solid transparent;
	content: " ";
}
.card-timeline .timeline > li > .timeline-panel:after {
	position: absolute;
	top: 27px;
	right: -14px;
	display: inline-block;
	border-top: 14px solid transparent;
	border-left: 14px solid #ffffff;
	border-right: 0 solid #ffffff;
	border-bottom: 14px solid transparent;
	content: " ";
}
.card-timeline .timeline > li > .timeline-badge {
	color: #ffffff;
	width: 50px;
	height: 50px;
	text-align: center;
	position: absolute;
	top: 16px;
	left: 50%;
	margin-left: -25px;
	background-color: #292929 !important;
	z-index: 100;
	border-top-right-radius: 50%;
	border-top-left-radius: 50%;
	border-bottom-right-radius: 50%;
	border-bottom-left-radius: 50%;
	border: 3px solid #f4f3ef;
}
.card-timeline .timeline > li > .timeline-badge [class^="fa-"],
.card-timeline .timeline > li > .timeline-badge [class*=" fa-"] {
	line-height: inherit;
}
.card-timeline .timeline > li > .timeline-badge .nc-icon {
	line-height: 2.1;
	width: 25px;
	text-align: center;
	font-size: 21px;
}
.card-timeline .timeline > li.timeline-inverted > .timeline-panel {
	float: right;
	background-color: #fff;
}
.card-timeline .timeline > li.timeline-inverted > .timeline-panel:before {
	border-left-width: 0;
	border-right-width: 15px;
	left: -15px;
	right: auto;
}
.card-timeline .timeline > li.timeline-inverted > .timeline-panel:after {
	border-left-width: 0;
	border-right-width: 14px;
	left: -14px;
	right: auto;
}
.card-timeline .timeline-heading {
	margin-bottom: 15px;
}
.card-timeline .timeline-badge.primary {
	background-color: #39a9db !important;
}
.card-timeline .timeline-badge.info {
	background-color: #39a9db !important;
}
.card-timeline .timeline-badge.success {
	background-color: #28a745 !important;
}
.card-timeline .timeline-badge.warning {
	background-color: #ffc759 !important;
}
.card-timeline .timeline-badge.danger {
	background-color: #c1292e !important;
}
.card-timeline .timeline-title {
	margin-top: 0;
	color: inherit;
}
.card-timeline .timeline-body > p,
.card-timeline .timeline-body > ul {
	margin-bottom: 0;
}
.card-timeline .timeline-body > p + p {
	margin-top: 5px;
}

.card {
	border-radius: 8px;
	background: #ffffff;
	box-shadow: 0 0 6px #acacac;
	margin-bottom: 0px;
	position: relative;
	border: none;
	transition: transform 300ms cubic-bezier(0.34, 2, 0.6, 1),
		box-shadow 200ms ease;
}

@media (max-width: 1000px) {
	.card {
		margin: 0.2em 0;
	}
}

.card .card-body {
	padding: 15px 15px 15px 15px;
}

.card .card-body.table-full-width {
	padding-left: 0;
	padding-right: 0;
}
.card .card-header {
	padding-top: 0.3rem;
	padding-left: 1rem;
	padding-right: 1rem;
	border: 0;
}
.card .card-header:not([data-background-color]) {
	background-color: transparent;
}
.card .card-header .card-title {
	margin-top: 0px;
}
.card .map {
	border-radius: 3px;
}
.card .map.map-big {
	height: 400px;
}
.card[data-background-color="orange"] {
	background-color: #1c77c3;
}
.card[data-background-color="orange"] .card-header {
	background-color: #1c77c3;
}
.card[data-background-color="orange"] .card-footer .stats {
	color: #ffffff;
}
.card[data-background-color="red"] {
	background-color: #c1292e;
}
.card[data-background-color="yellow"] {
	background-color: #ffc759;
}
.card[data-background-color="blue"] {
	background-color: #39a9db;
}
.card[data-background-color="green"] {
	background-color: #28a745;
}
.card .image {
	overflow: hidden;
	height: 200px;
	position: relative;
}
.card .avatar {
	width: 30px;
	height: 30px;
	overflow: hidden;
	border-radius: 50%;
	margin-bottom: 15px;
}
.card .numbers {
	font-size: 2em;
}
.card .big-title {
	font-size: 12px;
	text-align: center;
	font-weight: 500;
	padding-bottom: 15px;
}
.card label {
	font-size: 0.8em;
	margin-bottom: 2px;
	color: #3d3d3d;
}

@media (max-width: 768px) {
	.card label {
		font-size: 14px;
	}
}

.card .card-footer {
	background-color: transparent;
	border: 0;
}
.card .card-footer .stats i {
	margin-right: 5px;
	position: relative;
	top: 0px;
	color: #65adff;
}
.card .card-footer .btn {
	margin: 0;
}
.card.card-plain {
	background-color: transparent;
	box-shadow: none;
	border-radius: 0;
}
.card.card-plain .card-body {
	padding-left: 25px !important;
	padding-right: 25px !important;
}
.card.card-plain img {
	border-radius: 12px;
}

.card-chart .card-header .card-title {
	margin-top: 10px;
	margin-bottom: 0;
}
.card-chart .card-header .card-category {
	margin-bottom: 5px;
}
.card-chart .table {
	margin-bottom: 0;
}
.card-chart .table td {
	border-top: none;
	border-bottom: 1px solid #e9ecef;
}
.card-chart .card-progress {
	margin-top: 30px;
}
.card-chart .chart-area {
	height: 190px;
	width: calc(100% + 30px);
	margin-left: -15px;
	margin-right: -15px;
}
.card-chart .card-footer {
	margin-top: 15px;
}
.card-chart .card-footer .stats {
	color: #292929 !important;
}
.card-chart .dropdown {
	position: absolute;
	right: 20px;
	top: 20px;
}
.card-chart .dropdown .btn {
	margin: 0;
}

.map {
	height: 500px;
}

.card-user .image {
	height: 130px;
}
.card-user .image img {
	border-radius: 12px;
}
.card-user .author {
	text-align: center;
	text-transform: none;
	margin-top: -77px;
}
.card-user .author a + p.description {
	margin-top: -7px;
}
.card-user .avatar {
	width: 124px;
	height: 124px;
	border: 1px solid #ffffff;
	position: relative;
}
.card-user .card-body {
	min-height: 240px;
}
.card-user hr {
	margin: 5px 15px 15px;
}
.card-user .card-body + .card-footer {
	padding-top: 0;
}
.card-user .card-footer h5 {
	font-size: 1.25em;
	margin-bottom: 0;
}
.card-user .button-container {
	margin-bottom: 6px;
	text-align: center;
}

.card-background {
	background-position: center center;
	background-size: cover;
	text-align: center;
}
.card-background .card-body {
	position: relative;
	z-index: 2;
	min-height: 370px;
	max-width: 530px;
	margin: 0 auto;
	padding-top: 60px;
	padding-bottom: 60px;
}
.card-background .card-footer {
	position: relative;
	z-index: 2;
}
.card-background.card-background-product .card-body {
	max-width: 400px;
}
.card-background.card-background-product .card-body .card-title {
	margin-top: 30px;
}
.card-background .stats {
	color: #ffffff;
}
.card-background .card-footer .stats-link > a {
	color: #ffffff;
	line-height: 1.9;
}
.card-background .category,
.card-background .card-description,
.card-background small {
	color: rgba(255, 255, 255, 0.8);
}
.card-background .card-title {
	color: #ffffff;
	margin-top: 130px;
}
.card-background:not(.card-pricing) .btn {
	margin-bottom: 0;
}
.card-background::after {
	position: absolute;
	z-index: 1;
	width: 100%;
	height: 100%;
	display: block;
	left: 0;
	top: 0;
	content: "";
	background-color: rgba(0, 0, 0, 0.63);
	border-radius: 6px;
}

.card-collapse {
	padding-bottom: 10px;
}
.card-collapse .card {
	margin-bottom: 0px;
}
.card-collapse .card .card-header {
	position: relative;
	padding: 20px 0;
}
.card-collapse .card .card-header a[data-toggle="collapse"] {
	display: block;
	color: #444;
}
.card-collapse .card .card-header a[data-toggle="collapse"] i {
	float: right;
	position: relative;
	color: #f96332;
	top: 3px;
	right: 5px;
}
.card-collapse .card .card-header:after {
	content: "";
	position: absolute;
	bottom: 0;
	left: 0;
	width: 100%;
	height: 1px;
	background-color: #e3e3e3;
}
.card-collapse .card .card-body {
	padding: 20px 15px;
}

.card-contributions .card-description {
	max-width: 350px;
	margin: 0 auto;
	margin-bottom: 20px;
}
.card-contributions .card-title {
	padding-top: 35px;
}
.card-contributions .card-stats {
	display: flex;
	align-items: center;
	flex-direction: row;
	padding: 11px;
}
.card-contributions .card-footer [class*="col-"]:not(:first-child):before {
	content: "";
	position: absolute;
	left: 0;
	width: 1px;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.1);
}
.card-contributions .bootstrap-switch {
	margin: 0;
}
.card-contributions span {
	padding-left: 15px;
	text-align: left;
	max-width: 125px;
}

.card .info-area {
	padding: 40px 0 40px;
	text-align: center;
	position: relative;
	z-index: 2;
}

.card-lock .card-header img {
	width: 120px;
	height: 120px;
	border-radius: 50%;
	margin-top: -70px;
}

.card-pricing {
	text-align: center;
}
.card-pricing .card-body {
	padding: 15px !important;
}
.card-pricing .card-category {
	margin: 10px 0 10px;
	color: #2c2c2c;
}
.card-pricing .card-icon {
	padding: 15px 0 5px;
	transform: translateY(0%);
	color: #2c2c2c;
}
.card-pricing .card-icon.icon-info {
	color: #39a9db;
}
.card-pricing .card-icon.icon-danger {
	color: #c1292e;
}
.card-pricing .card-icon.icon-primary {
	color: #1c77c3;
}
.card-pricing .card-icon.icon-success {
	color: #28a745;
}
.card-pricing .card-icon.icon-warning {
	color: #ffc759;
}
.card-pricing .card-icon i {
	font-size: 40px;
	width: 105px;
	border: 2px solid #ccc;
	border-radius: 50%;
	height: 105px;
	line-height: 105px;
}
.card-pricing .card-title {
	margin-top: 30px !important;
}
.card-pricing ul {
	list-style: none;
	padding: 0;
	max-width: 240px;
	margin: 20px auto;
}
.card-pricing ul li {
	padding: 5px 0;
	list-style-type: none;
}
.card-pricing ul li b {
	font-weight: 600;
	color: #2c2c2c;
}
.card-pricing .btn-neutral {
	color: #65adff;
}
.card-pricing .btn-neutral:hover,
.card-pricing .btn-neutral :focus {
	color: #403d39;
}
.card-pricing.card-background-image ul li {
	color: #ffffff;
	text-align: center;
	border-color: rgba(255, 255, 255, 0.3);
}
.card-pricing.card-background-image ul li b {
	color: #ffffff !important;
}
.card-pricing.card-background-image .card-description {
	color: #ffffff !important;
}
.card-pricing.card-background-image .card-title small {
	color: rgba(255, 255, 255, 0.6);
}

.card-pricing.card-plain .card-category,
.card-pricing.card-plain .card-title {
	color: #2c2c2c;
}
.card-pricing.card-plain ul li b {
	font-weight: 600;
	color: #2c2c2c;
}

.card[data-background="image"] .card-icon i,
.card[data-background="color"] .card-icon i,
.card[data-color] .card-icon i {
	color: #ffffff;
	border: 2px solid rgba(255, 255, 255, 0.3);
}

.card-profile {
	margin-top: 30px;
	text-align: center;
}
.card-profile .card-body .card-title {
	margin-top: 0;
}
.card-profile [class*="col-"] .card-description {
	margin-bottom: 0;
}
.card-profile [class*="col-"] .card-description + .card-footer {
	margin-top: 8px;
}
.card-profile .card-header-avatar {
	max-width: 130px;
	max-height: 130px;
	margin: -60px auto 0;
}
.card-profile .card-header-avatar img {
	border-radius: 50% !important;
}
.card-profile .card-header-avatar + .card-body {
	margin-top: 15px;
}
.card-plain.card-profile .card-header-avatar {
	margin-top: 0;
}
.card-profile .card-body .card-avatar {
	margin: 0 auto 30px;
}

.card-signup .header {
	margin-left: 20px;
	margin-right: 20px;
	padding: 30px 0;
}
.card-signup .text-divider {
	margin-top: 30px;
	margin-bottom: 0px;
	text-align: center;
}
.card-signup .content {
	padding: 0px 30px;
}
.card-signup .form-check {
	margin-top: 20px;
}
.card-signup .form-check label {
	margin-left: 7px;
	padding-left: 38px;
}
.card-signup .social-line {
	margin-top: 20px;
	text-align: center;
}
.card-signup .social-line .btn.btn-icon,
.card-signup .social-line .btn.btn-icon .btn-icon {
	margin-left: 5px;
	margin-right: 5px;
	box-shadow: 0px 5px 50px 0px rgba(0, 0, 0, 0.2);
}
.card-signup .card-footer {
	margin-bottom: 10px;
	margin-top: 24px;
}

.card-stats-mini.card-background::after {
	background-image: linear-gradient(to right, #434343 0%, black 100%);
	opacity: 0.94;
}
.card-stats-mini .card-body::after {
	clear: both;
	content: "";
	display: block;
}
.card-stats-mini .card-footer {
	border-top: 1px solid rgba(255, 255, 255, 0.2);
	margin: 0 15px;
}
.card-stats-mini.card-background .card-body {
	min-height: auto;
	padding-top: 15px;
	padding-bottom: 15px;
}
.card-stats-mini .card-title {
	margin-top: 0;
	margin-bottom: 5px;
}
.card-stats-mini .info-area {
	text-align: left;
	width: 40%;
	float: left;
	padding: 15px 0;
}
.card-stats-mini .info-area .icon > i {
	font-size: 2em;
}
.card-stats-mini .chart-area {
	float: left;
	width: 60%;
}
.card-stats-mini .stats {
	text-align: left;
	color: #ffffff;
}

.card-contributions hr {
	margin: 5px 15px;
}

.card-stats .card-body {
	padding: 15px 15px 0px;
}
.card-stats .card-body .numbers {
	text-align: right;
	font-size: 2em;
}
.card-stats .card-body .numbers p {
	margin-bottom: 0;
}
.card-stats .card-body .numbers .card-category {
	/*color: #292929 !important;*/
	font-size: 16px;
	line-height: 1.4em;
}
.card-stats .card-footer {
	padding: 0px 15px 5px;
}

.card-stats .icon-big {
	font-size: 2.5em;
	min-height: 64px;
}
.card-stats .icon-big i {
	line-height: 59px;
}
.card-stats-active .card-footer .btn.btn-sm.btn-link {
	background-color: inherit;
}

.card-stats-active {
	background-color: #1c77c4 !important;
	box-shadow: none !important;
	transition: ease-in-out 0.5s;
	color: white !important;
}

.card-stats-active .card-body {
	padding: 15px 15px 0px;
	border-radius: 10px 10px 0 0;
}
.card-stats-active .card-footer {
	padding: 0px 15px 5px;
	border-radius: 0 0 10px 10px;
	border: none !important;
}

.card-stats-active hr {
	color: #c2e4ff !important;
}
.card-stats-active .card-body .numbers {
	text-align: right;
	color: inherit;
}
.card-stats-active .card-body .numbers p {
	margin-bottom: 0;
}
.card-stats-active .card-body .numbers .card-category {
	color: inherit;
	font-size: 14px;
	line-height: 1.4em;
}

.card-stats-active .card-footer .stats {
	color: #d9f5ff;
}
.card-stats-active .card-footer hr {
	margin-top: 10px;
	margin-bottom: 15px;
}
.card-stats-active .icon-big {
	font-size: 2.5em;
}
.card-stats-active .icon-big i {
	line-height: 59px;
}

.card-stats-active .text-success {
	color: #fff;
}

.card-subcategories .card-body {
	padding-bottom: 30px;
}

.card-testimonial {
	margin-top: 30px;
	text-align: center;
}
.card-testimonial .icon {
	padding: 0;
}
.card-testimonial .icon i {
	font-size: 30px;
	border: 0;
	display: block;
	line-height: 100px;
	margin: 0px auto;
	margin-bottom: 0px;
}
.card-testimonial .card-body {
	padding: 15px 30px;
}
.card-testimonial .card-body .card-description {
	font-style: italic;
	font-size: 16px;
}
.card-testimonial .card-body .card-category {
	margin-bottom: 20px;
}
.card-testimonial .card-body + .card-footer {
	padding-top: 0;
	margin-top: -20px;
}
.card-testimonial .card-avatar {
	margin-top: 0;
}
.card-testimonial .card-avatar .img {
	border-radius: 50%;
	width: 100px;
	height: 100px;
}
.card-testimonial .card-footer .card-title {
	color: #2c2c2c;
	text-align: center;
}
.card-testimonial .card-footer .card-category {
	color: #292929 !important;
}
.card-testimonial .card-footer .card-avatar {
	margin-top: 20px;
}
.card-testimonial .card-footer .card-avatar .img {
	border-radius: 50%;
	width: 60px;
	height: 60px;
}

.card-testimonial .card-description + .card-title {
	margin-top: 30px;
}
.card-testimonial .card-description + .card-title .card-image .img {
	border-radius: 12px;
}
.card-testimonial .card-description + .card-title .card-image .card-title {
	text-align: center;
}

.card-tasks {
	text-align: left;
}
.card-tasks .table tbody td:last-child {
	padding-right: 0;
	display: inline-flex;
}
.card-tasks .table tbody td:last-child .btn {
	padding: 3px;
}
.card-tasks .table tbody td:first-child {
	padding-left: 0;
}
.card-tasks .table tbody td {
	padding: 12px 8px !important;
}
.card-tasks .table-full-width {
	padding-bottom: 0 !important;
}
.card-tasks .card-footer {
	padding-top: 0;
}
.card-tasks .table {
	margin-bottom: 0 !important;
}

.login-page .content .container {
	margin-top: 8vh;
}
.login-page .card-login {
	border-radius: 6px;
	padding-bottom: 0.7rem;
	box-shadow: none;
}
.login-page .card-login .btn-wd {
	min-width: 180px;
}
.login-page .card-login .logo-container {
	width: 65px;
	margin: 0 auto;
	margin-bottom: 55px;
}
.login-page .card-login .logo-container img {
	width: 100%;
}
.login-page .card-login .input-group:last-child {
	margin-bottom: 1em;
}
.login-page .card-login.card-plain .form-control::-moz-placeholder {
	color: #ebebeb;
	opacity: 1;
	filter: alpha(opacity=100);
}
.login-page .card-login.card-plain .form-control:-moz-placeholder {
	color: #ebebeb;
	opacity: 1;
	filter: alpha(opacity=100);
}
.login-page .card-login.card-plain .form-control::-webkit-input-placeholder {
	color: #ebebeb;
	opacity: 1;
	filter: alpha(opacity=100);
}
.login-page .card-login.card-plain .form-control:-ms-input-placeholder {
	color: #ebebeb;
	opacity: 1;
	filter: alpha(opacity=100);
}
.login-page .card-login.card-plain .form-control {
	border-color: rgba(255, 255, 255, 0.5);
	color: #ffffff;
}
.login-page .card-login.card-plain .form-control:focus {
	border-color: #ffffff;
	background-color: transparent;
	color: #ffffff;
}
.login-page .card-login.card-plain .has-success:after,
.login-page .card-login.card-plain .has-danger:after {
	color: #ffffff;
}
.login-page .card-login.card-plain .has-danger .form-control {
	background-color: transparent;
}
.login-page .card-login.card-plain .input-group-prepend .input-group-text,
.login-page .card-login.card-plain .input-group-append .input-group-text {
	background-color: transparent;
	border-color: rgba(255, 255, 255, 0.5);
	color: #ffffff;
}
.login-page
	.card-login.card-plain
	.input-group-focus
	.input-group-prepend
	.input-group-text,
.login-page
	.card-login.card-plain
	.input-group-focus
	.input-group-append
	.input-group-text {
	background-color: transparent;
	border-color: #ffffff;
	color: #ffffff;
}
.login-page .card-login.card-plain .form-group.no-border .form-control,
.login-page .card-login.card-plain .input-group.no-border .form-control {
	background-color: rgba(255, 255, 255, 0.1);
	color: #ffffff;
}
.login-page .card-login.card-plain .form-group.no-border .form-control:focus,
.login-page .card-login.card-plain .form-group.no-border .form-control:active,
.login-page .card-login.card-plain .form-group.no-border .form-control:active,
.login-page .card-login.card-plain .input-group.no-border .form-control:focus,
.login-page .card-login.card-plain .input-group.no-border .form-control:active,
.login-page .card-login.card-plain .input-group.no-border .form-control:active {
	background-color: rgba(255, 255, 255, 0.2);
	color: #ffffff;
}
.login-page
	.card-login.card-plain
	.form-group.no-border
	.form-control
	+ .input-group-prepend
	.input-group-text,
.login-page
	.card-login.card-plain
	.form-group.no-border
	.form-control
	+ .input-group-append
	.input-group-text,
.login-page
	.card-login.card-plain
	.input-group.no-border
	.form-control
	+ .input-group-prepend
	.input-group-text,
.login-page
	.card-login.card-plain
	.input-group.no-border
	.form-control
	+ .input-group-append
	.input-group-text {
	background-color: rgba(255, 255, 255, 0.1);
}
.login-page
	.card-login.card-plain
	.form-group.no-border
	.form-control
	+ .input-group-prepend
	.input-group-text:focus,
.login-page
	.card-login.card-plain
	.form-group.no-border
	.form-control
	+ .input-group-prepend
	.input-group-text:active,
.login-page
	.card-login.card-plain
	.form-group.no-border
	.form-control
	+ .input-group-prepend
	.input-group-text:active,
.login-page
	.card-login.card-plain
	.form-group.no-border
	.form-control
	+ .input-group-append
	.input-group-text:focus,
.login-page
	.card-login.card-plain
	.form-group.no-border
	.form-control
	+ .input-group-append
	.input-group-text:active,
.login-page
	.card-login.card-plain
	.form-group.no-border
	.form-control
	+ .input-group-append
	.input-group-text:active,
.login-page
	.card-login.card-plain
	.input-group.no-border
	.form-control
	+ .input-group-prepend
	.input-group-text:focus,
.login-page
	.card-login.card-plain
	.input-group.no-border
	.form-control
	+ .input-group-prepend
	.input-group-text:active,
.login-page
	.card-login.card-plain
	.input-group.no-border
	.form-control
	+ .input-group-prepend
	.input-group-text:active,
.login-page
	.card-login.card-plain
	.input-group.no-border
	.form-control
	+ .input-group-append
	.input-group-text:focus,
.login-page
	.card-login.card-plain
	.input-group.no-border
	.form-control
	+ .input-group-append
	.input-group-text:active,
.login-page
	.card-login.card-plain
	.input-group.no-border
	.form-control
	+ .input-group-append
	.input-group-text:active {
	background-color: rgba(255, 255, 255, 0.2);
	color: #ffffff;
}
.login-page
	.card-login.card-plain
	.form-group.no-border
	.form-control:focus
	+ .input-group-prepend
	.input-group-text,
.login-page
	.card-login.card-plain
	.form-group.no-border
	.form-control:focus
	+ .input-group-append
	.input-group-text,
.login-page
	.card-login.card-plain
	.input-group.no-border
	.form-control:focus
	+ .input-group-prepend
	.input-group-text,
.login-page
	.card-login.card-plain
	.input-group.no-border
	.form-control:focus
	+ .input-group-append
	.input-group-text {
	background-color: rgba(255, 255, 255, 0.2);
	color: #ffffff;
}
.login-page
	.card-login.card-plain
	.form-group.no-border
	.input-group-prepend
	.input-group-text,
.login-page
	.card-login.card-plain
	.form-group.no-border
	.input-group-append
	.input-group-text,
.login-page
	.card-login.card-plain
	.input-group.no-border
	.input-group-prepend
	.input-group-text,
.login-page
	.card-login.card-plain
	.input-group.no-border
	.input-group-append
	.input-group-text {
	background-color: rgba(255, 255, 255, 0.1);
	border: none;
	color: #ffffff;
}
.login-page
	.card-login.card-plain
	.form-group.no-border.input-group-focus
	.input-group-prepend
	.input-group-text,
.login-page
	.card-login.card-plain
	.form-group.no-border.input-group-focus
	.input-group-append
	.input-group-text,
.login-page
	.card-login.card-plain
	.input-group.no-border.input-group-focus
	.input-group-prepend
	.input-group-text,
.login-page
	.card-login.card-plain
	.input-group.no-border.input-group-focus
	.input-group-append
	.input-group-text {
	background-color: rgba(255, 255, 255, 0.2);
	color: #ffffff;
}
.login-page .card-login.card-plain .input-group-addon,
.login-page .card-login.card-plain .form-group.no-border .input-group-addon,
.login-page .card-login.card-plain .input-group.no-border .input-group-addon {
	color: rgba(255, 255, 255, 0.8);
}
.login-page .link {
	font-size: 10px;
	color: #ffffff;
	text-decoration: none;
}

.full-page > .content,
.full-page > .footer {
	position: relative;
	z-index: 4;
}
.full-page.section-image {
	position: static;
	position: initial;
}
.full-page > .content {
	padding-top: 21vh;
}
.full-page .footer {
	position: absolute;
	width: 100%;
	bottom: 0;
}
.full-page .footer .container {
	color: #ffffff;
}
.full-page .full-page-background {
	position: absolute;
	z-index: 1;
	height: 100%;
	width: 100%;
	display: block;
	top: 0;
	left: 0;
	background-size: cover;
	background-position: center center;
}
.full-page:after {
	position: absolute;
	z-index: 1;
	width: 100%;
	height: 100%;
	display: block;
	left: 0;
	top: 0;
	content: "";
	background-color: rgba(255, 255, 255, 0.6);
}
.full-page.pricing-page .description {
	margin-bottom: 65px;
}
.full-page.register-page .content > .container {
	margin-top: 5vh;
}
.full-page.register-page .info-horizontal {
	padding: 0px 0px 20px;
}
.full-page.register-page .info-horizontal {
	text-align: left !important;
}
.full-page.register-page .info-horizontal .icon {
	margin-top: 0;
}
.full-page.register-page .info-horizontal .icon > i {
	font-size: 2em;
}
.full-page.register-page .info-horizontal .icon.icon-circle {
	width: 65px;
	height: 65px;
	max-width: 65px;
	margin-top: 8px;
}
.full-page.register-page .info-horizontal .icon.icon-circle i {
	display: table;
	margin: 0 auto;
	line-height: 3.5;
	font-size: 1.9em;
}
.full-page.register-page .info-horizontal .description {
	overflow: hidden;
}
.full-page.lock-page .content > .container {
	margin-top: 10vh;
}

.register-page .navbar .navbar-collapse .nav-item .nav-link,
.login-page .navbar .navbar-collapse .nav-item .nav-link,
.lock-page .navbar .navbar-collapse .nav-item .nav-link {
	text-transform: capitalize;
	color: #ffffff !important;
}
.register-page .navbar.navbar-transparent,
.login-page .navbar.navbar-transparent,
.lock-page .navbar.navbar-transparent {
	border-bottom: 1px solid transparent;
	margin-top: 25px;
}
.register-page .navbar .navbar-brand,
.login-page .navbar .navbar-brand,
.lock-page .navbar .navbar-brand {
	color: #ffffff !important;
}

@media screen and (max-width: 991px) {
	.register-page
		.navbar.bg-white
		.navbar-toggler
		.navbar-toggler-bar.navbar-kebab,
	.login-page .navbar.bg-white .navbar-toggler .navbar-toggler-bar.navbar-kebab,
	.lock-page .navbar.bg-white .navbar-toggler .navbar-toggler-bar.navbar-kebab {
		background: #65adff !important;
	}
	.register-page
		.navbar.bg-white
		.navbar-collapse
		.navbar-nav
		.nav-item
		.nav-link,
	.login-page .navbar.bg-white .navbar-collapse .navbar-nav .nav-item .nav-link,
	.lock-page .navbar.bg-white .navbar-collapse .navbar-nav .nav-item .nav-link {
		color: #65adff !important;
	}
	.register-page .navbar.bg-white .navbar-brand,
	.login-page .navbar.bg-white .navbar-brand,
	.lock-page .navbar.bg-white .navbar-brand {
		color: #65adff !important;
	}
	.register-page .navbar.navbar-transparent .navbar-toggle,
	.login-page .navbar.navbar-transparent .navbar-toggle,
	.lock-page .navbar.navbar-transparent .navbar-toggle {
		display: none;
	}
	.register-page
		.navbar.navbar-transparent
		.navbar-toggler
		.navbar-toggler-bar.navbar-kebab,
	.login-page
		.navbar.navbar-transparent
		.navbar-toggler
		.navbar-toggler-bar.navbar-kebab,
	.lock-page
		.navbar.navbar-transparent
		.navbar-toggler
		.navbar-toggler-bar.navbar-kebab {
		background: #ffffff !important;
	}
}
.section {
	padding: 70px 0;
	position: relative;
	background: #ffffff;
}
.section .row + .category {
	margin-top: 15px;
}

.section-navbars {
	padding-bottom: 0;
}

.section-full-screen {
	height: 100vh;
}

.section-signup {
	padding-top: 20vh;
}

.parallax-s {
	overflow: hidden;
	height: 500px;
	width: 100%;
}

.section-image {
	background-size: cover;
	background-position: center center;
	position: relative;
	width: 100%;
}
.section-image .title,
.section-image .card-plain .card-title {
	color: #ffffff;
}
.section-image .nav-pills .nav-link {
	background-color: #ffffff;
}
.section-image .nav-pills .nav-link:hover,
.section-image .nav-pills .nav-link:focus {
	background-color: #ffffff;
}
.section-image .info-title,
.section-image .info-area.info-horizontal .icon i,
.section-image .card-pricing.card-plain ul li {
	color: #ffffff;
}
.section-image .description,
.section-image .info-area .icon:not(.icon-circle) {
	color: rgba(255, 255, 255, 0.8);
}
.section-image .card:not(.card-plain) .info-title {
	color: #2c2c2c;
}
.section-image .card:not(.card-plain) .info-area p,
.section-image .card:not(.card-plain) .info-area .icon,
.section-image .card:not(.card-plain) .description {
	color: #292929 !important;
}
.section-image .footer {
	color: #ffffff;
}
.section-image .card-plain [class*="text-"],
.section-image .card-plain ul li b {
	color: #ffffff;
}
.section-image .card-plain .category {
	color: rgba(255, 255, 255, 0.5);
}
.section-image:after {
	position: absolute;
	z-index: 1;
	width: 100%;
	height: 100%;
	display: block;
	left: 0;
	top: 0;
	content: "";
	background-color: rgba(0, 0, 0, 0.7);
}
.section-image .container {
	z-index: 2;
	position: relative;
}

.page-header {
	min-height: 100vh;
	max-height: 999px;
	padding: 0;
	color: #ffffff;
	position: relative;
}
.page-header .page-header-image {
	position: absolute;
	background-size: cover;
	background-position: center center;
	width: 100%;
	height: 100%;
	z-index: -1;
}
.page-header .content-center {
	position: absolute;
	top: 50%;
	left: 50%;
	z-index: 2;
	transform: translate(-50%, -50%);
	text-align: center;
	color: #ffffff;
	padding: 0 15px;
	width: 100%;
	max-width: 880px;
}
.page-header footer {
	position: absolute;
	bottom: 0;
	width: 100%;
}
.page-header .container {
	height: 100%;
	z-index: 1;
}
.page-header .category,
.page-header .description {
	color: rgba(255, 255, 255, 0.8);
}
.page-header.page-header-small {
	min-height: 60vh;
	max-height: 440px;
}
.page-header.page-header-mini {
	min-height: 40vh;
	max-height: 340px;
}
.page-header .title {
	margin-bottom: 15px;
}
.page-header .title + h4 {
	margin-top: 10px;
}
.page-header:after,
.page-header:before {
	position: absolute;
	z-index: 0;
	width: 100%;
	height: 100%;
	display: block;
	left: 0;
	top: 0;
	content: "";
}
.page-header:before {
	background-color: rgba(0, 0, 0, 0.3);
}
.page-header[filter-color="orange"] {
	background: rgba(44, 44, 44, 0.2);
	/* For browsers that do not support gradients */
	/* For Safari 5.1 to 6.0 */
	/* For Opera 11.1 to 12.0 */
	/* For Firefox 3.6 to 15 */
	background: linear-gradient(
		0deg,
		rgba(44, 44, 44, 0.2),
		rgba(224, 23, 3, 0.6)
	);
	/* Standard syntax */
}

.clear-filter:after,
.clear-filter:before {
	display: none;
}

.section-story-overview {
	padding: 50px 0;
}
.section-story-overview .image-container {
	height: 335px;
	position: relative;
	background-position: center center;
	background-size: cover;
	box-shadow: 0px 10px 25px 0px rgba(0, 0, 0, 0.3);
	border-radius: 0.25rem;
}
.section-story-overview .image-container + .category {
	padding-top: 15px;
}
.section-story-overview .image-container.image-right {
	z-index: 2;
}
.section-story-overview .image-container.image-right + h3.title {
	margin-top: 120px;
}
.section-story-overview .image-container.image-left {
	z-index: 1;
}
.section-story-overview .image-container img {
	width: 100%;
	left: 0;
	top: 0;
	height: auto;
	position: absolute;
}
.section-story-overview .image-container:nth-child(2) {
	margin-top: 420px;
	margin-left: -105px;
}
.section-story-overview p.blockquote {
	width: 220px;
	min-height: 180px;
	text-align: left;
	position: absolute;
	top: 376px;
	right: 155px;
	z-index: 0;
}

.section-nucleo-icons .nucleo-container img {
	width: auto;
	left: 0;
	top: 0;
	height: 100%;
	position: absolute;
}
.section-nucleo-icons .nucleo-container {
	height: 335px;
	position: relative;
}
.section-nucleo-icons h5 {
	margin-bottom: 35px;
}
.section-nucleo-icons .icons-container {
	position: relative;
	max-width: 450px;
	height: 300px;
	max-height: 300px;
	margin: 0 auto;
}
.section-nucleo-icons .icons-container i {
	font-size: 34px;
	position: absolute;
	left: 0;
	top: 0;
}
.section-nucleo-icons .icons-container i:nth-child(1) {
	top: 5%;
	left: 7%;
}
.section-nucleo-icons .icons-container i:nth-child(2) {
	top: 28%;
	left: 24%;
}
.section-nucleo-icons .icons-container i:nth-child(3) {
	top: 40%;
}
.section-nucleo-icons .icons-container i:nth-child(4) {
	top: 18%;
	left: 62%;
}
.section-nucleo-icons .icons-container i:nth-child(5) {
	top: 74%;
	left: 3%;
}
.section-nucleo-icons .icons-container i:nth-child(6) {
	top: 36%;
	left: 44%;
	font-size: 65px;
	color: #f96332;
	padding: 1px;
}
.section-nucleo-icons .icons-container i:nth-child(7) {
	top: 59%;
	left: 26%;
}
.section-nucleo-icons .icons-container i:nth-child(8) {
	top: 60%;
	left: 69%;
}
.section-nucleo-icons .icons-container i:nth-child(9) {
	top: 72%;
	left: 47%;
}
.section-nucleo-icons .icons-container i:nth-child(10) {
	top: 88%;
	left: 27%;
}
.section-nucleo-icons .icons-container i:nth-child(11) {
	top: 31%;
	left: 80%;
}
.section-nucleo-icons .icons-container i:nth-child(12) {
	top: 88%;
	left: 68%;
}
.section-nucleo-icons .icons-container i:nth-child(13) {
	top: 5%;
	left: 81%;
}
.section-nucleo-icons .icons-container i:nth-child(14) {
	top: 58%;
	left: 90%;
}
.section-nucleo-icons .icons-container i:nth-child(15) {
	top: 6%;
	left: 40%;
}

.section-images {
	max-height: 670px;
	height: 670px;
}
.section-images .hero-images-container,
.section-images .hero-images-container-1,
.section-images .hero-images-container-2 {
	margin-top: -38vh;
}
.section-images .hero-images-container {
	max-width: 670px;
}
.section-images .hero-images-container-1 {
	max-width: 390px;
	position: absolute;
	top: 55%;
	right: 18%;
}
.section-images .hero-images-container-2 {
	max-width: 225px;
	position: absolute;
	top: 68%;
	right: 12%;
}

[data-background-color="gray"] {
	background-color: white;
}

[data-background-color="orange"] {
	background-color: #e95e38;
}

[data-background-color="black"] {
	background-color: #2c2c2c;
}

[data-background-color]:not([data-background-color="gray"]) {
	color: #ffffff;
}
[data-background-color]:not([data-background-color="gray"]) .separator-line {
	background-color: rgba(255, 255, 255, 0.5);
}
[data-background-color]:not([data-background-color="gray"])
	.footer.footer-white
	.footer-brand,
[data-background-color]:not([data-background-color="gray"])
	.footer.footer-white
	ul
	li
	> a.nav-link:not(.btn-icon) {
	color: #000;
	color: initial;
}
[data-background-color]:not([data-background-color="gray"])
	.pagination
	.page-item.disabled
	> .page-link {
	background-color: rgba(255, 255, 255, 0.2);
	color: #ffffff;
}
[data-background-color]:not([data-background-color="gray"])
	.card:not(.card-plain)
	.category,
[data-background-color]:not([data-background-color="gray"])
	.card:not(.card-plain)
	.card-description,
[data-background-color]:not([data-background-color="gray"])
	.card:not(.card-plain)
	.category,
[data-background-color]:not([data-background-color="gray"])
	.card:not(.card-plain)
	.category {
	color: #292929 !important;
}
[data-background-color]:not([data-background-color="gray"])
	.card:not(.card-plain)
	.card-title,
[data-background-color]:not([data-background-color="gray"])
	.card:not(.card-plain)
	.card-title {
	color: #000;
	color: initial;
}
[data-background-color]:not([data-background-color="gray"])
	.carousel
	.carousel-inner {
	box-shadow: none;
}
[data-background-color]:not([data-background-color="gray"]) .title,
[data-background-color]:not([data-background-color="gray"])
	.social-description
	h2,
[data-background-color]:not([data-background-color="gray"]) p,
[data-background-color]:not([data-background-color="gray"]) p.blockquote,
[data-background-color]:not([data-background-color="gray"]) p.blockquote small,
[data-background-color]:not([data-background-color="gray"]) h1,
[data-background-color]:not([data-background-color="gray"]) h2,
[data-background-color]:not([data-background-color="gray"]) h3,
[data-background-color]:not([data-background-color="gray"]) h4,
[data-background-color]:not([data-background-color="gray"]) h5,
[data-background-color]:not([data-background-color="gray"]) h6,
[data-background-color]:not([data-background-color="gray"])
	a:not(.btn):not(.dropdown-item):not(.card-link),
[data-background-color]:not([data-background-color="gray"]) .icons-container i,
[data-background-color]:not([data-background-color="gray"]).card-pricing ul li,
[data-background-color]:not([data-background-color="gray"])
	.info.info-horizontal
	.icon
	i,
[data-background-color]:not([data-background-color="gray"])
	.card-pricing.card-plain
	ul
	li {
	color: #ffffff;
}
[data-background-color]:not([data-background-color="gray"]).card
	a:not(.btn):not(.dropdown-item) {
	color: #ffffff;
}
[data-background-color]:not([data-background-color="gray"]).card
	a:not(.btn):not(.dropdown-item):hover,
[data-background-color]:not([data-background-color="gray"]).card
	a:not(.btn):not(.dropdown-item):focus {
	border-color: #ffffff;
}
[data-background-color]:not([data-background-color="gray"]).footer hr,
[data-background-color]:not([data-background-color="gray"]).card-pricing
	.icon
	i,
[data-background-color]:not([data-background-color="gray"]).card-pricing ul li {
	border-color: rgba(255, 255, 255, 0.2);
}
[data-background-color]:not([data-background-color="gray"])
	.card-footer
	.stats
	i,
[data-background-color]:not([data-background-color="gray"]).card-plain
	.category,
[data-background-color]:not([data-background-color="gray"])
	.card-plain
	.category,
[data-background-color]:not([data-background-color="gray"]) .card-header:after {
	color: rgba(255, 255, 255, 0.5);
}
[data-background-color]:not([data-background-color="gray"]).card-pricing
	ul
	li
	i,
[data-background-color]:not([data-background-color="gray"]).card-pricing
	ul
	li
	b,
[data-background-color]:not([data-background-color="gray"])
	.card-pricing.card-plain
	ul
	li
	b,
[data-background-color]:not([data-background-color="gray"]) .card-category,
[data-background-color]:not([data-background-color="gray"]) .author span,
[data-background-color]:not([data-background-color="gray"])
	.card-pricing.card-plain
	ul
	li
	i {
	color: rgba(255, 255, 255, 0.8) !important;
}
[data-background-color]:not([data-background-color="gray"]) .separator {
	background-color: #ffffff;
}
[data-background-color]:not([data-background-color="gray"]) .navbar.bg-white p {
	color: #65adff;
}
[data-background-color]:not([data-background-color="gray"]) .description,
[data-background-color]:not([data-background-color="gray"])
	.social-description
	p {
	color: rgba(255, 255, 255, 0.8);
}
[data-background-color]:not([data-background-color="gray"]) p.blockquote {
	border-color: rgba(255, 255, 255, 0.2);
}
[data-background-color]:not([data-background-color="gray"])
	.checkbox
	label::before,
[data-background-color]:not([data-background-color="gray"])
	.checkbox
	label::after,
[data-background-color]:not([data-background-color="gray"])
	.radio
	label::before,
[data-background-color]:not([data-background-color="gray"])
	.radio
	label::after {
	border-color: rgba(255, 255, 255, 0.2);
}
[data-background-color]:not([data-background-color="gray"])
	.checkbox
	label::after,
[data-background-color]:not([data-background-color="gray"]) .checkbox label,
[data-background-color]:not([data-background-color="gray"]) .radio label {
	color: #ffffff;
}
[data-background-color]:not([data-background-color="gray"])
	.checkbox
	input[type="checkbox"]:disabled
	+ label,
[data-background-color]:not([data-background-color="gray"])
	.radio
	input[type="radio"]:disabled
	+ label {
	color: #ffffff;
}
[data-background-color]:not([data-background-color="gray"])
	.radio
	input[type="radio"]:not(:disabled):hover
	+ label::after,
[data-background-color]:not([data-background-color="gray"])
	.radio
	input[type="radio"]:checked
	+ label::after {
	background-color: #ffffff;
	border-color: #ffffff;
}
[data-background-color]:not([data-background-color="gray"])
	.form-control::-moz-placeholder {
	color: #ebebeb;
	opacity: 1;
	filter: alpha(opacity=100);
}
[data-background-color]:not([data-background-color="gray"])
	.form-control:-moz-placeholder {
	color: #ebebeb;
	opacity: 1;
	filter: alpha(opacity=100);
}
[data-background-color]:not([data-background-color="gray"])
	.form-control::-webkit-input-placeholder {
	color: #ebebeb;
	opacity: 1;
	filter: alpha(opacity=100);
}
[data-background-color]:not([data-background-color="gray"])
	.form-control:-ms-input-placeholder {
	color: #ebebeb;
	opacity: 1;
	filter: alpha(opacity=100);
}
[data-background-color]:not([data-background-color="gray"]) .form-control {
	border-color: rgba(255, 255, 255, 0.5);
	color: #ffffff;
}
[data-background-color]:not([data-background-color="gray"])
	.form-control:focus {
	border-color: #ffffff;
	background-color: transparent;
	color: #ffffff;
}
[data-background-color]:not([data-background-color="gray"]) .has-success:after,
[data-background-color]:not([data-background-color="gray"]) .has-danger:after {
	color: #ffffff;
}
[data-background-color]:not([data-background-color="gray"])
	.has-danger
	.form-control {
	background-color: transparent;
}
[data-background-color]:not([data-background-color="gray"])
	.input-group-prepend
	.input-group-text,
[data-background-color]:not([data-background-color="gray"])
	.input-group-append
	.input-group-text {
	background-color: transparent;
	border-color: rgba(255, 255, 255, 0.5);
	color: #ffffff;
}
[data-background-color]:not([data-background-color="gray"])
	.input-group-focus
	.input-group-prepend
	.input-group-text,
[data-background-color]:not([data-background-color="gray"])
	.input-group-focus
	.input-group-append
	.input-group-text {
	background-color: transparent;
	border-color: #ffffff;
	color: #ffffff;
}
[data-background-color]:not([data-background-color="gray"])
	.form-group.no-border
	.form-control,
[data-background-color]:not([data-background-color="gray"])
	.input-group.no-border
	.form-control {
	background-color: rgba(255, 255, 255, 0.1);
	color: #ffffff;
}
[data-background-color]:not([data-background-color="gray"])
	.form-group.no-border
	.form-control:focus,
[data-background-color]:not([data-background-color="gray"])
	.form-group.no-border
	.form-control:active,
[data-background-color]:not([data-background-color="gray"])
	.form-group.no-border
	.form-control:active,
[data-background-color]:not([data-background-color="gray"])
	.input-group.no-border
	.form-control:focus,
[data-background-color]:not([data-background-color="gray"])
	.input-group.no-border
	.form-control:active,
[data-background-color]:not([data-background-color="gray"])
	.input-group.no-border
	.form-control:active {
	background-color: rgba(255, 255, 255, 0.2);
	color: #ffffff;
}
[data-background-color]:not([data-background-color="gray"])
	.form-group.no-border
	.form-control
	+ .input-group-prepend
	.input-group-text,
[data-background-color]:not([data-background-color="gray"])
	.form-group.no-border
	.form-control
	+ .input-group-append
	.input-group-text,
[data-background-color]:not([data-background-color="gray"])
	.input-group.no-border
	.form-control
	+ .input-group-prepend
	.input-group-text,
[data-background-color]:not([data-background-color="gray"])
	.input-group.no-border
	.form-control
	+ .input-group-append
	.input-group-text {
	background-color: rgba(255, 255, 255, 0.1);
}
[data-background-color]:not([data-background-color="gray"])
	.form-group.no-border
	.form-control
	+ .input-group-prepend
	.input-group-text:focus,
[data-background-color]:not([data-background-color="gray"])
	.form-group.no-border
	.form-control
	+ .input-group-prepend
	.input-group-text:active,
[data-background-color]:not([data-background-color="gray"])
	.form-group.no-border
	.form-control
	+ .input-group-prepend
	.input-group-text:active,
[data-background-color]:not([data-background-color="gray"])
	.form-group.no-border
	.form-control
	+ .input-group-append
	.input-group-text:focus,
[data-background-color]:not([data-background-color="gray"])
	.form-group.no-border
	.form-control
	+ .input-group-append
	.input-group-text:active,
[data-background-color]:not([data-background-color="gray"])
	.form-group.no-border
	.form-control
	+ .input-group-append
	.input-group-text:active,
[data-background-color]:not([data-background-color="gray"])
	.input-group.no-border
	.form-control
	+ .input-group-prepend
	.input-group-text:focus,
[data-background-color]:not([data-background-color="gray"])
	.input-group.no-border
	.form-control
	+ .input-group-prepend
	.input-group-text:active,
[data-background-color]:not([data-background-color="gray"])
	.input-group.no-border
	.form-control
	+ .input-group-prepend
	.input-group-text:active,
[data-background-color]:not([data-background-color="gray"])
	.input-group.no-border
	.form-control
	+ .input-group-append
	.input-group-text:focus,
[data-background-color]:not([data-background-color="gray"])
	.input-group.no-border
	.form-control
	+ .input-group-append
	.input-group-text:active,
[data-background-color]:not([data-background-color="gray"])
	.input-group.no-border
	.form-control
	+ .input-group-append
	.input-group-text:active {
	background-color: rgba(255, 255, 255, 0.2);
	color: #ffffff;
}
[data-background-color]:not([data-background-color="gray"])
	.form-group.no-border
	.form-control:focus
	+ .input-group-prepend
	.input-group-text,
[data-background-color]:not([data-background-color="gray"])
	.form-group.no-border
	.form-control:focus
	+ .input-group-append
	.input-group-text,
[data-background-color]:not([data-background-color="gray"])
	.input-group.no-border
	.form-control:focus
	+ .input-group-prepend
	.input-group-text,
[data-background-color]:not([data-background-color="gray"])
	.input-group.no-border
	.form-control:focus
	+ .input-group-append
	.input-group-text {
	background-color: rgba(255, 255, 255, 0.2);
	color: #ffffff;
}
[data-background-color]:not([data-background-color="gray"])
	.form-group.no-border
	.input-group-prepend
	.input-group-text,
[data-background-color]:not([data-background-color="gray"])
	.form-group.no-border
	.input-group-append
	.input-group-text,
[data-background-color]:not([data-background-color="gray"])
	.input-group.no-border
	.input-group-prepend
	.input-group-text,
[data-background-color]:not([data-background-color="gray"])
	.input-group.no-border
	.input-group-append
	.input-group-text {
	background-color: rgba(255, 255, 255, 0.1);
	border: none;
	color: #ffffff;
}
[data-background-color]:not([data-background-color="gray"])
	.form-group.no-border.input-group-focus
	.input-group-prepend
	.input-group-text,
[data-background-color]:not([data-background-color="gray"])
	.form-group.no-border.input-group-focus
	.input-group-append
	.input-group-text,
[data-background-color]:not([data-background-color="gray"])
	.input-group.no-border.input-group-focus
	.input-group-prepend
	.input-group-text,
[data-background-color]:not([data-background-color="gray"])
	.input-group.no-border.input-group-focus
	.input-group-append
	.input-group-text {
	background-color: rgba(255, 255, 255, 0.2);
	color: #ffffff;
}
[data-background-color]:not([data-background-color="gray"]) .input-group-addon,
[data-background-color]:not([data-background-color="gray"])
	.form-group.no-border
	.input-group-addon,
[data-background-color]:not([data-background-color="gray"])
	.input-group.no-border
	.input-group-addon {
	color: rgba(255, 255, 255, 0.8);
}
[data-background-color]:not([data-background-color="gray"])
	.subscribe-line
	.form-control {
	background-color: transparent;
	border: 1px solid #e3e3e3;
	color: #2c2c2c;
}
[data-background-color]:not([data-background-color="gray"])
	.subscribe-line
	.form-control:last-child {
	border-left: 0 none;
}
[data-background-color]:not([data-background-color="gray"])
	.subscribe-line
	.input-group-addon,
[data-background-color]:not([data-background-color="gray"])
	.subscribe-line
	.form-group.no-border
	.input-group-addon,
[data-background-color]:not([data-background-color="gray"])
	.subscribe-line
	.input-group.no-border
	.input-group-addon {
	color: #555555;
	border: 1px solid #e3e3e3;
}
[data-background-color]:not([data-background-color="gray"]) .btn.btn-simple {
	background-color: transparent;
	border-color: rgba(255, 255, 255, 0.5);
	color: #ffffff;
}
[data-background-color]:not([data-background-color="gray"])
	.btn.btn-simple:hover,
[data-background-color]:not([data-background-color="gray"])
	.btn.btn-simple:hover,
[data-background-color]:not([data-background-color="gray"])
	.btn.btn-simple:focus,
[data-background-color]:not([data-background-color="gray"])
	.btn.btn-simple:active {
	background-color: transparent;
	border-color: #ffffff;
}
[data-background-color]:not([data-background-color="gray"])
	.nav-tabs
	> .nav-item
	> .nav-link
	i.nc-icon {
	color: #ffffff;
}
[data-background-color]:not([data-background-color="gray"]).section-nucleo-icons
	.icons-container
	i:nth-child(6) {
	color: #ffffff;
}

@media screen and (max-width: 991px) {
	.navbar {
		padding: 0;
	}
	.navbar.navbar-absolute {
		padding-top: 0;
	}
	.navbar .navbar-brand {
		font-size: 16px;
		margin-right: 0;
	}

	.profile-photo .profile-photo-small {
		margin-left: -2px;
	}

	.button-dropdown {
		display: none;
	}

	#minimizeSidebar {
		display: none;
	}

	.navbar .container-fluid {
		padding-right: 15px;
		padding-left: 15px;
	}
	.navbar .navbar-collapse .input-group {
		margin: 0;
		margin-top: 5px;
	}
	.navbar .navbar-nav .nav-item:first-child {
		margin-top: 10px;
	}
	.navbar .navbar-nav .nav-item:not(:last-child) {
		margin-bottom: 10px;
	}
	.navbar .dropdown.show .dropdown-menu {
		display: block;
	}
	.navbar .dropdown .dropdown-menu {
		display: none;
	}
	.navbar .dropdown.show .dropdown-menu,
	.navbar .dropdown .dropdown-menu {
		border: 0;
		transition: none;
		-webkit-box-shadow: none;
		width: auto;
		margin: 0px 1rem;
		margin-top: 0px;
		box-shadow: none;
		position: static;
		padding-left: 10px;
	}
	.navbar .dropdown.show .dropdown-menu:before,
	.navbar .dropdown .dropdown-menu:before {
		display: none;
	}
	.navbar .dropdown-menu .dropdown-item:focus,
	.navbar .dropdown-menu .dropdown-item:hover {
		color: #ffffff;
	}
	.navbar.bg-white .dropdown-menu .dropdown-item:focus,
	.navbar.bg-white .dropdown-menu .dropdown-item:hover {
		color: #65adff;
	}
	.navbar .navbar-toggler-bar {
		display: block;
		position: relative;
		width: 22px;
		height: 1px;
		border-radius: 1px;
		background: #65adff;
	}
	.navbar .navbar-toggler-bar + .navbar-toggler-bar {
		margin-top: 7px;
	}
	.navbar .navbar-toggler-bar + .navbar-toggler-bar.navbar-kebab {
		margin-top: 3px;
	}
	.navbar .navbar-toggler-bar.bar2 {
		width: 17px;
		transition: width 0.2s linear;
	}
	.navbar.bg-white:not(.navbar-transparent) .navbar-toggler-bar {
		background-color: #65adff;
	}
	.navbar .toggled .navbar-toggler-bar {
		width: 24px;
	}
	.navbar .toggled .navbar-toggler-bar + .navbar-toggler-bar {
		margin-top: 5px;
	}

	.wrapper {
		transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);
	}

	.nav-open .main-panel {
		right: 0;
		transform: translate3d(260px, 0, 0);
	}
	.nav-open .sidebar {
		transform: translate3d(0px, 0, 0);
	}
	.nav-open body {
		position: relative;
		overflow-x: hidden;
	}
	.nav-open .menu-on-right .main-panel {
		transform: translate3d(-260px, 0, 0);
	}
	.nav-open .menu-on-right .navbar-collapse,
	.nav-open .menu-on-right .sidebar {
		transform: translate3d(0px, 0, 0);
	}
	.nav-open .menu-on-right .navbar-translate {
		transform: translate3d(-300px, 0, 0);
	}
	.nav-open .menu-on-right #bodyClick {
		right: 260px;
		left: auto;
	}

	.menu-on-right .sidebar {
		left: auto;
		right: 0;
		transform: translate3d(260px, 0, 0);
	}

	.bar1,
	.bar2,
	.bar3 {
		outline: 1px solid transparent;
	}

	.bar1 {
		top: 0px;
		animation: topbar-back 500ms 0s;
		animation-fill-mode: forwards;
	}

	.bar2 {
		opacity: 1;
	}

	.bar3 {
		bottom: 0px;
		animation: bottombar-back 500ms 0s;
		animation-fill-mode: forwards;
	}

	.toggled .bar1 {
		top: 6px;
		animation: topbar-x 500ms 0s;
		animation-fill-mode: forwards;
	}

	.toggled .bar2 {
		opacity: 0;
	}

	.toggled .bar3 {
		bottom: 6px;
		animation: bottombar-x 500ms 0s;
		animation-fill-mode: forwards;
	}

	@keyframes topbar-x {
		0% {
			top: 0px;
			transform: rotate(0deg);
		}
		45% {
			top: 6px;
			transform: rotate(145deg);
		}
		75% {
			transform: rotate(130deg);
		}
		100% {
			transform: rotate(135deg);
		}
	}
	@keyframes topbar-back {
		0% {
			top: 6px;
			transform: rotate(135deg);
		}
		45% {
			transform: rotate(-10deg);
		}
		75% {
			transform: rotate(5deg);
		}
		100% {
			top: 0px;
			transform: rotate(0);
		}
	}
	@keyframes bottombar-x {
		0% {
			bottom: 0px;
			transform: rotate(0deg);
		}
		45% {
			bottom: 6px;
			transform: rotate(-145deg);
		}
		75% {
			transform: rotate(-130deg);
		}
		100% {
			transform: rotate(-135deg);
		}
	}
	@keyframes bottombar-back {
		0% {
			bottom: 6px;
			transform: rotate(-135deg);
		}
		45% {
			transform: rotate(10deg);
		}
		75% {
			transform: rotate(-5deg);
		}
		100% {
			bottom: 0px;
			transform: rotate(0);
		}
	}
	@keyframes fadeIn {
		0% {
			opacity: 0;
		}
		100% {
			opacity: 1;
		}
	}
	#bodyClick {
		height: 100%;
		width: 100%;
		position: fixed;
		opacity: 1;
		top: 0;
		right: 0;
		left: 260px;
		content: "";
		z-index: 9999;
		overflow-x: hidden;
		background-color: transparent;
		transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);
	}

	.footer .copyright {
		text-align: right;
	}

	.section-nucleo-icons .icons-container {
		margin-top: 65px;
	}

	.navbar-nav .nav-link i.fa,
	.navbar-nav .nav-link i.nc-icon {
		opacity: 0.5;
	}

	.sidebar,
	.bootstrap-navbar {
		position: fixed;
		display: block;
		top: 0;
		height: 100%;
		width: 260px;
		right: auto;
		left: 0;
		z-index: 1032;
		visibility: visible;
		overflow-y: visible;
		padding: 0;
		transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);
		transform: translate3d(-260px, 0, 0);
	}

	.main-panel {
		width: 100%;
	}

	.timeline:before {
		left: 5% !important;
	}
	.timeline > li > .timeline-badge {
		left: 5% !important;
	}
	.timeline > li > .timeline-panel {
		float: right !important;
		width: 82% !important;
	}
	.timeline > li > .timeline-panel:before {
		border-left-width: 0 !important;
		border-right-width: 15px !important;
		left: -15px !important;
		right: auto !important;
	}
	.timeline > li > .timeline-panel:after {
		border-left-width: 0 !important;
		border-right-width: 14px !important;
		left: -14px !important;
		right: auto !important;
	}
}
@media (max-width: 991px) and (min-width: 768px) {
	.nav-tabs-navigation.verical-navs {
		padding: 0px 2px;
	}
}
@media screen and (min-width: 768px) {
	.footer .footer-nav {
		padding-left: 21px;
		justify-content: center;
	}
	.footer .credits {
		padding-right: 15px;
	}
}
@media screen and (min-width: 992px) {
	.navbar-collapse {
		background: none !important;
	}

	.navbar .navbar-toggle {
		display: none;
	}

	.navbar-nav .nav-link.profile-photo {
		padding: 0;
		margin: 7px 0.7rem;
	}

	.section-nucleo-icons .icons-container {
		margin: 0 0 0 auto;
	}

	.dropdown-menu .dropdown-item {
		color: inherit;
	}

	.footer .copyright {
		float: right;
		padding-right: 15px;
	}

	.sidebar .sidebar-wrapper li.active > a:not([data-toggle="collapse"]):before,
	.sidebar
		.sidebar-wrapper
		li.active
		> [data-toggle="collapse"]
		+ div
		.nav
		li:before {
		border-right: 17px solid #dddddd;
		border-top: 17px solid transparent;
		border-bottom: 17px solid transparent;
		content: "";
		display: inline-block;
		position: absolute;
		right: -16px;
		opacity: 1;
		top: 7px;
		transition: opacity 150ms ease-in;
	}
	.sidebar .sidebar-wrapper li.active > a:not([data-toggle="collapse"]):after,
	.sidebar
		.sidebar-wrapper
		li.active
		> [data-toggle="collapse"]
		+ div
		.nav
		li:after {
		border-right: 17px solid #f4f3ef;
		border-top: 17px solid transparent;
		border-bottom: 17px solid transparent;
		content: "";
		display: inline-block;
		position: absolute;
		right: -17px;
		opacity: 1;
		top: 7px;
		transition: opacity 150ms ease-in;
	}
	.sidebar
		.sidebar-wrapper
		li.active
		> [data-toggle="collapse"]
		+ div
		.nav
		li
		a:before,
	.sidebar
		.sidebar-wrapper
		li.active
		> [data-toggle="collapse"]
		+ div
		.nav
		li
		a:after {
		top: 0;
	}
}
@media screen and (max-width: 768px) {
	.card-stats [class*="col-"] .statistics::after {
		display: none;
	}

	.main-panel .content {
		padding-left: 15px;
		padding-right: 15px;
	}

	.footer nav {
		display: block;
		margin-bottom: 5px;
		float: none;
	}

	.landing-page .section-story-overview .image-container:nth-child(2) {
		margin-left: 0;
		margin-bottom: 30px;
	}

	.card .form-horizontal .col-md-3.col-form-label {
		text-align: left;
	}
}
@media screen and (max-width: 767px) {
	.nav-tabs-navigation.verical-navs {
		padding: 0 28px;
	}

	.typography-line {
		padding-left: 23% !important;
	}
	.typography-line span {
		width: 60px !important;
	}

	.login-page .navbar,
	.lock-page .navbar,
	.register-page .navbar,
	.navbar {
		padding: 0 !important;
	}

	.footer .footer-nav,
	.footer .credits {
		margin: 0 auto !important;
	}
	.footer .footer-nav {
		margin-bottom: 10px !important;
	}

	.register-page .content {
		padding-top: 5vh;
	}
	.register-page .footer {
		position: relative;
	}
	.register-page .info-area.info-horizontal {
		margin-top: 0;
	}
}
@media screen and (max-width: 374px) {
	.login-page .content {
		padding-top: 10vh;
	}
}
@media screen and (max-width: 413px) {
	.fixed-plugin .dropdown.show-dropdown.show .dropdown-menu.show {
		width: 225px !important;
	}
	.fixed-plugin
		.dropdown.show-dropdown.show
		.dropdown-menu.show[x-placement="top-start"] {
		transform: translate3d(0, 400px, 0) !important;
	}
	.fixed-plugin .dropdown.show-dropdown.show .dropdown-menu.show:before,
	.fixed-plugin .dropdown.show-dropdown.show .dropdown-menu.show:after {
		bottom: 360px !important;
	}
}
@media screen and (max-width: 576px) {
	.navbar[class*="navbar-toggleable-"] .container {
		margin-left: 0;
		margin-right: 0;
	}

	.card-contributions .card-stats {
		flex-direction: column;
	}
	.card-contributions .card-stats .bootstrap-switch {
		margin-bottom: 15px;
	}

	.footer .copyright {
		text-align: center;
	}

	.section-nucleo-icons .icons-container i {
		font-size: 30px;
	}
	.section-nucleo-icons .icons-container i:nth-child(6) {
		font-size: 48px;
	}

	.page-header .container h6.category-absolute {
		width: 90%;
	}

	.card-timeline .timeline .timeline-panel {
		width: 38%;
		padding: 15px;
	}
}
.alert .close {
	font-size: 1.8rem;
	font-weight: 300;
}

/*           badges             */
.badge + .badge {
	margin-left: 5px;
}

.btn i,
.navbar .navbar-nav > a.btn i {
	margin-right: 3px;
}

.btn + .btn,
.btn-group + .btn-group {
	margin-left: 5px;
}

.card .card-footer .stats i {
	margin-right: 9px;
}
.card .card-footer .legend i {
	margin-right: 4px;
}

.dropup .dropdown-toggle:after,
.dropdown .dropdown-toggle:after {
	margin-left: 3px;
}

.login-page .card-login {
	border-radius: 6px;
	padding-bottom: 0.7rem;
}
.login-page .card-login .btn-wd {
	min-width: 180px;
}
.login-page .card-login .logo-container {
	width: 65px;
	margin: 0 auto;
	margin-bottom: 55px;
}
.login-page .card-login .logo-container img {
	width: 100%;
}
.login-page .card-login .input-group:last-child {
	margin-bottom: 1em;
}
.login-page .card-login.card-plain .form-control::-moz-placeholder {
	color: #ebebeb;
	opacity: 1;
	filter: alpha(opacity=100);
}
.login-page .card-login.card-plain .form-control:-moz-placeholder {
	color: #ebebeb;
	opacity: 1;
	filter: alpha(opacity=100);
}
.login-page .card-login.card-plain .form-control::-webkit-input-placeholder {
	color: #ebebeb;
	opacity: 1;
	filter: alpha(opacity=100);
}
.login-page .card-login.card-plain .form-control:-ms-input-placeholder {
	color: #ebebeb;
	opacity: 1;
	filter: alpha(opacity=100);
}
.login-page .card-login.card-plain .form-control {
	border-color: rgba(255, 255, 255, 0.5);
	color: #ffffff;
}
.login-page .card-login.card-plain .form-control:focus {
	border-color: #ffffff;
	background-color: transparent;
	color: #ffffff;
}
.login-page .card-login.card-plain .has-success:after,
.login-page .card-login.card-plain .has-danger:after {
	color: #ffffff;
}
.login-page .card-login.card-plain .has-danger .form-control {
	background-color: transparent;
}
.login-page .card-login.card-plain .input-group-prepend .input-group-text,
.login-page .card-login.card-plain .input-group-append .input-group-text {
	background-color: transparent;
	border-color: rgba(255, 255, 255, 0.5);
	color: #ffffff;
}
.login-page
	.card-login.card-plain
	.input-group-focus
	.input-group-prepend
	.input-group-text,
.login-page
	.card-login.card-plain
	.input-group-focus
	.input-group-append
	.input-group-text {
	background-color: transparent;
	border-color: #ffffff;
	color: #ffffff;
}
.login-page .card-login.card-plain .form-group.no-border .form-control,
.login-page .card-login.card-plain .input-group.no-border .form-control {
	background-color: rgba(255, 255, 255, 0.1);
	color: #ffffff;
}
.login-page .card-login.card-plain .form-group.no-border .form-control:focus,
.login-page .card-login.card-plain .form-group.no-border .form-control:active,
.login-page .card-login.card-plain .form-group.no-border .form-control:active,
.login-page .card-login.card-plain .input-group.no-border .form-control:focus,
.login-page .card-login.card-plain .input-group.no-border .form-control:active,
.login-page .card-login.card-plain .input-group.no-border .form-control:active {
	background-color: rgba(255, 255, 255, 0.2);
	color: #ffffff;
}
.login-page
	.card-login.card-plain
	.form-group.no-border
	.form-control
	+ .input-group-prepend
	.input-group-text,
.login-page
	.card-login.card-plain
	.form-group.no-border
	.form-control
	+ .input-group-append
	.input-group-text,
.login-page
	.card-login.card-plain
	.input-group.no-border
	.form-control
	+ .input-group-prepend
	.input-group-text,
.login-page
	.card-login.card-plain
	.input-group.no-border
	.form-control
	+ .input-group-append
	.input-group-text {
	background-color: rgba(255, 255, 255, 0.1);
}
.login-page
	.card-login.card-plain
	.form-group.no-border
	.form-control
	+ .input-group-prepend
	.input-group-text:focus,
.login-page
	.card-login.card-plain
	.form-group.no-border
	.form-control
	+ .input-group-prepend
	.input-group-text:active,
.login-page
	.card-login.card-plain
	.form-group.no-border
	.form-control
	+ .input-group-prepend
	.input-group-text:active,
.login-page
	.card-login.card-plain
	.form-group.no-border
	.form-control
	+ .input-group-append
	.input-group-text:focus,
.login-page
	.card-login.card-plain
	.form-group.no-border
	.form-control
	+ .input-group-append
	.input-group-text:active,
.login-page
	.card-login.card-plain
	.form-group.no-border
	.form-control
	+ .input-group-append
	.input-group-text:active,
.login-page
	.card-login.card-plain
	.input-group.no-border
	.form-control
	+ .input-group-prepend
	.input-group-text:focus,
.login-page
	.card-login.card-plain
	.input-group.no-border
	.form-control
	+ .input-group-prepend
	.input-group-text:active,
.login-page
	.card-login.card-plain
	.input-group.no-border
	.form-control
	+ .input-group-prepend
	.input-group-text:active,
.login-page
	.card-login.card-plain
	.input-group.no-border
	.form-control
	+ .input-group-append
	.input-group-text:focus,
.login-page
	.card-login.card-plain
	.input-group.no-border
	.form-control
	+ .input-group-append
	.input-group-text:active,
.login-page
	.card-login.card-plain
	.input-group.no-border
	.form-control
	+ .input-group-append
	.input-group-text:active {
	background-color: rgba(255, 255, 255, 0.2);
	color: #ffffff;
}
.login-page
	.card-login.card-plain
	.form-group.no-border
	.form-control:focus
	+ .input-group-prepend
	.input-group-text,
.login-page
	.card-login.card-plain
	.form-group.no-border
	.form-control:focus
	+ .input-group-append
	.input-group-text,
.login-page
	.card-login.card-plain
	.input-group.no-border
	.form-control:focus
	+ .input-group-prepend
	.input-group-text,
.login-page
	.card-login.card-plain
	.input-group.no-border
	.form-control:focus
	+ .input-group-append
	.input-group-text {
	background-color: rgba(255, 255, 255, 0.2);
	color: #ffffff;
}
.login-page
	.card-login.card-plain
	.form-group.no-border
	.input-group-prepend
	.input-group-text,
.login-page
	.card-login.card-plain
	.form-group.no-border
	.input-group-append
	.input-group-text,
.login-page
	.card-login.card-plain
	.input-group.no-border
	.input-group-prepend
	.input-group-text,
.login-page
	.card-login.card-plain
	.input-group.no-border
	.input-group-append
	.input-group-text {
	background-color: rgba(255, 255, 255, 0.1);
	border: none;
	color: #ffffff;
}
.login-page
	.card-login.card-plain
	.form-group.no-border.input-group-focus
	.input-group-prepend
	.input-group-text,
.login-page
	.card-login.card-plain
	.form-group.no-border.input-group-focus
	.input-group-append
	.input-group-text,
.login-page
	.card-login.card-plain
	.input-group.no-border.input-group-focus
	.input-group-prepend
	.input-group-text,
.login-page
	.card-login.card-plain
	.input-group.no-border.input-group-focus
	.input-group-append
	.input-group-text {
	background-color: rgba(255, 255, 255, 0.2);
	color: #ffffff;
}
.login-page .card-login.card-plain .input-group-addon,
.login-page .card-login.card-plain .form-group.no-border .input-group-addon,
.login-page .card-login.card-plain .input-group.no-border .input-group-addon {
	color: rgba(255, 255, 255, 0.8);
}
.login-page .link {
	font-size: 10px;
	color: #ffffff;
	text-decoration: none;
}

.full-page {
	align-items: center;
	min-height: 100vh;
	padding: 100px 0 120px;
}
.full-page > .footer {
	position: relative;
	z-index: 4;
}
.full-page .footer {
	position: absolute;
	width: 100%;
	bottom: 0;
}
.full-page .footer .container {
	color: #ffffff;
}
.full-page .full-page-background {
	position: absolute;
	z-index: 1;
	height: 100%;
	width: 100%;
	display: block;
	top: 0;
	left: 0;
	background-size: cover;
	background-position: center center;
}
.full-page:after {
	position: absolute;
	z-index: 1;
	width: 100%;
	height: 100%;
	display: block;
	left: 0;
	top: 0;
	content: "";
	background-color: rgba(0, 0, 0, 0.6);
}
.full-page .pricing-page .description {
	margin-bottom: 65px;
}
.full-page .register-page > .container {
	margin-top: 5vh;
}
.full-page .register-page .info-horizontal {
	padding: 0px 0px 20px;
}
.full-page .register-page .info-horizontal {
	text-align: left !important;
}
.full-page .register-page .info-horizontal .icon {
	margin-top: 0;
}
.full-page .register-page .info-horizontal .icon > i {
	font-size: 2em;
}
.full-page .register-page .info-horizontal .icon.icon-circle {
	width: 65px;
	height: 65px;
	max-width: 65px;
	margin-top: 8px;
}
.full-page .register-page .info-horizontal .icon.icon-circle i {
	display: table;
	margin: 0 auto;
	line-height: 3.5;
	font-size: 1.9em;
}
.full-page .register-page .info-horizontal .description {
	overflow: hidden;
}

.register-page .navbar .navbar-collapse .nav-item .nav-link,
.login-page .navbar .navbar-collapse .nav-item .nav-link,
.lock-page .navbar .navbar-collapse .nav-item .nav-link {
	text-transform: capitalize;
	color: #ffffff !important;
}
.register-page .navbar .navbar-collapse .nav-item .nav-link i,
.login-page .navbar .navbar-collapse .nav-item .nav-link i,
.lock-page .navbar .navbar-collapse .nav-item .nav-link i {
	margin-right: 4px;
}
.register-page .navbar.navbar-transparent,
.login-page .navbar.navbar-transparent,
.lock-page .navbar.navbar-transparent {
	border-bottom: 1px solid transparent;
	margin-top: 25px;
}
.register-page .navbar .navbar-brand,
.login-page .navbar .navbar-brand,
.lock-page .navbar .navbar-brand {
	color: #ffffff !important;
}

.register-page,
.login-page,
.lock-page {
	width: 100%;
}

@media screen and (max-width: 991px) {
	.register-page
		.navbar.bg-white
		.navbar-toggler
		.navbar-toggler-bar.navbar-kebab,
	.login-page .navbar.bg-white .navbar-toggler .navbar-toggler-bar.navbar-kebab,
	.lock-page .navbar.bg-white .navbar-toggler .navbar-toggler-bar.navbar-kebab {
		background: #65adff !important;
	}
	.register-page
		.navbar.bg-white
		.navbar-collapse
		.navbar-nav
		.nav-item
		.nav-link,
	.login-page .navbar.bg-white .navbar-collapse .navbar-nav .nav-item .nav-link,
	.lock-page .navbar.bg-white .navbar-collapse .navbar-nav .nav-item .nav-link {
		color: #65adff !important;
	}
	.register-page .navbar.bg-white .navbar-brand,
	.login-page .navbar.bg-white .navbar-brand,
	.lock-page .navbar.bg-white .navbar-brand {
		color: #65adff !important;
	}
	.register-page .navbar.navbar-transparent .navbar-toggle,
	.login-page .navbar.navbar-transparent .navbar-toggle,
	.lock-page .navbar.navbar-transparent .navbar-toggle {
		display: none;
	}
	.register-page
		.navbar.navbar-transparent
		.navbar-toggler
		.navbar-toggler-bar.navbar-kebab,
	.login-page
		.navbar.navbar-transparent
		.navbar-toggler
		.navbar-toggler-bar.navbar-kebab,
	.lock-page
		.navbar.navbar-transparent
		.navbar-toggler
		.navbar-toggler-bar.navbar-kebab {
		background: #ffffff !important;
	}
}
.btn-file {
	position: relative;
	overflow: hidden;
	vertical-align: middle;
}

.btn-file > input {
	position: absolute;
	top: 0;
	right: 0;
	width: 100%;
	height: 100%;
	margin: 0;
	font-size: 23px;
	cursor: pointer;
	filter: alpha(opacity=0);
	opacity: 0;
	direction: ltr;
}

.fileinput {
	display: inline-block;
	margin-bottom: 9px;
}
.fileinput input[type="file"] {
	display: none;
}

.fileinput .form-control {
	display: inline-block;
	padding-top: 7px;
	padding-bottom: 5px;
	margin-bottom: 0;
	vertical-align: middle;
	cursor: text;
}

.fileinput .thumbnail {
	display: inline-block;
	margin-bottom: 10px;
	overflow: hidden;
	text-align: center;
	vertical-align: middle;
	max-width: 250px;
	box-shadow: 0 2px 2px rgba(204, 197, 185, 0.5);
}
.fileinput .thumbnail.img-circle {
	border-radius: 50%;
	max-width: 100px;
}

.fileinput .thumbnail > img {
	max-height: 100%;
}

.fileinput .btn {
	vertical-align: middle;
}

.fileinput-exists .fileinput-new,
.fileinput-new .fileinput-exists {
	display: none;
}

.fileinput-inline .fileinput-controls {
	display: inline;
}

.fileinput-filename {
	display: inline-block;
	overflow: hidden;
	vertical-align: middle;
}

.form-control .fileinput-filename {
	vertical-align: bottom;
}

.fileinput.input-group {
	display: table;
}

.fileinput.input-group > * {
	position: relative;
	z-index: 2;
}

.fileinput.input-group > .btn-file {
	z-index: 1;
}

.fileinput-new.input-group .btn-file,
.fileinput-new .input-group .btn-file {
	border-radius: 0 4px 4px 0;
}

.fileinput-new.input-group .btn-file.btn-xs,
.fileinput-new .input-group .btn-file.btn-xs,
.fileinput-new.input-group .btn-file.btn-sm,
.fileinput-new .input-group .btn-file.btn-sm {
	border-radius: 0 3px 3px 0;
}

.fileinput-new.input-group .btn-file.btn-lg,
.fileinput-new .input-group .btn-file.btn-lg {
	border-radius: 0 6px 6px 0;
}

.form-group.has-warning .fileinput .fileinput-preview {
	color: #ffc759;
}

.form-group.has-warning .fileinput .thumbnail {
	border-color: #ffc759;
}

.form-group.has-error .fileinput .fileinput-preview {
	color: #c1292e;
}

.form-group.has-error .fileinput .thumbnail {
	border-color: #c1292e;
}

.form-group.has-success .fileinput .fileinput-preview {
	color: #28a745;
}

.form-group.has-success .fileinput .thumbnail {
	border-color: #28a745;
}

.input-group-addon:not(:first-child) {
	border-left: 0;
}

.thumbnail {
	border: 0 none;
	border-radius: 3px;
	padding: 0;
}

.picture-container {
	position: relative;
	cursor: pointer;
	text-align: center;
}

.picture {
	width: 106px;
	height: 106px;
	background-color: #999999;
	border: 1px solid #e3e3e3;
	color: #ffffff;
	border-radius: 50%;
	margin: 5px auto;
	overflow: hidden;
	transition: all 0.2s;
	-webkit-transition: all 0.2s;
}
.picture:hover {
	border-color: #2ca8ff;
}

.picture input[type="file"] {
	cursor: pointer;
	display: block;
	height: 100%;
	left: 0;
	opacity: 0 !important;
	position: absolute;
	top: 0;
	width: 100%;
}

.picture-src {
	width: 100%;
}

.fixed-plugin {
	position: fixed;
	right: 0;
	width: 64px;
	background: rgba(0, 0, 0, 0.3);
	z-index: 1031;
	border-radius: 8px 0 0 8px;
	text-align: center;
	top: 120px;
}
.fixed-plugin li > a,
.fixed-plugin .badge {
	transition: all 0.34s;
	-webkit-transition: all 0.34s;
	-moz-transition: all 0.34s;
}
.fixed-plugin .fa-cog {
	color: #ffffff;
	padding: 10px;
	border-radius: 0 0 6px 6px;
	width: auto;
}
.fixed-plugin .dropdown-menu {
	right: 80px;
	left: auto !important;
	top: -52px !important;
	width: 290px;
	border-radius: 10px;
	padding: 0 10px;
}
.fixed-plugin .dropdown .dropdown-menu .nc-icon {
	top: 2px;
	right: 10px;
	font-size: 14px;
}
.fixed-plugin .dropdown-menu:after,
.fixed-plugin .dropdown-menu:before {
	right: 10px;
	margin-left: auto;
	left: auto;
}
.fixed-plugin .fa-circle-thin {
	color: #ffffff;
}
.fixed-plugin .active .fa-circle-thin {
	color: #00bbff;
}
.fixed-plugin .dropdown-menu > .active > a,
.fixed-plugin .dropdown-menu > .active > a:hover,
.fixed-plugin .dropdown-menu > .active > a:focus {
	color: #777777;
	text-align: center;
}
.fixed-plugin img {
	border-radius: 0;
	width: 100%;
	height: 100px;
	margin: 0 auto;
}
.fixed-plugin .dropdown-menu li > a:hover,
.fixed-plugin .dropdown-menu li > a:focus {
	box-shadow: none;
}
.fixed-plugin .badge {
	border: 3px solid #ffffff;
	border-radius: 50%;
	cursor: pointer;
	display: inline-block;
	height: 23px;
	margin-right: 5px;
	position: relative;
	width: 23px;
}
.fixed-plugin .badge.badge-light {
	border-color: #f5f5f5;
	background-color: #f5f5f5;
	border: 3px solid #ffffff;
}
.fixed-plugin .badge.badge-dark {
	border-color: #2c2c2c;
	background-color: #2c2c2c;
	border: 3px solid #ffffff;
}
.fixed-plugin .badge.active,
.fixed-plugin .badge:hover {
	border-color: #00bbff;
}
.fixed-plugin .badge-blue {
	background-color: #39a9db;
}
.fixed-plugin .badge-green {
	background-color: #28a745;
}
.fixed-plugin .badge-orange {
	background-color: #1c77c3;
}
.fixed-plugin .badge-yellow {
	background-color: #ffc759;
}
.fixed-plugin .badge-red {
	background-color: #c1292e;
}
.fixed-plugin h5 {
	font-size: 14px;
	margin: 10px;
}
.fixed-plugin .dropdown-menu li {
	display: block;
	padding: 15px 2px;
	width: 25%;
	float: left;
}
.fixed-plugin li.adjustments-line,
.fixed-plugin li.header-title,
.fixed-plugin li.button-container {
	width: 100%;
	height: 35px;
	min-height: inherit;
}
.fixed-plugin li.button-container {
	height: auto;
}
.fixed-plugin li.button-container div {
	margin-bottom: 5px;
}
.fixed-plugin #sharrreTitle {
	text-align: center;
	padding: 10px 0;
	height: 50px;
}
.fixed-plugin li.header-title {
	height: 30px;
	line-height: 25px;
	font-size: 12px;
	font-weight: 600;
	text-align: center;
	text-transform: uppercase;
}
.fixed-plugin .adjustments-line p {
	display: inline-block;
	margin-bottom: 0;
	font-size: 1em;
	color: #3c4858;
}
.fixed-plugin .adjustments-line a {
	color: transparent;
}
.fixed-plugin .adjustments-line a .badge-colors {
	position: relative;
	top: -2px;
}
.fixed-plugin .adjustments-line a a:hover,
.fixed-plugin .adjustments-line a a:focus {
	color: transparent;
}
.fixed-plugin .adjustments-line .togglebutton {
	text-align: center;
}
.fixed-plugin .adjustments-line .togglebutton .label-switch {
	position: relative;
	left: -10px;
	font-size: 0.7142em;
	color: #65adff;
}
.fixed-plugin .adjustments-line .togglebutton .label-switch.label-right {
	left: 10px;
}
.fixed-plugin .adjustments-line .togglebutton .toggle {
	margin-right: 0;
}
.fixed-plugin .adjustments-line .dropdown-menu > li.adjustments-line > a {
	padding-right: 0;
	padding-left: 0;
	border-bottom: 1px solid #ddd;
	border-radius: 0;
	margin: 0;
}
.fixed-plugin .dropdown-menu > li > a.img-holder {
	font-size: 16px;
	text-align: center;
	border-radius: 10px;
	background-color: #fff;
	border: 3px solid #fff;
	padding-left: 0;
	padding-right: 0;
	opacity: 1;
	cursor: pointer;
	display: block;
	max-height: 100px;
	overflow: hidden;
	padding: 0;
}
.fixed-plugin .dropdown-menu > li > a.img-holder img {
	margin-top: auto;
}
.fixed-plugin .dropdown-menu > li a.switch-trigger:hover,
.fixed-plugin .dropdown-menu > li > a.switch-trigger:focus {
	background-color: transparent;
}
.fixed-plugin .dropdown-menu > li:hover > a.img-holder,
.fixed-plugin .dropdown-menu > li:focus > a.img-holder {
	border-color: rgba(0, 187, 255, 0.53);
}
.fixed-plugin .dropdown-menu > .active > a.img-holder,
.fixed-plugin .dropdown-menu > .active > a.img-holder {
	border-color: #00bbff;
	background-color: #ffffff;
}
.fixed-plugin .btn-social {
	width: 50%;
	display: block;
	width: 48%;
	float: left;
	font-weight: 600;
}
.fixed-plugin .btn-social i {
	margin-right: 5px;
}
.fixed-plugin .btn-social:first-child {
	margin-right: 2%;
}
.fixed-plugin .dropdown .dropdown-menu {
	transform-origin: 0 0;
}
.fixed-plugin .dropdown .dropdown-menu:before {
	border-bottom: 16px solid rgba(0, 0, 0, 0);
	border-left: 16px solid rgba(0, 0, 0, 0.2);
	border-top: 16px solid rgba(0, 0, 0, 0);
	right: -27px;
	bottom: 425px;
}
.fixed-plugin .dropdown .dropdown-menu:after {
	border-bottom: 16px solid rgba(0, 0, 0, 0);
	border-left: 16px solid #ffffff;
	border-top: 16px solid rgba(0, 0, 0, 0);
	right: -26px;
	bottom: 425px;
}
.fixed-plugin .dropdown .dropdown-menu:before,
.fixed-plugin .dropdown .dropdown-menu:after {
	content: "";
	display: inline-block;
	position: absolute;
	width: 16px;
	transform: translateY(-50px);
	-webkit-transform: translateY(-50px);
	-moz-transform: translateY(-50px);
}
.fixed-plugin .dropdown.show-dropdown .show .dropdown-menu .show {
	transform: translate3d(0, -60px, 0) !important;
	bottom: auto !important;
	top: 0 !important;
}
.fixed-plugin .bootstrap-switch {
	margin: 0;
}

.fixed-plugin .show-dropdown .dropdown-menu[x-placement="bottom-start"] {
	transform: translate3d(0, -100px, 0) !important;
}
.fixed-plugin .show-dropdown .dropdown-menu[x-placement="bottom-start"]:before,
.fixed-plugin .show-dropdown .dropdown-menu[x-placement="bottom-start"]:after {
	top: 100px;
}
.fixed-plugin .show-dropdown .dropdown-menu[x-placement="top-start"] {
	transform: translate3d(0, 100px, 0) !important;
}
.fixed-plugin
	.show-dropdown.show
	.dropdown-menu.show[x-placement="bottom-start"] {
	transform: translate3d(0, -60px, 0) !important;
}
.fixed-plugin .show-dropdown.show .dropdown-menu.show[x-placement="top-start"] {
	transform: translate3d(0, 470px, 0) !important;
}

.form-group input[type="file"] {
	opacity: 1;
	position: static;
	position: initial;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	width: 100%;
	z-index: auto;
	z-index: initial;
}

.modal-footer .left-side,
.modal-footer .right-side {
	display: flex;
	flex: 1 1;
	text-align: center;
	width: auto;
	width: initial;
	padding: 5px;
}

.navbar .navbar-nav .nav-link i.fa + p,
.navbar .navbar-nav .nav-link i.nc-icon + p {
	margin-left: 7px;
}

/*--------------------------------

nucleo-icons Web Font - built using nucleoapp.com
License - nucleoapp.com/license/

-------------------------------- */
@font-face {
	font-family: "nucleo-icons";
	src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
	src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("embedded-opentype"),
		url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("woff2"),
		url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("woff"),
		url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("truetype");
	font-weight: normal;
	font-style: normal;
}
/* all icon font classes list here */
/*             Navigation Pills               */
.nav-pills .nav-item + .nav-link {
	margin-left: 0;
}
.nav-pills .nav-item.active .nav-link,
.nav-pills .nav-item.active .nav-link:hover,
.nav-pills .nav-item.active .nav-link:focus {
	background-color: #65adff;
	color: #ffffff;
}
.nav-pills.flex-column .nav-item .nav-link {
	border-radius: 30px !important;
	margin-bottom: 15px;
}
.nav-pills .nav-item .nav-link.active {
	background-color: #65adff;
	color: #ffffff;
}

.nav-pills-primary .nav-item .nav-link {
	border: 1px solid #1c77c3;
	color: #1c77c3;
}
.nav-pills-primary .nav-item .nav-link.active {
	border: 1px solid #1c77c3;
	background: #1c77c3;
	color: #ffffff;
}

.nav-pills-danger .nav-item .nav-link {
	border: 1px solid #c1292e;
	color: #c1292e;
}
.nav-pills-danger .nav-item .nav-link.active {
	border: 1px solid #c1292e;
	background: #c1292e;
	color: #ffffff;
}

.nav-pills-info .nav-item .nav-link {
	border: 1px solid #39a9db;
	color: #39a9db;
}
.nav-pills-info .nav-item .nav-link.active {
	border: 1px solid #39a9db;
	background: #39a9db;
	color: #ffffff;
}

.nav-pills-success .nav-item .nav-link {
	border: 1px solid #28a745;
	color: #28a745;
}
.nav-pills-success .nav-item .nav-link.active {
	border: 1px solid #28a745;
	background: #28a745;
	color: #ffffff;
}

.nav-pills-warning .nav-item .nav-link {
	border: 1px solid #ffc759;
	color: #ffc759;
}
.nav-pills-warning .nav-item .nav-link.active {
	border: 1px solid #ffc759;
	background: #ffc759;
	color: #ffffff;
}

.page-item:first-child .page-link,
.page-item:last-child .page-link {
	border-bottom-left-radius: 20px;
	border-top-left-radius: 20px;
	border-bottom-right-radius: 20px;
	border-top-right-radius: 20px;
}

.nav-pills-default .nav-item.show .nav-link,
.nav-pills-default .nav-link.active {
	background-color: #65adff !important;
}

.nav-pills-primary .nav-item.show .nav-link,
.nav-pills-primary .nav-link.active {
	background-color: #1c77c3 !important;
}

.nav-pills-info .nav-item.show .nav-link,
.nav-pills-info .nav-link.active {
	background-color: #39a9db !important;
}

.nav-pills-warning .nav-item.show .nav-link,
.nav-pills-warning .nav-link.active {
	background-color: #ffc759 !important;
}

.nav-pills-success .nav-item.show .nav-link,
.nav-pills-success .nav-link.active {
	background-color: #28a745 !important;
}

.nav-pills-danger .nav-item.show .nav-link,
.nav-pills-danger .nav-link.active {
	background-color: #c1292e !important;
}

@media screen and (max-width: 991px) {
	.navbar {
		padding: 0;
	}
	.navbar.navbar-absolute {
		padding-top: 0;
	}
	.navbar .navbar-brand {
		font-size: 16px;
		margin-right: 0;
	}

	.profile-photo .profile-photo-small {
		margin-left: -2px;
	}

	.button-dropdown {
		display: none;
	}

	#minimizeSidebar {
		display: none;
	}

	.navbar .container-fluid {
		padding-right: 15px;
		padding-left: 15px;
	}
	.navbar .navbar-collapse .input-group {
		margin: 0;
		margin-top: 5px;
	}
	.navbar .navbar-nav .nav-item:first-child {
		margin-top: 10px;
	}
	.navbar .navbar-nav .nav-item:not(:last-child) {
		margin-bottom: 10px;
	}
	.navbar .dropdown.show .dropdown-menu {
		display: block !important;
		transform: translate3d(0px, 0px, 0px) !important;
	}
	.navbar .dropdown .dropdown-menu {
		display: none;
	}
	.navbar .dropdown.show .dropdown-menu,
	.navbar .dropdown .dropdown-menu {
		border: 0;
		transition: none;
		-webkit-box-shadow: none;
		width: auto;
		margin: 0px 1rem;
		margin-top: 0px;
		box-shadow: none;
		position: static !important;
		padding-left: 10px;
	}
	.navbar .dropdown.show .dropdown-menu:before,
	.navbar .dropdown .dropdown-menu:before {
		display: none;
	}
	.navbar .dropdown-menu .dropdown-item:focus,
	.navbar .dropdown-menu .dropdown-item:hover {
		color: #ffffff;
	}
	.navbar.bg-white .dropdown-menu .dropdown-item:focus,
	.navbar.bg-white .dropdown-menu .dropdown-item:hover {
		color: #65adff;
	}
	.navbar .navbar-toggler-bar {
		display: block;
		position: relative;
		width: 22px;
		height: 1px;
		border-radius: 1px;
		background: #65adff;
	}
	.navbar .navbar-toggler-bar + .navbar-toggler-bar {
		margin-top: 7px;
	}
	.navbar .navbar-toggler-bar + .navbar-toggler-bar.navbar-kebab {
		margin-top: 3px;
	}
	.navbar .navbar-toggler-bar.bar2 {
		width: 17px;
		transition: width 0.2s linear;
	}
	.navbar.bg-white:not(.navbar-transparent) .navbar-toggler-bar {
		background-color: #65adff;
	}
	.navbar .toggled .navbar-toggler-bar {
		width: 24px;
	}
	.navbar .toggled .navbar-toggler-bar + .navbar-toggler-bar {
		margin-top: 5px;
	}

	.wrapper {
		transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);
	}

	.nav-open .main-panel {
		right: 0;
		transform: translate3d(260px, 0, 0);
	}
	.nav-open .sidebar {
		transform: translate3d(0px, 0, 0);
	}
	.nav-open body {
		position: relative;
		overflow-x: hidden;
	}
	.nav-open .menu-on-right .main-panel {
		transform: translate3d(-260px, 0, 0);
	}
	.nav-open .menu-on-right .navbar-collapse,
	.nav-open .menu-on-right .sidebar {
		transform: translate3d(0px, 0, 0);
	}
	.nav-open .menu-on-right .navbar-translate {
		transform: translate3d(-300px, 0, 0);
	}
	.nav-open .menu-on-right #bodyClick {
		left: auto;
	}

	.menu-on-right .sidebar {
		left: auto;
		right: 0;
		transform: translate3d(260px, 0, 0);
	}

	.bar1,
	.bar2,
	.bar3 {
		outline: 1px solid transparent;
	}

	.bar1 {
		top: 0px;
		animation: topbar-back 500ms 0s;
		animation-fill-mode: forwards;
	}

	.bar2 {
		opacity: 1;
	}

	.bar3 {
		bottom: 0px;
		animation: bottombar-back 500ms 0s;
		animation-fill-mode: forwards;
	}

	.toggled .bar1 {
		top: 6px;
		animation: topbar-x 500ms 0s;
		animation-fill-mode: forwards;
	}

	.toggled .bar2 {
		opacity: 0;
	}

	.toggled .bar3 {
		bottom: 6px;
		animation: bottombar-x 500ms 0s;
		animation-fill-mode: forwards;
	}

	@keyframes topbar-x {
		0% {
			top: 0px;
			transform: rotate(0deg);
		}
		45% {
			top: 6px;
			transform: rotate(145deg);
		}
		75% {
			transform: rotate(130deg);
		}
		100% {
			transform: rotate(135deg);
		}
	}
	@keyframes topbar-back {
		0% {
			top: 6px;
			transform: rotate(135deg);
		}
		45% {
			transform: rotate(-10deg);
		}
		75% {
			transform: rotate(5deg);
		}
		100% {
			top: 0px;
			transform: rotate(0);
		}
	}
	@keyframes bottombar-x {
		0% {
			bottom: 0px;
			transform: rotate(0deg);
		}
		45% {
			bottom: 6px;
			transform: rotate(-145deg);
		}
		75% {
			transform: rotate(-130deg);
		}
		100% {
			transform: rotate(-135deg);
		}
	}
	@keyframes bottombar-back {
		0% {
			bottom: 6px;
			transform: rotate(-135deg);
		}
		45% {
			transform: rotate(10deg);
		}
		75% {
			transform: rotate(-5deg);
		}
		100% {
			bottom: 0px;
			transform: rotate(0);
		}
	}
	@keyframes fadeIn {
		0% {
			opacity: 0;
		}
		100% {
			opacity: 1;
		}
	}
	#bodyClick {
		height: 100%;
		width: 100%;
		position: fixed;
		opacity: 1;
		top: 0;
		right: 0;
		content: "";
		z-index: 9999;
		overflow-x: hidden;
		background-color: transparent;
		transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);
	}

	.footer .copyright {
		text-align: right;
	}

	.section-nucleo-icons .icons-container {
		margin-top: 65px;
	}

	.navbar-nav .nav-link i.fa,
	.navbar-nav .nav-link i.nc-icon {
		opacity: 0.5;
	}

	.sidebar,
	.bootstrap-navbar {
		position: fixed;
		display: block;
		top: 0;
		height: 100%;
		width: 260px;
		right: auto;
		left: 0;
		z-index: 1032;
		visibility: visible;
		overflow-y: visible;
		padding: 0;
		transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);
		transform: translate3d(-260px, 0, 0);
	}

	.main-panel {
		width: 100%;
	}

	.timeline:before {
		left: 5% !important;
	}
	.timeline > li > .timeline-badge {
		left: 5% !important;
	}
	.timeline > li > .timeline-panel {
		float: right !important;
		width: 82% !important;
	}
	.timeline > li > .timeline-panel:before {
		border-left-width: 0 !important;
		border-right-width: 15px !important;
		left: -15px !important;
		right: auto !important;
	}
	.timeline > li > .timeline-panel:after {
		border-left-width: 0 !important;
		border-right-width: 14px !important;
		left: -14px !important;
		right: auto !important;
	}

	.fixed-plugin {
		width: 54px;
	}
	.fixed-plugin .dropdown-menu {
		max-width: 230px;
		right: 80px;
	}
}
@media (max-width: 991px) and (min-width: 768px) {
	.nav-tabs-navigation.verical-navs {
		padding: 0px 2px;
	}
}
@media screen and (min-width: 768px) {
	.footer .footer-nav {
		padding-left: 21px;
	}
	.footer .credits {
		padding-right: 15px;
	}
}
@media screen and (min-width: 992px) {
	.navbar-collapse {
		background: none !important;
	}

	.navbar .navbar-toggle {
		display: none;
	}

	.navbar-nav .nav-link.profile-photo {
		padding: 0;
		margin: 7px 0.7rem;
	}

	.section-nucleo-icons .icons-container {
		margin: 0 0 0 auto;
	}

	.dropdown-menu .dropdown-item {
		color: inherit;
	}

	.footer .copyright {
		float: right;
		padding-right: 15px;
	}

	.sidebar
		.sidebar-wrapper
		li
		> [data-toggle="collapse"]
		+ div
		.nav
		li.active
		a:before {
		top: -2px;
	}
	.sidebar
		.sidebar-wrapper
		li
		> [data-toggle="collapse"]
		+ div
		.nav
		li.active
		a:after {
		top: -1px;
	}
	.sidebar
		.sidebar-wrapper
		li.active
		> [data-toggle="collapse"]
		+ div
		.nav
		li:before,
	.sidebar
		.sidebar-wrapper
		li.active
		> [data-toggle="collapse"]
		+ div
		.nav
		li:after {
		display: none !important;
	}
	.sidebar .sidebar-wrapper li.active > a:not([data-toggle="collapse"]):before {
		border-right: 18px solid #dddddd;
		border-top: 18px solid transparent;
		border-bottom: 18px solid transparent;
		content: "";
		display: inline-block;
		position: absolute;
		right: -15px;
		opacity: 1;
		top: 6px;
		transition: opacity 150ms ease-in;
	}
	.sidebar .sidebar-wrapper li.active > a:not([data-toggle="collapse"]):after {
		border-right: 17px solid #f4f3ef;
		border-top: 17px solid transparent;
		border-bottom: 17px solid transparent;
		content: "";
		display: inline-block;
		position: absolute;
		right: -15px;
		opacity: 1;
		top: 7px;
		transition: opacity 150ms ease-in;
	}
}
@media screen and (max-width: 768px) {
	.card-stats [class*="col-"] .statistics::after {
		display: none;
	}

	.main-panel .content {
		padding-left: 15px;
		padding-right: 15px;
	}

	.footer nav {
		display: block;
		margin-bottom: 5px;
		float: none;
	}

	.landing-page .section-story-overview .image-container:nth-child(2) {
		margin-left: 0;
		margin-bottom: 30px;
	}

	.card .form-horizontal .col-md-3.col-form-label {
		text-align: left;
	}
}
@media screen and (max-width: 767px) {
	.typography-line {
		padding-left: 23% !important;
	}
	.typography-line span {
		width: 60px !important;
	}

	.login-page .navbar,
	.lock-page .navbar,
	.register-page .navbar {
		padding: 0.5rem 1rem;
	}

	.footer .footer-nav,
	.footer .credits {
		margin: 0 auto !important;
	}
	.footer .footer-nav {
		margin-bottom: 10px !important;
	}

	.register-page .content {
		padding-top: 5vh;
	}
	.register-page .footer {
		position: relative;
	}
	.register-page .info-area.info-horizontal {
		margin-top: 0;
	}
}
@media screen and (max-width: 413px) {
	.fixed-plugin .dropdown.show-dropdown.show .dropdown-menu.show {
		width: 225px !important;
	}
	.fixed-plugin
		.dropdown.show-dropdown.show
		.dropdown-menu.show[x-placement="top-start"] {
		transform: translate3d(0, 400px, 0) !important;
	}
	.fixed-plugin .dropdown.show-dropdown.show .dropdown-menu.show:before,
	.fixed-plugin .dropdown.show-dropdown.show .dropdown-menu.show:after {
		bottom: 360px !important;
	}
}
@media screen and (max-width: 576px) {
	.navbar[class*="navbar-toggleable-"] .container {
		margin-left: 0;
		margin-right: 0;
	}

	.card-contributions .card-stats {
		flex-direction: column;
	}
	.card-contributions .card-stats .bootstrap-switch {
		margin-bottom: 15px;
	}

	.footer .copyright {
		text-align: center;
	}

	.section-nucleo-icons .icons-container i {
		font-size: 30px;
	}
	.section-nucleo-icons .icons-container i:nth-child(6) {
		font-size: 48px;
	}

	.page-header .container h6.category-absolute {
		width: 90%;
	}

	.card-timeline .timeline .timeline-panel {
		width: 38%;
		padding: 15px;
	}
}
.wrapper {
	position: relative;
	top: 0;
	height: 100vh;
	overflow-x: hidden;
}
.wrapper.wrapper-full-page {
	min-height: 100vh;
	height: auto;
}

.sidebar,
.off-canvas-sidebar {
	position: fixed;
	top: 0;
	height: 100%;
	bottom: 0;
	width: 260px;
	left: 0;
	z-index: 999;
}
.sidebar .sidebar-wrapper,
.off-canvas-sidebar .sidebar-wrapper {
	position: relative;
	height: calc(100vh - 75px);
	overflow: auto;
	width: 260px;
	z-index: 4;
	padding-bottom: 100px;
}
.sidebar .sidebar-wrapper .dropdown .dropdown-backdrop,
.off-canvas-sidebar .sidebar-wrapper .dropdown .dropdown-backdrop {
	display: none !important;
}
.sidebar .sidebar-wrapper .navbar-form,
.off-canvas-sidebar .sidebar-wrapper .navbar-form {
	border: none;
}
.sidebar
	.sidebar-wrapper
	> .nav
	[data-toggle="collapse"]
	~ div
	> ul
	> li
	> a
	span,
.sidebar
	.sidebar-wrapper
	.user
	.info
	[data-toggle="collapse"]
	~ div
	> ul
	> li
	> a
	span,
.off-canvas-sidebar
	.sidebar-wrapper
	> .nav
	[data-toggle="collapse"]
	~ div
	> ul
	> li
	> a
	span,
.off-canvas-sidebar
	.sidebar-wrapper
	.user
	.info
	[data-toggle="collapse"]
	~ div
	> ul
	> li
	> a
	span {
	display: inline-block;
}
.sidebar
	.sidebar-wrapper
	> .nav
	[data-toggle="collapse"]
	~ div
	> ul
	> li
	> a
	.sidebar-normal,
.sidebar
	.sidebar-wrapper
	.user
	.info
	[data-toggle="collapse"]
	~ div
	> ul
	> li
	> a
	.sidebar-normal,
.off-canvas-sidebar
	.sidebar-wrapper
	> .nav
	[data-toggle="collapse"]
	~ div
	> ul
	> li
	> a
	.sidebar-normal,
.off-canvas-sidebar
	.sidebar-wrapper
	.user
	.info
	[data-toggle="collapse"]
	~ div
	> ul
	> li
	> a
	.sidebar-normal {
	margin: 0;
	position: relative;
	transform: translateX(0px);
	opacity: 1;
	white-space: nowrap;
	display: block;
	line-height: 20px;
	z-index: 1;
}
.sidebar
	.sidebar-wrapper
	> .nav
	[data-toggle="collapse"]
	~ div
	> ul
	> li
	> a
	.sidebar-mini-icon,
.sidebar
	.sidebar-wrapper
	.user
	.info
	[data-toggle="collapse"]
	~ div
	> ul
	> li
	> a
	.sidebar-mini-icon,
.off-canvas-sidebar
	.sidebar-wrapper
	> .nav
	[data-toggle="collapse"]
	~ div
	> ul
	> li
	> a
	.sidebar-mini-icon,
.off-canvas-sidebar
	.sidebar-wrapper
	.user
	.info
	[data-toggle="collapse"]
	~ div
	> ul
	> li
	> a
	.sidebar-mini-icon {
	text-transform: uppercase;
	width: 34px;
	margin-right: 10px;
	margin-left: 0px;
	font-size: 12px;
	text-align: center;
	line-height: 20px;
	position: relative;
	float: left;
	z-index: 1;
	display: inherit;
	color: rgba(255, 255, 255, 0.5);
}
.sidebar
	.sidebar-wrapper
	> .nav
	[data-toggle="collapse"]
	~ div
	> ul
	> li
	> a
	.sidebar-normal,
.sidebar
	.sidebar-wrapper
	.user
	.info
	[data-toggle="collapse"]
	~ div
	> ul
	> li
	> a
	.sidebar-normal,
.off-canvas-sidebar
	.sidebar-wrapper
	> .nav
	[data-toggle="collapse"]
	~ div
	> ul
	> li
	> a
	.sidebar-normal,
.off-canvas-sidebar
	.sidebar-wrapper
	.user
	.info
	[data-toggle="collapse"]
	~ div
	> ul
	> li
	> a
	.sidebar-normal {
	text-transform: capitalize;
}
.sidebar .sidebar-wrapper > .nav [data-toggle="collapse"] ~ div > ul > li > a i,
.sidebar
	.sidebar-wrapper
	.user
	.info
	[data-toggle="collapse"]
	~ div
	> ul
	> li
	> a
	i,
.off-canvas-sidebar
	.sidebar-wrapper
	> .nav
	[data-toggle="collapse"]
	~ div
	> ul
	> li
	> a
	i,
.off-canvas-sidebar
	.sidebar-wrapper
	.user
	.info
	[data-toggle="collapse"]
	~ div
	> ul
	> li
	> a
	i {
	font-size: 17px;
	line-height: 20px;
	width: 26px;
}
.sidebar .navbar-minimize,
.off-canvas-sidebar .navbar-minimize {
	position: absolute;
	right: 20px;
	top: 2px;
	opacity: 1;
}
.sidebar .logo-tim,
.off-canvas-sidebar .logo-tim {
	border-radius: 50%;
	border: 1px solid #333;
	display: block;
	height: 61px;
	width: 61px;
	float: left;
	overflow: hidden;
}
.sidebar .logo-tim img,
.off-canvas-sidebar .logo-tim img {
	width: 60px;
	height: 60px;
}
.sidebar .nav,
.off-canvas-sidebar .nav {
	margin-top: 20px;
	display: block;
}
.sidebar .nav .caret,
.off-canvas-sidebar .nav .caret {
	top: 14px;
	position: absolute;
	right: 10px;
}
.sidebar .nav li > a + div .nav li > a,
.off-canvas-sidebar .nav li > a + div .nav li > a {
	margin-top: 7px;
}
.sidebar .nav li > a,
.off-canvas-sidebar .nav li > a {
	margin: 10px 15px 0;
	color: #ffffff;
	display: block;
	text-decoration: none;
	position: relative;
	text-transform: uppercase;
	cursor: pointer;
	font-size: 12px;
	padding: 10px 8px;
	line-height: 30px;
	opacity: 0.7;
}
.sidebar .nav li .nav > li > a,
.off-canvas-sidebar .nav li .nav > li > a {
	padding: 5px 8px;
}
.sidebar .nav li.active > a,
.sidebar .nav li.active > a > i,
.off-canvas-sidebar .nav li.active > a,
.off-canvas-sidebar .nav li.active > a > i {
	opacity: 1;
}
.sidebar .nav li:hover:not(.active) > a,
.sidebar .nav li:focus:not(.active) > a,
.off-canvas-sidebar .nav li:hover:not(.active) > a,
.off-canvas-sidebar .nav li:focus:not(.active) > a {
	opacity: 1;
}
.sidebar .nav li.active > a[data-toggle="collapse"] >,
.off-canvas-sidebar .nav li.active > a[data-toggle="collapse"] > {
	background-color: transparent;
	box-shadow: 0 2px 2px rgba(204, 197, 185, 0.5);
}
.sidebar .nav li.active > a[data-toggle="collapse"],
.sidebar .nav li.active > a[data-toggle="collapse"] i,
.sidebar .nav li.active > a[data-toggle="collapse"] ~ div > ul > li.active i,
.sidebar .nav li.active > a[data-toggle="collapse"] ~ div > ul > li.active > a,
.off-canvas-sidebar .nav li.active > a[data-toggle="collapse"],
.off-canvas-sidebar .nav li.active > a[data-toggle="collapse"] i,
.off-canvas-sidebar
	.nav
	li.active
	> a[data-toggle="collapse"]
	~ div
	> ul
	> li.active
	i,
.off-canvas-sidebar
	.nav
	li.active
	> a[data-toggle="collapse"]
	~ div
	> ul
	> li.active
	> a {
	color: #c1292e;
}
.sidebar .nav li.active > a[data-toggle="collapse"] + div .nav .active a,
.sidebar .nav li.active > a[data-toggle="collapse"] i + div .nav .active a,
.sidebar
	.nav
	li.active
	> a[data-toggle="collapse"]
	~ div
	> ul
	> li.active
	i
	+ div
	.nav
	.active
	a,
.sidebar
	.nav
	li.active
	> a[data-toggle="collapse"]
	~ div
	> ul
	> li.active
	> a
	+ div
	.nav
	.active
	a,
.off-canvas-sidebar
	.nav
	li.active
	> a[data-toggle="collapse"]
	+ div
	.nav
	.active
	a,
.off-canvas-sidebar
	.nav
	li.active
	> a[data-toggle="collapse"]
	i
	+ div
	.nav
	.active
	a,
.off-canvas-sidebar
	.nav
	li.active
	> a[data-toggle="collapse"]
	~ div
	> ul
	> li.active
	i
	+ div
	.nav
	.active
	a,
.off-canvas-sidebar
	.nav
	li.active
	> a[data-toggle="collapse"]
	~ div
	> ul
	> li.active
	> a
	+ div
	.nav
	.active
	a {
	background-color: transparent;
	box-shadow: none;
}
.sidebar .nav li.active > a[data-toggle="collapse"] + div .nav .active a:after,
.sidebar
	.nav
	li.active
	> a[data-toggle="collapse"]
	i
	+ div
	.nav
	.active
	a:after,
.sidebar
	.nav
	li.active
	> a[data-toggle="collapse"]
	~ div
	> ul
	> li.active
	i
	+ div
	.nav
	.active
	a:after,
.sidebar
	.nav
	li.active
	> a[data-toggle="collapse"]
	~ div
	> ul
	> li.active
	> a
	+ div
	.nav
	.active
	a:after,
.off-canvas-sidebar
	.nav
	li.active
	> a[data-toggle="collapse"]
	+ div
	.nav
	.active
	a:after,
.off-canvas-sidebar
	.nav
	li.active
	> a[data-toggle="collapse"]
	i
	+ div
	.nav
	.active
	a:after,
.off-canvas-sidebar
	.nav
	li.active
	> a[data-toggle="collapse"]
	~ div
	> ul
	> li.active
	i
	+ div
	.nav
	.active
	a:after,
.off-canvas-sidebar
	.nav
	li.active
	> a[data-toggle="collapse"]
	~ div
	> ul
	> li.active
	> a
	+ div
	.nav
	.active
	a:after {
	content: "";
	position: absolute;
	width: calc(100% - 5px);
	z-index: 0;
}
.sidebar .nav li.active > a[data-toggle="collapse"] ~ div > .nav,
.off-canvas-sidebar .nav li.active > a[data-toggle="collapse"] ~ div > .nav {
	margin-top: 0;
}
.sidebar .nav p,
.off-canvas-sidebar .nav p {
	margin: 0;
	line-height: 30px;
	position: relative;
	display: block;
	height: auto;
	white-space: nowrap;
	font-weight: 600;
}
.sidebar .nav i,
.off-canvas-sidebar .nav i {
	font-size: 24px;
	float: left;
	margin-right: 12px;
	line-height: 30px;
	width: 34px;
	text-align: center;
	color: rgba(255, 255, 255, 0.5);
	position: relative;
}
.sidebar .sidebar-background,
.off-canvas-sidebar .sidebar-background {
	position: absolute;
	z-index: 1;
	height: 100%;
	width: 100%;
	display: block;
	top: 0;
	left: 0;
	background-size: cover;
	background-position: center center;
}
.sidebar .sidebar-background:after,
.off-canvas-sidebar .sidebar-background:after {
	position: absolute;
	z-index: 3;
	width: 100%;
	height: 100%;
	content: "";
	display: block;
	background: #ffffff;
	opacity: 1;
}
.sidebar .logo,
.off-canvas-sidebar .logo {
	position: relative;
	padding: 7px 0.7rem;
	z-index: 4;
}
.sidebar .logo a.logo-mini,
.off-canvas-sidebar .logo a.logo-mini {
	opacity: 0;
	float: left;
	width: 50px;
	text-align: center;
	margin-left: 12px;
	margin-right: 12px;
}
.sidebar .logo a.logo-normal,
.off-canvas-sidebar .logo a.logo-normal {
	display: block;
	opacity: 1;
	padding: 11px 0 8px;
	transform: translate3d(0px, 0, 0);
}
.sidebar .logo:after,
.off-canvas-sidebar .logo:after {
	content: "";
	position: absolute;
	bottom: 0;
	right: 15px;
	height: 1px;
	width: calc(100% - 30px);
	background-color: rgba(255, 255, 255, 0.5);
}
.sidebar .logo p,
.off-canvas-sidebar .logo p {
	float: left;
	font-size: 20px;
	margin: 10px 10px;
	color: #ffffff;
	line-height: 20px;
	font-family: "Muli", "Helvetica", Arial, sans-serif;
}
.sidebar .logo .simple-text,
.off-canvas-sidebar .logo .simple-text {
	text-transform: uppercase;
	padding: 0.5rem 0;
	display: block;
	white-space: nowrap;
	font-size: 1rem;
	color: #ffffff;
	text-decoration: none;
	font-weight: 400;
	line-height: 30px;
	overflow: hidden;
}
.sidebar .logo-tim,
.off-canvas-sidebar .logo-tim {
	border-radius: 50%;
	border: 1px solid #333;
	display: block;
	height: 61px;
	width: 61px;
	float: left;
	overflow: hidden;
}
.sidebar .logo-tim img,
.off-canvas-sidebar .logo-tim img {
	width: 60px;
	height: 60px;
}
.sidebar:before,
.sidebar:after,
.off-canvas-sidebar:before,
.off-canvas-sidebar:after {
	display: block;
	content: "";
	opacity: 1;
	position: absolute;
	width: 100%;
	height: 100%;
	top: 0;
	left: 0;
}
.sidebar:after,
.off-canvas-sidebar:after {
	background: #65adff;
	background: linear-gradient(#65adff 0%, #000 80%);
	z-index: 3;
}
.sidebar[data-color="white"]:after,
.off-canvas-sidebar[data-color="white"]:after {
	background: #ffffff;
}
.sidebar[data-color="white"] .nav li a,
.sidebar[data-color="white"] .nav li a i,
.sidebar[data-color="white"] .nav li a[data-toggle="collapse"],
.sidebar[data-color="white"] .nav li a[data-toggle="collapse"] i,
.sidebar[data-color="white"]
	.nav
	li
	a[data-toggle="collapse"]
	~ div
	> ul
	> li
	.sidebar-mini-icon,
.sidebar[data-color="white"]
	.nav
	li
	a[data-toggle="collapse"]
	~ div
	> ul
	> li
	> a,
.off-canvas-sidebar[data-color="white"] .nav li a,
.off-canvas-sidebar[data-color="white"] .nav li a i,
.off-canvas-sidebar[data-color="white"] .nav li a[data-toggle="collapse"],
.off-canvas-sidebar[data-color="white"] .nav li a[data-toggle="collapse"] i,
.off-canvas-sidebar[data-color="white"]
	.nav
	li
	a[data-toggle="collapse"]
	~ div
	> ul
	> li
	.sidebar-mini-icon,
.off-canvas-sidebar[data-color="white"]
	.nav
	li
	a[data-toggle="collapse"]
	~ div
	> ul
	> li
	> a {
	color: #65adff;
	opacity: 0.7;
}
.sidebar[data-color="white"] .nav li:hover:not(.active) > a,
.sidebar[data-color="white"] .nav li:focus:not(.active) > a,
.off-canvas-sidebar[data-color="white"] .nav li:hover:not(.active) > a,
.off-canvas-sidebar[data-color="white"] .nav li:focus:not(.active) > a {
	opacity: 1;
}
.sidebar[data-color="white"] .logo .simple-text,
.off-canvas-sidebar[data-color="white"] .logo .simple-text {
	color: #65adff;
}
.sidebar[data-color="white"] .logo:after,
.off-canvas-sidebar[data-color="white"] .logo:after {
	background-color: #65adff;
	opacity: 0.4;
}
.sidebar[data-color="white"] .user .info a span,
.sidebar[data-color="white"] .user .nav .sidebar-mini-icon,
.sidebar[data-color="white"] .user .nav .sidebar-normal,
.off-canvas-sidebar[data-color="white"] .user .info a span,
.off-canvas-sidebar[data-color="white"] .user .nav .sidebar-mini-icon,
.off-canvas-sidebar[data-color="white"] .user .nav .sidebar-normal {
	color: #65adff !important;
}
.sidebar[data-color="white"] .user:after,
.off-canvas-sidebar[data-color="white"] .user:after {
	background-color: #65adff;
	opacity: 0.4;
}
.sidebar[data-color="brown"]:after,
.off-canvas-sidebar[data-color="brown"]:after {
	background: #65adff;
}
.sidebar[data-active-color="primary"] .nav li.active > a,
.sidebar[data-active-color="primary"] .nav li.active > a i,
.sidebar[data-active-color="primary"]
	.nav
	li.active
	> a[data-toggle="collapse"],
.sidebar[data-active-color="primary"]
	.nav
	li.active
	> a[data-toggle="collapse"]
	i,
.sidebar[data-active-color="primary"]
	.nav
	li.active
	> a[data-toggle="collapse"]
	~ div
	> ul
	> li.active
	.sidebar-mini-icon,
.sidebar[data-active-color="primary"]
	.nav
	li.active
	> a[data-toggle="collapse"]
	~ div
	> ul
	> li.active
	> a,
.off-canvas-sidebar[data-active-color="primary"] .nav li.active > a,
.off-canvas-sidebar[data-active-color="primary"] .nav li.active > a i,
.off-canvas-sidebar[data-active-color="primary"]
	.nav
	li.active
	> a[data-toggle="collapse"],
.off-canvas-sidebar[data-active-color="primary"]
	.nav
	li.active
	> a[data-toggle="collapse"]
	i,
.off-canvas-sidebar[data-active-color="primary"]
	.nav
	li.active
	> a[data-toggle="collapse"]
	~ div
	> ul
	> li.active
	.sidebar-mini-icon,
.off-canvas-sidebar[data-active-color="primary"]
	.nav
	li.active
	> a[data-toggle="collapse"]
	~ div
	> ul
	> li.active
	> a {
	color: #1c77c3;
	opacity: 1;
}
.sidebar[data-active-color="info"] .nav li.active > a,
.sidebar[data-active-color="info"] .nav li.active > a i,
.sidebar[data-active-color="info"] .nav li.active > a[data-toggle="collapse"],
.sidebar[data-active-color="info"] .nav li.active > a[data-toggle="collapse"] i,
.sidebar[data-active-color="info"]
	.nav
	li.active
	> a[data-toggle="collapse"]
	~ div
	> ul
	> li.active
	.sidebar-mini-icon,
.sidebar[data-active-color="info"]
	.nav
	li.active
	> a[data-toggle="collapse"]
	~ div
	> ul
	> li.active
	> a,
.off-canvas-sidebar[data-active-color="info"] .nav li.active > a,
.off-canvas-sidebar[data-active-color="info"] .nav li.active > a i,
.off-canvas-sidebar[data-active-color="info"]
	.nav
	li.active
	> a[data-toggle="collapse"],
.off-canvas-sidebar[data-active-color="info"]
	.nav
	li.active
	> a[data-toggle="collapse"]
	i,
.off-canvas-sidebar[data-active-color="info"]
	.nav
	li.active
	> a[data-toggle="collapse"]
	~ div
	> ul
	> li.active
	.sidebar-mini-icon,
.off-canvas-sidebar[data-active-color="info"]
	.nav
	li.active
	> a[data-toggle="collapse"]
	~ div
	> ul
	> li.active
	> a {
	color: #39a9db;
	opacity: 1;
}
.sidebar[data-active-color="success"] .nav li.active > a,
.sidebar[data-active-color="success"] .nav li.active > a i,
.sidebar[data-active-color="success"]
	.nav
	li.active
	> a[data-toggle="collapse"],
.sidebar[data-active-color="success"]
	.nav
	li.active
	> a[data-toggle="collapse"]
	i,
.sidebar[data-active-color="success"]
	.nav
	li.active
	> a[data-toggle="collapse"]
	~ div
	> ul
	> li.active
	.sidebar-mini-icon,
.sidebar[data-active-color="success"]
	.nav
	li.active
	> a[data-toggle="collapse"]
	~ div
	> ul
	> li.active
	> a,
.off-canvas-sidebar[data-active-color="success"] .nav li.active > a,
.off-canvas-sidebar[data-active-color="success"] .nav li.active > a i,
.off-canvas-sidebar[data-active-color="success"]
	.nav
	li.active
	> a[data-toggle="collapse"],
.off-canvas-sidebar[data-active-color="success"]
	.nav
	li.active
	> a[data-toggle="collapse"]
	i,
.off-canvas-sidebar[data-active-color="success"]
	.nav
	li.active
	> a[data-toggle="collapse"]
	~ div
	> ul
	> li.active
	.sidebar-mini-icon,
.off-canvas-sidebar[data-active-color="success"]
	.nav
	li.active
	> a[data-toggle="collapse"]
	~ div
	> ul
	> li.active
	> a {
	color: #28a745;
	opacity: 1;
}
.sidebar[data-active-color="warning"] .nav li.active > a,
.sidebar[data-active-color="warning"] .nav li.active > a i,
.sidebar[data-active-color="warning"]
	.nav
	li.active
	> a[data-toggle="collapse"],
.sidebar[data-active-color="warning"]
	.nav
	li.active
	> a[data-toggle="collapse"]
	i,
.sidebar[data-active-color="warning"]
	.nav
	li.active
	> a[data-toggle="collapse"]
	~ div
	> ul
	> li.active
	.sidebar-mini-icon,
.sidebar[data-active-color="warning"]
	.nav
	li.active
	> a[data-toggle="collapse"]
	~ div
	> ul
	> li.active
	> a,
.off-canvas-sidebar[data-active-color="warning"] .nav li.active > a,
.off-canvas-sidebar[data-active-color="warning"] .nav li.active > a i,
.off-canvas-sidebar[data-active-color="warning"]
	.nav
	li.active
	> a[data-toggle="collapse"],
.off-canvas-sidebar[data-active-color="warning"]
	.nav
	li.active
	> a[data-toggle="collapse"]
	i,
.off-canvas-sidebar[data-active-color="warning"]
	.nav
	li.active
	> a[data-toggle="collapse"]
	~ div
	> ul
	> li.active
	.sidebar-mini-icon,
.off-canvas-sidebar[data-active-color="warning"]
	.nav
	li.active
	> a[data-toggle="collapse"]
	~ div
	> ul
	> li.active
	> a {
	color: #ffc759;
	opacity: 1;
}
.sidebar[data-active-color="danger"] .nav li.active > a,
.sidebar[data-active-color="danger"] .nav li.active > a i,
.sidebar[data-active-color="danger"] .nav li.active > a[data-toggle="collapse"],
.sidebar[data-active-color="danger"]
	.nav
	li.active
	> a[data-toggle="collapse"]
	i,
.sidebar[data-active-color="danger"]
	.nav
	li.active
	> a[data-toggle="collapse"]
	~ div
	> ul
	> li.active
	.sidebar-mini-icon,
.sidebar[data-active-color="danger"]
	.nav
	li.active
	> a[data-toggle="collapse"]
	~ div
	> ul
	> li.active
	> a,
.off-canvas-sidebar[data-active-color="danger"] .nav li.active > a,
.off-canvas-sidebar[data-active-color="danger"] .nav li.active > a i,
.off-canvas-sidebar[data-active-color="danger"]
	.nav
	li.active
	> a[data-toggle="collapse"],
.off-canvas-sidebar[data-active-color="danger"]
	.nav
	li.active
	> a[data-toggle="collapse"]
	i,
.off-canvas-sidebar[data-active-color="danger"]
	.nav
	li.active
	> a[data-toggle="collapse"]
	~ div
	> ul
	> li.active
	.sidebar-mini-icon,
.off-canvas-sidebar[data-active-color="danger"]
	.nav
	li.active
	> a[data-toggle="collapse"]
	~ div
	> ul
	> li.active
	> a {
	color: #c1292e;
	opacity: 1;
}
.sidebar .user,
.off-canvas-sidebar .user {
	padding-bottom: 20px;
	margin: 20px auto 0;
	position: relative;
}
.sidebar .user:after,
.off-canvas-sidebar .user:after {
	content: "";
	position: absolute;
	bottom: 0;
	right: 15px;
	height: 1px;
	width: calc(100% - 30px);
	background-color: rgba(255, 255, 255, 0.3);
}
.sidebar .user .photo,
.off-canvas-sidebar .user .photo {
	width: 34px;
	height: 34px;
	overflow: hidden;
	float: left;
	z-index: 5;
	margin-right: 12px;
	border-radius: 50%;
	margin-left: 23px;
}
.sidebar .user .photo img,
.off-canvas-sidebar .user .photo img {
	width: 100%;
}
.sidebar .user a,
.off-canvas-sidebar .user a {
	color: #ffffff;
	text-decoration: none;
	padding: 0.5rem 15px;
	white-space: nowrap;
}
.sidebar .user .info > a,
.off-canvas-sidebar .user .info > a {
	display: block;
	line-height: 18px;
}
.sidebar .user .info > a > span,
.off-canvas-sidebar .user .info > a > span {
	display: block;
	position: relative;
	opacity: 1;
}
.sidebar .user .info .caret,
.off-canvas-sidebar .user .info .caret {
	position: absolute;
	top: 8px;
	right: 18px;
}

.visible-on-sidebar-regular {
	display: inline-block !important;
}

.visible-on-sidebar-mini {
	display: none !important;
}

.off-canvas-sidebar .nav > li > a,
.off-canvas-sidebar .nav > li > a:hover {
	color: #ffffff;
}
.off-canvas-sidebar .nav > li > a:focus {
	background: rgba(200, 200, 200, 0.2);
}

.main-panel {
	position: relative;
	float: right;
	background-color: #f7f7f7;
	transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);
}
.main-panel > .content {
	padding: 0 30px 30px;
	min-height: calc(100vh - 123px);
	margin-top: 93px;
}
.main-panel > .map-content {
	min-height: calc(100vh - 123px);
	margin-top: 63px;
}
.main-panel > .navbar {
	margin-bottom: 0;
}
.main-panel .header {
	margin-bottom: 50px;
}

.perfect-scrollbar-on .sidebar,
.perfect-scrollbar-on .main-panel {
	height: 100%;
	max-height: 100%;
}

@media (min-width: 991px) {
	.sidebar,
	.main-panel,
	.sidebar-wrapper {
		transition-property: top, bottom, width;
		transition-duration: 0.2s, 0.2s, 0.35s;
		transition-timing-function: linear, linear, ease;
		-webkit-overflow-scrolling: touch;
	}

	.sidebar-mini .visible-on-sidebar-regular {
		display: none !important;
	}
	.sidebar-mini .visible-on-sidebar-mini {
		display: inline-block !important;
	}
	.sidebar-mini .sidebar,
	.sidebar-mini .sidebar .sidebar-wrapper {
		width: 80px;
	}
	.sidebar-mini .main-panel {
		width: calc(100% - 80px);
	}
	.sidebar-mini .sidebar {
		display: block;
		z-index: 1030;
	}
	.sidebar-mini .sidebar .logo a.logo-normal {
		opacity: 0;
		transform: translate3d(-25px, 0, 0);
	}
	.sidebar-mini .sidebar .logo a.logo-mini {
		opacity: 1;
	}
	.sidebar-mini
		.sidebar
		.sidebar-wrapper
		> .nav
		[data-toggle="collapse"]
		~ div
		> ul
		> li
		> a
		.sidebar-normal,
	.sidebar-mini
		.sidebar
		.sidebar-wrapper
		.user
		.info
		[data-toggle="collapse"]
		~ div
		> ul
		> li
		> a
		.sidebar-normal,
	.sidebar-mini .sidebar .sidebar-wrapper .user .info > a > span,
	.sidebar-mini .sidebar .sidebar-wrapper > .nav li > a p {
		transform: translate3d(-25px, 0, 0);
		opacity: 0;
	}
	.sidebar-mini .sidebar:hover {
		width: 260px;
	}
	.sidebar-mini .sidebar:hover .logo a.logo-normal {
		opacity: 1;
		transform: translate3d(0, 0, 0);
	}
	.sidebar-mini .sidebar:hover .navbar-minimize {
		opacity: 1;
	}
	.sidebar-mini .sidebar:hover .sidebar-wrapper {
		width: 260px;
	}
	.sidebar-mini .sidebar:hover .sidebar-wrapper > .nav li > a p,
	.sidebar-mini
		.sidebar:hover
		.sidebar-wrapper
		> .nav
		[data-toggle="collapse"]
		~ div
		> ul
		> li
		> a
		.sidebar-normal,
	.sidebar-mini
		.sidebar:hover
		.sidebar-wrapper
		.user
		.info
		[data-toggle="collapse"]
		~ div
		> ul
		> li
		> a
		.sidebar-normal,
	.sidebar-mini .sidebar:hover .sidebar-wrapper .user .info > a > span {
		transform: translate3d(0px, 0, 0);
		opacity: 1;
	}
}
.panel-header {
	height: 260px;
	padding-top: 80px;
	padding-bottom: 45px;
	background: #141e30;
	/* fallback for old browsers */
	background: linear-gradient(to right, #0c2646 0%, #204065 60%, #2a5788 100%);
	position: relative;
	overflow: hidden;
}
.panel-header .header .title {
	color: #ffffff;
}
.panel-header .header .category {
	max-width: 600px;
	color: rgba(255, 255, 255, 0.5);
	margin: 0 auto;
	font-size: 13px;
}
.panel-header .header .category a {
	color: #ffffff;
}

.panel-header-sm {
	height: 135px;
}

.panel-header-lg {
	height: 380px;
}

.sidebar .logo .simple-text .logo-img {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	height: 34px;
	width: 34px;
	background: #ffffff;
	border-radius: 50%;
	text-align: center;
	overflow: hidden;
}
.sidebar .logo .simple-text .logo-img img {
	width: 51%;
	vertical-align: baseline;
	vertical-align: initial;
	height: 51%;
}

.sidebar[data-color="white"] {
	border-right: 1px solid #ddd;
}

/*             Navigation Tabs                 */
.nav-tabs-navigation {
	text-align: center;
	border-bottom: 1px solid #f1eae0;
	margin-bottom: 30px;
}
.nav-tabs-navigation .nav > .nav-item > .nav-link {
	padding-bottom: 20px;
}

.nav-tabs-wrapper {
	display: inline-block;
	margin-bottom: -6px;
	position: relative;
	width: 100%;
	margin-left: auto;
	margin-right: auto;
}

.nav-tabs {
	justify-content: center;
	border-bottom: 0 none;
	font-size: 14px;
	font-weight: 400;
}
.nav-tabs .nav-item .nav-link {
	border: 0 none;
	color: #a49e93;
	background-color: transparent;
}
.nav-tabs .nav-item .nav-link:hover {
	color: #292929 !important;
}
.nav-tabs .nav-item .nav-link.active {
	color: #292929 !important;
}
.nav-tabs .nav-item {
	color: #292929 !important;
	position: relative;
}
.nav-tabs .nav-item .nav-link.active,
.nav-tabs .nav-item .nav-link.active:hover,
.nav-tabs .nav-item .nav-link.active:focus {
	background-color: transparent;
	border: 0 none;
}
.nav-tabs .nav-item .nav-link.active:after,
.nav-tabs .nav-item .nav-link.active:hover:after,
.nav-tabs .nav-item .nav-link.active:focus:after {
	border-bottom: 11px solid #ffffff;
	border-left: 11px solid rgba(0, 0, 0, 0);
	border-right: 11px solid rgba(0, 0, 0, 0);
	content: "";
	display: inline-block;
	position: absolute;
	right: 40%;
	bottom: 5px;
}
.nav-tabs .nav-item .nav-link.active:before,
.nav-tabs .nav-item .nav-link.active:hover:before,
.nav-tabs .nav-item .nav-link.active:focus:before {
	border-bottom: 11px solid #f1eae0;
	border-left: 11px solid rgba(0, 0, 0, 0);
	border-right: 11px solid rgba(0, 0, 0, 0);
	content: "";
	display: inline-block;
	position: absolute;
	right: 40%;
	bottom: 6px;
}
.nav-tabs .nav-item.show .nav-link {
	background-color: transparent;
}
.nav-tabs .dropdown-menu {
	margin-top: -6px;
	margin-left: -46px;
	border-radius: 8px;
}
.nav-tabs .dropdown-menu .dropdown-item:hover,
.nav-tabs .dropdown-menu .dropdown-item.active {
	color: #ffffff;
	background-color: #68b3c8;
}
.nav-tabs .dropdown-menu :before {
	border-bottom: 11px solid #f1eae0;
	border-left: 11px solid rgba(0, 0, 0, 0);
	border-right: 11px solid rgba(0, 0, 0, 0);
	content: "";
	display: inline-block;
	position: absolute;
	right: 12px;
	top: -11px;
}
.nav-tabs .dropdown-menu :after {
	border-bottom: 11px solid #fffcf5;
	border-left: 11px solid rgba(0, 0, 0, 0);
	border-right: 11px solid rgba(0, 0, 0, 0);
	content: "";
	display: inline-block;
	position: absolute;
	right: 12px;
	top: -10px;
}

.profile-content .tab-content .tab-pane {
	min-height: 200px;
}
.profile-content .tab-content #tweets,
.profile-content .tab-content #connections,
.profile-content .tab-content #media {
	height: 100%;
}

.nav-text,
.nav-icons {
	margin: 0 0 10px 0;
}
.nav-text > li > a,
.nav-icons > li > a {
	display: block;
	padding: 0px 0.7rem;
	color: #292929 !important;
	text-align: center;
	opacity: 0.8;
	filter: alpha(opacity=80);
}
.nav-text > li > a:hover,
.nav-text > li > a:focus,
.nav-icons > li > a:hover,
.nav-icons > li > a:focus {
	background-color: transparent;
	opacity: 1;
	filter: alpha(opacity=100);
}
.nav-text > li:first-child a,
.nav-icons > li:first-child a {
	padding-left: 0;
}
.nav-text > li.active a,
.nav-icons > li.active a {
	color: #39a9db;
}

.nav-icons > li {
	display: inline-block;
}
.nav-icons > li > a {
	padding: 0 10px;
	margin-bottom: 10px;
}
.nav-icons > li > a i {
	font-size: 1.714em;
	margin-bottom: 10px;
	width: 1.714em;
}

.nav-icons.nav-stacked > li {
	display: block;
}
.nav-icons.nav-stacked > li > a {
	margin-bottom: 20px;
}

.nav-blue > li.active a {
	color: #1c77c3;
}

.nav-azure > li.active a {
	color: #39a9db;
}

.nav-green > li.active a {
	color: #28a745;
}

.nav-orange > li.active a {
	color: #ffc759;
}

.nav-red > li.active a {
	color: #c1292e;
}

.nav-text {
	margin: 0 0 10px 0;
}
.nav-text > li > a {
	font-size: 1em;
	text-transform: uppercase;
	padding: 3px 0;
	text-align: left;
	font-weight: 600;
}
.nav-text > li:first-child > a {
	padding-top: 0;
}
.nav-text h4 {
	margin-top: 0;
}

.nav-text:not(.nav-stacked) > li {
	display: inline-block;
}
.nav-text:not(.nav-stacked) > li > a {
	margin-right: 15px;
}

.verical-navs .nav-stacked .nav-link.active:before,
.verical-navs .nav-stacked .nav-link.active:hover:before,
.verical-navs .nav-stacked .nav-link.active:focus:before,
.verical-navs .nav-stacked .nav-link.active.show:before {
	border-right: 11px solid #f1eae0;
	border-top: 11px solid transparent;
	border-bottom: 11px solid transparent;
	content: "";
	display: inline-block;
	position: absolute;
	right: 0;
	bottom: 20px;
}

.verical-navs .nav-stacked .nav-link.active:after,
.verical-navs .nav-stacked .nav-link.active:hover:after,
.verical-navs .nav-stacked .nav-link.active:focus:after,
.verical-navs .nav-stacked .nav-link.active.show:after {
	border-right: 11px solid #ffffff;
	border-top: 11px solid transparent;
	border-bottom: 11px solid transparent;
	content: "";
	display: inline-block;
	position: absolute;
	right: -1px;
	bottom: 20px;
}

#second-tabs {
	margin-left: 20px;
}

.nav-tabs-navigation.verical-navs {
	border-right: 1px solid #f1eae0;
	font-size: 16px;
	border-bottom: none;
}

.card-timeline .timeline h6 i {
	margin-right: 4px;
}

/*! nouislider - 11.1.0 - 2018-04-02 11:18:13 */
/* Functional styling;
* These styles are required for noUiSlider to function.
* You don't need to change these rules to apply your design.
*/
/*

This file was modified by Creative-Tim

*/
.noUi-target,
.noUi-target * {
	-webkit-touch-callout: none;
	-webkit-tap-highlight-color: rgba(0, 0, 0, 0);
	-webkit-user-select: none;
	touch-action: none;
	user-select: none;
	box-sizing: border-box;
}

.noUi-target {
	position: relative;
	direction: ltr;
}

.noUi-base,
.noUi-connects {
	width: 100%;
	height: 100%;
	position: relative;
	z-index: 1;
}

/* Wrapper for all connect elements.
*/
.noUi-connects {
	overflow: hidden;
	z-index: 0;
}

.noUi-connect,
.noUi-origin {
	will-change: transform;
	position: absolute;
	z-index: 1;
	top: 0;
	left: 0;
	height: 100%;
	width: 100%;
	transform-origin: 0 0;
}

/* Offset direction
*/
html:not([dir="rtl"]) .noUi-horizontal .noUi-origin {
	left: auto;
	right: 0;
}

/* Give origins 0 height/width so they don't interfere with clicking the
* connect elements.
*/
.noUi-vertical .noUi-origin {
	width: 0;
}

.noUi-horizontal .noUi-origin {
	height: 0;
}

.noUi-handle {
	position: absolute;
}

.noUi-state-tap .noUi-connect,
.noUi-state-tap .noUi-origin {
	transition: transform 0.3s;
}

.noUi-state-drag * {
	cursor: inherit !important;
}

/* Slider size and handle placement;
*/
.noUi-horizontal {
	height: 8px;
}

.noUi-horizontal .noUi-handle {
	background: #fff;
	background: linear-gradient(180deg, #fff 0, #f1f1f2);
	filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="\$white-color",endColorstr="#f1f1f2",GradientType=0);
	border-radius: 50%;
	box-shadow: inset 0 1px 1px #fff, 0 1px 2px rgba(0, 0, 0, 0.4);
	height: 15px;
	width: 15px;
	cursor: pointer;
	margin-left: -10px;
	margin-top: -4px;
}

.noUi-vertical {
	width: 8px;
}

.noUi-vertical .noUi-handle {
	background: #fff;
	background: linear-gradient(180deg, #fff 0, #f1f1f2);
	filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="\$white-color",endColorstr="#f1f1f2",GradientType=0);
	border-radius: 50%;
	box-shadow: inset 0 1px 1px #fff, 0 1px 2px rgba(0, 0, 0, 0.4);
	cursor: pointer;
	width: 15px;
	height: 15px;
	left: -4px;
	top: -10px;
}

html:not([dir="rtl"]) .noUi-horizontal .noUi-handle {
	right: -5px;
	left: auto;
}

/* Styling;
* Giving the connect element a border radius causes issues with using transform: scale
*/
.noUi-target {
	background-color: rgba(182, 182, 182, 0.3);
	border-radius: 3px;
}

.noUi-connects {
	border-radius: 3px;
}

.noUi-connect {
	background: #888;
	border-radius: 3px;
	transition: background 450ms;
}

/* Handles and cursors;
*/
.noUi-draggable {
	cursor: ew-resize;
}

.noUi-vertical .noUi-draggable {
	cursor: ns-resize;
}

.noUi-handle {
	border-radius: 3px;
	background: #fff;
	cursor: default;
	box-shadow: inset 0 0 1px #fff, inset 0 1px 7px #ebebeb, 0 3px 6px -3px #bbb;
	transition: 300ms ease 0s;
}
.noUi-handle:focus {
	outline: none;
}

.noUi-active {
	box-shadow: inset 0 0 1px #fff, inset 0 1px 7px #ddd, 0 3px 6px -3px #bbb;
}

/* Disabled state;
*/
[disabled] .noUi-connect {
	background: #b8b8b8;
}

[disabled].noUi-target,
[disabled].noUi-handle,
[disabled] .noUi-handle {
	cursor: not-allowed;
}

/* Base;
*
*/
.noUi-pips,
.noUi-pips * {
	box-sizing: border-box;
}

.noUi-pips {
	position: absolute;
	color: #999;
}

/* Values;
*
*/
.noUi-value {
	position: absolute;
	white-space: nowrap;
	text-align: center;
}

.noUi-value-sub {
	color: #ccc;
	font-size: 10px;
}

/* Markings;
*
*/
.noUi-marker {
	position: absolute;
	background: #ccc;
}

.noUi-marker-sub {
	background: #aaa;
}

.noUi-marker-large {
	background: #aaa;
}

/* Horizontal layout;
*
*/
.noUi-pips-horizontal {
	padding: 10px 0;
	height: 80px;
	top: 100%;
	left: 0;
	width: 100%;
}

.noUi-value-horizontal {
	transform: translate(-50%, 50%);
}

.noUi-rtl .noUi-value-horizontal {
	transform: translate(50%, 50%);
}

.noUi-marker-horizontal.noUi-marker {
	margin-left: -1px;
	width: 2px;
	height: 5px;
}

.noUi-marker-horizontal.noUi-marker-sub {
	height: 10px;
}

.noUi-marker-horizontal.noUi-marker-large {
	height: 15px;
}

/* Vertical layout;
*
*/
.noUi-pips-vertical {
	padding: 0 10px;
	height: 100%;
	top: 0;
	left: 100%;
}

.noUi-value-vertical {
	transform: translate(0, -50%, 0);
	padding-left: 25px;
}

.noUi-rtl .noUi-value-vertical {
	transform: translate(0, 50%);
}

.noUi-marker-vertical.noUi-marker {
	width: 5px;
	height: 2px;
	margin-top: -1px;
}

.noUi-marker-vertical.noUi-marker-sub {
	width: 10px;
}

.noUi-marker-vertical.noUi-marker-large {
	width: 15px;
}

.noUi-tooltip {
	display: block;
	position: absolute;
	border: 1px solid #d9d9d9;
	border-radius: 3px;
	background: #fff;
	color: #000;
	padding: 5px;
	text-align: center;
	white-space: nowrap;
}

.noUi-horizontal .noUi-tooltip {
	transform: translate(-50%, 0);
	left: 50%;
	bottom: 120%;
}

.noUi-vertical .noUi-tooltip {
	transform: translate(0, -50%);
	top: 50%;
	right: 120%;
}

.slider.slider-neutral .noUi-connect,
.slider.slider-neutral.noUi-connect {
	background-color: #ffffff;
}
.slider.slider-neutral.noUi-target {
	background-color: rgba(255, 255, 255, 0.3);
}
.slider.slider-neutral .noUi-handle {
	background-color: #ffffff;
}
.slider.slider-primary .noUi-connect,
.slider.slider-primary.noUi-connect {
	background-color: #1c77c3;
}
.slider.slider-info .noUi-connect,
.slider.slider-info.noUi-connect {
	background-color: #39a9db;
}
.slider.slider-success .noUi-connect,
.slider.slider-success.noUi-connect {
	background-color: #28a745;
}
.slider.slider-warning .noUi-connect,
.slider.slider-warning.noUi-connect {
	background-color: #ffc759;
}
.slider.slider-danger .noUi-connect,
.slider.slider-danger.noUi-connect {
	background-color: #c1292e;
}

.rbc-btn {
	color: inherit;
	font: inherit;
	margin: 0;
}

button.rbc-btn {
	overflow: visible;
	text-transform: none;
	cursor: pointer;
}

button[disabled].rbc-btn {
	cursor: not-allowed;
}

button.rbc-input::-moz-focus-inner {
	border: 0;
	padding: 0;
}

.rbc-calendar {
	box-sizing: border-box;
	height: 100%;
	display: flex;
	flex-direction: column;
	align-items: stretch;
}

.rbc-calendar *,
.rbc-calendar *:before,
.rbc-calendar *:after {
	box-sizing: inherit;
}

.rbc-abs-full,
.rbc-row-bg {
	overflow: hidden;
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
}

.rbc-ellipsis,
.rbc-event-label,
.rbc-row-segment .rbc-event-content,
.rbc-show-more {
	display: block;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.rbc-rtl {
	direction: rtl;
}

.rbc-off-range {
	color: #333333;
	opacity: 0.3;
}

.rbc-header {
	overflow: hidden;
	flex: 1 0;
	text-overflow: ellipsis;
	white-space: nowrap;
	padding: 0 3px;
	text-align: right;
	vertical-align: middle;
	font-weight: bold;
	font-size: 1em;
	min-height: 0;
	border-bottom: 1px solid #ddd;
	color: #999999;
}
.rbc-header:last-child span {
	padding-right: 15px;
}

.rbc-header > a,
.rbc-header > a:active,
.rbc-header > a:visited {
	color: inherit;
	text-decoration: none;
}

.rbc-row-content {
	position: relative;
	user-select: none;
	-webkit-user-select: none;
	z-index: 4;
	min-height: 153px;
}

.rbc-toolbar {
	display: flex;
	align-items: center;
	margin-bottom: 10px;
	font-size: 16px;
	padding-top: 20px;
	padding-left: 20px;
	padding-right: 20px;
}

.rbc-toolbar .rbc-toolbar-label {
	flex-grow: 1;
	padding: 0 10px;
	text-align: center;
	font-family: inherit;
	line-height: 1.5em;
	color: inherit;
	font-weight: 500;
	margin: 0;
	font-size: 2.5em;
}

.rbc-toolbar button {
	background-color: #65adff;
	color: #ffffff;
	border-width: 2px;
	font-weight: 400;
	font-size: 14px;
	line-height: 20px;
	margin: 5px 1px;
	border: none;
	margin: 10px 1px;
	border-radius: 30px;
	padding: 6px 12px;
	cursor: pointer;
	transition: all 0.2s ease-in-out;
	outline: none;
}
.rbc-toolbar button:hover,
.rbc-toolbar button:focus,
.rbc-toolbar button:active,
.rbc-toolbar button.active,
.rbc-toolbar button:active:focus,
.rbc-toolbar button:active:hover,
.rbc-toolbar button.active:focus,
.rbc-toolbar button.active:hover,
.show > .rbc-toolbar button.dropdown-toggle,
.show > .rbc-toolbar button.dropdown-toggle:focus,
.show > .rbc-toolbar button.dropdown-toggle:hover {
	background-color: #403d39 !important;
	color: #ffffff !important;
	box-shadow: none !important;
}
.rbc-toolbar button:not([data-action]):hover {
	box-shadow: none;
}
.rbc-toolbar button.disabled,
.rbc-toolbar button.disabled:hover,
.rbc-toolbar button.disabled:focus,
.rbc-toolbar button.disabled.focus,
.rbc-toolbar button.disabled:active,
.rbc-toolbar button.disabled.active,
.rbc-toolbar button:disabled,
.rbc-toolbar button:disabled:hover,
.rbc-toolbar button:disabled:focus,
.rbc-toolbar button:disabled.focus,
.rbc-toolbar button:disabled:active,
.rbc-toolbar button:disabled.active,
.rbc-toolbar button[disabled],
.rbc-toolbar button[disabled]:hover,
.rbc-toolbar button[disabled]:focus,
.rbc-toolbar button[disabled].focus,
.rbc-toolbar button[disabled]:active,
.rbc-toolbar button[disabled].active,
fieldset[disabled] .rbc-toolbar button,
fieldset[disabled] .rbc-toolbar button:hover,
fieldset[disabled] .rbc-toolbar button:focus,
fieldset[disabled] .rbc-toolbar button.focus,
fieldset[disabled] .rbc-toolbar button:active,
fieldset[disabled] .rbc-toolbar button.active {
	background-color: #65adff;
	border-color: #65adff;
}
.rbc-toolbar button.btn-simple {
	color: #65adff;
	border-color: #65adff;
}
.rbc-toolbar button.btn-simple:hover,
.rbc-toolbar button.btn-simple:focus,
.rbc-toolbar button.btn-simple:active {
	background-color: transparent;
	color: #403d39;
	border-color: #403d39;
	box-shadow: none;
}
.rbc-toolbar button.btn-link {
	color: #65adff;
}
.rbc-toolbar button.btn-link:hover,
.rbc-toolbar button.btn-link:focus,
.rbc-toolbar button.btn-link:active,
.rbc-toolbar button.btn-link:active:focus {
	background-color: transparent;
	color: #403d39;
	text-decoration: none;
	box-shadow: none;
}

.rbc-toolbar button:focus {
	outline: none;
}

.rbc-btn-group {
	display: inline-block;
}

.rbc-btn-group button {
	margin: 0 0 0 2px;
	border-radius: 30px;
}

@media screen and (max-width: 526px) {
	.rbc-btn-group button {
		margin: 2px !important;
	}
}
.rbc-btn-group button + button {
	margin: 0 0 0 2px;
	border-radius: 30px;
}

.rbc-btn-group + .rbc-btn-group,
.rbc-btn-group + button {
	margin-left: 10px;
}

.rbc-slot-selecting .rbc-event {
	cursor: inherit;
	pointer-events: none;
}

.rbc-event.rbc-selected {
	background-color: #265985;
}

.rbc-event-label {
	font-size: 80%;
}

.rbc-event-overlaps {
	box-shadow: -1px 1px 5px 0px rgba(51, 51, 51, 0.5);
}

.rbc-event-continues-prior {
	border-top-left-radius: 0;
	border-bottom-left-radius: 0;
}

.rbc-event-continues-after {
	border-top-right-radius: 0;
	border-bottom-right-radius: 0;
}

.rbc-event-continues-earlier {
	border-top-left-radius: 0;
	border-top-right-radius: 0;
}

.rbc-event-continues-later {
	border-bottom-left-radius: 0;
	border-bottom-right-radius: 0;
}

.rbc-event-continues-day-after {
	border-bottom-left-radius: 0;
	border-bottom-right-radius: 0;
}

.rbc-event-continues-day-prior {
	border-top-left-radius: 0;
	border-top-right-radius: 0;
}

.rbc-row {
	display: flex;
	flex-direction: row;
}

.rbc-row-segment {
	padding: 2px 6px 1px;
}

.rbc-selected-cell {
	background-color: rgba(0, 0, 0, 0.1);
}

.rbc-show-more {
	background-color: rgba(255, 255, 255, 0.3);
	z-index: 4;
	font-weight: bold;
	font-size: 85%;
	height: auto;
	line-height: normal;
	white-space: nowrap;
}

.rbc-month-view {
	position: relative;
	border: 1px solid #ddd;
	display: flex;
	flex-direction: column;
	flex: 1 0;
	width: 100%;
	user-select: none;
	-webkit-user-select: none;
	height: 100%;
	border-left: none;
	border-right: none;
}

.rbc-month-view {
	border-top: none;
}

.rbc-month-header {
	display: flex;
	flex-direction: row;
}

.rbc-month-row {
	display: flex;
	position: relative;
	flex-direction: column;
	flex: 1 0;
	-ms-flex-preferred-size: 0px;
	overflow: hidden;
	height: 100%;
}

.rbc-month-row + .rbc-month-row {
	border-top: 1px solid #ddd;
}

.rbc-date-cell {
	flex: 1 1;
	min-width: 0;
	padding-left: 5px;
	text-align: left;
}

.rbc-date-cell.rbc-now {
	font-weight: bold;
}

.rbc-date-cell > a,
.rbc-date-cell > a:active,
.rbc-date-cell > a:visited {
	color: inherit;
	text-decoration: none;
}

.rbc-row-bg {
	display: flex;
	flex-direction: row;
	flex: 1 0;
	overflow: hidden;
}

.rbc-day-bg {
	flex: 1 0;
}

.rbc-day-bg + .rbc-day-bg {
	border-left: 1px solid #ddd;
}

.rbc-rtl .rbc-day-bg + .rbc-day-bg {
	border-left-width: 0;
	border-right: 1px solid #ddd;
}

.rbc-overlay {
	position: absolute;
	z-index: 5;
	border: 1px solid #e5e5e5;
	background-color: #fff;
	box-shadow: 0 5px 15px rgba(0, 0, 0, 0.25);
	padding: 10px;
}

.rbc-overlay > * + * {
	margin-top: 1px;
}

.rbc-overlay-header {
	border-bottom: 1px solid #e5e5e5;
	margin: -10px -10px 5px -10px;
	padding: 2px 10px;
}

.rbc-agenda-view {
	display: flex;
	flex-direction: column;
	flex: 1 0;
	overflow: auto;
}

.rbc-agenda-view table.rbc-agenda-table {
	width: 100%;
	border: 1px solid #ddd;
	border-spacing: 0;
	border-collapse: collapse;
}

.rbc-agenda-view table.rbc-agenda-table tbody > tr > td {
	padding: 5px 10px;
	vertical-align: top;
}

.rbc-agenda-view table.rbc-agenda-table .rbc-agenda-time-cell {
	padding-left: 15px;
	padding-right: 15px;
	text-transform: lowercase;
}

.rbc-agenda-view table.rbc-agenda-table tbody > tr > td + td {
	border-left: 1px solid #ddd;
}

.rbc-rtl .rbc-agenda-view table.rbc-agenda-table tbody > tr > td + td {
	border-left-width: 0;
	border-right: 1px solid #ddd;
}

.rbc-agenda-view table.rbc-agenda-table tbody > tr + tr {
	border-top: 1px solid #ddd;
}

.rbc-agenda-view table.rbc-agenda-table thead > tr > th {
	padding: 3px 5px;
	text-align: left;
	border-bottom: 1px solid #ddd;
}

.rbc-rtl .rbc-agenda-view table.rbc-agenda-table thead > tr > th {
	text-align: right;
}

.rbc-agenda-time-cell {
	text-transform: lowercase;
}

.rbc-agenda-time-cell .rbc-continues-after:after {
	content: " »";
}

.rbc-agenda-time-cell .rbc-continues-prior:before {
	content: "« ";
}

.rbc-agenda-date-cell,
.rbc-agenda-time-cell {
	white-space: nowrap;
}

.rbc-agenda-event-cell {
	width: 100%;
}

.rbc-time-column {
	display: flex;
	flex-direction: column;
	min-height: 100%;
}

.rbc-time-column .rbc-timeslot-group {
	flex: 1 1;
}

.rbc-timeslot-group {
	border-bottom: 1px solid #ddd;
	min-height: 40px;
	display: flex;
	flex-flow: column nowrap;
}

.rbc-time-gutter,
.rbc-header-gutter {
	flex: none;
}

.rbc-label {
	padding: 0 5px;
}

.rbc-day-slot {
	position: relative;
}

.rbc-day-slot .rbc-events-container {
	bottom: 0;
	left: 0;
	position: absolute;
	right: 10px;
	top: 0;
}

.rbc-day-slot .rbc-events-container.rbc-is-rtl {
	left: 10px;
	right: 0;
}

.rbc-day-slot .rbc-event {
	display: flex;
	max-height: 100%;
	min-height: 20px;
	flex-flow: column wrap;
	align-items: flex-start;
	overflow: hidden;
	position: absolute;
}

.rbc-day-slot .rbc-event-label {
	flex: none;
	padding-right: 5px;
	width: auto;
	font-weight: bold;
	box-sizing: content-box;
	color: #fff;
	white-space: nowrap;
}

.rbc-day-slot .rbc-event-content {
	width: 100%;
	flex: 1 1;
	word-wrap: break-word;
	line-height: 1;
	height: 100%;
	min-height: 1em;
}

.rbc-day-slot .rbc-time-slot + .rbc-time-slot {
	border-top: 1px dotted #ddd;
}

.rbc-time-slot {
	flex: 1 0;
}

.rbc-time-slot.rbc-now {
	font-weight: bold;
}

.rbc-day-header {
	text-align: center;
}

.rbc-slot-selection {
	z-index: 10;
	position: absolute;
	background-color: rgba(0, 0, 0, 0.5);
	color: white;
	font-size: 75%;
	width: 100%;
	padding: 3px;
}

.rbc-slot-selecting {
	cursor: move;
}

.rbc-time-view {
	display: flex;
	flex-direction: column;
	flex: 1 1;
	width: 100%;
	border: 1px solid #ddd;
	min-height: 0;
	border-left: none;
	border-right: none;
	border-top: none;
}

.rbc-time-view .rbc-time-gutter {
	white-space: nowrap;
}

.rbc-time-view .rbc-allday-cell {
	box-sizing: content-box;
	width: 100%;
	position: relative;
}

.rbc-time-view .rbc-allday-events {
	position: relative;
	z-index: 4;
}

.rbc-time-view .rbc-row {
	box-sizing: border-box;
	min-height: 20px;
}

.rbc-time-header {
	display: flex;
	flex: 0 0 auto;
	flex-direction: row;
}

.rbc-time-header.rbc-overflowing {
	border-right: 1px solid #ddd;
}

.rbc-rtl .rbc-time-header.rbc-overflowing {
	border-right-width: 0;
	border-left: 1px solid #ddd;
}

.rbc-time-header > .rbc-row:first-child {
	border-bottom: 1px solid #ddd;
}

.rbc-time-header > .rbc-row.rbc-row-resource {
	border-bottom: 1px solid #ddd;
}

.rbc-time-header-content {
	flex: 1 1;
	min-width: 0;
	flex-direction: column;
	border-left: 1px solid #ddd;
}

.rbc-rtl .rbc-time-header-content {
	border-left-width: 0;
	border-right: 1px solid #ddd;
}

.rbc-time-content {
	display: flex;
	flex: 1 0;
	align-items: flex-start;
	width: 100%;
	border-top: 2px solid #ddd;
	overflow-y: auto;
	position: relative;
}

.rbc-time-content > .rbc-time-gutter {
	flex: none;
}

.rbc-time-content > * + * > * {
	border-left: 1px solid #ddd;
}

.rbc-rtl .rbc-time-content > * + * > * {
	border-left-width: 0;
	border-right: 1px solid #ddd;
}

.rbc-time-content > .rbc-day-slot {
	width: 100%;
	user-select: none;
	-webkit-user-select: none;
}

.rbc-current-time-indicator {
	position: absolute;
	z-index: 3;
	height: 1px;
	background-color: #74ad31;
	pointer-events: none;
}

.rbc-event {
	width: 100%;
	position: relative;
	/* for resize handle and other inner positioning */
	display: block;
	/* make the <a> tag block */
	font-size: 0.85em;
	border-radius: 2px;
	padding: 0;
	background-color: rgba(28, 119, 195, 0.2);
	/* default BACKGROUND color */
	font-weight: normal;
	/* undo jqui's ui-widget-header bold */
	text-align: left;
	border: none;
	padding-bottom: 1px;
	line-height: 1.2;
}
.rbc-event.event-azure {
	background-color: rgba(57, 169, 219, 0.2);
}
.rbc-event.event-green {
	background-color: rgba(19, 117, 71, 0.2);
}
.rbc-event.event-orange {
	background-color: rgba(255, 199, 89, 0.2);
}
.rbc-event.event-red {
	background-color: rgba(193, 41, 46, 0.2);
}
.rbc-event .rbc-event-content {
	position: relative;
	z-index: 2;
	white-space: nowrap;
	overflow: hidden;
	color: inherit;
	padding: 0 5px;
}

.rbc-day-slot .rbc-event {
	display: block !important;
	height: auto !important;
	height: initial !important;
	max-height: none !important;
	max-height: initial !important;
}

.rbc-today {
	background-color: #f5f5f5;
}

@media screen and (max-width: 1373px) {
	.rbc-toolbar {
		display: block;
	}
	.rbc-toolbar .rbc-btn-group {
		display: block;
		text-align: center;
	}
	.rbc-toolbar .rbc-toolbar-label {
		display: block;
		flex-grow: initial;
		padding: 0;
	}
}
.sweet-alert:focus {
	outline: none;
}

.sweet-alert {
	margin: auto !important;
}

.bootstrap-switch {
	display: inline-block;
	direction: ltr;
	cursor: pointer;
	border-radius: 30px;
	border: 0;
	position: relative;
	text-align: left;
	overflow: hidden;
	margin-bottom: 5px;
	line-height: 8px;
	width: 61px !important;
	height: 26px;
	outline: none;
	z-index: 0;
	margin-right: 1px;
	-webkit-user-select: none;
	user-select: none;
	vertical-align: middle;
	transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
}

.bootstrap-switch .bootstrap-switch-container {
	display: inline-flex;
	top: 0;
	height: 26px;
	border-radius: 4px;
	transform: translate3d(0, 0, 0);
	width: 100px !important;
}

.bootstrap-switch .bootstrap-switch-handle-on,
.bootstrap-switch .bootstrap-switch-handle-off,
.bootstrap-switch .bootstrap-switch-label {
	box-sizing: border-box;
	cursor: pointer;
	display: inline-block !important;
	height: 100%;
	color: #fff;
	padding: 6px 10px;
	font-size: 11px;
	text-indent: -5px;
	line-height: 15px;
	transition: 0.25s ease-out;
}
.bootstrap-switch .bootstrap-switch-handle-on i,
.bootstrap-switch .bootstrap-switch-handle-off i,
.bootstrap-switch .bootstrap-switch-label i {
	font-size: 12px;
	line-height: 14px;
}

.bootstrap-switch .bootstrap-switch-handle-on,
.bootstrap-switch .bootstrap-switch-handle-off {
	text-align: center;
	z-index: 1;
	float: left;
	width: 50% !important;
	background-color: #66615b;
}

.bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-primary,
.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-primary {
	color: #fff;
	background: #7a9e9f;
}

.bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-info,
.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-info {
	color: #fff;
	background: #68b3c8;
}

.bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-success,
.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-success {
	color: #fff;
	background: #7ac29a;
}

.bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-warning,
.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-warning {
	background: #f3bb45;
	color: #fff;
}

.bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-danger,
.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-danger {
	color: #fff;
	background: #eb5e28;
}

.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-default {
	color: #fff;
	background: #cfcfca;
}

.bootstrap-switch .bootstrap-switch-label {
	text-align: center;
	z-index: 100;
	color: #333333;
	background: #ffffff;
	width: 22px !important;
	height: 22px;
	margin: 2px -11px;
	border-radius: 12px;
	position: relative;
	float: left;
	padding: 0;
	background-color: #ffffff;
	box-shadow: 0 1px 1px #ffffff inset, 0 1px 1px rgba(0, 0, 0, 0.25);
}

.bootstrap-switch .bootstrap-switch-handle-on {
	border-bottom-left-radius: 3px;
	border-top-left-radius: 3px;
}

.bootstrap-switch .bootstrap-switch-handle-off {
	text-indent: 6px;
}

.bootstrap-switch input[type="radio"],
.bootstrap-switch input[type="checkbox"] {
	position: absolute !important;
	top: 0;
	left: 0;
	opacity: 0;
	filter: alpha(opacity=0);
	z-index: -1;
}

.bootstrap-switch input[type="radio"].form-control,
.bootstrap-switch input[type="checkbox"].form-control {
	height: auto;
}

.bootstrap-switch.bootstrap-switch-mini .bootstrap-switch-handle-on,
.bootstrap-switch.bootstrap-switch-mini .bootstrap-switch-handle-off,
.bootstrap-switch.bootstrap-switch-mini .bootstrap-switch-label {
	padding: 1px 5px;
	font-size: 12px;
	line-height: 1.5;
}

.bootstrap-switch.bootstrap-switch-small .bootstrap-switch-handle-on,
.bootstrap-switch.bootstrap-switch-small .bootstrap-switch-handle-off,
.bootstrap-switch.bootstrap-switch-small .bootstrap-switch-label {
	padding: 5px 10px;
	font-size: 12px;
	line-height: 1.5;
}

.bootstrap-switch.bootstrap-switch-large .bootstrap-switch-handle-on,
.bootstrap-switch.bootstrap-switch-large .bootstrap-switch-handle-off,
.bootstrap-switch.bootstrap-switch-large .bootstrap-switch-label {
	padding: 6px 16px;
	font-size: 18px;
	line-height: 1.33;
}

.bootstrap-switch.bootstrap-switch-disabled,
.bootstrap-switch.bootstrap-switch-readonly,
.bootstrap-switch.bootstrap-switch-indeterminate {
	cursor: default !important;
}

.bootstrap-switch.bootstrap-switch-disabled .bootstrap-switch-handle-on,
.bootstrap-switch.bootstrap-switch-readonly .bootstrap-switch-handle-on,
.bootstrap-switch.bootstrap-switch-indeterminate .bootstrap-switch-handle-on,
.bootstrap-switch.bootstrap-switch-disabled .bootstrap-switch-handle-off,
.bootstrap-switch.bootstrap-switch-readonly .bootstrap-switch-handle-off,
.bootstrap-switch.bootstrap-switch-indeterminate .bootstrap-switch-handle-off,
.bootstrap-switch.bootstrap-switch-disabled .bootstrap-switch-label,
.bootstrap-switch.bootstrap-switch-readonly .bootstrap-switch-label,
.bootstrap-switch.bootstrap-switch-indeterminate .bootstrap-switch-label {
	opacity: 0.5;
	filter: alpha(opacity=50);
	cursor: default !important;
}

.bootstrap-switch.bootstrap-switch-animate .bootstrap-switch-container {
	transition: margin-left 0.5s;
}

.bootstrap-switch.bootstrap-switch-inverse .bootstrap-switch-handle-on {
	border-bottom-left-radius: 0;
	border-top-left-radius: 0;
	border-bottom-right-radius: 3px;
	border-top-right-radius: 3px;
}

.bootstrap-switch.bootstrap-switch-inverse .bootstrap-switch-handle-off {
	border-bottom-right-radius: 0;
	border-top-right-radius: 0;
	border-bottom-left-radius: 3px;
	border-top-left-radius: 3px;
}

.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-container {
	margin-left: -2px !important;
}

.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-container {
	margin-left: -37px !important;
}

.bootstrap-switch.bootstrap-switch-on:hover .bootstrap-switch-label {
	width: 26px !important;
	margin: 2px -15px;
}

.bootstrap-switch.bootstrap-switch-off:hover .bootstrap-switch-label {
	width: 26px !important;
	margin: 2px -15px -13px -11px;
}

.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-handle-off {
	background-color: #66615b;
}

.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-handle-on {
	background-color: #cfcfca;
}

.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-danger {
	background-color: #eb5e28;
}

.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-warning {
	background-color: #f3bb45;
}

.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-success {
	background-color: #7ac29a;
}

.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-primary {
	background-color: #7a9e9f;
}

.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-info {
	background-color: #68b3c8;
}

.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-default {
	background-color: #66615b;
}

.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-danger,
.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-primary,
.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-info,
.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-warning,
.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-success {
	background-color: #cfcfca;
}

.bootstrap-switch.wrapper {
	min-height: auto;
	height: auto;
}

.card-wizard {
	min-height: 410px;
	box-shadow: 0 2px 2px rgba(204, 197, 185, 0.5);
	opacity: 0;
	transition: all 300ms linear;
}
.card-wizard[data-color="primary"] .moving-tab {
	color: #1c77c3;
}
.card-wizard[data-color="primary"] .picture:hover {
	border-color: #1c77c3;
}
.card-wizard[data-color="primary"] .choice:hover .icon,
.card-wizard[data-color="primary"] .choice.active .icon {
	border-color: #1c77c3;
	color: #1c77c3;
}
.card-wizard[data-color="primary"]
	.checkbox
	input[type="checkbox"]:checked
	+ .checkbox-material
	.check {
	background-color: #1c77c3;
}
.card-wizard[data-color="primary"] .radio input[type="radio"]:checked ~ .check {
	background-color: #1c77c3;
}
.card-wizard[data-color="primary"]
	.radio
	input[type="radio"]:checked
	~ .circle {
	border-color: #1c77c3;
}
.card-wizard[data-color="white"] .moving-tab {
	color: #ffffff;
}
.card-wizard[data-color="white"] .picture:hover {
	border-color: #ffffff;
}
.card-wizard[data-color="white"] .choice:hover .icon,
.card-wizard[data-color="white"] .choice.active .icon {
	border-color: #ffffff;
	color: #ffffff;
}
.card-wizard[data-color="white"]
	.checkbox
	input[type="checkbox"]:checked
	+ .checkbox-material
	.check {
	background-color: #ffffff;
}
.card-wizard[data-color="white"] .radio input[type="radio"]:checked ~ .check {
	background-color: #ffffff;
}
.card-wizard[data-color="white"] .radio input[type="radio"]:checked ~ .circle {
	border-color: #ffffff;
}
.card-wizard[data-color="green"] .moving-tab {
	color: #28a745;
}
.card-wizard[data-color="green"] .picture:hover {
	border-color: #28a745;
}
.card-wizard[data-color="green"] .choice:hover .icon,
.card-wizard[data-color="green"] .choice.active .icon {
	border-color: #28a745;
	color: #28a745;
}
.card-wizard[data-color="green"]
	.checkbox
	input[type="checkbox"]:checked
	+ .checkbox-material
	.check {
	background-color: #28a745;
}
.card-wizard[data-color="green"] .radio input[type="radio"]:checked ~ .check {
	background-color: #28a745;
}
.card-wizard[data-color="green"] .radio input[type="radio"]:checked ~ .circle {
	border-color: #28a745;
}
.card-wizard[data-color="blue"] .moving-tab {
	color: #39a9db;
}
.card-wizard[data-color="blue"] .picture:hover {
	border-color: #39a9db;
}
.card-wizard[data-color="blue"] .choice:hover .icon,
.card-wizard[data-color="blue"] .choice.active .icon {
	border-color: #39a9db;
	color: #39a9db;
}
.card-wizard[data-color="blue"]
	.checkbox
	input[type="checkbox"]:checked
	+ .checkbox-material
	.check {
	background-color: #39a9db;
}
.card-wizard[data-color="blue"] .radio input[type="radio"]:checked ~ .check {
	background-color: #39a9db;
}
.card-wizard[data-color="blue"] .radio input[type="radio"]:checked ~ .circle {
	border-color: #39a9db;
}
.card-wizard[data-color="orange"] .moving-tab {
	color: #ffc759;
}
.card-wizard[data-color="orange"] .picture:hover {
	border-color: #ffc759;
}
.card-wizard[data-color="orange"] .choice:hover .icon,
.card-wizard[data-color="orange"] .choice.active .icon {
	border-color: #ffc759;
	color: #ffc759;
}
.card-wizard[data-color="orange"]
	.checkbox
	input[type="checkbox"]:checked
	+ .checkbox-material
	.check {
	background-color: #ffc759;
}
.card-wizard[data-color="orange"] .radio input[type="radio"]:checked ~ .check {
	background-color: #ffc759;
}
.card-wizard[data-color="orange"] .radio input[type="radio"]:checked ~ .circle {
	border-color: #ffc759;
}
.card-wizard[data-color="red"] .moving-tab {
	color: #c1292e;
}
.card-wizard[data-color="red"] .picture:hover {
	border-color: #c1292e;
}
.card-wizard[data-color="red"] .choice:hover .icon,
.card-wizard[data-color="red"] .choice.active .icon {
	border-color: #c1292e;
	color: #c1292e;
}
.card-wizard[data-color="red"]
	.checkbox
	input[type="checkbox"]:checked
	+ .checkbox-material
	.check {
	background-color: #c1292e;
}
.card-wizard[data-color="red"] .radio input[type="radio"]:checked ~ .check {
	background-color: #c1292e;
}
.card-wizard[data-color="red"] .radio input[type="radio"]:checked ~ .circle {
	border-color: #c1292e;
}
.card-wizard.active {
	opacity: 1;
}
.card-wizard .card-header {
	padding: 15px 0 !important;
	padding-bottom: 40px;
	background-color: transparent;
}
.card-wizard .card-header .card-title {
	color: #252422;
}
.card-wizard .card-header .card-title + .description {
	color: #292929 !important;
}
.card-wizard .nav-pills .nav-item .nav-link {
	padding: 12px;
}
.card-wizard .nav-pills .nav-item .nav-link,
.card-wizard .nav-pills .nav-item .nav-link.active,
.card-wizard .nav-pills .nav-item .nav-link:hover,
.card-wizard .nav-pills .nav-item .nav-link:focus,
.card-wizard .nav-pills .nav-item .nav-link.active:focus,
.card-wizard .nav-pills .nav-item .nav-link.active:hover {
	background-color: transparent;
	box-shadow: none;
}
.card-wizard .picture-container {
	position: relative;
	cursor: pointer;
	text-align: center;
}
.card-wizard .wizard-navigation {
	position: relative;
}
.card-wizard .wizard-navigation .nav-link {
	display: flex;
	align-items: center;
	justify-content: center;
}
.card-wizard .wizard-navigation .nav-link i,
.card-wizard .moving-tab i {
	display: inline-block;
	font-size: 19px;
	line-height: normal;
	line-height: initial;
	margin-right: 6px;
	padding: 0;
	vertical-align: bottom;
}
.card-wizard .moving-tab i {
	margin-right: 9px;
}
.card-wizard .picture {
	width: 106px;
	height: 106px;
	background-color: #999999;
	border: 1px solid #e3e3e3;
	color: #ffffff;
	border-radius: 50%;
	margin: 5px auto;
	overflow: hidden;
	transition: all 0.2s;
	-webkit-transition: all 0.2s;
}
.card-wizard .picture:hover {
	border-color: #2ca8ff;
}
.card-wizard .moving-tab {
	position: absolute;
	text-align: center;
	padding: 12px;
	font-size: 12px;
	text-transform: uppercase;
	-webkit-font-smoothing: subpixel-antialiased;
	top: 0px;
	left: 0px;
	background-color: #65adff;
	box-shadow: 0 2px 2px rgba(204, 197, 185, 0.5);
	color: #ffffff !important;
	cursor: pointer;
	font-weight: 500;
}
.card-wizard .picture input[type="file"] {
	cursor: pointer;
	display: block;
	height: 100%;
	left: 0;
	opacity: 0 !important;
	position: absolute;
	top: 0;
	width: 100%;
}
.card-wizard .picture-src {
	width: 100%;
}
.card-wizard .tab-content {
	min-height: 355px;
	padding: 20px 0;
}
.card-wizard .wizard-footer {
	padding: 0 15px;
}
.card-wizard .wizard-footer .checkbox {
	margin-top: 16px;
}
.card-wizard .disabled {
	display: none;
}
.card-wizard .wizard-header {
	text-align: center;
	padding: 25px 0 35px;
}
.card-wizard .wizard-header h5 {
	margin: 5px 0 0;
}
.card-wizard .nav-pills > li {
	text-align: center;
}
.card-wizard .btn {
	text-transform: uppercase;
}
.card-wizard .info-text {
	text-align: center;
	font-weight: 300;
	margin: 10px 0 30px;
}
.card-wizard .choice {
	text-align: center;
	cursor: pointer;
	margin-top: 20px;
}
.card-wizard .choice[disabled] {
	pointer-events: none;
	cursor: not-allowed;
	opacity: 0.5;
}
.card-wizard .choice .icon {
	text-align: center;
	vertical-align: middle;
	height: 116px;
	width: 116px;
	border-radius: 50%;
	color: #65adff;
	margin: 0 auto 20px;
	border: 1px solid #e3e3e3;
	transition: all 0.2s;
	-webkit-transition: all 0.2s;
}
.card-wizard .choice i {
	font-size: 30px;
	line-height: 116px;
	position: absolute;
	left: 0;
	right: 0;
}
.card-wizard .choice:hover .icon,
.card-wizard .choice.active .icon {
	border-color: #2ca8ff;
}
.card-wizard .choice input[type="radio"],
.card-wizard .choice input[type="checkbox"] {
	position: absolute;
	left: -10000px;
	z-index: -1;
}
.card-wizard .btn-finish {
	display: none;
}
.card-wizard .card-title + .description {
	font-size: 17px;
	margin-bottom: 32px;
}
.card-wizard .wizard-title {
	margin: 0;
}
.card-wizard .nav-pills {
	background-color: #292929 !important;
}
.card-wizard .nav-pills > li + li {
	margin-left: 0;
}
.card-wizard .nav-pills > li > a {
	border: 0 !important;
	border-radius: 0;
	line-height: 18px;
	text-transform: uppercase;
	font-size: 12px;
	font-weight: 500;
	min-width: 100px;
	text-align: center;
	color: #ffffff !important;
}
.card-wizard .nav-pills > li.active > a,
.card-wizard .nav-pills > li.active > a:hover,
.card-wizard .nav-pills > li.active > a:focus,
.card-wizard .nav-pills > li > a:hover,
.card-wizard .nav-pills > li > a:focus {
	background-color: inherit;
	box-shadow: none;
}
.card-wizard .nav-pills > li i {
	display: block;
	font-size: 30px;
	padding: 15px 0;
}
.card-wizard .form-group.select-wizard {
	margin-top: 15px;
}
.card-wizard .dropdown.show .dropdown-menu,
.card-wizard .dropup.show .dropdown-menu {
	transform: translate3d(0, 0px, 0) !important;
}

/*!
* https://github.com/YouCanBookMe/react-datetime
*/
.rdt {
	position: relative;
}
.rdt .rdtPicker {
	transition: all 150ms linear;
	margin-top: -20px;
	visibility: hidden;
	display: block;
	opacity: 0;
}
.rdt.rdtOpen .rdtPicker {
	opacity: 1;
	visibility: visible;
	margin-top: 0;
}

.rdtPicker {
	display: none;
	position: absolute;
	width: 260px;
	padding: 4px;
	margin-top: 1px;
	z-index: 99999 !important;
	background: #fff;
	border-radius: 0.125rem;
	box-shadow: 0px 10px 50px 0px rgba(0, 0, 0, 0.2);
	-webkit-background-clip: padding-box;
	background-clip: padding-box;
	min-width: 160px;
}
.rdtPicker:before {
	display: inline-block;
	position: absolute;
	width: 0;
	height: 0;
	vertical-align: middle;
	content: "";
	top: -5px;
	left: 10px;
	right: auto;
	color: #ffffff;
	border-bottom: 0.4em solid;
	border-right: 0.4em solid transparent;
	border-left: 0.4em solid transparent;
}
.rdtPicker:after {
	border-bottom: 0.4em solid #ffffff;
	border-right: 0.4em solid transparent;
	border-left: 0.4em solid transparent;
	content: "";
	display: inline-block;
	position: absolute;
	top: -5px;
	left: 10px;
}

.rdtPicker {
	display: block;
	top: 40px;
}

.rdtStatic .rdtPicker {
	box-shadow: none;
	position: static;
}

.rdtPicker .rdtTimeToggle {
	text-align: center;
	padding: 5px;
	border-radius: 4px;
}

.rdtPicker table {
	width: 100%;
	margin: 0;
	border-color: #ffffff !important;
}

.rdtPicker td,
.rdtPicker th {
	text-align: center;
	padding: 1px;
}

.rdtPicker td {
	cursor: pointer;
}

.rdtDay {
	height: 30px;
	line-height: 33px;
	width: 30px;
	text-align: center;
	padding: 0px;
	border-radius: 50%;
}
.rdtDay.rdtToday.rdtActive,
.rdtDay.rdtActive,
.rdtDay.rdtActive:hover {
	background-color: #1c77c3 !important;
	color: #ffffff;
}

.rdtDays tr .dow {
	text-align: center;
	border-bottom: 1px solid #e3e3e3;
	font-size: 12px;
	text-transform: uppercase;
	font-weight: inherit;
	padding-bottom: 5px;
	padding-top: 10px;
}
.rdtDays tr .rdtOld,
.rdtDays tr .rdtNew {
	color: #dddddd;
}

.rdtPicker td.rdtDay:hover,
.rdtPicker td.rdtHour:hover,
.rdtPicker td.rdtMinute:hover,
.rdtPicker td.rdtSecond:hover,
.rdtPicker .rdtTimeToggle:hover {
	background: #eeeeee;
	cursor: pointer;
}

.rdtPicker td.rdtToday {
	position: relative;
}

.rdtPicker td.rdtActive.rdtToday:before {
	border-bottom-color: #fff;
}

.rdtPicker td.rdtDisabled,
.rdtPicker td.rdtDisabled:hover {
	background: none;
	color: #999999;
	cursor: not-allowed;
}

.rdtPicker td span.rdtOld {
	color: #999999;
}

.rdtPicker td span.rdtDisabled,
.rdtPicker td span.rdtDisabled:hover {
	background: none;
	color: #999999;
	cursor: not-allowed;
}

.rdtPicker .dow {
	width: 14.2857%;
	border-bottom: none;
}

.rdtPicker th.rdtSwitch {
	width: 50px;
	padding: 5px;
	border-radius: 4px;
}

.rdtPicker th.rdtNext,
.rdtPicker th.rdtPrev {
	font-size: 21px;
	vertical-align: top;
	border-radius: 50%;
	line-height: 33px;
}

.rdtPicker .dow,
.rdtPicker th.rdtSwitch,
.rdtPicker th.rdtNext,
.rdtPicker th.rdtPrev,
.rdtPicker .rdtTimeToggle {
	color: #1c77c3;
}

.rdtPrev span,
.rdtNext span {
	display: block;
	-webkit-touch-callout: none;
	/* iOS Safari */
	-webkit-user-select: none;
	/* Chrome/Safari/Opera */
	/* Konqueror */
	/* Firefox */
	/* Internet Explorer/Edge */
	user-select: none;
}

.rdtPicker th.rdtDisabled,
.rdtPicker th.rdtDisabled:hover {
	background: none;
	color: #999999;
	cursor: not-allowed;
}

.rdtPicker thead tr:first-child th {
	cursor: pointer;
}

.rdtPicker thead tr:first-child th:hover {
	background: #eeeeee;
}

.rdtPicker button {
	border: none;
	background: none;
	cursor: pointer;
}

.rdtPicker button:hover {
	background-color: #eee;
}

.rdtPicker thead button {
	width: 100%;
	height: 100%;
}

td.rdtMonth,
td.rdtYear {
	height: 50px;
	width: 25%;
	cursor: pointer;
}

td.rdtMonth:hover,
td.rdtYear:hover {
	background: #eee;
}

.rdtCounters {
	display: inline-block;
}

.rdtCounters > div {
	float: left;
	width: 40px;
	font-weight: inherit;
	margin: 3px;
	border-radius: 50%;
}
.rdtCounters .rdtCounterSeparator {
	width: 0;
	border: 1px solid transparent;
}

.rdtCounter {
	height: 100px;
}

.rdtCounter {
	width: 40px;
}
.rdtCounter .rdtCount {
	padding: 7px;
	height: 40px;
	border: 1px solid transparent;
}

.rdtCounters .rdtCounter:last-child .rdtCount {
	color: #1c77c3;
	border-radius: 50%;
	border: 1px solid #1c77c3;
}

.rdtCounterSeparator {
	padding: 7px;
	line-height: 100px;
}

.rdtCounter .rdtBtn {
	line-height: 40px;
	cursor: pointer;
	display: block;
	border-radius: 50%;
	color: #dddddd;
	transition: all 60ms ease-in;
	-webkit-touch-callout: none;
	/* iOS Safari */
	-webkit-user-select: none;
	/* Chrome/Safari/Opera */
	/* Konqueror */
	/* Firefox */
	/* Internet Explorer/Edge */
	user-select: none;
}

.rdtCounter .rdtBtn:hover {
	background: #eee;
	color: #797979;
}

.rdtCounter .rdtCount {
	font-size: inherit;
	line-height: 25px;
}

.rdtMilli {
	vertical-align: middle;
	padding-left: 8px;
	width: 48px;
}

.rdtMilli input {
	width: 100%;
	font-size: inherit;
	margin-top: 37px;
}

.rdtMonths,
.rdtYears {
	padding-bottom: 10px;
}
.rdtMonths .rdtMonth,
.rdtMonths .rdtYear,
.rdtYears .rdtMonth,
.rdtYears .rdtYear {
	display: inline-block;
	width: 56px;
	height: 56px;
	line-height: 56px;
	margin: 3px 3px;
	cursor: pointer;
	border-radius: 50%;
	text-align: center;
}
.rdtMonths .rdtMonth.rdtActive,
.rdtMonths .rdtYear.rdtActive,
.rdtYears .rdtMonth.rdtActive,
.rdtYears .rdtYear.rdtActive {
	background-color: #1c77c3 !important;
	color: #ffffff;
}

svg {
	touch-action: none;
}

.jvectormap-container {
	width: 100%;
	height: 100%;
	position: relative;
	overflow: hidden;
	touch-action: none;
}

.jvectormap-tip {
	position: absolute;
	display: none;
	border: solid 1px #cdcdcd;
	border-radius: 3px;
	background: #292929 !important;
	color: white;
	font-family: sans-serif, Verdana;
	font-size: smaller;
	padding: 3px;
}

.jvectormap-zoomin,
.jvectormap-zoomout,
.jvectormap-goback {
	position: absolute;
	left: 10px;
	border-radius: 3px;
	background: #292929 !important;
	padding: 3px;
	color: white;
	cursor: pointer;
	line-height: 10px;
	text-align: center;
	box-sizing: content-box;
}

.jvectormap-zoomin,
.jvectormap-zoomout {
	width: 10px;
	height: 10px;
}

.jvectormap-zoomin {
	top: 10px;
}

.jvectormap-zoomout {
	top: 30px;
}

.jvectormap-goback {
	bottom: 10px;
	z-index: 1000;
	padding: 6px;
}

.jvectormap-spinner {
	position: absolute;
	left: 0;
	top: 0;
	right: 0;
	bottom: 0;
	background: center no-repeat
		url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}

.jvectormap-legend-title {
	font-weight: bold;
	font-size: 14px;
	text-align: center;
}

.jvectormap-legend-cnt {
	position: absolute;
}

.jvectormap-legend-cnt-h {
	bottom: 0;
	right: 0;
}

.jvectormap-legend-cnt-v {
	top: 0;
	right: 0;
}

.jvectormap-legend {
	background: black;
	color: white;
	border-radius: 3px;
}

.jvectormap-legend-cnt-h .jvectormap-legend {
	float: left;
	margin: 0 10px 10px 0;
	padding: 3px 3px 1px 3px;
}

.jvectormap-legend-cnt-h .jvectormap-legend .jvectormap-legend-tick {
	float: left;
}

.jvectormap-legend-cnt-v .jvectormap-legend {
	margin: 10px 10px 0 0;
	padding: 3px;
}

.jvectormap-legend-cnt-h .jvectormap-legend-tick {
	width: 40px;
}

.jvectormap-legend-cnt-h .jvectormap-legend-tick-sample {
	height: 15px;
}

.jvectormap-legend-cnt-v .jvectormap-legend-tick-sample {
	height: 20px;
	width: 20px;
	display: inline-block;
	vertical-align: middle;
}

.jvectormap-legend-tick-text {
	font-size: 12px;
}

.jvectormap-legend-cnt-h .jvectormap-legend-tick-text {
	text-align: center;
}

.jvectormap-legend-cnt-v .jvectormap-legend-tick-text {
	display: inline-block;
	vertical-align: middle;
	line-height: 20px;
	padding-left: 3px;
}

/**
* React Select v1.0.0-rc.10
* ============
* Created by Jed Watson and Joss Mackison for KeystoneJS, https://www.keystonejs.com/
* https://twitter.com/jedwatson https://twitter.com/jossmackison https://twitter.com/keystonejs
* MIT License: https://github.com/JedWatson/react-select
*/
/*
This file was modified entirely by DealerClick for React-Select v2.0.0
*/
.react-select .react-select__menu {
	top: 105%;
	max-width: 94%;
	width: 94%;
	right: 3%;
	border-radius: 12px;
	border: 0;
	box-shadow: 1px 2px 7px 1px rgba(0, 0, 0, 0.125);
	transition: all 0.3s cubic-bezier(0.215, 0.61, 0.355, 1) 0s,
		opacity 0.3s ease 0s, height 0s linear 0.35s;
	background-color: #ffffff;
	box-sizing: border-box;
	max-height: 200px;
	position: absolute;
	z-index: 2;
	-webkit-overflow-scrolling: touch;
	padding-bottom: 10px;
	margin-bottom: 0;
	margin-bottom: initial;
	margin-top: 0;
	margin-top: initial;
}
.react-select .react-select__menu:before {
	border-bottom: 11px solid #f1eae0;
	top: -11px;
	border-left: 11px solid transparent;
	border-right: 11px solid transparent;
	content: "";
	display: inline-block;
	position: absolute;
	right: 15px;
}
.react-select .react-select__menu:after {
	top: -10px;
	border-bottom: 11px solid #fffcf5;
	border-left: 11px solid transparent;
	border-right: 11px solid transparent;
	content: "";
	display: inline-block;
	position: absolute;
	right: 15px;
}
.react-select .react-select__menu-list {
	max-height: 198px;
	overflow-y: auto;
	padding-bottom: 0;
	padding-bottom: initial;
	padding-top: 0;
	padding-top: initial;
	position: relative;
}
.react-select .react-select__option {
	font-size: 0.8571em;
	padding-top: 0.6rem;
	padding-bottom: 0.6rem;
	margin-top: 5px;
	transition: all 150ms linear;
	padding-left: 1.5rem;
	padding-right: 1.5rem;
	display: block;
	outline: none;
	color: #292b2c;
}
.react-select .react-select__menu .react-select__option,
.react-select .react-select__menu .react-select__option:active {
	background-color: transparent;
}
.react-select
	.react-select__menu
	.react-select__option.react-select__option--is-selected,
.react-select
	.react-select__menu
	.react-select__option.react-select__option--is-selected:active,
.react-select
	.react-select__menu
	.react-select__option.react-select__option--is-selected.react-select__option--is-focused,
.react-select
	.react-select__menu
	.react-select__option.react-select__option--is-selected.react-select__option--is-focused:active {
	background-color: #dddddd;
}
.react-select
	.react-select__menu
	.react-select__option.react-select__option--is-focused,
.react-select
	.react-select__menu
	.react-select__option.react-select__option--is-focused:active {
	background-color: #f5f5f5;
}
.react-select
	.react-select__menu
	.react-select__option.react-select__option--is-disabled,
.react-select
	.react-select__menu
	.react-select__option.react-select__option--is-disabled:active {
	color: #cccccc;
	cursor: default;
}
.react-select .react-select__control {
	border-radius: 4px;
	min-height: 40px;
	height: 40px;
	box-sizing: border-box;
	border-collapse: separate;
	display: table;
	width: 100%;
}
.react-select .react-select__control,
.react-select .react-select__control:hover {
	border: 1px solid #e3e3e3;
	box-shadow: none;
	background-color: transparent;
}
.react-select
	.react-select__control.react-select__control--is-focused
	.react-select__dropdown-indicator:after {
	transform: rotate(180deg);
	top: -4px;
}
.react-select .react-select__control.react-select__control--is-focused,
.react-select .react-select__control.react-select__control--is-focused:hover {
	border: 1px solid #1c77c3;
	box-shadow: none;
}
.react-select
	.react-select__control
	.react-select__value-container--has-value
	.react-select__multi-value {
	display: inline-flex;
	border-radius: 4px;
	background-color: transparent;
}
.react-select
	.react-select__control
	.react-select__value-container--has-value
	.react-select__multi-value
	+ div:not(.react-select__multi-value) {
	display: inline-flex;
}
.react-select
	.react-select__control
	.react-select__value-container--has-value
	.react-select__multi-value
	.react-select__multi-value__label {
	font-size: 0.9em;
}
.react-select
	.react-select__control
	.react-select__value-container--has-value
	.react-select__single-value {
	top: 48%;
	color: #2c2c2c;
}
.react-select .react-select__control .react-select__placeholder {
	color: #292929 !important;
	line-height: normal;
	font-size: 0.8571em;
	top: 48%;
}
.react-select .react-select__control .react-select__value-container,
.react-select .react-select__control .react-select__indicators {
	display: table-cell;
}
.react-select .react-select__control .react-select__indicators {
	width: 60px;
	padding-right: 10px;
	align-items: flex-end;
	vertical-align: middle;
	text-align: right;
}
.react-select
	.react-select__control
	.react-select__indicators
	.react-select__indicator-separator {
	display: none;
}
.react-select
	.react-select__control
	.react-select__indicators
	.react-select__indicator {
	padding: 0;
	display: inline-block;
}
.react-select
	.react-select__control
	.react-select__indicators
	.react-select__dropdown-indicator:after {
	transition: all 150ms ease 0s;
	border-color: #999 transparent transparent;
	border-style: solid;
	border-width: 5px 5px 2.5px;
	display: inline-block;
	height: 0;
	width: 0;
	position: relative;
	content: "";
}
.react-select
	.react-select__control
	.react-select__indicators
	.react-select__dropdown-indicator:hover:after {
	border-top-color: #666666;
}
.react-select
	.react-select__control
	.react-select__indicators
	.react-select__dropdown-indicator
	> * {
	display: none;
}
.react-select
	.react-select__control
	.react-select__indicators
	.react-select__clear-indicator:before {
	content: "×";
	display: inline-block;
	font-size: 18px;
	line-height: 1;
	top: 2px;
	position: relative;
	margin-right: 3px;
}
.react-select
	.react-select__control
	.react-select__indicators
	.react-select__clear-indicator
	> * {
	display: none;
}
.react-select.primary .react-select__control.react-select__control--is-focused,
.react-select.primary
	.react-select__control.react-select__control--is-focused:hover {
	border-color: #1c77c3;
}
.react-select.primary
	.react-select__control
	.react-select__value-container--has-value
	.react-select__single-value,
.react-select.primary
	.react-select__control
	.react-select__value-container--has-value
	.react-select__multi-value__label {
	color: #1c77c3;
}
.react-select.primary .react-select__multi-value {
	border: 1px solid #1c77c3;
}
.react-select.primary
	.react-select__multi-value
	.react-select__multi-value__remove {
	color: rgba(249, 99, 50, 0.3);
	border-left: 1px solid rgba(249, 99, 50, 0.3);
}
.react-select.primary
	.react-select__multi-value
	.react-select__multi-value__remove:hover {
	color: #1c77c3;
	background-color: transparent;
}
.react-select.success .react-select__control.react-select__control--is-focused,
.react-select.success
	.react-select__control.react-select__control--is-focused:hover {
	border-color: #28a745;
}
.react-select.success
	.react-select__control
	.react-select__value-container--has-value
	.react-select__single-value,
.react-select.success
	.react-select__control
	.react-select__value-container--has-value
	.react-select__multi-value__label {
	color: #28a745;
}
.react-select.success .react-select__multi-value {
	border: 1px solid #28a745;
}
.react-select.success
	.react-select__multi-value
	.react-select__multi-value__remove {
	color: rgba(24, 206, 15, 0.3);
	border-left: 1px solid rgba(24, 206, 15, 0.3);
}
.react-select.success
	.react-select__multi-value
	.react-select__multi-value__remove:hover {
	color: #28a745;
	background-color: transparent;
}
.react-select.info .react-select__control.react-select__control--is-focused,
.react-select.info
	.react-select__control.react-select__control--is-focused:hover {
	border-color: #39a9db;
}
.react-select.info
	.react-select__control
	.react-select__value-container--has-value
	.react-select__single-value,
.react-select.info
	.react-select__control
	.react-select__value-container--has-value
	.react-select__multi-value__label {
	color: #39a9db;
}
.react-select.info .react-select__multi-value {
	border: 1px solid #39a9db;
}
.react-select.info
	.react-select__multi-value
	.react-select__multi-value__remove {
	color: rgba(44, 168, 255, 0.3);
	border-left: 1px solid rgba(44, 168, 255, 0.3);
}
.react-select.info
	.react-select__multi-value
	.react-select__multi-value__remove:hover {
	color: #39a9db;
	background-color: transparent;
}
.react-select.warning .react-select__control.react-select__control--is-focused,
.react-select.warning
	.react-select__control.react-select__control--is-focused:hover {
	border-color: #ffc759;
}
.react-select.warning
	.react-select__control
	.react-select__value-container--has-value
	.react-select__single-value,
.react-select.warning
	.react-select__control
	.react-select__value-container--has-value
	.react-select__multi-value__label {
	color: #ffc759;
}
.react-select.warning .react-select__multi-value {
	border: 1px solid #ffc759;
}
.react-select.warning
	.react-select__multi-value
	.react-select__multi-value__remove {
	color: rgba(255, 178, 54, 0.3);
	border-left: 1px solid rgba(255, 178, 54, 0.3);
}
.react-select.warning
	.react-select__multi-value
	.react-select__multi-value__remove:hover {
	color: #ffc759;
	background-color: transparent;
}
.react-select.danger .react-select__control.react-select__control--is-focused,
.react-select.danger
	.react-select__control.react-select__control--is-focused:hover {
	border-color: #c1292e;
}
.react-select.danger
	.react-select__control
	.react-select__value-container--has-value
	.react-select__single-value,
.react-select.danger
	.react-select__control
	.react-select__value-container--has-value
	.react-select__multi-value__label {
	color: #c1292e;
}
.react-select.danger .react-select__multi-value {
	border: 1px solid #c1292e;
}
.react-select.danger
	.react-select__multi-value
	.react-select__multi-value__remove {
	color: rgba(255, 54, 54, 0.3);
	border-left: 1px solid rgba(255, 54, 54, 0.3);
}
.react-select.danger
	.react-select__multi-value
	.react-select__multi-value__remove:hover {
	color: #c1292e;
	background-color: transparent;
}
.react-select .react-select__multi-value {
	border: 1px solid #292929 !important;
}
.react-select .react-select__multi-value .react-select__multi-value__remove {
	position: relative;
	color: rgba(222, 222, 222, 0.8);
	border-left: 1px solid rgba(222, 222, 222, 0.8);
}
.react-select
	.react-select__multi-value
	.react-select__multi-value__remove:hover {
	color: #292929 !important;
	background-color: transparent;
}
.react-select.react-select--is-disabled
	.react-select__multi-value--is-disabled
	.react-select__multi-value__remove {
	display: none;
}
.react-select.react-select--is-disabled
	.react-select__multi-value--is-disabled.react-select__multi-value {
	background-color: #fcfcfc;
	border: 1px solid #e3e3e3;
}
.react-select.react-select--is-disabled .react-select__control--is-disabled {
	background-color: #f9f9f9;
}

.ReactTable {
	position: relative;
	display: flex;
	flex-direction: column;
	background-color: transparent;
	overflow-x: auto;
}
.ReactTable.primary-pagination .-pagination .-btn {
	background-color: #1c77c3;
	color: #ffffff;
}
.ReactTable.primary-pagination .-pagination .-btn:hover,
.ReactTable.primary-pagination .-pagination .-btn:focus,
.ReactTable.primary-pagination .-pagination .-btn:active,
.ReactTable.primary-pagination .-pagination .-btn.active,
.ReactTable.primary-pagination .-pagination .-btn:active:focus,
.ReactTable.primary-pagination .-pagination .-btn:active:hover,
.ReactTable.primary-pagination .-pagination .-btn.active:focus,
.ReactTable.primary-pagination .-pagination .-btn.active:hover,
.show > .ReactTable.primary-pagination .-pagination .-btn.dropdown-toggle,
.show > .ReactTable.primary-pagination .-pagination .-btn.dropdown-toggle:focus,
.show
	> .ReactTable.primary-pagination
	.-pagination
	.-btn.dropdown-toggle:hover {
	background-color: #165c96 !important;
	color: #ffffff !important;
	box-shadow: none !important;
}
.ReactTable.primary-pagination .-pagination .-btn:not([data-action]):hover {
	box-shadow: none;
}
.ReactTable.primary-pagination .-pagination .-btn.disabled,
.ReactTable.primary-pagination .-pagination .-btn.disabled:hover,
.ReactTable.primary-pagination .-pagination .-btn.disabled:focus,
.ReactTable.primary-pagination .-pagination .-btn.disabled.focus,
.ReactTable.primary-pagination .-pagination .-btn.disabled:active,
.ReactTable.primary-pagination .-pagination .-btn.disabled.active,
.ReactTable.primary-pagination .-pagination .-btn:disabled,
.ReactTable.primary-pagination .-pagination .-btn:disabled:hover,
.ReactTable.primary-pagination .-pagination .-btn:disabled:focus,
.ReactTable.primary-pagination .-pagination .-btn:disabled.focus,
.ReactTable.primary-pagination .-pagination .-btn:disabled:active,
.ReactTable.primary-pagination .-pagination .-btn:disabled.active,
.ReactTable.primary-pagination .-pagination .-btn[disabled],
.ReactTable.primary-pagination .-pagination .-btn[disabled]:hover,
.ReactTable.primary-pagination .-pagination .-btn[disabled]:focus,
.ReactTable.primary-pagination .-pagination .-btn[disabled].focus,
.ReactTable.primary-pagination .-pagination .-btn[disabled]:active,
.ReactTable.primary-pagination .-pagination .-btn[disabled].active,
fieldset[disabled] .ReactTable.primary-pagination .-pagination .-btn,
fieldset[disabled] .ReactTable.primary-pagination .-pagination .-btn:hover,
fieldset[disabled] .ReactTable.primary-pagination .-pagination .-btn:focus,
fieldset[disabled] .ReactTable.primary-pagination .-pagination .-btn.focus,
fieldset[disabled] .ReactTable.primary-pagination .-pagination .-btn:active,
fieldset[disabled] .ReactTable.primary-pagination .-pagination .-btn.active {
	background-color: #1c77c3;
	border-color: #1c77c3;
}
.ReactTable.primary-pagination .-pagination .-btn.btn-simple {
	color: #1c77c3;
	border-color: #1c77c3;
}
.ReactTable.primary-pagination .-pagination .-btn.btn-simple:hover,
.ReactTable.primary-pagination .-pagination .-btn.btn-simple:focus,
.ReactTable.primary-pagination .-pagination .-btn.btn-simple:active {
	background-color: transparent;
	color: #165c96;
	border-color: #165c96;
	box-shadow: none;
}
.ReactTable.primary-pagination .-pagination .-btn.btn-link {
	color: #1c77c3;
}
.ReactTable.primary-pagination .-pagination .-btn.btn-link:hover,
.ReactTable.primary-pagination .-pagination .-btn.btn-link:focus,
.ReactTable.primary-pagination .-pagination .-btn.btn-link:active,
.ReactTable.primary-pagination .-pagination .-btn.btn-link:active:focus {
	background-color: transparent;
	color: #165c96;
	text-decoration: none;
	box-shadow: none;
}
.ReactTable.primary-pagination .-pagination .-btn:disabled {
	opacity: 0.5;
	filter: alpha(opacity=50);
	pointer-events: none;
	cursor: not-allowed;
}
.ReactTable.info-pagination .-pagination .-btn {
	background-color: #39a9db;
	color: #ffffff;
}
.ReactTable.info-pagination .-pagination .-btn:hover,
.ReactTable.info-pagination .-pagination .-btn:focus,
.ReactTable.info-pagination .-pagination .-btn:active,
.ReactTable.info-pagination .-pagination .-btn.active,
.ReactTable.info-pagination .-pagination .-btn:active:focus,
.ReactTable.info-pagination .-pagination .-btn:active:hover,
.ReactTable.info-pagination .-pagination .-btn.active:focus,
.ReactTable.info-pagination .-pagination .-btn.active:hover,
.show > .ReactTable.info-pagination .-pagination .-btn.dropdown-toggle,
.show > .ReactTable.info-pagination .-pagination .-btn.dropdown-toggle:focus,
.show > .ReactTable.info-pagination .-pagination .-btn.dropdown-toggle:hover {
	background-color: #238ebe !important;
	color: #ffffff !important;
	box-shadow: none !important;
}
.ReactTable.info-pagination .-pagination .-btn:not([data-action]):hover {
	box-shadow: none;
}
.ReactTable.info-pagination .-pagination .-btn.disabled,
.ReactTable.info-pagination .-pagination .-btn.disabled:hover,
.ReactTable.info-pagination .-pagination .-btn.disabled:focus,
.ReactTable.info-pagination .-pagination .-btn.disabled.focus,
.ReactTable.info-pagination .-pagination .-btn.disabled:active,
.ReactTable.info-pagination .-pagination .-btn.disabled.active,
.ReactTable.info-pagination .-pagination .-btn:disabled,
.ReactTable.info-pagination .-pagination .-btn:disabled:hover,
.ReactTable.info-pagination .-pagination .-btn:disabled:focus,
.ReactTable.info-pagination .-pagination .-btn:disabled.focus,
.ReactTable.info-pagination .-pagination .-btn:disabled:active,
.ReactTable.info-pagination .-pagination .-btn:disabled.active,
.ReactTable.info-pagination .-pagination .-btn[disabled],
.ReactTable.info-pagination .-pagination .-btn[disabled]:hover,
.ReactTable.info-pagination .-pagination .-btn[disabled]:focus,
.ReactTable.info-pagination .-pagination .-btn[disabled].focus,
.ReactTable.info-pagination .-pagination .-btn[disabled]:active,
.ReactTable.info-pagination .-pagination .-btn[disabled].active,
fieldset[disabled] .ReactTable.info-pagination .-pagination .-btn,
fieldset[disabled] .ReactTable.info-pagination .-pagination .-btn:hover,
fieldset[disabled] .ReactTable.info-pagination .-pagination .-btn:focus,
fieldset[disabled] .ReactTable.info-pagination .-pagination .-btn.focus,
fieldset[disabled] .ReactTable.info-pagination .-pagination .-btn:active,
fieldset[disabled] .ReactTable.info-pagination .-pagination .-btn.active {
	background-color: #39a9db;
	border-color: #39a9db;
}
.ReactTable.info-pagination .-pagination .-btn.btn-simple {
	color: #39a9db;
	border-color: #39a9db;
}
.ReactTable.info-pagination .-pagination .-btn.btn-simple:hover,
.ReactTable.info-pagination .-pagination .-btn.btn-simple:focus,
.ReactTable.info-pagination .-pagination .-btn.btn-simple:active {
	background-color: transparent;
	color: #238ebe;
	border-color: #238ebe;
	box-shadow: none;
}
.ReactTable.info-pagination .-pagination .-btn.btn-link {
	color: #39a9db;
}
.ReactTable.info-pagination .-pagination .-btn.btn-link:hover,
.ReactTable.info-pagination .-pagination .-btn.btn-link:focus,
.ReactTable.info-pagination .-pagination .-btn.btn-link:active,
.ReactTable.info-pagination .-pagination .-btn.btn-link:active:focus {
	background-color: transparent;
	color: #238ebe;
	text-decoration: none;
	box-shadow: none;
}
.ReactTable.info-pagination .-pagination .-btn:disabled {
	opacity: 0.5;
	filter: alpha(opacity=50);
	pointer-events: none;
	cursor: not-allowed;
}
.ReactTable.success-pagination .-pagination .-btn {
	background-color: #28a745;
	color: #ffffff;
}
.ReactTable.success-pagination .-pagination .-btn:hover,
.ReactTable.success-pagination .-pagination .-btn:focus,
.ReactTable.success-pagination .-pagination .-btn:active,
.ReactTable.success-pagination .-pagination .-btn.active,
.ReactTable.success-pagination .-pagination .-btn:active:focus,
.ReactTable.success-pagination .-pagination .-btn:active:hover,
.ReactTable.success-pagination .-pagination .-btn.active:focus,
.ReactTable.success-pagination .-pagination .-btn.active:hover,
.show > .ReactTable.success-pagination .-pagination .-btn.dropdown-toggle,
.show > .ReactTable.success-pagination .-pagination .-btn.dropdown-toggle:focus,
.show
	> .ReactTable.success-pagination
	.-pagination
	.-btn.dropdown-toggle:hover {
	background-color: #0c492c !important;
	color: #ffffff !important;
	box-shadow: none !important;
}
.ReactTable.success-pagination .-pagination .-btn:not([data-action]):hover {
	box-shadow: none;
}
.ReactTable.success-pagination .-pagination .-btn.disabled,
.ReactTable.success-pagination .-pagination .-btn.disabled:hover,
.ReactTable.success-pagination .-pagination .-btn.disabled:focus,
.ReactTable.success-pagination .-pagination .-btn.disabled.focus,
.ReactTable.success-pagination .-pagination .-btn.disabled:active,
.ReactTable.success-pagination .-pagination .-btn.disabled.active,
.ReactTable.success-pagination .-pagination .-btn:disabled,
.ReactTable.success-pagination .-pagination .-btn:disabled:hover,
.ReactTable.success-pagination .-pagination .-btn:disabled:focus,
.ReactTable.success-pagination .-pagination .-btn:disabled.focus,
.ReactTable.success-pagination .-pagination .-btn:disabled:active,
.ReactTable.success-pagination .-pagination .-btn:disabled.active,
.ReactTable.success-pagination .-pagination .-btn[disabled],
.ReactTable.success-pagination .-pagination .-btn[disabled]:hover,
.ReactTable.success-pagination .-pagination .-btn[disabled]:focus,
.ReactTable.success-pagination .-pagination .-btn[disabled].focus,
.ReactTable.success-pagination .-pagination .-btn[disabled]:active,
.ReactTable.success-pagination .-pagination .-btn[disabled].active,
fieldset[disabled] .ReactTable.success-pagination .-pagination .-btn,
fieldset[disabled] .ReactTable.success-pagination .-pagination .-btn:hover,
fieldset[disabled] .ReactTable.success-pagination .-pagination .-btn:focus,
fieldset[disabled] .ReactTable.success-pagination .-pagination .-btn.focus,
fieldset[disabled] .ReactTable.success-pagination .-pagination .-btn:active,
fieldset[disabled] .ReactTable.success-pagination .-pagination .-btn.active {
	background-color: #28a745;
	border-color: #28a745;
}
.ReactTable.success-pagination .-pagination .-btn.btn-simple {
	color: #28a745;
	border-color: #28a745;
}
.ReactTable.success-pagination .-pagination .-btn.btn-simple:hover,
.ReactTable.success-pagination .-pagination .-btn.btn-simple:focus,
.ReactTable.success-pagination .-pagination .-btn.btn-simple:active {
	background-color: transparent;
	color: #0c492c;
	border-color: #0c492c;
	box-shadow: none;
}
.ReactTable.success-pagination .-pagination .-btn.btn-link {
	color: #28a745;
}
.ReactTable.success-pagination .-pagination .-btn.btn-link:hover,
.ReactTable.success-pagination .-pagination .-btn.btn-link:focus,
.ReactTable.success-pagination .-pagination .-btn.btn-link:active,
.ReactTable.success-pagination .-pagination .-btn.btn-link:active:focus {
	background-color: transparent;
	color: #0c492c;
	text-decoration: none;
	box-shadow: none;
}
.ReactTable.success-pagination .-pagination .-btn:disabled {
	opacity: 0.5;
	filter: alpha(opacity=50);
	pointer-events: none;
	cursor: not-allowed;
}
.ReactTable.warning-pagination .-pagination .-btn {
	background-color: #ffc759;
	color: #ffffff;
}
.ReactTable.warning-pagination .-pagination .-btn:hover,
.ReactTable.warning-pagination .-pagination .-btn:focus,
.ReactTable.warning-pagination .-pagination .-btn:active,
.ReactTable.warning-pagination .-pagination .-btn.active,
.ReactTable.warning-pagination .-pagination .-btn:active:focus,
.ReactTable.warning-pagination .-pagination .-btn:active:hover,
.ReactTable.warning-pagination .-pagination .-btn.active:focus,
.ReactTable.warning-pagination .-pagination .-btn.active:hover,
.show > .ReactTable.warning-pagination .-pagination .-btn.dropdown-toggle,
.show > .ReactTable.warning-pagination .-pagination .-btn.dropdown-toggle:focus,
.show
	> .ReactTable.warning-pagination
	.-pagination
	.-btn.dropdown-toggle:hover {
	background-color: #ffb626 !important;
	color: #ffffff !important;
	box-shadow: none !important;
}
.ReactTable.warning-pagination .-pagination .-btn:not([data-action]):hover {
	box-shadow: none;
}
.ReactTable.warning-pagination .-pagination .-btn.disabled,
.ReactTable.warning-pagination .-pagination .-btn.disabled:hover,
.ReactTable.warning-pagination .-pagination .-btn.disabled:focus,
.ReactTable.warning-pagination .-pagination .-btn.disabled.focus,
.ReactTable.warning-pagination .-pagination .-btn.disabled:active,
.ReactTable.warning-pagination .-pagination .-btn.disabled.active,
.ReactTable.warning-pagination .-pagination .-btn:disabled,
.ReactTable.warning-pagination .-pagination .-btn:disabled:hover,
.ReactTable.warning-pagination .-pagination .-btn:disabled:focus,
.ReactTable.warning-pagination .-pagination .-btn:disabled.focus,
.ReactTable.warning-pagination .-pagination .-btn:disabled:active,
.ReactTable.warning-pagination .-pagination .-btn:disabled.active,
.ReactTable.warning-pagination .-pagination .-btn[disabled],
.ReactTable.warning-pagination .-pagination .-btn[disabled]:hover,
.ReactTable.warning-pagination .-pagination .-btn[disabled]:focus,
.ReactTable.warning-pagination .-pagination .-btn[disabled].focus,
.ReactTable.warning-pagination .-pagination .-btn[disabled]:active,
.ReactTable.warning-pagination .-pagination .-btn[disabled].active,
fieldset[disabled] .ReactTable.warning-pagination .-pagination .-btn,
fieldset[disabled] .ReactTable.warning-pagination .-pagination .-btn:hover,
fieldset[disabled] .ReactTable.warning-pagination .-pagination .-btn:focus,
fieldset[disabled] .ReactTable.warning-pagination .-pagination .-btn.focus,
fieldset[disabled] .ReactTable.warning-pagination .-pagination .-btn:active,
fieldset[disabled] .ReactTable.warning-pagination .-pagination .-btn.active {
	background-color: #ffc759;
	border-color: #ffc759;
}
.ReactTable.warning-pagination .-pagination .-btn.btn-simple {
	color: #ffc759;
	border-color: #ffc759;
}
.ReactTable.warning-pagination .-pagination .-btn.btn-simple:hover,
.ReactTable.warning-pagination .-pagination .-btn.btn-simple:focus,
.ReactTable.warning-pagination .-pagination .-btn.btn-simple:active {
	background-color: transparent;
	color: #ffb626;
	border-color: #ffb626;
	box-shadow: none;
}
.ReactTable.warning-pagination .-pagination .-btn.btn-link {
	color: #ffc759;
}
.ReactTable.warning-pagination .-pagination .-btn.btn-link:hover,
.ReactTable.warning-pagination .-pagination .-btn.btn-link:focus,
.ReactTable.warning-pagination .-pagination .-btn.btn-link:active,
.ReactTable.warning-pagination .-pagination .-btn.btn-link:active:focus {
	background-color: transparent;
	color: #ffb626;
	text-decoration: none;
	box-shadow: none;
}
.ReactTable.warning-pagination .-pagination .-btn:disabled {
	opacity: 0.5;
	filter: alpha(opacity=50);
	pointer-events: none;
	cursor: not-allowed;
}
.ReactTable.danger-pagination .-pagination .-btn {
	background-color: #c1292e;
	color: #ffffff;
}
.ReactTable.danger-pagination .-pagination .-btn:hover,
.ReactTable.danger-pagination .-pagination .-btn:focus,
.ReactTable.danger-pagination .-pagination .-btn:active,
.ReactTable.danger-pagination .-pagination .-btn.active,
.ReactTable.danger-pagination .-pagination .-btn:active:focus,
.ReactTable.danger-pagination .-pagination .-btn:active:hover,
.ReactTable.danger-pagination .-pagination .-btn.active:focus,
.ReactTable.danger-pagination .-pagination .-btn.active:hover,
.show > .ReactTable.danger-pagination .-pagination .-btn.dropdown-toggle,
.show > .ReactTable.danger-pagination .-pagination .-btn.dropdown-toggle:focus,
.show > .ReactTable.danger-pagination .-pagination .-btn.dropdown-toggle:hover {
	background-color: #9f2226 !important;
	color: #ffffff !important;
	box-shadow: none !important;
}
.ReactTable.danger-pagination .-pagination .-btn:not([data-action]):hover {
	box-shadow: none;
}
.ReactTable.danger-pagination .-pagination .-btn.disabled,
.ReactTable.danger-pagination .-pagination .-btn.disabled:hover,
.ReactTable.danger-pagination .-pagination .-btn.disabled:focus,
.ReactTable.danger-pagination .-pagination .-btn.disabled.focus,
.ReactTable.danger-pagination .-pagination .-btn.disabled:active,
.ReactTable.danger-pagination .-pagination .-btn.disabled.active,
.ReactTable.danger-pagination .-pagination .-btn:disabled,
.ReactTable.danger-pagination .-pagination .-btn:disabled:hover,
.ReactTable.danger-pagination .-pagination .-btn:disabled:focus,
.ReactTable.danger-pagination .-pagination .-btn:disabled.focus,
.ReactTable.danger-pagination .-pagination .-btn:disabled:active,
.ReactTable.danger-pagination .-pagination .-btn:disabled.active,
.ReactTable.danger-pagination .-pagination .-btn[disabled],
.ReactTable.danger-pagination .-pagination .-btn[disabled]:hover,
.ReactTable.danger-pagination .-pagination .-btn[disabled]:focus,
.ReactTable.danger-pagination .-pagination .-btn[disabled].focus,
.ReactTable.danger-pagination .-pagination .-btn[disabled]:active,
.ReactTable.danger-pagination .-pagination .-btn[disabled].active,
fieldset[disabled] .ReactTable.danger-pagination .-pagination .-btn,
fieldset[disabled] .ReactTable.danger-pagination .-pagination .-btn:hover,
fieldset[disabled] .ReactTable.danger-pagination .-pagination .-btn:focus,
fieldset[disabled] .ReactTable.danger-pagination .-pagination .-btn.focus,
fieldset[disabled] .ReactTable.danger-pagination .-pagination .-btn:active,
fieldset[disabled] .ReactTable.danger-pagination .-pagination .-btn.active {
	background-color: #c1292e;
	border-color: #c1292e;
}
.ReactTable.danger-pagination .-pagination .-btn.btn-simple {
	color: #c1292e;
	border-color: #c1292e;
}
.ReactTable.danger-pagination .-pagination .-btn.btn-simple:hover,
.ReactTable.danger-pagination .-pagination .-btn.btn-simple:focus,
.ReactTable.danger-pagination .-pagination .-btn.btn-simple:active {
	background-color: transparent;
	color: #9f2226;
	border-color: #9f2226;
	box-shadow: none;
}
.ReactTable.danger-pagination .-pagination .-btn.btn-link {
	color: #c1292e;
}
.ReactTable.danger-pagination .-pagination .-btn.btn-link:hover,
.ReactTable.danger-pagination .-pagination .-btn.btn-link:focus,
.ReactTable.danger-pagination .-pagination .-btn.btn-link:active,
.ReactTable.danger-pagination .-pagination .-btn.btn-link:active:focus {
	background-color: transparent;
	color: #9f2226;
	text-decoration: none;
	box-shadow: none;
}
.ReactTable.danger-pagination .-pagination .-btn:disabled {
	opacity: 0.5;
	filter: alpha(opacity=50);
	pointer-events: none;
	cursor: not-allowed;
}

.ReactTable .actions-right {
	text-align: right;
	display: flex;
	justify-content: flex-end;
}
.ReactTable .actions-left {
	text-align: left;
}
.ReactTable .actions-center {
	text-align: center;
}

.ReactTable * {
	box-sizing: border-box;
}

.ReactTable .rt-table {
	flex: auto 1;
	display: -ms-flexbox;
	flex-direction: column;
	align-items: stretch;
	width: 100%;
	border-collapse: collapse;
	overflow: visible;
}

.ReactTable .rt-thead {
	flex: 1 0 auto;
	display: flex;
	flex-direction: column;
	-webkit-user-select: none;
	user-select: none;
}

.ReactTable .rt-thead.-headerGroups {
	background: rgba(0, 0, 0, 0.03);
	border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

.ReactTable .rt-thead.-filters input,
.ReactTable .rt-thead.-filters select {
	border: 1px solid #e3e3e3;
	border-radius: 4px;
	color: #565656;
	font-weight: 400;
	height: 28px;
	background-color: inherit;
	padding-left: 0.8em;
}
.ReactTable .rt-thead.-filters input:focus,
.ReactTable .rt-thead.-filters select:focus {
	outline: none;
	border: 1px solid #aaa;
	color: #333;
}

.ReactTable .rt-thead .rt-th:last-child {
	text-align: right;
}

.ReactTable .rt-thead .rt-th.-cursor-pointer > div:first-of-type:after {
	opacity: 0.6;
	content: "\\f0dc";
	position: relative;
	display: inline-block;
	bottom: 0px;
	right: -7px;
	font-family: "FontAwesome";
}

.ReactTable
	.rt-thead
	.rt-th.-cursor-pointer.-sort-desc
	> div:first-of-type:after {
	content: "\\f0dd";
	top: -3px;
	position: relative;
	display: inline-block;
	bottom: 0px;
	right: -7px;
	font-family: "FontAwesome";
	opacity: 1;
}

.ReactTable
	.rt-thead
	.rt-th.-cursor-pointer.-sort-asc
	> div:first-of-type:after {
	content: "\\f0de";
	top: 3px;
	position: relative;
	display: inline-block;
	bottom: 0px;
	right: -7px;
	font-family: "FontAwesome";
	opacity: 1;
}

.ReactTable .rt-thead .rt-th,
.ReactTable .rt-thead .rt-td {
	font-size: 1.063rem;
	text-align: left;
	font-weight: 300;
	line-height: 2.5em !important;
	padding: 5px 5px;
	line-height: normal;
	position: relative;
	transition: box-shadow 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
	box-shadow: inset 0 0 0 0 transparent;
}

.ReactTable .rt-thead .rt-th.-cursor-pointer,
.ReactTable .rt-thead .rt-td.-cursor-pointer {
	cursor: pointer;
}

.ReactTable .rt-thead .rt-th.-check-box,
.ReactTable .rt-thead .rt-td.-check-box {
	max-width: 40px;
}

.ReactTable .rt-thead .rt-th:last-child,
.ReactTable .rt-thead .rt-td:last-child {
	border-right: 0;
}

.ReactTable .rt-thead .rt-resizable-header {
	overflow: visible;
}

.ReactTable .rt-thead .rt-resizable-header:last-child {
	overflow: hidden;
}

.ReactTable .rt-thead .rt-resizable-header-content {
	overflow: hidden;
	text-overflow: ellipsis;
}
.ReactTable .rt-thead .rt-resizable-header-content:focus {
	outline: none;
}

.ReactTable .rt-thead .rt-header-pivot {
	border-right-color: #f7f7f7;
}

.ReactTable .rt-thead .rt-header-pivot:after,
.ReactTable .rt-thead .rt-header-pivot:before {
	left: 100%;
	top: 50%;
	border: solid transparent;
	content: " ";
	height: 0;
	width: 0;
	position: absolute;
	pointer-events: none;
}

.ReactTable .rt-thead .rt-header-pivot:after {
	border-color: rgba(255, 255, 255, 0);
	border-left-color: #fff;
	border-width: 8px;
	margin-top: -8px;
}

.ReactTable .rt-thead .rt-header-pivot:before {
	border-color: rgba(102, 102, 102, 0);
	border-left-color: #f7f7f7;
	border-width: 10px;
	margin-top: -10px;
}

.ReactTable .rt-tbody {
	flex: 99999 1 auto;
	width: auto;
	display: flex;
	flex-direction: column;
	overflow: visible;
}

@media screen and (max-width: 767px) {
	.ReactTable .rt-tbody {
		width: -webkit-fit-content;
		width: -moz-fit-content;
		width: fit-content;
	}
}

.ReactTable .rt-tbody .rt-tr-group:last-child {
	border-bottom: 0;
}

.ReactTable .rt-tbody .rt-td:last-child {
	border-right: 0;
}

.ReactTable .rt-tbody .rt-expandable {
	cursor: pointer;
}

.ReactTable .rt-tr-group {
	flex: 1 0 auto;
	display: flex;
	flex-direction: column;
	align-items: stretch;
}

.ReactTable .rt-tr {
	flex: 1 0 auto;
	display: inline-flex;
}

.ReactTable .rt-th,
.ReactTable .rt-td {
	flex: 1 0;
	white-space: nowrap;
	text-overflow: ellipsis;
	padding: 12px 7px;
	overflow: hidden;
	transition: 0.3s ease;
	transition-property: width, min-width, padding, opacity;
	line-height: 2;
}

.ReactTable .rt-th.-hidden,
.ReactTable .rt-td.-hidden {
	width: 0 !important;
	min-width: 0 !important;
	padding: 0 !important;
	border: 0 !important;
	opacity: 0 !important;
}

.ReactTable .rt-expander {
	display: inline-block;
	position: relative;
	margin: 0;
	color: transparent;
	margin: 0 10px;
}

.ReactTable .rt-expander:after {
	content: "";
	position: absolute;
	width: 0;
	height: 0;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%) rotate(-90deg);
	border-left: 5.04px solid transparent;
	border-right: 5.04px solid transparent;
	border-top: 7px solid rgba(0, 0, 0, 0.8);
	transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
	cursor: pointer;
}

.ReactTable .rt-expander.-open:after {
	transform: translate(-50%, -50%) rotate(0);
}

.ReactTable .rt-resizer {
	display: inline-block;
	position: absolute;
	width: 36px;
	top: 0;
	bottom: 0;
	right: -18px;
	cursor: col-resize;
	z-index: 10;
}

.ReactTable .rt-tfoot {
	flex: 1 0 auto;
	display: flex;
	flex-direction: column;
	box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.15);
}

.ReactTable .rt-tfoot .rt-td {
	border-right: 1px solid rgba(0, 0, 0, 0.05);
}

.ReactTable .rt-tfoot .rt-td:last-child {
	border-right: 0;
}

.ReactTable.-striped .rt-tr.-odd {
	background: rgba(0, 0, 0, 0.03);
}

.ReactTable.-highlight .rt-tbody .rt-tr:not(.-padRow):hover {
	background: rgba(214, 214, 214, 0.4);
}

.ReactTable .-pagination {
	z-index: 1;
	display: flex;
	justify-content: space-between;
	align-items: stretch;
	flex-wrap: wrap;
	padding: 3px;
}

.ReactTable .-pagination input,
.ReactTable .-pagination select {
	border: 1px solid #e3e3e3;
	border-radius: 4px;
	color: #565656;
	font-weight: 400;
	height: 28px;
	background-color: inherit;
	text-align: center;
}
.ReactTable .-pagination input:focus,
.ReactTable .-pagination select:focus {
	outline: none;
	border: 1px solid #aaa;
	color: #333;
}

.ReactTable .-pagination .-btn {
	-webkit-appearance: none;
	appearance: none;
	display: block;
	width: 100%;
	height: 100%;
	border: 0;
	border-radius: 3px;
	padding: 6px;
	font-size: 0.6em;
	font-weight: 600;
	color: #444;
	transition: all 0.1s ease;
	cursor: pointer;
	outline: none;
}

.ReactTable .-pagination .-btn[disabled] {
	opacity: 0.6;
	cursor: not-allowed;
}

.ReactTable .-pagination .-btn i {
	font-size: 28px;
}

.ReactTable .-pagination .-btn:not([disabled]):hover {
	background: rgba(0, 0, 0, 0.3);
	color: #fff;
}

.ReactTable .-pagination .-previous,
.ReactTable .-pagination .-next {
	flex: 1 1;
	text-align: center;
}

.ReactTable .-pagination .-center {
	flex: 1.5 1;
	text-align: center;
	margin-bottom: 0;
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	align-items: center;
	justify-content: space-around;
}

.ReactTable .-pagination .-pageInfo {
	display: inline-block;
	margin: 3px 10px;
	white-space: nowrap;
}

.ReactTable .-pagination .-pageJump {
	display: inline-block;
}

.ReactTable .-pagination .-pageSizeOptions {
	margin: 3px 10px;
}

.ReactTable .rt-noData {
	display: block;
	position: absolute;
	left: 50%;
	top: 50%;
	transform: translate(-50%, -50%);
	background: rgba(255, 255, 255, 0.8);
	transition: all 0.3s ease;
	z-index: 1;
	pointer-events: none;
	padding: 20px;
	color: rgba(0, 0, 0, 0.5);
}

.ReactTable .-loading {
	display: block;
	position: absolute;
	left: 0;
	right: 0;
	top: 0;
	bottom: 0;
	background: rgba(255, 255, 255, 0.8);
	transition: all 0.3s ease;
	z-index: -1;
	opacity: 0;
	pointer-events: none;
}

.ReactTable .-loading > div {
	position: absolute;
	display: block;
	text-align: center;
	width: 100%;
	top: 50%;
	left: 0;
	font-size: 15px;
	color: rgba(0, 0, 0, 0.6);
	transform: translateY(-52%);
	transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

.ReactTable .-loading.-active {
	opacity: 1;
	z-index: 2;
	pointer-events: all;
}

.ReactTable .-loading.-active > div {
	transform: translateY(50%);
}

.ReactTable .rt-resizing .rt-th,
.ReactTable .rt-resizing .rt-td {
	transition: none !important;
	cursor: col-resize;
	-webkit-user-select: none;
	user-select: none;
}

.ReactTable .rt-thead .rt-th:focus {
	outline: none;
}

.ReactTable .rt-thead .rt-th {
	font-size: 14px;
	font-weight: 600;
	text-transform: uppercase;
	border: 0;
}

.ReactTable .rt-table {
	border: 1px solid #dee2e6;
}

.ReactTable .rt-table .rt-td {
	border-top: 1px solid #dee2e6;
	border-right: 1px solid #dee2e6;
	text-align: center;
}

.ReactTable .rt-table .rt-td.-check-box {
	max-width: 40px;
}

.ReactTable .btn.btn-icon {
	margin: 0 3px;
	padding: 5px 8px;
}

.react-tagsinput {
	display: inline-block;
	padding: 4px 6px;
	max-width: 100%;
	line-height: 22px;
}

.react-tagsinput-tag {
	transition: all 0.17s linear;
	cursor: pointer;
	margin: 5px 3px 5px 0;
	position: relative;
	padding: 4px 8px 3px 0.8em;
	border-radius: 12px;
	color: #fff;
	font-size: 0.75em;
	font-weight: 500;
	display: inline-block;
	line-height: 1.5em;
	text-transform: uppercase;
	border: 1px solid;
}

.react-tagsinput-remove {
	cursor: pointer;
	font-weight: bold;
}

.react-tagsinput-tag a::before {
	font-family: "nucleo-icons";
	content: "\\ea4f";
	padding: 0px 2px;
}

.react-tagsinput-tag a {
	cursor: pointer;
	position: absolute;
	top: 3px;
	right: 0px;
	opacity: 0;
	background-color: transparent;
}

.react-tagsinput-input {
	background: transparent;
	border: 0;
	color: #777;
	font-family: sans-serif;
	font-size: 13px;
	font-weight: 400;
	margin-bottom: 6px;
	margin-top: 1px;
	outline: none;
	padding: 5px;
	width: 80px;
}

.react-tagsinput .react-tagsinput-tag {
	transition: all 300ms ease 0s;
	border-color: #65adff;
	background-color: #65adff;
}
.react-tagsinput .react-tagsinput-tag:hover {
	padding-right: 22px;
}
.react-tagsinput .react-tagsinput-tag:hover a {
	opacity: 1;
	padding-right: 4px;
}
.react-tagsinput .react-tagsinput-tag.primary {
	border-color: #1c77c3;
	background-color: #1c77c3;
}
.react-tagsinput .react-tagsinput-tag.info {
	border-color: #39a9db;
	background-color: #39a9db;
}
.react-tagsinput .react-tagsinput-tag.success {
	border-color: #28a745;
	background-color: #28a745;
}
.react-tagsinput .react-tagsinput-tag.warning {
	border-color: #ffc759;
	background-color: #ffc759;
}
.react-tagsinput .react-tagsinput-tag.danger {
	border-color: #c1292e;
	background-color: #c1292e;
}
.react-tagsinput .react-tagsinput-tag.neutral {
	border-color: #ffffff;
	background-color: #ffffff;
	color: inherit;
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/paper-dashboard.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;;;;;;;;;;;;;EAaE;AAKF;CACC,qBAAqB;CACrB,cAAc;CACd,eAAe;CACf,mBAAmB;CACnB,SAAS;CACT,kBAAkB;CAClB,gBAAgB;CAChB,gBAAgB;CAChB,kBAAkB;CAClB,gBAAgB;CAChB,sBAAsB;CACtB,YAAY;CACZ,aAAa;CACb,UAAU;CACV,iBAAiB;CACjB,yBAAyB;CAGzB,iBAAiB;CACjB,sBAAsB;CAGtB,wEAAwE;AACzE;;AAEA;CACC,oBAAoB;CACpB,MAAM;CACN,YAAY;CACZ,kBAAkB;CAElB,+BAA+B;CAC/B,uBAAuB;AACxB;;AAEA;;;CAKC,sBAAsB;CACtB,eAAe;CACf,gCAAgC;CAChC,YAAY;CACZ,WAAW;CACX,iBAAiB;CACjB,eAAe;CACf,iBAAiB;CACjB,iBAAiB;CAEjB,0BAA0B;AAC3B;AACA;;;CAGC,eAAe;CACf,iBAAiB;AAClB;;AAEA;;CAEC,kBAAkB;CAClB,UAAU;CACV,WAAW;CACX,qBAAqB;CACrB,yBAAyB;AAC1B;;AAEA;;CAEC,WAAW;CACX,mBAAmB;AACpB;;AAEA;;CAEC,WAAW;CACX,mBAAmB;AACpB;;AAEA;;CAEC,WAAW;CACX,mBAAmB;AACpB;;AAEA;;CAEC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;;CAEC,WAAW;CACX,mBAAmB;AACpB;;AAEA;CACC,WAAW;CACX,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ,cAAc;CACd,mBAAmB;CACnB,sBAAsB;CACtB,YAAY;CACZ,iBAAiB;CACjB,mBAAmB;CACnB,kBAAkB;CAClB,WAAW;CACX,UAAU;CACV,yBAAyB;CACzB,kEAAkE;AACnE;;AAEA;CACC,8BAA8B;CAC9B,2BAA2B;AAC5B;;AAEA;CACC,gBAAgB;AACjB;;AAEA;;CAEC,6BAA6B;CAC7B,MAAM;CACN,OAAO;CACP,UAAU;CACV,wBAAwB;CACxB,WAAW;AACZ;;AAEA;;CAEC,YAAY;AACb;;AAEA;;;CAGC,gBAAgB;CAChB,eAAe;CACf,gBAAgB;AACjB;;AAEA;;;CAGC,iBAAiB;CACjB,eAAe;CACf,gBAAgB;AACjB;;AAEA;;;CAGC,iBAAiB;CACjB,eAAe;CACf,iBAAiB;AAClB;;AAEA;;;CAGC,0BAA0B;AAC3B;;AAEA;;;;;;;;;CASC,YAAY;CACZ,yBAAyB;CACzB,0BAA0B;AAC3B;;AAEA;CAEC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;CAC5B,yBAAyB;CACzB,+BAA+B;CAC/B,4BAA4B;AAC7B;;AAEA;CACC,6BAA6B;CAC7B,0BAA0B;CAC1B,8BAA8B;CAC9B,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,sBAAsB;CACtB,iBAAiB;AAClB;;AAEA;CACC,sBAAsB;CACtB,6BAA6B;AAC9B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;;;;;CAKC,yBAAyB;AAC1B;;AAEA;;;;EAIE;AACF;CACC,2BAA2B;CAC3B,gCAAgC;CAChC,oCAAoC;CACpC,kBAAkB;AACnB;;AAEA;;;;;;CAMC,YAAY;AACb;;AAEA;;CAEC,mCAAmC;AACpC;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,yBAAyB;CACzB,kBAAkB;CAClB,0BAA0B;CAC1B,uBAAuB;AACxB;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;;CAEC,gBAAgB;AACjB;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,gBAAgB;CAChB,gBAAgB;CAChB,YAAY;AACb;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,SAAS;CACT,UAAU;CACV,SAAS;CACT,8BAA8B;AAC/B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,iBAAiB;CACjB,2BAA2B;CAC3B,mCAAmC;CACnC,+BAA+B;AAChC;;AAEA;;CAEC,YAAY;CACZ,iBAAiB;CACjB,mBAAmB;CACnB,gBAAgB;CAChB,uBAAuB;CACvB,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,0BAA0B;CAC1B,4BAA4B;CAC5B,mBAAmB;AACpB;;AAEA;CACC,yDAA4T;AAC7T;;AAEA;CACC,yDAAuQ;AACxQ;;AAEA;CACC,yDAAoQ;AACrQ;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,iBAAiB;AAClB;;AAEA,gCAAgC;AAChC;CACC,yBAAyB;AAC1B;;AAEA;CACC,kBAAkB;AACnB;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA;CACC,kBAAkB;AACnB;;AAEA;;CAEC,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,iBAAiB;CACjB,wBAAwB;AACzB;;AAEA;CACC,iBAAiB;CACjB,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,sBAAsB;AACvB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,cAAc;CACd,iBAAiB;CACjB,WAAW;CACX,mBAAmB;CACnB,wBAAwB;AACzB;;AAEA;;;CAGC,kBAAkB;CAClB,gBAAgB;CAChB,mBAAmB;CACnB,iBAAiB;AAClB;;AAEA;CACC,oBAAoB;CACpB,eAAe;AAChB;;AAEA;CACC,aAAa;CACb,kBAAkB;CAClB,SAAS;CACT,QAAQ;CACR,SAAS;CACT,OAAO;CACP,WAAW;CACX,sBAAsB;CACtB,kBAAkB;AACnB;;AAEA;CACC,iBAAiB;CACjB,qBAAqB;CACrB,cAAc;CACd,2BAA2B;AAC5B;;AAEA,wBAAwB;AACxB;CACC,sBAAsB;AACvB;;AAEA;;CAEC,sBAAsB;CACtB,sBAAsB;AACvB;;AAEA;CACC,gBAAgB;CAChB,iBAAiB;CACjB,cAAc;AACf;;AAEA;CACC,qBAAqB;CACrB,4BAA4B;AAC7B;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,2BAA2B;CAC3B,8BAA8B;AAC/B;;AAEA;CACC,4BAA4B;CAC5B,+BAA+B;AAChC;;AAEA;CACC,sBAAsB;CACtB,6BAA6B;AAC9B;;AAEA,wBAAwB;AACxB;CACC,UAAU;CACV,SAAS;AACV;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,mBAAmB;CACnB,gBAAgB;CAChB,qBAAqB;AACtB;;AAEA;CACC,QAAQ;CACR,UAAU;AACX;;AAEA,8BAA8B;AAC9B;CACC,WAAW;CACX,aAAa;AACd;;AAEA;CACC,MAAM;CACN,OAAO;CACP,kBAAkB;CAClB,YAAY;CACZ,aAAa;CACb,gBAAgB;AACjB;;AAEA,6BAA6B;AAC7B;;CAEC,WAAW;CACX,cAAc;CACd,WAAW;AACZ;;AAEA;CACC,eAAe;CACf,MAAM;CACN,OAAO;CACP,aAAa;CACb,sBAAsB;CACtB,gBAAgB;AACjB;;AAEA;CACC,wCAAwC;CACxC,2CAA2C;CAC3C,iBAAiB;AAClB;;AAEA,8CAA8C;AAC9C;;;EAGE;AACF;;CAEC,2BAA2B;CAC3B,6CAA6C;CAC7C,yBAAyB;CAEzB,kBAAkB;CAGlB,iBAAiB;CAEjB,sBAAsB;AACvB;;AAEA;CACC,kBAAkB;CAClB,cAAc;AACf;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,UAAU;CACV,YAAY;AACb;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,MAAM;CACN,OAAO;CACP,SAAS;AACV;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,QAAQ;AACT;;AAEA;CACC,kBAAkB;CAClB,UAAU;AACX;;AAEA;;CAGC,wDAAwD;AACzD;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;;EAEE;AACF;;CAGC,+BAA+B;AAChC;;AAEA;EACE;AACF;CACC,WAAW;AACZ;;AAEA;CACC,iBAAiB;CACjB,iBAAiB;CAEjB,WAAW;CAQX,oBAAoB;CAEpB,yBAAyB;CAEzB,iBAAiB;CAEjB,UAAU;CACV,8DAA8D;CAC9D,QAAQ;CACR,wHAAwH;CACxH,UAAU;CACV,kBAAkB;CAClB,iEAAiE;CACjE,YAAY;CACZ,WAAW;CACX,eAAe;CACf,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,UAAU;CACV,UAAU;AACX;;AAEA;EACE;AACF;CACC,yBAAyB;CACzB,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,kBAAkB;CAElB,4BAA4B;AAC7B;;AAEA;EACE;AACF;CACC,iBAAiB;AAClB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,eAAe;CACf,4EAA4E;AAC7E;;AAEA;CACC,yEAAyE;AAC1E;;AAEA;EACE;AACF;EACE;AACF;CACC,mBAAmB;AACpB;;AAEA;;;CAGC,mBAAmB;AACpB;;AAEA;;EAEE;AACF;;CAGC,sBAAsB;AACvB;;AAEA;CACC,kBAAkB;CAClB,WAAW;AACZ;;AAEA;;EAEE;AACF;CACC,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,eAAe;AAChB;;AAEA;;EAEE;AACF;CACC,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;;EAEE;AACF;CACC,eAAe;CACf,YAAY;CACZ,SAAS;CACT,OAAO;CACP,WAAW;AACZ;;AAEA;CAEC,oCAAoC;AACrC;;AAEA;CACC,iBAAiB;CACjB,UAAU;CACV,WAAW;AACZ;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,YAAY;AACb;;AAEA;;EAEE;AACF;CACC,eAAe;CACf,YAAY;CACZ,MAAM;CACN,UAAU;AACX;;AAEA;CAEC,iCAAiC;CACjC,kBAAkB;AACnB;;AAEA;CACC,UAAU;CACV,WAAW;CACX,gBAAgB;AACjB;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,cAAc;CACd,kBAAkB;CAClB,yBAAyB;CACzB,kBAAkB;CAClB,gBAAgB;CAChB,WAAW;CACX,YAAY;CACZ,kBAAkB;AACnB;;AAEA;CAEC,6BAA6B;CAC7B,SAAS;CACT,YAAY;AACb;;AAEA;CAEC,6BAA6B;CAC7B,QAAQ;CACR,WAAW;AACZ;;AAEA;;CAEC,yBAAyB;AAC1B;AACA;CACC,qBAAqB;AACtB;AACA;;CAEC,yBAAyB;AAC1B;AACA;CACC,qBAAqB;AACtB;AACA;;CAEC,yBAAyB;AAC1B;AACA;CACC,qBAAqB;AACtB;AACA;;CAEC,yBAAyB;AAC1B;AACA;CACC,qBAAqB;AACtB;;AAEA;;;;;CAKC;AACD;CAEC,sBAAsB;CAEtB,yBAAyB;AAC1B;;AAEA;CAEC,mCAAmC;AACpC;;AAEA;CAEC,sBAAsB;AACvB;;AAEA;;CAGC,yBAAyB;AAC1B;;AAEA;;CAGC,yBAAyB;AAC1B;AAwBA;CACC;;EAGC,+BAA+B;CAChC;CACA;;;;;EAMC,mCAAmC;CACpC;CACA;;;;EAKC,kCAAkC;CACnC;AACD;AACA;CAEC,qBAAqB;AACtB;AAcA;CACC;EACC,UAAU;EAEV,mCAAmC;CACpC;CACA;EACC,UAAU;EAEV,eAAe;CAChB;AACD;AACA;CAEC,0BAA0B;AAC3B;AAUA;CACC;EACC,UAAU;CACX;CACA;EACC,UAAU;CACX;AACD;AACA;CAEC,uBAAuB;AACxB;AAYA;CACC;EACC,UAAU;CACX;CACA;EACC,UAAU;EAEV,kCAAkC;CACnC;AACD;AACA;CAEC,2BAA2B;AAC5B;AAYA;CACC;EACC,UAAU;CACX;CACA;EACC,UAAU;EAEV,mCAAmC;CACpC;AACD;AACA;CAEC,yBAAyB;AAC1B;;AAEA,8BAA8B;AAC9B;CAEC,kBAAkB;CAClB,2BAA2B;CAC3B,wBAAwB;AACzB;;AAEA;CACC;EACC,yBAAyB;CAC1B;AACD;AACA;CACC;EACC,yBAAyB;CAC1B;AACD;AACA;;CAEC,cAAc;CACd,6BAA6B;AAC9B;;AAEA;CACC,sBAAsB;CACtB,YAAY;AACb;;AAEA;CACC,sBAAsB;CACtB,YAAY;AACb;;AAEA;CACC,sBAAsB;CACtB,YAAY;AACb;;AAEA;CACC,sBAAsB;CACtB,WAAW;AACZ;;AAEA;CACC,aAAa;CACb,kBAAkB;CAClB,mCAAmC;CACnC,UAAU;CAIV,6DAA6D;CAC7D,WAAW;CACX,mDAAmD;CACnD,YAAY;AACb;;AAEA;CACC,kBAAkB;CAClB,mCAAmC;CACnC,sBAAsB;CAGtB,kBAAkB;CAUlB;wDACuD;CAIvD,WAAW;CACX,8CAA8C;CAC9C,WAAW;AACZ;;AAEA;;CAEC,YAAY;AACb;;AAEA;CACC,aAAa;CACb,kBAAkB;CAClB,mCAAmC;CACnC,UAAU;CAIV,6DAA6D;CAC7D,QAAQ;CACR,kDAAkD;CAClD,WAAW;AACZ;;AAEA;CACC,kBAAkB;CAClB,mCAAmC;CACnC,sBAAsB;CAGtB,kBAAkB;CAUlB;wDACuD;CAIvD,UAAU;CACV,6CAA6C;CAC7C,UAAU;AACX;;AAEA;;CAEC,WAAW;AACZ;;AAEA;CACC,sBAAsB;CACtB,YAAY;AACb;;AAEA;;;CAGC,sBAAsB;CACtB,YAAY;AACb;;AAEA;CACC,sBAAsB;CACtB,YAAY;AACb;;AAEA;;;CAGC,sBAAsB;CACtB,WAAW;AACZ;;AAEA;;CAEC,YAAY;AACb;;AAEA;CACC,sBAAsB;CACtB,YAAY;AACb;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,sBAAsB;CACtB,YAAY;AACb;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,eAAe;CACf,OAAO;CACP,QAAQ;AACT;;AAEA;CAGC,aAAa;CAGb,mBAAmB;CACnB,eAAe;CACf,MAAM;CACN,OAAO;CACP,SAAS;CACT,QAAQ;CACR,aAAa;CACb,6BAA6B;CAC7B,aAAa;AACd;;AAEA;CAEC,iCAAiC;AAClC;;AAEA;CACC,oCAAoC;AACrC;;AAEA;CACC,sBAAsB;CACtB,2DAA2D;CAC3D,kBAAkB;CAElB,sBAAsB;CACtB,kBAAkB;CAClB,YAAY;CACZ,8CAA8C;CAC9C,kBAAkB;CAClB,gBAAgB;CAChB,aAAa;CACb,kBAAkB;CAClB,eAAe;AAChB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,oBAAoB;CACpB,kBAAkB;CAClB,iBAAiB;CACjB,UAAU;CACV,cAAc;CACd,qBAAqB;AACtB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,YAAY;CACZ,eAAe;AAChB;;AAEA;CAEC,sBAAsB;CACtB,6BAA6B;CAC7B,yBAAyB;CACzB,WAAW;CACX,YAAY;CACZ,UAAU;CACV,aAAa;CACb,mBAAmB;CACnB,wCAAwC;CACxC,kBAAkB;CAClB,eAAe;CACf,mBAAmB;CAEnB,wDAAwD;CACxD,yBAAyB;CAGzB,iBAAiB;AAClB;;AAEA;CACC,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;;;CAGC,qBAAqB;CACrB,WAAW;CACX,gBAAgB;CAChB,oBAAoB;CACpB,YAAY;CACZ,WAAW;CACX,yBAAyB;CAEzB,4BAA4B;CAC5B,+BAA+B;CAC/B,kBAAkB;CAElB,wDAAwD;AACzD;;AAEA;CACC,SAAS;CACT,kBAAkB;CAElB,gBAAgB;CAChB,WAAW;CACX,eAAe;CACf,eAAe;CACf,gBAAgB;CAChB,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,aAAa;CAEb,6DAA6D;AAC9D;;AAEA;CACC,iBAAiB;CACjB,eAAe;AAChB;;AAEA;CACC,uBAAuB;CACvB,SAAS;CACT,SAAS;CACT,UAAU;CACV,WAAW;CACX,YAAY;CACZ,eAAe;CACf,iBAAiB;CACjB,kBAAkB;CAClB,kBAAkB;CAClB,QAAQ;CACR,UAAU;CACV,eAAe;CACf,cAAc;CAEd,2BAA2B;AAC5B;;AAEA;CACC,WAAW;AACZ;;AAEA;;;;;;CAMC,aAAa;AACd;;AAEA;CACC,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,kBAAkB;CAClB,WAAW;CACX,SAAS;CACT,UAAU;CACV,mBAAmB;CACnB,cAAc;CACd,qBAAqB;AACtB;;AAEA;;;;;;CAMC,iBAAiB;AAClB;;AAEA;;;CAGC,WAAW;CAEX,sBAAsB;CACtB,eAAe;CACf,kBAAkB;CAClB,yBAAyB;CAEzB,+CAA+C;CAG/C,8CAA8C;AAE/C;;AAEA;;;CAGC,gCAAgC;CAEhC,sCAAsC;AACvC;;AAEA;;;CAGC,aAAa;CACb,yBAAyB;CAEzB,2BAA2B;AAC5B;;AAcA;;;CAGC,cAAc;AACf;;AAEA;CACC,WAAW;CACX,UAAU;AACX;;AAEA;CACC,YAAY;CACZ,UAAU;CACV,eAAe;CACf,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;;CAEC,YAAY;CACZ,iBAAiB;CACjB,sBAAsB;CACtB,iBAAiB;CACjB,UAAU;AACX;;AAEA;CACC,YAAY;CACZ,eAAe;AAChB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,aAAa;CACb,aAAa;AACd;;AAEA;CACC,cAAc;CACd,kBAAkB;CAClB,iBAAiB;CACjB,cAAc;CACd,eAAe;AAChB;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,iBAAiB;AAClB;;AAEA;;CAEC,sBAAsB;AACvB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,cAAc;AACf;;AAEA;;CAEC,sBAAsB;AACvB;;AAEA;CACC,yBAAyB;CACzB,eAAe;CACf,gBAAgB;CAChB,aAAa;CACb,WAAW;CACX,eAAe;CACf,gBAAgB;CAChB,aAAa;AACd;;AAEA;CACC,YAAY;CACZ,qBAAqB;CACrB,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,yBAAyB;CACzB,WAAW;CACX,iBAAiB;CACjB,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC;EACC,sBAAsB;CACvB;;CAEA;EACC,aAAa;CACd;AACD;AACA;CACC;EACC,sBAAsB;CACvB;;CAEA;EACC,aAAa;CACd;AACD;AACA;CACC,WAAW;CACX,YAAY;CACZ,6BAA6B;CAC7B,kBAAkB;CAClB,sBAAsB;CACtB,UAAU;CACV,kBAAkB;CAElB,uBAAuB;CACvB,eAAe;CACf,yBAAyB;CAGzB,iBAAiB;AAClB;;AAEA;CACC,oCAAoC;AACrC;;AAEA;CACC,kBAAkB;CAClB,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,WAAW;CACX,yBAAyB;CACzB,cAAc;CACd,SAAS;CACT,kBAAkB;AACnB;;AAEA;CAEC,wBAAwB;CACxB,UAAU;AACX;;AAEA;CAEC,yBAAyB;CACzB,WAAW;AACZ;;AAEA;CACC,2DAA2D;CAC3D,cAAc;CACd,qBAAqB;CACrB,eAAe;CACf,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,oCAAoC;CACpC,cAAc;CACd,qBAAqB;CACrB,eAAe;CACf,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,2DAA2D;CAC3D,cAAc;CACd,qBAAqB;CACrB,eAAe;CACf,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,WAAW;CACX,aAAa;CAEb,wBAAwB;AACzB;;AAEA;;CAEC,8BAA8B;CAC9B,SAAS;CACT,WAAW;CAEX,yBAAyB;CAEzB,2BAA2B;AAC5B;;AAEA;;CAEC,8BAA8B;CAC9B,UAAU;CACV,UAAU;CAEV,yBAAyB;CAEzB,wBAAwB;AACzB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,wCAAwC;CACxC,kBAAkB;CAElB,uBAAuB;CACvB,kBAAkB;CAClB,UAAU;CACV,SAAS;CACT,UAAU;AACX;;AAEA;CACC,UAAU;CACV,YAAY;CACZ,kBAAkB;CAClB,UAAU;CACV,QAAQ;CACR,UAAU;CAEV,yBAAyB;AAC1B;;AAEA;CACC,WAAW;CACX,yBAAyB;CACzB,cAAc;CACd,kBAAkB;CAClB,kBAAkB;CAClB,UAAU;AACX;;AAEA;CACC,WAAW;CACX,UAAU;CACV,SAAS;CAET,wBAAwB;AACzB;;AAEA;CACC,WAAW;CACX,UAAU;CACV,SAAS;CAET,yBAAyB;AAC1B;;AAEA;CACC,gBAAgB;CAChB,gBAAgB;CAChB,UAAU;AACX;;AAEA;CACC,qBAAqB;CACrB,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,kBAAkB;CAClB,WAAW;CACX,WAAW;CACX,gBAAgB;CAChB,kBAAkB;CAClB,UAAU;CACV,WAAW;AACZ;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;;;CAGC,mBAAmB;AACpB;;AAEA;;;CAGC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;CACnB,aAAa;CACb,cAAc;CACd,WAAW;AACZ;;AAEA;CACC,wCAAwC;AACzC;AAoBA;CACC;EAEC,qBAAqB;CACtB;CACA;EAEC,sBAAsB;CACvB;CACA;EAEC,sBAAsB;CACvB;CACA;EAEC,mBAAmB;CACpB;AACD;AAaA;CACC;EAEC,mBAAmB;EACnB,UAAU;CACX;CACA;EAEC,qBAAqB;EACrB,UAAU;CACX;AACD;AACA;CAEC,8BAA8B;AAC/B;;AAEA;CAEC,eAAe;AAChB;;AAEA;CAEC,wCAAwC;AACzC;;AAEA;CAEC,eAAe;AAChB;AA6BA;CACC;EACC,QAAQ;EACR,SAAS;EACT,SAAS;CACV;CACA;EACC,QAAQ;EACR,SAAS;EACT,SAAS;CACV;CACA;EACC,WAAW;EACX,UAAU;EACV,SAAS;CACV;CACA;EACC,WAAW;EACX,UAAU;EACV,SAAS;CACV;CACA;EACC,WAAW;EACX,UAAU;EACV,SAAS;CACV;AACD;AAuBA;CACC;EACC,QAAQ;EACR,WAAW;EACX,SAAS;CACV;CACA;EACC,QAAQ;EACR,WAAW;EACX,SAAS;CACV;CACA;EACC,WAAW;EACX,QAAQ;EACR,SAAS;CACV;CACA;EACC,WAAW;EACX,UAAU;EACV,SAAS;CACV;AACD;AAmBA;CACC;EAEC,yBAAyB;CAC1B;CACA;EAEC,yBAAyB;CAC1B;CACA;EAEC,0BAA0B;CAC3B;CACA;EAEC,0BAA0B;CAC3B;AACD;AACA;CAEC,oCAAoC;AACrC;;AAEA;CAEC,qCAAqC;AACtC;;AAEA;CAEC,0CAA0C;AAC3C;AAcA;CACC;EAEC,0BAA0B;EAC1B,UAAU;CACX;CACA;EAEC,wBAAwB;EACxB,UAAU;CACX;AACD;AACA;CAEC,kCAAkC;AACnC;AA2BA;CACC;EAEC,qBAAqB;EACrB,gBAAgB;EAChB,UAAU;CACX;CACA;EAEC,qBAAqB;EACrB,gBAAgB;EAChB,UAAU;CACX;CACA;EAEC,sBAAsB;EACtB,gBAAgB;CACjB;CACA;EAEC,mBAAmB;EACnB,aAAa;EACb,UAAU;CACX;AACD;AACA;CAEC,8BAA8B;AAC/B;AAYA;CACC;EAEC,uBAAuB;CACxB;CACA;EAEC,yBAAyB;CAC1B;AACD;AACA;CACC,iBAAiB;CACjB,8CAA8C;CAC9C,UAAU;CAKV,4BAA4B;AAC7B;AACA;CACC,UAAU;AACX;AACA;CACC,0BAA0B;CAC1B,oBAAoB;AACrB;AACA;CACC,aAAa;AACd;AACA;;;;;;CAMC,6BAA6B;CAC7B,gBAAgB;AACjB;AACA;CACC,kBAAkB;CAClB,eAAe;CACf,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,aAAa;CACb,mBAAmB;CAEnB,uBAAuB;AACxB;AACA;;CAEC,qBAAqB;CACrB,eAAe;CACf,mBAAoB;CAApB,oBAAoB;CACpB,iBAAiB;CACjB,UAAU;CACV,sBAAsB;AACvB;AACA;CACC,YAAY;CACZ,aAAa;CACb,yBAAyB;CACzB,yBAAyB;CACzB,cAAc;CACd,kBAAkB;CAClB,gBAAgB;CAChB,gBAAgB;CAChB,oBAAoB;CACpB,4BAA4B;AAC7B;AACA;CACC,qBAAqB;AACtB;AACA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,aAAa;CACb,eAAe;CACf,yBAAyB;CACzB,4CAA4C;CAC5C,QAAQ;CACR,SAAS;CACT,yBAAyB;CACzB,8CAA8C;CAC9C,yBAAyB;CACzB,eAAe;CACf,gBAAgB;AACjB;AACA;CACC,cAAc;AACf;AACA;CACC,qBAAqB;AACtB;AACA;;CAEC,qBAAqB;CACrB,cAAc;AACf;AACA;;;;;CAKC,yBAAyB;AAC1B;AACA;CACC,yBAAyB;AAC1B;AACA;;;;CAIC,qBAAqB;AACtB;AACA;CACC,cAAc;AACf;AACA;CACC,qBAAqB;AACtB;AACA;;CAEC,qBAAqB;CACrB,cAAc;AACf;AACA;;;;;CAKC,yBAAyB;AAC1B;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,qBAAqB;AACtB;AACA;CACC,cAAc;AACf;AACA;CACC,qBAAqB;AACtB;AACA;;CAEC,qBAAqB;CACrB,cAAc;AACf;AACA;;;;;CAKC,yBAAyB;AAC1B;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,qBAAqB;AACtB;AACA;CACC,cAAc;AACf;AACA;CACC,qBAAqB;AACtB;AACA;;CAEC,qBAAqB;CACrB,cAAc;AACf;AACA;;;;;CAKC,yBAAyB;AAC1B;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,qBAAqB;AACtB;AACA;CACC,cAAc;AACf;AACA;CACC,qBAAqB;AACtB;AACA;;CAEC,qBAAqB;CACrB,cAAc;AACf;AACA;;;;;CAKC,yBAAyB;AAC1B;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,qBAAqB;AACtB;AACA;CACC,cAAc;AACf;AACA;CACC,qBAAqB;AACtB;AACA;;CAEC,qBAAqB;CACrB,cAAc;AACf;AACA;;;;;CAKC,yBAAyB;AAC1B;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,qBAAqB;AACtB;AACA;CACC,eAAe;CACf,cAAc;CACd,YAAY;CACZ,OAAO;CACP,qBAAqB;CACrB,kBAAkB;CAClB,MAAM;CACN,WAAW;AACZ;AACA;CACC,WAAW;AACZ;AACA;CACC,iBAAiB;CACjB,eAAe;AAChB;AACA;CACC,eAAe;AAChB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,aAAa;AACd;AACA;CACC,kBAAkB;CAClB,oBAAoB;AACrB;AACA;CACC,eAAe;AAChB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,mBAAmB;AACpB;AACA;CACC,kBAAkB;CAClB,eAAe;CACf,gBAAgB;AACjB;AACA;CACC,oBAAoB;CACpB,mBAAmB;CACnB,YAAY;AACb;AACA;CACC,kBAAkB;CAClB,sBAAsB;CACtB,aAAa;CACb,YAAY;CACZ,kBAAkB;CAClB,cAAc;CACd,mBAAmB;CACnB,yBAAyB;CACzB,oBAAoB;CACpB,4BAA4B;AAC7B;AACA;CACC,eAAe;CACf,kBAAkB;CAClB,kBAAkB;CAClB,OAAO;CACP,QAAQ;AACT;AACA;;CAEC,qBAAqB;AACtB;AACA;;CAEC,kBAAkB;CAClB,cAAc;CACd,WAAW;AACZ;AACA;CACC,aAAa;AACd;AACA;CACC,eAAe;CACf,mBAAmB;AACpB;AACA;CACC,SAAS;AACV;AACA;CACC,oCAAoC;AACrC;AACA;CACC,cAAc;AACf;AACA;CACC,oBAAoB;CACpB,gBAAgB;CAChB,iBAAiB;CACjB,yBAAyB;CACzB,eAAe;CACf,gBAAgB;CAChB,gBAAgB;CAChB,kBAAkB;CAClB,yBAAyB;AAC1B;AACA;;;;;CAKC,yBAAyB;CACzB,gBAAgB;AACjB;AACA;CACC,cAAc;CACd,eAAe;CACf,eAAe;AAChB;AACA;CACC,gBAAgB;AACjB;AACA;;CAMC,4CAA4C;AAC7C;;AAEA;;;;EAIE;AACF;;;;;;;;;;;;;CAaC,kBAAkB;CAClB,UAAU;CACV,WAAW;CACX,YAAY;CACZ,UAAU;CACV,gBAAgB;CAChB,sBAAsB;CACtB,SAAS;AACV;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,YAAY;CACZ,WAAW;AACZ;;AAEA;CACC;EACC,WAAW;CACZ;AACD;AACA;CACC;EACC,WAAW;CACZ;AACD;AACA;CACC;EACC,WAAW;CACZ;AACD;AACA;CACC,iCAAiC;CACjC,mCAAmC;CACnC,oCAAoC;CACpC,WAAW;CACX,qBAAqB;CACrB,kBAAkB;CAClB,WAAW;CACX,UAAU;CACV,UAAU;AACX;;AAEA;CACC,iCAAiC;CACjC,mCAAmC;CACnC,oCAAoC;CACpC,WAAW;CACX,qBAAqB;CACrB,kBAAkB;CAClB,WAAW;CACX,UAAU;CACV,UAAU;AACX;;AAEA;CACC,gBAAgB;CAChB,oBAAoB;AACrB;;AAEA;CACC,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,UAAU;CACV,UAAU;AACX;;AAEA;CACC,UAAU;CACV,UAAU;AACX;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,cAAc;CACd,eAAe;CACf,cAAc;CACd,6BAA6B;AAC9B;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA;CACC,6BAA6B;CAC7B,gCAAgC;AACjC;;AAEA;CACC,gBAAgB;AACjB;;AAEA;;;CAGC,WAAW;CACX,YAAY;CACZ,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;CAChB,WAAW;CACX,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,UAAU;AACX;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,gCAAgC;AACjC;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,uCAAuC;AACxC;;AAEA;CACC,UAAU;CACV,SAAS;CACT,YAAY;CACZ,WAAW;CACX,oBAAoB;AACrB;;AAEA;CACC,gBAAgB;CAChB,aAAa;CACb,WAAW;CACX,kBAAkB;CAClB,0BAA0B;AAC3B;;AAEA;CACC,WAAW;CACX,SAAS;AACV;;AAEA;;CAEC,kBAAkB;AACnB;;AAEA;CACC,YAAY;CACZ,iBAAiB;CACjB,WAAW;AACZ;;AAEA;CACC,YAAY;AACb;;AAEA;;CAEC,gBAAgB;CAChB,cAAc;CACd,mBAAmB;AACpB;;AAEA;;CAEC,kBAAkB;CAClB,YAAY;CACZ,WAAW;CACX,iBAAiB;CACjB,eAAe;CACf,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,kBAAkB;CAClB,gCAAgC;CAChC,eAAe;CACf,yBAAyB;CACzB,yBAAyB;CACzB,gBAAgB;CAChB,mBAAmB;CACnB,iBAAiB;AAClB;;AAEA;CACC,eAAe;AAChB;;AAEA;;;;;;CAMC,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ,iBAAiB;CACjB,WAAW;CACX,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;CAChB,YAAY;CACZ,iBAAiB;CACjB,cAAc;AACf;;AAEA;CACC,YAAY;CACZ,iBAAiB;CACjB,WAAW;CACX,kBAAkB;CAClB,YAAY;CACZ,kBAAkB;CAClB,cAAc;CACd,WAAW;CACX,kBAAkB;AACnB;;AAEA;CAKC,4BAA4B;AAC7B;;AAEA;;CAEC,kBAAkB;AACnB;;AAEA;;;;CAIC,mBAAmB;CACnB,eAAe;AAChB;;AAEA;;CAEC,cAAc;AACf;;AAEA;CACC,WAAW;CACX,qBAAqB;CACrB,qCAAqC;CACrC,4BAA4B;CAC5B,oCAAoC;CACpC,kBAAkB;CAClB,WAAW;CACX,UAAU;AACX;;AAEA;;CAEC,yBAAyB;CACzB,cAAc;AACf;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;;CAEC,gBAAgB;CAChB,cAAc;CACd,mBAAmB;AACpB;;AAEA;CACC,qBAAqB;CACrB,WAAW;CACX,YAAY;CACZ,iBAAiB;CACjB,eAAe;CACf,eAAe;CACf,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,yBAAyB;CACzB,cAAc;AACf;;AAEA;CACC,cAAc;AACf;;AAEA;;CAEC,gBAAgB;CAChB,cAAc;CACd,mBAAmB;AACpB;;AAEA;;;CAGC,6BAA6B;AAC9B;;AAEA;CACC,YAAY;CACZ,iBAAiB;AAClB;;AAEA;CACC,eAAe;AAChB;;AAEA;;;;;;CAMC,YAAY;CACZ,kBAAkB;CAClB,UAAU;CACV,eAAe;AAChB;;AAEA;CACC,UAAU;CAGV,yEAAyE;CAKzE,8CAA8C;AAC/C;AACA;CAKC,6CAA6C;CAC7C,UAAU;AACX;AACA;CACC,UAAU;CACV,iEAAiE;CAKjE,4CAA4C;AAC7C;;AAEA;CACC,UAAU;CAKV,6CAA6C;CAC7C,iEAAiE;AAClE;AACA;CACC,8BAA8B;CAC9B,mCAAmC;CACnC,oCAAoC;CACpC,WAAW;CACX,qBAAqB;CACrB,kBAAkB;CAClB,WAAW;CACX,aAAa;AACd;AACA;CACC,8BAA8B;CAC9B,mCAAmC;CACnC,oCAAoC;CACpC,WAAW;CACX,qBAAqB;CACrB,kBAAkB;CAClB,WAAW;CACX,aAAa;AACd;;AAEA;;;;;EAKE;AACF;;CAEC,wBAAwB;AACzB;;AAEA;CACC,YAAY;CACZ,gBAAgB;AACjB;AACA;CACC,WAAW;CACX,mBAAmB;CACnB,UAAU;AACX;AACA;CACC,6BAA6B;CAC7B,SAAS;CACT,SAAS;CACT,yBAAyB;CACzB,uBAAuB;CACvB,uBAAuB;CACvB,qBAAqB;CACrB,qBAAqB;CACrB,YAAY;AACb;AACA;CACC,MAAM;CACN,OAAO;CACP,yBAAyB;CACzB,sBAAsB;CACtB,UAAU;AACX;AACA;;CAEC,qBAAqB;AACtB;AACA;CACC,sBAAsB;AACvB;AACA;;;CAGC,YAAY;AACb;;AAEA;CACC,gBAAgB;CAChB,UAAU;CACV,YAAY;AACb;AACA;CACC,WAAW;AACZ;AACA;CACC,aAAa;AACd;AACA;;;;CAIC,gBAAgB;AACjB;;AAEA;;CAEC,WAAW;CACX,qBAAqB;CACrB,cAAc;AACf;AACA;;;CAGC,YAAY;AACb;AACA;;;CAGC,gBAAgB;AACjB;AACA;;CAEC,UAAU;AACX;AACA;;CAEC,YAAY;CACZ,kBAAkB;CAClB,oBAAoB;CACpB,sBAAsB;AACvB;AACA;CACC,WAAW;AACZ;AACA;;CAEC,mBAAmB;AACpB;AACA;;CAEC,wBAAwB;AACzB;AACA;CACC,kBAAkB;CAClB,oBAAoB;CACpB,qBAAqB;AACtB;AACA;CACC,aAAa;AACd;AACA;CACC,qBAAqB;CACrB,gBAAgB;CAChB,WAAW;CACX,gBAAgB;AACjB;AACA;CACC,WAAW;AACZ;AACA;CACC,eAAe;CAGf,sBAAsB;AACvB;AACA;CACC,gBAAgB;CAChB,WAAW;CACX,SAAS;CACT,UAAU;CACV,SAAS;AACV;AACA;CACC,kBAAkB;AACnB;AACA;CACC,WAAW;AACZ;AACA;CACC,mBAAmB;AACpB;AACA;CACC,cAAc;CACd,eAAe;CACf,0BAA0B;CAC1B,WAAW;CACX,mBAAmB;CACnB,WAAW;CACX,cAAc;AACf;AACA;CACC,yBAAyB;CACzB,+BAA+B;CAC/B,UAAU;CACV,qBAAqB;AACtB;AACA;CACC,kBAAkB;CAClB,oBAAoB;AACrB;AACA;CACC,aAAa;AACd;AACA;CACC,qBAAqB;AACtB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,kBAAkB;CAClB,WAAW;CACX,UAAU;CACV,YAAY;CACZ,gBAAgB;CAChB,gBAAgB;CAChB,sBAAsB;CACtB,yBAAyB;CAEzB,+CAA+C;CAC/C,oBAAoB;CACpB,YAAY;CAGZ,sBAAsB;AACvB;AACA;CACC,YAAY;CACZ,mBAAmB;CACnB,aAAa;CACb,mBAAmB;AACpB;AACA;CACC,gBAAgB;AACjB;AACA;;;;;CAKC,kBAAkB;CAClB,qBAAqB;CACrB,WAAW;CACX,eAAe;AAChB;AACA;CACC,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;AACA;CACC,WAAW;CACX,kCAAkC;CAClC,mCAAmC;CACnC,iDAAiD;CACjD,kBAAkB;CAClB,YAAY;CACZ,SAAS;CACT,aAAa;AACd;AACA;CACC,WAAW;CACX,kCAAkC;CAClC,mCAAmC;CACnC,8BAA8B;CAC9B,kBAAkB;CAClB,YAAY;CACZ,UAAU;CACV,aAAa;AACd;AACA;CACC,YAAY;CACZ,SAAS;CACT,8CAA8C;CAC9C,gBAAgB;AACjB;AACA;CACC,YAAY;CACZ,SAAS;CACT,2BAA2B;CAC3B,gBAAgB;AACjB;AACA;CACC,WAAW;CACX,UAAU;AACX;AACA;CACC,WAAW;CACX,UAAU;AACX;AACA;;CAEC,cAAc;AACf;;AAEA;;;CAGC,gBAAgB;AACjB;;AAEA;CACC,WAAW;CAGX,sBAAsB;AACvB;AACA;CACC,UAAU;AACX;;AAEA;CACC,WAAW;CACX,WAAW;CAGX,sBAAsB;AACvB;AACA;CACC,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;AACA;CACC,gBAAgB;CAChB,WAAW;CACX,WAAW;AACZ;;AAEA;CACC,iCAAiC;CACjC,mCAAmC;CACnC,oCAAoC;CACpC,WAAW;CACX,qBAAqB;CACrB,kBAAkB;CAClB,WAAW;CACX,SAAS;AACV;;AAEA;CACC,iCAAiC;CACjC,mCAAmC;CACnC,oCAAoC;CACpC,WAAW;CACX,qBAAqB;CACrB,kBAAkB;CAClB,WAAW;CACX,SAAS;AACV;;AAEA;CACC,8BAA8B;CAC9B,mCAAmC;CACnC,oCAAoC;CACpC,mBAAmB;CACnB,WAAW;CACX,UAAU;AACX;;AAEA;CACC,8BAA8B;CAC9B,mCAAmC;CACnC,oCAAoC;CACpC,mBAAmB;CACnB,WAAW;CACX,UAAU;AACX;;AAEA;CAKC,0CAA0C;AAC3C;AACA;;CAEC,aAAa;AACd;AACA;CAKC,8CAA8C;AAC/C;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,sBAAsB;AACvB;;AAEA;CACC,kBAAkB;CAClB,MAAM;CACN,QAAQ;CACR,WAAW;CACX,YAAY;CACZ,SAAS;CACT,eAAe;CACf,eAAe;CACf,wBAAwB;CACxB,UAAU;CACV,cAAc;AACf;;AAEA;CACC,qBAAqB;CACrB,kBAAkB;AACnB;;AAEA;CACC,qBAAqB;CACrB,gBAAgB;CAChB,mBAAmB;CACnB,gBAAgB;CAChB,sBAAsB;CACtB,YAAY;AACb;;AAEA;CACC,qBAAqB;CACrB,mBAAmB;CACnB,gBAAgB;CAChB,kBAAkB;CAClB,sBAAsB;CACtB,gBAAgB;CAChB,8CAA8C;AAC/C;AACA;CACC,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;;CAEC,aAAa;AACd;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,qBAAqB;CACrB,gBAAgB;CAChB,sBAAsB;AACvB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,UAAU;AACX;;AAEA;CACC,UAAU;AACX;;AAEA;;CAEC,0BAA0B;AAC3B;;AAEA;;;;CAIC,0BAA0B;AAC3B;;AAEA;;CAEC,0BAA0B;AAC3B;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,cAAc;CACd,kBAAkB;CAClB,UAAU;AACX;;AAEA;CACC,6BAA6B;CAC7B,qBAAqB;CACrB,gBAAgB;CAChB,sBAAsB;CACtB,kBAAkB;CAClB,WAAW;CACX,iBAAiB;CACjB,YAAY;AACb;AACA;CACC,YAAY;CACZ,gBAAgB;CAChB,aAAa;CACb,6BAA6B;CAC7B,cAAc;CACd,SAAS;CACT,WAAW;CACX,kBAAkB;AACnB;AACA;CACC,YAAY;CACZ,gBAAgB;AACjB;AACA;CACC,WAAW;CACX,UAAU;AACX;AACA;CACC,WAAW;AACZ;AACA;CACC,WAAW;AACZ;AACA;CACC,WAAW;AACZ;AACA;CACC,WAAW;AACZ;AACA;CACC,WAAW;AACZ;AACA;CAKC,4BAA4B;AAC7B;AACA;CACC,eAAe;CACf,qBAAqB;CACrB,kBAAkB;CAClB,0BAA0B;CAC1B,mBAAmB;CACnB,WAAW;CACX,iBAAiB;CACjB,gBAAgB;CAChB,qBAAqB;CACrB,kBAAkB;CAClB,yBAAyB;AAC1B;AACA;CACC,mBAAmB;AACpB;AACA;CACC,UAAU;CACV,kBAAkB;AACnB;AACA;CACC,eAAe;CACf,kBAAkB;CAClB,UAAU;CACV,QAAQ;CACR,UAAU;AACX;AACA;CACC,gBAAgB;CAChB,gBAAgB;CAChB,eAAe;CACf,6CAA6C;AAC9C;AACA;CACC,gDAAgD;CAChD,UAAU;AACX;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;;;;;;;;;;EAUE;AACF;CACC,WAAW;CACX,0BAA0B;CAC1B,6BAA6B;CAC7B,0BAA0B;CAC1B,oCAAoC;AACrC;;AAEA;;CAIC,uBAAuB;AACxB;;AAEA;;CAEC,kBAAkB;AACnB;;AAEA;;CAEC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;CACnB,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,WAAW;CACX,qBAAqB;AACtB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,mBAAmB;CACnB,mBAAmB;CACnB,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,WAAW;AACZ;;AAEA;CACC,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,SAAS;CACT,mBAAmB;CACnB,iBAAiB;AAClB;;AAEA;CACC,aAAa;CACb,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,SAAS;CACT,YAAY;CACZ,mBAAmB;CACnB,iBAAiB;CACjB,kBAAkB;CAClB,cAAc;AACf;;AAEA;;;;;;CAMC,mBAAmB;AACpB;;AAEA;;CAEC,aAAa;AACd;;AAEA;;;;;CAKC,eAAe;CACf,kBAAkB;AACnB;;AAEA;;;;;CAKC,kBAAkB;CAClB,WAAW;CACX,UAAU;CACV,cAAc;CACd,mCAAmC;CACnC,YAAY;AACb;;AAEA;CACC,YAAY;CACZ,gBAAgB;CAChB,SAAS;AACV;;AAEA;CACC,gBAAgB;CAChB,uBAAuB;AACxB;;AAEA;CACC,gBAAgB;CAChB,2BAA2B;AAC5B;;AAEA;;CAEC,WAAW;AACZ;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,gBAAgB;CAChB,wBAAwB;CACxB,2BAA2B;AAC5B;;AAEA;;;CAGC,aAAa;AACd;;AAEA;;CAEC,gBAAgB;AACjB;;AAEA;CACC,wBAAwB;CACxB,gBAAgB;AACjB;;AAEA;CACC;;;;EAIC,kBAAkB;CACnB;AACD;AACA;CACC,mBAAmB;AACpB;;AAEA;;;CAGC,QAAQ;CACR,UAAU;AACX;;AAEA;;CAEC,oBAAoB;AACrB;;AAEA;;;;CAIC,qBAAqB;AACtB;;AAEA;;CAEC,sBAAsB;AACvB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,SAAS;AACV;;AAEA;;;;CAIC,eAAe;AAChB;;AAEA;;;;CAIC,gBAAgB;AACjB;;AAEA;;;;;CAKC,kBAAkB;CAClB,qBAAqB;CACrB,WAAW;CACX,WAAW;CACX,0BAA0B;CAC1B,YAAY;AACb;AACA;;;;;CAKC,aAAa;AACd;AACA;CACC,YAAY;CACZ,gBAAgB;AACjB;AACA;CACC,gBAAgB;CAChB,QAAQ;AACT;AACA;CACC,gBAAgB;CAChB,SAAS;AACV;AACA;CACC,yBAAyB;AAC1B;AACA;;;;;;CAMC,uBAAuB;CACvB,UAAU;AACX;AACA;CACC,aAAa;CACb,gBAAgB;AACjB;;AAEA;CACC,UAAU;AACX;;AAEA;;;CAGC,0BAA0B;AAC3B;AACA;;;CAGC,wBAAwB;AACzB;AACA;;CAEC,kBAAkB;CAClB,kBAAkB;CAClB,eAAe;AAChB;AACA;;CAEC,QAAQ;CACR,gBAAgB;CAChB,SAAS;CACT,YAAY;CACZ,WAAW;CACX,cAAc;CACd,kBAAkB;CAClB,cAAc;CACd,uBAAuB;CACvB,mBAAmB;CACnB,wBAAwB;CACxB,uBAAuB;CACvB,kBAAkB;CAClB,8CAA8C;CAC9C,iBAAiB;CACjB,YAAY;CACZ,sBAAsB;AACvB;AACA;;;;;;;;CAQC,YAAY;CACZ,cAAc;AACf;AACA;CACC,aAAa;AACd;;AAEA;;CAEC,kBAAkB;AACnB;AACA;;;;;;;;CAQC,QAAQ;CACR,SAAS;CACT,YAAY;CACZ,WAAW;CACX,mBAAmB;CACnB,iBAAiB;CACjB,gBAAgB;AACjB;;AAEA;;CAEC,kBAAkB;CAClB,eAAe;AAChB;AACA;;CAEC,QAAQ;CACR,SAAS;CACT,YAAY;CACZ,WAAW;CACX,iBAAiB;CACjB,kBAAkB;CAClB,cAAc;CACd,kBAAkB;CAClB,YAAY;CACZ,uBAAuB;CACvB,mBAAmB;CACnB,wBAAwB;CACxB,uBAAuB;CACvB,kBAAkB;CAClB,8CAA8C;CAC9C,iBAAiB;CACjB,YAAY;CACZ,yBAAyB;AAC1B;AACA;;CAEC,YAAY;CACZ,yBAAyB;AAC1B;;AAEA;CACC,kBAAkB;AACnB;AACA;CACC,kCAAkC;AACnC;AACA;CACC,qBAAqB;CACrB,qBAAqB;CACrB,SAAS;CACT,UAAU;AACX;AACA;CACC,gCAAgC;CAChC,gBAAgB;AACjB;AACA;CACC,cAAc;AACf;AACA;CACC,mBAAmB;AACpB;AACA;CACC,qBAAqB;CACrB,eAAe;CACf,iBAAiB;AAClB;;AAEA;CACC,eAAe;CACf,sBAAsB;CACtB,MAAM;CACN,OAAO;CACP,YAAY;CACZ,WAAW;CACX,YAAY;CACZ,iBAAiB;AAClB;AACA;CACC,kBAAkB;CAClB,MAAM;CACN,OAAO;CACP,SAAS;CACT,QAAQ;CACR,UAAU;CACV,WAAW;CACX,cAAc;CACd,YAAY;CACZ,YAAY;CACZ,cAAc;CACd,yBAAyB;CACzB,uBAAuB;CACvB,oBAAoB;CACpB,0CAA0C;AAC3C;AACA;CACC,kBAAkB;CAClB,YAAY;AACb;AACA;CACC,kBAAkB;CAClB,QAAQ;CACR,UAAU;CACV,WAAW;CACX,YAAY;CACZ,yBAAyB;CACzB,yBAAyB;CACzB,kBAAkB;CAClB,kBAAkB;CAClB,eAAe;CACf,WAAW;AACZ;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,eAAe;CACf,MAAM;CACN,OAAO;CACP,QAAQ;CACR,SAAS;CACT,YAAY;CACZ,8BAA8B;AAC/B;;AAEA;CACC;EACC,UAAU;CACX;AACD;AACA;CACC,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,aAAa;CACb,yBAAyB;CACzB,kBAAkB;CAClB,8BAA8B;CAC9B,YAAY;CACZ,gCAAgC;CAChC,kBAAkB;CAClB,YAAY;AACb;;AAEA;;;CAGC,kBAAkB;CAClB,UAAU;CACV,kBAAkB;CAClB,8BAA8B;CAC9B,YAAY;CACZ,YAAY;CACZ,eAAe;CACf,iBAAiB;CACjB,kBAAkB;CAClB,uBAAuB;AACxB;;AAEA;;CAEC,WAAW;CACX,YAAY;AACb;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,YAAY;CACZ,aAAa;CACb,YAAY;AACb;;AAEA;CACC,kBAAkB;CAClB,OAAO;CACP,MAAM;CACN,QAAQ;CACR,SAAS;CACT;yCACotI;AACrtI;;AAEA;CACC,iBAAiB;CACjB,eAAe;CACf,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,SAAS;CACT,QAAQ;AACT;;AAEA;CACC,MAAM;CACN,QAAQ;AACT;;AAEA;CACC,iBAAiB;CACjB,YAAY;CACZ,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,qBAAqB;CACrB,wBAAwB;AACzB;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,qBAAqB;CACrB,YAAY;AACb;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,YAAY;CACZ,WAAW;CACX,qBAAqB;CACrB,sBAAsB;AACvB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,qBAAqB;CACrB,sBAAsB;CACtB,iBAAiB;CACjB,iBAAiB;AAClB;;AAEA;;;;EAIE;AACF;CACC,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,sCAAsC;CACtC,cAAc;AACf;;AAEA;mGACmG;AACnG;;;;;;;CAOC,kBAAkB;AACnB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;;CAEC,mBAAmB;AACpB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,iCAAiC;CACjC,mBAAmB;CACnB,YAAY;CACZ,yBAAyB;CACzB,WAAW;AACZ;;AAEA;CACC,uCAAuC;CACvC,mBAAmB;CACnB,YAAY;CACZ,yBAAyB;CACzB,WAAW;AACZ;;AAEA;CACC,8CAA8C;CAC9C,sCAAsC;CACtC,mBAAmB;AACpB;;AAEA;mGACmG;AACnG;CACC,qBAAqB;CACrB,UAAU;CACV,WAAW;CACX,gBAAgB;CAChB,cAAc;CACd,kBAAkB;CAClB,gBAAgB;CAChB,8CAA8C;CAC9C,uCAAuC;CACvC,2BAA2B;CAC3B,yBAAyB;CAIzB,iBAAiB;AAClB;;AAEA;;;;;;CAMC;AACD;CACC,kBAAkB;CAClB,cAAc;CACd,4DAA4D;AAC7D;;AAEA;CACC,YAAY;CACZ,iBAAiB;CACjB,eAAe;CACf,QAAQ;CACR,QAAQ;AACT;;AAEA;CACC,YAAY;CACZ,iBAAiB;CACjB,eAAe;CACf,QAAQ;CACR,SAAS;AACV;;AAEA;CACC,YAAY;CACZ,eAAe;CACf,QAAQ;AACT;;AAEA;CACC,YAAY;CACZ,eAAe;CACf,QAAQ;AACT;;AAEA;CACC,YAAY;CACZ,eAAe;CACf,OAAO;CACP,SAAS;AACV;;AAEA;CACC,YAAY;CACZ,eAAe;CACf,OAAO;CACP,QAAQ;AACT;;AAEA;CACC,YAAY;CACZ,eAAe;CACf,OAAO;AACR;;AAEA;CACC,YAAY;CACZ,eAAe;CACf,OAAO;AACR;;AAEA;mGACmG;AACnG;CACC,mBAAmB;CACnB,sBAAsB;CACtB,iBAAiB;CACjB,6BAA6B;CAC7B,eAAe;CACf,gBAAgB;CAChB,sBAAsB;CACtB,yBAAyB;CACzB,cAAc;CAKd,4BAA4B;AAC7B;AACA;;;;;;;;;;;CAWC,oCAAoC;CACpC,yBAAyB;CACzB,2BAA2B;AAC5B;AACA;CACC,gBAAgB;AACjB;AACA;;;;;;;;;;;;;;;;;;;;;;;;CAwBC,yBAAyB;CACzB,qBAAqB;AACtB;AACA;CACC,cAAc;CACd,qBAAqB;AACtB;AACA;;;CAGC,6BAA6B;CAC7B,cAAc;CACd,qBAAqB;CACrB,gBAAgB;AACjB;AACA;CACC,cAAc;AACf;;AAEA;;CAEC,qBAAqB;AACtB;AACA;;;CAIC,gBAAgB;CAChB,qBAAqB;AACtB;AACA;CACC,mBAAmB;CACnB,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;;AAEA,yCAAyC;AACzC;CACC,SAAS;CACT,UAAU;AACX;;AAEA;CACC,cAAc;CACd,iBAAiB;AAClB;;AAEA,qBAAqB;AACrB;CACC,cAAc;CACd,kBAAkB;CAClB,YAAY;CACZ,kDAAkD;CAClD,eAAe;CACf,sBAAsB;AACvB;;AAEA;;;CAGC;AACD;;;CAGC,cAAc;CACd,yBAAyB;AAC1B;;AAEA;;;CAGC,yBAAyB;CACzB,qBAAqB;CACrB,eAAe;CACf,aAAa;CACb,yBAAyB;CACzB,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;;;;;;CAMC,yBAAyB;CACzB,cAAc;AACf;;AAEA;mGACmG;AACnG;CACC,qBAAqB;AACtB;;AAEA;;;CAGC;AACD;CACC,yDAAyD;CACzD,WAAW;CACX,iBAAiB;AAClB;;AAEA;CACC,SAAS;CACT,cAAc;AACf;;AAEA;mGACmG;AACnG;CACC,kBAAkB;CAElB,gDAAgD;AACjD;;AAEA;CACC,kDAAkD;CAClD,gBAAgB;AACjB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,eAAe;AAChB;;AAEA;;CAEC,WAAW;AACZ;;AAEA;;CAEC,YAAY;AACb;;AAEA,aAAa;AACb;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,gBAAgB;CAChB,eAAe;AAChB;;AAEA,gBAAgB;AAChB;CACC,aAAa;CACb,oDAAoD;AACrD;;AAEA;mGACmG;AACnG;CACC,mBAAmB;CACnB,iBAAiB;AAClB;;AAEA;CACC,SAAS;CACT,SAAS;CACT,gBAAgB;CAChB,yDAAyD;CACzD,mBAAmB;AACpB;;AAEA;CACC,WAAW;AACZ;;AAEA;;;;CAIC,gEAAgE;CAChE,kBAAkB;CAClB,MAAM;CACN,OAAO;CACP,QAAQ;AACT;;AAEA;CACC,SAAS;CACT,6BAA6B;AAC9B;;AAEA;CACC,YAAY;CACZ,6BAA6B;AAC9B;;AAEA;mGACmG;AACnG;CACC,WAAW;CACX,mBAAmB;CACnB,yBAAyB;CACzB,iBAAiB;CACjB,cAAc;CACd,4BAA4B;AAC7B;;AAEA;CACC,iBAAiB;CACjB,wBAAwB;CACxB,cAAc;CACd,yBAAyB;CACzB,yBAAyB;CACzB,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;CACnB,iBAAiB;CACjB,UAAU;CACV,mBAAmB;AACpB;;AAEA;CACC,oBAAoB;CACpB,iCAAiC;AAClC;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,gBAAgB;AACjB;;AAEA;mGACmG;AACnG;CACC,mFAAmF;CACnF,+FAA+F;CAC/F,mBAAmB;CACnB,eAAe;AAChB;;AAEA;CACC;4CAC2C;CAC3C,iCAAiC;CACjC,kCAAkC;CAClC,8BAA8B;CAC9B,mCAAmC;AACpC;;AAEA;CACC,gCAAgC;CAChC,+BAA+B;AAChC;;AAEA;mGACmG;AACnG;CACC,kBAAkB;AACnB;;AAEA;CACC,UAAU;AACX;;AAEA,mDAAmD;AACnD;;CAEC,SAAS;CACT,sCAAsC;AACvC;;AAEA;;CAEC,YAAY;CACZ,sCAAsC;AACvC;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,UAAU;AACX;;AAEA;;;CAGC;AACD;CACC,kBAAkB;CAClB,UAAU;CACV,mBAAmB;CACnB,uCAAuC;AACxC;;AAEA;CACC,UAAU;AACX;;AAEA;;CAEC,wCAAwC;CACxC,gBAAgB;CAChB,sCAAsC;CACtC,yBAAyB;CACzB,4DAA4D;CAC5D,gBAAgB;AACjB;;AAEA;;CAEC,2CAA2C;CAC3C,aAAa;AACd;;AAEA;mGACmG;AACnG;CACC,mEAAmE;CACnE,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,yCAAyC;CACzC,kBAAkB;CAClB,2BAA2B;CAC3B,WAAW;CACX,gFAAgF;CAChF,gBAAgB;CAChB,6EAA6E;AAC9E;;AAEA;mGACmG;AACnG;CACC,kBAAkB;CAClB,kDAAkD;CAClD,cAAc;CACd,2BAA2B;CAC3B,iBAAiB;CACjB,gBAAgB;CAChB,kBAAkB;CAClB,yCAAyC;CACzC,6BAA6B;CAC7B,mBAAmB;CACnB,sCAAsC;AACvC;AACA;CACC,yCAAyC;AAC1C;AACA;CACC,wCAAwC;AACzC;AACA;CACC,yCAAyC;AAC1C;AACA;CACC,wCAAwC;AACzC;;AAEA,gEAAgE;AAChE;;;CAGC,cAAc;CACd,uBAAuB;CACvB,qBAAqB;CACrB,uBAAuB;AACxB;;AAEA;;CAEC,eAAe;CACf,qEAAqE;AACtE;;AAEA;;CAEC,yCAAyC;CACzC,mBAAmB;AACpB;;AAEA;CACC,6CAA6C;CAC7C,UAAU;CACV,mBAAmB;CACnB,aAAa;CACb,yBAAyB;CACzB,WAAW;AACZ;;AAEA;CACC,kBAAkB;CAClB,UAAU;AACX;;AAEA;CACC,kBAAkB;CAClB,UAAU;AACX;;AAEA;mGACmG;AACnG,mGAAmG;AACnG;;CAEC,cAAc;CACd,oBAAoB;CACpB,iBAAiB;CACjB,oCAAoC;CACpC,yBAAyB;CACzB,4BAA4B;AAC7B;;AAEA;;CAEC,eAAe;CACf,qBAAqB;CACrB,kBAAkB;CAClB,oCAAoC;CACpC,0BAA0B;CAC1B,6BAA6B;AAC9B;;AAEA,YAAY;AACZ;CACC,kDAAkD;CAClD,SAAS;CACT,YAAY;CACZ,UAAU;CACV,WAAW;CACX,UAAU;AACX;;AAEA,kBAAkB;AAClB;;;;;;CAMC,WAAW;CACX,2CAA2C;CAC3C,gBAAgB;AACjB;;AAEA,kBAAkB;AAClB;;;;;;CAMC,UAAU;CACV,2CAA2C;CAC3C,gBAAgB;AACjB;;AAEA;;;;CAIC;AACD;CACC,iBAAiB;CACjB,qCAAqC;CACrC,gBAAgB;AACjB;;AAEA;CACC,qCAAqC;CACrC,mBAAmB;CACnB,gBAAgB;AACjB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,iCAAiC;CACjC,UAAU;CACV,WAAW;CACX,UAAU;AACX;;AAEA;mGACmG;AACnG,8CAA8C;AAC9C;CACC,eAAe;CACf,iBAAiB;CACjB,eAAe;CACf,qBAAqB;AACtB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,4DAA4D;CAC5D,aAAa;AACd;;AAEA,qDAAqD;AACrD;CACC,UAAU;CACV,iDAAiD;AAClD;;AAEA;CACC,UAAU;CACV,YAAY;AACb;;AAEA;CACC,aAAa;AACd;;AAEA;mGACmG;AACnG;CACC,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,gBAAgB;AACjB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,qBAAqB;AACtB;;AAEA,qDAAqD;AACrD;CACC,uDAAuD;CACvD,WAAW;CACX,mBAAmB;AACpB;;AAEA,0DAA0D;AAC1D;CACC,uDAAuD;CACvD,cAAc;AACf;;AAEA,eAAe;AACf;CACC,SAAS;AACV;;AAEA,4CAA4C;AAC5C;CACC,kBAAkB;AACnB;;AAEA;;CAEC,UAAU;AACX;;AAEA;CACC,UAAU;AACX;;AAEA;;CAEC,UAAU;AACX;;AAEA;CACC,UAAU;AACX;;AAEA;mGACmG;AACnG,iFAAiF;AACjF,iGAAiG;AACjG;;;CAKC,uBAAuB;AACxB;;AAEA;;CAEC,6DAA6D;CAC7D,kBAAkB;CAClB,UAAU;AACX;;AAEA;mGACmG;AACnG,sBAAsB;AACtB;;CAEC,+DAA+D;CAC/D,gBAAgB;CAChB,gEAAgE;CAChE,mBAAmB;CACnB,iEAAiE;AAClE;;AAEA;CACC,eAAe;CACf,gDAAgD;AACjD;;AAEA,gGAAgG;AAChG;CACC,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,MAAM;CACN,OAAO;CACP,QAAQ;AACT;;AAEA,gCAAgC;AAChC;;CAEC,cAAc;AACf;;AAEA;;CAEC,YAAY;AACb;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,yEAAyE;CACzE,qBAAqB;CACrB,iBAAiB;AAClB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,YAAY;CACZ,yBAAyB;CACzB,WAAW;CACX;;qDAEoD;AACrD;;AAEA;mGACmG;AACnG;CACC,kBAAkB;CAClB,UAAU;CACV,uDAAuD;AACxD;;AAEA;CACC,eAAe;CACf,qDAAqD;AACtD;;AAEA;CACC,gBAAgB;CAChB,gEAAgE;CAChE,mBAAmB;CACnB,6DAA6D;AAC9D;;AAEA;mGACmG;AACnG;CACC,wCAAwC;CACxC,sBAAsB;CACtB,cAAc;CACd,mBAAmB;AACpB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,mBAAmB;CACnB,uCAAuC;AACxC;;AAEA;mGACmG;AACnG;;CAEC,6DAA6D;CAC7D,kBAAkB;CAClB,UAAU;AACX;;AAEA;CACC,gBAAgB;CAChB,oEAAoE;AACrE;;AAEA;CACC,oDAAoD;CACpD,4BAA4B;AAC7B;;AAEA;CACC,UAAU;AACX;;AAEA;;CAEC,mEAAmE;CACnE,kBAAkB;CAClB,UAAU;AACX;;AAEA;;CAEC,kBAAkB;CAClB,MAAM;CACN,OAAO;CACP,QAAQ;AACT;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,UAAU;AACX;;AAEA;mGACmG;AACnG;CACC,aAAa;CACb,gBAAgB;CAChB,gDAAgD;AACjD;;AAEA;CACC,wBAAwB;AACzB;;AAEA;CACC,mBAAmB;CACnB,gBAAgB;CAChB,yBAAyB;AAC1B;;AAEA;mGACmG;AACnG;CACC,yDAAyD;CACzD,kBAAkB;CAClB,kEAAkE;AACnE;;AAEA;CACC,kBAAkB;CAClB,OAAO;CACP,QAAQ;CACR,oCAAoC;AACrC;;AAEA;mGACmG;AACnG;;CAEC,uDAAuD;CACvD,kBAAkB;AACnB;;AAEA;CACC,mDAAmD;CACnD,oBAAoB;AACrB;;AAEA;CACC,yCAAyC;CACzC,oBAAoB;AACrB;;AAEA;;CAEC,kBAAkB;CAClB,UAAU;CACV,0BAA0B;AAC3B;;AAEA;CACC,6CAA6C;CAC7C,OAAO;CACP,QAAQ;AACT;;AAEA;mGACmG;AACnG;CACC,gDAAgD;CAChD,sDAAsD;CACtD,mBAAmB;CACnB,gBAAgB;CAChB,+BAA+B;CAC/B,yBAAyB;CACzB,0BAA0B;AAC3B;;AAEA;CACC,sDAAsD;CACtD,sBAAsB;CACtB,mBAAmB;CACnB,kCAAkC;CAClC,4BAA4B;CAC5B,6BAA6B;AAC9B;;AAEA;;;;CAIC;AACD;CACC,gBAAgB;CAChB,+CAA+C;AAChD;;AAEA;;CAEC,cAAc;AACf;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA,0DAA0D;AAC1D;CACC,iEAAiE;CACjE,mBAAmB;AACpB;;AAEA;;CAEC,4CAA4C;CAC5C,qBAAqB;CACrB,mBAAmB;AACpB;;AAEA;CACC,aAAa;CACb,wCAAwC;AACzC;;AAEA;CACC,yBAAyB;CACzB,4CAA4C;AAC7C;;AAEA;CACC,cAAc;CACd,4CAA4C;AAC7C;;AAEA;CACC,iBAAiB;CACjB,kDAAkD;CAClD,UAAU;CACV,4BAA4B;AAC7B;;AAEA,YAAY;AACZ;CACC,OAAO;CACP,QAAQ;CACR,SAAS;CACT,WAAW;CACX,gBAAgB;CAChB,gBAAgB;CAChB,eAAe;CACf,sBAAsB;CACtB,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,qBAAqB;AACtB;AACA;CACC,iBAAiB;CACjB,kBAAkB;CAClB,mBAAmB;AACpB;AACA;CACC,cAAc;AACf;AACA;CACC,eAAe;AAChB;AACA;;CAEC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;;AAEA;;;;;kCAKkC;AAClC;CACC,2BAA2B;CAC3B,4CAA0C;CAC1C;;;4DAGyD;CACzD,mBAAmB;CACnB,kBAAkB;AACnB;AACA;;0BAE0B;AAC1B;CACC,qBAAqB;CACrB,gDAAgD;CAChD,kBAAkB;CAClB,oBAAoB;CACpB,0BAA0B;CAC1B,mCAAmC;CACnC,kCAAkC;AACnC;;AAEA;;0BAE0B;AAC1B;CACC,uBAAuB;CACvB,oBAAoB;AACrB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,cAAc;AACf;;AAEA;;oCAEoC;AACpC;;CAEC,qBAAqB;CACrB,oBAAoB;CACpB,sBAAsB;AACvB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;;0BAE0B;AAC1B;CACC,eAAe;CACf,yBAAyB;CACzB,qBAAqB;AACtB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,mBAAmB;CACnB,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,MAAM;CACN,mBAAmB;AACpB;;AAEA;;CAEC,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;;0BAE0B;AAC1B;CAGC,0CAA0C;AAC3C;AAkBA;CACC;EAKC,uBAAuB;CACxB;CACA;EAKC,yBAAyB;CAC1B;AACD;AACA;;0BAE0B;AAC1B;CACC,gEAAgE;CAKhE,wBAAwB;AACzB;;AAEA;CACC,gEAAgE;CAKhE,yBAAyB;AAC1B;;AAEA;CACC,gEAAgE;CAKhE,yBAAyB;AAC1B;;AAEA;CACC,gEAAgE;CAKhE,uBAAuB;AACxB;;AAEA;CACC,gEAAgE;CAKhE,uBAAuB;AACxB;;AAEA;;0BAE0B;AAC1B;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,iBAAiB,EAAE,2CAA2C;AAC/D;;AAEA;;;;;;;;;;;;;;;;;;;;;;CAsBC,gBAAgB;AACjB;AACA;;CAEC,gBAAgB;AACjB;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;CAgDC,yBAAyB;CACzB,qBAAqB;AACtB;AACA;;CAEC,cAAc;CACd,qBAAqB;AACtB;;AAEA;;;;CAIC,UAAU;CACV,0BAA0B;CAC1B,qBAAqB;AACtB;AACA;;;;;;CAOC,gBAAgB;CAChB,qBAAqB;AACtB;AACA;;CAEC,SAAS;AACV;AACA;;CAEC,YAAY;CACZ,eAAe;CACf,WAAW;CACX,UAAU;CACV,oBAAoB;CACpB,gBAAgB;CAChB,kBAAkB;CAClB,mBAAmB;AACpB;AACA;;CAEC,UAAU;AACX;AACA;;CAEC,gBAAgB;CAChB,mBAAmB;CACnB,eAAe;AAChB;AACA;;;;;;;;CAQC,oBAAoB;AACrB;AACA;;CAEC,cAAc;CACd,iBAAiB;CACjB,aAAa;AACd;AACA;;;;;;;;CAQC,mBAAmB;AACpB;AACA;;;;;;;;CAQC,kBAAkB;CAClB,QAAQ;CACR,SAAS;CACT,kCAAkC;CAClC,sBAAsB;CACtB,WAAW;AACZ;AACA;;CAEC,eAAe;AAChB;AACA;;CAEC,kBAAkB;CAClB,QAAQ;AACT;;AAEA;CACC,yBAAyB;CACzB,cAAc;AACf;AACA;;;;;;;;;;;CAWC,oCAAoC;CACpC,yBAAyB;CACzB,2BAA2B;AAC5B;AACA;CACC,gBAAgB;AACjB;AACA;;;;;;;;;;;;;;;;;;;;;;;;CAwBC,yBAAyB;CACzB,qBAAqB;AACtB;AACA;CACC,cAAc;CACd,qBAAqB;AACtB;AACA;;;CAGC,6BAA6B;CAC7B,cAAc;CACd,qBAAqB;CACrB,gBAAgB;AACjB;;AAEA;;;CAGC,6BAA6B;CAC7B,cAAc;CACd,qBAAqB;CACrB,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;CACzB,cAAc;AACf;AACA;;;;;;;;;;;CAWC,oCAAoC;CACpC,yBAAyB;CACzB,2BAA2B;AAC5B;AACA;CACC,gBAAgB;AACjB;AACA;;;;;;;;;;;;;;;;;;;;;;;;CAwBC,yBAAyB;CACzB,qBAAqB;AACtB;AACA;CACC,cAAc;CACd,qBAAqB;AACtB;AACA;;;CAGC,6BAA6B;CAC7B,cAAc;CACd,qBAAqB;CACrB,gBAAgB;AACjB;AACA;CACC,cAAc;AACf;AACA;;;CAGC,6BAA6B;CAC7B,cAAc;CACd,qBAAqB;CACrB,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;CACzB,cAAc;AACf;AACA;;;;;;;;;;;CAWC,oCAAoC;CACpC,yBAAyB;CACzB,2BAA2B;AAC5B;AACA;CACC,gBAAgB;AACjB;AACA;;;;;;;;;;;;;;;;;;;;;;;;CAwBC,yBAAyB;CACzB,qBAAqB;AACtB;AACA;CACC,cAAc;CACd,qBAAqB;AACtB;AACA;;;CAGC,6BAA6B;CAC7B,cAAc;CACd,qBAAqB;CACrB,gBAAgB;AACjB;AACA;CACC,cAAc;AACf;AACA;;;;CAIC,6BAA6B;CAC7B,cAAc;CACd,qBAAqB;CACrB,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;CACzB,cAAc;AACf;AACA;;;;;;;;;;;CAWC,yBAAyB;CACzB,cAAc;CACd,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;;;;;;;;;;;;;;;;;;;;;;;;CAwBC,yBAAyB;CACzB,qBAAqB;AACtB;AACA;CACC,cAAc;CACd,qBAAqB;AACtB;AACA;;;CAGC,6BAA6B;CAC7B,cAAc;CACd,qBAAqB;CACrB,gBAAgB;AACjB;AACA;CACC,cAAc;AACf;AACA;;;;CAIC,6BAA6B;CAC7B,cAAc;CACd,qBAAqB;CACrB,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;CACzB,cAAc;AACf;AACA;;;;;;;;;;;CAWC,yBAAyB;CACzB,yBAAyB;CACzB,2BAA2B;AAC5B;AACA;CACC,gBAAgB;AACjB;AACA;;;;;;;;;;;;;;;;;;;;;;;;CAwBC,yBAAyB;CACzB,qBAAqB;AACtB;AACA;CACC,cAAc;CACd,qBAAqB;AACtB;AACA;;;CAGC,6BAA6B;CAC7B,cAAc;CACd,qBAAqB;CACrB,gBAAgB;AACjB;AACA;CACC,cAAc;AACf;AACA;;;;CAIC,6BAA6B;CAC7B,cAAc;CACd,qBAAqB;CACrB,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;CACzB,cAAc;AACf;AACA;;;;;;;;;;;CAWC,oCAAoC;CACpC,yBAAyB;CACzB,2BAA2B;AAC5B;AACA;CACC,gBAAgB;AACjB;AACA;;;;;;;;;;;;;;;;;;;;;;;;CAwBC,yBAAyB;CACzB,qBAAqB;AACtB;AACA;CACC,cAAc;CACd,qBAAqB;AACtB;AACA;;;CAGC,6BAA6B;CAC7B,cAAc;CACd,qBAAqB;CACrB,gBAAgB;AACjB;AACA;CACC,cAAc;AACf;AACA;;;;CAIC,6BAA6B;CAC7B,cAAc;CACd,qBAAqB;CACrB,gBAAgB;AACjB;;AAEA;;;;;;;;;;;CAWC,oCAAoC;CACpC,yBAAyB;CACzB,2BAA2B;AAC5B;AACA;CACC,gBAAgB;AACjB;AACA;;;;;;;;;;;;;;;;;;;;;;;;CAwBC,yBAAyB;CACzB,qBAAqB;AACtB;AACA;CACC,cAAc;CACd,qBAAqB;AACtB;AACA;;;CAGC,6BAA6B;CAC7B,cAAc;CACd,qBAAqB;CACrB,gBAAgB;AACjB;AACA;CACC,cAAc;AACf;AACA;;;;CAIC,6BAA6B;CAC7B,cAAc;CACd,qBAAqB;CACrB,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;CACzB,cAAc;AACf;AACA;;;;;;;;;;;CAWC,oCAAoC;CACpC,yBAAyB;CACzB,2BAA2B;AAC5B;AACA;CACC,gBAAgB;AACjB;AACA;;;;;;;;;;;;;;;;;;;;;;;;CAwBC,yBAAyB;CACzB,qBAAqB;AACtB;AACA;CACC,cAAc;CACd,qBAAqB;AACtB;AACA;;;CAGC,6BAA6B;CAC7B,cAAc;CACd,qBAAqB;CACrB,gBAAgB;AACjB;AACA;CACC,cAAc;AACf;AACA;;;;CAIC,6BAA6B;CAC7B,cAAc;CACd,qBAAqB;CACrB,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;CACzB,cAAc;AACf;AACA;;;;;;;;;;;CAWC,oCAAoC;CACpC,yBAAyB;CACzB,2BAA2B;AAC5B;AACA;CACC,gBAAgB;AACjB;AACA;;;;;;;;;;;;;;;;;;;;;;;;CAwBC,yBAAyB;CACzB,qBAAqB;AACtB;AACA;CACC,cAAc;AACf;AACA;;;;CAIC,yBAAyB;AAC1B;AACA;CACC,yBAAyB;AAC1B;AACA;;;;CAIC,yBAAyB;AAC1B;AACA;CACC,yBAAyB;AAC1B;AACA;;;;CAIC,yBAAyB;AAC1B;AACA;CACC,yBAAyB;AAC1B;AACA;;;;CAIC,yBAAyB;AAC1B;AACA;CACC,yBAAyB;AAC1B;AACA;;;;CAIC,yBAAyB;AAC1B;AACA;;;;;;;;;CASC,oCAAoC;CACpC,yBAAyB;CACzB,2BAA2B;AAC5B;AACA;;CAEC,yBAAyB;AAC1B;AACA;;CAEC,gBAAgB;AACjB;AACA;CACC,cAAc;CACd,qBAAqB;AACtB;AACA;;;CAGC,6BAA6B;CAC7B,cAAc;CACd,qBAAqB;CACrB,gBAAgB;AACjB;AACA;CACC,cAAc;AACf;AACA;;;;CAIC,6BAA6B;CAC7B,cAAc;CACd,qBAAqB;CACrB,gBAAgB;AACjB;;AAEA;CACC,uBAAuB;CACvB,oCAAoC;CACpC,cAAc;CACd,UAAU;CACV,0BAA0B;AAC3B;AACA;;;;;;CAMC,oCAAoC;CACpC,0CAA0C;CAC1C,gCAAgC;AACjC;AACA;;;;;;CAMC,qDAAqD;AACtD;AACA;CACC,oCAAoC;AACrC;AACA;;;;;;;;;;;;;;;;;;;;;;;;CAwBC,wCAAwC;CACxC,gCAAgC;AACjC;;AAEA;CACC,uBAAuB;CACvB,oCAAoC;CACpC,cAAc;CACd,UAAU;CACV,0BAA0B;AAC3B;AACA;;;;;;CAMC,oCAAoC;CACpC,0CAA0C;CAC1C,gCAAgC;AACjC;AACA;;;;;;CAMC,qDAAqD;AACtD;AACA;CACC,oCAAoC;AACrC;AACA;;;;;;;;;;;;;;;;;;;;;;;;CAwBC,wCAAwC;CACxC,gCAAgC;AACjC;;AAEA;CACC,uBAAuB;CACvB,oCAAoC;CACpC,cAAc;CACd,UAAU;CACV,0BAA0B;AAC3B;AACA;;;;;;CAMC,oCAAoC;CACpC,0CAA0C;CAC1C,gCAAgC;AACjC;AACA;;;;;;CAMC,qDAAqD;AACtD;AACA;CACC,oCAAoC;AACrC;AACA;;;;;;;;;;;;;;;;;;;;;;;;CAwBC,wCAAwC;CACxC,gCAAgC;AACjC;;AAEA;CACC,uBAAuB;CACvB,oCAAoC;CACpC,cAAc;CACd,UAAU;CACV,0BAA0B;AAC3B;AACA;;;;;;CAMC,oCAAoC;CACpC,0CAA0C;CAC1C,gCAAgC;AACjC;AACA;;;;;;CAMC,qDAAqD;AACtD;AACA;CACC,oCAAoC;AACrC;AACA;;;;;;;;;;;;;;;;;;;;;;;;CAwBC,wCAAwC;CACxC,gCAAgC;AACjC;;AAEA;CACC,uBAAuB;CACvB,oCAAoC;CACpC,cAAc;CACd,UAAU;CACV,0BAA0B;AAC3B;AACA;;;;;;CAMC,oCAAoC;CACpC,0CAA0C;CAC1C,gCAAgC;AACjC;AACA;;;;;;CAMC,qDAAqD;AACtD;AACA;CACC,oCAAoC;AACrC;AACA;;;;;;;;;;;;;;;;;;;;;;;;CAwBC,wCAAwC;CACxC,gCAAgC;AACjC;;AAEA;CACC,uBAAuB;CACvB,oCAAoC;CACpC,cAAc;CACd,UAAU;CACV,0BAA0B;AAC3B;AACA;;;;;;CAMC,oCAAoC;CACpC,0CAA0C;CAC1C,gCAAgC;AACjC;AACA;;;;;;CAMC,qDAAqD;AACtD;AACA;CACC,oCAAoC;AACrC;AACA;;;;;;;;;;;;;;;;;;;;;;;;CAwBC,wCAAwC;CACxC,gCAAgC;AACjC;;AAEA;CACC,uBAAuB;CACvB,oCAAoC;CACpC,cAAc;CACd,UAAU;CACV,0BAA0B;AAC3B;AACA;;;;;;CAMC,oCAAoC;CACpC,0CAA0C;CAC1C,gCAAgC;AACjC;AACA;;;;;;CAMC,qDAAqD;AACtD;AACA;CACC,oCAAoC;AACrC;AACA;;;;;;;;;;;;;;;;;;;;;;;;CAwBC,wCAAwC;CACxC,gCAAgC;AACjC;;AAEA;CACC,uBAAuB;CACvB,oCAAoC;CACpC,cAAc;CACd,UAAU;CACV,0BAA0B;AAC3B;AACA;;;;;;CAMC,oCAAoC;CACpC,0CAA0C;CAC1C,gCAAgC;AACjC;AACA;;;;;;CAMC,qDAAqD;AACtD;AACA;CACC,oCAAoC;AACrC;AACA;;;;;;;;;;;;;;;;;;;;;;;;CAwBC,wCAAwC;CACxC,gCAAgC;AACjC;AACA;;CAEC,cAAc;CACd,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;CACzB,cAAc;CACd,cAAc;AACf;AACA;;;;;;;;;;;CAWC,oCAAoC;CACpC,yBAAyB;CACzB,2BAA2B;AAC5B;AACA;CACC,gBAAgB;AACjB;AACA;;;;;;;;;;;;;;;;;;;;;;;;CAwBC,yBAAyB;CACzB,qBAAqB;AACtB;AACA;CACC,cAAc;AACf;AACA;;;;CAIC,yBAAyB;AAC1B;AACA;CACC,yBAAyB;AAC1B;AACA;;;;CAIC,yBAAyB;AAC1B;AACA;CACC,yBAAyB;AAC1B;AACA;;;;CAIC,yBAAyB;AAC1B;AACA;CACC,yBAAyB;AAC1B;AACA;;;;CAIC,yBAAyB;AAC1B;AACA;CACC,yBAAyB;AAC1B;AACA;;;;CAIC,yBAAyB;AAC1B;AACA;;;;;;;;;CASC,oCAAoC;CACpC,yBAAyB;CACzB,2BAA2B;AAC5B;AACA;;CAEC,yBAAyB;AAC1B;AACA;;CAEC,gBAAgB;AACjB;AACA;CACC,cAAc;CACd,qBAAqB;AACtB;AACA;;;CAGC,6BAA6B;CAC7B,cAAc;CACd,qBAAqB;CACrB,gBAAgB;AACjB;AACA;CACC,cAAc;AACf;AACA;;;;CAIC,6BAA6B;CAC7B,cAAc;CACd,qBAAqB;CACrB,gBAAgB;AACjB;AACA;;CAEC,cAAc;AACf;AACA;;CAEC,cAAc;AACf;AACA;;;CAGC,yBAAyB;CACzB,cAAc;AACf;AACA;;CAEC,6BAA6B;AAC9B;;AAEA;;;CAGC,YAAY;CACZ,yBAAyB;CACzB,oBAAoB;AACrB;;AAEA;CACC,iBAAiB;CACjB,qBAAqB;CACrB,kBAAkB;CAClB,6BAA6B;AAC9B;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;CAgDC,yBAAyB;AAC1B;;AAEA;CACC,6BAA6B;CAC7B,cAAc;AACf;AACA;CACC,yBAAyB;CACzB,YAAY;CACZ,qBAAqB;AACtB;;AAEA;CACC,eAAe;CACf,kBAAkB;CAClB,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,kBAAkB;CAClB,gBAAgB;AACjB;AACA;CACC,mBAAmB;CACnB,kBAAkB;CAClB,gBAAgB;AACjB;AACA;CACC,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,gBAAgB;CAChB,UAAU;AACX;;AAEA;CACC,iBAAiB;AAClB;AACA;CACC,oCAAoC;AACrC;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;AACA;CACC,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,yBAAyB;CACzB,cAAc;AACf;AACA;;;CAGC,oCAAoC;CACpC,yBAAyB;AAC1B;AACA;CACC,cAAc;CACd,6BAA6B;CAC7B,gBAAgB;CAChB,qBAAqB;AACtB;AACA;;;CAGC,cAAc;CACd,qBAAqB;AACtB;AACA;CACC,cAAc;CACd,yBAAyB;AAC1B;AACA;;;CAGC,yBAAyB;AAC1B;AACA;CACC,yBAAyB;CACzB,cAAc;AACf;AACA;;;CAGC,oCAAoC;CACpC,yBAAyB;AAC1B;AACA;CACC,cAAc;CACd,6BAA6B;CAC7B,gBAAgB;CAChB,qBAAqB;AACtB;AACA;;;CAGC,cAAc;CACd,qBAAqB;AACtB;AACA;CACC,cAAc;CACd,yBAAyB;AAC1B;AACA;;;CAGC,yBAAyB;AAC1B;AACA;CACC,yBAAyB;CACzB,cAAc;AACf;AACA;;;CAGC,oCAAoC;CACpC,yBAAyB;AAC1B;AACA;CACC,cAAc;CACd,6BAA6B;CAC7B,gBAAgB;CAChB,qBAAqB;AACtB;AACA;;;CAGC,cAAc;CACd,qBAAqB;AACtB;AACA;CACC,cAAc;CACd,yBAAyB;AAC1B;AACA;;;CAGC,yBAAyB;AAC1B;AACA;CACC,yBAAyB;CACzB,cAAc;AACf;AACA;;;CAGC,oCAAoC;CACpC,yBAAyB;AAC1B;AACA;CACC,cAAc;CACd,6BAA6B;CAC7B,gBAAgB;CAChB,qBAAqB;AACtB;AACA;;;CAGC,cAAc;CACd,qBAAqB;AACtB;AACA;CACC,cAAc;CACd,yBAAyB;AAC1B;AACA;;;CAGC,yBAAyB;AAC1B;AACA;CACC,yBAAyB;CACzB,cAAc;AACf;AACA;;;CAGC,oCAAoC;CACpC,yBAAyB;AAC1B;AACA;CACC,cAAc;CACd,6BAA6B;CAC7B,gBAAgB;CAChB,qBAAqB;AACtB;AACA;;;CAGC,cAAc;CACd,qBAAqB;AACtB;AACA;CACC,cAAc;CACd,yBAAyB;AAC1B;AACA;;;CAGC,yBAAyB;AAC1B;AACA;CACC,yBAAyB;CACzB,cAAc;AACf;AACA;;;CAGC,oCAAoC;CACpC,yBAAyB;AAC1B;AACA;CACC,cAAc;CACd,6BAA6B;CAC7B,gBAAgB;CAChB,qBAAqB;AACtB;AACA;;;CAGC,cAAc;CACd,qBAAqB;AACtB;AACA;CACC,cAAc;CACd,yBAAyB;AAC1B;AACA;;;CAGC,yBAAyB;AAC1B;AACA;CACC,yBAAyB;CACzB,cAAc;AACf;AACA;;;CAGC,oCAAoC;CACpC,yBAAyB;AAC1B;AACA;CACC,cAAc;CACd,6BAA6B;CAC7B,gBAAgB;CAChB,qBAAqB;AACtB;AACA;;;CAGC,cAAc;CACd,qBAAqB;AACtB;AACA;CACC,cAAc;CACd,yBAAyB;AAC1B;AACA;;;CAGC,yBAAyB;AAC1B;AACA;CACC,yBAAyB;CACzB,cAAc;AACf;AACA;;;CAGC,oCAAoC;CACpC,yBAAyB;AAC1B;AACA;CACC,cAAc;CACd,6BAA6B;CAC7B,gBAAgB;CAChB,qBAAqB;AACtB;AACA;;;CAGC,cAAc;CACd,qBAAqB;AACtB;AACA;CACC,cAAc;CACd,yBAAyB;AAC1B;AACA;;;CAGC,yBAAyB;AAC1B;AACA;CACC,yBAAyB;CACzB,cAAc;AACf;AACA;;;CAGC,oCAAoC;CACpC,yBAAyB;AAC1B;AACA;CACC,cAAc;CACd,6BAA6B;CAC7B,gBAAgB;CAChB,qBAAqB;AACtB;AACA;;;CAGC,cAAc;CACd,qBAAqB;AACtB;AACA;CACC,cAAc;CACd,yBAAyB;AAC1B;AACA;;;CAGC,yBAAyB;AAC1B;AACA;CACC,yBAAyB;CACzB,cAAc;AACf;AACA;;;CAGC,oCAAoC;CACpC,yBAAyB;AAC1B;AACA;CACC,cAAc;CACd,6BAA6B;CAC7B,gBAAgB;CAChB,qBAAqB;AACtB;AACA;;;CAGC,cAAc;CACd,qBAAqB;AACtB;AACA;CACC,cAAc;CACd,yBAAyB;AAC1B;AACA;;;CAGC,yBAAyB;AAC1B;AACA;CACC,yBAAyB;CACzB,cAAc;AACf;AACA;;;CAGC,oCAAoC;CACpC,yBAAyB;AAC1B;AACA;CACC,cAAc;CACd,6BAA6B;CAC7B,gBAAgB;CAChB,qBAAqB;AACtB;AACA;;;CAGC,cAAc;CACd,qBAAqB;AACtB;AACA;CACC,cAAc;CACd,yBAAyB;AAC1B;AACA;;;CAGC,yBAAyB;AAC1B;AACA;CACC,yBAAyB;CACzB,cAAc;AACf;AACA;;;CAGC,oCAAoC;CACpC,yBAAyB;AAC1B;AACA;CACC,cAAc;CACd,6BAA6B;CAC7B,gBAAgB;CAChB,qBAAqB;AACtB;AACA;;;CAGC,cAAc;CACd,qBAAqB;AACtB;AACA;CACC,cAAc;CACd,yBAAyB;AAC1B;AACA;;;CAGC,yBAAyB;AAC1B;;AAEA;;;;;CASC,sDAAsD;CACtD,kBAAkB;CAClB,qBAAqB;AACtB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,gBAAgB;AACjB;;AAEA;;CAEC,gEAAgE;CAGhE,wBAAwB;AACzB;;AAEA;;CAMC,sBAAsB;AACvB;;AAEA;CACC,eAAe;AAChB;AACA;;CAMC,kCAAkC;AACnC;;AAEA;CACC,eAAe;AAChB;AACA;;CAMC,iCAAiC;AAClC;;AAEA;;;;;CAKC,8DAA8D;AAC/D;;AAEA;;;;;;CAMC,gBAAgB;AACjB;;AAEA;CACC,cAAc;AACf;AACA;;CAEC,cAAc;AACf;;AAEA;;CAEC,cAAc;CACd,iBAAiB;CACjB,mBAAmB;AACpB;AACA;;CAEC,gBAAgB;CAChB,yBAAyB;CACzB,YAAY;AACb;;AAEA;;CAEC,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;;CAEC,gBAAgB;CAChB,mBAAmB;CACnB,kBAAkB;AACnB;;AAEA;;CAEC,gBAAgB;CAChB,mBAAmB;CACnB,gBAAgB;CAChB,mBAAmB;AACpB;AACA;;;;CAIC,iBAAiB;AAClB;;AAEA;;CAEC,iBAAiB;CACjB,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;;CAEC,cAAc;CACd,gBAAgB;CAChB,yBAAyB;CACzB,kBAAkB;AACnB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;AACjB;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,cAAc;CACd,qBAAqB;AACtB;AACA;CACC,iBAAiB;AAClB;;AAEA;;;;CAIC,yBAAyB;CACzB,gBAAgB;AACjB;;AAEA;;CAEC,0BAA0B;CAC1B,gBAAgB;CAChB,cAAc;CACd,mBAAmB;AACpB;;AAEA;;;CAGC,yBAAyB;AAC1B;;AAEA;;;CAGC,yBAAyB;AAC1B;;AAEA;;;CAGC,yBAAyB;AAC1B;;AAEA;;;CAGC,yBAAyB;AAC1B;;AAEA;;;CAGC,yBAAyB;AAC1B;;AAEA;;;CAGC,yBAAyB;AAC1B;;AAEA;CACC,iBAAiB;CACjB,yBAAyB;CACzB,aAAa;CACb,gBAAgB;CAChB,gBAAgB;AACjB;AACA;CACC,cAAc;CACd,mBAAmB;CACnB,yBAAyB;AAC1B;AACA;CACC,qBAAqB;CACrB,cAAc;AACf;AACA;CACC,cAAc;AACf;AACA;CACC,qBAAqB;CACrB,cAAc;AACf;AACA;CACC,cAAc;AACf;AACA;CACC,sCAAsC;CACtC,cAAc;AACf;AACA;CACC,+BAA+B;AAChC;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,cAAc;CACd,eAAgC;CAAhC,gCAAgC;CAChC,8DAA8D;CAC9D,kCAAkC;CAClC,mCAAmC;AACpC;;AAEA;CACC,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;;CAEC,6BAA6B;CAC7B,cAAc;AACf;;AAEA;;CAEC,2BAA2B;CAC3B,YAAY;CACZ,qBAAqB;AACtB;;AAEA;CACC,yBAAyB;AAC1B;AACA;CACC,cAAc;AACf;;AAEA,eAAe;AACf;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;CAiFC,6BAA6B;AAC9B;;AAEA;;;CAOC,6BAA6B;AAC9B;;AAEA;;;;CAIC,gEAAgE;CAGhE,yBAAyB;AAC1B;;AAEA;CACC,cAAc;CACd,kBAAkB;CAClB,WAAW;CACX,WAAW;CACX,kBAAkB;CAClB,mBAAmB;AACpB;AACA;CACC,eAAe;AAChB;AACA;CACC,WAAW;AACZ;;AAEA;CACC,qBAAqB;CACrB,QAAQ;CACR,SAAS;CACT,gBAAgB;CAChB,sBAAsB;CACtB,sBAAsB;CACtB,uBAAuB;CACvB,mCAAmC;CACnC,kCAAkC;AACnC;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;AACA;CACC,aAAa;AACd;AACA;;CAEC,yBAAyB;AAC1B;AACA;CACC,qBAAqB;AACtB;AACA;CACC,UAAU;AACX;AACA;CACC,oCAAoC;CACpC,WAAW;CACX,cAAc;CACd,YAAY;CACZ,OAAO;CACP,kBAAkB;CAClB,MAAM;CACN,WAAW;CACX,UAAU;AACX;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,qBAAqB;CACrB,yBAAyB;AAC1B;AACA;CACC,qBAAqB;CACrB,yBAAyB;AAC1B;AACA;CACC,qBAAqB;CACrB,yBAAyB;AAC1B;AACA;CACC,qBAAqB;CACrB,yBAAyB;AAC1B;AACA;CACC,qBAAqB;CACrB,yBAAyB;AAC1B;AACA;CACC,qBAAqB;CACrB,yBAAyB;AAC1B;AACA;CACC,qBAAqB;CACrB,yBAAyB;CACzB,cAAc;AACf;;AAEA;CACC,mBAAmB;AACpB;;AAEA;;CAEC,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,gBAAgB;AACjB;AACA;CACC,yBAAyB;CACzB,cAAc;AACf;AACA;CACC,eAAe;AAChB;AACA;CACC,eAAe;AAChB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,cAAc;CACd,qCAAqC;AACtC;;AAEA;CACC;EACC,sBAAsB;CACvB;CACA;EACC,mBAAmB;CACpB;CACA;EACC,sBAAsB;CACvB;CACA;EACC,mBAAmB;CACpB;CACA;EACC,sBAAsB;CACvB;CACA;EACC,sBAAsB;CACvB;AACD;AACA;CACC,gBAAgB;AACjB;;AAEA;CACC,qBAAqB;CACrB,sBAAsB;CACtB,gBAAgB;CAChB,mBAAmB;AACpB;AACA;CACC,sBAAsB;AACvB;AACA;CACC,cAAc;AACf;AACA;CACC,cAAc;AACf;AACA;;CAEC,cAAc;AACf;AACA;;CAEC,cAAc;AACf;AACA;;CAEC,cAAc;AACf;AACA;;;;CAIC,cAAc;AACf;AACA;;CAEC,cAAc;CACd,YAAY;AACb;AACA;;CAEC,SAAS;CACT,iBAAiB;CACjB,iBAAiB;AAClB;AACA;;;;;;CAMC,cAAc;AACf;AACA;;;;;;CAMC,UAAU;AACX;AACA;;CAEC,cAAc;AACf;AACA;;CAEC,cAAc;AACf;AACA;;CAEC,cAAc;AACf;AACA;;CAEC,cAAc;AACf;AACA;CACC,qBAAqB;CACrB,SAAS;CACT,kBAAkB;CAClB,cAAc;CACd,gBAAgB;AACjB;AACA;CACC,kBAAkB;CAClB,WAAW;CACX,iBAAiB;CACjB,aAAa;CACb,MAAM;AACP;AACA;CACC,OAAO;CACP,WAAc;CAAd,cAAc;AACf;AACA;CACC,oBAAoB;CACpB,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,SAAS;AACV;AACA;CACC,eAAe;AAChB;AACA;CACC,WAAW;AACZ;AACA;CACC,kBAAkB;CAClB,OAAO;CACP,QAAQ;CACR,cAAc;CACd,WAAW;CACX,SAAS;AACV;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,yBAAyB;CACzB,mBAAmB;CACnB,sBAAsB;CACtB,qBAAqB;CACrB,iBAAiB;AAClB;AACA;;CAEC,gBAAgB;AACjB;AACA;;CAEC,eAAe;CACf,kBAAkB;CAClB,QAAQ;CACR,kBAAkB;CAClB,WAAW;AACZ;AACA;CACC,QAAQ;CACR,eAAe;AAChB;AACA;CACC,WAAW;CACX,YAAY;AACb;AACA;CACC,YAAY;CACZ,cAAc;AACf;AACA;;;;CAIC,kBAAkB;CAClB,cAAc;AACf;AACA;CACC,WAAW;CACX,YAAY;CACZ,gBAAgB;CAChB,cAAc;CACd,kBAAkB;CAClB,6BAA6B;AAC9B;AACA;CACC,0BAA0B;CAC1B,eAAe;CACf,mBAAmB;CACnB,sBAAsB;CACtB,qBAAqB;AACtB;AACA;CACC,WAAW;CACX,YAAY;CACZ,sBAAsB;CACtB,UAAU;CACV,eAAe;AAChB;AACA;CACC,UAAU;CACV,WAAW;CACX,kBAAkB;CAClB,cAAc;AACf;AACA;CACC,WAAW;AACZ;AACA;CACC,wCAAwC;CACxC,gBAAgB;CAChB,6BAA6B;AAC9B;AACA;CACC,cAAc;AACf;AACA;CACC,YAAY;CACZ,cAAc;AACf;AACA;CACC,mBAAmB;AACpB;AACA;CACC,cAAc;AACf;AACA;;;;;CAKC,cAAc;AACf;AACA;CACC,cAAc;AACf;AACA;CACC,YAAY;CACZ,cAAc;AACf;AACA;CACC,mBAAmB;AACpB;AACA;;;;CAIC,cAAc;AACf;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,eAAe;AAChB;;AAEA;CACC,oCAAoC;AACrC;;AAEA;CACC,oCAAoC;AACrC;;AAEA;CACC,oCAAoC;AACrC;;AAEA;CACC,oCAAoC;AACrC;;AAEA;CACC,oCAAoC;AACrC;;AAEA;CACC,oCAAoC;AACrC;;AAEA;CACC,oCAAoC;AACrC;;AAEA;;;CAGC,cAAc;CACd,gBAAgB;CAChB,UAAU;CACV,wBAAwB;CAExB,gDAAgD;CAChD,kBAAkB;CAClB,kBAAkB;CAClB;8CAC6C;AAC9C;AACA;;;CAOC,gDAAgD;AACjD;AACA;;;CAOC,gDAAgD;AACjD;AACA;;;CAGC,UAAU;CACV,0BAA0B;CAC1B,mBAAmB;AACpB;AACA;;;CAOC,kDAAkD;CAClD,oBAAoB;CACpB,oBAAoB;AACrB;AACA;;;CAOC,iDAAiD;CACjD,uBAAuB;CACvB,iBAAiB;AAClB;;AAEA;;CAMC,gDAAgD;CAChD,oBAAoB;CACpB,oBAAoB;AACrB;;AAEA;;CAEC,UAAU;CACV,mBAAmB;AACpB;AACA;;CAMC,4CAA4C;AAC7C;;AAEA;CAKC,kDAAkD;CAClD,oBAAoB;CACpB,oBAAoB;AACrB;AACA;CACC,4BAA4B;AAC7B;;AAEA;CACC,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB;;AAEA;CACC,yBAAyB;CACzB,cAAc;CACd,mBAAmB;CACnB,gBAAgB;CAChB,YAAY;AACb;AACA;CACC,yBAAyB;CACzB,WAAW;AACZ;AACA;CACC,yBAAyB;CACzB,mBAAmB;CACnB,kBAAkB;AACnB;AACA;CACC,yBAAyB;CACzB,gBAAgB;CAChB,kBAAkB;CAClB,kBAAkB;AACnB;AACA;CACC,cAAc;CACd,eAAe;CACf,aAAa;CACb,WAAW;CACX,mBAAmB;CACnB,WAAW;CACX,cAAc;AACf;AACA;CACC,gBAAgB;AACjB;AACA;CACC,qBAAqB;AACtB;AACA;CACC,eAAe;AAChB;AACA;CACC,4BAA4B;CAC5B,6BAA6B;AAC9B;AACA;CACC,+BAA+B;CAC/B,gCAAgC;AACjC;AACA;CACC,gBAAgB;CAChB,qBAAqB;AACtB;AACA;;CAEC,yBAAyB;CACzB,UAAU;CACV,qBAAqB;AACtB;AACA;;CAEC,yBAAyB;AAC1B;AACA;;CAEC,yBAAyB;AAC1B;AACA;;CAEC,yBAAyB;AAC1B;AACA;;CAEC,yBAAyB;AAC1B;AACA;;CAEC,yBAAyB;AAC1B;AACA;;CAEC,yBAAyB;AAC1B;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,WAAW;CACX,UAAU;AACX;;AAEA;;;;;;CAMC,iCAAiC;CACjC,wCAAwC;CACxC,yCAAyC;CACzC,WAAW;CACX,qBAAqB;CACrB,kBAAkB;CAClB,WAAW;CACX,UAAU;AACX;;AAEA;;;;;;CAMC,iCAAiC;CACjC,wCAAwC;CACxC,yCAAyC;CACzC,WAAW;CACX,qBAAqB;CACrB,kBAAkB;CAClB,WAAW;CACX,UAAU;AACX;;AAEA;;;CAGC,qBAAqB;CACrB,WAAW;AACZ;;AAEA;;;CAGC,qBAAqB;CACrB,WAAW;AACZ;;AAEA;CACC;EACC,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;CACnB;;CAEA;EACC,aAAa;CACd;;CAEA;;;EAGC,uCAAuC;EACvC;+CAC6C;CAC9C;;CAEA;;;EAGC,qCAAqC;EACrC,8BAA8B;CAC/B;;CAEA;EAKC,4BAA4B;CAC7B;;CAEA;EACC,8BAA8B;CAC/B;;CAEA;EACC;+CAC6C;EAC7C,qCAAqC;CACtC;;CAEA;;EAEC,UAAU;EACV,WAAW;CACZ;;CAEA;EACC,cAAc;CACf;;CAEA;EACC,wBAAwB;CACzB;AACD;AACA;CACC,yBAAyB;CACzB,eAAe;AAChB;AACA;CACC,iBAAiB;CACjB,sCAAsC;AACvC;AACA;CACC,eAAe;AAChB;AACA;CACC,cAAc;CACd,cAAc;AACf;AACA;CACC,YAAY;AACb;AACA;;;;CAIC,yBAAyB;CACzB,yBAAyB;CACzB,UAAU;CACV,qBAAqB;AACtB;;AAEA;;CAEC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;AACA;CACC,iBAAiB;CACjB,iBAAiB;CACjB,iBAAiB;AAClB;AACA;CACC,eAAe;AAChB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,cAAc;AACf;AACA;;;CAGC,cAAc;AACf;AACA;;CAEC,yBAAyB;CACzB,UAAU;CACV,qBAAqB;AACtB;AACA;CACC,kBAAkB;AACnB;;AAEA;;;CAGC,8BAA8B;CAC9B,mCAAmC;CACnC,oCAAoC;CACpC,WAAW;CACX,qBAAqB;CACrB,kBAAkB;CAClB,WAAW;CACX,aAAa;AACd;;AAEA;;;CAGC,2BAA2B;CAC3B,mCAAmC;CACnC,oCAAoC;CACpC,WAAW;CACX,qBAAqB;CACrB,kBAAkB;CAClB,WAAW;CACX,aAAa;AACd;;AAEA;;CAEC,cAAc;AACf;;AAEA;CACC,gCAAgC;CAChC,eAAe;CACf,cAAc;AACf;AACA;;;;CAIC,kBAAkB;CAClB,kBAAkB;CAClB,gBAAgB;CAChB,gBAAgB;CAChB,mBAAmB;AACpB;AACA;;;;;CAKC,cAAc;CACd,kBAAkB;CAClB,QAAQ;CACR,iBAAiB;CACjB,SAAS;AACV;AACA;;;;;CAKC,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;AAClB;AACA;;;;;CAKC,yBAAyB;CACzB,gBAAgB;CAChB,iBAAiB;AAClB;AACA;;;;CAIC,eAAe;CACf,UAAU;CACV,kBAAkB;CAClB,UAAU;CACV,QAAQ;CACR,iBAAiB;AAClB;AACA;CACC,qBAAqB;AACtB;AACA;;;;CAIC,cAAc;CACd,oCAAoC;AACrC;AACA;;;;CAIC,qBAAqB;AACtB;AACA;CACC,yBAAyB;CACzB,0BAA0B;AAC3B;AACA;CACC,6BAA6B;CAC7B,gBAAgB;AACjB;AACA;CACC,qBAAqB;CACrB,gBAAgB;CAChB,eAAe;AAChB;AACA;CACC,cAAc;CACd,gBAAgB;CAChB,iBAAiB;AAClB;;AAEA;CACC,SAAS;CACT,kBAAkB;CAClB,cAAc;CACd,mBAAmB;CACnB,sBAAsB;CACtB,kBAAkB;AACnB;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,cAAc;CACd,YAAY;CACZ,iBAAiB;CACjB,cAAc;CACd,UAAU;AACX;AACA;;CAEC,0BAA0B;AAC3B;AACA;;CAEC,UAAU;AACX;AACA;CACC,eAAe;CACf,cAAc;CACd,UAAU;CACV,kBAAkB;CAClB,QAAQ;CACR,iBAAiB;AAClB;AACA;CACC,kBAAkB;CAClB,WAAW;CACX,QAAQ;CACR,iBAAiB;CACjB,WAAW;CACX,YAAY;CACZ,YAAY;AACb;AACA;CACC,cAAc;CACd,cAAc;AACf;AACA;CACC,kBAAkB;AACnB;;AAEA;CACC,eAAe;CACf,kBAAkB;AACnB;;AAEA;CACC,gDAAgD;AACjD;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,gBAAgB;CAChB,cAAc;AACf;AACA;CACC,eAAe;CACf,WAAW;AACZ;AACA;CACC,SAAS;AACV;AACA;;CAEC,UAAU;CACV,SAAS;AACV;AACA;CACC,SAAS;AACV;AACA;;CAEC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;;;;;;CAMC,cAAc;CACd,iBAAiB;AAClB;AACA;CACC,eAAe;CACf,gBAAgB;CAChB,iBAAiB;CACjB,yBAAyB;CACzB,SAAS;AACV;AACA;;CAEC,aAAa;CACb,gBAAgB;CAChB,UAAU;CACV,WAAW;AACZ;AACA;;CAEC,kBAAkB;AACnB;AACA;;;;CAIC,UAAU;CACV,UAAU;AACX;AACA;;;;;;CAMC,iBAAiB;CACjB,sBAAsB;AACvB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,eAAe;CACf,gBAAgB;CAChB,eAAe;CACf,kBAAkB;CAClB,QAAQ;CACR,iBAAiB;AAClB;AACA;CACC,gBAAgB;CAChB,iBAAiB;CACjB,iBAAiB;CACjB,iBAAiB;AAClB;AACA;CACC,WAAW;AACZ;AACA;CACC,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,yBAAyB;AAC1B;AACA;CACC,cAAc;AACf;AACA;CACC,cAAc;CACd,kBAAkB;AACnB;AACA;CACC,gBAAgB;CAChB,gBAAgB;AACjB;AACA;CACC,yBAAyB;CACzB,iBAAiB;CACjB,gBAAgB;AACjB;AACA;CACC,gBAAgB;CAChB,kBAAkB;AACnB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,iBAAiB;CACjB,gBAAgB;AACjB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,YAAY;CACZ,iBAAiB;CACjB,gBAAgB;CAChB,cAAc;AACf;AACA;CACC,WAAW;AACZ;;AAEA;CACC,gBAAgB;CAChB,oBAAoB;AACrB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,gBAAgB;CAChB,cAAc;AACf;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,qBAAqB;CACrB,eAAe;AAChB;AACA;CACC,gBAAgB;CAChB,UAAU;CACV,gBAAgB;AACjB;AACA;CACC,qBAAqB;AACtB;AACA;CACC,cAAc;CACd,eAAe;CACf,mBAAmB;CACnB,yBAAyB;CACzB,qBAAqB;AACtB;AACA;CACC,qBAAqB;AACtB;AACA;CACC,mBAAmB;CACnB,gBAAgB;AACjB;AACA;CACC,cAAc;CACd,WAAW;CACX,YAAY;AACb;;AAEA;CACC,eAAe;CACf,QAAQ;CACR,WAAW;CACX,8BAA8B;CAC9B,aAAa;CACb,0BAA0B;CAC1B,kBAAkB;CAClB,UAAU;AACX;AACA;;CAEC,qBAAqB;CACrB,6BAA6B;CAC7B,0BAA0B;AAC3B;AACA;CACC,cAAc;CACd,aAAa;CACb,0BAA0B;CAC1B,WAAW;AACZ;AACA;CACC,WAAW;CACX,qBAAqB;CACrB,qBAAqB;CACrB,YAAY;CACZ,mBAAmB;CACnB,eAAe;AAChB;AACA;CACC,QAAQ;CACR,WAAW;CACX,eAAe;AAChB;AACA;;CAEC,WAAW;CACX,iBAAiB;CACjB,UAAU;AACX;AACA;CACC,cAAc;AACf;AACA;CACC,cAAc;AACf;AACA;;;CAGC,cAAc;CACd,kBAAkB;AACnB;AACA;CACC,gBAAgB;CAChB,WAAW;CACX,aAAa;CACb,cAAc;AACf;AACA;;CAEC,gBAAgB;AACjB;AACA;CACC,yBAAyB;CACzB,kBAAkB;CAClB,eAAe;CACf,qBAAqB;CACrB,YAAY;CACZ,iBAAiB;CACjB,kBAAkB;CAClB,WAAW;AACZ;AACA;CACC,yBAAyB;AAC1B;AACA;;CAEC,sBAAsB;AACvB;AACA;;CAEC,qBAAqB;AACtB;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,eAAe;CACf,YAAY;AACb;AACA;CACC,cAAc;CACd,iBAAiB;CACjB,UAAU;CACV,WAAW;AACZ;AACA;;;CAGC,WAAW;CACX,YAAY;CACZ,mBAAmB;AACpB;AACA;CACC,YAAY;AACb;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;CAClB,eAAe;CACf,YAAY;AACb;AACA;CACC,YAAY;CACZ,iBAAiB;CACjB,eAAe;CACf,gBAAgB;CAChB,kBAAkB;CAClB,yBAAyB;AAC1B;AACA;CACC,qBAAqB;CACrB,gBAAgB;CAChB,cAAc;CACd,cAAc;AACf;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;CAClB,SAAS;AACV;AACA;;CAEC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;CAClB,WAAW;CACX,mBAAmB;CACnB,cAAc;AACf;AACA;CACC,UAAU;AACX;AACA;CACC,eAAe;AAChB;AACA;CACC,gBAAgB;CAChB,eAAe;CACf,6BAA6B;CAC7B,gBAAgB;CAChB,SAAS;AACV;AACA;CACC,eAAe;CACf,kBAAkB;CAClB,mBAAmB;CACnB,sBAAsB;CACtB,sBAAsB;CACtB,eAAe;CACf,gBAAgB;CAChB,UAAU;CACV,eAAe;CACf,cAAc;CACd,iBAAiB;CACjB,gBAAgB;CAChB,UAAU;AACX;AACA;CACC,gBAAgB;AACjB;AACA;;CAEC,6BAA6B;AAC9B;AACA;;CAEC,qCAAqC;AACtC;AACA;;CAEC,qBAAqB;CACrB,yBAAyB;AAC1B;AACA;CACC,UAAU;CACV,cAAc;CACd,UAAU;CACV,WAAW;CACX,gBAAgB;AACjB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,qBAAqB;AACtB;AACA;CACC,0CAA0C;CAC1C,0CAA0C;CAC1C,uCAAuC;CACvC,YAAY;CACZ,aAAa;AACd;AACA;CACC,0CAA0C;CAC1C,+BAA+B;CAC/B,uCAAuC;CACvC,YAAY;CACZ,aAAa;AACd;AACA;;CAEC,WAAW;CACX,qBAAqB;CACrB,kBAAkB;CAClB,WAAW;CACX,4BAA4B;CAC5B,oCAAoC;CACpC,iCAAiC;AAClC;AACA;CACC,8CAA8C;CAC9C,uBAAuB;CACvB,iBAAiB;AAClB;AACA;CACC,SAAS;AACV;;AAEA;CAKC,+CAA+C;AAChD;AACA;;CAEC,UAAU;AACX;AACA;CAKC,8CAA8C;AAC/C;AACA;;;CAOC,8CAA8C;AAC/C;AACA;CAKC,8CAA8C;AAC/C;;AAEA;;CAEC,mBAAmB;CACnB,kBAAkB;AACnB;;AAEA;CACC,eAAe;CACf,qBAAqB;AACtB;AACA;CACC,qBAAqB;CACrB,kBAAkB;CAClB,eAAe;CACf,kBAAkB;CAClB,iBAAiB;CACjB,gBAAgB;AACjB;AACA;;CAEC,YAAY;CACZ,qBAAqB;CACrB,kBAAkB;CAClB,WAAW;CACX,YAAY;CACZ,OAAO;CACP,eAAe;CACf,kBAAkB;CAClB,MAAM;CACN,yBAAyB;CAKzB,+BAA+B;AAChC;AACA;CACC,0BAA0B;CAC1B,gBAAgB;CAChB,SAAS;CACT,kBAAkB;CAClB,eAAe;CACf,UAAU;CACV,WAAW;CACX,SAAS;CACT,yBAAyB;AAC1B;AACA;CACC,yBAAyB;CACzB,YAAY;CACZ,mBAAmB;AACpB;;AAEA;CACC,UAAU;AACX;;AAEA;;CAEC,mBAAmB;AACpB;;AAEA;;;;;CAKC,+BAA+B;AAChC;;AAEA;CACC,iBAAiB;AAClB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,yBAAyB;CACzB,YAAY;CACZ,mBAAmB;AACpB;;AAEA;CACC,0BAA0B;CAC1B,gBAAgB;CAChB,eAAe;CACf,mCAAmC;CACnC,kCAAkC;CAClC,qBAAqB;CACrB,kBAAkB;CAClB,YAAY;CACZ,SAAS;CACT,SAAS;AACV;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;;CAEC,UAAU;CAKV,+BAA+B;CAC/B,YAAY;CACZ,cAAc;AACf;;AAEA;CACC,0BAA0B;CAC1B,gBAAgB;CAChB,SAAS;CACT,kBAAkB;CAClB,SAAS;CACT,UAAU;CACV,eAAe;AAChB;;AAEA;CACC,UAAU;AACX;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;CACzB,kBAAkB;CAClB,gBAAgB;CAChB,YAAY;AACb;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA,iCAAiC;AACjC;CACC,gBAAgB;CAChB,yBAAyB;CACzB,mBAAmB;CACnB,iBAAiB;CACjB,6BAA6B;CAC7B,iBAAiB;CACjB,qBAAqB;CACrB,cAAc;CACd,kBAAkB;AACnB;AACA;;CAEC,qBAAqB;AACtB;;AAEA;CACC,qBAAqB;AACtB;AACA;CACC,gBAAgB;AACjB;;AAEA;CACC,qBAAqB;CACrB,yBAAyB;AAC1B;;AAEA;CACC,qBAAqB;CACrB,yBAAyB;AAC1B;;AAEA;CACC,qBAAqB;CACrB,yBAAyB;AAC1B;;AAEA;CACC,qBAAqB;CACrB,yBAAyB;AAC1B;;AAEA;CACC,qBAAqB;CACrB,yBAAyB;AAC1B;;AAEA;CACC,qBAAqB;CACrB,yBAAyB;AAC1B;;AAEA;CACC,qBAAqB;CACrB,yBAAyB;CACzB,cAAc;AACf;;AAEA;;CAEC,cAAc;CACd,yBAAyB;CACzB,qBAAqB;AACtB;;AAEA;;CAEC,cAAc;CACd,yBAAyB;CACzB,qBAAqB;AACtB;;AAEA;;CAEC,cAAc;CACd,yBAAyB;CACzB,qBAAqB;AACtB;;AAEA;;CAEC,cAAc;CACd,yBAAyB;CACzB,qBAAqB;AACtB;;AAEA;;CAEC,cAAc;CACd,yBAAyB;CACzB,qBAAqB;AACtB;;AAEA;;CAEC,cAAc;CACd,yBAAyB;CACzB,qBAAqB;AACtB;;AAEA;CACC,SAAS;CACT,8BAA8B;CAC9B,oBAAoB;CACpB,iBAAiB;CACjB,aAAa;CACb,eAAe;CACf,kBAAkB;CAClB,YAAY;CACZ,iBAAiB;CACjB,cAAc;CACd,eAAe;CACf,eAAe;CACf,yBAAyB;CACzB,uBAAuB;CACvB,aAAa;AACd;AACA;;CAEC,cAAc;CACd,0CAA0C;CAC1C,YAAY;AACb;AACA;;CAEC,gBAAgB;AACjB;AACA;;CAEC,kBAAkB;AACnB;AACA;CACC,QAAQ;AACT;AACA;CACC,OAAO;AACR;AACA;CACC,cAAc;CACd,8CAA8C;AAC/C;AACA;;;CAGC,yBAAyB;CACzB,qBAAqB;CACrB,cAAc;AACf;AACA;CACC,YAAY;AACb;AACA;;;CAGC,yBAAyB;CACzB,qBAAqB;AACtB;AACA;;;CAGC,yBAAyB;CACzB,qBAAqB;AACtB;AACA;;;CAGC,yBAAyB;CACzB,qBAAqB;AACtB;AACA;;;CAGC,yBAAyB;CACzB,qBAAqB;AACtB;AACA;;;CAGC,yBAAyB;CACzB,qBAAqB;AACtB;AACA;CACC,cAAc;AACf;AACA;;CAEC,0CAA0C;CAC1C,cAAc;AACf;AACA;;;CAGC,yBAAyB;CACzB,qBAAqB;CACrB,cAAc;AACf;;AAEA;CACC,sBAAsB;AACvB;AACA;CAKC,gDAAgD;AACjD;AACA;CACC,oDAAoD;AACrD;AACA;CACC,qDAAqD;AACtD;AACA;CACC,oDAAoD;AACrD;AACA;CACC,qDAAqD;AACtD;AACA;CACC,oDAAoD;AACrD;AACA;CACC,cAAc;AACf;AACA;CACC,cAAc;AACf;AACA;CACC,cAAc;AACf;AACA;CACC,cAAc;AACf;AACA;CACC,cAAc;AACf;AACA;CACC,cAAc;CACd,2CAA2C;AAC5C;AACA;CACC,gBAAgB;AACjB;AACA;CACC,eAAe;CACf,WAAW;CACX,YAAY;CACZ,cAAc;CACd,kBAAkB;CAClB,gDAAgD;CAChD,mBAAmB;CACnB,yBAAyB;CACzB,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;CAClB,eAAe;CACf,cAAc;CACd,gBAAgB;AACjB;AACA;CACC,cAAc;CACd,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,2BAA2B;AAC5B;AACA;CACC,WAAW;CACX,gBAAgB;CAChB,kBAAkB;AACnB;AACA;CACC,cAAc;AACf;AACA;CACC,WAAW;CACX,YAAY;CACZ,eAAe;CACf,eAAe;AAChB;AACA;CACC,cAAc;CACd,cAAc;CACd,gBAAgB;CAChB,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;;AAEA;CACC,cAAc;AACf;AACA;CACC,qDAAqD;AACtD;AACA;CACC,cAAc;AACf;AACA;CACC,qDAAqD;AACtD;AACA;CACC,cAAc;AACf;AACA;CACC,oDAAoD;AACrD;AACA;CACC,cAAc;AACf;AACA;CACC,qDAAqD;AACtD;AACA;CACC,cAAc;AACf;AACA;CACC,oDAAoD;AACrD;AACA;CACC,cAAc;AACf;;AAEA,+CAA+C;AAC/C;CACC,cAAc;AACf;AACA;CACC,YAAY;CACZ,gBAAgB;CAChB,gBAAgB;CAChB,cAAc;CACd,iBAAiB;AAClB;AACA;;;CAGC,yBAAyB;CACzB,cAAc;CACd,gBAAgB;AACjB;AACA;CACC,yBAAyB;CACzB,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,iBAAiB;CACjB,qBAAqB;AACtB;AACA;CACC,YAAY;CACZ,WAAW;AACZ;AACA;CACC,YAAY;CACZ,mBAAmB;CACnB,cAAc;AACf;;AAEA;CACC,iBAAiB;CACjB,oBAAoB;CACpB,kCAAkC;AACnC;AACA;CACC,YAAY;CACZ,WAAW;AACZ;AACA;CACC,YAAY;CACZ,mBAAmB;CACnB,cAAc;AACf;;AAEA;CACC,iBAAiB;CACjB,oBAAoB;CACpB,kCAAkC;AACnC;AACA;CACC,YAAY;CACZ,WAAW;AACZ;AACA;CACC,YAAY;CACZ,mBAAmB;CACnB,cAAc;AACf;;AAEA;CACC,yBAAyB;CACzB,cAAc;AACf;AACA;CACC,yBAAyB;CACzB,mBAAmB;CACnB,cAAc;AACf;;AAEA;CACC,yBAAyB;CACzB,cAAc;AACf;AACA;CACC,yBAAyB;CACzB,mBAAmB;CACnB,cAAc;AACf;;AAEA;CACC,yBAAyB;CACzB,cAAc;AACf;AACA;CACC,yBAAyB;CACzB,mBAAmB;CACnB,cAAc;AACf;;AAEA;CACC,yBAAyB;CACzB,cAAc;AACf;AACA;CACC,yBAAyB;CACzB,mBAAmB;CACnB,cAAc;AACf;;AAEA;;CAEC,+BAA+B;CAC/B,4BAA4B;CAC5B,gCAAgC;CAChC,6BAA6B;AAC9B;;AAEA;;CAEC,oCAAoC;AACrC;;AAEA;;CAEC,oCAAoC;AACrC;;AAEA;;CAEC,oCAAoC;AACrC;;AAEA;;CAEC,oCAAoC;AACrC;;AAEA;;CAEC,oCAAoC;AACrC;;AAEA;;CAEC,oCAAoC;AACrC;;AAEA;;CAEC,oCAAoC;AACrC;;AAEA;;CAEC,oCAAoC;AACrC;;AAEA,gDAAgD;AAChD;CACC,kBAAkB;CAClB,gCAAgC;CAChC,mBAAmB;AACpB;AACA;CACC,oBAAoB;AACrB;;AAEA;CACC,qBAAqB;CACrB,mBAAmB;CACnB,kBAAkB;CAClB,mBAAmB;CACnB,kBAAkB;CAClB,WAAW;AACZ;;AAEA;CACC,qBAAqB;CACrB,eAAe;CACf,gBAAgB;AACjB;AACA;CACC,cAAc;CACd,cAAc;CACd,6BAA6B;AAC9B;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,yBAAyB;CACzB,kBAAkB;AACnB;AACA;;;CAGC,6BAA6B;CAC7B,cAAc;AACf;AACA;;;CAGC,iCAAiC;CACjC,wCAAwC;CACxC,yCAAyC;CACzC,WAAW;CACX,qBAAqB;CACrB,kBAAkB;CAClB,UAAU;CACV,WAAW;AACZ;AACA;;;CAGC,iCAAiC;CACjC,wCAAwC;CACxC,yCAAyC;CACzC,WAAW;CACX,qBAAqB;CACrB,kBAAkB;CAClB,UAAU;CACV,WAAW;AACZ;AACA;CACC,6BAA6B;AAC9B;AACA;CACC,gBAAgB;CAChB,kBAAkB;CAClB,kBAAkB;AACnB;AACA;;CAEC,cAAc;CACd,yBAAyB;AAC1B;AACA;CACC,iCAAiC;CACjC,wCAAwC;CACxC,yCAAyC;CACzC,WAAW;CACX,qBAAqB;CACrB,kBAAkB;CAClB,WAAW;CACX,UAAU;AACX;AACA;CACC,iCAAiC;CACjC,wCAAwC;CACxC,yCAAyC;CACzC,WAAW;CACX,qBAAqB;CACrB,kBAAkB;CAClB,WAAW;CACX,UAAU;AACX;;AAEA;CACC,iBAAiB;AAClB;AACA;;;CAGC,YAAY;AACb;;AAEA;;CAEC,kBAAkB;AACnB;AACA;;CAEC,cAAc;CACd,mBAAmB;CACnB,yBAAyB;CACzB,kBAAkB;CAClB,YAAY;CACZ,yBAAyB;AAC1B;AACA;;;;CAIC,6BAA6B;CAC7B,UAAU;CACV,0BAA0B;AAC3B;AACA;;CAEC,eAAe;AAChB;AACA;;CAEC,cAAc;AACf;;AAEA;CACC,qBAAqB;AACtB;AACA;CACC,eAAe;CACf,mBAAmB;AACpB;AACA;CACC,kBAAkB;CAClB,mBAAmB;CACnB,cAAc;AACf;;AAEA;CACC,cAAc;AACf;AACA;CACC,mBAAmB;AACpB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;AACA;CACC,cAAc;CACd,yBAAyB;CACzB,cAAc;CACd,gBAAgB;CAChB,gBAAgB;AACjB;AACA;CACC,cAAc;AACf;AACA;CACC,aAAa;AACd;;AAEA;CACC,qBAAqB;AACtB;AACA;CACC,kBAAkB;AACnB;;AAEA;;;CAGC,gCAAgC;CAChC,kCAAkC;CAClC,qCAAqC;CACrC,WAAW;CACX,qBAAqB;CACrB,kBAAkB;CAClB,QAAQ;CACR,YAAY;AACb;;AAEA;;;CAGC,gCAAgC;CAChC,kCAAkC;CAClC,qCAAqC;CACrC,WAAW;CACX,qBAAqB;CACrB,kBAAkB;CAClB,WAAW;CACX,YAAY;AACb;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,+BAA+B;CAC/B,eAAe;CACf,eAAe;CACf,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,gDAAgD;CAChD,YAAY;CACZ,gBAAgB;CAChB,gBAAgB;AACjB;AACA;;;;CAIC,6BAA6B;CAC7B,8BAA8B;CAC9B,+BAA+B;CAC/B,gCAAgC;AACjC;AACA;CACC,+BAA+B;CAC/B,eAAe;CACf,0BAA0B;CAC1B,gBAAgB;CAChB,SAAS;CACT,eAAe;CACf,YAAY;CACZ,6BAA6B;AAC9B;AACA;CACC,aAAa;AACd;AACA;CACC,4BAA4B;CAC5B,SAAS;AACV;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,cAAc;AACf;AACA;CACC,2BAA2B;AAC5B;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,4BAA4B;AAC7B;AACA;CACC,0BAA0B;AAC3B;AACA;CACC,cAAc;CACd,YAAY;AACb;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,cAAc;AACf;AACA;CACC,2BAA2B;AAC5B;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,4BAA4B;AAC7B;AACA;CACC,0BAA0B;AAC3B;AACA;CACC,cAAc;CACd,YAAY;AACb;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,cAAc;AACf;AACA;CACC,2BAA2B;AAC5B;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,4BAA4B;AAC7B;AACA;CACC,0BAA0B;AAC3B;AACA;CACC,cAAc;CACd,YAAY;AACb;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,cAAc;AACf;AACA;CACC,2BAA2B;AAC5B;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,4BAA4B;AAC7B;AACA;CACC,0BAA0B;AAC3B;AACA;CACC,cAAc;CACd,YAAY;AACb;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,cAAc;AACf;AACA;CACC,2BAA2B;AAC5B;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,4BAA4B;AAC7B;AACA;CACC,0BAA0B;AAC3B;AACA;CACC,cAAc;CACd,YAAY;AACb;;AAEA;CACC,2BAA2B;AAC5B;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,4BAA4B;AAC7B;AACA;CACC,0BAA0B;AAC3B;;AAEA;CACC,sBAAsB;CACtB,gBAAgB;CAChB,yBAAyB;CACzB,eAAe;CACf,cAAc;CACd,+CAA+C;AAChD;;AAEA;CACC,gCAAgC;CAChC,aAAa;CACb,kBAAkB;CAClB,yBAAyB;AAC1B;AACA;CACC,gCAAgC;AACjC;AACA;CACC,gBAAgB;AACjB;AACA;CACC,aAAa;AACd;AACA;CACC,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,kBAAkB;CAClB,gBAAgB;CAChB,oCAAoC;AACrC;AACA;CACC,eAAe;AAChB;;AAEA;;CAEC,aAAa;AACd;;AAEA;CACC,cAAc;CACd,mBAAmB;CACnB,wEAAwE;AACzE;AACA;CACC,gBAAgB;AACjB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,6BAA6B;CAC7B,YAAY;AACb;AACA;CACC,kBAAkB;AACnB;;AAEA;;CAEC,qBAAqB;CACrB,kBAAkB;CAClB,UAAU;CACV,YAAY;AACb;;AAEA;CACC,aAAa;CACb,WAAW;CACX,SAAS;AACV;;AAEA;CACC,yBAAyB;CACzB,qBAAqB;CACrB,YAAY;CACZ,gBAAgB;CAChB,UAAU;AACX;;AAEA;CACC,kBAAkB;CAClB,mBAAmB;CACnB,oBAAoB;AACrB;AACA;CACC,WAAW;AACZ;;AAEA;;;CAGC,cAAc;AACf;;AAEA;CACC,gDAAgD;AACjD;AACA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,MAAM;CACN,aAAa;AACd;AACA;CACC,iBAAiB;CACjB,YAAY;AACb;;AAEA;;CAEC,eAAe;CACf,MAAM;CACN,YAAY;CACZ,SAAS;CACT,YAAY;CACZ,OAAO;CACP,YAAY;AACb;AACA;;CAEC,kBAAkB;CAClB,0BAA0B;CAC1B,cAAc;CACd,YAAY;CACZ,UAAU;CACV,qBAAqB;AACtB;AACA;;CAEC,wBAAwB;AACzB;AACA;;CAEC,YAAY;AACb;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;CAsCC,qBAAqB;AACtB;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;CAsCC,SAAS;CACT,kBAAkB;CAClB,0BAA0B;CAC1B,UAAU;CACV,mBAAmB;CACnB,cAAc;CACd,iBAAiB;CACjB,UAAU;AACX;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;CAsCC,yBAAyB;CACzB,WAAW;CACX,kBAAkB;CAClB,gBAAgB;CAChB,eAAe;CACf,kBAAkB;CAClB,iBAAiB;CACjB,kBAAkB;CAClB,WAAW;CACX,UAAU;CACV,gBAAgB;AACjB;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;CAsCC,0BAA0B;AAC3B;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;CA8BC,eAAe;CACf,iBAAiB;CACjB,WAAW;AACZ;AACA;;CAEC,kBAAkB;CAClB,WAAW;CACX,QAAQ;CACR,UAAU;AACX;AACA;;CAEC,gBAAgB;CAChB,cAAc;AACf;AACA;;CAEC,SAAS;CACT,kBAAkB;CAClB,WAAW;AACZ;AACA;;CAEC,eAAe;AAChB;AACA;;CAEC,mBAAmB;CACnB,cAAc;CACd,cAAc;CACd,qBAAqB;CACrB,kBAAkB;CAClB,yBAAyB;CACzB,eAAe;CACf,eAAe;CACf,iBAAiB;CACjB,iBAAiB;CACjB,YAAY;AACb;AACA;;CAEC,gBAAgB;AACjB;AACA;;;;CAIC,UAAU;CACV,yBAAyB;AAC1B;AACA;;;;CAIC,UAAU;AACX;AACA;;CAEC,8CAA8C;AAC/C;AACA;;;;;;;;;;;;;;;;;;;;;;CAsBC,yBAAyB;AAC1B;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;CAmEC,6BAA6B;CAC7B,gBAAgB;AACjB;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;CA2EC,WAAW;CACX,kBAAkB;CAClB,uBAAuB;CACvB,UAAU;AACX;AACA;;CAEC,aAAa;AACd;AACA;;CAEC,SAAS;CACT,iBAAiB;CACjB,kBAAkB;CAClB,cAAc;CACd,YAAY;CACZ,mBAAmB;CACnB,gBAAgB;AACjB;AACA;;CAEC,eAAe;CACf,WAAW;CACX,kBAAkB;CAClB,iBAAiB;CACjB,WAAW;CACX,kBAAkB;CAClB,+BAA+B;CAC/B,kBAAkB;AACnB;AACA;;;;CAIC,aAAa;CACb,yBAAyB;CACzB,mBAAmB;CACnB,sBAAsB;AACvB;AACA;;CAEC,kBAAkB;CAClB,UAAU;CACV,YAAY;CACZ,WAAW;CACX,cAAc;CACd,MAAM;CACN,OAAO;CACP,sBAAsB;CACtB,kCAAkC;AACnC;AACA;;CAEC,kBAAkB;CAClB,UAAU;CACV,WAAW;CACX,YAAY;CACZ,WAAW;CACX,cAAc;CACd,mBAAmB;CACnB,UAAU;AACX;AACA;;CAEC,kBAAkB;CAClB,mBAAmB;CACnB,UAAU;CACV,0BAA0B;AAC3B;AACA;;CAEC,UAAU;CACV,WAAW;CACX,WAAW;CACX,kBAAkB;CAClB,iBAAiB;CACjB,kBAAkB;AACnB;AACA;;CAEC,cAAc;CACd,UAAU;CACV,yBAAyB;CAKzB,iCAAiC;AAClC;AACA;;CAEC,WAAW;CACX,kBAAkB;CAClB,SAAS;CACT,WAAW;CACX,WAAW;CACX,wBAAwB;CACxB,0CAA0C;AAC3C;AACA;;CAEC,WAAW;CACX,eAAe;CACf,iBAAiB;CACjB,cAAc;CACd,iBAAiB;CACjB,mDAAmD;AACpD;AACA;;CAEC,yBAAyB;CACzB,iBAAiB;CACjB,cAAc;CACd,mBAAmB;CACnB,eAAe;CACf,cAAc;CACd,qBAAqB;CACrB,gBAAgB;CAChB,iBAAiB;CACjB,gBAAgB;AACjB;AACA;;CAEC,mBAAmB;AACpB;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;CAwCC,cAAc;CACd,YAAY;AACb;AACA;;;;CAIC,UAAU;AACX;AACA;;CAEC,cAAc;AACf;AACA;;CAEC,yBAAyB;CACzB,YAAY;AACb;AACA;;;;;;CAMC,yBAAyB;AAC1B;AACA;;CAEC,yBAAyB;CACzB,YAAY;AACb;AACA;;CAEC,mBAAmB;AACpB;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;CAwCC,cAAc;CACd,YAAY;AACb;AACA;;;;CAIC,UAAU;AACX;AACA;;CAEC,cAAc;AACf;AACA;;CAEC,yBAAyB;CACzB,YAAY;AACb;AACA;;;;;;CAMC,yBAAyB;AAC1B;AACA;;CAEC,yBAAyB;CACzB,YAAY;AACb;AACA;;CAEC,mBAAmB;AACpB;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;CAsDC,cAAc;CACd,UAAU;AACX;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;CA+CC,cAAc;CACd,UAAU;AACX;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;CAsDC,cAAc;CACd,UAAU;AACX;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;CAsDC,cAAc;CACd,UAAU;AACX;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;CAmDC,cAAc;CACd,UAAU;AACX;AACA;;CAEC,oBAAoB;CACpB,mBAAmB;CACnB,kBAAkB;AACnB;AACA;;CAEC,WAAW;CACX,kBAAkB;CAClB,SAAS;CACT,WAAW;CACX,WAAW;CACX,wBAAwB;CACxB,0CAA0C;AAC3C;AACA;;CAEC,WAAW;CACX,YAAY;CACZ,gBAAgB;CAChB,WAAW;CACX,UAAU;CACV,kBAAkB;CAClB,kBAAkB;CAClB,iBAAiB;AAClB;AACA;;CAEC,WAAW;AACZ;AACA;;CAEC,cAAc;CACd,qBAAqB;CACrB,oBAAoB;CACpB,mBAAmB;AACpB;AACA;;CAEC,cAAc;CACd,iBAAiB;AAClB;AACA;;CAEC,cAAc;CACd,kBAAkB;CAClB,UAAU;AACX;AACA;;CAEC,kBAAkB;CAClB,QAAQ;CACR,WAAW;AACZ;;AAEA;CACC,gCAAgC;AACjC;;AAEA;CACC,wBAAwB;AACzB;;AAEA;;CAEC,cAAc;AACf;AACA;CACC,oCAAoC;AACrC;;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ,yBAAyB;CACzB,yBAAyB;CAKzB,0DAA0D;AAC3D;AACA;CACC,oBAAoB;CACpB,+BAA+B;CAC/B,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,mBAAmB;AACpB;;AAEA;;CAEC,YAAY;CACZ,gBAAgB;AACjB;;AAEA;CACC;;;EAIC,uCAAuC;EAEvC,sCAAsC;EAEtC,gDAAgD;EAChD,iCAAiC;CAClC;;CAEA;EACC,wBAAwB;CACzB;CACA;EACC,gCAAgC;CACjC;CACA;;EAEC,WAAW;CACZ;CACA;EACC,wBAAwB;CACzB;CACA;EACC,cAAc;EACd,aAAa;CACd;CACA;EACC,UAAU;EAKV,mCAAmC;CACpC;CACA;EACC,UAAU;CACX;CACA;;;;;;;;;;;;;;;;;;;;;;;EA2BC,mCAAmC;EACnC,UAAU;CACX;CACA;EACC,YAAY;CACb;CACA;EACC,UAAU;EAKV,+BAA+B;CAChC;CACA;EACC,UAAU;EAKV,+BAA+B;CAChC;CACA;EACC,UAAU;CACX;CACA;EACC,YAAY;CACb;CACA;;;;;;;;;;;;;;;;;;;;;;;EA2BC,iCAAiC;EACjC,UAAU;CACX;AACD;AACA;CACC,aAAa;CACb,iBAAiB;CACjB,oBAAoB;CACpB,mBAAmB;CACnB,8BAA8B;CAS9B,4EAA4E;CAC5E,kBAAkB;CAClB,gBAAgB;AACjB;AACA;CACC,cAAc;AACf;AACA;CACC,gBAAgB;CAChB,+BAA+B;CAC/B,cAAc;CACd,eAAe;AAChB;AACA;CACC,cAAc;AACf;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,aAAa;AACd;;AAEA;CAGC,oBAAoB;CAGpB,mBAAmB;CAGnB,uBAAuB;CACvB,YAAY;CACZ,WAAW;CACX,kBAAkB;CAClB,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,gBAAgB;CAChB,oBAAoB;CACpB,kBAAkB;AACnB;AACA;CACC,MAAM;CACN,SAAS;CACT,kBAAkB;CAClB,YAAY;CACZ,UAAU;CACV,yBAAyB;CACzB,SAAS;CACT,mBAAmB;AACpB;AACA;CACC,SAAS;AACV;AACA;CACC,yBAAyB;CACzB,gBAAgB;CAChB,oBAAoB;AACrB;AACA;CACC,QAAQ;AACT;AACA;CACC,UAAU;AACX;AACA;CACC,QAAQ;AACT;AACA;CACC,mBAAmB;CACnB,kBAAkB;AACnB;AACA;;CAEC,YAAY;CACZ,cAAc;AACf;AACA;CACC,WAAW;AACZ;AACA;CACC,UAAU;CACV,WAAW;CACX,aAAa;CACb,kBAAkB;CAClB,8CAA8C;CAC9C,yBAAyB;CACzB,cAAc;CACd,mBAAmB;CACnB,kBAAkB;AACnB;AACA;CACC,kBAAkB;CAClB,SAAS;CACT,YAAY;CACZ,qBAAqB;CACrB,kCAAkC;CAClC,+BAA+B;CAC/B,6BAA6B;CAC7B,qCAAqC;CACrC,YAAY;AACb;AACA;CACC,kBAAkB;CAClB,SAAS;CACT,YAAY;CACZ,qBAAqB;CACrB,kCAAkC;CAClC,+BAA+B;CAC/B,6BAA6B;CAC7B,qCAAqC;CACrC,YAAY;AACb;AACA;CACC,cAAc;CACd,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,kBAAkB;CAClB,SAAS;CACT,SAAS;CACT,kBAAkB;CAClB,oCAAoC;CACpC,YAAY;CACZ,4BAA4B;CAC5B,2BAA2B;CAC3B,+BAA+B;CAC/B,8BAA8B;CAC9B,yBAAyB;AAC1B;AACA;;CAEC,oBAAoB;AACrB;AACA;CACC,gBAAgB;CAChB,WAAW;CACX,kBAAkB;CAClB,eAAe;AAChB;AACA;CACC,YAAY;CACZ,sBAAsB;AACvB;AACA;CACC,oBAAoB;CACpB,wBAAwB;CACxB,WAAW;CACX,WAAW;AACZ;AACA;CACC,oBAAoB;CACpB,wBAAwB;CACxB,WAAW;CACX,WAAW;AACZ;AACA;CACC,mBAAmB;AACpB;AACA;CACC,oCAAoC;AACrC;AACA;CACC,oCAAoC;AACrC;AACA;CACC,oCAAoC;AACrC;AACA;CACC,oCAAoC;AACrC;AACA;CACC,oCAAoC;AACrC;AACA;CACC,aAAa;CACb,cAAc;AACf;AACA;;CAEC,gBAAgB;AACjB;AACA;CACC,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,mBAAmB;CACnB,2BAA2B;CAC3B,kBAAkB;CAClB,kBAAkB;CAClB,YAAY;CASZ;uBACsB;AACvB;;AAEA;CACC;EACC,eAAe;CAChB;AACD;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;AACA;CACC,mBAAmB;CACnB,kBAAkB;CAClB,mBAAmB;CACnB,SAAS;AACV;AACA;CACC,6BAA6B;AAC9B;AACA;CACC,eAAe;AAChB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,aAAa;AACd;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,cAAc;AACf;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,gBAAgB;CAChB,aAAa;CACb,kBAAkB;AACnB;AACA;CACC,WAAW;CACX,YAAY;CACZ,gBAAgB;CAChB,kBAAkB;CAClB,mBAAmB;AACpB;AACA;CACC,cAAc;AACf;AACA;CACC,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,oBAAoB;AACrB;AACA;CACC,gBAAgB;CAChB,kBAAkB;CAClB,cAAc;AACf;;AAEA;CACC;EACC,eAAe;CAChB;AACD;;AAEA;CACC,6BAA6B;CAC7B,SAAS;AACV;AACA;CACC,iBAAiB;CACjB,kBAAkB;CAClB,QAAQ;CACR,cAAc;AACf;AACA;CACC,SAAS;AACV;AACA;CACC,6BAA6B;CAC7B,gBAAgB;CAChB,gBAAgB;AACjB;AACA;CACC,6BAA6B;CAC7B,8BAA8B;AAC/B;AACA;CACC,mBAAmB;AACpB;;AAEA;CACC,gBAAgB;CAChB,gBAAgB;AACjB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;CAChB,gCAAgC;AACjC;AACA;CACC,gBAAgB;AACjB;AACA;CACC,aAAa;CACb,wBAAwB;CACxB,kBAAkB;CAClB,mBAAmB;AACpB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,kBAAkB;CAClB,WAAW;CACX,SAAS;AACV;AACA;CACC,SAAS;AACV;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,aAAa;AACd;AACA;CACC,mBAAmB;AACpB;AACA;CACC,kBAAkB;CAClB,oBAAoB;CACpB,iBAAiB;AAClB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,YAAY;CACZ,aAAa;CACb,yBAAyB;CACzB,kBAAkB;AACnB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,qBAAqB;AACtB;AACA;CACC,cAAc;AACf;AACA;CACC,iBAAiB;CACjB,gBAAgB;AACjB;AACA;CACC,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,kCAAkC;CAClC,sBAAsB;CACtB,kBAAkB;AACnB;AACA;CACC,kBAAkB;CAClB,UAAU;CACV,iBAAiB;CACjB,gBAAgB;CAChB,cAAc;CACd,iBAAiB;CACjB,oBAAoB;AACrB;AACA;CACC,kBAAkB;CAClB,UAAU;AACX;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,cAAc;AACf;AACA;CACC,cAAc;CACd,gBAAgB;AACjB;AACA;;;CAGC,+BAA+B;AAChC;AACA;CACC,cAAc;CACd,iBAAiB;AAClB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,kBAAkB;CAClB,UAAU;CACV,WAAW;CACX,YAAY;CACZ,cAAc;CACd,OAAO;CACP,MAAM;CACN,WAAW;CACX,qCAAqC;CACrC,kBAAkB;AACnB;;AAEA;CACC,oBAAoB;AACrB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;CAClB,eAAe;AAChB;AACA;CACC,cAAc;CACd,WAAW;AACZ;AACA;CACC,YAAY;CACZ,kBAAkB;CAClB,cAAc;CACd,QAAQ;CACR,UAAU;AACX;AACA;CACC,WAAW;CACX,kBAAkB;CAClB,SAAS;CACT,OAAO;CACP,WAAW;CACX,WAAW;CACX,yBAAyB;AAC1B;AACA;CACC,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;CAChB,cAAc;CACd,mBAAmB;AACpB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,aAAa;CACb,mBAAmB;CACnB,mBAAmB;CACnB,aAAa;AACd;AACA;CACC,WAAW;CACX,kBAAkB;CAClB,OAAO;CACP,UAAU;CACV,YAAY;CACZ,oCAAoC;AACrC;AACA;CACC,SAAS;AACV;AACA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,gBAAgB;AACjB;;AAEA;CACC,oBAAoB;CACpB,kBAAkB;CAClB,kBAAkB;CAClB,UAAU;AACX;;AAEA;CACC,YAAY;CACZ,aAAa;CACb,kBAAkB;CAClB,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;AACnB;AACA;CACC,wBAAwB;AACzB;AACA;CACC,mBAAmB;CACnB,cAAc;AACf;AACA;CACC,mBAAmB;CACnB,yBAAyB;CACzB,cAAc;AACf;AACA;CACC,cAAc;AACf;AACA;CACC,cAAc;AACf;AACA;CACC,cAAc;AACf;AACA;CACC,cAAc;AACf;AACA;CACC,cAAc;AACf;AACA;CACC,eAAe;CACf,YAAY;CACZ,sBAAsB;CACtB,kBAAkB;CAClB,aAAa;CACb,kBAAkB;AACnB;AACA;CACC,2BAA2B;AAC5B;AACA;CACC,gBAAgB;CAChB,UAAU;CACV,gBAAgB;CAChB,iBAAiB;AAClB;AACA;CACC,cAAc;CACd,qBAAqB;AACtB;AACA;CACC,gBAAgB;CAChB,cAAc;AACf;AACA;CACC,cAAc;AACf;AACA;;CAEC,cAAc;AACf;AACA;CACC,cAAc;CACd,kBAAkB;CAClB,sCAAsC;AACvC;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,+BAA+B;AAChC;;AAEA;;CAEC,cAAc;AACf;AACA;CACC,gBAAgB;CAChB,cAAc;AACf;;AAEA;;;CAGC,cAAc;CACd,0CAA0C;AAC3C;;AAEA;CACC,gBAAgB;CAChB,kBAAkB;AACnB;AACA;CACC,aAAa;AACd;AACA;CACC,gBAAgB;AACjB;AACA;CACC,eAAe;AAChB;AACA;CACC,gBAAgB;CAChB,iBAAiB;CACjB,oBAAoB;AACrB;AACA;CACC,6BAA6B;AAC9B;AACA;CACC,gBAAgB;AACjB;AACA;CACC,aAAa;AACd;AACA;CACC,mBAAmB;AACpB;;AAEA;CACC,iBAAiB;CACjB,kBAAkB;CAClB,eAAe;AAChB;AACA;CACC,gBAAgB;CAChB,kBAAkB;CAClB,kBAAkB;AACnB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;CAChB,kBAAkB;AACnB;AACA;CACC,gBAAgB;CAChB,kBAAkB;AACnB;AACA;;CAEC,gBAAgB;CAChB,iBAAiB;CACjB,+CAA+C;AAChD;AACA;CACC,mBAAmB;CACnB,gBAAgB;AACjB;;AAEA;CACC,mEAAmE;CACnE,aAAa;AACd;AACA;CACC,WAAW;CACX,WAAW;CACX,cAAc;AACf;AACA;CACC,8CAA8C;CAC9C,cAAc;AACf;AACA;CACC,gBAAgB;CAChB,iBAAiB;CACjB,oBAAoB;AACrB;AACA;CACC,aAAa;CACb,kBAAkB;AACnB;AACA;CACC,gBAAgB;CAChB,UAAU;CACV,WAAW;CACX,eAAe;AAChB;AACA;CACC,cAAc;AACf;AACA;CACC,WAAW;CACX,UAAU;AACX;AACA;CACC,gBAAgB;CAChB,cAAc;AACf;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,sBAAsB;AACvB;AACA;CACC,iBAAiB;CACjB,cAAc;AACf;AACA;CACC,gBAAgB;AACjB;AACA;CACC,6BAA6B;CAC7B,eAAe;CACf,kBAAkB;AACnB;AACA;CACC,qBAAqB;AACtB;;AAEA;CACC,gBAAgB;CAChB,gBAAgB;AACjB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,yBAAyB;AAC1B;;AAEA;CACC,oCAAoC;CACpC,2BAA2B;CAC3B,4BAA4B;CAC5B,uBAAuB;AACxB;;AAEA;CACC,sBAAsB;CACtB,4BAA4B;AAC7B;AACA;CACC,qBAAqB;CACrB,4BAA4B;CAC5B,uBAAuB;AACxB;;AAEA;CACC,yBAAyB;AAC1B;AACA;CACC,iBAAiB;CACjB,cAAc;AACf;AACA;CACC,gBAAgB;AACjB;AACA;CACC,cAAc;CACd,eAAe;CACf,kBAAkB;AACnB;;AAEA;CACC,cAAc;AACf;AACA;CACC,gBAAgB;CAChB,mBAAmB;AACpB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,iBAAiB;AAClB;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,gBAAgB;CAChB,kBAAkB;AACnB;AACA;CACC,UAAU;AACX;AACA;CACC,eAAe;CACf,SAAS;CACT,cAAc;CACd,kBAAkB;CAClB,gBAAgB;CAChB,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;CAClB,eAAe;AAChB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,cAAc;CACd,iBAAiB;AAClB;AACA;CACC,aAAa;AACd;AACA;CACC,kBAAkB;CAClB,YAAY;CACZ,aAAa;AACd;AACA;CACC,cAAc;CACd,kBAAkB;AACnB;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,gBAAgB;AACjB;AACA;CACC,kBAAkB;CAClB,WAAW;CACX,YAAY;AACb;;AAEA;CACC,gBAAgB;AACjB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;CAChB,oBAAoB;AACrB;AACA;CACC,YAAY;AACb;AACA;CACC,eAAe;AAChB;AACA;CACC,4BAA4B;AAC7B;AACA;CACC,4BAA4B;AAC7B;AACA;CACC,cAAc;AACf;AACA;CACC,2BAA2B;AAC5B;;AAEA;CACC,eAAe;AAChB;AACA;CACC,kBAAkB;CAClB,sBAAsB;CACtB,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,WAAW;CACX,cAAc;CACd,mBAAmB;AACpB;AACA;CACC,WAAW;AACZ;AACA;CACC,kBAAkB;AACnB;AACA;CACC,cAAc;CACd,UAAU;CACV,0BAA0B;AAC3B;AACA;CACC,cAAc;CACd,UAAU;CACV,0BAA0B;AAC3B;AACA;CACC,cAAc;CACd,UAAU;CACV,0BAA0B;AAC3B;AACA;CACC,cAAc;CACd,UAAU;CACV,0BAA0B;AAC3B;AACA;CACC,sCAAsC;CACtC,cAAc;AACf;AACA;CACC,qBAAqB;CACrB,6BAA6B;CAC7B,cAAc;AACf;AACA;;CAEC,cAAc;AACf;AACA;CACC,6BAA6B;AAC9B;AACA;;CAEC,6BAA6B;CAC7B,sCAAsC;CACtC,cAAc;AACf;AACA;;;;;;;;;;CAUC,6BAA6B;CAC7B,qBAAqB;CACrB,cAAc;AACf;AACA;;CAEC,0CAA0C;CAC1C,cAAc;AACf;AACA;;;;;;CAMC,0CAA0C;CAC1C,cAAc;AACf;AACA;;;;;;;;;;;;;;;;;;;;;;;;CAwBC,0CAA0C;AAC3C;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;CAwEC,0CAA0C;CAC1C,cAAc;AACf;AACA;;;;;;;;;;;;;;;;;;;;;;;;CAwBC,0CAA0C;CAC1C,cAAc;AACf;AACA;;;;;;;;;;;;;;;;;;;;CAoBC,0CAA0C;CAC1C,YAAY;CACZ,cAAc;AACf;AACA;;;;;;;;;;;;;;;;;;;;CAoBC,0CAA0C;CAC1C,cAAc;AACf;AACA;;;CAGC,+BAA+B;AAChC;AACA;CACC,eAAe;CACf,cAAc;CACd,qBAAqB;AACtB;;AAEA;;CAEC,kBAAkB;CAClB,UAAU;AACX;AACA;CACC,gBAAiB;CAAjB,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,kBAAkB;CAClB,WAAW;CACX,SAAS;AACV;AACA;CACC,cAAc;AACf;AACA;CACC,kBAAkB;CAClB,UAAU;CACV,YAAY;CACZ,WAAW;CACX,cAAc;CACd,MAAM;CACN,OAAO;CACP,sBAAsB;CACtB,kCAAkC;AACnC;AACA;CACC,kBAAkB;CAClB,UAAU;CACV,WAAW;CACX,YAAY;CACZ,cAAc;CACd,OAAO;CACP,MAAM;CACN,WAAW;CACX,0CAA0C;AAC3C;AACA;CACC,mBAAmB;AACpB;AACA;CACC,eAAe;AAChB;AACA;CACC,qBAAqB;AACtB;AACA;CACC,2BAA2B;AAC5B;AACA;CACC,aAAa;AACd;AACA;CACC,cAAc;AACf;AACA;CACC,WAAW;CACX,YAAY;CACZ,eAAe;CACf,eAAe;AAChB;AACA;CACC,cAAc;CACd,cAAc;CACd,gBAAgB;CAChB,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;;AAEA;;;CAGC,0BAA0B;CAC1B,yBAAyB;AAC1B;AACA;;;CAGC,oCAAoC;CACpC,gBAAgB;AACjB;AACA;;;CAGC,yBAAyB;AAC1B;;AAEA;CACC;;;;;;EAMC,8BAA8B;CAC/B;CACA;;;;;;;;EAQC,yBAAyB;CAC1B;CACA;;;EAGC,yBAAyB;CAC1B;CACA;;;EAGC,aAAa;CACd;CACA;;;;;;;;;;;;EAYC,8BAA8B;CAC/B;AACD;AACA;CACC,eAAe;CACf,kBAAkB;CAClB,mBAAmB;AACpB;AACA;CACC,gBAAgB;AACjB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;CAChB,aAAa;CACb,WAAW;AACZ;;AAEA;CACC,sBAAsB;CACtB,kCAAkC;CAClC,kBAAkB;CAClB,WAAW;AACZ;AACA;;CAEC,cAAc;AACf;AACA;CACC,yBAAyB;AAC1B;AACA;;CAEC,yBAAyB;AAC1B;AACA;;;CAGC,cAAc;AACf;AACA;;CAEC,+BAA+B;AAChC;AACA;CACC,cAAc;AACf;AACA;;;CAGC,yBAAyB;AAC1B;AACA;CACC,cAAc;AACf;AACA;;CAEC,cAAc;AACf;AACA;CACC,+BAA+B;AAChC;AACA;CACC,kBAAkB;CAClB,UAAU;CACV,WAAW;CACX,YAAY;CACZ,cAAc;CACd,OAAO;CACP,MAAM;CACN,WAAW;CACX,oCAAoC;AACrC;AACA;CACC,UAAU;CACV,kBAAkB;AACnB;;AAEA;CACC,iBAAiB;CACjB,iBAAiB;CACjB,UAAU;CACV,cAAc;CACd,kBAAkB;AACnB;AACA;CACC,kBAAkB;CAClB,sBAAsB;CACtB,kCAAkC;CAClC,WAAW;CACX,YAAY;CACZ,WAAW;AACZ;AACA;CACC,kBAAkB;CAClB,QAAQ;CACR,SAAS;CACT,UAAU;CAGV,gCAAgC;CAChC,kBAAkB;CAClB,cAAc;CACd,eAAe;CACf,WAAW;CACX,gBAAgB;AACjB;AACA;CACC,kBAAkB;CAClB,SAAS;CACT,WAAW;AACZ;AACA;CACC,YAAY;CACZ,UAAU;AACX;AACA;;CAEC,+BAA+B;AAChC;AACA;CACC,gBAAgB;CAChB,iBAAiB;AAClB;AACA;CACC,gBAAgB;CAChB,iBAAiB;AAClB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,gBAAgB;AACjB;AACA;;CAEC,kBAAkB;CAClB,UAAU;CACV,WAAW;CACX,YAAY;CACZ,cAAc;CACd,OAAO;CACP,MAAM;CACN,WAAW;AACZ;AACA;CACC,oCAAoC;AACrC;AACA;CACC,iCAAiC;CACjC,+CAA+C;CAM/C,0BAA0B;CAM1B,2BAA2B;CAM3B,0BAA0B;CAC1B;;;;EAIC;CACD,oBAAoB;AACrB;;AAEA;;CAEC,aAAa;AACd;;AAEA;CACC,eAAe;AAChB;AACA;CACC,aAAa;CACb,kBAAkB;CAClB,kCAAkC;CAClC,sBAAsB;CACtB,gDAAgD;CAChD,sBAAsB;AACvB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,UAAU;AACX;AACA;CACC,iBAAiB;AAClB;AACA;CACC,UAAU;AACX;AACA;CACC,WAAW;CACX,OAAO;CACP,MAAM;CACN,YAAY;CACZ,kBAAkB;AACnB;AACA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;AACA;CACC,YAAY;CACZ,iBAAiB;CACjB,gBAAgB;CAChB,kBAAkB;CAClB,UAAU;CACV,YAAY;CACZ,UAAU;AACX;;AAEA;CACC,WAAW;CACX,OAAO;CACP,MAAM;CACN,YAAY;CACZ,kBAAkB;AACnB;AACA;CACC,aAAa;CACb,kBAAkB;AACnB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,aAAa;CACb,iBAAiB;CACjB,cAAc;AACf;AACA;CACC,eAAe;CACf,kBAAkB;CAClB,OAAO;CACP,MAAM;AACP;AACA;CACC,OAAO;CACP,QAAQ;AACT;AACA;CACC,QAAQ;CACR,SAAS;AACV;AACA;CACC,QAAQ;AACT;AACA;CACC,QAAQ;CACR,SAAS;AACV;AACA;CACC,QAAQ;CACR,QAAQ;AACT;AACA;CACC,QAAQ;CACR,SAAS;CACT,eAAe;CACf,cAAc;CACd,YAAY;AACb;AACA;CACC,QAAQ;CACR,SAAS;AACV;AACA;CACC,QAAQ;CACR,SAAS;AACV;AACA;CACC,QAAQ;CACR,SAAS;AACV;AACA;CACC,QAAQ;CACR,SAAS;AACV;AACA;CACC,QAAQ;CACR,SAAS;AACV;AACA;CACC,QAAQ;CACR,SAAS;AACV;AACA;CACC,OAAO;CACP,SAAS;AACV;AACA;CACC,QAAQ;CACR,SAAS;AACV;AACA;CACC,OAAO;CACP,SAAS;AACV;;AAEA;CACC,iBAAiB;CACjB,aAAa;AACd;AACA;;;CAGC,iBAAiB;AAClB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;CAChB,kBAAkB;CAClB,QAAQ;CACR,UAAU;AACX;AACA;CACC,gBAAgB;CAChB,kBAAkB;CAClB,QAAQ;CACR,UAAU;AACX;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,cAAc;AACf;AACA;CACC,0CAA0C;AAC3C;AACA;;;;;;;;CAQC,WAAc;CAAd,cAAc;AACf;AACA;;;;CAIC,0CAA0C;CAC1C,cAAc;AACf;AACA;;;;;;;;;;;;CAYC,yBAAyB;AAC1B;AACA;;;;;;CAMC,WAAc;CAAd,cAAc;AACf;AACA;;;CAGC,gBAAgB;AACjB;AACA;;;;;;;;;;;;;;;;;;;;;;;;;CAyBC,cAAc;AACf;AACA;;CAEC,cAAc;AACf;AACA;;;;CAIC,qBAAqB;AACtB;AACA;;;;;CAKC,sCAAsC;AACvC;AACA;;;;;;;;;;CAUC,+BAA+B;AAChC;AACA;;;;;;;;;;;;;;;;;;;;CAoBC,0CAA0C;AAC3C;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,cAAc;AACf;AACA;;;;CAIC,+BAA+B;AAChC;AACA;CACC,sCAAsC;AACvC;AACA;;;;;;;;;;;;CAYC,sCAAsC;AACvC;AACA;;;;;CAKC,cAAc;AACf;AACA;;;;;;;;CAQC,cAAc;AACf;AACA;;;;;;;;CAQC,yBAAyB;CACzB,qBAAqB;AACtB;AACA;;CAEC,cAAc;CACd,UAAU;CACV,0BAA0B;AAC3B;AACA;;CAEC,cAAc;CACd,UAAU;CACV,0BAA0B;AAC3B;AACA;;CAEC,cAAc;CACd,UAAU;CACV,0BAA0B;AAC3B;AACA;;CAEC,cAAc;CACd,UAAU;CACV,0BAA0B;AAC3B;AACA;CACC,sCAAsC;CACtC,cAAc;AACf;AACA;;CAEC,qBAAqB;CACrB,6BAA6B;CAC7B,cAAc;AACf;AACA;;CAEC,cAAc;AACf;AACA;;;CAGC,6BAA6B;AAC9B;AACA;;;;;;CAMC,6BAA6B;CAC7B,sCAAsC;CACtC,cAAc;AACf;AACA;;;;;;;;CAQC,6BAA6B;CAC7B,qBAAqB;CACrB,cAAc;AACf;AACA;;;;;;CAMC,0CAA0C;CAC1C,cAAc;AACf;AACA;;;;;;;;;;;;;;;;;;CAkBC,0CAA0C;CAC1C,cAAc;AACf;AACA;;;;;;;;;;;;;;;;;;;;CAoBC,0CAA0C;AAC3C;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;CA4DC,0CAA0C;CAC1C,cAAc;AACf;AACA;;;;;;;;;;;;;;;;;;;;CAoBC,0CAA0C;CAC1C,cAAc;AACf;AACA;;;;;;;;;;;;;;;;CAgBC,0CAA0C;CAC1C,YAAY;CACZ,cAAc;AACf;AACA;;;;;;;;;;;;;;;;CAgBC,0CAA0C;CAC1C,cAAc;AACf;AACA;;;;;;;CAOC,+BAA+B;AAChC;AACA;;;CAGC,6BAA6B;CAC7B,yBAAyB;CACzB,cAAc;AACf;AACA;;;CAGC,mBAAmB;AACpB;AACA;;;;;;;;;;;CAWC,cAAc;CACd,yBAAyB;AAC1B;AACA;CACC,6BAA6B;CAC7B,sCAAsC;CACtC,cAAc;AACf;AACA;;;;;;;;CAQC,6BAA6B;CAC7B,qBAAqB;AACtB;AACA;;;;;CAKC,cAAc;AACf;AACA;;;CAGC,cAAc;AACf;;AAEA;CACC;EACC,UAAU;CACX;CACA;EACC,cAAc;CACf;CACA;EACC,eAAe;EACf,eAAe;CAChB;;CAEA;EACC,iBAAiB;CAClB;;CAEA;EACC,aAAa;CACd;;CAEA;EACC,aAAa;CACd;;CAEA;EACC,mBAAmB;EACnB,kBAAkB;CACnB;CACA;EACC,SAAS;EACT,eAAe;CAChB;CACA;EACC,gBAAgB;CACjB;CACA;EACC,mBAAmB;CACpB;CACA;EACC,cAAc;CACf;CACA;EACC,aAAa;CACd;CACA;;EAEC,SAAS;EACT,gBAAgB;EAChB,wBAAwB;EACxB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;CACnB;CACA;;EAEC,aAAa;CACd;CACA;;EAEC,cAAc;CACf;CACA;;EAEC,cAAc;CACf;CACA;EACC,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,mBAAmB;CACpB;CACA;EACC,eAAe;CAChB;CACA;EACC,eAAe;CAChB;CACA;EACC,WAAW;EACX,6BAA6B;CAC9B;CACA;EACC,yBAAyB;CAC1B;CACA;EACC,WAAW;CACZ;CACA;EACC,eAAe;CAChB;;CAEA;EAKC,0DAA0D;CAC3D;;CAEA;EACC,QAAQ;EAKR,mCAAmC;CACpC;CACA;EAKC,iCAAiC;CAClC;CACA;EACC,kBAAkB;EAClB,kBAAkB;CACnB;CACA;EAKC,oCAAoC;CACrC;CACA;;EAMC,iCAAiC;CAClC;CACA;EAKC,oCAAoC;CACrC;CACA;EACC,YAAY;EACZ,UAAU;CACX;;CAEA;EACC,UAAU;EACV,QAAQ;EAKR,mCAAmC;CACpC;;CAEA;;;EAGC,8BAA8B;CAC/B;;CAEA;EACC,QAAQ;EAGR,+BAA+B;EAG/B,6BAA6B;CAC9B;;CAEA;EACC,UAAU;CACX;;CAEA;EACC,WAAW;EAGX,kCAAkC;EAGlC,6BAA6B;CAC9B;;CAEA;EACC,QAAQ;EAGR,4BAA4B;EAG5B,6BAA6B;CAC9B;;CAEA;EACC,UAAU;CACX;;CAEA;EACC,WAAW;EAGX,+BAA+B;EAG/B,6BAA6B;CAC9B;;CAEA;EACC;GACC,QAAQ;GACR,uBAAuB;EACxB;EACA;GACC,QAAQ;GACR,yBAAyB;EAC1B;EACA;GACC,yBAAyB;EAC1B;EACA;GACC,yBAAyB;EAC1B;CACD;CAiCA;EACC;GACC,QAAQ;GACR,yBAAyB;EAC1B;EACA;GACC,yBAAyB;EAC1B;EACA;GACC,uBAAuB;EACxB;EACA;GACC,QAAQ;GACR,oBAAoB;EACrB;CACD;CAiCA;EACC;GACC,WAAW;GACX,uBAAuB;EACxB;EACA;GACC,WAAW;GACX,0BAA0B;EAC3B;EACA;GACC,0BAA0B;EAC3B;EACA;GACC,0BAA0B;EAC3B;CACD;CAiCA;EACC;GACC,WAAW;GACX,0BAA0B;EAC3B;EACA;GACC,wBAAwB;EACzB;EACA;GACC,wBAAwB;EACzB;EACA;GACC,WAAW;GACX,oBAAoB;EACrB;CACD;CAiDA;EACC;GACC,UAAU;EACX;EACA;GACC,UAAU;EACX;CACD;CACA;EACC,YAAY;EACZ,WAAW;EACX,eAAe;EACf,UAAU;EACV,MAAM;EACN,QAAQ;EACR,WAAW;EACX,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,6BAA6B;EAK7B,0DAA0D;CAC3D;;CAEA;EACC,iBAAiB;CAClB;;CAEA;EACC,gBAAgB;CACjB;;CAEA;;EAEC,YAAY;CACb;;CAEA;;EAEC,eAAe;EACf,cAAc;EACd,MAAM;EACN,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,UAAU;EAKV,0DAA0D;EAK1D,oCAAoC;CACrC;;CAEA;EACC,WAAW;CACZ;;CAEA;EACC,mBAAmB;CACpB;CACA;EACC,mBAAmB;CACpB;CACA;EACC,uBAAuB;EACvB,qBAAqB;CACtB;CACA;EACC,+BAA+B;EAC/B,mCAAmC;EACnC,sBAAsB;EACtB,sBAAsB;CACvB;CACA;EACC,+BAA+B;EAC/B,mCAAmC;EACnC,sBAAsB;EACtB,sBAAsB;CACvB;AACD;AACA;CACC;EACC,gBAAgB;CACjB;AACD;AACA;CACC;EACC,kBAAkB;EAClB,uBAAuB;CACxB;CACA;EACC,mBAAmB;CACpB;AACD;AACA;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,aAAa;CACd;;CAEA;EACC,UAAU;EACV,kBAAkB;CACnB;;CAEA;EACC,kBAAkB;CACnB;;CAEA;EACC,cAAc;CACf;;CAEA;EACC,YAAY;EACZ,mBAAmB;CACpB;;CAEA;;;;;;;;EAQC,gCAAgC;EAChC,kCAAkC;EAClC,qCAAqC;EACrC,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,QAAQ;EACR,iCAAiC;CAClC;CACA;;;;;;;;EAQC,gCAAgC;EAChC,kCAAkC;EAClC,qCAAqC;EACrC,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,QAAQ;EACR,iCAAiC;CAClC;CACA;;;;;;;;;;;;;;;;EAgBC,MAAM;CACP;AACD;AACA;CACC;EACC,aAAa;CACd;;CAEA;EACC,kBAAkB;EAClB,mBAAmB;CACpB;;CAEA;EACC,cAAc;EACd,kBAAkB;EAClB,WAAW;CACZ;;CAEA;EACC,cAAc;EACd,mBAAmB;CACpB;;CAEA;EACC,gBAAgB;CACjB;AACD;AACA;CACC;EACC,eAAe;CAChB;;CAEA;EACC,4BAA4B;CAC7B;CACA;EACC,sBAAsB;CACvB;;CAEA;;;;EAIC,qBAAqB;CACtB;;CAEA;;EAEC,yBAAyB;CAC1B;CACA;EACC,8BAA8B;CAC/B;;CAEA;EACC,gBAAgB;CACjB;CACA;EACC,kBAAkB;CACnB;CACA;EACC,aAAa;CACd;AACD;AACA;CACC;EACC,iBAAiB;CAClB;AACD;AACA;CACC;EACC,uBAAuB;CACxB;CACA;;;EAGC,8CAA8C;CAC/C;CACA;;EAEC,wBAAwB;CACzB;AACD;AACA;CACC;EACC,cAAc;EACd,eAAe;CAChB;;CAEA;EACC,sBAAsB;CACvB;CACA;EACC,mBAAmB;CACpB;;CAEA;EACC,kBAAkB;CACnB;;CAEA;EACC,eAAe;CAChB;CACA;EACC,eAAe;CAChB;;CAEA;EACC,UAAU;CACX;;CAEA;EACC,UAAU;EACV,aAAa;CACd;AACD;AACA;CACC,iBAAiB;CACjB,gBAAgB;AACjB;;AAEA,iCAAiC;AACjC;CACC,gBAAgB;AACjB;;AAEA;;CAEC,iBAAiB;AAClB;;AAEA;;CAEC,gBAAgB;AACjB;;AAEA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;;AAEA;;CAEC,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,sBAAsB;AACvB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,WAAW;CACX,cAAc;CACd,mBAAmB;AACpB;AACA;CACC,WAAW;AACZ;AACA;CACC,kBAAkB;AACnB;AACA;CACC,cAAc;CACd,UAAU;CACV,0BAA0B;AAC3B;AACA;CACC,cAAc;CACd,UAAU;CACV,0BAA0B;AAC3B;AACA;CACC,cAAc;CACd,UAAU;CACV,0BAA0B;AAC3B;AACA;CACC,cAAc;CACd,UAAU;CACV,0BAA0B;AAC3B;AACA;CACC,sCAAsC;CACtC,cAAc;AACf;AACA;CACC,qBAAqB;CACrB,6BAA6B;CAC7B,cAAc;AACf;AACA;;CAEC,cAAc;AACf;AACA;CACC,6BAA6B;AAC9B;AACA;;CAEC,6BAA6B;CAC7B,sCAAsC;CACtC,cAAc;AACf;AACA;;;;;;;;;;CAUC,6BAA6B;CAC7B,qBAAqB;CACrB,cAAc;AACf;AACA;;CAEC,0CAA0C;CAC1C,cAAc;AACf;AACA;;;;;;CAMC,0CAA0C;CAC1C,cAAc;AACf;AACA;;;;;;;;;;;;;;;;;;;;;;;;CAwBC,0CAA0C;AAC3C;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;CAwEC,0CAA0C;CAC1C,cAAc;AACf;AACA;;;;;;;;;;;;;;;;;;;;;;;;CAwBC,0CAA0C;CAC1C,cAAc;AACf;AACA;;;;;;;;;;;;;;;;;;;;CAoBC,0CAA0C;CAC1C,YAAY;CACZ,cAAc;AACf;AACA;;;;;;;;;;;;;;;;;;;;CAoBC,0CAA0C;CAC1C,cAAc;AACf;AACA;;;CAGC,+BAA+B;AAChC;AACA;CACC,eAAe;CACf,cAAc;CACd,qBAAqB;AACtB;;AAEA;CACC,mBAAmB;CACnB,iBAAiB;CACjB,sBAAsB;AACvB;AACA;CACC,kBAAkB;CAClB,UAAU;AACX;AACA;CACC,kBAAkB;CAClB,WAAW;CACX,SAAS;AACV;AACA;CACC,cAAc;AACf;AACA;CACC,kBAAkB;CAClB,UAAU;CACV,YAAY;CACZ,WAAW;CACX,cAAc;CACd,MAAM;CACN,OAAO;CACP,sBAAsB;CACtB,kCAAkC;AACnC;AACA;CACC,kBAAkB;CAClB,UAAU;CACV,WAAW;CACX,YAAY;CACZ,cAAc;CACd,OAAO;CACP,MAAM;CACN,WAAW;CACX,oCAAoC;AACrC;AACA;CACC,mBAAmB;AACpB;AACA;CACC,eAAe;AAChB;AACA;CACC,qBAAqB;AACtB;AACA;CACC,2BAA2B;AAC5B;AACA;CACC,aAAa;AACd;AACA;CACC,cAAc;AACf;AACA;CACC,WAAW;CACX,YAAY;CACZ,eAAe;CACf,eAAe;AAChB;AACA;CACC,cAAc;CACd,cAAc;CACd,gBAAgB;CAChB,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;;AAEA;;;CAGC,0BAA0B;CAC1B,yBAAyB;AAC1B;AACA;;;CAGC,iBAAiB;AAClB;AACA;;;CAGC,oCAAoC;CACpC,gBAAgB;AACjB;AACA;;;CAGC,yBAAyB;AAC1B;;AAEA;;;CAGC,WAAW;AACZ;;AAEA;CACC;;;;;;EAMC,8BAA8B;CAC/B;CACA;;;;;;;;EAQC,yBAAyB;CAC1B;CACA;;;EAGC,yBAAyB;CAC1B;CACA;;;EAGC,aAAa;CACd;CACA;;;;;;;;;;;;EAYC,8BAA8B;CAC/B;AACD;AACA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,sBAAsB;AACvB;;AAEA;CACC,kBAAkB;CAClB,MAAM;CACN,QAAQ;CACR,WAAW;CACX,YAAY;CACZ,SAAS;CACT,eAAe;CACf,eAAe;CACf,wBAAwB;CACxB,UAAU;CACV,cAAc;AACf;;AAEA;CACC,qBAAqB;CACrB,kBAAkB;AACnB;AACA;CACC,aAAa;AACd;;AAEA;CACC,qBAAqB;CACrB,gBAAgB;CAChB,mBAAmB;CACnB,gBAAgB;CAChB,sBAAsB;CACtB,YAAY;AACb;;AAEA;CACC,qBAAqB;CACrB,mBAAmB;CACnB,gBAAgB;CAChB,kBAAkB;CAClB,sBAAsB;CACtB,gBAAgB;CAChB,8CAA8C;AAC/C;AACA;CACC,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;;CAEC,aAAa;AACd;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,qBAAqB;CACrB,gBAAgB;CAChB,sBAAsB;AACvB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,UAAU;AACX;;AAEA;CACC,UAAU;AACX;;AAEA;;CAEC,0BAA0B;AAC3B;;AAEA;;;;CAIC,0BAA0B;AAC3B;;AAEA;;CAEC,0BAA0B;AAC3B;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,cAAc;CACd,kBAAkB;CAClB,UAAU;AACX;;AAEA;CACC,kBAAkB;CAClB,eAAe;CACf,kBAAkB;AACnB;;AAEA;CACC,YAAY;CACZ,aAAa;CACb,yBAAyB;CACzB,yBAAyB;CACzB,cAAc;CACd,kBAAkB;CAClB,gBAAgB;CAChB,gBAAgB;CAChB,oBAAoB;CACpB,4BAA4B;AAC7B;AACA;CACC,qBAAqB;AACtB;;AAEA;CACC,eAAe;CACf,cAAc;CACd,YAAY;CACZ,OAAO;CACP,qBAAqB;CACrB,kBAAkB;CAClB,MAAM;CACN,WAAW;AACZ;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,eAAe;CACf,QAAQ;CACR,WAAW;CACX,8BAA8B;CAC9B,aAAa;CACb,0BAA0B;CAC1B,kBAAkB;CAClB,UAAU;AACX;AACA;;CAEC,qBAAqB;CACrB,6BAA6B;CAC7B,0BAA0B;AAC3B;AACA;CACC,cAAc;CACd,aAAa;CACb,0BAA0B;CAC1B,WAAW;AACZ;AACA;CACC,WAAW;CACX,qBAAqB;CACrB,qBAAqB;CACrB,YAAY;CACZ,mBAAmB;CACnB,eAAe;AAChB;AACA;CACC,QAAQ;CACR,WAAW;CACX,eAAe;AAChB;AACA;;CAEC,WAAW;CACX,iBAAiB;CACjB,UAAU;AACX;AACA;CACC,cAAc;AACf;AACA;CACC,cAAc;AACf;AACA;;;CAGC,cAAc;CACd,kBAAkB;AACnB;AACA;CACC,gBAAgB;CAChB,WAAW;CACX,aAAa;CACb,cAAc;AACf;AACA;;CAEC,gBAAgB;AACjB;AACA;CACC,yBAAyB;CACzB,kBAAkB;CAClB,eAAe;CACf,qBAAqB;CACrB,YAAY;CACZ,iBAAiB;CACjB,kBAAkB;CAClB,WAAW;AACZ;AACA;CACC,qBAAqB;CACrB,yBAAyB;CACzB,yBAAyB;AAC1B;AACA;CACC,qBAAqB;CACrB,yBAAyB;CACzB,yBAAyB;AAC1B;AACA;;CAEC,qBAAqB;AACtB;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,eAAe;CACf,YAAY;AACb;AACA;CACC,cAAc;CACd,iBAAiB;CACjB,UAAU;CACV,WAAW;AACZ;AACA;;;CAGC,WAAW;CACX,YAAY;CACZ,mBAAmB;AACpB;AACA;CACC,YAAY;AACb;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;CAClB,eAAe;CACf,YAAY;AACb;AACA;CACC,YAAY;CACZ,iBAAiB;CACjB,eAAe;CACf,gBAAgB;CAChB,kBAAkB;CAClB,yBAAyB;AAC1B;AACA;CACC,qBAAqB;CACrB,gBAAgB;CAChB,cAAc;CACd,cAAc;AACf;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;CAClB,SAAS;AACV;AACA;;CAEC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;CAClB,WAAW;CACX,mBAAmB;CACnB,cAAc;AACf;AACA;CACC,UAAU;AACX;AACA;CACC,eAAe;AAChB;AACA;CACC,gBAAgB;CAChB,eAAe;CACf,6BAA6B;CAC7B,gBAAgB;CAChB,SAAS;AACV;AACA;CACC,eAAe;CACf,kBAAkB;CAClB,mBAAmB;CACnB,sBAAsB;CACtB,sBAAsB;CACtB,eAAe;CACf,gBAAgB;CAChB,UAAU;CACV,eAAe;CACf,cAAc;CACd,iBAAiB;CACjB,gBAAgB;CAChB,UAAU;AACX;AACA;CACC,gBAAgB;AACjB;AACA;;CAEC,6BAA6B;AAC9B;AACA;;CAEC,qCAAqC;AACtC;AACA;;CAEC,qBAAqB;CACrB,yBAAyB;AAC1B;AACA;CACC,UAAU;CACV,cAAc;CACd,UAAU;CACV,WAAW;CACX,gBAAgB;AACjB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,qBAAqB;AACtB;AACA;CACC,0CAA0C;CAC1C,0CAA0C;CAC1C,uCAAuC;CACvC,YAAY;CACZ,aAAa;AACd;AACA;CACC,0CAA0C;CAC1C,+BAA+B;CAC/B,uCAAuC;CACvC,YAAY;CACZ,aAAa;AACd;AACA;;CAEC,WAAW;CACX,qBAAqB;CACrB,kBAAkB;CAClB,WAAW;CACX,4BAA4B;CAC5B,oCAAoC;CACpC,iCAAiC;AAClC;AACA;CACC,8CAA8C;CAC9C,uBAAuB;CACvB,iBAAiB;AAClB;AACA;CACC,SAAS;AACV;;AAEA;CAKC,+CAA+C;AAChD;AACA;;CAEC,UAAU;AACX;AACA;CAKC,8CAA8C;AAC/C;AACA;;;CAOC,8CAA8C;AAC/C;AACA;CAKC,8CAA8C;AAC/C;;AAEA;CACC,UAAU;CACV,gBAAe;CAAf,iBAAe;CACf,MAAM;CACN,QAAQ;CACR,SAAS;CACT,OAAO;CACP,WAAW;CACX,aAAc;CAAd,gBAAc;AACf;;AAEA;;CAEC,aAAa;CACb,SAAO;CACP,kBAAkB;CAClB,WAAY;CAAZ,cAAY;CACZ,YAAY;AACb;;AAEA;;CAEC,gBAAgB;AACjB;;AAEA;;;;;kCAKkC;AAClC;CACC,2BAA2B;CAC3B,4CAA0C;CAC1C;;;4DAGyD;CACzD,mBAAmB;CACnB,kBAAkB;AACnB;AACA,oCAAoC;AACpC,+CAA+C;AAC/C;CACC,cAAc;AACf;AACA;;;CAGC,yBAAyB;CACzB,cAAc;AACf;AACA;CACC,8BAA8B;CAC9B,mBAAmB;AACpB;AACA;CACC,yBAAyB;CACzB,cAAc;AACf;;AAEA;CACC,yBAAyB;CACzB,cAAc;AACf;AACA;CACC,yBAAyB;CACzB,mBAAmB;CACnB,cAAc;AACf;;AAEA;CACC,yBAAyB;CACzB,cAAc;AACf;AACA;CACC,yBAAyB;CACzB,mBAAmB;CACnB,cAAc;AACf;;AAEA;CACC,yBAAyB;CACzB,cAAc;AACf;AACA;CACC,yBAAyB;CACzB,mBAAmB;CACnB,cAAc;AACf;;AAEA;CACC,yBAAyB;CACzB,cAAc;AACf;AACA;CACC,yBAAyB;CACzB,mBAAmB;CACnB,cAAc;AACf;;AAEA;CACC,yBAAyB;CACzB,cAAc;AACf;AACA;CACC,yBAAyB;CACzB,mBAAmB;CACnB,cAAc;AACf;;AAEA;;CAEC,+BAA+B;CAC/B,4BAA4B;CAC5B,gCAAgC;CAChC,6BAA6B;AAC9B;;AAEA;;CAEC,oCAAoC;AACrC;;AAEA;;CAEC,oCAAoC;AACrC;;AAEA;;CAEC,oCAAoC;AACrC;;AAEA;;CAEC,oCAAoC;AACrC;;AAEA;;CAEC,oCAAoC;AACrC;;AAEA;;CAEC,oCAAoC;AACrC;;AAEA;CACC;EACC,UAAU;CACX;CACA;EACC,cAAc;CACf;CACA;EACC,eAAe;EACf,eAAe;CAChB;;CAEA;EACC,iBAAiB;CAClB;;CAEA;EACC,aAAa;CACd;;CAEA;EACC,aAAa;CACd;;CAEA;EACC,mBAAmB;EACnB,kBAAkB;CACnB;CACA;EACC,SAAS;EACT,eAAe;CAChB;CACA;EACC,gBAAgB;CACjB;CACA;EACC,mBAAmB;CACpB;CACA;EACC,yBAAyB;EACzB,gDAAgD;CACjD;CACA;EACC,aAAa;CACd;CACA;;EAEC,SAAS;EACT,gBAAgB;EAChB,wBAAwB;EACxB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,kBAAkB;CACnB;CACA;;EAEC,aAAa;CACd;CACA;;EAEC,cAAc;CACf;CACA;;EAEC,cAAc;CACf;CACA;EACC,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,mBAAmB;CACpB;CACA;EACC,eAAe;CAChB;CACA;EACC,eAAe;CAChB;CACA;EACC,WAAW;EACX,6BAA6B;CAC9B;CACA;EACC,yBAAyB;CAC1B;CACA;EACC,WAAW;CACZ;CACA;EACC,eAAe;CAChB;;CAEA;EAKC,0DAA0D;CAC3D;;CAEA;EACC,QAAQ;EAKR,mCAAmC;CACpC;CACA;EAKC,iCAAiC;CAClC;CACA;EACC,kBAAkB;EAClB,kBAAkB;CACnB;CACA;EAKC,oCAAoC;CACrC;CACA;;EAMC,iCAAiC;CAClC;CACA;EAKC,oCAAoC;CACrC;CACA;EACC,UAAU;CACX;;CAEA;EACC,UAAU;EACV,QAAQ;EAKR,mCAAmC;CACpC;;CAEA;;;EAGC,8BAA8B;CAC/B;;CAEA;EACC,QAAQ;EAGR,+BAA+B;EAG/B,6BAA6B;CAC9B;;CAEA;EACC,UAAU;CACX;;CAEA;EACC,WAAW;EAGX,kCAAkC;EAGlC,6BAA6B;CAC9B;;CAEA;EACC,QAAQ;EAGR,4BAA4B;EAG5B,6BAA6B;CAC9B;;CAEA;EACC,UAAU;CACX;;CAEA;EACC,WAAW;EAGX,+BAA+B;EAG/B,6BAA6B;CAC9B;;CAEA;EACC;GACC,QAAQ;GACR,uBAAuB;EACxB;EACA;GACC,QAAQ;GACR,yBAAyB;EAC1B;EACA;GACC,yBAAyB;EAC1B;EACA;GACC,yBAAyB;EAC1B;CACD;CAiCA;EACC;GACC,QAAQ;GACR,yBAAyB;EAC1B;EACA;GACC,yBAAyB;EAC1B;EACA;GACC,uBAAuB;EACxB;EACA;GACC,QAAQ;GACR,oBAAoB;EACrB;CACD;CAiCA;EACC;GACC,WAAW;GACX,uBAAuB;EACxB;EACA;GACC,WAAW;GACX,0BAA0B;EAC3B;EACA;GACC,0BAA0B;EAC3B;EACA;GACC,0BAA0B;EAC3B;CACD;CAiCA;EACC;GACC,WAAW;GACX,0BAA0B;EAC3B;EACA;GACC,wBAAwB;EACzB;EACA;GACC,wBAAwB;EACzB;EACA;GACC,WAAW;GACX,oBAAoB;EACrB;CACD;CAiDA;EACC;GACC,UAAU;EACX;EACA;GACC,UAAU;EACX;CACD;CACA;EACC,YAAY;EACZ,WAAW;EACX,eAAe;EACf,UAAU;EACV,MAAM;EACN,QAAQ;EACR,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,6BAA6B;EAK7B,0DAA0D;CAC3D;;CAEA;EACC,iBAAiB;CAClB;;CAEA;EACC,gBAAgB;CACjB;;CAEA;;EAEC,YAAY;CACb;;CAEA;;EAEC,eAAe;EACf,cAAc;EACd,MAAM;EACN,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,UAAU;EAKV,0DAA0D;EAK1D,oCAAoC;CACrC;;CAEA;EACC,WAAW;CACZ;;CAEA;EACC,mBAAmB;CACpB;CACA;EACC,mBAAmB;CACpB;CACA;EACC,uBAAuB;EACvB,qBAAqB;CACtB;CACA;EACC,+BAA+B;EAC/B,mCAAmC;EACnC,sBAAsB;EACtB,sBAAsB;CACvB;CACA;EACC,+BAA+B;EAC/B,mCAAmC;EACnC,sBAAsB;EACtB,sBAAsB;CACvB;;CAEA;EACC,WAAW;CACZ;CACA;EACC,gBAAgB;EAChB,WAAW;CACZ;AACD;AACA;CACC;EACC,gBAAgB;CACjB;AACD;AACA;CACC;EACC,kBAAkB;CACnB;CACA;EACC,mBAAmB;CACpB;AACD;AACA;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,aAAa;CACd;;CAEA;EACC,UAAU;EACV,kBAAkB;CACnB;;CAEA;EACC,kBAAkB;CACnB;;CAEA;EACC,cAAc;CACf;;CAEA;EACC,YAAY;EACZ,mBAAmB;CACpB;;CAEA;;;;;;;;EAQC,SAAS;CACV;CACA;;;;;;;;EAQC,SAAS;CACV;CACA;;;;;;;;;;;;;;EAcC,wBAAwB;CACzB;CACA;EACC,gCAAgC;EAChC,kCAAkC;EAClC,qCAAqC;EACrC,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,QAAQ;EACR,iCAAiC;CAClC;CACA;EACC,gCAAgC;EAChC,kCAAkC;EAClC,qCAAqC;EACrC,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,QAAQ;EACR,iCAAiC;CAClC;AACD;AACA;CACC;EACC,aAAa;CACd;;CAEA;EACC,kBAAkB;EAClB,mBAAmB;CACpB;;CAEA;EACC,cAAc;EACd,kBAAkB;EAClB,WAAW;CACZ;;CAEA;EACC,cAAc;EACd,mBAAmB;CACpB;;CAEA;EACC,gBAAgB;CACjB;AACD;AACA;CACC;EACC,4BAA4B;CAC7B;CACA;EACC,sBAAsB;CACvB;;CAEA;;;EAGC,oBAAoB;CACrB;;CAEA;;EAEC,yBAAyB;CAC1B;CACA;EACC,8BAA8B;CAC/B;;CAEA;EACC,gBAAgB;CACjB;CACA;EACC,kBAAkB;CACnB;CACA;EACC,aAAa;CACd;AACD;AACA;CACC;EACC,uBAAuB;CACxB;CACA;;;EAGC,8CAA8C;CAC/C;CACA;;EAEC,wBAAwB;CACzB;AACD;AACA;CACC;EACC,cAAc;EACd,eAAe;CAChB;;CAEA;EACC,sBAAsB;CACvB;CACA;EACC,mBAAmB;CACpB;;CAEA;EACC,kBAAkB;CACnB;;CAEA;EACC,eAAe;CAChB;CACA;EACC,eAAe;CAChB;;CAEA;EACC,UAAU;CACX;;CAEA;EACC,UAAU;EACV,aAAa;CACd;AACD;AACA;CACC,kBAAkB;CAClB,MAAM;CACN,aAAa;CACb,kBAAkB;AACnB;AACA;CACC,iBAAiB;CACjB,YAAY;AACb;;AAEA;;CAEC,eAAe;CACf,MAAM;CACN,YAAY;CACZ,SAAS;CACT,YAAY;CACZ,OAAO;CACP,YAAY;AACb;AACA;;CAEC,kBAAkB;CAClB,0BAA0B;CAC1B,cAAc;CACd,YAAY;CACZ,UAAU;CACV,qBAAqB;AACtB;AACA;;CAEC,wBAAwB;AACzB;AACA;;CAEC,YAAY;AACb;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;CAsCC,qBAAqB;AACtB;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;CAsCC,SAAS;CACT,kBAAkB;CAClB,0BAA0B;CAC1B,UAAU;CACV,mBAAmB;CACnB,cAAc;CACd,iBAAiB;CACjB,UAAU;AACX;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;CAsCC,yBAAyB;CACzB,WAAW;CACX,kBAAkB;CAClB,gBAAgB;CAChB,eAAe;CACf,kBAAkB;CAClB,iBAAiB;CACjB,kBAAkB;CAClB,WAAW;CACX,UAAU;CACV,gBAAgB;CAChB,+BAA+B;AAChC;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;CAsCC,0BAA0B;AAC3B;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;CA8BC,eAAe;CACf,iBAAiB;CACjB,WAAW;AACZ;AACA;;CAEC,kBAAkB;CAClB,WAAW;CACX,QAAQ;CACR,UAAU;AACX;AACA;;CAEC,kBAAkB;CAClB,sBAAsB;CACtB,cAAc;CACd,YAAY;CACZ,WAAW;CACX,WAAW;CACX,gBAAgB;AACjB;AACA;;CAEC,WAAW;CACX,YAAY;AACb;AACA;;CAEC,gBAAgB;CAChB,cAAc;AACf;AACA;;CAEC,SAAS;CACT,kBAAkB;CAClB,WAAW;AACZ;AACA;;CAEC,eAAe;AAChB;AACA;;CAEC,mBAAmB;CACnB,cAAc;CACd,cAAc;CACd,qBAAqB;CACrB,kBAAkB;CAClB,yBAAyB;CACzB,eAAe;CACf,eAAe;CACf,iBAAiB;CACjB,iBAAiB;CACjB,YAAY;AACb;AACA;;CAEC,gBAAgB;AACjB;AACA;;;;CAIC,UAAU;AACX;AACA;;;;CAIC,UAAU;AACX;AACA;;CAEC,6BAA6B;CAC7B,8CAA8C;AAC/C;AACA;;;;;;;;;;;;;;;;;;;;;;CAsBC,cAAc;AACf;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;CAmEC,6BAA6B;CAC7B,gBAAgB;AACjB;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;CA2EC,WAAW;CACX,kBAAkB;CAClB,uBAAuB;CACvB,UAAU;AACX;AACA;;CAEC,aAAa;AACd;AACA;;CAEC,SAAS;CACT,iBAAiB;CACjB,kBAAkB;CAClB,cAAc;CACd,YAAY;CACZ,mBAAmB;CACnB,gBAAgB;AACjB;AACA;;CAEC,eAAe;CACf,WAAW;CACX,kBAAkB;CAClB,iBAAiB;CACjB,WAAW;CACX,kBAAkB;CAClB,+BAA+B;CAC/B,kBAAkB;AACnB;AACA;;CAEC,kBAAkB;CAClB,UAAU;CACV,YAAY;CACZ,WAAW;CACX,cAAc;CACd,MAAM;CACN,OAAO;CACP,sBAAsB;CACtB,kCAAkC;AACnC;AACA;;CAEC,kBAAkB;CAClB,UAAU;CACV,WAAW;CACX,YAAY;CACZ,WAAW;CACX,cAAc;CACd,mBAAmB;CACnB,UAAU;AACX;AACA;;CAEC,kBAAkB;CAClB,mBAAmB;CACnB,UAAU;AACX;AACA;;CAEC,UAAU;CACV,WAAW;CACX,WAAW;CACX,kBAAkB;CAClB,iBAAiB;CACjB,kBAAkB;AACnB;AACA;;CAEC,cAAc;CACd,UAAU;CACV,mBAAmB;CAKnB,iCAAiC;AAClC;AACA;;CAEC,WAAW;CACX,kBAAkB;CAClB,SAAS;CACT,WAAW;CACX,WAAW;CACX,wBAAwB;CACxB,0CAA0C;AAC3C;AACA;;CAEC,WAAW;CACX,eAAe;CACf,iBAAiB;CACjB,cAAc;CACd,iBAAiB;CACjB,mDAAmD;AACpD;AACA;;CAEC,yBAAyB;CACzB,iBAAiB;CACjB,cAAc;CACd,mBAAmB;CACnB,eAAe;CACf,cAAc;CACd,qBAAqB;CACrB,gBAAgB;CAChB,iBAAiB;CACjB,gBAAgB;AACjB;AACA;;CAEC,kBAAkB;CAClB,sBAAsB;CACtB,cAAc;CACd,YAAY;CACZ,WAAW;CACX,WAAW;CACX,gBAAgB;AACjB;AACA;;CAEC,WAAW;CACX,YAAY;AACb;AACA;;;;CAIC,cAAc;CACd,WAAW;CACX,UAAU;CACV,kBAAkB;CAClB,WAAW;CACX,YAAY;CACZ,MAAM;CACN,OAAO;AACR;AACA;;CAEC,mBAAmB;CAInB,iDAAiD;CACjD,UAAU;AACX;AACA;;CAEC,mBAAmB;AACpB;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;CAwCC,cAAc;CACd,YAAY;AACb;AACA;;;;CAIC,UAAU;AACX;AACA;;CAEC,cAAc;AACf;AACA;;CAEC,yBAAyB;CACzB,YAAY;AACb;AACA;;;;;;CAMC,yBAAyB;AAC1B;AACA;;CAEC,yBAAyB;CACzB,YAAY;AACb;AACA;;CAEC,mBAAmB;AACpB;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;CAsDC,cAAc;CACd,UAAU;AACX;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;CA+CC,cAAc;CACd,UAAU;AACX;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;CAsDC,cAAc;CACd,UAAU;AACX;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;CAsDC,cAAc;CACd,UAAU;AACX;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;CAmDC,cAAc;CACd,UAAU;AACX;AACA;;CAEC,oBAAoB;CACpB,mBAAmB;CACnB,kBAAkB;AACnB;AACA;;CAEC,WAAW;CACX,kBAAkB;CAClB,SAAS;CACT,WAAW;CACX,WAAW;CACX,wBAAwB;CACxB,0CAA0C;AAC3C;AACA;;CAEC,WAAW;CACX,YAAY;CACZ,gBAAgB;CAChB,WAAW;CACX,UAAU;CACV,kBAAkB;CAClB,kBAAkB;CAClB,iBAAiB;AAClB;AACA;;CAEC,WAAW;AACZ;AACA;;CAEC,cAAc;CACd,qBAAqB;CACrB,oBAAoB;CACpB,mBAAmB;AACpB;AACA;;CAEC,cAAc;CACd,iBAAiB;AAClB;AACA;;CAEC,cAAc;CACd,kBAAkB;CAClB,UAAU;AACX;AACA;;CAEC,kBAAkB;CAClB,QAAQ;CACR,WAAW;AACZ;;AAEA;CACC,gCAAgC;AACjC;;AAEA;CACC,wBAAwB;AACzB;;AAEA;;CAEC,cAAc;AACf;AACA;CACC,oCAAoC;AACrC;;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ,yBAAyB;CAKzB,0DAA0D;AAC3D;AACA;CACC,oBAAoB;CACpB,+BAA+B;CAC/B,gBAAgB;AACjB;AACA;CACC,+BAA+B;CAC/B,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,mBAAmB;AACpB;;AAEA;;CAEC,YAAY;CACZ,gBAAgB;AACjB;;AAEA;CACC;;;EAIC,uCAAuC;EAEvC,sCAAsC;EAEtC,gDAAgD;EAChD,iCAAiC;CAClC;;CAEA;EACC,wBAAwB;CACzB;CACA;EACC,gCAAgC;CACjC;CACA;;EAEC,WAAW;CACZ;CACA;EACC,wBAAwB;CACzB;CACA;EACC,cAAc;EACd,aAAa;CACd;CACA;EACC,UAAU;EAKV,mCAAmC;CACpC;CACA;EACC,UAAU;CACX;CACA;;;;;;;;;;;;;;;;;;;;;;;EA2BC,mCAAmC;EACnC,UAAU;CACX;CACA;EACC,YAAY;CACb;CACA;EACC,UAAU;EAKV,+BAA+B;CAChC;CACA;EACC,UAAU;CACX;CACA;EACC,YAAY;CACb;CACA;;;;;;;;;;;;;;;;;;;;;;;EA2BC,iCAAiC;EACjC,UAAU;CACX;AACD;AACA;CACC,aAAa;CACb,iBAAiB;CACjB,oBAAoB;CACpB,mBAAmB;CACnB,8BAA8B;CAS9B,4EAA4E;CAC5E,kBAAkB;CAClB,gBAAgB;AACjB;AACA;CACC,cAAc;AACf;AACA;CACC,gBAAgB;CAChB,+BAA+B;CAC/B,cAAc;CACd,eAAe;AAChB;AACA;CACC,cAAc;AACf;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,aAAa;AACd;;AAEA;CAGC,oBAAoB;CAGpB,mBAAmB;CAGnB,uBAAuB;CACvB,YAAY;CACZ,WAAW;CACX,mBAAmB;CACnB,kBAAkB;CAClB,kBAAkB;CAClB,gBAAgB;AACjB;AACA;CACC,UAAU;CACV,wBAAqB;CAArB,uBAAqB;CACrB,WAAW;AACZ;;AAEA;CACC,4BAA4B;AAC7B;;AAEA,gDAAgD;AAChD;CACC,kBAAkB;CAClB,gCAAgC;CAChC,mBAAmB;AACpB;AACA;CACC,oBAAoB;AACrB;;AAEA;CACC,qBAAqB;CACrB,mBAAmB;CACnB,kBAAkB;CAClB,WAAW;CACX,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,uBAAuB;CACvB,qBAAqB;CACrB,eAAe;CACf,gBAAgB;AACjB;AACA;CACC,cAAc;CACd,cAAc;CACd,6BAA6B;AAC9B;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,yBAAyB;CACzB,kBAAkB;AACnB;AACA;;;CAGC,6BAA6B;CAC7B,cAAc;AACf;AACA;;;CAGC,iCAAiC;CACjC,wCAAwC;CACxC,yCAAyC;CACzC,WAAW;CACX,qBAAqB;CACrB,kBAAkB;CAClB,UAAU;CACV,WAAW;AACZ;AACA;;;CAGC,iCAAiC;CACjC,wCAAwC;CACxC,yCAAyC;CACzC,WAAW;CACX,qBAAqB;CACrB,kBAAkB;CAClB,UAAU;CACV,WAAW;AACZ;AACA;CACC,6BAA6B;AAC9B;AACA;CACC,gBAAgB;CAChB,kBAAkB;CAClB,kBAAkB;AACnB;AACA;;CAEC,cAAc;CACd,yBAAyB;AAC1B;AACA;CACC,iCAAiC;CACjC,wCAAwC;CACxC,yCAAyC;CACzC,WAAW;CACX,qBAAqB;CACrB,kBAAkB;CAClB,WAAW;CACX,UAAU;AACX;AACA;CACC,iCAAiC;CACjC,wCAAwC;CACxC,yCAAyC;CACzC,WAAW;CACX,qBAAqB;CACrB,kBAAkB;CAClB,WAAW;CACX,UAAU;AACX;;AAEA;CACC,iBAAiB;AAClB;AACA;;;CAGC,YAAY;AACb;;AAEA;;CAEC,kBAAkB;AACnB;AACA;;CAEC,cAAc;CACd,mBAAmB;CACnB,yBAAyB;CACzB,kBAAkB;CAClB,YAAY;CACZ,yBAAyB;AAC1B;AACA;;;;CAIC,6BAA6B;CAC7B,UAAU;CACV,0BAA0B;AAC3B;AACA;;CAEC,eAAe;AAChB;AACA;;CAEC,cAAc;AACf;;AAEA;CACC,qBAAqB;AACtB;AACA;CACC,eAAe;CACf,mBAAmB;AACpB;AACA;CACC,kBAAkB;CAClB,mBAAmB;CACnB,cAAc;AACf;;AAEA;CACC,cAAc;AACf;AACA;CACC,mBAAmB;AACpB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;AACA;CACC,cAAc;CACd,yBAAyB;CACzB,cAAc;CACd,gBAAgB;CAChB,gBAAgB;AACjB;AACA;CACC,cAAc;AACf;AACA;CACC,aAAa;AACd;;AAEA;CACC,qBAAqB;AACtB;AACA;CACC,kBAAkB;AACnB;;AAEA;;;;CAIC,gCAAgC;CAChC,kCAAkC;CAClC,qCAAqC;CACrC,WAAW;CACX,qBAAqB;CACrB,kBAAkB;CAClB,QAAQ;CACR,YAAY;AACb;;AAEA;;;;CAIC,gCAAgC;CAChC,kCAAkC;CAClC,qCAAqC;CACrC,WAAW;CACX,qBAAqB;CACrB,kBAAkB;CAClB,WAAW;CACX,YAAY;AACb;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,+BAA+B;CAC/B,eAAe;CACf,mBAAmB;AACpB;;AAEA;CACC,iBAAiB;AAClB;;AAEA,+CAA+C;AAC/C;;;CAGC;AACD;;;;CAIC;AACD;;CAEC,2BAA2B;CAC3B,6CAA6C;CAC7C,yBAAyB;CAEzB,kBAAkB;CAGlB,iBAAiB;CAEjB,sBAAsB;AACvB;;AAEA;CACC,kBAAkB;CAClB,cAAc;AACf;;AAEA;;CAEC,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,UAAU;AACX;;AAEA;CACC;AACD;CACC,gBAAgB;CAChB,UAAU;AACX;;AAEA;;CAEC,sBAAsB;CACtB,kBAAkB;CAClB,UAAU;CACV,MAAM;CACN,OAAO;CACP,YAAY;CACZ,WAAW;CAGX,qBAAqB;AACtB;;AAEA;CACC;AACD;CACC,UAAU;CACV,QAAQ;AACT;;AAEA;;CAEC;AACD;CACC,QAAQ;AACT;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,kBAAkB;AACnB;;AAEA;;CAGC,0BAA0B;AAC3B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC;AACD;CACC,WAAW;AACZ;;AAEA;CACC,gBAAgB;CAChB,oDAAoD;CACpD,qHAAqH;CACrH,kBAAkB;CAClB,8DAA8D;CAC9D,YAAY;CACZ,WAAW;CACX,eAAe;CACf,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,gBAAgB;CAChB,oDAAoD;CACpD,qHAAqH;CACrH,kBAAkB;CAClB,8DAA8D;CAC9D,eAAe;CACf,WAAW;CACX,YAAY;CACZ,UAAU;CACV,UAAU;AACX;;AAEA;CACC,WAAW;CACX,UAAU;AACX;;AAEA;;CAEC;AACD;CACC,0CAA0C;CAC1C,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;CAChB,kBAAkB;CAElB,4BAA4B;AAC7B;;AAEA;CACC;AACD;CACC,iBAAiB;AAClB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,eAAe;CACf,4EAA4E;CAI5E,yBAAyB;AAC1B;AACA;CACC,aAAa;AACd;;AAEA;CACC,yEAAyE;AAC1E;;AAEA;CACC;AACD;CACC,mBAAmB;AACpB;;AAEA;;;CAGC,mBAAmB;AACpB;;AAEA;;CAEC;AACD;;CAGC,sBAAsB;AACvB;;AAEA;CACC,kBAAkB;CAClB,WAAW;AACZ;;AAEA;;CAEC;AACD;CACC,kBAAkB;CAClB,mBAAmB;CACnB,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,eAAe;AAChB;;AAEA;;CAEC;AACD;CACC,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;;CAEC;AACD;CACC,eAAe;CACf,YAAY;CACZ,SAAS;CACT,OAAO;CACP,WAAW;AACZ;;AAEA;CAEC,+BAA+B;AAChC;;AAEA;CAEC,8BAA8B;AAC/B;;AAEA;CACC,iBAAiB;CACjB,UAAU;CACV,WAAW;AACZ;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,YAAY;AACb;;AAEA;;CAEC;AACD;CACC,eAAe;CACf,YAAY;CACZ,MAAM;CACN,UAAU;AACX;;AAEA;CAEC,gCAAgC;CAChC,kBAAkB;AACnB;;AAEA;CAEC,4BAA4B;AAC7B;;AAEA;CACC,UAAU;CACV,WAAW;CACX,gBAAgB;AACjB;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,cAAc;CACd,kBAAkB;CAClB,yBAAyB;CACzB,kBAAkB;CAClB,gBAAgB;CAChB,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CAEC,6BAA6B;CAC7B,SAAS;CACT,YAAY;AACb;;AAEA;CAEC,6BAA6B;CAC7B,QAAQ;CACR,WAAW;AACZ;;AAEA;;CAEC,yBAAyB;AAC1B;AACA;CACC,0CAA0C;AAC3C;AACA;CACC,yBAAyB;AAC1B;AACA;;CAEC,yBAAyB;AAC1B;AACA;;CAEC,yBAAyB;AAC1B;AACA;;CAEC,yBAAyB;AAC1B;AACA;;CAEC,yBAAyB;AAC1B;AACA;;CAEC,yBAAyB;AAC1B;;AAEA;CACC,cAAc;CACd,aAAa;CACb,SAAS;AACV;;AAEA;CACC,iBAAiB;CACjB,oBAAoB;CACpB,eAAe;AAChB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,SAAS;CACT,UAAU;AACX;;AAEA;CACC,sBAAsB;CACtB,YAAY;CAGZ,aAAa;CAGb,sBAAsB;CAGtB,oBAAoB;AACrB;;AAEA;;;CAGC,mBAAmB;AACpB;;AAEA;;CAEC,gBAAgB;CAChB,kBAAkB;CAClB,MAAM;CACN,OAAO;CACP,QAAQ;CACR,SAAS;AACV;;AAEA;;;;CAIC,cAAc;CACd,gBAAgB;CAChB,uBAAuB;CACvB,mBAAmB;AACpB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,cAAc;CACd,YAAY;AACb;;AAEA;CACC,gBAAgB;CAGhB,SAAY;CACZ,uBAAuB;CACvB,mBAAmB;CACnB,cAAc;CACd,iBAAiB;CACjB,sBAAsB;CACtB,iBAAiB;CACjB,cAAc;CACd,aAAa;CACb,6BAA6B;CAC7B,cAAc;AACf;AACA;CACC,mBAAmB;AACpB;;AAEA;;;CAGC,cAAc;CACd,qBAAqB;AACtB;;AAEA;CACC,kBAAkB;CAGlB,iBAAiB;CACjB,yBAAyB;CACzB,UAAU;CACV,iBAAiB;AAClB;;AAEA;CAGC,aAAa;CAGb,mBAAmB;CACnB,mBAAmB;CACnB,eAAe;CACf,iBAAiB;CACjB,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CAGC,YAAY;CACZ,eAAe;CACf,kBAAkB;CAClB,oBAAoB;CACpB,kBAAkB;CAClB,cAAc;CACd,gBAAgB;CAChB,SAAS;CACT,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;CACzB,cAAc;CACd,iBAAiB;CACjB,gBAAgB;CAChB,eAAe;CACf,iBAAiB;CACjB,eAAe;CACf,YAAY;CACZ,gBAAgB;CAChB,mBAAmB;CACnB,iBAAiB;CACjB,eAAe;CACf,gCAAgC;CAChC,aAAa;AACd;AACA;;;;;;;;;;;CAWC,oCAAoC;CACpC,yBAAyB;CACzB,2BAA2B;AAC5B;AACA;CACC,gBAAgB;AACjB;AACA;;;;;;;;;;;;;;;;;;;;;;;;CAwBC,yBAAyB;CACzB,qBAAqB;AACtB;AACA;CACC,cAAc;CACd,qBAAqB;AACtB;AACA;;;CAGC,6BAA6B;CAC7B,cAAc;CACd,qBAAqB;CACrB,gBAAgB;AACjB;AACA;CACC,cAAc;AACf;AACA;;;;CAIC,6BAA6B;CAC7B,cAAc;CACd,qBAAqB;CACrB,gBAAgB;AACjB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC;EACC,sBAAsB;CACvB;AACD;AACA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;;CAEC,iBAAiB;AAClB;;AAEA;CACC,eAAe;CACf,oBAAoB;AACrB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kDAAkD;AACnD;;AAEA;CACC,yBAAyB;CACzB,4BAA4B;AAC7B;;AAEA;CACC,0BAA0B;CAC1B,6BAA6B;AAC9B;;AAEA;CACC,yBAAyB;CACzB,0BAA0B;AAC3B;;AAEA;CACC,4BAA4B;CAC5B,6BAA6B;AAC9B;;AAEA;CACC,4BAA4B;CAC5B,6BAA6B;AAC9B;;AAEA;CACC,yBAAyB;CACzB,0BAA0B;AAC3B;;AAEA;CAGC,aAAa;CAGb,mBAAmB;AACpB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,oCAAoC;AACrC;;AAEA;CACC,0CAA0C;CAC1C,UAAU;CACV,iBAAiB;CACjB,cAAc;CACd,YAAY;CACZ,mBAAmB;CACnB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,sBAAsB;CAGtB,aAAa;CAGb,sBAAsB;CAGtB,SAAW;CACX,WAAW;CAGX,iBAAiB;CACjB,yBAAyB;CACzB,YAAY;CACZ,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CAGC,aAAa;CAGb,mBAAmB;AACpB;;AAEA;CAGC,aAAa;CACb,kBAAkB;CAGlB,sBAAsB;CAGtB,SAAW;CACX,4BAA4B;CAC5B,gBAAgB;CAChB,YAAY;AACb;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,SAAS;CACT,YAAY;CACZ,iBAAiB;CACjB,gBAAgB;AACjB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;;;CAGC,cAAc;CACd,qBAAqB;AACtB;;AAEA;CAGC,aAAa;CAGb,mBAAmB;CAGnB,SAAW;CACX,gBAAgB;AACjB;;AAEA;CAGC,SAAY;AACb;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,oBAAoB;CACpB,4BAA4B;AAC7B;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,yBAAyB;CACzB,sBAAsB;CACtB,0CAA0C;CAC1C,aAAa;AACd;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,gCAAgC;CAChC,6BAA6B;CAC7B,iBAAiB;AAClB;;AAEA;CAGC,aAAa;CAGb,sBAAsB;CAGtB,SAAW;CACX,cAAc;AACf;;AAEA;CACC,WAAW;CACX,sBAAsB;CACtB,iBAAiB;CACjB,yBAAyB;AAC1B;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,mBAAmB;CACnB,yBAAyB;AAC1B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,oBAAoB;CACpB,4BAA4B;AAC7B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,gBAAgB;CAChB,gBAAgB;CAChB,6BAA6B;AAC9B;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,aAAa;AACd;;AAEA;;CAEC,mBAAmB;AACpB;;AAEA;CACC,WAAW;AACZ;;AAEA;CAGC,aAAa;CAGb,sBAAsB;CACtB,gBAAgB;AACjB;;AAEA;CAGC,SAAO;AACR;;AAEA;CACC,6BAA6B;CAC7B,gBAAgB;CAGhB,aAAa;CAGb,wBAAwB;AACzB;;AAEA;;CAIC,UAAU;AACX;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,SAAS;CACT,OAAO;CACP,kBAAkB;CAClB,WAAW;CACX,MAAM;AACP;;AAEA;CACC,UAAU;CACV,QAAQ;AACT;;AAEA;CAGC,aAAa;CACb,gBAAgB;CAChB,gBAAgB;CAGhB,sBAAsB;CAGtB,uBAAuB;CACvB,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CAGC,UAAU;CACV,kBAAkB;CAClB,WAAW;CACX,iBAAiB;CAGjB,uBAAuB;CACvB,WAAW;CACX,mBAAmB;AACpB;;AAEA;CACC,WAAW;CAGX,SAAW;CACX,qBAAqB;CACrB,cAAc;CACd,YAAY;CACZ,eAAe;AAChB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CAGC,SAAW;AACZ;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,oCAAoC;CACpC,YAAY;CACZ,cAAc;CACd,WAAW;CACX,YAAY;AACb;;AAEA;CACC,YAAY;AACb;;AAEA;CAGC,aAAa;CAGb,sBAAsB;CAGtB,SAAO;CACP,WAAW;CACX,sBAAsB;CACtB,aAAa;CACb,iBAAiB;CACjB,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,uBAAuB;CACvB,WAAW;CACX,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,UAAU;AACX;;AAEA;CACC,sBAAsB;CACtB,gBAAgB;AACjB;;AAEA;CAGC,aAAa;CAGb,cAAc;CAGd,mBAAmB;AACpB;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,qBAAqB;CACrB,2BAA2B;AAC5B;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CAGC,SAAO;CACP,YAAY;CAGZ,sBAAsB;CACtB,2BAA2B;AAC5B;;AAEA;CACC,oBAAoB;CACpB,4BAA4B;AAC7B;;AAEA;CAGC,aAAa;CAGb,SAAY;CAGZ,uBAAuB;CACvB,WAAW;CACX,0BAA0B;CAC1B,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CAGC,UAAU;AACX;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,oBAAoB;CACpB,4BAA4B;AAC7B;;AAEA;CACC,WAAW;CAGX,iBAAiB;CACjB,yBAAyB;AAC1B;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,WAAW;CACX,yBAAyB;CACzB,oBAAoB;AACrB;;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,kDAAkD;CAClD,cAAc;CACd,2BAA2B;CAC3B,iBAAiB;CACjB,kBAAkB;CAClB,UAAU;CACV,yCAAyC;CACzC,6BAA6B;CAC7B,mBAAmB;CACnB,sCAAsC;CACtC,gBAAgB;CAChB,YAAY;CACZ,mBAAmB;CACnB,gBAAgB;AACjB;AACA;CACC,yCAAyC;AAC1C;AACA;CACC,wCAAwC;AACzC;AACA;CACC,yCAAyC;AAC1C;AACA;CACC,wCAAwC;AACzC;AACA;CACC,kBAAkB;CAClB,UAAU;CACV,mBAAmB;CACnB,gBAAgB;CAChB,cAAc;CACd,cAAc;AACf;;AAEA;CACC,yBAAyB;CACzB,uBAAwB;CAAxB,0BAAwB;CACxB,2BAA4B;CAA5B,8BAA4B;AAC7B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC;EACC,cAAc;CACf;CACA;EACC,cAAc;EACd,kBAAkB;CACnB;CACA;EACC,cAAc;EACd,kBAAgB;EAChB,UAAU;CACX;AACD;AACA;CACC,aAAa;AACd;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,qBAAqB;CACrB,cAAc;CACd,eAAe;CACf,mBAAmB;CACnB,SAAS;CACT,kBAAkB;CAClB,gBAAgB;CAChB,gBAAgB;CAChB,kBAAkB;CAClB,gBAAgB;CAChB,sBAAsB;CACtB,YAAY;CACZ,aAAa;CACb,UAAU;CACV,iBAAiB;CACjB,yBAAyB;CAGzB,iBAAiB;CACjB,sBAAsB;CAGtB,wEAAwE;AACzE;;AAEA;CACC,oBAAoB;CACpB,MAAM;CACN,YAAY;CACZ,kBAAkB;CAElB,+BAA+B;CAC/B,uBAAuB;AACxB;;AAEA;;;CAKC,sBAAsB;CACtB,eAAe;CACf,gCAAgC;CAChC,YAAY;CACZ,WAAW;CACX,iBAAiB;CACjB,eAAe;CACf,iBAAiB;CACjB,iBAAiB;CAEjB,0BAA0B;AAC3B;AACA;;;CAGC,eAAe;CACf,iBAAiB;AAClB;;AAEA;;CAEC,kBAAkB;CAClB,UAAU;CACV,WAAW;CACX,qBAAqB;CACrB,yBAAyB;AAC1B;;AAEA;;CAEC,WAAW;CACX,mBAAmB;AACpB;;AAEA;;CAEC,WAAW;CACX,mBAAmB;AACpB;;AAEA;;CAEC,WAAW;CACX,mBAAmB;AACpB;;AAEA;;CAEC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;;CAEC,WAAW;CACX,mBAAmB;AACpB;;AAEA;CACC,WAAW;CACX,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ,cAAc;CACd,mBAAmB;CACnB,sBAAsB;CACtB,YAAY;CACZ,iBAAiB;CACjB,mBAAmB;CACnB,kBAAkB;CAClB,WAAW;CACX,UAAU;CACV,yBAAyB;CACzB,kEAAkE;AACnE;;AAEA;CACC,8BAA8B;CAC9B,2BAA2B;AAC5B;;AAEA;CACC,gBAAgB;AACjB;;AAEA;;CAEC,6BAA6B;CAC7B,MAAM;CACN,OAAO;CACP,UAAU;CACV,wBAAwB;CACxB,WAAW;AACZ;;AAEA;;CAEC,YAAY;AACb;;AAEA;;;CAGC,gBAAgB;CAChB,eAAe;CACf,gBAAgB;AACjB;;AAEA;;;CAGC,iBAAiB;CACjB,eAAe;CACf,gBAAgB;AACjB;;AAEA;;;CAGC,iBAAiB;CACjB,eAAe;CACf,iBAAiB;AAClB;;AAEA;;;CAGC,0BAA0B;AAC3B;;AAEA;;;;;;;;;CASC,YAAY;CACZ,yBAAyB;CACzB,0BAA0B;AAC3B;;AAEA;CAEC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;CAC5B,yBAAyB;CACzB,+BAA+B;CAC/B,4BAA4B;AAC7B;;AAEA;CACC,6BAA6B;CAC7B,0BAA0B;CAC1B,8BAA8B;CAC9B,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,sBAAsB;CACtB,iBAAiB;AAClB;;AAEA;CACC,sBAAsB;CACtB,6BAA6B;AAC9B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;;;;;CAKC,yBAAyB;AAC1B;;AAEA;CACC,gBAAgB;CAChB,YAAY;AACb;;AAEA;CACC,iBAAiB;CACjB,8CAA8C;CAC9C,UAAU;CAKV,4BAA4B;AAC7B;AACA;CACC,cAAc;AACf;AACA;CACC,qBAAqB;AACtB;AACA;;CAEC,qBAAqB;CACrB,cAAc;AACf;AACA;;;;;CAKC,yBAAyB;AAC1B;AACA;CACC,yBAAyB;AAC1B;AACA;;;;CAIC,qBAAqB;AACtB;AACA;CACC,cAAc;AACf;AACA;CACC,qBAAqB;AACtB;AACA;;CAEC,qBAAqB;CACrB,cAAc;AACf;AACA;;;;;CAKC,yBAAyB;AAC1B;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,qBAAqB;AACtB;AACA;CACC,cAAc;AACf;AACA;CACC,qBAAqB;AACtB;AACA;;CAEC,qBAAqB;CACrB,cAAc;AACf;AACA;;;;;CAKC,yBAAyB;AAC1B;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,qBAAqB;AACtB;AACA;CACC,cAAc;AACf;AACA;CACC,qBAAqB;AACtB;AACA;;CAEC,qBAAqB;CACrB,cAAc;AACf;AACA;;;;;CAKC,yBAAyB;AAC1B;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,qBAAqB;AACtB;AACA;CACC,cAAc;AACf;AACA;CACC,qBAAqB;AACtB;AACA;;CAEC,qBAAqB;CACrB,cAAc;AACf;AACA;;;;;CAKC,yBAAyB;AAC1B;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,qBAAqB;AACtB;AACA;CACC,cAAc;AACf;AACA;CACC,qBAAqB;AACtB;AACA;;CAEC,qBAAqB;CACrB,cAAc;AACf;AACA;;;;;CAKC,yBAAyB;AAC1B;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,qBAAqB;AACtB;AACA;CACC,UAAU;AACX;AACA;CACC,0BAA0B;CAC1B,oBAAoB;CACpB,6BAA6B;AAC9B;AACA;CACC,cAAc;AACf;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,aAAa;AACd;AACA;;;;;;CAMC,6BAA6B;CAC7B,gBAAgB;AACjB;AACA;CACC,kBAAkB;CAClB,eAAe;CACf,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,aAAa;CACb,mBAAmB;CAEnB,uBAAuB;AACxB;AACA;;CAEC,qBAAqB;CACrB,eAAe;CACf,mBAAoB;CAApB,oBAAoB;CACpB,iBAAiB;CACjB,UAAU;CACV,sBAAsB;AACvB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,YAAY;CACZ,aAAa;CACb,yBAAyB;CACzB,yBAAyB;CACzB,cAAc;CACd,kBAAkB;CAClB,gBAAgB;CAChB,gBAAgB;CAChB,oBAAoB;CACpB,4BAA4B;AAC7B;AACA;CACC,qBAAqB;AACtB;AACA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,aAAa;CACb,eAAe;CACf,yBAAyB;CACzB,4CAA4C;CAC5C,QAAQ;CACR,SAAS;CACT,yBAAyB;CACzB,8CAA8C;CAC9C,yBAAyB;CACzB,eAAe;CACf,gBAAgB;AACjB;AACA;CACC,eAAe;CACf,cAAc;CACd,YAAY;CACZ,OAAO;CACP,qBAAqB;CACrB,kBAAkB;CAClB,MAAM;CACN,WAAW;AACZ;AACA;CACC,WAAW;AACZ;AACA;CACC,iBAAiB;CACjB,eAAe;AAChB;AACA;CACC,eAAe;AAChB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,aAAa;AACd;AACA;CACC,kBAAkB;CAClB,oBAAoB;AACrB;AACA;CACC,eAAe;AAChB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,mBAAmB;AACpB;AACA;CACC,kBAAkB;CAClB,eAAe;CACf,gBAAgB;AACjB;AACA;CACC,oBAAoB;CACpB,mBAAmB;CACnB,YAAY;AACb;AACA;CACC,kBAAkB;CAClB,sBAAsB;CACtB,aAAa;CACb,YAAY;CACZ,kBAAkB;CAClB,cAAc;CACd,mBAAmB;CACnB,yBAAyB;CACzB,oBAAoB;CACpB,4BAA4B;AAC7B;AACA;CACC,eAAe;CACf,kBAAkB;CAClB,kBAAkB;CAClB,OAAO;CACP,QAAQ;AACT;AACA;;CAEC,qBAAqB;AACtB;AACA;;CAEC,kBAAkB;CAClB,cAAc;CACd,WAAW;AACZ;AACA;CACC,aAAa;AACd;AACA;CACC,eAAe;CACf,mBAAmB;AACpB;AACA;CACC,SAAS;AACV;AACA;CACC,oCAAoC;AACrC;AACA;CACC,cAAc;AACf;AACA;CACC,oBAAoB;CACpB,gBAAgB;CAChB,iBAAiB;CACjB,yBAAyB;CACzB,eAAe;CACf,gBAAgB;CAChB,gBAAgB;CAChB,kBAAkB;CAClB,yBAAyB;AAC1B;AACA;;;;;CAKC,yBAAyB;CACzB,gBAAgB;AACjB;AACA;CACC,cAAc;CACd,eAAe;CACf,eAAe;AAChB;AACA;CACC,gBAAgB;AACjB;AACA;;CAMC,4CAA4C;AAC7C;;AAEA;;CAEC;AACD;CACC,kBAAkB;AACnB;AACA;CAKC,4BAA4B;CAC5B,iBAAiB;CACjB,kBAAkB;CAClB,cAAc;CACd,UAAU;AACX;AACA;CACC,UAAU;CACV,mBAAmB;CACnB,aAAa;AACd;;AAEA;CACC,aAAa;CACb,kBAAkB;CAClB,YAAY;CACZ,YAAY;CACZ,eAAe;CACf,yBAAyB;CACzB,gBAAgB;CAChB,uBAAuB;CACvB,gDAAgD;CAChD,oCAAoC;CACpC,4BAA4B;CAC5B,gBAAgB;AACjB;AACA;CACC,qBAAqB;CACrB,kBAAkB;CAClB,QAAQ;CACR,SAAS;CACT,sBAAsB;CACtB,WAAW;CACX,SAAS;CACT,UAAU;CACV,WAAW;CACX,cAAc;CACd,0BAA0B;CAC1B,qCAAqC;CACrC,oCAAoC;AACrC;AACA;CACC,kCAAkC;CAClC,qCAAqC;CACrC,oCAAoC;CACpC,WAAW;CACX,qBAAqB;CACrB,kBAAkB;CAClB,SAAS;CACT,UAAU;AACX;;AAEA;CACC,cAAc;CACd,SAAS;AACV;;AAEA;CACC,gBAAgB;CAChB,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,SAAS;CACT,gCAAgC;AACjC;;AAEA;;CAEC,kBAAkB;CAClB,YAAY;AACb;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,YAAY;CACZ,iBAAiB;CACjB,WAAW;CACX,kBAAkB;CAClB,YAAY;CACZ,kBAAkB;AACnB;AACA;;;CAGC,oCAAoC;CACpC,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,gCAAgC;CAChC,eAAe;CACf,yBAAyB;CACzB,oBAAoB;CACpB,mBAAmB;CACnB,iBAAiB;AAClB;AACA;;CAEC,cAAc;AACf;;AAEA;;;;;CAKC,mBAAmB;CACnB,eAAe;AAChB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;;CAEC,gBAAgB;CAChB,cAAc;CACd,mBAAmB;AACpB;;AAEA;CACC,cAAc;AACf;;AAEA;;CAEC,gBAAgB;CAChB,cAAc;CACd,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,mBAAmB;AACpB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,kBAAkB;AACnB;;AAEA;;CAEC,eAAe;CACf,mBAAmB;CACnB,kBAAkB;CAClB,iBAAiB;AAClB;;AAEA;;;;;CAKC,cAAc;AACf;;AAEA;;CAEC,cAAc;CACd,2BAA2B;CAC3B,eAAe;CACf,yBAAyB;CACzB,wBAAwB;CAExB,cAAc;CAEd,YAAY;CAEZ,2BAA2B;CAC3B,iBAAiB;AAClB;;AAEA;;CAEC,gBAAgB;CAChB,cAAc;CACd,mBAAmB;AACpB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,YAAY;CACZ,gBAAgB;CAChB,eAAe;AAChB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,WAAW;CACX,YAAY;AACb;;AAEA;;CAEC,YAAY;CACZ,UAAU;CACV,eAAe;AAChB;;AAEA;;CAEC,gBAAgB;AACjB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,WAAW;CACX,WAAW;CACX,oBAAoB;CACpB,WAAW;CACX,kBAAkB;AACnB;AACA;CACC,QAAQ;CACR,6BAA6B;AAC9B;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,WAAW;AACZ;AACA;CACC,YAAY;CACZ,YAAY;CACZ,6BAA6B;AAC9B;;AAEA;CACC,cAAc;CACd,kBAAkB;CAClB,yBAAyB;AAC1B;;AAEA;CACC,YAAY;CACZ,kBAAkB;AACnB;;AAEA;CACC,iBAAiB;CACjB,eAAe;CACf,cAAc;CACd,kBAAkB;CAClB,cAAc;CAKd,4BAA4B;CAC5B,2BAA2B;CAC3B,eAAe;CACf,yBAAyB;CACzB,wBAAwB;CAExB,cAAc;CAEd,YAAY;CAEZ,2BAA2B;CAC3B,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;CAChB,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,iBAAiB;AAClB;;AAEA;CACC,sBAAsB;CACtB,iBAAiB;CACjB,WAAW;AACZ;;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;;CAEC,oBAAoB;AACrB;AACA;;;;CAIC,qBAAqB;CACrB,WAAW;CACX,YAAY;CACZ,iBAAiB;CACjB,eAAe;CACf,eAAe;CACf,kBAAkB;CAClB,kBAAkB;AACnB;AACA;;;;CAIC,oCAAoC;CACpC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,aAAa;CACb,yBAAyB;CACzB,kBAAkB;CAClB,8BAA8B;CAC9B,YAAY;CACZ,gCAAgC;CAChC,kBAAkB;CAClB,YAAY;AACb;;AAEA;;;CAGC,kBAAkB;CAClB,UAAU;CACV,kBAAkB;CAClB,8BAA8B;CAC9B,YAAY;CACZ,YAAY;CACZ,eAAe;CACf,iBAAiB;CACjB,kBAAkB;CAClB,uBAAuB;AACxB;;AAEA;;CAEC,WAAW;CACX,YAAY;AACb;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,YAAY;CACZ,aAAa;CACb,YAAY;AACb;;AAEA;CACC,kBAAkB;CAClB,OAAO;CACP,MAAM;CACN,QAAQ;CACR,SAAS;CACT;yCACotI;AACrtI;;AAEA;CACC,iBAAiB;CACjB,eAAe;CACf,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,SAAS;CACT,QAAQ;AACT;;AAEA;CACC,MAAM;CACN,QAAQ;AACT;;AAEA;CACC,iBAAiB;CACjB,YAAY;CACZ,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,qBAAqB;CACrB,wBAAwB;AACzB;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,qBAAqB;CACrB,YAAY;AACb;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,YAAY;CACZ,WAAW;CACX,qBAAqB;CACrB,sBAAsB;AACvB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,qBAAqB;CACrB,sBAAsB;CACtB,iBAAiB;CACjB,iBAAiB;AAClB;;AAEA;;;;;;CAMC;AACD;;CAEC;AACD;CACC,SAAS;CACT,cAAc;CACd,UAAU;CACV,SAAS;CACT,mBAAmB;CACnB,SAAS;CACT,gDAAgD;CAChD;8CAC6C;CAC7C,yBAAyB;CACzB,sBAAsB;CACtB,iBAAiB;CACjB,kBAAkB;CAClB,UAAU;CACV,iCAAiC;CACjC,oBAAoB;CACpB,gBAAoB;CAApB,sBAAoB;CACpB,aAAiB;CAAjB,mBAAiB;AAClB;AACA;CACC,iCAAiC;CACjC,UAAU;CACV,mCAAmC;CACnC,oCAAoC;CACpC,WAAW;CACX,qBAAqB;CACrB,kBAAkB;CAClB,WAAW;AACZ;AACA;CACC,UAAU;CACV,iCAAiC;CACjC,mCAAmC;CACnC,oCAAoC;CACpC,WAAW;CACX,qBAAqB;CACrB,kBAAkB;CAClB,WAAW;AACZ;AACA;CACC,iBAAiB;CACjB,gBAAgB;CAChB,iBAAqB;CAArB,uBAAqB;CACrB,cAAkB;CAAlB,oBAAkB;CAClB,kBAAkB;AACnB;AACA;CACC,mBAAmB;CACnB,mBAAmB;CACnB,sBAAsB;CACtB,eAAe;CAKf,4BAA4B;CAC5B,oBAAoB;CACpB,qBAAqB;CACrB,cAAc;CACd,aAAa;CACb,cAAc;AACf;AACA;;CAEC,6BAA6B;AAC9B;AACA;;;;;;;;;;;;CAYC,yBAAyB;AAC1B;AACA;;;;;;CAMC,yBAAyB;AAC1B;AACA;;;;;;CAMC,cAAc;CACd,eAAe;AAChB;AACA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,YAAY;CACZ,sBAAsB;CACtB,yBAAyB;CACzB,cAAc;CACd,WAAW;AACZ;AACA;;CAEC,yBAAyB;CACzB,gBAAgB;CAChB,6BAA6B;AAC9B;AACA;;;CAGC,yBAAyB;CACzB,SAAS;AACV;AACA;;CAEC,yBAAyB;CACzB,gBAAgB;AACjB;AACA;;;;CAIC,oBAAoB;CACpB,kBAAkB;CAClB,6BAA6B;AAC9B;AACA;;;;;CAKC,oBAAoB;AACrB;AACA;;;;;CAKC,gBAAgB;AACjB;AACA;;;;CAIC,QAAQ;CACR,cAAc;AACf;AACA;CACC,yBAAyB;CACzB,mBAAmB;CACnB,mBAAmB;CACnB,QAAQ;AACT;AACA;;CAEC,mBAAmB;AACpB;AACA;CACC,WAAW;CACX,mBAAmB;CACnB,qBAAqB;CACrB,sBAAsB;CACtB,iBAAiB;AAClB;AACA;;;;CAIC,aAAa;AACd;AACA;;;;CAIC,UAAU;CACV,qBAAqB;AACtB;AACA;;;;CAIC,6BAA6B;CAC7B,0CAA0C;CAC1C,mBAAmB;CACnB,2BAA2B;CAC3B,qBAAqB;CACrB,SAAS;CACT,QAAQ;CACR,kBAAkB;CAClB,WAAW;AACZ;AACA;;;;CAIC,yBAAyB;AAC1B;AACA;;;;;CAKC,aAAa;AACd;AACA;;;;CAIC,YAAY;CACZ,qBAAqB;CACrB,eAAe;CACf,cAAc;CACd,QAAQ;CACR,kBAAkB;CAClB,iBAAiB;AAClB;AACA;;;;;CAKC,aAAa;AACd;AACA;;;CAGC,qBAAqB;AACtB;AACA;;;;;;;;CAQC,cAAc;AACf;AACA;CACC,yBAAyB;AAC1B;AACA;;;CAGC,6BAA6B;CAC7B,6CAA6C;AAC9C;AACA;;;CAGC,cAAc;CACd,6BAA6B;AAC9B;AACA;;;CAGC,qBAAqB;AACtB;AACA;;;;;;;;CAQC,cAAc;AACf;AACA;CACC,yBAAyB;AAC1B;AACA;;;CAGC,6BAA6B;CAC7B,6CAA6C;AAC9C;AACA;;;CAGC,cAAc;CACd,6BAA6B;AAC9B;AACA;;;CAGC,qBAAqB;AACtB;AACA;;;;;;;;CAQC,cAAc;AACf;AACA;CACC,yBAAyB;AAC1B;AACA;;;CAGC,8BAA8B;CAC9B,8CAA8C;AAC/C;AACA;;;CAGC,cAAc;CACd,6BAA6B;AAC9B;AACA;;;CAGC,qBAAqB;AACtB;AACA;;;;;;;;CAQC,cAAc;AACf;AACA;CACC,yBAAyB;AAC1B;AACA;;;CAGC,8BAA8B;CAC9B,8CAA8C;AAC/C;AACA;;;CAGC,cAAc;CACd,6BAA6B;AAC9B;AACA;;;CAGC,qBAAqB;AACtB;AACA;;;;;;;;CAQC,cAAc;AACf;AACA;CACC,yBAAyB;AAC1B;AACA;;;CAGC,6BAA6B;CAC7B,6CAA6C;AAC9C;AACA;;;CAGC,cAAc;CACd,6BAA6B;AAC9B;AACA;CACC,oCAAoC;AACrC;AACA;CACC,kBAAkB;CAClB,+BAA+B;CAC/B,+CAA+C;AAChD;AACA;;;CAGC,yBAAyB;CACzB,6BAA6B;AAC9B;AACA;;;CAGC,aAAa;AACd;AACA;;CAEC,yBAAyB;CACzB,yBAAyB;AAC1B;AACA;CACC,yBAAyB;AAC1B;;AAEA;CACC,kBAAkB;CAGlB,aAAa;CAIb,sBAAsB;CACtB,6BAA6B;CAC7B,gBAAgB;AACjB;AACA;CACC,yBAAyB;CACzB,cAAc;AACf;AACA;;;;;;;;;;;;;;CAcC,oCAAoC;CACpC,yBAAyB;CACzB,2BAA2B;AAC5B;AACA;CACC,gBAAgB;AACjB;AACA;;;;;;;;;;;;;;;;;;;;;;;;CAwBC,yBAAyB;CACzB,qBAAqB;AACtB;AACA;CACC,cAAc;CACd,qBAAqB;AACtB;AACA;;;CAGC,6BAA6B;CAC7B,cAAc;CACd,qBAAqB;CACrB,gBAAgB;AACjB;AACA;CACC,cAAc;AACf;AACA;;;;CAIC,6BAA6B;CAC7B,cAAc;CACd,qBAAqB;CACrB,gBAAgB;AACjB;AACA;CACC,YAAY;CACZ,yBAAyB;CACzB,oBAAoB;CACpB,mBAAmB;AACpB;AACA;CACC,yBAAyB;CACzB,cAAc;AACf;AACA;;;;;;;;;;;CAWC,oCAAoC;CACpC,yBAAyB;CACzB,2BAA2B;AAC5B;AACA;CACC,gBAAgB;AACjB;AACA;;;;;;;;;;;;;;;;;;;;;;;;CAwBC,yBAAyB;CACzB,qBAAqB;AACtB;AACA;CACC,cAAc;CACd,qBAAqB;AACtB;AACA;;;CAGC,6BAA6B;CAC7B,cAAc;CACd,qBAAqB;CACrB,gBAAgB;AACjB;AACA;CACC,cAAc;AACf;AACA;;;;CAIC,6BAA6B;CAC7B,cAAc;CACd,qBAAqB;CACrB,gBAAgB;AACjB;AACA;CACC,YAAY;CACZ,yBAAyB;CACzB,oBAAoB;CACpB,mBAAmB;AACpB;AACA;CACC,yBAAyB;CACzB,cAAc;AACf;AACA;;;;;;;;;;;;;;CAcC,oCAAoC;CACpC,yBAAyB;CACzB,2BAA2B;AAC5B;AACA;CACC,gBAAgB;AACjB;AACA;;;;;;;;;;;;;;;;;;;;;;;;CAwBC,yBAAyB;CACzB,qBAAqB;AACtB;AACA;CACC,cAAc;CACd,qBAAqB;AACtB;AACA;;;CAGC,6BAA6B;CAC7B,cAAc;CACd,qBAAqB;CACrB,gBAAgB;AACjB;AACA;CACC,cAAc;AACf;AACA;;;;CAIC,6BAA6B;CAC7B,cAAc;CACd,qBAAqB;CACrB,gBAAgB;AACjB;AACA;CACC,YAAY;CACZ,yBAAyB;CACzB,oBAAoB;CACpB,mBAAmB;AACpB;AACA;CACC,yBAAyB;CACzB,cAAc;AACf;AACA;;;;;;;;;;;;;;CAcC,oCAAoC;CACpC,yBAAyB;CACzB,2BAA2B;AAC5B;AACA;CACC,gBAAgB;AACjB;AACA;;;;;;;;;;;;;;;;;;;;;;;;CAwBC,yBAAyB;CACzB,qBAAqB;AACtB;AACA;CACC,cAAc;CACd,qBAAqB;AACtB;AACA;;;CAGC,6BAA6B;CAC7B,cAAc;CACd,qBAAqB;CACrB,gBAAgB;AACjB;AACA;CACC,cAAc;AACf;AACA;;;;CAIC,6BAA6B;CAC7B,cAAc;CACd,qBAAqB;CACrB,gBAAgB;AACjB;AACA;CACC,YAAY;CACZ,yBAAyB;CACzB,oBAAoB;CACpB,mBAAmB;AACpB;AACA;CACC,yBAAyB;CACzB,cAAc;AACf;AACA;;;;;;;;;;;CAWC,oCAAoC;CACpC,yBAAyB;CACzB,2BAA2B;AAC5B;AACA;CACC,gBAAgB;AACjB;AACA;;;;;;;;;;;;;;;;;;;;;;;;CAwBC,yBAAyB;CACzB,qBAAqB;AACtB;AACA;CACC,cAAc;CACd,qBAAqB;AACtB;AACA;;;CAGC,6BAA6B;CAC7B,cAAc;CACd,qBAAqB;CACrB,gBAAgB;AACjB;AACA;CACC,cAAc;AACf;AACA;;;;CAIC,6BAA6B;CAC7B,cAAc;CACd,qBAAqB;CACrB,gBAAgB;AACjB;AACA;CACC,YAAY;CACZ,yBAAyB;CACzB,oBAAoB;CACpB,mBAAmB;AACpB;;AAEA;CACC,iBAAiB;CACjB,aAAa;CACb,yBAAyB;AAC1B;AACA;CACC,gBAAgB;AACjB;AACA;CACC,kBAAkB;AACnB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CAGC,YAAY;CAEZ,oBAAoB;CAIpB,sBAAsB;CAGtB,oBAAoB;CACpB,WAAW;CACX,yBAAyB;CACzB,iBAAiB;AAClB;;AAEA;CAGC,cAAc;CAGd,aAAa;CAIb,sBAAsB;CACtB,yBAAyB;CAGzB,iBAAiB;AAClB;;AAEA;CACC,+BAA+B;CAC/B,4CAA4C;AAC7C;;AAEA;;CAEC,yBAAyB;CACzB,kBAAkB;CAClB,cAAc;CACd,gBAAgB;CAChB,YAAY;CACZ,yBAAyB;CACzB,mBAAmB;AACpB;AACA;;CAEC,aAAa;CACb,sBAAsB;CACtB,WAAW;AACZ;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,YAAY;CACZ,gBAAgB;CAChB,kBAAkB;CAClB,qBAAqB;CACrB,WAAW;CACX,WAAW;CACX,0BAA0B;AAC3B;;AAEA;;;;CAIC,gBAAgB;CAChB,SAAS;CACT,kBAAkB;CAClB,qBAAqB;CACrB,WAAW;CACX,WAAW;CACX,0BAA0B;CAC1B,UAAU;AACX;;AAEA;;;;CAIC,gBAAgB;CAChB,QAAQ;CACR,kBAAkB;CAClB,qBAAqB;CACrB,WAAW;CACX,WAAW;CACX,0BAA0B;CAC1B,UAAU;AACX;;AAEA;;CAEC,mBAAmB;CACnB,gBAAgB;CAChB,gBAAgB;CAChB,6BAA6B;CAC7B,gBAAgB;CAChB,mBAAmB;CACnB,kBAAkB;CAClB,mEAAmE;CACnE,qCAAqC;AACtC;;AAEA;;CAEC,eAAe;AAChB;;AAEA;;CAEC,eAAe;AAChB;;AAEA;;CAEC,eAAe;AAChB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;CAChB,uBAAuB;AACxB;AACA;CACC,aAAa;AACd;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;;CAEC,UAAU;CACV,QAAQ;CACR,yBAAyB;CACzB,YAAY;CACZ,SAAS;CACT,QAAQ;CACR,kBAAkB;CAClB,oBAAoB;AACrB;;AAEA;CACC,oCAAoC;CACpC,uBAAuB;CACvB,iBAAiB;CACjB,gBAAgB;AACjB;;AAEA;CACC,oCAAoC;CACpC,0BAA0B;CAC1B,kBAAkB;CAClB,iBAAiB;AAClB;;AAEA;CAGC,kBAAkB;CAClB,WAAW;CAGX,aAAa;CAIb,sBAAsB;CACtB,iBAAiB;AAClB;;AAEA;CACC;EACC,0BAAkB;EAAlB,uBAAkB;EAAlB,kBAAkB;CACnB;AACD;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA;CAGC,cAAc;CAGd,aAAa;CAIb,sBAAsB;CAGtB,oBAAoB;AACrB;;AAEA;CAGC,cAAc;CAGd,oBAAoB;AACrB;;AAEA;;CAIC,SAAW;CACX,mBAAmB;CACnB,uBAAuB;CACvB,iBAAiB;CACjB,gBAAgB;CAChB,qBAAqB;CACrB,uDAAuD;CACvD,cAAc;AACf;;AAEA;;CAEC,mBAAmB;CACnB,uBAAuB;CACvB,qBAAqB;CACrB,oBAAoB;CACpB,qBAAqB;AACtB;;AAEA;CACC,qBAAqB;CACrB,kBAAkB;CAClB,SAAS;CACT,kBAAkB;CAClB,cAAc;AACf;;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,QAAQ;CACR,SAAS;CACT,QAAQ;CACR,SAAS;CAET,+CAA+C;CAC/C,qCAAqC;CACrC,sCAAsC;CACtC,wCAAwC;CACxC,4DAA4D;CAC5D,eAAe;AAChB;;AAEA;CAEC,0CAA0C;AAC3C;;AAEA;CACC,qBAAqB;CACrB,kBAAkB;CAClB,WAAW;CACX,MAAM;CACN,SAAS;CACT,YAAY;CACZ,kBAAkB;CAClB,WAAW;AACZ;;AAEA;CAGC,cAAc;CAGd,aAAa;CAIb,sBAAsB;CACtB,0CAA0C;AAC3C;;AAEA;CACC,2CAA2C;AAC5C;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,oCAAoC;AACrC;;AAEA;CACC,UAAU;CAGV,aAAa;CAGb,8BAA8B;CAG9B,oBAAoB;CAEpB,eAAe;CACf,YAAY;AACb;;AAEA;;CAEC,yBAAyB;CACzB,kBAAkB;CAClB,cAAc;CACd,gBAAgB;CAChB,YAAY;CACZ,yBAAyB;CACzB,kBAAkB;AACnB;AACA;;CAEC,aAAa;CACb,sBAAsB;CACtB,WAAW;AACZ;;AAEA;CACC,wBAAwB;CAExB,gBAAgB;CAChB,cAAc;CACd,WAAW;CACX,YAAY;CACZ,SAAS;CACT,kBAAkB;CAClB,YAAY;CACZ,gBAAgB;CAChB,gBAAgB;CAChB,WAAW;CACX,yBAAyB;CACzB,eAAe;CACf,aAAa;AACd;;AAEA;CACC,YAAY;CACZ,mBAAmB;AACpB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,8BAA8B;CAC9B,WAAW;AACZ;;AAEA;;CAIC,SAAO;CACP,kBAAkB;AACnB;;AAEA;CAGC,WAAS;CACT,kBAAkB;CAClB,gBAAgB;CAGhB,aAAa;CAIb,mBAAmB;CAEnB,eAAe;CAGf,mBAAmB;CAEnB,6BAA6B;AAC9B;;AAEA;CACC,qBAAqB;CACrB,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,cAAc;CACd,kBAAkB;CAClB,SAAS;CACT,QAAQ;CAER,gCAAgC;CAChC,oCAAoC;CACpC,yBAAyB;CACzB,UAAU;CACV,oBAAoB;CACpB,aAAa;CACb,yBAAyB;AAC1B;;AAEA;CACC,cAAc;CACd,kBAAkB;CAClB,OAAO;CACP,QAAQ;CACR,MAAM;CACN,SAAS;CACT,oCAAoC;CACpC,yBAAyB;CACzB,WAAW;CACX,UAAU;CACV,oBAAoB;AACrB;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,kBAAkB;CAClB,WAAW;CACX,QAAQ;CACR,OAAO;CACP,eAAe;CACf,yBAAyB;CAEzB,2BAA2B;CAC3B,yDAAyD;AAC1D;;AAEA;CACC,UAAU;CACV,UAAU;CACV,mBAAmB;AACpB;;AAEA;CAEC,0BAA0B;AAC3B;;AAEA;;CAEC,2BAA2B;CAC3B,kBAAkB;CAClB,yBAAyB;CAGzB,iBAAiB;AAClB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,yBAAyB;CACzB,SAAS;AACV;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,6BAA6B;CAC7B,+BAA+B;CAC/B,kBAAkB;AACnB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,aAAa;CACb,gBAAgB;AACjB;;AAEA;CACC,qBAAqB;CACrB,gBAAgB;CAChB,eAAe;CACf,iBAAiB;AAClB;;AAEA;CACC,4BAA4B;CAC5B,eAAe;CACf,qBAAqB;CACrB,kBAAkB;CAClB,0BAA0B;CAC1B,mBAAmB;CACnB,WAAW;CACX,iBAAiB;CACjB,gBAAgB;CAChB,qBAAqB;CACrB,kBAAkB;CAClB,yBAAyB;CACzB,iBAAiB;AAClB;;AAEA;CACC,eAAe;CACf,iBAAiB;AAClB;;AAEA;CACC,2BAA2B;CAC3B,gBAAgB;CAChB,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,kBAAkB;CAClB,QAAQ;CACR,UAAU;CACV,UAAU;CACV,6BAA6B;AAC9B;;AAEA;CACC,uBAAuB;CACvB,SAAS;CACT,WAAW;CACX,uBAAuB;CACvB,eAAe;CACf,gBAAgB;CAChB,kBAAkB;CAClB,eAAe;CACf,aAAa;CACb,YAAY;CACZ,WAAW;AACZ;;AAEA;CAKC,6BAA6B;CAC7B,qBAAqB;CACrB,yBAAyB;AAC1B;AACA;CACC,mBAAmB;AACpB;AACA;CACC,UAAU;CACV,kBAAkB;AACnB;AACA;CACC,qBAAqB;CACrB,yBAAyB;AAC1B;AACA;CACC,qBAAqB;CACrB,yBAAyB;AAC1B;AACA;CACC,qBAAqB;CACrB,yBAAyB;AAC1B;AACA;CACC,qBAAqB;CACrB,yBAAyB;AAC1B;AACA;CACC,qBAAqB;CACrB,yBAAyB;AAC1B;AACA;CACC,qBAAqB;CACrB,yBAAyB;CACzB,cAAc;AACf","sourcesContent":["@charset \"UTF-8\";\n/*!\n\n =========================================================\n * DealerClick 2.0 React - v1.2.0 based on Paper Dashboard 2 Pro - v2.0.1\n =========================================================\n\n * Product Page: https://dealerclick.com\n * Copyright 2020 DealerClick (http://dealerclick.com)\n\n =========================================================\n\n * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.\n\n */\n@import \"../css/error.css\";\n@import \"../css/number-scrollbar.css\";\n@import \"../css/kbb-book-sheet.css\";\n@import \"../css/kbb-all-values.css\";\n.bootstrap-switch {\n\tdisplay: inline-block;\n\tdirection: ltr;\n\tcursor: pointer;\n\tborder-radius: 30px;\n\tborder: 0;\n\tposition: relative;\n\ttext-align: left;\n\toverflow: hidden;\n\tmargin-bottom: 5px;\n\tline-height: 8px;\n\twidth: 61px !important;\n\theight: 26px;\n\toutline: none;\n\tz-index: 0;\n\tmargin-right: 1px;\n\t-webkit-user-select: none;\n\t-moz-user-select: none;\n\t-ms-user-select: none;\n\tuser-select: none;\n\tvertical-align: middle;\n\t-webkit-transition: border-color ease-in-out 0.15s,\n\t\tbox-shadow ease-in-out 0.15s;\n\ttransition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;\n}\n\n.bootstrap-switch .bootstrap-switch-container {\n\tdisplay: inline-flex;\n\ttop: 0;\n\theight: 26px;\n\tborder-radius: 4px;\n\t-webkit-transform: translate3d(0, 0, 0);\n\ttransform: translate3d(0, 0, 0);\n\twidth: 100px !important;\n}\n\n.bootstrap-switch .bootstrap-switch-handle-on,\n.bootstrap-switch .bootstrap-switch-handle-off,\n.bootstrap-switch .bootstrap-switch-label {\n\t-webkit-box-sizing: border-box;\n\t-moz-box-sizing: border-box;\n\tbox-sizing: border-box;\n\tcursor: pointer;\n\tdisplay: inline-block !important;\n\theight: 100%;\n\tcolor: #fff;\n\tpadding: 6px 10px;\n\tfont-size: 11px;\n\ttext-indent: -5px;\n\tline-height: 15px;\n\t-webkit-transition: 0.25s ease-out;\n\ttransition: 0.25s ease-out;\n}\n.bootstrap-switch .bootstrap-switch-handle-on i,\n.bootstrap-switch .bootstrap-switch-handle-off i,\n.bootstrap-switch .bootstrap-switch-label i {\n\tfont-size: 12px;\n\tline-height: 14px;\n}\n\n.bootstrap-switch .bootstrap-switch-handle-on,\n.bootstrap-switch .bootstrap-switch-handle-off {\n\ttext-align: center;\n\tz-index: 1;\n\tfloat: left;\n\twidth: 50% !important;\n\tbackground-color: #66615b;\n}\n\n.bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-primary,\n.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-primary {\n\tcolor: #fff;\n\tbackground: #7a9e9f;\n}\n\n.bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-info,\n.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-info {\n\tcolor: #fff;\n\tbackground: #68b3c8;\n}\n\n.bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-success,\n.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-success {\n\tcolor: #fff;\n\tbackground: #7ac29a;\n}\n\n.bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-warning,\n.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-warning {\n\tbackground: #f3bb45;\n\tcolor: #fff;\n}\n\n.bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-danger,\n.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-danger {\n\tcolor: #fff;\n\tbackground: #eb5e28;\n}\n\n.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-default {\n\tcolor: #fff;\n\tbackground: #cfcfca;\n}\n\n.bootstrap-switch .bootstrap-switch-label {\n\ttext-align: center;\n\tz-index: 100;\n\tcolor: #333333;\n\tbackground: #ffffff;\n\twidth: 22px !important;\n\theight: 22px;\n\tmargin: 2px -11px;\n\tborder-radius: 12px;\n\tposition: relative;\n\tfloat: left;\n\tpadding: 0;\n\tbackground-color: #ffffff;\n\tbox-shadow: 0 1px 1px #ffffff inset, 0 1px 1px rgba(0, 0, 0, 0.25);\n}\n\n.bootstrap-switch .bootstrap-switch-handle-on {\n\tborder-bottom-left-radius: 3px;\n\tborder-top-left-radius: 3px;\n}\n\n.bootstrap-switch .bootstrap-switch-handle-off {\n\ttext-indent: 6px;\n}\n\n.bootstrap-switch input[type=\"radio\"],\n.bootstrap-switch input[type=\"checkbox\"] {\n\tposition: absolute !important;\n\ttop: 0;\n\tleft: 0;\n\topacity: 0;\n\tfilter: alpha(opacity=0);\n\tz-index: -1;\n}\n\n.bootstrap-switch input[type=\"radio\"].form-control,\n.bootstrap-switch input[type=\"checkbox\"].form-control {\n\theight: auto;\n}\n\n.bootstrap-switch.bootstrap-switch-mini .bootstrap-switch-handle-on,\n.bootstrap-switch.bootstrap-switch-mini .bootstrap-switch-handle-off,\n.bootstrap-switch.bootstrap-switch-mini .bootstrap-switch-label {\n\tpadding: 1px 5px;\n\tfont-size: 12px;\n\tline-height: 1.5;\n}\n\n.bootstrap-switch.bootstrap-switch-small .bootstrap-switch-handle-on,\n.bootstrap-switch.bootstrap-switch-small .bootstrap-switch-handle-off,\n.bootstrap-switch.bootstrap-switch-small .bootstrap-switch-label {\n\tpadding: 5px 10px;\n\tfont-size: 12px;\n\tline-height: 1.5;\n}\n\n.bootstrap-switch.bootstrap-switch-large .bootstrap-switch-handle-on,\n.bootstrap-switch.bootstrap-switch-large .bootstrap-switch-handle-off,\n.bootstrap-switch.bootstrap-switch-large .bootstrap-switch-label {\n\tpadding: 6px 16px;\n\tfont-size: 18px;\n\tline-height: 1.33;\n}\n\n.bootstrap-switch.bootstrap-switch-disabled,\n.bootstrap-switch.bootstrap-switch-readonly,\n.bootstrap-switch.bootstrap-switch-indeterminate {\n\tcursor: default !important;\n}\n\n.bootstrap-switch.bootstrap-switch-disabled .bootstrap-switch-handle-on,\n.bootstrap-switch.bootstrap-switch-readonly .bootstrap-switch-handle-on,\n.bootstrap-switch.bootstrap-switch-indeterminate .bootstrap-switch-handle-on,\n.bootstrap-switch.bootstrap-switch-disabled .bootstrap-switch-handle-off,\n.bootstrap-switch.bootstrap-switch-readonly .bootstrap-switch-handle-off,\n.bootstrap-switch.bootstrap-switch-indeterminate .bootstrap-switch-handle-off,\n.bootstrap-switch.bootstrap-switch-disabled .bootstrap-switch-label,\n.bootstrap-switch.bootstrap-switch-readonly .bootstrap-switch-label,\n.bootstrap-switch.bootstrap-switch-indeterminate .bootstrap-switch-label {\n\topacity: 0.5;\n\tfilter: alpha(opacity=50);\n\tcursor: default !important;\n}\n\n.bootstrap-switch.bootstrap-switch-animate .bootstrap-switch-container {\n\t-webkit-transition: margin-left 0.5s;\n\ttransition: margin-left 0.5s;\n}\n\n.bootstrap-switch.bootstrap-switch-inverse .bootstrap-switch-handle-on {\n\tborder-bottom-left-radius: 0;\n\tborder-top-left-radius: 0;\n\tborder-bottom-right-radius: 3px;\n\tborder-top-right-radius: 3px;\n}\n\n.bootstrap-switch.bootstrap-switch-inverse .bootstrap-switch-handle-off {\n\tborder-bottom-right-radius: 0;\n\tborder-top-right-radius: 0;\n\tborder-bottom-left-radius: 3px;\n\tborder-top-left-radius: 3px;\n}\n\n.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-container {\n\tmargin-left: -2px !important;\n}\n\n.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-container {\n\tmargin-left: -37px !important;\n}\n\n.bootstrap-switch.bootstrap-switch-on:hover .bootstrap-switch-label {\n\twidth: 26px !important;\n\tmargin: 2px -15px;\n}\n\n.bootstrap-switch.bootstrap-switch-off:hover .bootstrap-switch-label {\n\twidth: 26px !important;\n\tmargin: 2px -15px -13px -11px;\n}\n\n.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-handle-off {\n\tbackground-color: #66615b;\n}\n\n.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-handle-on {\n\tbackground-color: #cfcfca;\n}\n\n.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-danger {\n\tbackground-color: #eb5e28;\n}\n\n.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-warning {\n\tbackground-color: #f3bb45;\n}\n\n.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-success {\n\tbackground-color: #7ac29a;\n}\n\n.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-primary {\n\tbackground-color: #7a9e9f;\n}\n\n.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-info {\n\tbackground-color: #68b3c8;\n}\n\n.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-default {\n\tbackground-color: #66615b;\n}\n\n.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-danger,\n.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-primary,\n.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-info,\n.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-warning,\n.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-success {\n\tbackground-color: #cfcfca;\n}\n\n/**\n * @author zhixin wen <wenzhixin2010@gmail.com>\n * version: 1.12.1\n * https://github.com/wenzhixin/bootstrap-table/\n */\n.bootstrap-table .table {\n\tmargin-bottom: 0 !important;\n\tborder-bottom: 1px solid #dddddd;\n\tborder-collapse: collapse !important;\n\tborder-radius: 1px;\n}\n\n.bootstrap-table .table:not(.table-condensed),\n.bootstrap-table .table:not(.table-condensed) > tbody > tr > th,\n.bootstrap-table .table:not(.table-condensed) > tfoot > tr > th,\n.bootstrap-table .table:not(.table-condensed) > thead > tr > td,\n.bootstrap-table .table:not(.table-condensed) > tbody > tr > td,\n.bootstrap-table .table:not(.table-condensed) > tfoot > tr > td {\n\tpadding: 8px;\n}\n\n.bootstrap-table .table.table-no-bordered > thead > tr > th,\n.bootstrap-table .table.table-no-bordered > tbody > tr > td {\n\tborder-right: 2px solid transparent;\n}\n\n.bootstrap-table .table.table-no-bordered > tbody > tr > td:last-child {\n\tborder-right: none;\n}\n\n.fixed-table-container {\n\tposition: relative;\n\tclear: both;\n\tborder: 1px solid #dddddd;\n\tborder-radius: 4px;\n\t-webkit-border-radius: 4px;\n\t-moz-border-radius: 4px;\n}\n\n.fixed-table-container.table-no-bordered {\n\tborder: 1px solid transparent;\n}\n\n.fixed-table-footer,\n.fixed-table-header {\n\toverflow: hidden;\n}\n\n.fixed-table-footer {\n\tborder-top: 1px solid #dddddd;\n}\n\n.fixed-table-body {\n\toverflow-x: auto;\n\toverflow-y: auto;\n\theight: 100%;\n}\n\n.fixed-table-container table {\n\twidth: 100%;\n}\n\n.fixed-table-container thead th {\n\theight: 0;\n\tpadding: 0;\n\tmargin: 0;\n\tborder-left: 1px solid #dddddd;\n}\n\n.fixed-table-container thead th:focus {\n\toutline: 0 solid transparent;\n}\n\n.fixed-table-container thead th:first-child:not([data-not-first-th]) {\n\tborder-left: none;\n\tborder-top-left-radius: 4px;\n\t-webkit-border-top-left-radius: 4px;\n\t-moz-border-radius-topleft: 4px;\n}\n\n.fixed-table-container thead th .th-inner,\n.fixed-table-container tbody td .th-inner {\n\tpadding: 8px;\n\tline-height: 24px;\n\tvertical-align: top;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\twhite-space: nowrap;\n}\n\n.fixed-table-container thead th .sortable {\n\tcursor: pointer;\n\tbackground-position: right;\n\tbackground-repeat: no-repeat;\n\tpadding-right: 30px;\n}\n\n.fixed-table-container thead th .both {\n\tbackground-image: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAATCAQAAADYWf5HAAAAkElEQVQoz7X QMQ5AQBCF4dWQSJxC5wwax1Cq1e7BAdxD5SL+Tq/QCM1oNiJidwox0355mXnG/DrEtIQ6azioNZQxI0ykPhTQIwhCR+BmBYtlK7kLJYwWCcJA9M4qdrZrd8pPjZWPtOqdRQy320YSV17OatFC4euts6z39GYMKRPCTKY9UnPQ6P+GtMRfGtPnBCiqhAeJPmkqAAAAAElFTkSuQmCC\");\n}\n\n.fixed-table-container thead th .asc {\n\tbackground-image: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAATCAYAAAByUDbMAAAAZ0lEQVQ4y2NgGLKgquEuFxBPAGI2ahhWCsS/gDibUoO0gPgxEP8H4ttArEyuQYxAPBdqEAxPBImTY5gjEL9DM+wTENuQahAvEO9DMwiGdwAxOymGJQLxTyD+jgWDxCMZRsEoGAVoAADeemwtPcZI2wAAAABJRU5ErkJggg==\");\n}\n\n.fixed-table-container thead th .desc {\n\tbackground-image: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAATCAYAAAByUDbMAAAAZUlEQVQ4y2NgGAWjYBSggaqGu5FA/BOIv2PBIPFEUgxjB+IdQPwfC94HxLykus4GiD+hGfQOiB3J8SojEE9EM2wuSJzcsFMG4ttQgx4DsRalkZENxL+AuJQaMcsGxBOAmGvopk8AVz1sLZgg0bsAAAAASUVORK5CYII= \");\n}\n\n.fixed-table-container th.detail {\n\twidth: 30px;\n}\n\n.fixed-table-container tbody td {\n\tborder-left: 1px solid #dddddd;\n}\n\n.fixed-table-container tbody tr:first-child td {\n\tborder-top: none;\n}\n\n.fixed-table-container tbody td:first-child {\n\tborder-left: none;\n}\n\n/* the same color with .active */\n.fixed-table-container tbody .selected td {\n\tbackground-color: #f5f5f5;\n}\n\n.fixed-table-container .bs-checkbox {\n\ttext-align: center;\n}\n\n.fixed-table-container input[type=\"radio\"],\n.fixed-table-container input[type=\"checkbox\"] {\n\tmargin: 0 auto !important;\n}\n\n.fixed-table-container .no-records-found {\n\ttext-align: center;\n}\n\n.fixed-table-pagination div.pagination,\n.fixed-table-pagination .pagination-detail {\n\tmargin-top: 10px;\n\tmargin-bottom: 10px;\n}\n\n.fixed-table-pagination div.pagination .pagination {\n\tmargin: 0;\n}\n\n.fixed-table-pagination .pagination a {\n\tpadding: 6px 12px;\n\tline-height: 1.428571429;\n}\n\n.fixed-table-pagination .pagination-info {\n\tline-height: 34px;\n\tmargin-right: 5px;\n}\n\n.fixed-table-pagination .btn-group {\n\tposition: relative;\n\tdisplay: inline-block;\n\tvertical-align: middle;\n}\n\n.fixed-table-pagination .dropup .dropdown-menu {\n\tmargin-bottom: 0;\n}\n\n.fixed-table-pagination .page-list {\n\tdisplay: inline-block;\n}\n\n.fixed-table-toolbar .columns-left {\n\tmargin-right: 5px;\n}\n\n.fixed-table-toolbar .columns-right {\n\tmargin-left: 5px;\n}\n\n.fixed-table-toolbar .columns label {\n\tdisplay: block;\n\tpadding: 3px 20px;\n\tclear: both;\n\tfont-weight: normal;\n\tline-height: 1.428571429;\n}\n\n.fixed-table-toolbar .bs-bars,\n.fixed-table-toolbar .search,\n.fixed-table-toolbar .columns {\n\tposition: relative;\n\tmargin-top: 10px;\n\tmargin-bottom: 10px;\n\tline-height: 34px;\n}\n\n.fixed-table-pagination li.disabled a {\n\tpointer-events: none;\n\tcursor: default;\n}\n\n.fixed-table-loading {\n\tdisplay: none;\n\tposition: absolute;\n\ttop: 42px;\n\tright: 0;\n\tbottom: 0;\n\tleft: 0;\n\tz-index: 99;\n\tbackground-color: #fff;\n\ttext-align: center;\n}\n\n.fixed-table-body .card-view .title {\n\tfont-weight: bold;\n\tdisplay: inline-block;\n\tmin-width: 30%;\n\ttext-align: left !important;\n}\n\n/* support bootstrap 2 */\n.fixed-table-body thead th .th-inner {\n\tbox-sizing: border-box;\n}\n\n.table th,\n.table td {\n\tvertical-align: middle;\n\tbox-sizing: border-box;\n}\n\n.fixed-table-toolbar .dropdown-menu {\n\ttext-align: left;\n\tmax-height: 300px;\n\toverflow: auto;\n}\n\n.fixed-table-toolbar .btn-group > .btn-group {\n\tdisplay: inline-block;\n\tmargin-left: -1px !important;\n}\n\n.fixed-table-toolbar .btn-group > .btn-group > .btn {\n\tborder-radius: 0;\n}\n\n.fixed-table-toolbar .btn-group > .btn-group:first-child > .btn {\n\tborder-top-left-radius: 4px;\n\tborder-bottom-left-radius: 4px;\n}\n\n.fixed-table-toolbar .btn-group > .btn-group:last-child > .btn {\n\tborder-top-right-radius: 4px;\n\tborder-bottom-right-radius: 4px;\n}\n\n.bootstrap-table .table > thead > tr > th {\n\tvertical-align: bottom;\n\tborder-bottom: 1px solid #ddd;\n}\n\n/* support bootstrap 3 */\n.bootstrap-table .table thead > tr > th {\n\tpadding: 0;\n\tmargin: 0;\n}\n\n.bootstrap-table .fixed-table-footer tbody > tr > td {\n\tpadding: 0 !important;\n}\n\n.bootstrap-table .fixed-table-footer .table {\n\tborder-bottom: none;\n\tborder-radius: 0;\n\tpadding: 0 !important;\n}\n\n.bootstrap-table .pull-right .dropdown-menu {\n\tright: 0;\n\tleft: auto;\n}\n\n/* calculate scrollbar width */\np.fixed-table-scroll-inner {\n\twidth: 100%;\n\theight: 200px;\n}\n\ndiv.fixed-table-scroll-outer {\n\ttop: 0;\n\tleft: 0;\n\tvisibility: hidden;\n\twidth: 200px;\n\theight: 150px;\n\toverflow: hidden;\n}\n\n/* for get correct heights  */\n.fixed-table-toolbar:after,\n.fixed-table-pagination:after {\n\tcontent: \"\";\n\tdisplay: block;\n\tclear: both;\n}\n\n.fullscreen {\n\tposition: fixed;\n\ttop: 0;\n\tleft: 0;\n\tz-index: 1050;\n\twidth: 100% !important;\n\tbackground: #fff;\n}\n\n.bootstrap-table .btn-group:last-child .btn {\n\tborder-top-right-radius: 30px !important;\n\tborder-bottom-right-radius: 30px !important;\n\tmargin-left: -2px;\n}\n\n/*! nouislider - 9.1.0 - 2016-12-10 16:00:32 */\n/* Functional styling;\n * These styles are required for noUiSlider to function.\n * You don't need to change these rules to apply your design.\n */\n.noUi-target,\n.noUi-target * {\n\t-webkit-touch-callout: none;\n\t-webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n\t-webkit-user-select: none;\n\t-ms-touch-action: none;\n\ttouch-action: none;\n\t-ms-user-select: none;\n\t-moz-user-select: none;\n\tuser-select: none;\n\t-moz-box-sizing: border-box;\n\tbox-sizing: border-box;\n}\n\n.noUi-target {\n\tposition: relative;\n\tdirection: ltr;\n}\n\n.noUi-base {\n\twidth: 100%;\n\theight: 100%;\n\tposition: relative;\n\tz-index: 1;\n\t/* Fix 401 */\n}\n\n.noUi-connect {\n\tposition: absolute;\n\tright: 0;\n\ttop: 0;\n\tleft: 0;\n\tbottom: 0;\n}\n\n.noUi-origin {\n\tposition: absolute;\n\theight: 0;\n\twidth: 0;\n}\n\n.noUi-handle {\n\tposition: relative;\n\tz-index: 1;\n}\n\n.noUi-state-tap .noUi-connect,\n.noUi-state-tap .noUi-origin {\n\t-webkit-transition: top 0.3s, right 0.3s, bottom 0.3s, left 0.3s;\n\ttransition: top 0.3s, right 0.3s, bottom 0.3s, left 0.3s;\n}\n\n.noUi-state-drag * {\n\tcursor: inherit !important;\n}\n\n/* Painting and performance;\n * Browsers can paint handles in their own layer.\n */\n.noUi-base,\n.noUi-handle {\n\t-webkit-transform: translate3d(0, 0, 0);\n\ttransform: translate3d(0, 0, 0);\n}\n\n/* Slider size and handle placement;\n */\n.noUi-horizontal {\n\theight: 8px;\n}\n\n.noUi-horizontal .noUi-handle {\n\tbackground: white;\n\t/* Old browsers */\n\tbackground: -moz-linear-gradient(top, white 0%, #f1f1f2 100%);\n\t/* FF3.6+ */\n\tbackground: -webkit-gradient(\n\t\tlinear,\n\t\tleft top,\n\t\tleft bottom,\n\t\tcolor-stop(0%, white),\n\t\tcolor-stop(100%, #f1f1f2)\n\t);\n\t/* Chrome,Safari4+ */\n\tbackground: -webkit-linear-gradient(top, white 0%, #f1f1f2 100%);\n\t/* Chrome10+,Safari5.1+ */\n\tbackground: -o-linear-gradient(top, white 0%, #f1f1f2 100%);\n\t/* Opera 11.10+ */\n\tbackground: -ms-linear-gradient(top, white 0%, #f1f1f2 100%);\n\t/* IE10+ */\n\tbackground: linear-gradient(to bottom, white 0%, #f1f1f2 100%);\n\t/* W3C */\n\tfilter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\"$white-color\", endColorstr=\"#f1f1f2\",GradientType=0 );\n\t/* IE6-9 */\n\tborder-radius: 50%;\n\tbox-shadow: 0 1px 1px #ffffff inset, 0 1px 2px rgba(0, 0, 0, 0.4);\n\theight: 15px;\n\twidth: 15px;\n\tcursor: pointer;\n\tmargin-left: -10px;\n\tmargin-top: -4px;\n}\n\n.noUi-vertical {\n\twidth: 18px;\n}\n\n.noUi-vertical .noUi-handle {\n\twidth: 28px;\n\theight: 34px;\n\tleft: -6px;\n\ttop: -17px;\n}\n\n/* Styling;\n */\n.noUi-target {\n\tbackground-color: #e5e5e5;\n\tborder-radius: 3px;\n}\n\n.noUi-connect {\n\tbackground: #3fb8af;\n\tborder-radius: 3px;\n\t-webkit-transition: background 450ms;\n\ttransition: background 450ms;\n}\n\n/* Handles and cursors;\n */\n.noUi-draggable {\n\tcursor: ew-resize;\n}\n\n.noUi-vertical .noUi-draggable {\n\tcursor: ns-resize;\n}\n\n.noUi-handle {\n\tborder-radius: 3px;\n\tbackground: #fff;\n\tcursor: default;\n\tbox-shadow: inset 0 0 1px #fff, inset 0 1px 7px #ebebeb, 0 3px 6px -3px #bbb;\n}\n\n.noUi-active {\n\tbox-shadow: inset 0 0 1px #fff, inset 0 1px 7px #ddd, 0 3px 6px -3px #bbb;\n}\n\n/* Handle stripes;\n */\n/* Disabled state;\n */\n[disabled] .noUi-connect {\n\tbackground: #b8b8b8;\n}\n\n[disabled].noUi-target,\n[disabled].noUi-handle,\n[disabled] .noUi-handle {\n\tcursor: not-allowed;\n}\n\n/* Base;\n *\n */\n.noUi-pips,\n.noUi-pips * {\n\t-moz-box-sizing: border-box;\n\tbox-sizing: border-box;\n}\n\n.noUi-pips {\n\tposition: absolute;\n\tcolor: #999;\n}\n\n/* Values;\n *\n */\n.noUi-value {\n\tposition: absolute;\n\ttext-align: center;\n}\n\n.noUi-value-sub {\n\tcolor: #ccc;\n\tfont-size: 10px;\n}\n\n/* Markings;\n *\n */\n.noUi-marker {\n\tposition: absolute;\n\tbackground: #ccc;\n}\n\n.noUi-marker-sub {\n\tbackground: #aaa;\n}\n\n.noUi-marker-large {\n\tbackground: #aaa;\n}\n\n/* Horizontal layout;\n *\n */\n.noUi-pips-horizontal {\n\tpadding: 10px 0;\n\theight: 80px;\n\ttop: 100%;\n\tleft: 0;\n\twidth: 100%;\n}\n\n.noUi-value-horizontal {\n\t-webkit-transform: translate3d(-50%, 50%, 0);\n\ttransform: translate3d(-50%, 50%, 0);\n}\n\n.noUi-marker-horizontal.noUi-marker {\n\tmargin-left: -1px;\n\twidth: 2px;\n\theight: 5px;\n}\n\n.noUi-marker-horizontal.noUi-marker-sub {\n\theight: 10px;\n}\n\n.noUi-marker-horizontal.noUi-marker-large {\n\theight: 15px;\n}\n\n/* Vertical layout;\n *\n */\n.noUi-pips-vertical {\n\tpadding: 0 10px;\n\theight: 100%;\n\ttop: 0;\n\tleft: 100%;\n}\n\n.noUi-value-vertical {\n\t-webkit-transform: translate3d(0, 50%, 0);\n\ttransform: translate3d(0, 50%, 0);\n\tpadding-left: 25px;\n}\n\n.noUi-marker-vertical.noUi-marker {\n\twidth: 5px;\n\theight: 2px;\n\tmargin-top: -1px;\n}\n\n.noUi-marker-vertical.noUi-marker-sub {\n\twidth: 10px;\n}\n\n.noUi-marker-vertical.noUi-marker-large {\n\twidth: 15px;\n}\n\n.noUi-tooltip {\n\tdisplay: block;\n\tposition: absolute;\n\tborder: 1px solid #d9d9d9;\n\tborder-radius: 3px;\n\tbackground: #fff;\n\tcolor: #000;\n\tpadding: 5px;\n\ttext-align: center;\n}\n\n.noUi-horizontal .noUi-tooltip {\n\t-webkit-transform: translate(-50%, 0);\n\ttransform: translate(-50%, 0);\n\tleft: 50%;\n\tbottom: 120%;\n}\n\n.noUi-vertical .noUi-tooltip {\n\t-webkit-transform: translate(0, -50%);\n\ttransform: translate(0, -50%);\n\ttop: 50%;\n\tright: 120%;\n}\n\n.slider.slider-info .noUi-connect,\n.slider.slider-info.noUi-connect {\n\tbackground-color: #39a9db;\n}\n.slider.slider-info .noUi-handle {\n\tborder-color: #39a9db;\n}\n.slider.slider-success .noUi-connect,\n.slider.slider-success.noUi-connect {\n\tbackground-color: #28a745;\n}\n.slider.slider-success .noUi-handle {\n\tborder-color: #28a745;\n}\n.slider.slider-warning .noUi-connect,\n.slider.slider-warning.noUi-connect {\n\tbackground-color: #ffc759;\n}\n.slider.slider-warning .noUi-handle {\n\tborder-color: #ffc759;\n}\n.slider.slider-danger .noUi-connect,\n.slider.slider-danger.noUi-connect {\n\tbackground-color: #c1292e;\n}\n.slider.slider-danger .noUi-handle {\n\tborder-color: #c1292e;\n}\n\n/*!\nAnimate.css - http://daneden.me/animate\nLicensed under the MIT license - http://opensource.org/licenses/MIT\n\nCopyright (c) 2015 Daniel Eden\n*/\n.animated {\n\t-webkit-animation-duration: 1s;\n\tanimation-duration: 1s;\n\t-webkit-animation-fill-mode: both;\n\tanimation-fill-mode: both;\n}\n\n.animated.infinite {\n\t-webkit-animation-iteration-count: infinite;\n\tanimation-iteration-count: infinite;\n}\n\n.animated.hinge {\n\t-webkit-animation-duration: 2s;\n\tanimation-duration: 2s;\n}\n\n.animated.bounceIn,\n.animated.bounceOut {\n\t-webkit-animation-duration: 0.75s;\n\tanimation-duration: 0.75s;\n}\n\n.animated.flipOutX,\n.animated.flipOutY {\n\t-webkit-animation-duration: 0.75s;\n\tanimation-duration: 0.75s;\n}\n\n@-webkit-keyframes shake {\n\tfrom,\n\tto {\n\t\t-webkit-transform: translate3d(0, 0, 0);\n\t\ttransform: translate3d(0, 0, 0);\n\t}\n\t10%,\n\t30%,\n\t50%,\n\t70%,\n\t90% {\n\t\t-webkit-transform: translate3d(-10px, 0, 0);\n\t\ttransform: translate3d(-10px, 0, 0);\n\t}\n\t20%,\n\t40%,\n\t60%,\n\t80% {\n\t\t-webkit-transform: translate3d(10px, 0, 0);\n\t\ttransform: translate3d(10px, 0, 0);\n\t}\n}\n@keyframes shake {\n\tfrom,\n\tto {\n\t\t-webkit-transform: translate3d(0, 0, 0);\n\t\ttransform: translate3d(0, 0, 0);\n\t}\n\t10%,\n\t30%,\n\t50%,\n\t70%,\n\t90% {\n\t\t-webkit-transform: translate3d(-10px, 0, 0);\n\t\ttransform: translate3d(-10px, 0, 0);\n\t}\n\t20%,\n\t40%,\n\t60%,\n\t80% {\n\t\t-webkit-transform: translate3d(10px, 0, 0);\n\t\ttransform: translate3d(10px, 0, 0);\n\t}\n}\n.shake {\n\t-webkit-animation-name: shake;\n\tanimation-name: shake;\n}\n\n@-webkit-keyframes fadeInDown {\n\tfrom {\n\t\topacity: 0;\n\t\t-webkit-transform: translate3d(0, -100%, 0);\n\t\ttransform: translate3d(0, -100%, 0);\n\t}\n\tto {\n\t\topacity: 1;\n\t\t-webkit-transform: none;\n\t\ttransform: none;\n\t}\n}\n@keyframes fadeInDown {\n\tfrom {\n\t\topacity: 0;\n\t\t-webkit-transform: translate3d(0, -100%, 0);\n\t\ttransform: translate3d(0, -100%, 0);\n\t}\n\tto {\n\t\topacity: 1;\n\t\t-webkit-transform: none;\n\t\ttransform: none;\n\t}\n}\n.fadeInDown {\n\t-webkit-animation-name: fadeInDown;\n\tanimation-name: fadeInDown;\n}\n\n@-webkit-keyframes fadeOut {\n\tfrom {\n\t\topacity: 1;\n\t}\n\tto {\n\t\topacity: 0;\n\t}\n}\n@keyframes fadeOut {\n\tfrom {\n\t\topacity: 1;\n\t}\n\tto {\n\t\topacity: 0;\n\t}\n}\n.fadeOut {\n\t-webkit-animation-name: fadeOut;\n\tanimation-name: fadeOut;\n}\n\n@-webkit-keyframes fadeOutDown {\n\tfrom {\n\t\topacity: 1;\n\t}\n\tto {\n\t\topacity: 0;\n\t\t-webkit-transform: translate3d(0, 100%, 0);\n\t\ttransform: translate3d(0, 100%, 0);\n\t}\n}\n@keyframes fadeOutDown {\n\tfrom {\n\t\topacity: 1;\n\t}\n\tto {\n\t\topacity: 0;\n\t\t-webkit-transform: translate3d(0, 100%, 0);\n\t\ttransform: translate3d(0, 100%, 0);\n\t}\n}\n.fadeOutDown {\n\t-webkit-animation-name: fadeOutDown;\n\tanimation-name: fadeOutDown;\n}\n\n@-webkit-keyframes fadeOutUp {\n\tfrom {\n\t\topacity: 1;\n\t}\n\tto {\n\t\topacity: 0;\n\t\t-webkit-transform: translate3d(0, -100%, 0);\n\t\ttransform: translate3d(0, -100%, 0);\n\t}\n}\n@keyframes fadeOutUp {\n\tfrom {\n\t\topacity: 1;\n\t}\n\tto {\n\t\topacity: 0;\n\t\t-webkit-transform: translate3d(0, -100%, 0);\n\t\ttransform: translate3d(0, -100%, 0);\n\t}\n}\n.fadeOutUp {\n\t-webkit-animation-name: fadeOutUp;\n\tanimation-name: fadeOutUp;\n}\n\n/* perfect-scrollbar v0.6.13 */\n.ps-container {\n\t-ms-touch-action: auto;\n\ttouch-action: auto;\n\toverflow: hidden !important;\n\t-ms-overflow-style: none;\n}\n\n@supports (-ms-overflow-style: none) {\n\t.ps-container {\n\t\toverflow: auto !important;\n\t}\n}\n@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n\t.ps-container {\n\t\toverflow: auto !important;\n\t}\n}\n.ps-container.ps-active-x > .ps-scrollbar-x-rail,\n.ps-container.ps-active-y > .ps-scrollbar-y-rail {\n\tdisplay: block;\n\tbackground-color: transparent;\n}\n\n.ps-container.ps-in-scrolling.ps-x > .ps-scrollbar-x-rail {\n\tbackground-color: #eee;\n\topacity: 0.9;\n}\n\n.ps-container.ps-in-scrolling.ps-x > .ps-scrollbar-x-rail > .ps-scrollbar-x {\n\tbackground-color: #999;\n\theight: 11px;\n}\n\n.ps-container.ps-in-scrolling.ps-y > .ps-scrollbar-y-rail {\n\tbackground-color: #eee;\n\topacity: 0.9;\n}\n\n.ps-container.ps-in-scrolling.ps-y > .ps-scrollbar-y-rail > .ps-scrollbar-y {\n\tbackground-color: #999;\n\twidth: 11px;\n}\n\n.ps-container > .ps-scrollbar-x-rail {\n\tdisplay: none;\n\tposition: absolute;\n\t/* please don't change 'position' */\n\topacity: 0;\n\t-webkit-transition: background-color 0.2s linear, opacity 0.2s linear;\n\t-o-transition: background-color 0.2s linear, opacity 0.2s linear;\n\t-moz-transition: background-color 0.2s linear, opacity 0.2s linear;\n\ttransition: background-color 0.2s linear, opacity 0.2s linear;\n\tbottom: 0px;\n\t/* there must be 'bottom' for ps-scrollbar-x-rail */\n\theight: 15px;\n}\n\n.ps-container > .ps-scrollbar-x-rail > .ps-scrollbar-x {\n\tposition: absolute;\n\t/* please don't change 'position' */\n\tbackground-color: #aaa;\n\t-webkit-border-radius: 6px;\n\t-moz-border-radius: 6px;\n\tborder-radius: 6px;\n\t-webkit-transition: background-color 0.2s linear, height 0.2s linear,\n\t\twidth 0.2s ease-in-out, -webkit-border-radius 0.2s ease-in-out;\n\ttransition: background-color 0.2s linear, height 0.2s linear,\n\t\twidth 0.2s ease-in-out, -webkit-border-radius 0.2s ease-in-out;\n\t-o-transition: background-color 0.2s linear, height 0.2s linear,\n\t\twidth 0.2s ease-in-out, border-radius 0.2s ease-in-out;\n\t-moz-transition: background-color 0.2s linear, height 0.2s linear,\n\t\twidth 0.2s ease-in-out, border-radius 0.2s ease-in-out,\n\t\t-moz-border-radius 0.2s ease-in-out;\n\ttransition: background-color 0.2s linear, height 0.2s linear,\n\t\twidth 0.2s ease-in-out, border-radius 0.2s ease-in-out;\n\ttransition: background-color 0.2s linear, height 0.2s linear,\n\t\twidth 0.2s ease-in-out, border-radius 0.2s ease-in-out,\n\t\t-webkit-border-radius 0.2s ease-in-out, -moz-border-radius 0.2s ease-in-out;\n\tbottom: 2px;\n\t/* there must be 'bottom' for ps-scrollbar-x */\n\theight: 6px;\n}\n\n.ps-container > .ps-scrollbar-x-rail:hover > .ps-scrollbar-x,\n.ps-container > .ps-scrollbar-x-rail:active > .ps-scrollbar-x {\n\theight: 11px;\n}\n\n.ps-container > .ps-scrollbar-y-rail {\n\tdisplay: none;\n\tposition: absolute;\n\t/* please don't change 'position' */\n\topacity: 0;\n\t-webkit-transition: background-color 0.2s linear, opacity 0.2s linear;\n\t-o-transition: background-color 0.2s linear, opacity 0.2s linear;\n\t-moz-transition: background-color 0.2s linear, opacity 0.2s linear;\n\ttransition: background-color 0.2s linear, opacity 0.2s linear;\n\tright: 0;\n\t/* there must be 'right' for ps-scrollbar-y-rail */\n\twidth: 15px;\n}\n\n.ps-container > .ps-scrollbar-y-rail > .ps-scrollbar-y {\n\tposition: absolute;\n\t/* please don't change 'position' */\n\tbackground-color: #aaa;\n\t-webkit-border-radius: 6px;\n\t-moz-border-radius: 6px;\n\tborder-radius: 6px;\n\t-webkit-transition: background-color 0.2s linear, height 0.2s linear,\n\t\twidth 0.2s ease-in-out, -webkit-border-radius 0.2s ease-in-out;\n\ttransition: background-color 0.2s linear, height 0.2s linear,\n\t\twidth 0.2s ease-in-out, -webkit-border-radius 0.2s ease-in-out;\n\t-o-transition: background-color 0.2s linear, height 0.2s linear,\n\t\twidth 0.2s ease-in-out, border-radius 0.2s ease-in-out;\n\t-moz-transition: background-color 0.2s linear, height 0.2s linear,\n\t\twidth 0.2s ease-in-out, border-radius 0.2s ease-in-out,\n\t\t-moz-border-radius 0.2s ease-in-out;\n\ttransition: background-color 0.2s linear, height 0.2s linear,\n\t\twidth 0.2s ease-in-out, border-radius 0.2s ease-in-out;\n\ttransition: background-color 0.2s linear, height 0.2s linear,\n\t\twidth 0.2s ease-in-out, border-radius 0.2s ease-in-out,\n\t\t-webkit-border-radius 0.2s ease-in-out, -moz-border-radius 0.2s ease-in-out;\n\tright: 2px;\n\t/* there must be 'right' for ps-scrollbar-y */\n\twidth: 6px;\n}\n\n.ps-container > .ps-scrollbar-y-rail:hover > .ps-scrollbar-y,\n.ps-container > .ps-scrollbar-y-rail:active > .ps-scrollbar-y {\n\twidth: 11px;\n}\n\n.ps-container:hover.ps-in-scrolling.ps-x > .ps-scrollbar-x-rail {\n\tbackground-color: #eee;\n\topacity: 0.9;\n}\n\n.ps-container:hover.ps-in-scrolling.ps-x\n\t> .ps-scrollbar-x-rail\n\t> .ps-scrollbar-x {\n\tbackground-color: #999;\n\theight: 11px;\n}\n\n.ps-container:hover.ps-in-scrolling.ps-y > .ps-scrollbar-y-rail {\n\tbackground-color: #eee;\n\topacity: 0.9;\n}\n\n.ps-container:hover.ps-in-scrolling.ps-y\n\t> .ps-scrollbar-y-rail\n\t> .ps-scrollbar-y {\n\tbackground-color: #999;\n\twidth: 11px;\n}\n\n.ps-container:hover > .ps-scrollbar-x-rail,\n.ps-container:hover > .ps-scrollbar-y-rail {\n\topacity: 0.6;\n}\n\n.ps-container:hover > .ps-scrollbar-x-rail:hover {\n\tbackground-color: #eee;\n\topacity: 0.9;\n}\n\n.ps-container:hover > .ps-scrollbar-x-rail:hover > .ps-scrollbar-x {\n\tbackground-color: #999;\n}\n\n.ps-container:hover > .ps-scrollbar-y-rail:hover {\n\tbackground-color: #eee;\n\topacity: 0.9;\n}\n\n.ps-container:hover > .ps-scrollbar-y-rail:hover > .ps-scrollbar-y {\n\tbackground-color: #999;\n}\n\nbody.swal2-shown {\n\toverflow-y: hidden;\n}\n\nbody.swal2-iosfix {\n\tposition: fixed;\n\tleft: 0;\n\tright: 0;\n}\n\n.swal2-container {\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-align: center;\n\t-ms-flex-align: center;\n\talign-items: center;\n\tposition: fixed;\n\ttop: 0;\n\tleft: 0;\n\tbottom: 0;\n\tright: 0;\n\tpadding: 10px;\n\tbackground-color: transparent;\n\tz-index: 1060;\n}\n\n.swal2-container.swal2-fade {\n\t-webkit-transition: background-color 0.1s;\n\ttransition: background-color 0.1s;\n}\n\n.swal2-container.swal2-shown {\n\tbackground-color: rgba(0, 0, 0, 0.4);\n}\n\n.swal2-modal {\n\tbackground-color: #fff;\n\tfont-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n\tborder-radius: 5px;\n\t-webkit-box-sizing: border-box;\n\tbox-sizing: border-box;\n\ttext-align: center;\n\tmargin: auto;\n\tbox-shadow: 0 2px 2px rgba(204, 197, 185, 0.5);\n\toverflow-x: hidden;\n\toverflow-y: auto;\n\tdisplay: none;\n\tposition: relative;\n\tmax-width: 100%;\n}\n\n.swal2-modal:focus {\n\toutline: none;\n}\n\n.swal2-modal.swal2-loading {\n\toverflow-y: hidden;\n}\n\n.swal2-modal .swal2-title {\n\tcolor: #595959;\n\tfont-size: 30px;\n\ttext-align: center;\n\tfont-weight: 600;\n\ttext-transform: none;\n\tposition: relative;\n\tmargin: 0 0 0.4em;\n\tpadding: 0;\n\tdisplay: block;\n\tword-wrap: break-word;\n}\n\n.swal2-modal .swal2-buttonswrapper {\n\tmargin-top: 15px;\n}\n\n.swal2-modal .swal2-buttonswrapper:not(.swal2-loading) .swal2-styled[disabled] {\n\topacity: 0.4;\n\tcursor: no-drop;\n}\n\n.swal2-modal .swal2-buttonswrapper.swal2-loading .swal2-styled.swal2-confirm {\n\t-webkit-box-sizing: border-box;\n\tbox-sizing: border-box;\n\tborder: 4px solid transparent;\n\tborder-color: transparent;\n\twidth: 40px;\n\theight: 40px;\n\tpadding: 0;\n\tmargin: 7.5px;\n\tvertical-align: top;\n\tbackground-color: transparent !important;\n\tcolor: transparent;\n\tcursor: default;\n\tborder-radius: 100%;\n\t-webkit-animation: rotate-loading 1.5s linear 0s infinite normal;\n\tanimation: rotate-loading 1.5s linear 0s infinite normal;\n\t-webkit-user-select: none;\n\t-moz-user-select: none;\n\t-ms-user-select: none;\n\tuser-select: none;\n}\n\n.swal2-modal .swal2-buttonswrapper.swal2-loading .swal2-styled.swal2-cancel {\n\tmargin-left: 30px;\n\tmargin-right: 30px;\n}\n\n.swal2-modal\n\t.swal2-buttonswrapper.swal2-loading\n\t:not(.swal2-styled).swal2-confirm::after {\n\tdisplay: inline-block;\n\tcontent: \"\";\n\tmargin-left: 5px;\n\tvertical-align: -1px;\n\theight: 15px;\n\twidth: 15px;\n\tborder: 3px solid #999999;\n\t-webkit-box-shadow: 1px 1px 1px #fff;\n\tbox-shadow: 1px 1px 1px #fff;\n\tborder-right-color: transparent;\n\tborder-radius: 50%;\n\t-webkit-animation: rotate-loading 1.5s linear 0s infinite normal;\n\tanimation: rotate-loading 1.5s linear 0s infinite normal;\n}\n\n.swal2-modal .swal2-styled {\n\tborder: 0;\n\tborder-radius: 3px;\n\t-webkit-box-shadow: none;\n\tbox-shadow: none;\n\tcolor: #fff;\n\tcursor: pointer;\n\tfont-size: 17px;\n\tfont-weight: 500;\n\tmargin: 15px 5px 0;\n\tpadding: 10px 32px;\n}\n\n.swal2-modal .swal2-styled:focus {\n\toutline: none;\n\t-webkit-box-shadow: 0 0 0 2px #fff, 0 0 0 4px rgba(50, 100, 150, 0.4);\n\tbox-shadow: 0 0 0 2px #fff, 0 0 0 4px rgba(50, 100, 150, 0.4);\n}\n\n.swal2-modal .swal2-image {\n\tmargin: 20px auto;\n\tmax-width: 100%;\n}\n\n.swal2-modal .swal2-close {\n\tbackground: transparent;\n\tborder: 0;\n\tmargin: 0;\n\tpadding: 0;\n\twidth: 38px;\n\theight: 40px;\n\tfont-size: 36px;\n\tline-height: 40px;\n\tfont-family: serif;\n\tposition: absolute;\n\ttop: 5px;\n\tright: 8px;\n\tcursor: pointer;\n\tcolor: #cccccc;\n\t-webkit-transition: color 0.1s ease;\n\ttransition: color 0.1s ease;\n}\n\n.swal2-modal .swal2-close:hover {\n\tcolor: #d55;\n}\n\n.swal2-modal > .swal2-input,\n.swal2-modal > .swal2-file,\n.swal2-modal > .swal2-textarea,\n.swal2-modal > .swal2-select,\n.swal2-modal > .swal2-radio,\n.swal2-modal > .swal2-checkbox {\n\tdisplay: none;\n}\n\n.swal2-modal .swal2-content {\n\tfont-size: 18px;\n\ttext-align: center;\n\tfont-weight: 300;\n\tposition: relative;\n\tfloat: none;\n\tmargin: 0;\n\tpadding: 0;\n\tline-height: normal;\n\tcolor: #545454;\n\tword-wrap: break-word;\n}\n\n.swal2-modal .swal2-input,\n.swal2-modal .swal2-file,\n.swal2-modal .swal2-textarea,\n.swal2-modal .swal2-select,\n.swal2-modal .swal2-radio,\n.swal2-modal .swal2-checkbox {\n\tmargin: 20px auto;\n}\n\n.swal2-modal .swal2-input,\n.swal2-modal .swal2-file,\n.swal2-modal .swal2-textarea {\n\twidth: 100%;\n\t-webkit-box-sizing: border-box;\n\tbox-sizing: border-box;\n\tfont-size: 18px;\n\tborder-radius: 3px;\n\tborder: 1px solid #d9d9d9;\n\t-webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.06);\n\tbox-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.06);\n\t-webkit-transition: border-color 0.3s, -webkit-box-shadow 0.3s;\n\ttransition: border-color 0.3s, -webkit-box-shadow 0.3s;\n\ttransition: border-color 0.3s, box-shadow 0.3s;\n\ttransition: border-color 0.3s, box-shadow 0.3s, -webkit-box-shadow 0.3s;\n}\n\n.swal2-modal .swal2-input.swal2-inputerror,\n.swal2-modal .swal2-file.swal2-inputerror,\n.swal2-modal .swal2-textarea.swal2-inputerror {\n\tborder-color: #f27474 !important;\n\t-webkit-box-shadow: 0 0 2px #f27474 !important;\n\tbox-shadow: 0 0 2px #f27474 !important;\n}\n\n.swal2-modal .swal2-input:focus,\n.swal2-modal .swal2-file:focus,\n.swal2-modal .swal2-textarea:focus {\n\toutline: none;\n\tborder: 1px solid #b4dbed;\n\t-webkit-box-shadow: 0 0 3px #c4e6f5;\n\tbox-shadow: 0 0 3px #c4e6f5;\n}\n\n.swal2-modal .swal2-input::-webkit-input-placeholder,\n.swal2-modal .swal2-file::-webkit-input-placeholder,\n.swal2-modal .swal2-textarea::-webkit-input-placeholder {\n\tcolor: #cccccc;\n}\n\n.swal2-modal .swal2-input:-ms-input-placeholder,\n.swal2-modal .swal2-file:-ms-input-placeholder,\n.swal2-modal .swal2-textarea:-ms-input-placeholder {\n\tcolor: #cccccc;\n}\n\n.swal2-modal .swal2-input::placeholder,\n.swal2-modal .swal2-file::placeholder,\n.swal2-modal .swal2-textarea::placeholder {\n\tcolor: #cccccc;\n}\n\n.swal2-modal .swal2-range input {\n\tfloat: left;\n\twidth: 80%;\n}\n\n.swal2-modal .swal2-range output {\n\tfloat: right;\n\twidth: 20%;\n\tfont-size: 20px;\n\tfont-weight: 600;\n\ttext-align: center;\n}\n\n.swal2-modal .swal2-range input,\n.swal2-modal .swal2-range output {\n\theight: 43px;\n\tline-height: 43px;\n\tvertical-align: middle;\n\tmargin: 20px auto;\n\tpadding: 0;\n}\n\n.swal2-modal .swal2-input {\n\theight: 43px;\n\tpadding: 0 12px;\n}\n\n.swal2-modal .swal2-input[type=\"number\"] {\n\tmax-width: 150px;\n}\n\n.swal2-modal .swal2-file {\n\tfont-size: 20px;\n}\n\n.swal2-modal .swal2-textarea {\n\theight: 108px;\n\tpadding: 12px;\n}\n\n.swal2-modal .swal2-select {\n\tcolor: #545454;\n\tfont-size: inherit;\n\tpadding: 5px 10px;\n\tmin-width: 40%;\n\tmax-width: 100%;\n}\n\n.swal2-modal .swal2-radio {\n\tborder: 0;\n}\n\n.swal2-modal .swal2-radio label:not(:first-child) {\n\tmargin-left: 20px;\n}\n\n.swal2-modal .swal2-radio input,\n.swal2-modal .swal2-radio span {\n\tvertical-align: middle;\n}\n\n.swal2-modal .swal2-radio input {\n\tmargin: 0 3px 0 0;\n}\n\n.swal2-modal .swal2-checkbox {\n\tcolor: #545454;\n}\n\n.swal2-modal .swal2-checkbox input,\n.swal2-modal .swal2-checkbox span {\n\tvertical-align: middle;\n}\n\n.swal2-modal .swal2-validationerror {\n\tbackground-color: #f0f0f0;\n\tmargin: 0 -20px;\n\toverflow: hidden;\n\tpadding: 10px;\n\tcolor: gray;\n\tfont-size: 16px;\n\tfont-weight: 300;\n\tdisplay: none;\n}\n\n.swal2-modal .swal2-validationerror::before {\n\tcontent: \"!\";\n\tdisplay: inline-block;\n\twidth: 24px;\n\theight: 24px;\n\tborder-radius: 50%;\n\tbackground-color: #ea7d7d;\n\tcolor: #fff;\n\tline-height: 24px;\n\ttext-align: center;\n\tmargin-right: 10px;\n}\n\n@supports (-ms-accelerator: true) {\n\t.swal2-range input {\n\t\twidth: 100% !important;\n\t}\n\n\t.swal2-range output {\n\t\tdisplay: none;\n\t}\n}\n@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n\t.swal2-range input {\n\t\twidth: 100% !important;\n\t}\n\n\t.swal2-range output {\n\t\tdisplay: none;\n\t}\n}\n.swal2-icon {\n\twidth: 80px;\n\theight: 80px;\n\tborder: 4px solid transparent;\n\tborder-radius: 50%;\n\tmargin: 20px auto 30px;\n\tpadding: 0;\n\tposition: relative;\n\t-webkit-box-sizing: content-box;\n\tbox-sizing: content-box;\n\tcursor: default;\n\t-webkit-user-select: none;\n\t-moz-user-select: none;\n\t-ms-user-select: none;\n\tuser-select: none;\n}\n\n.swal2-icon.swal2-error {\n\tborder-color: rgba(255, 54, 54, 0.3);\n}\n\n.swal2-icon.swal2-error .swal2-x-mark {\n\tposition: relative;\n\tdisplay: block;\n}\n\n.swal2-icon.swal2-error [class^=\"swal2-x-mark-line\"] {\n\tposition: absolute;\n\theight: 5px;\n\twidth: 47px;\n\tbackground-color: #ff3636;\n\tdisplay: block;\n\ttop: 37px;\n\tborder-radius: 2px;\n}\n\n.swal2-icon.swal2-error [class^=\"swal2-x-mark-line\"][class$=\"left\"] {\n\t-webkit-transform: rotate(45deg);\n\ttransform: rotate(45deg);\n\tleft: 17px;\n}\n\n.swal2-icon.swal2-error [class^=\"swal2-x-mark-line\"][class$=\"right\"] {\n\t-webkit-transform: rotate(-45deg);\n\ttransform: rotate(-45deg);\n\tright: 16px;\n}\n\n.swal2-icon.swal2-warning {\n\tfont-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n\tcolor: #ffb236;\n\tborder-color: #ffb236;\n\tfont-size: 20px;\n\tline-height: 120px;\n\ttext-align: center;\n}\n\n.swal2-icon.swal2-info {\n\tfont-family: \"Open Sans\", sans-serif;\n\tcolor: #3fc3ee;\n\tborder-color: #9de0f6;\n\tfont-size: 60px;\n\tline-height: 80px;\n\ttext-align: center;\n}\n\n.swal2-icon.swal2-question {\n\tfont-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n\tcolor: #87adbd;\n\tborder-color: #c9dae1;\n\tfont-size: 60px;\n\tline-height: 80px;\n\ttext-align: center;\n}\n\n.swal2-icon.swal2-success {\n\tborder-color: #a5dc86;\n}\n\n.swal2-icon.swal2-success [class^=\"swal2-success-circular-line\"] {\n\tborder-radius: 50%;\n\tposition: absolute;\n\twidth: 60px;\n\theight: 120px;\n\t-webkit-transform: rotate(45deg);\n\ttransform: rotate(45deg);\n}\n\n.swal2-icon.swal2-success\n\t[class^=\"swal2-success-circular-line\"][class$=\"left\"] {\n\tborder-radius: 120px 0 0 120px;\n\ttop: -7px;\n\tleft: -33px;\n\t-webkit-transform: rotate(-45deg);\n\ttransform: rotate(-45deg);\n\t-webkit-transform-origin: 60px 60px;\n\ttransform-origin: 60px 60px;\n}\n\n.swal2-icon.swal2-success\n\t[class^=\"swal2-success-circular-line\"][class$=\"right\"] {\n\tborder-radius: 0 120px 120px 0;\n\ttop: -11px;\n\tleft: 30px;\n\t-webkit-transform: rotate(-45deg);\n\ttransform: rotate(-45deg);\n\t-webkit-transform-origin: 0 60px;\n\ttransform-origin: 0 60px;\n}\n\n.swal2-icon.swal2-success .swal2-success-ring {\n\twidth: 80px;\n\theight: 80px;\n\tborder: 4px solid rgba(24, 206, 15, 0.3);\n\tborder-radius: 50%;\n\t-webkit-box-sizing: content-box;\n\tbox-sizing: content-box;\n\tposition: absolute;\n\tleft: -4px;\n\ttop: -4px;\n\tz-index: 2;\n}\n\n.swal2-icon.swal2-success .swal2-success-fix {\n\twidth: 7px;\n\theight: 90px;\n\tposition: absolute;\n\tleft: 28px;\n\ttop: 8px;\n\tz-index: 1;\n\t-webkit-transform: rotate(-45deg);\n\ttransform: rotate(-45deg);\n}\n\n.swal2-icon.swal2-success [class^=\"swal2-success-line\"] {\n\theight: 5px;\n\tbackground-color: #18ce0f;\n\tdisplay: block;\n\tborder-radius: 2px;\n\tposition: absolute;\n\tz-index: 2;\n}\n\n.swal2-icon.swal2-success [class^=\"swal2-success-line\"][class$=\"tip\"] {\n\twidth: 25px;\n\tleft: 14px;\n\ttop: 46px;\n\t-webkit-transform: rotate(45deg);\n\ttransform: rotate(45deg);\n}\n\n.swal2-icon.swal2-success [class^=\"swal2-success-line\"][class$=\"long\"] {\n\twidth: 47px;\n\tright: 8px;\n\ttop: 38px;\n\t-webkit-transform: rotate(-45deg);\n\ttransform: rotate(-45deg);\n}\n\n.swal2-progresssteps {\n\tfont-weight: 600;\n\tmargin: 0 0 20px;\n\tpadding: 0;\n}\n\n.swal2-progresssteps li {\n\tdisplay: inline-block;\n\tposition: relative;\n}\n\n.swal2-progresssteps .swal2-progresscircle {\n\tbackground: #3085d6;\n\tborder-radius: 2em;\n\tcolor: #fff;\n\theight: 2em;\n\tline-height: 2em;\n\ttext-align: center;\n\twidth: 2em;\n\tz-index: 20;\n}\n\n.swal2-progresssteps .swal2-progresscircle:first-child {\n\tmargin-left: 0;\n}\n\n.swal2-progresssteps .swal2-progresscircle:last-child {\n\tmargin-right: 0;\n}\n\n.swal2-progresssteps .swal2-progresscircle.swal2-activeprogressstep {\n\tbackground: #3085d6;\n}\n\n.swal2-progresssteps\n\t.swal2-progresscircle.swal2-activeprogressstep\n\t~ .swal2-progresscircle {\n\tbackground: #add8e6;\n}\n\n.swal2-progresssteps\n\t.swal2-progresscircle.swal2-activeprogressstep\n\t~ .swal2-progressline {\n\tbackground: #add8e6;\n}\n\n.swal2-progresssteps .swal2-progressline {\n\tbackground: #3085d6;\n\theight: 0.4em;\n\tmargin: 0 -1px;\n\tz-index: 10;\n}\n\n[class^=\"swal2\"] {\n\t-webkit-tap-highlight-color: transparent;\n}\n\n@-webkit-keyframes showSweetAlert {\n\t0% {\n\t\t-webkit-transform: scale(0.7);\n\t\ttransform: scale(0.7);\n\t}\n\t45% {\n\t\t-webkit-transform: scale(1.05);\n\t\ttransform: scale(1.05);\n\t}\n\t80% {\n\t\t-webkit-transform: scale(0.95);\n\t\ttransform: scale(0.95);\n\t}\n\t100% {\n\t\t-webkit-transform: scale(1);\n\t\ttransform: scale(1);\n\t}\n}\n@keyframes showSweetAlert {\n\t0% {\n\t\t-webkit-transform: scale(0.7);\n\t\ttransform: scale(0.7);\n\t}\n\t45% {\n\t\t-webkit-transform: scale(1.05);\n\t\ttransform: scale(1.05);\n\t}\n\t80% {\n\t\t-webkit-transform: scale(0.95);\n\t\ttransform: scale(0.95);\n\t}\n\t100% {\n\t\t-webkit-transform: scale(1);\n\t\ttransform: scale(1);\n\t}\n}\n@-webkit-keyframes hideSweetAlert {\n\t0% {\n\t\t-webkit-transform: scale(1);\n\t\ttransform: scale(1);\n\t\topacity: 1;\n\t}\n\t100% {\n\t\t-webkit-transform: scale(0.5);\n\t\ttransform: scale(0.5);\n\t\topacity: 0;\n\t}\n}\n@keyframes hideSweetAlert {\n\t0% {\n\t\t-webkit-transform: scale(1);\n\t\ttransform: scale(1);\n\t\topacity: 1;\n\t}\n\t100% {\n\t\t-webkit-transform: scale(0.5);\n\t\ttransform: scale(0.5);\n\t\topacity: 0;\n\t}\n}\n.swal2-show {\n\t-webkit-animation: showSweetAlert 0.3s;\n\tanimation: showSweetAlert 0.3s;\n}\n\n.swal2-show.swal2-noanimation {\n\t-webkit-animation: none;\n\tanimation: none;\n}\n\n.swal2-hide {\n\t-webkit-animation: hideSweetAlert 0.15s forwards;\n\tanimation: hideSweetAlert 0.15s forwards;\n}\n\n.swal2-hide.swal2-noanimation {\n\t-webkit-animation: none;\n\tanimation: none;\n}\n\n@-webkit-keyframes animate-success-tip {\n\t0% {\n\t\twidth: 0;\n\t\tleft: 1px;\n\t\ttop: 19px;\n\t}\n\t54% {\n\t\twidth: 0;\n\t\tleft: 1px;\n\t\ttop: 19px;\n\t}\n\t70% {\n\t\twidth: 50px;\n\t\tleft: -8px;\n\t\ttop: 37px;\n\t}\n\t84% {\n\t\twidth: 17px;\n\t\tleft: 21px;\n\t\ttop: 48px;\n\t}\n\t100% {\n\t\twidth: 25px;\n\t\tleft: 14px;\n\t\ttop: 45px;\n\t}\n}\n@keyframes animate-success-tip {\n\t0% {\n\t\twidth: 0;\n\t\tleft: 1px;\n\t\ttop: 19px;\n\t}\n\t54% {\n\t\twidth: 0;\n\t\tleft: 1px;\n\t\ttop: 19px;\n\t}\n\t70% {\n\t\twidth: 50px;\n\t\tleft: -8px;\n\t\ttop: 37px;\n\t}\n\t84% {\n\t\twidth: 17px;\n\t\tleft: 21px;\n\t\ttop: 48px;\n\t}\n\t100% {\n\t\twidth: 25px;\n\t\tleft: 14px;\n\t\ttop: 45px;\n\t}\n}\n@-webkit-keyframes animate-success-long {\n\t0% {\n\t\twidth: 0;\n\t\tright: 46px;\n\t\ttop: 54px;\n\t}\n\t65% {\n\t\twidth: 0;\n\t\tright: 46px;\n\t\ttop: 54px;\n\t}\n\t84% {\n\t\twidth: 55px;\n\t\tright: 0;\n\t\ttop: 35px;\n\t}\n\t100% {\n\t\twidth: 47px;\n\t\tright: 8px;\n\t\ttop: 38px;\n\t}\n}\n@keyframes animate-success-long {\n\t0% {\n\t\twidth: 0;\n\t\tright: 46px;\n\t\ttop: 54px;\n\t}\n\t65% {\n\t\twidth: 0;\n\t\tright: 46px;\n\t\ttop: 54px;\n\t}\n\t84% {\n\t\twidth: 55px;\n\t\tright: 0;\n\t\ttop: 35px;\n\t}\n\t100% {\n\t\twidth: 47px;\n\t\tright: 8px;\n\t\ttop: 38px;\n\t}\n}\n@-webkit-keyframes rotatePlaceholder {\n\t0% {\n\t\t-webkit-transform: rotate(-45deg);\n\t\ttransform: rotate(-45deg);\n\t}\n\t5% {\n\t\t-webkit-transform: rotate(-45deg);\n\t\ttransform: rotate(-45deg);\n\t}\n\t12% {\n\t\t-webkit-transform: rotate(-405deg);\n\t\ttransform: rotate(-405deg);\n\t}\n\t100% {\n\t\t-webkit-transform: rotate(-405deg);\n\t\ttransform: rotate(-405deg);\n\t}\n}\n@keyframes rotatePlaceholder {\n\t0% {\n\t\t-webkit-transform: rotate(-45deg);\n\t\ttransform: rotate(-45deg);\n\t}\n\t5% {\n\t\t-webkit-transform: rotate(-45deg);\n\t\ttransform: rotate(-45deg);\n\t}\n\t12% {\n\t\t-webkit-transform: rotate(-405deg);\n\t\ttransform: rotate(-405deg);\n\t}\n\t100% {\n\t\t-webkit-transform: rotate(-405deg);\n\t\ttransform: rotate(-405deg);\n\t}\n}\n.swal2-animate-success-line-tip {\n\t-webkit-animation: animate-success-tip 0.75s;\n\tanimation: animate-success-tip 0.75s;\n}\n\n.swal2-animate-success-line-long {\n\t-webkit-animation: animate-success-long 0.75s;\n\tanimation: animate-success-long 0.75s;\n}\n\n.swal2-success.swal2-animate-success-icon .swal2-success-circular-line-right {\n\t-webkit-animation: rotatePlaceholder 4.25s ease-in;\n\tanimation: rotatePlaceholder 4.25s ease-in;\n}\n\n@-webkit-keyframes animate-error-icon {\n\t0% {\n\t\t-webkit-transform: rotateX(100deg);\n\t\ttransform: rotateX(100deg);\n\t\topacity: 0;\n\t}\n\t100% {\n\t\t-webkit-transform: rotateX(0deg);\n\t\ttransform: rotateX(0deg);\n\t\topacity: 1;\n\t}\n}\n@keyframes animate-error-icon {\n\t0% {\n\t\t-webkit-transform: rotateX(100deg);\n\t\ttransform: rotateX(100deg);\n\t\topacity: 0;\n\t}\n\t100% {\n\t\t-webkit-transform: rotateX(0deg);\n\t\ttransform: rotateX(0deg);\n\t\topacity: 1;\n\t}\n}\n.swal2-animate-error-icon {\n\t-webkit-animation: animate-error-icon 0.5s;\n\tanimation: animate-error-icon 0.5s;\n}\n\n@-webkit-keyframes animate-x-mark {\n\t0% {\n\t\t-webkit-transform: scale(0.4);\n\t\ttransform: scale(0.4);\n\t\tmargin-top: 26px;\n\t\topacity: 0;\n\t}\n\t50% {\n\t\t-webkit-transform: scale(0.4);\n\t\ttransform: scale(0.4);\n\t\tmargin-top: 26px;\n\t\topacity: 0;\n\t}\n\t80% {\n\t\t-webkit-transform: scale(1.15);\n\t\ttransform: scale(1.15);\n\t\tmargin-top: -6px;\n\t}\n\t100% {\n\t\t-webkit-transform: scale(1);\n\t\ttransform: scale(1);\n\t\tmargin-top: 0;\n\t\topacity: 1;\n\t}\n}\n@keyframes animate-x-mark {\n\t0% {\n\t\t-webkit-transform: scale(0.4);\n\t\ttransform: scale(0.4);\n\t\tmargin-top: 26px;\n\t\topacity: 0;\n\t}\n\t50% {\n\t\t-webkit-transform: scale(0.4);\n\t\ttransform: scale(0.4);\n\t\tmargin-top: 26px;\n\t\topacity: 0;\n\t}\n\t80% {\n\t\t-webkit-transform: scale(1.15);\n\t\ttransform: scale(1.15);\n\t\tmargin-top: -6px;\n\t}\n\t100% {\n\t\t-webkit-transform: scale(1);\n\t\ttransform: scale(1);\n\t\tmargin-top: 0;\n\t\topacity: 1;\n\t}\n}\n.swal2-animate-x-mark {\n\t-webkit-animation: animate-x-mark 0.5s;\n\tanimation: animate-x-mark 0.5s;\n}\n\n@-webkit-keyframes rotate-loading {\n\t0% {\n\t\t-webkit-transform: rotate(0deg);\n\t\ttransform: rotate(0deg);\n\t}\n\t100% {\n\t\t-webkit-transform: rotate(360deg);\n\t\ttransform: rotate(360deg);\n\t}\n}\n@keyframes rotate-loading {\n\t0% {\n\t\t-webkit-transform: rotate(0deg);\n\t\ttransform: rotate(0deg);\n\t}\n\t100% {\n\t\t-webkit-transform: rotate(360deg);\n\t\ttransform: rotate(360deg);\n\t}\n}\n.card-wizard {\n\tmin-height: 410px;\n\tbox-shadow: 0 2px 2px rgba(204, 197, 185, 0.5);\n\topacity: 0;\n\t-webkit-transition: all 300ms linear;\n\t-moz-transition: all 300ms linear;\n\t-o-transition: all 300ms linear;\n\t-ms-transition: all 300ms linear;\n\ttransition: all 300ms linear;\n}\n.card-wizard.active {\n\topacity: 1;\n}\n.card-wizard .card-header {\n\tpadding: 15px 0 !important;\n\tpadding-bottom: 40px;\n}\n.card-wizard .nav-pills .nav-item .nav-link {\n\tpadding: 12px;\n}\n.card-wizard .nav-pills .nav-item .nav-link,\n.card-wizard .nav-pills .nav-item .nav-link.active,\n.card-wizard .nav-pills .nav-item .nav-link:hover,\n.card-wizard .nav-pills .nav-item .nav-link:focus,\n.card-wizard .nav-pills .nav-item .nav-link.active:focus,\n.card-wizard .nav-pills .nav-item .nav-link.active:hover {\n\tbackground-color: transparent;\n\tbox-shadow: none;\n}\n.card-wizard .picture-container {\n\tposition: relative;\n\tcursor: pointer;\n\ttext-align: center;\n}\n.card-wizard .wizard-navigation {\n\tposition: relative;\n}\n.card-wizard .wizard-navigation .nav-link {\n\tdisplay: flex;\n\talign-items: center;\n\t-ms-flex-pack: center;\n\tjustify-content: center;\n}\n.card-wizard .wizard-navigation .nav-link i,\n.card-wizard .moving-tab i {\n\tdisplay: inline-block;\n\tfont-size: 19px;\n\tline-height: initial;\n\tmargin-right: 6px;\n\tpadding: 0;\n\tvertical-align: bottom;\n}\n.card-wizard .picture {\n\twidth: 106px;\n\theight: 106px;\n\tbackground-color: #999999;\n\tborder: 1px solid #e3e3e3;\n\tcolor: #ffffff;\n\tborder-radius: 50%;\n\tmargin: 5px auto;\n\toverflow: hidden;\n\ttransition: all 0.2s;\n\t-webkit-transition: all 0.2s;\n}\n.card-wizard .picture:hover {\n\tborder-color: #2ca8ff;\n}\n.card-wizard .moving-tab {\n\tposition: absolute;\n\ttext-align: center;\n\tpadding: 12px;\n\tfont-size: 12px;\n\ttext-transform: uppercase;\n\t-webkit-font-smoothing: subpixel-antialiased;\n\ttop: 0px;\n\tleft: 0px;\n\tbackground-color: #65adff;\n\tbox-shadow: 0 2px 2px rgba(204, 197, 185, 0.5);\n\tcolor: #ffffff !important;\n\tcursor: pointer;\n\tfont-weight: 500;\n}\n.card-wizard[data-color=\"primary\"] .moving-tab {\n\tcolor: #1c77c3;\n}\n.card-wizard[data-color=\"primary\"] .picture:hover {\n\tborder-color: #1c77c3;\n}\n.card-wizard[data-color=\"primary\"] .choice:hover .icon,\n.card-wizard[data-color=\"primary\"] .choice.active .icon {\n\tborder-color: #1c77c3;\n\tcolor: #1c77c3;\n}\n.card-wizard[data-color=\"primary\"]\n\t.checkbox\n\tinput[type=\"checkbox\"]:checked\n\t+ .checkbox-material\n\t.check {\n\tbackground-color: #1c77c3;\n}\n.card-wizard[data-color=\"primary\"] .radio input[type=\"radio\"]:checked ~ .check {\n\tbackground-color: #1c77c3;\n}\n.card-wizard[data-color=\"primary\"]\n\t.radio\n\tinput[type=\"radio\"]:checked\n\t~ .circle {\n\tborder-color: #1c77c3;\n}\n.card-wizard[data-color=\"white\"] .moving-tab {\n\tcolor: #ffffff;\n}\n.card-wizard[data-color=\"white\"] .picture:hover {\n\tborder-color: #ffffff;\n}\n.card-wizard[data-color=\"white\"] .choice:hover .icon,\n.card-wizard[data-color=\"white\"] .choice.active .icon {\n\tborder-color: #ffffff;\n\tcolor: #ffffff;\n}\n.card-wizard[data-color=\"white\"]\n\t.checkbox\n\tinput[type=\"checkbox\"]:checked\n\t+ .checkbox-material\n\t.check {\n\tbackground-color: #ffffff;\n}\n.card-wizard[data-color=\"white\"] .radio input[type=\"radio\"]:checked ~ .check {\n\tbackground-color: #ffffff;\n}\n.card-wizard[data-color=\"white\"] .radio input[type=\"radio\"]:checked ~ .circle {\n\tborder-color: #ffffff;\n}\n.card-wizard[data-color=\"green\"] .moving-tab {\n\tcolor: #28a745;\n}\n.card-wizard[data-color=\"green\"] .picture:hover {\n\tborder-color: #28a745;\n}\n.card-wizard[data-color=\"green\"] .choice:hover .icon,\n.card-wizard[data-color=\"green\"] .choice.active .icon {\n\tborder-color: #28a745;\n\tcolor: #28a745;\n}\n.card-wizard[data-color=\"green\"]\n\t.checkbox\n\tinput[type=\"checkbox\"]:checked\n\t+ .checkbox-material\n\t.check {\n\tbackground-color: #28a745;\n}\n.card-wizard[data-color=\"green\"] .radio input[type=\"radio\"]:checked ~ .check {\n\tbackground-color: #28a745;\n}\n.card-wizard[data-color=\"green\"] .radio input[type=\"radio\"]:checked ~ .circle {\n\tborder-color: #28a745;\n}\n.card-wizard[data-color=\"blue\"] .moving-tab {\n\tcolor: #39a9db;\n}\n.card-wizard[data-color=\"blue\"] .picture:hover {\n\tborder-color: #39a9db;\n}\n.card-wizard[data-color=\"blue\"] .choice:hover .icon,\n.card-wizard[data-color=\"blue\"] .choice.active .icon {\n\tborder-color: #39a9db;\n\tcolor: #39a9db;\n}\n.card-wizard[data-color=\"blue\"]\n\t.checkbox\n\tinput[type=\"checkbox\"]:checked\n\t+ .checkbox-material\n\t.check {\n\tbackground-color: #39a9db;\n}\n.card-wizard[data-color=\"blue\"] .radio input[type=\"radio\"]:checked ~ .check {\n\tbackground-color: #39a9db;\n}\n.card-wizard[data-color=\"blue\"] .radio input[type=\"radio\"]:checked ~ .circle {\n\tborder-color: #39a9db;\n}\n.card-wizard[data-color=\"orange\"] .moving-tab {\n\tcolor: #ffc759;\n}\n.card-wizard[data-color=\"orange\"] .picture:hover {\n\tborder-color: #ffc759;\n}\n.card-wizard[data-color=\"orange\"] .choice:hover .icon,\n.card-wizard[data-color=\"orange\"] .choice.active .icon {\n\tborder-color: #ffc759;\n\tcolor: #ffc759;\n}\n.card-wizard[data-color=\"orange\"]\n\t.checkbox\n\tinput[type=\"checkbox\"]:checked\n\t+ .checkbox-material\n\t.check {\n\tbackground-color: #ffc759;\n}\n.card-wizard[data-color=\"orange\"] .radio input[type=\"radio\"]:checked ~ .check {\n\tbackground-color: #ffc759;\n}\n.card-wizard[data-color=\"orange\"] .radio input[type=\"radio\"]:checked ~ .circle {\n\tborder-color: #ffc759;\n}\n.card-wizard[data-color=\"red\"] .moving-tab {\n\tcolor: #c1292e;\n}\n.card-wizard[data-color=\"red\"] .picture:hover {\n\tborder-color: #c1292e;\n}\n.card-wizard[data-color=\"red\"] .choice:hover .icon,\n.card-wizard[data-color=\"red\"] .choice.active .icon {\n\tborder-color: #c1292e;\n\tcolor: #c1292e;\n}\n.card-wizard[data-color=\"red\"]\n\t.checkbox\n\tinput[type=\"checkbox\"]:checked\n\t+ .checkbox-material\n\t.check {\n\tbackground-color: #c1292e;\n}\n.card-wizard[data-color=\"red\"] .radio input[type=\"radio\"]:checked ~ .check {\n\tbackground-color: #c1292e;\n}\n.card-wizard[data-color=\"red\"] .radio input[type=\"radio\"]:checked ~ .circle {\n\tborder-color: #c1292e;\n}\n.card-wizard .picture input[type=\"file\"] {\n\tcursor: pointer;\n\tdisplay: block;\n\theight: 100%;\n\tleft: 0;\n\topacity: 0 !important;\n\tposition: absolute;\n\ttop: 0;\n\twidth: 100%;\n}\n.card-wizard .picture-src {\n\twidth: 100%;\n}\n.card-wizard .tab-content {\n\tmin-height: 355px;\n\tpadding: 20px 0;\n}\n.card-wizard .wizard-footer {\n\tpadding: 0 15px;\n}\n.card-wizard .wizard-footer .checkbox {\n\tmargin-top: 16px;\n}\n.card-wizard .disabled {\n\tdisplay: none;\n}\n.card-wizard .wizard-header {\n\ttext-align: center;\n\tpadding: 25px 0 35px;\n}\n.card-wizard .wizard-header h5 {\n\tmargin: 5px 0 0;\n}\n.card-wizard .nav-pills > li {\n\ttext-align: center;\n}\n.card-wizard .btn {\n\ttext-transform: uppercase;\n}\n.card-wizard .info-text {\n\ttext-align: center;\n\tfont-weight: 300;\n\tmargin: 10px 0 30px;\n}\n.card-wizard .choice {\n\ttext-align: center;\n\tcursor: pointer;\n\tmargin-top: 20px;\n}\n.card-wizard .choice[disabled] {\n\tpointer-events: none;\n\tcursor: not-allowed;\n\topacity: 0.5;\n}\n.card-wizard .choice .icon {\n\ttext-align: center;\n\tvertical-align: middle;\n\theight: 116px;\n\twidth: 116px;\n\tborder-radius: 50%;\n\tcolor: #65adff;\n\tmargin: 0 auto 20px;\n\tborder: 1px solid #e3e3e3;\n\ttransition: all 0.2s;\n\t-webkit-transition: all 0.2s;\n}\n.card-wizard .choice i {\n\tfont-size: 30px;\n\tline-height: 116px;\n\tposition: absolute;\n\tleft: 0;\n\tright: 0;\n}\n.card-wizard .choice:hover .icon,\n.card-wizard .choice.active .icon {\n\tborder-color: #2ca8ff;\n}\n.card-wizard .choice input[type=\"radio\"],\n.card-wizard .choice input[type=\"checkbox\"] {\n\tposition: absolute;\n\tleft: -10000px;\n\tz-index: -1;\n}\n.card-wizard .btn-finish {\n\tdisplay: none;\n}\n.card-wizard .card-title + .description {\n\tfont-size: 17px;\n\tmargin-bottom: 32px;\n}\n.card-wizard .wizard-title {\n\tmargin: 0;\n}\n.card-wizard .nav-pills {\n\tbackground-color: #292929 !important;\n}\n.card-wizard .nav-pills > li + li {\n\tmargin-left: 0;\n}\n.card-wizard .nav-pills > li > a {\n\tborder: 0 !important;\n\tborder-radius: 0;\n\tline-height: 18px;\n\ttext-transform: uppercase;\n\tfont-size: 12px;\n\tfont-weight: 500;\n\tmin-width: 100px;\n\ttext-align: center;\n\tcolor: #ffffff !important;\n}\n.card-wizard .nav-pills > li.active > a,\n.card-wizard .nav-pills > li.active > a:hover,\n.card-wizard .nav-pills > li.active > a:focus,\n.card-wizard .nav-pills > li > a:hover,\n.card-wizard .nav-pills > li > a:focus {\n\tbackground-color: inherit;\n\tbox-shadow: none;\n}\n.card-wizard .nav-pills > li i {\n\tdisplay: block;\n\tfont-size: 30px;\n\tpadding: 15px 0;\n}\n.card-wizard .form-group.select-wizard {\n\tmargin-top: 15px;\n}\n.card-wizard .dropdown.show .dropdown-menu,\n.card-wizard .dropup.show .dropdown-menu {\n\t-webkit-transform: translate3d(0, 0px, 0) !important;\n\t-moz-transform: translate3d(0, 0px, 0) !important;\n\t-o-transform: translate3d(0, 0px, 0) !important;\n\t-ms-transform: translate3d(0, 0px, 0) !important;\n\ttransform: translate3d(0, 0px, 0) !important;\n}\n\n/*!\n * Datetimepicker for Bootstrap 3\n * ! version : 4.7.14\n * https://github.com/Eonasdan/bootstrap-datetimepicker/\n */\n.sr-only,\n.bootstrap-datetimepicker-widget .btn[data-action=\"incrementHours\"]::after,\n.bootstrap-datetimepicker-widget .btn[data-action=\"incrementMinutes\"]::after,\n.bootstrap-datetimepicker-widget .btn[data-action=\"decrementHours\"]::after,\n.bootstrap-datetimepicker-widget .btn[data-action=\"decrementMinutes\"]::after,\n.bootstrap-datetimepicker-widget .btn[data-action=\"showHours\"]::after,\n.bootstrap-datetimepicker-widget .btn[data-action=\"showMinutes\"]::after,\n.bootstrap-datetimepicker-widget .btn[data-action=\"togglePeriod\"]::after,\n.bootstrap-datetimepicker-widget .btn[data-action=\"clear\"]::after,\n.bootstrap-datetimepicker-widget .btn[data-action=\"today\"]::after,\n.bootstrap-datetimepicker-widget .picker-switch::after,\n.bootstrap-datetimepicker-widget table th.prev::after,\n.bootstrap-datetimepicker-widget table th.next::after {\n\tposition: absolute;\n\twidth: 1px;\n\theight: 1px;\n\tmargin: -1px;\n\tpadding: 0;\n\toverflow: hidden;\n\tclip: rect(0, 0, 0, 0);\n\tborder: 0;\n}\n\n.bootstrap-datetimepicker-widget {\n\tlist-style: none;\n}\n\n.bootstrap-datetimepicker-widget a .btn:hover {\n\tbackground-color: transparent;\n}\n\n.bootstrap-datetimepicker-widget.dropdown-menu {\n\tpadding: 4px;\n\twidth: 16em;\n}\n\n@media (min-width: 768px) {\n\t.bootstrap-datetimepicker-widget.dropdown-menu.timepicker-sbs {\n\t\twidth: 38em;\n\t}\n}\n@media (min-width: 992px) {\n\t.bootstrap-datetimepicker-widget.dropdown-menu.timepicker-sbs {\n\t\twidth: 38em;\n\t}\n}\n@media (min-width: 1200px) {\n\t.bootstrap-datetimepicker-widget.dropdown-menu.timepicker-sbs {\n\t\twidth: 38em;\n\t}\n}\n.bootstrap-datetimepicker-widget.dropdown-menu.bottom:before {\n\tborder-bottom: 11px solid #f1eae0;\n\tborder-left: 11px solid transparent;\n\tborder-right: 11px solid transparent;\n\tcontent: \"\";\n\tdisplay: inline-block;\n\tposition: absolute;\n\tright: 12px;\n\tleft: auto;\n\ttop: -12px;\n}\n\n.bootstrap-datetimepicker-widget.dropdown-menu.bottom:after {\n\tborder-bottom: 11px solid #ffffff;\n\tborder-left: 11px solid transparent;\n\tborder-right: 11px solid transparent;\n\tcontent: \"\";\n\tdisplay: inline-block;\n\tposition: absolute;\n\tright: 12px;\n\tleft: auto;\n\ttop: -11px;\n}\n\n.bootstrap-datetimepicker-widget.dropdown-menu.top {\n\tmargin-top: auto;\n\tmargin-bottom: -20px;\n}\n\n.bootstrap-datetimepicker-widget.dropdown-menu.top.open {\n\tmargin-top: auto;\n\tmargin-bottom: 5px;\n}\n\n.bootstrap-datetimepicker-widget.dropdown-menu.pull-right:before {\n\tleft: auto;\n\tright: 6px;\n}\n\n.bootstrap-datetimepicker-widget.dropdown-menu.pull-right:after {\n\tleft: auto;\n\tright: 7px;\n}\n\n.bootstrap-datetimepicker-widget .list-unstyled {\n\tmargin: 0;\n}\n\n.bootstrap-datetimepicker-widget a[data-action] {\n\tpadding: 6px 0;\n\tborder-width: 0;\n\tcolor: #66615b;\n\tbackground-color: transparent;\n}\n\n.bootstrap-datetimepicker-widget a[data-action=\"togglePicker\"],\n.bootstrap-datetimepicker-widget a[data-action=\"togglePicker\"]:hover {\n\tcolor: #429cb6 !important;\n}\n\n.bootstrap-datetimepicker-widget a[data-action]:hover {\n\tbackground-color: transparent;\n\tcolor: rgba(255, 255, 255, 0.85);\n}\n\n.bootstrap-datetimepicker-widget a[data-action]:active {\n\tbox-shadow: none;\n}\n\n.bootstrap-datetimepicker-widget .timepicker-hour,\n.bootstrap-datetimepicker-widget .timepicker-minute,\n.bootstrap-datetimepicker-widget .timepicker-second {\n\twidth: 40px;\n\theight: 40px;\n\tline-height: 40px;\n\tfont-weight: 300;\n\tfont-size: 1.5em;\n\tmargin: 3px;\n\tborder-radius: 50%;\n}\n\n.bootstrap-datetimepicker-widget button[data-action] {\n\twidth: 38px;\n\theight: 38px;\n\tpadding: 0;\n}\n\n.bootstrap-datetimepicker-widget .btn[data-action=\"incrementHours\"]::after {\n\tcontent: \"Increment Hours\";\n}\n\n.bootstrap-datetimepicker-widget .btn[data-action=\"incrementMinutes\"]::after {\n\tcontent: \"Increment Minutes\";\n}\n\n.bootstrap-datetimepicker-widget .btn[data-action=\"decrementHours\"]::after {\n\tcontent: \"Decrement Hours\";\n}\n\n.bootstrap-datetimepicker-widget .btn[data-action=\"decrementMinutes\"]::after {\n\tcontent: \"Decrement Minutes\";\n}\n\n.bootstrap-datetimepicker-widget .btn[data-action=\"showHours\"]::after {\n\tcontent: \"Show Hours\";\n}\n\n.bootstrap-datetimepicker-widget .btn[data-action=\"showMinutes\"]::after {\n\tcontent: \"Show Minutes\";\n}\n\n.bootstrap-datetimepicker-widget .btn[data-action=\"togglePeriod\"]::after {\n\tcontent: \"Toggle AM/PM\";\n}\n\n.bootstrap-datetimepicker-widget .btn[data-action=\"clear\"]::after {\n\tcontent: \"Clear the picker\";\n}\n\n.bootstrap-datetimepicker-widget .btn[data-action=\"today\"]::after {\n\tcontent: \"Set the date to today\";\n}\n\n.bootstrap-datetimepicker-widget .picker-switch {\n\ttext-align: center;\n\tborder-radius: 4px;\n}\n\n.bootstrap-datetimepicker-widget .picker-switch::after {\n\tcontent: \"Toggle Date and Time Screens\";\n}\n\n.bootstrap-datetimepicker-widget .picker-switch td {\n\tpadding: 0;\n\tmargin: 0;\n\theight: auto;\n\twidth: auto;\n\tline-height: inherit;\n}\n\n.bootstrap-datetimepicker-widget .picker-switch td span {\n\tline-height: 2.5;\n\theight: 2.5em;\n\twidth: 100%;\n\tborder-radius: 4px;\n\tmargin: 2px 0px !important;\n}\n\n.bootstrap-datetimepicker-widget table {\n\twidth: 100%;\n\tmargin: 0;\n}\n\n.bootstrap-datetimepicker-widget table td > div,\n.bootstrap-datetimepicker-widget table th > div {\n\ttext-align: center;\n}\n\n.bootstrap-datetimepicker-widget table th {\n\theight: 20px;\n\tline-height: 20px;\n\twidth: 20px;\n}\n\n.bootstrap-datetimepicker-widget table th.picker-switch {\n\twidth: 145px;\n}\n\n.bootstrap-datetimepicker-widget table th.disabled,\n.bootstrap-datetimepicker-widget table th.disabled:hover {\n\tbackground: none;\n\tcolor: #cfcfca;\n\tcursor: not-allowed;\n}\n\n.bootstrap-datetimepicker-widget table th.prev span,\n.bootstrap-datetimepicker-widget table th.next span {\n\tborder-radius: 4px;\n\theight: 27px;\n\twidth: 27px;\n\tline-height: 28px;\n\tfont-size: 12px;\n\tborder-radius: 50%;\n\ttext-align: center;\n}\n\n.bootstrap-datetimepicker-widget table th.prev::after {\n\tcontent: \"Previous Month\";\n}\n\n.bootstrap-datetimepicker-widget table th.next::after {\n\tcontent: \"Next Month\";\n}\n\n.bootstrap-datetimepicker-widget table th.dow {\n\ttext-align: center;\n\tborder-bottom: 1px solid #e3e3e3;\n\tfont-size: 12px;\n\ttext-transform: uppercase;\n\tcolor: #292929 !important;\n\tfont-weight: 400;\n\tpadding-bottom: 5px;\n\tpadding-top: 10px;\n}\n\n.bootstrap-datetimepicker-widget table thead tr:first-child th {\n\tcursor: pointer;\n}\n\n.bootstrap-datetimepicker-widget table thead tr:first-child th:hover span,\n.bootstrap-datetimepicker-widget\n\ttable\n\tthead\n\ttr:first-child\n\tth.picker-switch:hover {\n\tbackground: #e3e3e3;\n}\n\n.bootstrap-datetimepicker-widget table td > div {\n\tborder-radius: 4px;\n\theight: 54px;\n\tline-height: 54px;\n\twidth: 54px;\n\ttext-align: center;\n}\n\n.bootstrap-datetimepicker-widget table td.cw > div {\n\tfont-size: 0.8em;\n\theight: 20px;\n\tline-height: 20px;\n\tcolor: #cfcfca;\n}\n\n.bootstrap-datetimepicker-widget table td.day > div {\n\theight: 30px;\n\tline-height: 31px;\n\twidth: 30px;\n\ttext-align: center;\n\tpadding: 0px;\n\tborder-radius: 50%;\n\tmargin: 0 auto;\n\tz-index: -1;\n\tposition: relative;\n}\n\n.table-condensed .day:hover div {\n\t-webkit-transition: all 150ms linear;\n\t-moz-transition: all 150ms linear;\n\t-o-transition: all 150ms linear;\n\t-ms-transition: all 150ms linear;\n\ttransition: all 150ms linear;\n}\n\n.bootstrap-datetimepicker-widget table td.minute > div,\n.bootstrap-datetimepicker-widget table td.hour > div {\n\tborder-radius: 50%;\n}\n\n.bootstrap-datetimepicker-widget table td.day:hover > div,\n.bootstrap-datetimepicker-widget table td.hour:hover > div,\n.bootstrap-datetimepicker-widget table td.minute:hover > div,\n.bootstrap-datetimepicker-widget table td.second:hover > div {\n\tbackground: #e3e3e3;\n\tcursor: pointer;\n}\n\n.bootstrap-datetimepicker-widget table td.old > div,\n.bootstrap-datetimepicker-widget table td.new > div {\n\tcolor: #cfcfca;\n}\n\n.bootstrap-datetimepicker-widget table td.today > div:before {\n\tcontent: \"\";\n\tdisplay: inline-block;\n\tborder: 0 0 7px 7px solid transparent;\n\tborder-bottom-color: #68b3c8;\n\tborder-top-color: rgba(0, 0, 0, 0.2);\n\tposition: absolute;\n\tbottom: 4px;\n\tright: 4px;\n}\n\n.bootstrap-datetimepicker-widget table td.active > div,\n.bootstrap-datetimepicker-widget table td.active:hover > div {\n\tbackground-color: #68b3c8;\n\tcolor: #ffffff;\n}\n\n.bootstrap-datetimepicker-widget table td.active.today:before > div {\n\tborder-bottom-color: #ffffff;\n}\n\n.bootstrap-datetimepicker-widget table td.disabled > div,\n.bootstrap-datetimepicker-widget table td.disabled:hover > div {\n\tbackground: none;\n\tcolor: #cfcfca;\n\tcursor: not-allowed;\n}\n\n.bootstrap-datetimepicker-widget table td span {\n\tdisplay: inline-block;\n\twidth: 40px;\n\theight: 40px;\n\tline-height: 40px;\n\tmargin: 3px 3px;\n\tcursor: pointer;\n\tborder-radius: 50%;\n\ttext-align: center;\n}\n\n.bootstrap-datetimepicker-widget table td span:hover {\n\tbackground: #e3e3e3;\n}\n\n.bootstrap-datetimepicker-widget table td span.active {\n\tbackground-color: #68b3c8;\n\tcolor: #ffffff;\n}\n\n.bootstrap-datetimepicker-widget table td span.old {\n\tcolor: #cfcfca;\n}\n\n.bootstrap-datetimepicker-widget table td span.disabled,\n.bootstrap-datetimepicker-widget table td span.disabled:hover {\n\tbackground: none;\n\tcolor: #cfcfca;\n\tcursor: not-allowed;\n}\n\n.bootstrap-datetimepicker-widget .timepicker-picker span,\n.bootstrap-datetimepicker-widget .timepicker-hours span,\n.bootstrap-datetimepicker-widget .timepicker-minutes span {\n\tborder-radius: 50% !important;\n}\n\n.bootstrap-datetimepicker-widget.usetwentyfour td.hour {\n\theight: 27px;\n\tline-height: 27px;\n}\n\n.input-group.date .input-group-addon {\n\tcursor: pointer;\n}\n\n.table-condensed > tbody > tr > td,\n.table-condensed > tbody > tr > th,\n.table-condensed > tfoot > tr > td,\n.table-condensed > tfoot > tr > th,\n.table-condensed > thead > tr > td,\n.table-condensed > thead > tr > th {\n\tpadding: 1px;\n\ttext-align: center;\n\tz-index: 1;\n\tcursor: pointer;\n}\n\n.bootstrap-datetimepicker-widget {\n\topacity: 0;\n\t-webkit-box-shadow: 0 2px rgba(17, 16, 15, 0.1),\n\t\t0 2px 10px rgba(17, 16, 15, 0.1);\n\tbox-shadow: 0 2px rgba(17, 16, 15, 0.1), 0 2px 10px rgba(17, 16, 15, 0.1);\n\t-webkit-transform: translate3d(0, -10px, 0) !important;\n\t-moz-transform: translate3d(0, -10px, 0) !important;\n\t-o-transform: translate3d(0, -10px, 0) !important;\n\t-ms-transform: translate3d(0, -10px, 0) !important;\n\ttransform: translate3d(0, -10px, 0) !important;\n}\n.bootstrap-datetimepicker-widget.top {\n\t-webkit-transform: translate3d(0, 10px, 0) !important;\n\t-moz-transform: translate3d(0, 10px, 0) !important;\n\t-o-transform: translate3d(0, 10px, 0) !important;\n\t-ms-transform: translate3d(0, 10px, 0) !important;\n\ttransform: translate3d(0, 10px, 0) !important;\n\topacity: 0;\n}\n.bootstrap-datetimepicker-widget.open {\n\topacity: 1;\n\ttransition: transform 0.5s cubic-bezier(0.215, 0.61, 0.355, 1) 0s;\n\t-webkit-transform: translate3d(0, 2px, 0) !important;\n\t-moz-transform: translate3d(0, 2px, 0) !important;\n\t-o-transform: translate3d(0, 2px, 0) !important;\n\t-ms-transform: translate3d(0, 2px, 0) !important;\n\ttransform: translate3d(0, 2px, 0) !important;\n}\n\n.bootstrap-datetimepicker-widget.top.open {\n\topacity: 1;\n\t-webkit-transform: translate3d(0, -7px, 0) !important;\n\t-moz-transform: translate3d(0, -7px, 0) !important;\n\t-o-transform: translate3d(0, -7px, 0) !important;\n\t-ms-transform: translate3d(0, -7px, 0) !important;\n\ttransform: translate3d(0, -7px, 0) !important;\n\ttransition: transform 0.5s cubic-bezier(0.215, 0.61, 0.355, 1) 0s;\n}\n.bootstrap-datetimepicker-widget.top.open:before {\n\tborder-top: 11px solid #dcd9d1;\n\tborder-left: 11px solid transparent;\n\tborder-right: 11px solid transparent;\n\tcontent: \"\";\n\tdisplay: inline-block;\n\tposition: absolute;\n\tright: 12px;\n\tbottom: -12px;\n}\n.bootstrap-datetimepicker-widget.top.open:after {\n\tborder-top: 11px solid #ffffff;\n\tborder-left: 11px solid transparent;\n\tborder-right: 11px solid transparent;\n\tcontent: \"\";\n\tdisplay: inline-block;\n\tposition: absolute;\n\tright: 12px;\n\tbottom: -11px;\n}\n\n/*!\n * Bootstrap-select v1.12.2 (http://silviomoreto.github.io/bootstrap-select)\n *\n * Copyright 2013-2017 bootstrap-select\n * Licensed under MIT (https://github.com/silviomoreto/bootstrap-select/blob/master/LICENSE)\n */\nselect.bs-select-hidden,\nselect.selectpicker {\n\tdisplay: none !important;\n}\n\n.bootstrap-select {\n\twidth: 220px;\n\t/*IE9 and below*/\n}\n.bootstrap-select > .dropdown-toggle {\n\twidth: 100%;\n\tpadding-right: 25px;\n\tz-index: 1;\n}\n.bootstrap-select > select {\n\tposition: absolute !important;\n\tbottom: 0;\n\tleft: 50%;\n\tdisplay: block !important;\n\twidth: 0.5px !important;\n\theight: 100% !important;\n\tpadding: 0 !important;\n\topacity: 0 !important;\n\tborder: none;\n}\n.bootstrap-select > select.mobile-device {\n\ttop: 0;\n\tleft: 0;\n\tdisplay: block !important;\n\twidth: 100% !important;\n\tz-index: 2;\n}\n.has-error .bootstrap-select .dropdown-toggle,\n.error .bootstrap-select .dropdown-toggle {\n\tborder-color: #b94a48;\n}\n.bootstrap-select.fit-width {\n\twidth: auto !important;\n}\n.bootstrap-select:not([class*=\"col-\"]):not([class*=\"form-control\"]):not(\n\t\t.input-group-btn\n\t) {\n\twidth: 150px;\n}\n\n.bootstrap-select.form-control {\n\tmargin-bottom: 0;\n\tpadding: 0;\n\tborder: none;\n}\n.bootstrap-select.form-control:not([class*=\"col-\"]) {\n\twidth: 100%;\n}\n.bootstrap-select.form-control.input-group-btn {\n\tz-index: auto;\n}\n.bootstrap-select.form-control.input-group-btn:not(:first-child):not(\n\t\t:last-child\n\t)\n\t> .btn {\n\tborder-radius: 0;\n}\n\n.bootstrap-select.btn-group:not(.input-group-btn),\n.bootstrap-select.btn-group[class*=\"col-\"] {\n\tfloat: none;\n\tdisplay: inline-block;\n\tmargin-left: 0;\n}\n.bootstrap-select.btn-group.dropdown-menu-right,\n.bootstrap-select.btn-group[class*=\"col-\"].dropdown-menu-right,\n.row .bootstrap-select.btn-group[class*=\"col-\"].dropdown-menu-right {\n\tfloat: right;\n}\n.form-inline .bootstrap-select.btn-group,\n.form-horizontal .bootstrap-select.btn-group,\n.form-group .bootstrap-select.btn-group {\n\tmargin-bottom: 0;\n}\n.form-group-lg .bootstrap-select.btn-group.form-control,\n.form-group-sm .bootstrap-select.btn-group.form-control {\n\tpadding: 0;\n}\n.form-group-lg .bootstrap-select.btn-group.form-control .dropdown-toggle,\n.form-group-sm .bootstrap-select.btn-group.form-control .dropdown-toggle {\n\theight: 100%;\n\tfont-size: inherit;\n\tline-height: inherit;\n\tborder-radius: inherit;\n}\n.form-inline .bootstrap-select.btn-group .form-control {\n\twidth: 100%;\n}\n.bootstrap-select.btn-group.disabled,\n.bootstrap-select.btn-group > .disabled {\n\tcursor: not-allowed;\n}\n.bootstrap-select.btn-group.disabled:focus,\n.bootstrap-select.btn-group > .disabled:focus {\n\toutline: none !important;\n}\n.bootstrap-select.btn-group.bs-container {\n\tposition: absolute;\n\theight: 0 !important;\n\tpadding: 0 !important;\n}\n.bootstrap-select.btn-group.bs-container .dropdown-menu {\n\tz-index: 1060;\n}\n.bootstrap-select.btn-group .dropdown-toggle .filter-option {\n\tdisplay: inline-block;\n\toverflow: hidden;\n\twidth: 100%;\n\ttext-align: left;\n}\n.bootstrap-select.btn-group[class*=\"col-\"] .dropdown-toggle {\n\twidth: 100%;\n}\n.bootstrap-select.btn-group .dropdown-menu {\n\tmin-width: 100%;\n\t-webkit-box-sizing: border-box;\n\t-moz-box-sizing: border-box;\n\tbox-sizing: border-box;\n}\n.bootstrap-select.btn-group .dropdown-menu.inner {\n\tposition: static;\n\tfloat: none;\n\tborder: 0;\n\tpadding: 0;\n\tmargin: 0;\n}\n.bootstrap-select.btn-group .dropdown-menu li {\n\tposition: relative;\n}\n.bootstrap-select.btn-group .dropdown-menu li.active small {\n\tcolor: #fff;\n}\n.bootstrap-select.btn-group .dropdown-menu li.disabled a {\n\tcursor: not-allowed;\n}\n.bootstrap-select.btn-group .dropdown-menu li a {\n\tcolor: #66615b;\n\tfont-size: 16px;\n\tpadding: 5px 45px 5px 15px;\n\tclear: both;\n\twhite-space: nowrap;\n\twidth: 100%;\n\tdisplay: block;\n}\n.bootstrap-select.btn-group .dropdown-menu li a:hover {\n\tbackground-color: #66615b;\n\tcolor: rgba(255, 255, 255, 0.7);\n\topacity: 1;\n\ttext-decoration: none;\n}\n.bootstrap-select.btn-group .dropdown-menu li a.opt {\n\tposition: relative;\n\tpadding-left: 2.25em;\n}\n.bootstrap-select.btn-group .dropdown-menu li a span.check-mark {\n\tdisplay: none;\n}\n.bootstrap-select.btn-group .dropdown-menu li a span.text {\n\tdisplay: inline-block;\n}\n.bootstrap-select.btn-group .dropdown-menu li small {\n\tpadding-left: 0.5em;\n}\n.bootstrap-select.btn-group .dropdown-menu .notify {\n\tposition: absolute;\n\tbottom: 5px;\n\twidth: 96%;\n\tmargin: 0 2%;\n\tmin-height: 26px;\n\tpadding: 3px 5px;\n\tbackground: whitesmoke;\n\tborder: 1px solid #e3e3e3;\n\t-webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.05);\n\tbox-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.05);\n\tpointer-events: none;\n\topacity: 0.9;\n\t-webkit-box-sizing: border-box;\n\t-moz-box-sizing: border-box;\n\tbox-sizing: border-box;\n}\n.bootstrap-select.btn-group .no-results {\n\tpadding: 3px;\n\tbackground: #f5f5f5;\n\tmargin: 0 5px;\n\twhite-space: nowrap;\n}\n.bootstrap-select.btn-group.fit-width .dropdown-toggle .filter-option {\n\tposition: static;\n}\n.bootstrap-select.btn-group.show-tick\n\t.dropdown-menu\n\tli.selected\n\ta\n\tspan.check-mark {\n\tposition: absolute;\n\tdisplay: inline-block;\n\tright: 15px;\n\tmargin-top: 5px;\n}\n.bootstrap-select.btn-group.show-tick .dropdown-menu li a span.text {\n\tmargin-right: 34px;\n}\n\n.bootstrap-select.show-menu-arrow.show > .dropdown-toggle {\n\tz-index: 1061;\n}\n.bootstrap-select.show-menu-arrow .dropdown-toggle:before {\n\tcontent: \"\";\n\tborder-left: 7px solid transparent;\n\tborder-right: 7px solid transparent;\n\tborder-bottom: 7px solid rgba(204, 204, 204, 0.2);\n\tposition: absolute;\n\tbottom: -4px;\n\tleft: 9px;\n\tdisplay: none;\n}\n.bootstrap-select.show-menu-arrow .dropdown-toggle:after {\n\tcontent: \"\";\n\tborder-left: 6px solid transparent;\n\tborder-right: 6px solid transparent;\n\tborder-bottom: 6px solid white;\n\tposition: absolute;\n\tbottom: -4px;\n\tleft: 10px;\n\tdisplay: none;\n}\n.bootstrap-select.show-menu-arrow.dropup .dropdown-toggle:before {\n\tbottom: auto;\n\ttop: -3px;\n\tborder-top: 7px solid rgba(204, 204, 204, 0.2);\n\tborder-bottom: 0;\n}\n.bootstrap-select.show-menu-arrow.dropup .dropdown-toggle:after {\n\tbottom: auto;\n\ttop: -3px;\n\tborder-top: 6px solid white;\n\tborder-bottom: 0;\n}\n.bootstrap-select.show-menu-arrow.pull-right .dropdown-toggle:before {\n\tright: 12px;\n\tleft: auto;\n}\n.bootstrap-select.show-menu-arrow.pull-right .dropdown-toggle:after {\n\tright: 13px;\n\tleft: auto;\n}\n.bootstrap-select.show-menu-arrow.show > .dropdown-toggle:before,\n.bootstrap-select.show-menu-arrow.show > .dropdown-toggle:after {\n\tdisplay: block;\n}\n\n.bs-searchbox,\n.bs-actionsbox,\n.bs-donebutton {\n\tpadding: 4px 8px;\n}\n\n.bs-actionsbox {\n\twidth: 100%;\n\t-webkit-box-sizing: border-box;\n\t-moz-box-sizing: border-box;\n\tbox-sizing: border-box;\n}\n.bs-actionsbox .btn-group button {\n\twidth: 50%;\n}\n\n.bs-donebutton {\n\tfloat: left;\n\twidth: 100%;\n\t-webkit-box-sizing: border-box;\n\t-moz-box-sizing: border-box;\n\tbox-sizing: border-box;\n}\n.bs-donebutton .btn-group button {\n\twidth: 100%;\n}\n\n.bs-searchbox + .bs-actionsbox {\n\tpadding: 0 8px 4px;\n}\n.bs-searchbox .form-control {\n\tmargin-bottom: 0;\n\twidth: 100%;\n\tfloat: none;\n}\n\n.bootstrap-select.show:before {\n\tborder-bottom: 11px solid #f1eae0;\n\tborder-left: 11px solid transparent;\n\tborder-right: 11px solid transparent;\n\tcontent: \"\";\n\tdisplay: inline-block;\n\tposition: absolute;\n\tright: 15px;\n\ttop: 50px;\n}\n\n.bootstrap-select.show:after {\n\tborder-bottom: 11px solid #fffcf5;\n\tborder-left: 11px solid transparent;\n\tborder-right: 11px solid transparent;\n\tcontent: \"\";\n\tdisplay: inline-block;\n\tposition: absolute;\n\tright: 15px;\n\ttop: 51px;\n}\n\n.bootstrap-select.dropup.show:before {\n\tborder-top: 11px solid #dcd9d1;\n\tborder-left: 11px solid transparent;\n\tborder-right: 11px solid transparent;\n\tborder-bottom: none;\n\tright: 15px;\n\ttop: -11px;\n}\n\n.bootstrap-select.dropup.show:after {\n\tborder-top: 11px solid #ffffff;\n\tborder-left: 11px solid transparent;\n\tborder-right: 11px solid transparent;\n\tborder-bottom: none;\n\tright: 15px;\n\ttop: -12px;\n}\n\n.bootstrap-select .dropdown-menu .dropdown-menu {\n\t-webkit-transform: translate3d(0, 0, 0) !important;\n\t-moz-transform: translate3d(0, 0, 0) !important;\n\t-o-transform: translate3d(0, 0, 0) !important;\n\t-ms-transform: translate3d(0, 0, 0) !important;\n\ttransform: translate3d(0, 0, 0) !important;\n}\n.bootstrap-select .dropdown-menu .dropdown-menu:after,\n.bootstrap-select .dropdown-menu .dropdown-menu:before {\n\tdisplay: none;\n}\n.bootstrap-select.dropup .dropdown-menu.show {\n\t-webkit-transform: translate3d(0, -60px, 0) !important;\n\t-moz-transform: translate3d(0, -60px, 0) !important;\n\t-o-transform: translate3d(0, -60px, 0) !important;\n\t-ms-transform: translate3d(0, -60px, 0) !important;\n\ttransform: translate3d(0, -60px, 0) !important;\n}\n\n.btn-file {\n\tposition: relative;\n\toverflow: hidden;\n\tvertical-align: middle;\n}\n\n.btn-file > input {\n\tposition: absolute;\n\ttop: 0;\n\tright: 0;\n\twidth: 100%;\n\theight: 100%;\n\tmargin: 0;\n\tfont-size: 23px;\n\tcursor: pointer;\n\tfilter: alpha(opacity=0);\n\topacity: 0;\n\tdirection: ltr;\n}\n\n.fileinput {\n\tdisplay: inline-block;\n\tmargin-bottom: 9px;\n}\n\n.fileinput .form-control {\n\tdisplay: inline-block;\n\tpadding-top: 7px;\n\tpadding-bottom: 5px;\n\tmargin-bottom: 0;\n\tvertical-align: middle;\n\tcursor: text;\n}\n\n.fileinput .thumbnail {\n\tdisplay: inline-block;\n\tmargin-bottom: 10px;\n\toverflow: hidden;\n\ttext-align: center;\n\tvertical-align: middle;\n\tmax-width: 250px;\n\tbox-shadow: 0 2px 2px rgba(204, 197, 185, 0.5);\n}\n.fileinput .thumbnail.img-circle {\n\tborder-radius: 50%;\n\tmax-width: 100px;\n}\n\n.fileinput .thumbnail > img {\n\tmax-height: 100%;\n}\n\n.fileinput .btn {\n\tvertical-align: middle;\n}\n\n.fileinput-exists .fileinput-new,\n.fileinput-new .fileinput-exists {\n\tdisplay: none;\n}\n\n.fileinput-inline .fileinput-controls {\n\tdisplay: inline;\n}\n\n.fileinput-filename {\n\tdisplay: inline-block;\n\toverflow: hidden;\n\tvertical-align: middle;\n}\n\n.form-control .fileinput-filename {\n\tvertical-align: bottom;\n}\n\n.fileinput.input-group {\n\tdisplay: table;\n}\n\n.fileinput.input-group > * {\n\tposition: relative;\n\tz-index: 2;\n}\n\n.fileinput.input-group > .btn-file {\n\tz-index: 1;\n}\n\n.fileinput-new.input-group .btn-file,\n.fileinput-new .input-group .btn-file {\n\tborder-radius: 0 4px 4px 0;\n}\n\n.fileinput-new.input-group .btn-file.btn-xs,\n.fileinput-new .input-group .btn-file.btn-xs,\n.fileinput-new.input-group .btn-file.btn-sm,\n.fileinput-new .input-group .btn-file.btn-sm {\n\tborder-radius: 0 3px 3px 0;\n}\n\n.fileinput-new.input-group .btn-file.btn-lg,\n.fileinput-new .input-group .btn-file.btn-lg {\n\tborder-radius: 0 6px 6px 0;\n}\n\n.form-group.has-warning .fileinput .fileinput-preview {\n\tcolor: #ffc759;\n}\n\n.form-group.has-warning .fileinput .thumbnail {\n\tborder-color: #ffc759;\n}\n\n.form-group.has-error .fileinput .fileinput-preview {\n\tcolor: #c1292e;\n}\n\n.form-group.has-error .fileinput .thumbnail {\n\tborder-color: #c1292e;\n}\n\n.form-group.has-success .fileinput .fileinput-preview {\n\tcolor: #28a745;\n}\n\n.form-group.has-success .fileinput .thumbnail {\n\tborder-color: #28a745;\n}\n\n.input-group-addon:not(:first-child) {\n\tborder-left: 0;\n}\n\n.thumbnail {\n\tborder: 0 none;\n\tborder-radius: 3px;\n\tpadding: 0;\n}\n\n.bootstrap-tagsinput {\n\tbackground-color: transparent;\n\tdisplay: inline-block;\n\tpadding: 4px 6px;\n\tvertical-align: middle;\n\tborder-radius: 4px;\n\twidth: 100%;\n\tline-height: 22px;\n\tcursor: text;\n}\n.bootstrap-tagsinput input {\n\tborder: none;\n\tbox-shadow: none;\n\toutline: none;\n\tbackground-color: transparent;\n\tpadding: 0 6px;\n\tmargin: 0;\n\twidth: auto;\n\tmax-width: inherit;\n}\n.bootstrap-tagsinput input:focus {\n\tborder: none;\n\tbox-shadow: none;\n}\n.bootstrap-tagsinput input::-moz-placeholder {\n\tcolor: #999;\n\topacity: 1;\n}\n.bootstrap-tagsinput input:-ms-input-placeholder {\n\tcolor: #999;\n}\n.bootstrap-tagsinput input::-webkit-input-placeholder {\n\tcolor: #999;\n}\n.bootstrap-tagsinput.form-control input::-moz-placeholder {\n\tcolor: #999;\n}\n.bootstrap-tagsinput.form-control input:-ms-input-placeholder {\n\tcolor: #999;\n}\n.bootstrap-tagsinput.form-control input::-webkit-input-placeholder {\n\tcolor: #999;\n}\n.bootstrap-tagsinput .badge {\n\t-webkit-transition: all 170ms linear;\n\t-moz-transition: all 170ms linear;\n\t-o-transition: all 170ms linear;\n\t-ms-transition: all 170ms linear;\n\ttransition: all 170ms linear;\n}\n.bootstrap-tagsinput .badge {\n\tcursor: pointer;\n\tmargin: 5px 3px 5px 0;\n\tposition: relative;\n\tpadding: 4px 8px 3px 0.8em;\n\tborder-radius: 12px;\n\tcolor: #fff;\n\tfont-size: 0.75em;\n\tfont-weight: 500;\n\tdisplay: inline-block;\n\tline-height: 1.5em;\n\ttext-transform: uppercase;\n}\n.bootstrap-tagsinput .badge:hover {\n\tpadding-right: 25px;\n}\n.bootstrap-tagsinput .badge:hover [data-role=\"remove\"] {\n\topacity: 1;\n\tpadding-right: 6px;\n}\n.bootstrap-tagsinput .badge [data-role=\"remove\"] {\n\tcursor: pointer;\n\tposition: absolute;\n\ttop: 3.5px;\n\tright: 0;\n\topacity: 0;\n}\n.bootstrap-tagsinput .badge [data-role=\"remove\"]:after {\n\tcontent: \"\\f00d\";\n\tpadding: 0px 4px;\n\tfont-size: 18px;\n\tfont: normal normal normal 10px/1 FontAwesome;\n}\n.bootstrap-tagsinput .badge [data-role=\"remove\"]:hover:active {\n\tbox-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n\topacity: 1;\n}\n\n.badge-success {\n\tbackground-color: #7ac29a;\n}\n\n/*\n * This combined file was created by the DataTables downloader builder:\n *   https://datatables.net/download\n *\n * To rebuild or modify this file with the latest versions of the included\n * software please visit:\n *   https://datatables.net/download/#bs4/dt-1.10.16/cr-1.4.1/fc-3.2.3/fh-3.1.3/r-2.2.0/rg-1.0.2/rr-1.2.3/sc-1.4.3/sl-1.2.3\n *\n * Included libraries:\n *   DataTables 1.10.16, ColReorder 1.4.1, FixedColumns 3.2.3, FixedHeader 3.1.3, Responsive 2.2.0, RowGroup 1.0.2, RowReorder 1.2.3, Scroller 1.4.3, Select 1.2.3\n */\ntable.dataTable {\n\tclear: both;\n\tmargin-top: 6px !important;\n\tmargin-bottom: 6px !important;\n\tmax-width: none !important;\n\tborder-collapse: separate !important;\n}\n\ntable.dataTable td,\ntable.dataTable th {\n\t-webkit-box-sizing: content-box;\n\t-moz-box-sizing: content-box;\n\tbox-sizing: content-box;\n}\n\ntable.dataTable td.dataTables_empty,\ntable.dataTable th.dataTables_empty {\n\ttext-align: center;\n}\n\ntable.dataTable.nowrap th,\ntable.dataTable.nowrap td {\n\twhite-space: nowrap;\n}\n\ndiv.dataTables_wrapper div.dataTables_length label {\n\tfont-weight: normal;\n\ttext-align: left;\n\twhite-space: nowrap;\n}\n\ndiv.dataTables_wrapper div.dataTables_length select {\n\twidth: 75px;\n\tdisplay: inline-block;\n}\n\ndiv.dataTables_wrapper div.dataTables_filter {\n\ttext-align: right;\n}\n\ndiv.dataTables_wrapper div.dataTables_filter label {\n\tfont-weight: normal;\n\twhite-space: nowrap;\n\ttext-align: left;\n}\n\ndiv.dataTables_wrapper div.dataTables_filter input {\n\tmargin-left: 0.5em;\n\tdisplay: inline-block;\n\twidth: auto;\n}\n\ndiv.dataTables_wrapper div.dataTables_info {\n\tpadding-top: 8px;\n\twhite-space: nowrap;\n}\n\ndiv.dataTables_wrapper div.dataTables_paginate {\n\tmargin: 0;\n\twhite-space: nowrap;\n\ttext-align: right;\n}\n\ndiv.dataTables_wrapper div.dataTables_paginate ul.pagination {\n\tmargin: 2px 0;\n\twhite-space: nowrap;\n}\n\ndiv.dataTables_wrapper div.dataTables_processing {\n\tposition: absolute;\n\ttop: 50%;\n\tleft: 50%;\n\twidth: 200px;\n\tmargin-left: -100px;\n\tmargin-top: -26px;\n\ttext-align: center;\n\tpadding: 1em 0;\n}\n\ntable.dataTable thead > tr > th.sorting_asc,\ntable.dataTable thead > tr > th.sorting_desc,\ntable.dataTable thead > tr > th.sorting,\ntable.dataTable thead > tr > td.sorting_asc,\ntable.dataTable thead > tr > td.sorting_desc,\ntable.dataTable thead > tr > td.sorting {\n\tpadding-right: 30px;\n}\n\ntable.dataTable thead > tr > th:active,\ntable.dataTable thead > tr > td:active {\n\toutline: none;\n}\n\ntable.dataTable thead .sorting,\ntable.dataTable thead .sorting_asc,\ntable.dataTable thead .sorting_desc,\ntable.dataTable thead .sorting_asc_disabled,\ntable.dataTable thead .sorting_desc_disabled {\n\tcursor: pointer;\n\tposition: relative;\n}\n\ntable.dataTable thead .sorting:after,\ntable.dataTable thead .sorting_asc:after,\ntable.dataTable thead .sorting_desc:after,\ntable.dataTable thead .sorting_asc_disabled:after,\ntable.dataTable thead .sorting_desc_disabled:after {\n\tposition: absolute;\n\tbottom: 8px;\n\tright: 8px;\n\tdisplay: block;\n\tfont-family: \"Glyphicons Halflings\";\n\topacity: 0.5;\n}\n\ntable.dataTable thead .sorting:after {\n\topacity: 0.2;\n\tcontent: \"\\e150\";\n\t/* sort */\n}\n\ntable.dataTable thead .sorting_asc:after {\n\tcontent: \"\\e155\";\n\t/* sort-by-attributes */\n}\n\ntable.dataTable thead .sorting_desc:after {\n\tcontent: \"\\e156\";\n\t/* sort-by-attributes-alt */\n}\n\ntable.dataTable thead .sorting_asc_disabled:after,\ntable.dataTable thead .sorting_desc_disabled:after {\n\tcolor: #eee;\n}\n\ndiv.dataTables_scrollHead table.dataTable {\n\tmargin-bottom: 0 !important;\n}\n\ndiv.dataTables_scrollBody table {\n\tborder-top: none;\n\tmargin-top: 0 !important;\n\tmargin-bottom: 0 !important;\n}\n\ndiv.dataTables_scrollBody table thead .sorting:after,\ndiv.dataTables_scrollBody table thead .sorting_asc:after,\ndiv.dataTables_scrollBody table thead .sorting_desc:after {\n\tdisplay: none;\n}\n\ndiv.dataTables_scrollBody table tbody tr:first-child th,\ndiv.dataTables_scrollBody table tbody tr:first-child td {\n\tborder-top: none;\n}\n\ndiv.dataTables_scrollFoot table {\n\tmargin-top: 0 !important;\n\tborder-top: none;\n}\n\n@media screen and (max-width: 767px) {\n\tdiv.dataTables_wrapper div.dataTables_length,\n\tdiv.dataTables_wrapper div.dataTables_filter,\n\tdiv.dataTables_wrapper div.dataTables_info,\n\tdiv.dataTables_wrapper div.dataTables_paginate {\n\t\ttext-align: center;\n\t}\n}\ntable.dataTable.table-condensed > thead > tr > th {\n\tpadding-right: 20px;\n}\n\ntable.dataTable.table-condensed .sorting:after,\ntable.dataTable.table-condensed .sorting_asc:after,\ntable.dataTable.table-condensed .sorting_desc:after {\n\ttop: 6px;\n\tright: 6px;\n}\n\ntable.table-bordered.dataTable th,\ntable.table-bordered.dataTable td {\n\tborder-left-width: 0;\n}\n\ntable.table-bordered.dataTable th:last-child,\ntable.table-bordered.dataTable th:last-child,\ntable.table-bordered.dataTable td:last-child,\ntable.table-bordered.dataTable td:last-child {\n\tborder-right-width: 0;\n}\n\ntable.table-bordered.dataTable tbody th,\ntable.table-bordered.dataTable tbody td {\n\tborder-bottom-width: 0;\n}\n\ndiv.dataTables_scrollHead table.table-bordered {\n\tborder-bottom-width: 0;\n}\n\ndiv.table-responsive > div.dataTables_wrapper > div.row {\n\tmargin: 0;\n}\n\ndiv.table-responsive\n\t> div.dataTables_wrapper\n\t> div.row\n\t> div[class^=\"col-\"]:first-child {\n\tpadding-left: 0;\n}\n\ndiv.table-responsive\n\t> div.dataTables_wrapper\n\t> div.row\n\t> div[class^=\"col-\"]:last-child {\n\tpadding-right: 0;\n}\n\ntable.dataTable thead .sorting:after,\ntable.dataTable thead .sorting_asc:after,\ntable.dataTable thead .sorting_desc:after,\ntable.dataTable thead .sorting_asc_disabled:after,\ntable.dataTable thead .sorting_desc_disabled:after {\n\tposition: relative;\n\tdisplay: inline-block;\n\tbottom: 0px;\n\tright: -7px;\n\tfont-family: \"FontAwesome\";\n\topacity: 0.8;\n}\ntable.dataTable thead .disabled-sorting.sorting:after,\ntable.dataTable thead .disabled-sorting.sorting_asc:after,\ntable.dataTable thead .disabled-sorting.sorting_desc:after,\ntable.dataTable thead .disabled-sorting.sorting_asc_disabled:after,\ntable.dataTable thead .disabled-sorting.sorting_desc_disabled:after {\n\tdisplay: none;\n}\ntable.dataTable thead .sorting:after {\n\topacity: 0.4;\n\tcontent: \"\\f0dc\";\n}\ntable.dataTable thead .sorting_asc:after {\n\tcontent: \"\\f0de\";\n\ttop: 3px;\n}\ntable.dataTable thead .sorting_desc:after {\n\tcontent: \"\\f0dd\";\n\ttop: -3px;\n}\ntable.dataTable .table-hover > tbody > tr:hover {\n\tbackground-color: #fff4dc;\n}\ntable.dataTable .table > thead > tr > th,\ntable.dataTable .table > tbody > tr > th,\ntable.dataTable .table > tfoot > tr > th,\ntable.dataTable .table > thead > tr > td,\ntable.dataTable .table > tbody > tr > td,\ntable.dataTable .table > tfoot > tr > td {\n\tpadding: 8px !important;\n\toutline: 0;\n}\ntable.dataTable .btn.btn-icon {\n\tmargin: 0 3px;\n\tpadding: 5px 8px;\n}\n\n.dataTables_paginate a {\n\toutline: 0;\n}\n\ntable.dataTable.dtr-inline.collapsed > tbody > tr > td.child,\ntable.dataTable.dtr-inline.collapsed > tbody > tr > th.child,\ntable.dataTable.dtr-inline.collapsed > tbody > tr > td.dataTables_empty {\n\tcursor: default !important;\n}\ntable.dataTable.dtr-inline.collapsed > tbody > tr > td.child:before,\ntable.dataTable.dtr-inline.collapsed > tbody > tr > th.child:before,\ntable.dataTable.dtr-inline.collapsed > tbody > tr > td.dataTables_empty:before {\n\tdisplay: none !important;\n}\ntable.dataTable.dtr-inline.collapsed > tbody > tr > td:first-child,\ntable.dataTable.dtr-inline.collapsed > tbody > tr > th:first-child {\n\tposition: relative;\n\tpadding-left: 30px;\n\tcursor: pointer;\n}\ntable.dataTable.dtr-inline.collapsed > tbody > tr > td:first-child:before,\ntable.dataTable.dtr-inline.collapsed > tbody > tr > th:first-child:before {\n\ttop: 50%;\n\tmargin-top: -9px;\n\tleft: 4px;\n\theight: 18px;\n\twidth: 18px;\n\tdisplay: block;\n\tposition: absolute;\n\tcolor: #518607;\n\tborder: 0px solid white;\n\tborder-radius: 14px;\n\tbox-shadow: 0 0 3px #444;\n\tbox-sizing: content-box;\n\ttext-align: center;\n\tfont-family: \"Courier New\", Courier, monospace;\n\tline-height: 18px;\n\tcontent: \"+\";\n\tbackground-color: #fff;\n}\ntable.dataTable.dtr-inline.collapsed\n\t> tbody\n\t> tr.parent\n\t> td:first-child:before,\ntable.dataTable.dtr-inline.collapsed\n\t> tbody\n\t> tr.parent\n\t> th:first-child:before {\n\tcontent: \"-\";\n\tcolor: #ed362c;\n}\ntable.dataTable.dtr-inline.collapsed > tbody > tr.child td:before {\n\tdisplay: none;\n}\n\ntable.dataTable.dtr-inline.collapsed.compact > tbody > tr > td:first-child,\ntable.dataTable.dtr-inline.collapsed.compact > tbody > tr > th:first-child {\n\tpadding-left: 27px;\n}\ntable.dataTable.dtr-inline.collapsed.compact\n\t> tbody\n\t> tr\n\t> td:first-child:before,\ntable.dataTable.dtr-inline.collapsed.compact\n\t> tbody\n\t> tr\n\t> th:first-child:before {\n\ttop: 5px;\n\tleft: 4px;\n\theight: 14px;\n\twidth: 14px;\n\tborder-radius: 14px;\n\tline-height: 14px;\n\ttext-indent: 3px;\n}\n\ntable.dataTable.dtr-column > tbody > tr > td.control,\ntable.dataTable.dtr-column > tbody > tr > th.control {\n\tposition: relative;\n\tcursor: pointer;\n}\ntable.dataTable.dtr-column > tbody > tr > td.control:before,\ntable.dataTable.dtr-column > tbody > tr > th.control:before {\n\ttop: 50%;\n\tleft: 50%;\n\theight: 16px;\n\twidth: 16px;\n\tmargin-top: -10px;\n\tmargin-left: -10px;\n\tdisplay: block;\n\tposition: absolute;\n\tcolor: white;\n\tborder: 2px solid white;\n\tborder-radius: 14px;\n\tbox-shadow: 0 0 3px #444;\n\tbox-sizing: content-box;\n\ttext-align: center;\n\tfont-family: \"Courier New\", Courier, monospace;\n\tline-height: 14px;\n\tcontent: \"+\";\n\tbackground-color: #31b131;\n}\ntable.dataTable.dtr-column > tbody > tr.parent td.control:before,\ntable.dataTable.dtr-column > tbody > tr.parent th.control:before {\n\tcontent: \"-\";\n\tbackground-color: #d33333;\n}\n\ntable.dataTable > tbody > tr.child {\n\tpadding: 0.5em 1em;\n}\ntable.dataTable > tbody > tr.child:hover {\n\tbackground: transparent !important;\n}\ntable.dataTable > tbody > tr.child ul {\n\tdisplay: inline-block;\n\tlist-style-type: none;\n\tmargin: 0;\n\tpadding: 0;\n}\ntable.dataTable > tbody > tr.child ul li {\n\tborder-bottom: 1px solid #004e89;\n\tpadding: 0.5em 0;\n}\ntable.dataTable > tbody > tr.child ul li:first-child {\n\tpadding-top: 0;\n}\ntable.dataTable > tbody > tr.child ul li:last-child {\n\tborder-bottom: none;\n}\ntable.dataTable > tbody > tr.child span.dtr-title {\n\tdisplay: inline-block;\n\tmin-width: 75px;\n\tfont-weight: bold;\n}\n\ndiv.dtr-modal {\n\tposition: fixed;\n\tbox-sizing: border-box;\n\ttop: 0;\n\tleft: 0;\n\theight: 100%;\n\twidth: 100%;\n\tz-index: 100;\n\tpadding: 10em 1em;\n}\ndiv.dtr-modal div.dtr-modal-display {\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\tbottom: 0;\n\tright: 0;\n\twidth: 50%;\n\theight: 50%;\n\toverflow: auto;\n\tmargin: auto;\n\tz-index: 102;\n\toverflow: auto;\n\tbackground-color: #f5f5f7;\n\tborder: 1px solid black;\n\tborder-radius: 0.5em;\n\tbox-shadow: 0 12px 30px rgba(0, 0, 0, 0.6);\n}\ndiv.dtr-modal div.dtr-modal-content {\n\tposition: relative;\n\tpadding: 1em;\n}\ndiv.dtr-modal div.dtr-modal-close {\n\tposition: absolute;\n\ttop: 6px;\n\tright: 6px;\n\twidth: 22px;\n\theight: 22px;\n\tborder: 1px solid #eaeaea;\n\tbackground-color: #f9f9f9;\n\ttext-align: center;\n\tborder-radius: 3px;\n\tcursor: pointer;\n\tz-index: 12;\n}\ndiv.dtr-modal div.dtr-modal-close:hover {\n\tbackground-color: #eaeaea;\n}\ndiv.dtr-modal div.dtr-modal-background {\n\tposition: fixed;\n\ttop: 0;\n\tleft: 0;\n\tright: 0;\n\tbottom: 0;\n\tz-index: 101;\n\tbackground: rgba(0, 0, 0, 0.6);\n}\n\n@media screen and (max-width: 767px) {\n\tdiv.dtr-modal div.dtr-modal-display {\n\t\twidth: 95%;\n\t}\n}\nsvg {\n\ttouch-action: none;\n}\n\n.jvectormap-container {\n\twidth: 100%;\n\theight: 100%;\n\tposition: relative;\n\toverflow: hidden;\n\ttouch-action: none;\n}\n\n.jvectormap-tip {\n\tposition: absolute;\n\tdisplay: none;\n\tborder: solid 1px #cdcdcd;\n\tborder-radius: 3px;\n\tbackground: #292929 !important;\n\tcolor: white;\n\tfont-family: sans-serif, Verdana;\n\tfont-size: smaller;\n\tpadding: 3px;\n}\n\n.jvectormap-zoomin,\n.jvectormap-zoomout,\n.jvectormap-goback {\n\tposition: absolute;\n\tleft: 10px;\n\tborder-radius: 3px;\n\tbackground: #292929 !important;\n\tpadding: 3px;\n\tcolor: white;\n\tcursor: pointer;\n\tline-height: 10px;\n\ttext-align: center;\n\tbox-sizing: content-box;\n}\n\n.jvectormap-zoomin,\n.jvectormap-zoomout {\n\twidth: 10px;\n\theight: 10px;\n}\n\n.jvectormap-zoomin {\n\ttop: 10px;\n}\n\n.jvectormap-zoomout {\n\ttop: 30px;\n}\n\n.jvectormap-goback {\n\tbottom: 10px;\n\tz-index: 1000;\n\tpadding: 6px;\n}\n\n.jvectormap-spinner {\n\tposition: absolute;\n\tleft: 0;\n\ttop: 0;\n\tright: 0;\n\tbottom: 0;\n\tbackground: center no-repeat\n\t\turl(data:image/gif;base64,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);\n}\n\n.jvectormap-legend-title {\n\tfont-weight: bold;\n\tfont-size: 14px;\n\ttext-align: center;\n}\n\n.jvectormap-legend-cnt {\n\tposition: absolute;\n}\n\n.jvectormap-legend-cnt-h {\n\tbottom: 0;\n\tright: 0;\n}\n\n.jvectormap-legend-cnt-v {\n\ttop: 0;\n\tright: 0;\n}\n\n.jvectormap-legend {\n\tbackground: black;\n\tcolor: white;\n\tborder-radius: 3px;\n}\n\n.jvectormap-legend-cnt-h .jvectormap-legend {\n\tfloat: left;\n\tmargin: 0 10px 10px 0;\n\tpadding: 3px 3px 1px 3px;\n}\n\n.jvectormap-legend-cnt-h .jvectormap-legend .jvectormap-legend-tick {\n\tfloat: left;\n}\n\n.jvectormap-legend-cnt-v .jvectormap-legend {\n\tmargin: 10px 10px 0 0;\n\tpadding: 3px;\n}\n\n.jvectormap-legend-cnt-h .jvectormap-legend-tick {\n\twidth: 40px;\n}\n\n.jvectormap-legend-cnt-h .jvectormap-legend-tick-sample {\n\theight: 15px;\n}\n\n.jvectormap-legend-cnt-v .jvectormap-legend-tick-sample {\n\theight: 20px;\n\twidth: 20px;\n\tdisplay: inline-block;\n\tvertical-align: middle;\n}\n\n.jvectormap-legend-tick-text {\n\tfont-size: 12px;\n}\n\n.jvectormap-legend-cnt-h .jvectormap-legend-tick-text {\n\ttext-align: center;\n}\n\n.jvectormap-legend-cnt-v .jvectormap-legend-tick-text {\n\tdisplay: inline-block;\n\tvertical-align: middle;\n\tline-height: 20px;\n\tpadding-left: 3px;\n}\n\n/*!\n * FullCalendar v3.1.0 Stylesheet\n * Docs & License: http://fullcalendar.io/\n * (c) 2016 Adam Shaw\n */\n.fc {\n\tdirection: ltr;\n\ttext-align: left;\n}\n\n.fc-rtl {\n\ttext-align: right;\n}\n\nbody .fc {\n\t/* extra precedence to overcome jqui */\n\tfont-size: 1em;\n}\n\n/* Colors\n--------------------------------------------------------------------------------------------------*/\n.fc-unthemed th,\n.fc-unthemed td,\n.fc-unthemed thead,\n.fc-unthemed tbody,\n.fc-unthemed .fc-divider,\n.fc-unthemed .fc-row,\n.fc-unthemed .fc-popover {\n\tborder-color: #ddd;\n}\n\n.fc-unthemed .fc-popover {\n\tbackground-color: #ffffff;\n}\n\n.fc-unthemed .fc-divider,\n.fc-unthemed .fc-popover .fc-header {\n\tbackground: #e3e3e3;\n}\n\n.fc-unthemed .fc-popover .fc-header .fc-close {\n\tcolor: #666666;\n}\n\n.fc-unthemed .fc-today {\n\tbackground: #f5f5f5;\n}\n\n.fc-highlight {\n\t/* when user is selecting cells */\n\tbackground: #bce8f1;\n\topacity: 0.3;\n\tfilter: alpha(opacity=30);\n\t/* for IE */\n}\n\n.fc-bgevent {\n\t/* default look for background events */\n\tbackground: #8fdf82;\n\topacity: 0.3;\n\tfilter: alpha(opacity=30);\n\t/* for IE */\n}\n\n.fc-nonbusiness {\n\t/* default look for non-business-hours areas */\n\t/* will inherit .fc-bgevent's styles */\n\tbackground: #d7d7d7;\n}\n\n/* Icons (inline elements with styled text that mock arrow icons)\n--------------------------------------------------------------------------------------------------*/\n.fc-icon {\n\tdisplay: inline-block;\n\twidth: 1em;\n\theight: 1em;\n\tline-height: 1em;\n\tfont-size: 1em;\n\ttext-align: center;\n\toverflow: hidden;\n\tfont-family: \"Courier New\", Courier, monospace;\n\t/* don't allow browser text-selection */\n\t-webkit-touch-callout: none;\n\t-webkit-user-select: none;\n\t-khtml-user-select: none;\n\t-moz-user-select: none;\n\t-ms-user-select: none;\n\tuser-select: none;\n}\n\n/*\nAcceptable font-family overrides for individual icons:\n\t\"Arial\", sans-serif\n\t\"Times New Roman\", serif\n\nNOTE: use percentage font sizes or else old IE chokes\n*/\n.fc-icon:after {\n\tposition: relative;\n\tmargin: 0 -1em;\n\t/* ensures character will be centered, regardless of width */\n}\n\n.fc-icon-left-single-arrow:after {\n\tcontent: \"‹\";\n\tfont-weight: bold;\n\tfont-size: 200%;\n\ttop: -7%;\n\tleft: 3%;\n}\n\n.fc-icon-right-single-arrow:after {\n\tcontent: \"›\";\n\tfont-weight: bold;\n\tfont-size: 200%;\n\ttop: -7%;\n\tleft: -3%;\n}\n\n.fc-icon-left-double-arrow:after {\n\tcontent: \"«\";\n\tfont-size: 160%;\n\ttop: -7%;\n}\n\n.fc-icon-right-double-arrow:after {\n\tcontent: \"»\";\n\tfont-size: 160%;\n\ttop: -7%;\n}\n\n.fc-icon-left-triangle:after {\n\tcontent: \"◄\";\n\tfont-size: 125%;\n\ttop: 3%;\n\tleft: -2%;\n}\n\n.fc-icon-right-triangle:after {\n\tcontent: \"►\";\n\tfont-size: 125%;\n\ttop: 3%;\n\tleft: 2%;\n}\n\n.fc-icon-down-triangle:after {\n\tcontent: \"▼\";\n\tfont-size: 125%;\n\ttop: 2%;\n}\n\n.fc-icon-x:after {\n\tcontent: \"×\";\n\tfont-size: 200%;\n\ttop: 6%;\n}\n\n/* Buttons (styled <button> tags, normalized to work cross-browser)\n--------------------------------------------------------------------------------------------------*/\n.fc button {\n\tborder-radius: 20px;\n\tbox-sizing: border-box;\n\tborder-width: 2px;\n\tbackground-color: transparent;\n\tfont-size: 12px;\n\tfont-weight: 600;\n\tpadding: 0.5rem 0.7rem;\n\tbackground-color: #65adff;\n\tcolor: #ffffff;\n\t-webkit-transition: all 150ms linear;\n\t-moz-transition: all 150ms linear;\n\t-o-transition: all 150ms linear;\n\t-ms-transition: all 150ms linear;\n\ttransition: all 150ms linear;\n}\n.fc button:hover,\n.fc button:focus,\n.fc button:active,\n.fc button.active,\n.fc button:active:focus,\n.fc button:active:hover,\n.fc button.active:focus,\n.fc button.active:hover,\n.show > .fc button.dropdown-toggle,\n.show > .fc button.dropdown-toggle:focus,\n.show > .fc button.dropdown-toggle:hover {\n\tbackground-color: #403d39 !important;\n\tcolor: #ffffff !important;\n\tbox-shadow: none !important;\n}\n.fc button:not([data-action]):hover {\n\tbox-shadow: none;\n}\n.fc button.disabled,\n.fc button.disabled:hover,\n.fc button.disabled:focus,\n.fc button.disabled.focus,\n.fc button.disabled:active,\n.fc button.disabled.active,\n.fc button:disabled,\n.fc button:disabled:hover,\n.fc button:disabled:focus,\n.fc button:disabled.focus,\n.fc button:disabled:active,\n.fc button:disabled.active,\n.fc button[disabled],\n.fc button[disabled]:hover,\n.fc button[disabled]:focus,\n.fc button[disabled].focus,\n.fc button[disabled]:active,\n.fc button[disabled].active,\nfieldset[disabled] .fc button,\nfieldset[disabled] .fc button:hover,\nfieldset[disabled] .fc button:focus,\nfieldset[disabled] .fc button.focus,\nfieldset[disabled] .fc button:active,\nfieldset[disabled] .fc button.active {\n\tbackground-color: #65adff;\n\tborder-color: #65adff;\n}\n.fc button.btn-simple {\n\tcolor: #65adff;\n\tborder-color: #65adff;\n}\n.fc button.btn-simple:hover,\n.fc button.btn-simple:focus,\n.fc button.btn-simple:active {\n\tbackground-color: transparent;\n\tcolor: #403d39;\n\tborder-color: #403d39;\n\tbox-shadow: none;\n}\n.fc button.btn-link {\n\tcolor: #65adff;\n}\n\n.fc button:hover,\n.fc button:focus {\n\toutline: 0 !important;\n}\n.fc button:active,\n.fc button.active,\n.open > .fc button.dropdown-toggle {\n\t-webkit-box-shadow: none;\n\tbox-shadow: none;\n\toutline: 0 !important;\n}\n.fc button.btn-icon {\n\tborder-radius: 25px;\n\tpadding: 6px 10px;\n}\n.fc button.btn-icon i {\n\tmargin-right: 0px;\n}\n\n/* Firefox has an annoying inner border */\n.fc button::-moz-focus-inner {\n\tmargin: 0;\n\tpadding: 0;\n}\n\n.fc-state-default {\n\t/* non-theme */\n\tborder: 1px solid;\n}\n\n/* icons in buttons */\n.fc button .fc-icon {\n\t/* non-theme */\n\tposition: relative;\n\ttop: -0.05em;\n\t/* seems to be a good adjustment across browsers */\n\tmargin: 0 0.2em;\n\tvertical-align: middle;\n}\n\n/*\n  button states\n  borrowed from twitter bootstrap (http://twitter.github.com/bootstrap/)\n*/\n.fc-state-hover,\n.fc-state-active,\n.fc-state-disabled {\n\tcolor: #2c2c2c;\n\tbackground-color: #e6e6e6;\n}\n\n.fc button[disabled],\n.fc button[disabled]:focus,\n.fc button[disabled]:hover {\n\tbackground-color: #e3e3e3;\n\tborder-color: #e3e3e3;\n\tcursor: default;\n\topacity: 0.65;\n\tfilter: alpha(opacity=65);\n\tcolor: #292929 !important;\n}\n\n.fc-state-hover {\n\tbackground-color: #f5f5f5;\n}\n\n.fc .fc-state-active,\n.fc .fc-state-active:focus,\n.fc .fc-state-active:hover,\n.fc .fc-state-active:active:focus,\n.fc .fc-state-active:active:hover,\n.fc .fc-state-active:active {\n\tbackground-color: #65adff;\n\tcolor: #ffffff;\n}\n\n/* Buttons Groups\n--------------------------------------------------------------------------------------------------*/\n.fc-button-group {\n\tdisplay: inline-block;\n}\n\n/*\nevery button that is not first in a button group should scootch over one pixel and cover the\nprevious button's border...\n*/\n.fc .fc-button-group > * {\n\t/* extra precedence b/c buttons have margin set to zero */\n\tfloat: left;\n\tmargin: 0 2px 0 0;\n}\n\n.fc .fc-button-group > :first-child {\n\t/* same */\n\tmargin-left: 0;\n}\n\n/* Popover\n--------------------------------------------------------------------------------------------------*/\n.fc-popover {\n\tposition: absolute;\n\t-webkit-box-shadow: 1px 2px 7px 1px rgba(0, 0, 0, 0.125);\n\tbox-shadow: 1px 2px 7px 1px rgba(0, 0, 0, 0.125);\n}\n\n.fc-popover .fc-header {\n\t/* TODO: be more consistent with fc-head/fc-body */\n\tpadding: 2px 4px;\n}\n\n.fc-popover .fc-header .fc-title {\n\tmargin: 0 2px;\n}\n\n.fc-popover .fc-header .fc-close {\n\tcursor: pointer;\n}\n\n.fc-ltr .fc-popover .fc-header .fc-title,\n.fc-rtl .fc-popover .fc-header .fc-close {\n\tfloat: left;\n}\n\n.fc-rtl .fc-popover .fc-header .fc-title,\n.fc-ltr .fc-popover .fc-header .fc-close {\n\tfloat: right;\n}\n\n/* unthemed */\n.fc-unthemed .fc-popover {\n\tborder-width: 1px;\n\tborder-style: solid;\n}\n\n.fc-unthemed .fc-popover .fc-header .fc-close {\n\tfont-size: 0.9em;\n\tmargin-top: 2px;\n}\n\n/* jqui themed */\n.fc-popover > .ui-widget-header + .ui-widget-content {\n\tborder-top: 0;\n\t/* where they meet, let the header have the border */\n}\n\n/* Misc Reusable Components\n--------------------------------------------------------------------------------------------------*/\n.fc-divider {\n\tborder-style: solid;\n\tborder-width: 1px;\n}\n\nhr.fc-divider {\n\theight: 0;\n\tmargin: 0;\n\tpadding: 0 0 2px;\n\t/* height is unreliable across browsers, so use padding */\n\tborder-width: 1px 0;\n}\n\n.fc-clear {\n\tclear: both;\n}\n\n.fc-bg,\n.fc-bgevent-skeleton,\n.fc-highlight-skeleton,\n.fc-helper-skeleton {\n\t/* these element should always cling to top-left/right corners */\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\tright: 0;\n}\n\n.fc-bg {\n\tbottom: 0;\n\t/* strech bg to bottom edge */\n}\n\n.fc-bg table {\n\theight: 100%;\n\t/* strech bg to bottom edge */\n}\n\n/* Tables\n--------------------------------------------------------------------------------------------------*/\n.fc table {\n\twidth: 100%;\n\ttable-layout: fixed;\n\tborder-collapse: collapse;\n\tborder-spacing: 0;\n\tfont-size: 1em;\n\t/* normalize cross-browser */\n}\n\n.fc th {\n\ttext-align: right;\n\tborder-bottom-width: 1px;\n\tfont-size: 1em;\n\ttext-transform: uppercase;\n\tcolor: #292929 !important;\n\tfont-weight: 400;\n\tpadding-bottom: 3px;\n}\n\n.fc td {\n\tborder-style: solid;\n\tborder-width: 1px;\n\tpadding: 0;\n\tvertical-align: top;\n}\n\n.fc td.fc-today {\n\tborder-style: double;\n\t/* overcome neighboring borders */\n}\n\n.fc .fc-widget-header {\n\tborder: 0;\n}\n\n.fc .fc-head .fc-widget-header {\n\tmargin-top: 15px;\n}\n\n/* Fake Table Rows\n--------------------------------------------------------------------------------------------------*/\n.fc .fc-row {\n\t/* extra precedence to overcome themes w/ .ui-widget-content forcing a 1px border */\n\t/* no visible border by default. but make available if need be (scrollbar width compensation) */\n\tborder-style: solid;\n\tborder-width: 0;\n}\n\n.fc-row table {\n\t/* don't put left/right border on anything within a fake row.\n     the outer tbody will worry about this */\n\tborder-left: 0 hidden transparent;\n\tborder-right: 0 hidden transparent;\n\t/* no bottom borders on rows */\n\tborder-bottom: 0 hidden transparent;\n}\n\n.fc-row:first-child table {\n\tborder-top: 0 hidden transparent;\n\t/* no top border on first row */\n}\n\n/* Day Row (used within the header and the DayGrid)\n--------------------------------------------------------------------------------------------------*/\n.fc-row {\n\tposition: relative;\n}\n\n.fc-row .fc-bg {\n\tz-index: 1;\n}\n\n/* highlighting cells & background event skeleton */\n.fc-row .fc-bgevent-skeleton,\n.fc-row .fc-highlight-skeleton {\n\tbottom: 0;\n\t/* stretch skeleton to bottom of row */\n}\n\n.fc-row .fc-bgevent-skeleton table,\n.fc-row .fc-highlight-skeleton table {\n\theight: 100%;\n\t/* stretch skeleton to bottom of row */\n}\n\n.fc-row .fc-highlight-skeleton td,\n.fc-row .fc-bgevent-skeleton td {\n\tborder-color: transparent;\n}\n\n.fc-row .fc-bgevent-skeleton {\n\tz-index: 2;\n}\n\n.fc-row .fc-highlight-skeleton {\n\tz-index: 3;\n}\n\n/*\nrow content (which contains day/week numbers and events) as well as \"helper\" (which contains\ntemporary rendered events).\n*/\n.fc-row .fc-content-skeleton {\n\tposition: relative;\n\tz-index: 4;\n\tpadding-bottom: 2px;\n\t/* matches the space above the events */\n}\n\n.fc-row .fc-helper-skeleton {\n\tz-index: 5;\n}\n\n.fc-row .fc-content-skeleton td,\n.fc-row .fc-helper-skeleton td {\n\t/* see-through to the background below */\n\tbackground: none;\n\t/* in case <td>s are globally styled */\n\tborder-color: transparent;\n\t/* don't put a border between events and/or the day number */\n\tborder-bottom: 0;\n}\n\n.fc-row .fc-content-skeleton tbody td,\n.fc-row .fc-helper-skeleton tbody td {\n\t/* don't put a border between event cells */\n\tborder-top: 0;\n}\n\n/* Scrolling Container\n--------------------------------------------------------------------------------------------------*/\n.fc-scroller {\n\t/* this class goes on elements for guaranteed vertical scrollbars */\n\toverflow-y: scroll;\n\toverflow-x: hidden;\n}\n\n.fc-scroller > * {\n\t/* we expect an immediate inner element */\n\tposition: relative;\n\t/* re-scope all positions */\n\twidth: 100%;\n\t/* hack to force re-sizing this inner element when scrollbars appear/disappear */\n\toverflow: hidden;\n\t/* don't let negative margins or absolute positioning create further scroll */\n}\n\n/* Global Event Styles\n--------------------------------------------------------------------------------------------------*/\n.fc-event {\n\tposition: relative;\n\t/* for resize handle and other inner positioning */\n\tdisplay: block;\n\t/* make the <a> tag block */\n\tfont-size: 0.85em;\n\tline-height: 1.3;\n\tborder-radius: 2px;\n\tbackground-color: rgba(28, 119, 195, 0.2);\n\t/* default BACKGROUND color */\n\tfont-weight: normal;\n\t/* undo jqui's ui-widget-header bold */\n}\n.fc-event.event-azure {\n\tbackground-color: rgba(57, 169, 219, 0.2);\n}\n.fc-event.event-green {\n\tbackground-color: rgba(19, 117, 71, 0.2);\n}\n.fc-event.event-orange {\n\tbackground-color: rgba(255, 199, 89, 0.2);\n}\n.fc-event.event-red {\n\tbackground-color: rgba(193, 41, 46, 0.2);\n}\n\n/* overpower some of bootstrap's and jqui's styles on <a> tags */\n.fc-event,\n.fc-event:hover,\n.ui-widget .fc-event {\n\tcolor: #2c2c2c;\n\t/* default TEXT color */\n\ttext-decoration: none;\n\t/* if <a> has an href */\n}\n\n.fc-event[href],\n.fc-event.fc-draggable {\n\tcursor: pointer;\n\t/* give events with links and draggable events a hand mouse pointer */\n}\n\n.fc-not-allowed,\n.fc-not-allowed .fc-event {\n\t/* to override an event's custom cursor */\n\tcursor: not-allowed;\n}\n\n.fc-event .fc-bg {\n\t/* the generic .fc-bg already does position */\n\tz-index: 1;\n\tbackground: #ffffff;\n\topacity: 0.25;\n\tfilter: alpha(opacity=25);\n\t/* for IE */\n}\n\n.fc-event .fc-content {\n\tposition: relative;\n\tz-index: 2;\n}\n\n.fc-event .fc-resizer {\n\tposition: absolute;\n\tz-index: 3;\n}\n\n/* Horizontal Events\n--------------------------------------------------------------------------------------------------*/\n/* events that are continuing to/from another week. kill rounded corners and butt up against edge */\n.fc-ltr .fc-h-event.fc-not-start,\n.fc-rtl .fc-h-event.fc-not-end {\n\tmargin-left: 0;\n\tborder-left-width: 0;\n\tpadding-left: 1px;\n\t/* replace the border with padding */\n\tborder-top-left-radius: 0;\n\tborder-bottom-left-radius: 0;\n}\n\n.fc-ltr .fc-h-event.fc-not-end,\n.fc-rtl .fc-h-event.fc-not-start {\n\tmargin-right: 0;\n\tborder-right-width: 0;\n\tpadding-right: 1px;\n\t/* replace the border with padding */\n\tborder-top-right-radius: 0;\n\tborder-bottom-right-radius: 0;\n}\n\n/* resizer */\n.fc-h-event .fc-resizer {\n\t/* positioned it to overcome the event's borders */\n\ttop: -1px;\n\tbottom: -1px;\n\tleft: -1px;\n\tright: -1px;\n\twidth: 5px;\n}\n\n/* left resizer  */\n.fc-ltr .fc-h-event .fc-start-resizer,\n.fc-ltr .fc-h-event .fc-start-resizer:before,\n.fc-ltr .fc-h-event .fc-start-resizer:after,\n.fc-rtl .fc-h-event .fc-end-resizer,\n.fc-rtl .fc-h-event .fc-end-resizer:before,\n.fc-rtl .fc-h-event .fc-end-resizer:after {\n\tright: auto;\n\t/* ignore the right and only use the left */\n\tcursor: w-resize;\n}\n\n/* right resizer */\n.fc-ltr .fc-h-event .fc-end-resizer,\n.fc-ltr .fc-h-event .fc-end-resizer:before,\n.fc-ltr .fc-h-event .fc-end-resizer:after,\n.fc-rtl .fc-h-event .fc-start-resizer,\n.fc-rtl .fc-h-event .fc-start-resizer:before,\n.fc-rtl .fc-h-event .fc-start-resizer:after {\n\tleft: auto;\n\t/* ignore the left and only use the right */\n\tcursor: e-resize;\n}\n\n/* DayGrid events\n----------------------------------------------------------------------------------------------------\nWe use the full \"fc-day-grid-event\" class instead of using descendants because the event won't\nbe a descendant of the grid when it is being dragged.\n*/\n.fc-day-grid-event {\n\tmargin: 2px 5px 0;\n\t/* spacing between events and edges */\n\tpadding: 1px 2px;\n}\n\n.fc-day-grid-event .fc-content {\n\t/* force events to be one-line tall */\n\twhite-space: nowrap;\n\toverflow: hidden;\n}\n\n.fc-day-grid-event .fc-time {\n\tfont-weight: bold;\n}\n\n.fc-day-grid-event .fc-resizer {\n\t/* enlarge the default hit area */\n\tleft: -3px;\n\tright: -3px;\n\twidth: 7px;\n}\n\n/* Event Limiting\n--------------------------------------------------------------------------------------------------*/\n/* \"more\" link that represents hidden events */\na.fc-more {\n\tmargin: 1px 3px;\n\tfont-size: 0.85em;\n\tcursor: pointer;\n\ttext-decoration: none;\n}\n\na.fc-more:hover {\n\ttext-decoration: none;\n}\n\n.fc-limited {\n\t/* rows and cells that are hidden because of a \"more\" link */\n\tdisplay: none;\n}\n\n/* popover that appears when \"more\" link is clicked */\n.fc-day-grid .fc-row {\n\tz-index: 1;\n\t/* make the \"more\" popover one higher than this */\n}\n\n.fc-more-popover {\n\tz-index: 2;\n\twidth: 220px;\n}\n\n.fc-more-popover .fc-event-container {\n\tpadding: 10px;\n}\n\n/* Toolbar\n--------------------------------------------------------------------------------------------------*/\n.fc-toolbar {\n\ttext-align: center;\n\tmargin-bottom: 1em;\n}\n\n.fc-toolbar .fc-left {\n\tfloat: left;\n\tmin-width: 260px;\n}\n\n.fc-toolbar .fc-right {\n\tfloat: right;\n}\n\n.fc-toolbar .fc-center {\n\tdisplay: inline-block;\n}\n\n/* the things within each left/right/center section */\n.fc .fc-toolbar > * > * {\n\t/* extra precedence to override button border margins */\n\tfloat: left;\n\tmargin-left: 0.75em;\n}\n\n/* the first thing within each left/center/right section */\n.fc .fc-toolbar > * > :first-child {\n\t/* extra precedence to override button border margins */\n\tmargin-left: 0;\n}\n\n/* title text */\n.fc-toolbar h2 {\n\tmargin: 0;\n}\n\n/* button layering (for border precedence) */\n.fc-toolbar button {\n\tposition: relative;\n}\n\n.fc-toolbar .fc-state-hover,\n.fc-toolbar .ui-state-hover {\n\tz-index: 2;\n}\n\n.fc-toolbar .fc-state-down {\n\tz-index: 3;\n}\n\n.fc-toolbar .fc-state-active,\n.fc-toolbar .ui-state-active {\n\tz-index: 4;\n}\n\n.fc-toolbar button:focus {\n\tz-index: 5;\n}\n\n/* View Structure\n--------------------------------------------------------------------------------------------------*/\n/* undo twitter bootstrap's box-sizing rules. normalizes positioning techniques */\n/* don't do this for the toolbar because we'll want bootstrap to style those buttons as some pt */\n.fc-view-container *,\n.fc-view-container *:before,\n.fc-view-container *:after {\n\t-webkit-box-sizing: content-box;\n\t-moz-box-sizing: content-box;\n\tbox-sizing: content-box;\n}\n\n.fc-view,\n.fc-view > table {\n\t/* so dragged elements can be above the view's main element */\n\tposition: relative;\n\tz-index: 1;\n}\n\n/* BasicView\n--------------------------------------------------------------------------------------------------*/\n/* day row structure */\n.fc-basicWeek-view .fc-content-skeleton,\n.fc-basicDay-view .fc-content-skeleton {\n\t/* we are sure there are no day numbers in these views, so... */\n\tpadding-top: 1px;\n\t/* add a pixel to make sure there are 2px padding above events */\n\tpadding-bottom: 1em;\n\t/* ensure a space at bottom of cell for user selecting/clicking */\n}\n\n.fc-basic-view .fc-body .fc-row {\n\tmin-height: 4em;\n\t/* ensure that all rows are at least this tall */\n}\n\n/* a \"rigid\" row will take up a constant amount of height because content-skeleton is absolute */\n.fc-row.fc-rigid {\n\toverflow: hidden;\n}\n\n.fc-row.fc-rigid .fc-content-skeleton {\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\tright: 0;\n}\n\n/* week and day number styling */\n.fc-basic-view .fc-week-number,\n.fc-basic-view .fc-day-number {\n\tpadding: 0 2px;\n}\n\n.fc-basic-view td.fc-week-number span,\n.fc-basic-view td.fc-day-number {\n\tpadding: 8px;\n}\n\n.fc-basic-view .fc-week-number {\n\ttext-align: center;\n}\n\n.fc-basic-view .fc-week-number span {\n\t/* work around the way we do column resizing and ensure a minimum width */\n\tdisplay: inline-block;\n\tmin-width: 1.25em;\n}\n\n.fc-ltr .fc-basic-view .fc-day-number {\n\ttext-align: right;\n}\n\n.fc-rtl .fc-basic-view .fc-day-number {\n\ttext-align: left;\n}\n\n.fc-day-number.fc-other-month {\n\topacity: 0.3;\n\tfilter: alpha(opacity=30);\n\t/* for IE */\n\t/* opacity with small font can sometimes look too faded\n     might want to set the 'color' property instead\n     making day-numbers bold also fixes the problem */\n}\n\n/* AgendaView all-day area\n--------------------------------------------------------------------------------------------------*/\n.fc-agenda-view .fc-day-grid {\n\tposition: relative;\n\tz-index: 2;\n\t/* so the \"more..\" popover will be over the time grid */\n}\n\n.fc-agenda-view .fc-day-grid .fc-row {\n\tmin-height: 3em;\n\t/* all-day section will never get shorter than this */\n}\n\n.fc-agenda-view .fc-day-grid .fc-row .fc-content-skeleton {\n\tpadding-top: 1px;\n\t/* add a pixel to make sure there are 2px padding above events */\n\tpadding-bottom: 1em;\n\t/* give space underneath events for clicking/selecting days */\n}\n\n/* TimeGrid axis running down the side (for both the all-day area and the slot area)\n--------------------------------------------------------------------------------------------------*/\n.fc .fc-axis {\n\t/* .fc to overcome default cell styles */\n\tvertical-align: middle;\n\tpadding: 0 4px;\n\twhite-space: nowrap;\n}\n\n.fc-ltr .fc-axis {\n\ttext-align: right;\n}\n\n.fc-rtl .fc-axis {\n\ttext-align: left;\n}\n\n.ui-widget td.fc-axis {\n\tfont-weight: normal;\n\t/* overcome jqui theme making it bold */\n}\n\n/* TimeGrid Structure\n--------------------------------------------------------------------------------------------------*/\n.fc-time-grid-container,\n.fc-time-grid {\n\t/* so slats/bg/content/etc positions get scoped within here */\n\tposition: relative;\n\tz-index: 1;\n}\n\n.fc-time-grid {\n\tmin-height: 100%;\n\t/* so if height setting is 'auto', .fc-bg stretches to fill height */\n}\n\n.fc-time-grid table {\n\t/* don't put outer borders on slats/bg/content/etc */\n\tborder: 0 hidden transparent;\n}\n\n.fc-time-grid > .fc-bg {\n\tz-index: 1;\n}\n\n.fc-time-grid .fc-slats,\n.fc-time-grid > hr {\n\t/* the <hr> AgendaView injects when grid is shorter than scroller */\n\tposition: relative;\n\tz-index: 2;\n}\n\n.fc-time-grid .fc-bgevent-skeleton,\n.fc-time-grid .fc-content-skeleton {\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\tright: 0;\n}\n\n.fc-time-grid .fc-bgevent-skeleton {\n\tz-index: 3;\n}\n\n.fc-time-grid .fc-highlight-skeleton {\n\tz-index: 4;\n}\n\n.fc-time-grid .fc-content-skeleton {\n\tz-index: 5;\n}\n\n.fc-time-grid .fc-helper-skeleton {\n\tz-index: 6;\n}\n\n/* TimeGrid Slats (lines that run horizontally)\n--------------------------------------------------------------------------------------------------*/\n.fc-time-grid .fc-slats td {\n\theight: 1.5em;\n\tborder-bottom: 0;\n\t/* each cell is responsible for its top border */\n}\n\n.fc-time-grid .fc-slats .fc-minor td {\n\tborder-top-style: dotted;\n}\n\n.fc-time-grid .fc-slats .ui-widget-content {\n\t/* for jqui theme */\n\tbackground: none;\n\t/* see through to fc-bg */\n}\n\n/* TimeGrid Highlighting Slots\n--------------------------------------------------------------------------------------------------*/\n.fc-time-grid .fc-highlight-container {\n\t/* a div within a cell within the fc-highlight-skeleton */\n\tposition: relative;\n\t/* scopes the left/right of the fc-highlight to be in the column */\n}\n\n.fc-time-grid .fc-highlight {\n\tposition: absolute;\n\tleft: 0;\n\tright: 0;\n\t/* top and bottom will be in by JS */\n}\n\n/* TimeGrid Event Containment\n--------------------------------------------------------------------------------------------------*/\n.fc-time-grid .fc-event-container,\n.fc-time-grid .fc-bgevent-container {\n\t/* a div within a cell within the fc-bgevent-skeleton */\n\tposition: relative;\n}\n\n.fc-ltr .fc-time-grid .fc-event-container {\n\t/* space on the sides of events for LTR (default) */\n\tmargin: 0 2.5% 0 2px;\n}\n\n.fc-rtl .fc-time-grid .fc-event-container {\n\t/* space on the sides of events for RTL */\n\tmargin: 0 2px 0 2.5%;\n}\n\n.fc-time-grid .fc-event,\n.fc-time-grid .fc-bgevent {\n\tposition: absolute;\n\tz-index: 1;\n\t/* scope inner z-index's */\n}\n\n.fc-time-grid .fc-bgevent {\n\t/* background events always span full width */\n\tleft: 0;\n\tright: 0;\n}\n\n/* Generic Vertical Event\n--------------------------------------------------------------------------------------------------*/\n.fc-v-event.fc-not-start {\n\t/* events that are continuing from another day */\n\t/* replace space made by the top border with padding */\n\tborder-top-width: 0;\n\tpadding-top: 1px;\n\t/* remove top rounded corners */\n\tborder-top-left-radius: 0;\n\tborder-top-right-radius: 0;\n}\n\n.fc-v-event.fc-not-end {\n\t/* replace space made by the top border with padding */\n\tborder-bottom-width: 0;\n\tpadding-bottom: 1px;\n\t/* remove bottom rounded corners */\n\tborder-bottom-left-radius: 0;\n\tborder-bottom-right-radius: 0;\n}\n\n/* TimeGrid Event Styling\n----------------------------------------------------------------------------------------------------\nWe use the full \"fc-time-grid-event\" class instead of using descendants because the event won't\nbe a descendant of the grid when it is being dragged.\n*/\n.fc-time-grid-event {\n\toverflow: hidden;\n\t/* don't let the bg flow over rounded corners */\n}\n\n.fc-time-grid-event .fc-time,\n.fc-time-grid-event .fc-title {\n\tpadding: 0 1px;\n}\n\n.fc-time-grid-event .fc-time {\n\tfont-size: 0.85em;\n\twhite-space: nowrap;\n}\n\n/* short mode, where time and title are on the same line */\n.fc-time-grid-event.fc-short .fc-content {\n\t/* don't wrap to second line (now that contents will be inline) */\n\twhite-space: nowrap;\n}\n\n.fc-time-grid-event.fc-short .fc-time,\n.fc-time-grid-event.fc-short .fc-title {\n\t/* put the time and title on the same line */\n\tdisplay: inline-block;\n\tvertical-align: top;\n}\n\n.fc-time-grid-event.fc-short .fc-time span {\n\tdisplay: none;\n\t/* don't display the full time text... */\n}\n\n.fc-time-grid-event.fc-short .fc-time:before {\n\tcontent: attr(data-start);\n\t/* ...instead, display only the start time */\n}\n\n.fc-time-grid-event.fc-short .fc-time:after {\n\tcontent: \" - \";\n\t/* seperate with a dash, wrapped in nbsp's */\n}\n\n.fc-time-grid-event.fc-short .fc-title {\n\tfont-size: 0.85em;\n\t/* make the title text the same size as the time */\n\tpadding: 0;\n\t/* undo padding from above */\n}\n\n/* resizer */\n.fc-time-grid-event .fc-resizer {\n\tleft: 0;\n\tright: 0;\n\tbottom: 0;\n\theight: 8px;\n\toverflow: hidden;\n\tline-height: 8px;\n\tfont-size: 11px;\n\tfont-family: monospace;\n\ttext-align: center;\n\tcursor: s-resize;\n}\n\n.fc-time-grid-event .fc-resizer:after {\n\tcontent: \"=\";\n}\n\n.card-calendar .content {\n\tpadding: 0 !important;\n}\n.card-calendar .fc-toolbar {\n\tpadding-top: 15px;\n\tpadding-left: 15px;\n\tpadding-right: 15px;\n}\n.card-calendar .fc td:first-child {\n\tborder-left: 0;\n}\n.card-calendar .fc td:last-child {\n\tborder-right: 0;\n}\n.card-calendar .fc-basic-view td:last-child.fc-week-number span,\n.card-calendar .fc-basic-view td:last-child.fc-day-number {\n\tpadding-right: 15px;\n}\n.card-calendar .fc .fc-day-header:last-child {\n\tpadding-right: 15px;\n}\n.card-calendar .fc .fc-row:last-child td {\n\tborder-bottom: 0;\n}\n.card-calendar .fc .fc-body .fc-widget-content {\n\tborder-bottom: 0;\n}\n\n/*--------------------------------\n\nnucleo-icons Web Font - built using nucleoapp.com\nLicense - nucleoapp.com/license/\n\n-------------------------------- */\n@font-face {\n\tfont-family: \"nucleo-icons\";\n\tsrc: url(\"~assets/fonts/nucleo-icons.eot\");\n\tsrc: url(\"~assets/fonts/nucleo-icons.eot\") format(\"embedded-opentype\"),\n\t\turl(\"~assets/fonts/nucleo-icons.woff2\") format(\"woff2\"),\n\t\turl(\"~assets/fonts/nucleo-icons.woff\") format(\"woff\"),\n\t\turl(\"~assets/fonts/nucleo-icons.ttf\") format(\"truetype\");\n\tfont-weight: normal;\n\tfont-style: normal;\n}\n/*------------------------\n\tbase class definition\n-------------------------*/\n.nc-icon {\n\tdisplay: inline-block;\n\tfont: normal normal normal 14px/1 \"nucleo-icons\";\n\tfont-size: inherit;\n\ttext-transform: none;\n\t/* Better Font Rendering */\n\t-webkit-font-smoothing: antialiased;\n\t-moz-osx-font-smoothing: grayscale;\n}\n\n/*------------------------\n  change icon size\n-------------------------*/\n.nc-icon.lg {\n\tfont-size: 1.33333333em;\n\tvertical-align: -16%;\n}\n\n.nc-icon.x2 {\n\tfont-size: 2em;\n}\n\n.nc-icon.x3 {\n\tfont-size: 3em;\n}\n\n/*----------------------------------\n  add a square/circle background\n-----------------------------------*/\n.nc-icon.square,\n.nc-icon.circle {\n\tpadding: 0.33333333em;\n\tvertical-align: -16%;\n\tbackground-color: #eee;\n}\n\n.nc-icon.circle {\n\tborder-radius: 50%;\n}\n\n/*------------------------\n  list icons\n-------------------------*/\n.nc-icon-ul {\n\tpadding-left: 0;\n\tmargin-left: 2.14285714em;\n\tlist-style-type: none;\n}\n\n.nc-icon-ul > li {\n\tposition: relative;\n}\n\n.nc-icon-ul > li > .nc-icon {\n\tposition: absolute;\n\tleft: -1.57142857em;\n\ttop: 0.14285714em;\n\ttext-align: center;\n}\n\n.nc-icon-ul > li > .nc-icon.lg {\n\ttop: 0;\n\tleft: -1.35714286em;\n}\n\n.nc-icon-ul > li > .nc-icon.circle,\n.nc-icon-ul > li > .nc-icon.square {\n\ttop: -0.19047619em;\n\tleft: -1.9047619em;\n}\n\n/*------------------------\n  spinning icons\n-------------------------*/\n.nc-icon.spin {\n\t-webkit-animation: nc-icon-spin 2s infinite linear;\n\t-moz-animation: nc-icon-spin 2s infinite linear;\n\tanimation: nc-icon-spin 2s infinite linear;\n}\n\n@-webkit-keyframes nc-icon-spin {\n\t0% {\n\t\t-webkit-transform: rotate(0deg);\n\t}\n\t100% {\n\t\t-webkit-transform: rotate(360deg);\n\t}\n}\n@-moz-keyframes nc-icon-spin {\n\t0% {\n\t\t-moz-transform: rotate(0deg);\n\t}\n\t100% {\n\t\t-moz-transform: rotate(360deg);\n\t}\n}\n@keyframes nc-icon-spin {\n\t0% {\n\t\t-webkit-transform: rotate(0deg);\n\t\t-moz-transform: rotate(0deg);\n\t\t-ms-transform: rotate(0deg);\n\t\t-o-transform: rotate(0deg);\n\t\ttransform: rotate(0deg);\n\t}\n\t100% {\n\t\t-webkit-transform: rotate(360deg);\n\t\t-moz-transform: rotate(360deg);\n\t\t-ms-transform: rotate(360deg);\n\t\t-o-transform: rotate(360deg);\n\t\ttransform: rotate(360deg);\n\t}\n}\n/*------------------------\n  rotated/flipped icons\n-------------------------*/\n.nc-icon.rotate-90 {\n\tfilter: progid:DXImageTransform.Microsoft.BasicImage(rotation=1);\n\t-webkit-transform: rotate(90deg);\n\t-moz-transform: rotate(90deg);\n\t-ms-transform: rotate(90deg);\n\t-o-transform: rotate(90deg);\n\ttransform: rotate(90deg);\n}\n\n.nc-icon.rotate-180 {\n\tfilter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);\n\t-webkit-transform: rotate(180deg);\n\t-moz-transform: rotate(180deg);\n\t-ms-transform: rotate(180deg);\n\t-o-transform: rotate(180deg);\n\ttransform: rotate(180deg);\n}\n\n.nc-icon.rotate-270 {\n\tfilter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3);\n\t-webkit-transform: rotate(270deg);\n\t-moz-transform: rotate(270deg);\n\t-ms-transform: rotate(270deg);\n\t-o-transform: rotate(270deg);\n\ttransform: rotate(270deg);\n}\n\n.nc-icon.flip-y {\n\tfilter: progid:DXImageTransform.Microsoft.BasicImage(rotation=0);\n\t-webkit-transform: scale(-1, 1);\n\t-moz-transform: scale(-1, 1);\n\t-ms-transform: scale(-1, 1);\n\t-o-transform: scale(-1, 1);\n\ttransform: scale(-1, 1);\n}\n\n.nc-icon.flip-x {\n\tfilter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);\n\t-webkit-transform: scale(1, -1);\n\t-moz-transform: scale(1, -1);\n\t-ms-transform: scale(1, -1);\n\t-o-transform: scale(1, -1);\n\ttransform: scale(1, -1);\n}\n\n/*------------------------\n\tfont icons\n-------------------------*/\n.nc-air-baloon::before {\n\tcontent: \"\\ea01\";\n}\n\n.nc-album-2::before {\n\tcontent: \"\\ea02\";\n}\n\n.nc-alert-circle-i::before {\n\tcontent: \"\\ea04\";\n}\n\n.nc-align-center::before {\n\tcontent: \"\\ea03\";\n}\n\n.nc-align-left-2::before {\n\tcontent: \"\\ea05\";\n}\n\n.nc-ambulance::before {\n\tcontent: \"\\ea06\";\n}\n\n.nc-app::before {\n\tcontent: \"\\ea07\";\n}\n\n.nc-atom::before {\n\tcontent: \"\\ea08\";\n}\n\n.nc-badge::before {\n\tcontent: \"\\ea09\";\n}\n\n.nc-bag-16::before {\n\tcontent: \"\\ea0a\";\n}\n\n.nc-bank::before {\n\tcontent: \"\\ea0b\";\n}\n\n.nc-basket::before {\n\tcontent: \"\\ea0c\";\n}\n\n.nc-bell-55::before {\n\tcontent: \"\\ea0d\";\n}\n\n.nc-bold::before {\n\tcontent: \"\\ea0e\";\n}\n\n.nc-book-bookmark::before {\n\tcontent: \"\\ea0f\";\n}\n\n.nc-bookmark-2::before {\n\tcontent: \"\\ea10\";\n}\n\n.nc-box-2::before {\n\tcontent: \"\\ea11\";\n}\n\n.nc-box::before {\n\tcontent: \"\\ea12\";\n}\n\n.nc-briefcase-24::before {\n\tcontent: \"\\ea13\";\n}\n\n.nc-bulb-63::before {\n\tcontent: \"\\ea14\";\n}\n\n.nc-bullet-list-67::before {\n\tcontent: \"\\ea15\";\n}\n\n.nc-bus-front-12::before {\n\tcontent: \"\\ea16\";\n}\n\n.nc-button-pause::before {\n\tcontent: \"\\ea17\";\n}\n\n.nc-button-play::before {\n\tcontent: \"\\ea18\";\n}\n\n.nc-button-power::before {\n\tcontent: \"\\ea19\";\n}\n\n.nc-calendar-60::before {\n\tcontent: \"\\ea1a\";\n}\n\n.nc-camera-compact::before {\n\tcontent: \"\\ea1b\";\n}\n\n.nc-caps-small::before {\n\tcontent: \"\\ea1c\";\n}\n\n.nc-cart-simple::before {\n\tcontent: \"\\ea1d\";\n}\n\n.nc-chart-bar-32::before {\n\tcontent: \"\\ea1e\";\n}\n\n.nc-chart-pie-36::before {\n\tcontent: \"\\ea1f\";\n}\n\n.nc-chat-33::before {\n\tcontent: \"\\ea20\";\n}\n\n.nc-check-2::before {\n\tcontent: \"\\ea21\";\n}\n\n.nc-circle-10::before {\n\tcontent: \"\\ea22\";\n}\n\n.nc-cloud-download-93::before {\n\tcontent: \"\\ea23\";\n}\n\n.nc-cloud-upload-94::before {\n\tcontent: \"\\ea24\";\n}\n\n.nc-compass-05::before {\n\tcontent: \"\\ea25\";\n}\n\n.nc-controller-modern::before {\n\tcontent: \"\\ea26\";\n}\n\n.nc-credit-card::before {\n\tcontent: \"\\ea27\";\n}\n\n.nc-delivery-fast::before {\n\tcontent: \"\\ea28\";\n}\n\n.nc-diamond::before {\n\tcontent: \"\\ea29\";\n}\n\n.nc-email-85::before {\n\tcontent: \"\\ea2a\";\n}\n\n.nc-favourite-28::before {\n\tcontent: \"\\ea2b\";\n}\n\n.nc-glasses-2::before {\n\tcontent: \"\\ea2c\";\n}\n\n.nc-globe-2::before {\n\tcontent: \"\\ea2d\";\n}\n\n.nc-globe::before {\n\tcontent: \"\\ea2e\";\n}\n\n.nc-hat-3::before {\n\tcontent: \"\\ea2f\";\n}\n\n.nc-headphones::before {\n\tcontent: \"\\ea30\";\n}\n\n.nc-html5::before {\n\tcontent: \"\\ea31\";\n}\n\n.nc-image::before {\n\tcontent: \"\\ea32\";\n}\n\n.nc-istanbul::before {\n\tcontent: \"\\ea33\";\n}\n\n.nc-key-25::before {\n\tcontent: \"\\ea34\";\n}\n\n.nc-laptop::before {\n\tcontent: \"\\ea35\";\n}\n\n.nc-layout-11::before {\n\tcontent: \"\\ea36\";\n}\n\n.nc-lock-circle-open::before {\n\tcontent: \"\\ea37\";\n}\n\n.nc-map-big::before {\n\tcontent: \"\\ea38\";\n}\n\n.nc-minimal-down::before {\n\tcontent: \"\\ea39\";\n}\n\n.nc-minimal-left::before {\n\tcontent: \"\\ea3a\";\n}\n\n.nc-minimal-right::before {\n\tcontent: \"\\ea3b\";\n}\n\n.nc-minimal-up::before {\n\tcontent: \"\\ea3c\";\n}\n\n.nc-mobile::before {\n\tcontent: \"\\ea3d\";\n}\n\n.nc-money-coins::before {\n\tcontent: \"\\ea3e\";\n}\n\n.nc-note-03::before {\n\tcontent: \"\\ea3f\";\n}\n\n.nc-palette::before {\n\tcontent: \"\\ea40\";\n}\n\n.nc-paper::before {\n\tcontent: \"\\ea41\";\n}\n\n.nc-pin-3::before {\n\tcontent: \"\\ea42\";\n}\n\n.nc-planet::before {\n\tcontent: \"\\ea43\";\n}\n\n.nc-refresh-69::before {\n\tcontent: \"\\ea44\";\n}\n\n.nc-ruler-pencil::before {\n\tcontent: \"\\ea45\";\n}\n\n.nc-satisfied::before {\n\tcontent: \"\\ea46\";\n}\n\n.nc-scissors::before {\n\tcontent: \"\\ea47\";\n}\n\n.nc-send::before {\n\tcontent: \"\\ea48\";\n}\n\n.nc-settings-gear-65::before {\n\tcontent: \"\\ea49\";\n}\n\n.nc-settings::before {\n\tcontent: \"\\ea4a\";\n}\n\n.nc-share-66::before {\n\tcontent: \"\\ea4b\";\n}\n\n.nc-shop::before {\n\tcontent: \"\\ea4c\";\n}\n\n.nc-simple-add::before {\n\tcontent: \"\\ea4d\";\n}\n\n.nc-simple-delete::before {\n\tcontent: \"\\ea4e\";\n}\n\n.nc-simple-remove::before {\n\tcontent: \"\\ea4f\";\n}\n\n.nc-single-02::before {\n\tcontent: \"\\ea50\";\n}\n\n.nc-single-copy-04::before {\n\tcontent: \"\\ea51\";\n}\n\n.nc-sound-wave::before {\n\tcontent: \"\\ea52\";\n}\n\n.nc-spaceship::before {\n\tcontent: \"\\ea53\";\n}\n\n.nc-sun-fog-29::before {\n\tcontent: \"\\ea54\";\n}\n\n.nc-support-17::before {\n\tcontent: \"\\ea55\";\n}\n\n.nc-tablet-2::before {\n\tcontent: \"\\ea56\";\n}\n\n.nc-tag-content::before {\n\tcontent: \"\\ea57\";\n}\n\n.nc-tap-01::before {\n\tcontent: \"\\ea58\";\n}\n\n.nc-tie-bow::before {\n\tcontent: \"\\ea59\";\n}\n\n.nc-tile-56::before {\n\tcontent: \"\\ea5a\";\n}\n\n.nc-time-alarm::before {\n\tcontent: \"\\ea5b\";\n}\n\n.nc-touch-id::before {\n\tcontent: \"\\ea5c\";\n}\n\n.nc-trophy::before {\n\tcontent: \"\\ea5d\";\n}\n\n.nc-tv-2::before {\n\tcontent: \"\\ea5e\";\n}\n\n.nc-umbrella-13::before {\n\tcontent: \"\\ea5f\";\n}\n\n.nc-user-run::before {\n\tcontent: \"\\ea60\";\n}\n\n.nc-vector::before {\n\tcontent: \"\\ea61\";\n}\n\n.nc-watch-time::before {\n\tcontent: \"\\ea62\";\n}\n\n.nc-world-2::before {\n\tcontent: \"\\ea63\";\n}\n\n.nc-zoom-split::before {\n\tcontent: \"\\ea64\";\n}\n\n.nc-search-icon::before {\n\tcontent: \"\\1F50E\"; /* Unicode for horizontal bar with circle */\n}\n\n.btn:hover,\n.btn:focus,\n.btn:active,\n.btn.active,\n.btn:active:focus,\n.btn:active:hover,\n.btn.active:focus,\n.btn.active:hover,\n.show > .btn.dropdown-toggle,\n.show > .btn.dropdown-toggle:focus,\n.show > .btn.dropdown-toggle:hover,\n.navbar .navbar-nav > a.btn:hover,\n.navbar .navbar-nav > a.btn:focus,\n.navbar .navbar-nav > a.btn:active,\n.navbar .navbar-nav > a.btn.active,\n.navbar .navbar-nav > a.btn:active:focus,\n.navbar .navbar-nav > a.btn:active:hover,\n.navbar .navbar-nav > a.btn.active:focus,\n.navbar .navbar-nav > a.btn.active:hover,\n.show > .navbar .navbar-nav > a.btn.dropdown-toggle,\n.show > .navbar .navbar-nav > a.btn.dropdown-toggle:focus,\n.show > .navbar .navbar-nav > a.btn.dropdown-toggle:hover {\n\tbox-shadow: none;\n}\n.btn:not([data-action]):hover,\n.navbar .navbar-nav > a.btn:not([data-action]):hover {\n\tbox-shadow: none;\n}\n.btn.disabled,\n.btn.disabled:hover,\n.btn.disabled:focus,\n.btn.disabled.focus,\n.btn.disabled:active,\n.btn.disabled.active,\n.btn:disabled,\n.btn:disabled:hover,\n.btn:disabled:focus,\n.btn:disabled.focus,\n.btn:disabled:active,\n.btn:disabled.active,\n.btn[disabled],\n.btn[disabled]:hover,\n.btn[disabled]:focus,\n.btn[disabled].focus,\n.btn[disabled]:active,\n.btn[disabled].active,\nfieldset[disabled] .btn,\nfieldset[disabled] .btn:hover,\nfieldset[disabled] .btn:focus,\nfieldset[disabled] .btn.focus,\nfieldset[disabled] .btn:active,\nfieldset[disabled] .btn.active,\n.navbar .navbar-nav > a.btn.disabled,\n.navbar .navbar-nav > a.btn.disabled:hover,\n.navbar .navbar-nav > a.btn.disabled:focus,\n.navbar .navbar-nav > a.btn.disabled.focus,\n.navbar .navbar-nav > a.btn.disabled:active,\n.navbar .navbar-nav > a.btn.disabled.active,\n.navbar .navbar-nav > a.btn:disabled,\n.navbar .navbar-nav > a.btn:disabled:hover,\n.navbar .navbar-nav > a.btn:disabled:focus,\n.navbar .navbar-nav > a.btn:disabled.focus,\n.navbar .navbar-nav > a.btn:disabled:active,\n.navbar .navbar-nav > a.btn:disabled.active,\n.navbar .navbar-nav > a.btn[disabled],\n.navbar .navbar-nav > a.btn[disabled]:hover,\n.navbar .navbar-nav > a.btn[disabled]:focus,\n.navbar .navbar-nav > a.btn[disabled].focus,\n.navbar .navbar-nav > a.btn[disabled]:active,\n.navbar .navbar-nav > a.btn[disabled].active,\nfieldset[disabled] .navbar .navbar-nav > a.btn,\nfieldset[disabled] .navbar .navbar-nav > a.btn:hover,\nfieldset[disabled] .navbar .navbar-nav > a.btn:focus,\nfieldset[disabled] .navbar .navbar-nav > a.btn.focus,\nfieldset[disabled] .navbar .navbar-nav > a.btn:active,\nfieldset[disabled] .navbar .navbar-nav > a.btn.active {\n\tbackground-color: #1c77c3;\n\tborder-color: #1c77c3;\n}\n.btn.btn-simple,\n.navbar .navbar-nav > a.btn.btn-simple {\n\tcolor: #1c77c3;\n\tborder-color: #1c77c3;\n}\n\n.btn:hover,\n.btn:focus,\n.navbar .navbar-nav > a.btn:hover,\n.navbar .navbar-nav > a.btn:focus {\n\topacity: 1;\n\tfilter: alpha(opacity=100);\n\toutline: 0 !important;\n}\n.btn:active,\n.btn.active,\n.open > .btn.dropdown-toggle,\n.navbar .navbar-nav > a.btn:active,\n.navbar .navbar-nav > a.btn.active,\n.open > .navbar .navbar-nav > a.btn.dropdown-toggle {\n\t-webkit-box-shadow: none;\n\tbox-shadow: none;\n\toutline: 0 !important;\n}\n.btn .badge,\n.navbar .navbar-nav > a.btn .badge {\n\tmargin: 0;\n}\n.btn.btn-icon,\n.navbar .navbar-nav > a.btn.btn-icon {\n\theight: 2rem;\n\tmin-width: 2rem;\n\twidth: 2rem;\n\tpadding: 0;\n\tfont-size: 0.9375rem;\n\toverflow: hidden;\n\tposition: relative;\n\tline-height: normal;\n}\n.btn.btn-icon.btn-simple,\n.navbar .navbar-nav > a.btn.btn-icon.btn-simple {\n\tpadding: 0;\n}\n.btn.btn-icon.btn-sm,\n.navbar .navbar-nav > a.btn.btn-icon.btn-sm {\n\theight: 1.875rem;\n\tmin-width: 1.875rem;\n\twidth: 1.875rem;\n}\n.btn.btn-icon.btn-sm .fa,\n.btn.btn-icon.btn-sm .far,\n.btn.btn-icon.btn-sm .fas,\n.btn.btn-icon.btn-sm .nc-icon,\n.navbar .navbar-nav > a.btn.btn-icon.btn-sm .fa,\n.navbar .navbar-nav > a.btn.btn-icon.btn-sm .far,\n.navbar .navbar-nav > a.btn.btn-icon.btn-sm .fas,\n.navbar .navbar-nav > a.btn.btn-icon.btn-sm .nc-icon {\n\tfont-size: 0.6875rem;\n}\n.btn.btn-icon.btn-lg,\n.navbar .navbar-nav > a.btn.btn-icon.btn-lg {\n\theight: 3.6rem;\n\tmin-width: 3.6rem;\n\twidth: 3.6rem;\n}\n.btn.btn-icon.btn-lg .fa,\n.btn.btn-icon.btn-lg .far,\n.btn.btn-icon.btn-lg .fas,\n.btn.btn-icon.btn-lg .nc-icon,\n.navbar .navbar-nav > a.btn.btn-icon.btn-lg .fa,\n.navbar .navbar-nav > a.btn.btn-icon.btn-lg .far,\n.navbar .navbar-nav > a.btn.btn-icon.btn-lg .fas,\n.navbar .navbar-nav > a.btn.btn-icon.btn-lg .nc-icon {\n\tfont-size: 1.325rem;\n}\n.btn.btn-icon:not(.btn-footer) .nc-icon,\n.btn.btn-icon:not(.btn-footer) .fa,\n.btn.btn-icon:not(.btn-footer) .far,\n.btn.btn-icon:not(.btn-footer) .fas,\n.navbar .navbar-nav > a.btn.btn-icon:not(.btn-footer) .nc-icon,\n.navbar .navbar-nav > a.btn.btn-icon:not(.btn-footer) .fa,\n.navbar .navbar-nav > a.btn.btn-icon:not(.btn-footer) .far,\n.navbar .navbar-nav > a.btn.btn-icon:not(.btn-footer) .fas {\n\tposition: absolute;\n\ttop: 50%;\n\tleft: 50%;\n\ttransform: translate(-12px, -12px);\n\tline-height: 1.5626rem;\n\twidth: 24px;\n}\n.btn.btn-icon.btn-neutral,\n.navbar .navbar-nav > a.btn.btn-icon.btn-neutral {\n\tfont-size: 20px;\n}\n.btn:not(.btn-icon) .nc-icon,\n.navbar .navbar-nav > a.btn:not(.btn-icon) .nc-icon {\n\tposition: relative;\n\ttop: 1px;\n}\n\n.btn-default {\n\tbackground-color: #65adff;\n\tcolor: #ffffff;\n}\n.btn-default:hover,\n.btn-default:focus,\n.btn-default:active,\n.btn-default.active,\n.btn-default:active:focus,\n.btn-default:active:hover,\n.btn-default.active:focus,\n.btn-default.active:hover,\n.show > .btn-default.dropdown-toggle,\n.show > .btn-default.dropdown-toggle:focus,\n.show > .btn-default.dropdown-toggle:hover {\n\tbackground-color: #403d39 !important;\n\tcolor: #ffffff !important;\n\tbox-shadow: none !important;\n}\n.btn-default:not([data-action]):hover {\n\tbox-shadow: none;\n}\n.btn-default.disabled,\n.btn-default.disabled:hover,\n.btn-default.disabled:focus,\n.btn-default.disabled.focus,\n.btn-default.disabled:active,\n.btn-default.disabled.active,\n.btn-default:disabled,\n.btn-default:disabled:hover,\n.btn-default:disabled:focus,\n.btn-default:disabled.focus,\n.btn-default:disabled:active,\n.btn-default:disabled.active,\n.btn-default[disabled],\n.btn-default[disabled]:hover,\n.btn-default[disabled]:focus,\n.btn-default[disabled].focus,\n.btn-default[disabled]:active,\n.btn-default[disabled].active,\nfieldset[disabled] .btn-default,\nfieldset[disabled] .btn-default:hover,\nfieldset[disabled] .btn-default:focus,\nfieldset[disabled] .btn-default.focus,\nfieldset[disabled] .btn-default:active,\nfieldset[disabled] .btn-default.active {\n\tbackground-color: #65adff;\n\tborder-color: #65adff;\n}\n.btn-default.btn-simple {\n\tcolor: #65adff;\n\tborder-color: #65adff;\n}\n.btn-default.btn-simple:hover,\n.btn-default.btn-simple:focus,\n.btn-default.btn-simple:active {\n\tbackground-color: transparent;\n\tcolor: #403d39;\n\tborder-color: #403d39;\n\tbox-shadow: none;\n}\n\n.btn-default.btn-link:focus,\n.btn-default.btn-link:active,\n.btn-default.btn-link:active:focus {\n\tbackground-color: transparent;\n\tcolor: #403d39;\n\ttext-decoration: none;\n\tbox-shadow: none;\n}\n\n.btn-primary {\n\tbackground-color: #1c77c3;\n\tcolor: #ffffff;\n}\n.btn-primary:hover,\n.btn-primary:focus,\n.btn-primary:active,\n.btn-primary.active,\n.btn-primary:active:focus,\n.btn-primary:active:hover,\n.btn-primary.active:focus,\n.btn-primary.active:hover,\n.show > .btn-primary.dropdown-toggle,\n.show > .btn-primary.dropdown-toggle:focus,\n.show > .btn-primary.dropdown-toggle:hover {\n\tbackground-color: #1c68a6 !important;\n\tcolor: #ffffff !important;\n\tbox-shadow: none !important;\n}\n.btn-primary:not([data-action]):hover {\n\tbox-shadow: none;\n}\n.btn-primary.disabled,\n.btn-primary.disabled:hover,\n.btn-primary.disabled:focus,\n.btn-primary.disabled.focus,\n.btn-primary.disabled:active,\n.btn-primary.disabled.active,\n.btn-primary:disabled,\n.btn-primary:disabled:hover,\n.btn-primary:disabled:focus,\n.btn-primary:disabled.focus,\n.btn-primary:disabled:active,\n.btn-primary:disabled.active,\n.btn-primary[disabled],\n.btn-primary[disabled]:hover,\n.btn-primary[disabled]:focus,\n.btn-primary[disabled].focus,\n.btn-primary[disabled]:active,\n.btn-primary[disabled].active,\nfieldset[disabled] .btn-primary,\nfieldset[disabled] .btn-primary:hover,\nfieldset[disabled] .btn-primary:focus,\nfieldset[disabled] .btn-primary.focus,\nfieldset[disabled] .btn-primary:active,\nfieldset[disabled] .btn-primary.active {\n\tbackground-color: #1c77c3;\n\tborder-color: #1c77c3;\n}\n.btn-primary.btn-simple {\n\tcolor: #1c77c3;\n\tborder-color: #1c77c3;\n}\n.btn-primary.btn-simple:hover,\n.btn-primary.btn-simple:focus,\n.btn-primary.btn-simple:active {\n\tbackground-color: transparent;\n\tcolor: #165c96;\n\tborder-color: #165c96;\n\tbox-shadow: none;\n}\n.btn-primary.btn-link {\n\tcolor: #1c77c3;\n}\n.btn-primary.btn-link:focus,\n.btn-primary.btn-link:active,\n.btn-primary.btn-link:active:focus {\n\tbackground-color: transparent;\n\tcolor: #165c96;\n\ttext-decoration: none;\n\tbox-shadow: none;\n}\n\n.btn-primary-dark {\n\tbackground-color: #004e89;\n\tcolor: #ffffff;\n}\n.btn-primary-dark:hover,\n.btn-primary-dark:focus,\n.btn-primary-dark:active,\n.btn-primary-dark.active,\n.btn-primary-dark:active:focus,\n.btn-primary-dark:active:hover,\n.btn-primary-dark.active:focus,\n.btn-primary-dark.active:hover,\n.show > .btn-primary-dark.dropdown-toggle,\n.show > .btn-primary-dark.dropdown-toggle:focus,\n.show > .btn-primary-dark.dropdown-toggle:hover {\n\tbackground-color: #0a3253 !important;\n\tcolor: #ffffff !important;\n\tbox-shadow: none !important;\n}\n.btn-primary-dark:not([data-action]):hover {\n\tbox-shadow: none;\n}\n.btn-primary-dark.disabled,\n.btn-primary-dark.disabled:hover,\n.btn-primary-dark.disabled:focus,\n.btn-primary-dark.disabled.focus,\n.btn-primary-dark.disabled:active,\n.btn-primary-dark.disabled.active,\n.btn-primary-dark:disabled,\n.btn-primary-dark:disabled:hover,\n.btn-primary-dark:disabled:focus,\n.btn-primary-dark:disabled.focus,\n.btn-primary-dark:disabled:active,\n.btn-primary-dark:disabled.active,\n.btn-primary-dark[disabled],\n.btn-primary-dark[disabled]:hover,\n.btn-primary-dark[disabled]:focus,\n.btn-primary-dark[disabled].focus,\n.btn-primary-dark[disabled]:active,\n.btn-primary-dark[disabled].active,\nfieldset[disabled] .btn-primary-dark,\nfieldset[disabled] .btn-primary-dark:hover,\nfieldset[disabled] .btn-primary-dark:focus,\nfieldset[disabled] .btn-primary-dark.focus,\nfieldset[disabled] .btn-primary-dark:active,\nfieldset[disabled] .btn-primary-dark.active {\n\tbackground-color: #004e89;\n\tborder-color: #004e89;\n}\n.btn-primary-dark.btn-simple {\n\tcolor: #004e89;\n\tborder-color: #004e89;\n}\n.btn-primary-dark.btn-simple:hover,\n.btn-primary-dark.btn-simple:focus,\n.btn-primary-dark.btn-simple:active {\n\tbackground-color: transparent;\n\tcolor: #0a3253;\n\tborder-color: #0a3253;\n\tbox-shadow: none;\n}\n.btn-primary-dark.btn-link {\n\tcolor: #004e89;\n}\n.btn-primary-dark.btn-link:hover,\n.btn-primary-dark.btn-link:focus,\n.btn-primary-dark.btn-link:active,\n.btn-primary-dark.btn-link:active:focus {\n\tbackground-color: transparent;\n\tcolor: #0a3253;\n\ttext-decoration: none;\n\tbox-shadow: none;\n}\n\n.btn-secondary {\n\tbackground-color: #1f84d6;\n\tcolor: #ffffff;\n}\n.btn-secondary:hover,\n.btn-secondary:focus,\n.btn-secondary:active,\n.btn-secondary.active,\n.btn-secondary:active:focus,\n.btn-secondary:active:hover,\n.btn-secondary.active:focus,\n.btn-secondary.active:hover,\n.show > .btn-secondary.dropdown-toggle,\n.show > .btn-secondary.dropdown-toggle:focus,\n.show > .btn-secondary.dropdown-toggle:hover {\n\tbackground-color: inherit;\n\tcolor: inherit;\n\tbox-shadow: none;\n}\n.btn-secondary:not([data-action]):hover {\n\tbox-shadow: none;\n}\n.btn-secondary.disabled,\n.btn-secondary.disabled:hover,\n.btn-secondary.disabled:focus,\n.btn-secondary.disabled.focus,\n.btn-secondary.disabled:active,\n.btn-secondary.disabled.active,\n.btn-secondary:disabled,\n.btn-secondary:disabled:hover,\n.btn-secondary:disabled:focus,\n.btn-secondary:disabled.focus,\n.btn-secondary:disabled:active,\n.btn-secondary:disabled.active,\n.btn-secondary[disabled],\n.btn-secondary[disabled]:hover,\n.btn-secondary[disabled]:focus,\n.btn-secondary[disabled].focus,\n.btn-secondary[disabled]:active,\n.btn-secondary[disabled].active,\nfieldset[disabled] .btn-secondary,\nfieldset[disabled] .btn-secondary:hover,\nfieldset[disabled] .btn-secondary:focus,\nfieldset[disabled] .btn-secondary.focus,\nfieldset[disabled] .btn-secondary:active,\nfieldset[disabled] .btn-secondary.active {\n\tbackground-color: #1f84d6;\n\tborder-color: #1f84d6;\n}\n.btn-secondary.btn-simple {\n\tcolor: #1f84d6;\n\tborder-color: #1f84d6;\n}\n.btn-secondary.btn-simple:hover,\n.btn-secondary.btn-simple:focus,\n.btn-secondary.btn-simple:active {\n\tbackground-color: transparent;\n\tcolor: #1969a9;\n\tborder-color: #1969a9;\n\tbox-shadow: none;\n}\n.btn-secondary.btn-link {\n\tcolor: #5a5a5a;\n}\n.btn-secondary.btn-link:hover,\n.btn-secondary.btn-link:focus,\n.btn-secondary.btn-link:active,\n.btn-secondary.btn-link:active:focus {\n\tbackground-color: transparent;\n\tcolor: #1969a9;\n\ttext-decoration: none;\n\tbox-shadow: none;\n}\n\n.btn-success {\n\tbackground-color: #28a745;\n\tcolor: #ffffff;\n}\n.btn-success:hover,\n.btn-success:focus,\n.btn-success:active,\n.btn-success.active,\n.btn-success:active:focus,\n.btn-success:active:hover,\n.btn-success.active:focus,\n.btn-success.active:hover,\n.show > .btn-success.dropdown-toggle,\n.show > .btn-success.dropdown-toggle:focus,\n.show > .btn-success.dropdown-toggle:hover {\n\tbackground-color: #146f43;\n\tcolor: #ffffff !important;\n\tbox-shadow: none !important;\n}\n.btn-success:not([data-action]):hover {\n\tbox-shadow: none;\n}\n.btn-success.disabled,\n.btn-success.disabled:hover,\n.btn-success.disabled:focus,\n.btn-success.disabled.focus,\n.btn-success.disabled:active,\n.btn-success.disabled.active,\n.btn-success:disabled,\n.btn-success:disabled:hover,\n.btn-success:disabled:focus,\n.btn-success:disabled.focus,\n.btn-success:disabled:active,\n.btn-success:disabled.active,\n.btn-success[disabled],\n.btn-success[disabled]:hover,\n.btn-success[disabled]:focus,\n.btn-success[disabled].focus,\n.btn-success[disabled]:active,\n.btn-success[disabled].active,\nfieldset[disabled] .btn-success,\nfieldset[disabled] .btn-success:hover,\nfieldset[disabled] .btn-success:focus,\nfieldset[disabled] .btn-success.focus,\nfieldset[disabled] .btn-success:active,\nfieldset[disabled] .btn-success.active {\n\tbackground-color: #28a745;\n\tborder-color: #28a745;\n}\n.btn-success.btn-simple {\n\tcolor: #28a745;\n\tborder-color: #28a745;\n}\n.btn-success.btn-simple:hover,\n.btn-success.btn-simple:focus,\n.btn-success.btn-simple:active {\n\tbackground-color: transparent;\n\tcolor: #0c492c;\n\tborder-color: #0c492c;\n\tbox-shadow: none;\n}\n.btn-success.btn-link {\n\tcolor: #28a745;\n}\n.btn-success.btn-link:hover,\n.btn-success.btn-link:focus,\n.btn-success.btn-link:active,\n.btn-success.btn-link:active:focus {\n\tbackground-color: transparent;\n\tcolor: #0c492c;\n\ttext-decoration: none;\n\tbox-shadow: none;\n}\n\n.btn-info {\n\tbackground-color: #39a9db;\n\tcolor: #ffffff;\n}\n.btn-info:hover,\n.btn-info:focus,\n.btn-info:active,\n.btn-info.active,\n.btn-info:active:focus,\n.btn-info:active:hover,\n.btn-info.active:focus,\n.btn-info.active:hover,\n.show > .btn-info.dropdown-toggle,\n.show > .btn-info.dropdown-toggle:focus,\n.show > .btn-info.dropdown-toggle:hover {\n\tbackground-color: #238ebe !important;\n\tcolor: #ffffff !important;\n\tbox-shadow: none !important;\n}\n.btn-info:not([data-action]):hover {\n\tbox-shadow: none;\n}\n.btn-info.disabled,\n.btn-info.disabled:hover,\n.btn-info.disabled:focus,\n.btn-info.disabled.focus,\n.btn-info.disabled:active,\n.btn-info.disabled.active,\n.btn-info:disabled,\n.btn-info:disabled:hover,\n.btn-info:disabled:focus,\n.btn-info:disabled.focus,\n.btn-info:disabled:active,\n.btn-info:disabled.active,\n.btn-info[disabled],\n.btn-info[disabled]:hover,\n.btn-info[disabled]:focus,\n.btn-info[disabled].focus,\n.btn-info[disabled]:active,\n.btn-info[disabled].active,\nfieldset[disabled] .btn-info,\nfieldset[disabled] .btn-info:hover,\nfieldset[disabled] .btn-info:focus,\nfieldset[disabled] .btn-info.focus,\nfieldset[disabled] .btn-info:active,\nfieldset[disabled] .btn-info.active {\n\tbackground-color: #39a9db;\n\tborder-color: #39a9db;\n}\n.btn-info.btn-simple {\n\tcolor: #39a9db;\n\tborder-color: #39a9db;\n}\n.btn-info.btn-simple:hover,\n.btn-info.btn-simple:focus,\n.btn-info.btn-simple:active {\n\tbackground-color: transparent;\n\tcolor: #238ebe;\n\tborder-color: #238ebe;\n\tbox-shadow: none;\n}\n.btn-info.btn-link {\n\tcolor: #39a9db;\n}\n.btn-info.btn-link:hover,\n.btn-info.btn-link:focus,\n.btn-info.btn-link:active,\n.btn-info.btn-link:active:focus {\n\tbackground-color: transparent;\n\tcolor: #238ebe;\n\ttext-decoration: none;\n\tbox-shadow: none;\n}\n\n.btn-warning:hover,\n.btn-warning:focus,\n.btn-warning:active,\n.btn-warning.active,\n.btn-warning:active:focus,\n.btn-warning:active:hover,\n.btn-warning.active:focus,\n.btn-warning.active:hover,\n.show > .btn-warning.dropdown-toggle,\n.show > .btn-warning.dropdown-toggle:focus,\n.show > .btn-warning.dropdown-toggle:hover {\n\tbackground-color: #ffb626 !important;\n\tcolor: #ffffff !important;\n\tbox-shadow: none !important;\n}\n.btn-warning:not([data-action]):hover {\n\tbox-shadow: none;\n}\n.btn-warning.disabled,\n.btn-warning.disabled:hover,\n.btn-warning.disabled:focus,\n.btn-warning.disabled.focus,\n.btn-warning.disabled:active,\n.btn-warning.disabled.active,\n.btn-warning:disabled,\n.btn-warning:disabled:hover,\n.btn-warning:disabled:focus,\n.btn-warning:disabled.focus,\n.btn-warning:disabled:active,\n.btn-warning:disabled.active,\n.btn-warning[disabled],\n.btn-warning[disabled]:hover,\n.btn-warning[disabled]:focus,\n.btn-warning[disabled].focus,\n.btn-warning[disabled]:active,\n.btn-warning[disabled].active,\nfieldset[disabled] .btn-warning,\nfieldset[disabled] .btn-warning:hover,\nfieldset[disabled] .btn-warning:focus,\nfieldset[disabled] .btn-warning.focus,\nfieldset[disabled] .btn-warning:active,\nfieldset[disabled] .btn-warning.active {\n\tbackground-color: #ffc759;\n\tborder-color: #ffc759;\n}\n.btn-warning.btn-simple {\n\tcolor: #ffc759;\n\tborder-color: #ffc759;\n}\n.btn-warning.btn-simple:hover,\n.btn-warning.btn-simple:focus,\n.btn-warning.btn-simple:active {\n\tbackground-color: transparent;\n\tcolor: #ffb626;\n\tborder-color: #ffb626;\n\tbox-shadow: none;\n}\n.btn-warning.btn-link {\n\tcolor: #ffc759;\n}\n.btn-warning.btn-link:hover,\n.btn-warning.btn-link:focus,\n.btn-warning.btn-link:active,\n.btn-warning.btn-link:active:focus {\n\tbackground-color: transparent;\n\tcolor: #ffb626;\n\ttext-decoration: none;\n\tbox-shadow: none;\n}\n\n.btn-danger {\n\tbackground-color: #c1292e;\n\tcolor: #ffffff;\n}\n.btn-danger:hover,\n.btn-danger:focus,\n.btn-danger:active,\n.btn-danger.active,\n.btn-danger:active:focus,\n.btn-danger:active:hover,\n.btn-danger.active:focus,\n.btn-danger.active:hover,\n.show > .btn-danger.dropdown-toggle,\n.show > .btn-danger.dropdown-toggle:focus,\n.show > .btn-danger.dropdown-toggle:hover {\n\tbackground-color: #9f2226 !important;\n\tcolor: #ffffff !important;\n\tbox-shadow: none !important;\n}\n.btn-danger:not([data-action]):hover {\n\tbox-shadow: none;\n}\n.btn-danger.disabled,\n.btn-danger.disabled:hover,\n.btn-danger.disabled:focus,\n.btn-danger.disabled.focus,\n.btn-danger.disabled:active,\n.btn-danger.disabled.active,\n.btn-danger:disabled,\n.btn-danger:disabled:hover,\n.btn-danger:disabled:focus,\n.btn-danger:disabled.focus,\n.btn-danger:disabled:active,\n.btn-danger:disabled.active,\n.btn-danger[disabled],\n.btn-danger[disabled]:hover,\n.btn-danger[disabled]:focus,\n.btn-danger[disabled].focus,\n.btn-danger[disabled]:active,\n.btn-danger[disabled].active,\nfieldset[disabled] .btn-danger,\nfieldset[disabled] .btn-danger:hover,\nfieldset[disabled] .btn-danger:focus,\nfieldset[disabled] .btn-danger.focus,\nfieldset[disabled] .btn-danger:active,\nfieldset[disabled] .btn-danger.active {\n\tbackground-color: #c1292e;\n\tborder-color: #c1292e;\n}\n.btn-danger.btn-simple {\n\tcolor: #c1292e;\n\tborder-color: #c1292e;\n}\n.btn-danger.btn-simple:hover,\n.btn-danger.btn-simple:focus,\n.btn-danger.btn-simple:active {\n\tbackground-color: transparent;\n\tcolor: #9f2226;\n\tborder-color: #9f2226;\n\tbox-shadow: none;\n}\n.btn-danger.btn-link {\n\tcolor: #c1292e;\n}\n.btn-danger.btn-link:hover,\n.btn-danger.btn-link:focus,\n.btn-danger.btn-link:active,\n.btn-danger.btn-link:active:focus {\n\tbackground-color: transparent;\n\tcolor: #9f2226;\n\ttext-decoration: none;\n\tbox-shadow: none;\n}\n\n.btn-neutral {\n\tbackground-color: #ffffff;\n\tcolor: #1c77c3;\n}\n.btn-neutral:hover,\n.btn-neutral:focus,\n.btn-neutral:active,\n.btn-neutral.active,\n.btn-neutral:active:focus,\n.btn-neutral:active:hover,\n.btn-neutral.active:focus,\n.btn-neutral.active:hover,\n.show > .btn-neutral.dropdown-toggle,\n.show > .btn-neutral.dropdown-toggle:focus,\n.show > .btn-neutral.dropdown-toggle:hover {\n\tbackground-color: #ffffff !important;\n\tcolor: #ffffff !important;\n\tbox-shadow: none !important;\n}\n.btn-neutral:not([data-action]):hover {\n\tbox-shadow: none;\n}\n.btn-neutral.disabled,\n.btn-neutral.disabled:hover,\n.btn-neutral.disabled:focus,\n.btn-neutral.disabled.focus,\n.btn-neutral.disabled:active,\n.btn-neutral.disabled.active,\n.btn-neutral:disabled,\n.btn-neutral:disabled:hover,\n.btn-neutral:disabled:focus,\n.btn-neutral:disabled.focus,\n.btn-neutral:disabled:active,\n.btn-neutral:disabled.active,\n.btn-neutral[disabled],\n.btn-neutral[disabled]:hover,\n.btn-neutral[disabled]:focus,\n.btn-neutral[disabled].focus,\n.btn-neutral[disabled]:active,\n.btn-neutral[disabled].active,\nfieldset[disabled] .btn-neutral,\nfieldset[disabled] .btn-neutral:hover,\nfieldset[disabled] .btn-neutral:focus,\nfieldset[disabled] .btn-neutral.focus,\nfieldset[disabled] .btn-neutral:active,\nfieldset[disabled] .btn-neutral.active {\n\tbackground-color: #ffffff;\n\tborder-color: #ffffff;\n}\n.btn-neutral.btn-danger {\n\tcolor: #c1292e;\n}\n.btn-neutral.btn-danger:hover,\n.btn-neutral.btn-danger:focus,\n.btn-neutral.btn-danger:active,\n.btn-neutral.btn-danger:active:focus {\n\tcolor: #9f2226 !important;\n}\n.btn-neutral.btn-info {\n\tcolor: #39a9db !important;\n}\n.btn-neutral.btn-info:hover,\n.btn-neutral.btn-info:focus,\n.btn-neutral.btn-info:active,\n.btn-neutral.btn-info:active:focus {\n\tcolor: #238ebe !important;\n}\n.btn-neutral.btn-warning {\n\tcolor: #ffc759 !important;\n}\n.btn-neutral.btn-warning:hover,\n.btn-neutral.btn-warning:focus,\n.btn-neutral.btn-warning:active,\n.btn-neutral.btn-warning:active:focus {\n\tcolor: #ffb626 !important;\n}\n.btn-neutral.btn-success {\n\tcolor: #28a745 !important;\n}\n.btn-neutral.btn-success:hover,\n.btn-neutral.btn-success:focus,\n.btn-neutral.btn-success:active,\n.btn-neutral.btn-success:active:focus {\n\tcolor: #0c492c !important;\n}\n.btn-neutral.btn-default {\n\tcolor: #65adff !important;\n}\n.btn-neutral.btn-default:hover,\n.btn-neutral.btn-default:focus,\n.btn-neutral.btn-default:active,\n.btn-neutral.btn-default:active:focus {\n\tcolor: #403d39 !important;\n}\n.btn-neutral.active,\n.btn-neutral:active,\n.btn-neutral:active:focus,\n.btn-neutral:active:hover,\n.btn-neutral.active:focus,\n.btn-neutral.active:hover,\n.show > .btn-neutral.dropdown-toggle,\n.show > .btn-neutral.dropdown-toggle:focus,\n.show > .btn-neutral.dropdown-toggle:hover {\n\tbackground-color: #ffffff !important;\n\tcolor: #165c96 !important;\n\tbox-shadow: none !important;\n}\n.btn-neutral:hover,\n.btn-neutral:focus {\n\tcolor: #165c96 !important;\n}\n.btn-neutral:hover:not(.nav-link),\n.btn-neutral:focus:not(.nav-link) {\n\tbox-shadow: none;\n}\n.btn-neutral.btn-simple {\n\tcolor: #ffffff;\n\tborder-color: #ffffff;\n}\n.btn-neutral.btn-simple:hover,\n.btn-neutral.btn-simple:focus,\n.btn-neutral.btn-simple:active {\n\tbackground-color: transparent;\n\tcolor: #ffffff;\n\tborder-color: #ffffff;\n\tbox-shadow: none;\n}\n.btn-neutral.btn-link {\n\tcolor: #ffffff;\n}\n.btn-neutral.btn-link:hover,\n.btn-neutral.btn-link:focus,\n.btn-neutral.btn-link:active,\n.btn-neutral.btn-link:active:focus {\n\tbackground-color: transparent;\n\tcolor: #ffffff;\n\ttext-decoration: none;\n\tbox-shadow: none;\n}\n\n.btn-outline-default {\n\tbackground: transparent;\n\tborder: 2px solid #65adff !important;\n\tcolor: #65adff;\n\topacity: 1;\n\tfilter: alpha(opacity=100);\n}\n.btn-outline-default:hover,\n.btn-outline-default:focus,\n.btn-outline-default:active,\n.btn-outline-default:focus:active,\n.btn-outline-default.active,\n.open > .btn-outline-default.dropdown-toggle {\n\tbackground-color: #65adff !important;\n\tcolor: rgba(255, 255, 255, 0.8) !important;\n\tborder-color: #65adff !important;\n}\n.btn-outline-default:hover .caret,\n.btn-outline-default:focus .caret,\n.btn-outline-default:active .caret,\n.btn-outline-default:focus:active .caret,\n.btn-outline-default.active .caret,\n.open > .btn-outline-default.dropdown-toggle .caret {\n\tborder-top-color: rgba(255, 255, 255, 0.8) !important;\n}\n.btn-outline-default .caret {\n\tborder-top-color: #ffffff !important;\n}\n.btn-outline-default.disabled,\n.btn-outline-default.disabled:hover,\n.btn-outline-default.disabled:focus,\n.btn-outline-default.disabled.focus,\n.btn-outline-default.disabled:active,\n.btn-outline-default.disabled.active,\n.btn-outline-default:disabled,\n.btn-outline-default:disabled:hover,\n.btn-outline-default:disabled:focus,\n.btn-outline-default:disabled.focus,\n.btn-outline-default:disabled:active,\n.btn-outline-default:disabled.active,\n.btn-outline-default[disabled],\n.btn-outline-default[disabled]:hover,\n.btn-outline-default[disabled]:focus,\n.btn-outline-default[disabled].focus,\n.btn-outline-default[disabled]:active,\n.btn-outline-default[disabled].active,\nfieldset[disabled] .btn-outline-default,\nfieldset[disabled] .btn-outline-default:hover,\nfieldset[disabled] .btn-outline-default:focus,\nfieldset[disabled] .btn-outline-default.focus,\nfieldset[disabled] .btn-outline-default:active,\nfieldset[disabled] .btn-outline-default.active {\n\tbackground-color: transparent !important;\n\tborder-color: #65adff !important;\n}\n\n.btn-outline-primary {\n\tbackground: transparent;\n\tborder: 2px solid #1c77c3 !important;\n\tcolor: #1c77c3;\n\topacity: 1;\n\tfilter: alpha(opacity=100);\n}\n.btn-outline-primary:hover,\n.btn-outline-primary:focus,\n.btn-outline-primary:active,\n.btn-outline-primary:focus:active,\n.btn-outline-primary.active,\n.open > .btn-outline-primary.dropdown-toggle {\n\tbackground-color: #1c77c3 !important;\n\tcolor: rgba(255, 255, 255, 0.8) !important;\n\tborder-color: #1c77c3 !important;\n}\n.btn-outline-primary:hover .caret,\n.btn-outline-primary:focus .caret,\n.btn-outline-primary:active .caret,\n.btn-outline-primary:focus:active .caret,\n.btn-outline-primary.active .caret,\n.open > .btn-outline-primary.dropdown-toggle .caret {\n\tborder-top-color: rgba(255, 255, 255, 0.8) !important;\n}\n.btn-outline-primary .caret {\n\tborder-top-color: #ffffff !important;\n}\n.btn-outline-primary.disabled,\n.btn-outline-primary.disabled:hover,\n.btn-outline-primary.disabled:focus,\n.btn-outline-primary.disabled.focus,\n.btn-outline-primary.disabled:active,\n.btn-outline-primary.disabled.active,\n.btn-outline-primary:disabled,\n.btn-outline-primary:disabled:hover,\n.btn-outline-primary:disabled:focus,\n.btn-outline-primary:disabled.focus,\n.btn-outline-primary:disabled:active,\n.btn-outline-primary:disabled.active,\n.btn-outline-primary[disabled],\n.btn-outline-primary[disabled]:hover,\n.btn-outline-primary[disabled]:focus,\n.btn-outline-primary[disabled].focus,\n.btn-outline-primary[disabled]:active,\n.btn-outline-primary[disabled].active,\nfieldset[disabled] .btn-outline-primary,\nfieldset[disabled] .btn-outline-primary:hover,\nfieldset[disabled] .btn-outline-primary:focus,\nfieldset[disabled] .btn-outline-primary.focus,\nfieldset[disabled] .btn-outline-primary:active,\nfieldset[disabled] .btn-outline-primary.active {\n\tbackground-color: transparent !important;\n\tborder-color: #1c77c3 !important;\n}\n\n.btn-outline-secondary {\n\tbackground: transparent;\n\tborder: 2px solid #1f84d6 !important;\n\tcolor: #1f84d6;\n\topacity: 1;\n\tfilter: alpha(opacity=100);\n}\n.btn-outline-secondary:hover,\n.btn-outline-secondary:focus,\n.btn-outline-secondary:active,\n.btn-outline-secondary:focus:active,\n.btn-outline-secondary.active,\n.open > .btn-outline-secondary.dropdown-toggle {\n\tbackground-color: #1f84d6 !important;\n\tcolor: rgba(255, 255, 255, 0.8) !important;\n\tborder-color: #1f84d6 !important;\n}\n.btn-outline-secondary:hover .caret,\n.btn-outline-secondary:focus .caret,\n.btn-outline-secondary:active .caret,\n.btn-outline-secondary:focus:active .caret,\n.btn-outline-secondary.active .caret,\n.open > .btn-outline-secondary.dropdown-toggle .caret {\n\tborder-top-color: rgba(255, 255, 255, 0.8) !important;\n}\n.btn-outline-secondary .caret {\n\tborder-top-color: #ffffff !important;\n}\n.btn-outline-secondary.disabled,\n.btn-outline-secondary.disabled:hover,\n.btn-outline-secondary.disabled:focus,\n.btn-outline-secondary.disabled.focus,\n.btn-outline-secondary.disabled:active,\n.btn-outline-secondary.disabled.active,\n.btn-outline-secondary:disabled,\n.btn-outline-secondary:disabled:hover,\n.btn-outline-secondary:disabled:focus,\n.btn-outline-secondary:disabled.focus,\n.btn-outline-secondary:disabled:active,\n.btn-outline-secondary:disabled.active,\n.btn-outline-secondary[disabled],\n.btn-outline-secondary[disabled]:hover,\n.btn-outline-secondary[disabled]:focus,\n.btn-outline-secondary[disabled].focus,\n.btn-outline-secondary[disabled]:active,\n.btn-outline-secondary[disabled].active,\nfieldset[disabled] .btn-outline-secondary,\nfieldset[disabled] .btn-outline-secondary:hover,\nfieldset[disabled] .btn-outline-secondary:focus,\nfieldset[disabled] .btn-outline-secondary.focus,\nfieldset[disabled] .btn-outline-secondary:active,\nfieldset[disabled] .btn-outline-secondary.active {\n\tbackground-color: transparent !important;\n\tborder-color: #1f84d6 !important;\n}\n\n.btn-outline-success {\n\tbackground: transparent;\n\tborder: 2px solid #28a745 !important;\n\tcolor: #28a745;\n\topacity: 1;\n\tfilter: alpha(opacity=100);\n}\n.btn-outline-success:hover,\n.btn-outline-success:focus,\n.btn-outline-success:active,\n.btn-outline-success:focus:active,\n.btn-outline-success.active,\n.open > .btn-outline-success.dropdown-toggle {\n\tbackground-color: #28a745 !important;\n\tcolor: rgba(255, 255, 255, 0.8) !important;\n\tborder-color: #28a745 !important;\n}\n.btn-outline-success:hover .caret,\n.btn-outline-success:focus .caret,\n.btn-outline-success:active .caret,\n.btn-outline-success:focus:active .caret,\n.btn-outline-success.active .caret,\n.open > .btn-outline-success.dropdown-toggle .caret {\n\tborder-top-color: rgba(255, 255, 255, 0.8) !important;\n}\n.btn-outline-success .caret {\n\tborder-top-color: #ffffff !important;\n}\n.btn-outline-success.disabled,\n.btn-outline-success.disabled:hover,\n.btn-outline-success.disabled:focus,\n.btn-outline-success.disabled.focus,\n.btn-outline-success.disabled:active,\n.btn-outline-success.disabled.active,\n.btn-outline-success:disabled,\n.btn-outline-success:disabled:hover,\n.btn-outline-success:disabled:focus,\n.btn-outline-success:disabled.focus,\n.btn-outline-success:disabled:active,\n.btn-outline-success:disabled.active,\n.btn-outline-success[disabled],\n.btn-outline-success[disabled]:hover,\n.btn-outline-success[disabled]:focus,\n.btn-outline-success[disabled].focus,\n.btn-outline-success[disabled]:active,\n.btn-outline-success[disabled].active,\nfieldset[disabled] .btn-outline-success,\nfieldset[disabled] .btn-outline-success:hover,\nfieldset[disabled] .btn-outline-success:focus,\nfieldset[disabled] .btn-outline-success.focus,\nfieldset[disabled] .btn-outline-success:active,\nfieldset[disabled] .btn-outline-success.active {\n\tbackground-color: transparent !important;\n\tborder-color: #28a745 !important;\n}\n\n.btn-outline-info {\n\tbackground: transparent;\n\tborder: 2px solid #39a9db !important;\n\tcolor: #39a9db;\n\topacity: 1;\n\tfilter: alpha(opacity=100);\n}\n.btn-outline-info:hover,\n.btn-outline-info:focus,\n.btn-outline-info:active,\n.btn-outline-info:focus:active,\n.btn-outline-info.active,\n.open > .btn-outline-info.dropdown-toggle {\n\tbackground-color: #39a9db !important;\n\tcolor: rgba(255, 255, 255, 0.8) !important;\n\tborder-color: #39a9db !important;\n}\n.btn-outline-info:hover .caret,\n.btn-outline-info:focus .caret,\n.btn-outline-info:active .caret,\n.btn-outline-info:focus:active .caret,\n.btn-outline-info.active .caret,\n.open > .btn-outline-info.dropdown-toggle .caret {\n\tborder-top-color: rgba(255, 255, 255, 0.8) !important;\n}\n.btn-outline-info .caret {\n\tborder-top-color: #ffffff !important;\n}\n.btn-outline-info.disabled,\n.btn-outline-info.disabled:hover,\n.btn-outline-info.disabled:focus,\n.btn-outline-info.disabled.focus,\n.btn-outline-info.disabled:active,\n.btn-outline-info.disabled.active,\n.btn-outline-info:disabled,\n.btn-outline-info:disabled:hover,\n.btn-outline-info:disabled:focus,\n.btn-outline-info:disabled.focus,\n.btn-outline-info:disabled:active,\n.btn-outline-info:disabled.active,\n.btn-outline-info[disabled],\n.btn-outline-info[disabled]:hover,\n.btn-outline-info[disabled]:focus,\n.btn-outline-info[disabled].focus,\n.btn-outline-info[disabled]:active,\n.btn-outline-info[disabled].active,\nfieldset[disabled] .btn-outline-info,\nfieldset[disabled] .btn-outline-info:hover,\nfieldset[disabled] .btn-outline-info:focus,\nfieldset[disabled] .btn-outline-info.focus,\nfieldset[disabled] .btn-outline-info:active,\nfieldset[disabled] .btn-outline-info.active {\n\tbackground-color: transparent !important;\n\tborder-color: #39a9db !important;\n}\n\n.btn-outline-warning {\n\tbackground: transparent;\n\tborder: 2px solid #ffc759 !important;\n\tcolor: #ffc759;\n\topacity: 1;\n\tfilter: alpha(opacity=100);\n}\n.btn-outline-warning:hover,\n.btn-outline-warning:focus,\n.btn-outline-warning:active,\n.btn-outline-warning:focus:active,\n.btn-outline-warning.active,\n.open > .btn-outline-warning.dropdown-toggle {\n\tbackground-color: #ffc759 !important;\n\tcolor: rgba(255, 255, 255, 0.8) !important;\n\tborder-color: #ffc759 !important;\n}\n.btn-outline-warning:hover .caret,\n.btn-outline-warning:focus .caret,\n.btn-outline-warning:active .caret,\n.btn-outline-warning:focus:active .caret,\n.btn-outline-warning.active .caret,\n.open > .btn-outline-warning.dropdown-toggle .caret {\n\tborder-top-color: rgba(255, 255, 255, 0.8) !important;\n}\n.btn-outline-warning .caret {\n\tborder-top-color: #ffffff !important;\n}\n.btn-outline-warning.disabled,\n.btn-outline-warning.disabled:hover,\n.btn-outline-warning.disabled:focus,\n.btn-outline-warning.disabled.focus,\n.btn-outline-warning.disabled:active,\n.btn-outline-warning.disabled.active,\n.btn-outline-warning:disabled,\n.btn-outline-warning:disabled:hover,\n.btn-outline-warning:disabled:focus,\n.btn-outline-warning:disabled.focus,\n.btn-outline-warning:disabled:active,\n.btn-outline-warning:disabled.active,\n.btn-outline-warning[disabled],\n.btn-outline-warning[disabled]:hover,\n.btn-outline-warning[disabled]:focus,\n.btn-outline-warning[disabled].focus,\n.btn-outline-warning[disabled]:active,\n.btn-outline-warning[disabled].active,\nfieldset[disabled] .btn-outline-warning,\nfieldset[disabled] .btn-outline-warning:hover,\nfieldset[disabled] .btn-outline-warning:focus,\nfieldset[disabled] .btn-outline-warning.focus,\nfieldset[disabled] .btn-outline-warning:active,\nfieldset[disabled] .btn-outline-warning.active {\n\tbackground-color: transparent !important;\n\tborder-color: #ffc759 !important;\n}\n\n.btn-outline-danger {\n\tbackground: transparent;\n\tborder: 2px solid #c1292e !important;\n\tcolor: #c1292e;\n\topacity: 1;\n\tfilter: alpha(opacity=100);\n}\n.btn-outline-danger:hover,\n.btn-outline-danger:focus,\n.btn-outline-danger:active,\n.btn-outline-danger:focus:active,\n.btn-outline-danger.active,\n.open > .btn-outline-danger.dropdown-toggle {\n\tbackground-color: #c1292e !important;\n\tcolor: rgba(255, 255, 255, 0.8) !important;\n\tborder-color: #c1292e !important;\n}\n.btn-outline-danger:hover .caret,\n.btn-outline-danger:focus .caret,\n.btn-outline-danger:active .caret,\n.btn-outline-danger:focus:active .caret,\n.btn-outline-danger.active .caret,\n.open > .btn-outline-danger.dropdown-toggle .caret {\n\tborder-top-color: rgba(255, 255, 255, 0.8) !important;\n}\n.btn-outline-danger .caret {\n\tborder-top-color: #ffffff !important;\n}\n.btn-outline-danger.disabled,\n.btn-outline-danger.disabled:hover,\n.btn-outline-danger.disabled:focus,\n.btn-outline-danger.disabled.focus,\n.btn-outline-danger.disabled:active,\n.btn-outline-danger.disabled.active,\n.btn-outline-danger:disabled,\n.btn-outline-danger:disabled:hover,\n.btn-outline-danger:disabled:focus,\n.btn-outline-danger:disabled.focus,\n.btn-outline-danger:disabled:active,\n.btn-outline-danger:disabled.active,\n.btn-outline-danger[disabled],\n.btn-outline-danger[disabled]:hover,\n.btn-outline-danger[disabled]:focus,\n.btn-outline-danger[disabled].focus,\n.btn-outline-danger[disabled]:active,\n.btn-outline-danger[disabled].active,\nfieldset[disabled] .btn-outline-danger,\nfieldset[disabled] .btn-outline-danger:hover,\nfieldset[disabled] .btn-outline-danger:focus,\nfieldset[disabled] .btn-outline-danger.focus,\nfieldset[disabled] .btn-outline-danger:active,\nfieldset[disabled] .btn-outline-danger.active {\n\tbackground-color: transparent !important;\n\tborder-color: #c1292e !important;\n}\n\n.btn-outline-neutral {\n\tbackground: transparent;\n\tborder: 2px solid #ffffff !important;\n\tcolor: #ffffff;\n\topacity: 1;\n\tfilter: alpha(opacity=100);\n}\n.btn-outline-neutral:hover,\n.btn-outline-neutral:focus,\n.btn-outline-neutral:active,\n.btn-outline-neutral:focus:active,\n.btn-outline-neutral.active,\n.open > .btn-outline-neutral.dropdown-toggle {\n\tbackground-color: #ffffff !important;\n\tcolor: rgba(255, 255, 255, 0.8) !important;\n\tborder-color: #ffffff !important;\n}\n.btn-outline-neutral:hover .caret,\n.btn-outline-neutral:focus .caret,\n.btn-outline-neutral:active .caret,\n.btn-outline-neutral:focus:active .caret,\n.btn-outline-neutral.active .caret,\n.open > .btn-outline-neutral.dropdown-toggle .caret {\n\tborder-top-color: rgba(255, 255, 255, 0.8) !important;\n}\n.btn-outline-neutral .caret {\n\tborder-top-color: #ffffff !important;\n}\n.btn-outline-neutral.disabled,\n.btn-outline-neutral.disabled:hover,\n.btn-outline-neutral.disabled:focus,\n.btn-outline-neutral.disabled.focus,\n.btn-outline-neutral.disabled:active,\n.btn-outline-neutral.disabled.active,\n.btn-outline-neutral:disabled,\n.btn-outline-neutral:disabled:hover,\n.btn-outline-neutral:disabled:focus,\n.btn-outline-neutral:disabled.focus,\n.btn-outline-neutral:disabled:active,\n.btn-outline-neutral:disabled.active,\n.btn-outline-neutral[disabled],\n.btn-outline-neutral[disabled]:hover,\n.btn-outline-neutral[disabled]:focus,\n.btn-outline-neutral[disabled].focus,\n.btn-outline-neutral[disabled]:active,\n.btn-outline-neutral[disabled].active,\nfieldset[disabled] .btn-outline-neutral,\nfieldset[disabled] .btn-outline-neutral:hover,\nfieldset[disabled] .btn-outline-neutral:focus,\nfieldset[disabled] .btn-outline-neutral.focus,\nfieldset[disabled] .btn-outline-neutral:active,\nfieldset[disabled] .btn-outline-neutral.active {\n\tbackground-color: transparent !important;\n\tborder-color: #ffffff !important;\n}\n.btn-outline-neutral:hover,\n.btn-outline-neutral:focus {\n\tcolor: #403d39;\n\tbackground-color: #ffffff;\n}\n\n.btn-neutral {\n\tbackground-color: #ffffff;\n\tcolor: #1c77c3;\n\tcolor: #65adff;\n}\n.btn-neutral:hover,\n.btn-neutral:focus,\n.btn-neutral:active,\n.btn-neutral.active,\n.btn-neutral:active:focus,\n.btn-neutral:active:hover,\n.btn-neutral.active:focus,\n.btn-neutral.active:hover,\n.show > .btn-neutral.dropdown-toggle,\n.show > .btn-neutral.dropdown-toggle:focus,\n.show > .btn-neutral.dropdown-toggle:hover {\n\tbackground-color: #ffffff !important;\n\tcolor: #ffffff !important;\n\tbox-shadow: none !important;\n}\n.btn-neutral:not([data-action]):hover {\n\tbox-shadow: none;\n}\n.btn-neutral.disabled,\n.btn-neutral.disabled:hover,\n.btn-neutral.disabled:focus,\n.btn-neutral.disabled.focus,\n.btn-neutral.disabled:active,\n.btn-neutral.disabled.active,\n.btn-neutral:disabled,\n.btn-neutral:disabled:hover,\n.btn-neutral:disabled:focus,\n.btn-neutral:disabled.focus,\n.btn-neutral:disabled:active,\n.btn-neutral:disabled.active,\n.btn-neutral[disabled],\n.btn-neutral[disabled]:hover,\n.btn-neutral[disabled]:focus,\n.btn-neutral[disabled].focus,\n.btn-neutral[disabled]:active,\n.btn-neutral[disabled].active,\nfieldset[disabled] .btn-neutral,\nfieldset[disabled] .btn-neutral:hover,\nfieldset[disabled] .btn-neutral:focus,\nfieldset[disabled] .btn-neutral.focus,\nfieldset[disabled] .btn-neutral:active,\nfieldset[disabled] .btn-neutral.active {\n\tbackground-color: #ffffff;\n\tborder-color: #ffffff;\n}\n.btn-neutral.btn-danger {\n\tcolor: #c1292e;\n}\n.btn-neutral.btn-danger:hover,\n.btn-neutral.btn-danger:focus,\n.btn-neutral.btn-danger:active,\n.btn-neutral.btn-danger:active:focus {\n\tcolor: #9f2226 !important;\n}\n.btn-neutral.btn-info {\n\tcolor: #39a9db !important;\n}\n.btn-neutral.btn-info:hover,\n.btn-neutral.btn-info:focus,\n.btn-neutral.btn-info:active,\n.btn-neutral.btn-info:active:focus {\n\tcolor: #238ebe !important;\n}\n.btn-neutral.btn-warning {\n\tcolor: #ffc759 !important;\n}\n.btn-neutral.btn-warning:hover,\n.btn-neutral.btn-warning:focus,\n.btn-neutral.btn-warning:active,\n.btn-neutral.btn-warning:active:focus {\n\tcolor: #ffb626 !important;\n}\n.btn-neutral.btn-success {\n\tcolor: #28a745 !important;\n}\n.btn-neutral.btn-success:hover,\n.btn-neutral.btn-success:focus,\n.btn-neutral.btn-success:active,\n.btn-neutral.btn-success:active:focus {\n\tcolor: #0c492c !important;\n}\n.btn-neutral.btn-default {\n\tcolor: #65adff !important;\n}\n.btn-neutral.btn-default:hover,\n.btn-neutral.btn-default:focus,\n.btn-neutral.btn-default:active,\n.btn-neutral.btn-default:active:focus {\n\tcolor: #403d39 !important;\n}\n.btn-neutral.active,\n.btn-neutral:active,\n.btn-neutral:active:focus,\n.btn-neutral:active:hover,\n.btn-neutral.active:focus,\n.btn-neutral.active:hover,\n.show > .btn-neutral.dropdown-toggle,\n.show > .btn-neutral.dropdown-toggle:focus,\n.show > .btn-neutral.dropdown-toggle:hover {\n\tbackground-color: #ffffff !important;\n\tcolor: #165c96 !important;\n\tbox-shadow: none !important;\n}\n.btn-neutral:hover,\n.btn-neutral:focus {\n\tcolor: #165c96 !important;\n}\n.btn-neutral:hover:not(.nav-link),\n.btn-neutral:focus:not(.nav-link) {\n\tbox-shadow: none;\n}\n.btn-neutral.btn-simple {\n\tcolor: #ffffff;\n\tborder-color: #ffffff;\n}\n.btn-neutral.btn-simple:hover,\n.btn-neutral.btn-simple:focus,\n.btn-neutral.btn-simple:active {\n\tbackground-color: transparent;\n\tcolor: #ffffff;\n\tborder-color: #ffffff;\n\tbox-shadow: none;\n}\n.btn-neutral.btn-link {\n\tcolor: #ffffff;\n}\n.btn-neutral.btn-link:hover,\n.btn-neutral.btn-link:focus,\n.btn-neutral.btn-link:active,\n.btn-neutral.btn-link:active:focus {\n\tbackground-color: transparent;\n\tcolor: #ffffff;\n\ttext-decoration: none;\n\tbox-shadow: none;\n}\n.btn-neutral:hover,\n.btn-neutral:focus {\n\tcolor: #403d39;\n}\n.btn-neutral.btn-border:hover,\n.btn-neutral.btn-border:focus {\n\tcolor: #65adff;\n}\n.btn-neutral.btn-border:active,\n.btn-neutral.btn-border.active,\n.open > .btn-neutral.btn-border.dropdown-toggle {\n\tbackground-color: #ffffff;\n\tcolor: #65adff;\n}\n.btn-neutral.btn-link:active,\n.btn-neutral.btn-link.active {\n\tbackground-color: transparent;\n}\n\n.btn:disabled,\n.btn[disabled],\n.btn.disabled {\n\topacity: 0.5;\n\tfilter: alpha(opacity=50);\n\tpointer-events: none;\n}\n\n.btn-simple {\n\tborder: 1px solid;\n\tborder-color: #65adff;\n\tpadding: 10px 22px;\n\tbackground-color: transparent;\n}\n\n.btn-simple.disabled,\n.btn-simple.disabled:hover,\n.btn-simple.disabled:focus,\n.btn-simple.disabled.focus,\n.btn-simple.disabled:active,\n.btn-simple.disabled.active,\n.btn-simple:disabled,\n.btn-simple:disabled:hover,\n.btn-simple:disabled:focus,\n.btn-simple:disabled.focus,\n.btn-simple:disabled:active,\n.btn-simple:disabled.active,\n.btn-simple[disabled],\n.btn-simple[disabled]:hover,\n.btn-simple[disabled]:focus,\n.btn-simple[disabled].focus,\n.btn-simple[disabled]:active,\n.btn-simple[disabled].active,\nfieldset[disabled] .btn-simple,\nfieldset[disabled] .btn-simple:hover,\nfieldset[disabled] .btn-simple:focus,\nfieldset[disabled] .btn-simple.focus,\nfieldset[disabled] .btn-simple:active,\nfieldset[disabled] .btn-simple.active,\n.btn-link.disabled,\n.btn-link.disabled:hover,\n.btn-link.disabled:focus,\n.btn-link.disabled.focus,\n.btn-link.disabled:active,\n.btn-link.disabled.active,\n.btn-link:disabled,\n.btn-link:disabled:hover,\n.btn-link:disabled:focus,\n.btn-link:disabled.focus,\n.btn-link:disabled:active,\n.btn-link:disabled.active,\n.btn-link[disabled],\n.btn-link[disabled]:hover,\n.btn-link[disabled]:focus,\n.btn-link[disabled].focus,\n.btn-link[disabled]:active,\n.btn-link[disabled].active,\nfieldset[disabled] .btn-link,\nfieldset[disabled] .btn-link:hover,\nfieldset[disabled] .btn-link:focus,\nfieldset[disabled] .btn-link.focus,\nfieldset[disabled] .btn-link:active,\nfieldset[disabled] .btn-link.active {\n\tbackground-color: #1c77c3;\n}\n\n.btn-link {\n\tbackground-color: transparent;\n\tcolor: inherit;\n}\n.btn-link:hover {\n\tbackground-color: #1c77c3;\n\tcolor: white;\n\ttext-decoration: none;\n}\n\n.btn-lg {\n\tfont-size: 1rem;\n\tborder-radius: 6px;\n\tpadding: 15px 35px;\n}\n.btn-lg.btn-simple {\n\tpadding: 14px 34px;\n}\n\n.btn-sm {\n\tfont-size: 0.8571em;\n\tborder-radius: 3px;\n\tpadding: 5px 7px;\n}\n.btn-md {\n\tfont-size: 0.8871em;\n\tborder-radius: 3px;\n\tpadding: 7px 9px;\n}\n.btn-sm.btn-simple {\n\tpadding: 4px 14px;\n}\n\n.btn-wd {\n\tmin-width: 140px;\n}\n\n.btn-group.select {\n\twidth: 100%;\n}\n\n.btn-group.select .btn {\n\ttext-align: left;\n}\n\n.btn-group.select .caret {\n\tposition: absolute;\n\ttop: 50%;\n\tmargin-top: -1px;\n\tright: 8px;\n}\n\n.btn-group .btn + .btn {\n\tmargin-left: -3px;\n}\n.btn-group .btn:focus {\n\tbackground-color: #1f84d6 !important;\n}\n\n.btn-round {\n\tborder-width: 1px;\n\tborder-radius: 30px;\n}\n.btn-round.btn-simple {\n\tpadding: 10px 22px;\n}\n\n.no-caret.dropdown-toggle::after {\n\tdisplay: none;\n}\n\n.btn.btn-facebook {\n\tbackground-color: #3b5998;\n\tcolor: #ffffff;\n}\n.btn.btn-facebook:focus,\n.btn.btn-facebook:active,\n.btn.btn-facebook:hover {\n\tbackground-color: #344e86 !important;\n\tcolor: #ffffff !important;\n}\n.btn.btn-facebook.btn-simple {\n\tcolor: #3b5998;\n\tbackground-color: transparent;\n\tbox-shadow: none;\n\tborder-color: #3b5998;\n}\n.btn.btn-facebook.btn-simple:hover,\n.btn.btn-facebook.btn-simple:focus,\n.btn.btn-facebook.btn-simple:active {\n\tcolor: #344e86;\n\tborder-color: #344e86;\n}\n.btn.btn-facebook.btn-neutral {\n\tcolor: #3b5998;\n\tbackground-color: #ffffff;\n}\n.btn.btn-facebook.btn-neutral:hover,\n.btn.btn-facebook.btn-neutral:focus,\n.btn.btn-facebook.btn-neutral:active {\n\tcolor: #344e86 !important;\n}\n.btn.btn-twitter {\n\tbackground-color: #55acee;\n\tcolor: #ffffff;\n}\n.btn.btn-twitter:focus,\n.btn.btn-twitter:active,\n.btn.btn-twitter:hover {\n\tbackground-color: #3ea1ec !important;\n\tcolor: #ffffff !important;\n}\n.btn.btn-twitter.btn-simple {\n\tcolor: #55acee;\n\tbackground-color: transparent;\n\tbox-shadow: none;\n\tborder-color: #55acee;\n}\n.btn.btn-twitter.btn-simple:hover,\n.btn.btn-twitter.btn-simple:focus,\n.btn.btn-twitter.btn-simple:active {\n\tcolor: #3ea1ec;\n\tborder-color: #3ea1ec;\n}\n.btn.btn-twitter.btn-neutral {\n\tcolor: #55acee;\n\tbackground-color: #ffffff;\n}\n.btn.btn-twitter.btn-neutral:hover,\n.btn.btn-twitter.btn-neutral:focus,\n.btn.btn-twitter.btn-neutral:active {\n\tcolor: #3ea1ec !important;\n}\n.btn.btn-pinterest {\n\tbackground-color: #cc2127;\n\tcolor: #ffffff;\n}\n.btn.btn-pinterest:focus,\n.btn.btn-pinterest:active,\n.btn.btn-pinterest:hover {\n\tbackground-color: #dd2e34 !important;\n\tcolor: #ffffff !important;\n}\n.btn.btn-pinterest.btn-simple {\n\tcolor: #cc2127;\n\tbackground-color: transparent;\n\tbox-shadow: none;\n\tborder-color: #cc2127;\n}\n.btn.btn-pinterest.btn-simple:hover,\n.btn.btn-pinterest.btn-simple:focus,\n.btn.btn-pinterest.btn-simple:active {\n\tcolor: #dd2e34;\n\tborder-color: #dd2e34;\n}\n.btn.btn-pinterest.btn-neutral {\n\tcolor: #cc2127;\n\tbackground-color: #ffffff;\n}\n.btn.btn-pinterest.btn-neutral:hover,\n.btn.btn-pinterest.btn-neutral:focus,\n.btn.btn-pinterest.btn-neutral:active {\n\tcolor: #dd2e34 !important;\n}\n.btn.btn-google {\n\tbackground-color: #dd4b39;\n\tcolor: #ffffff;\n}\n.btn.btn-google:focus,\n.btn.btn-google:active,\n.btn.btn-google:hover {\n\tbackground-color: #d73925 !important;\n\tcolor: #ffffff !important;\n}\n.btn.btn-google.btn-simple {\n\tcolor: #dd4b39;\n\tbackground-color: transparent;\n\tbox-shadow: none;\n\tborder-color: #dd4b39;\n}\n.btn.btn-google.btn-simple:hover,\n.btn.btn-google.btn-simple:focus,\n.btn.btn-google.btn-simple:active {\n\tcolor: #d73925;\n\tborder-color: #d73925;\n}\n.btn.btn-google.btn-neutral {\n\tcolor: #dd4b39;\n\tbackground-color: #ffffff;\n}\n.btn.btn-google.btn-neutral:hover,\n.btn.btn-google.btn-neutral:focus,\n.btn.btn-google.btn-neutral:active {\n\tcolor: #d73925 !important;\n}\n.btn.btn-linkedin {\n\tbackground-color: #0077b5;\n\tcolor: #ffffff;\n}\n.btn.btn-linkedin:focus,\n.btn.btn-linkedin:active,\n.btn.btn-linkedin:hover {\n\tbackground-color: #00669c !important;\n\tcolor: #ffffff !important;\n}\n.btn.btn-linkedin.btn-simple {\n\tcolor: #0077b5;\n\tbackground-color: transparent;\n\tbox-shadow: none;\n\tborder-color: #0077b5;\n}\n.btn.btn-linkedin.btn-simple:hover,\n.btn.btn-linkedin.btn-simple:focus,\n.btn.btn-linkedin.btn-simple:active {\n\tcolor: #00669c;\n\tborder-color: #00669c;\n}\n.btn.btn-linkedin.btn-neutral {\n\tcolor: #0077b5;\n\tbackground-color: #ffffff;\n}\n.btn.btn-linkedin.btn-neutral:hover,\n.btn.btn-linkedin.btn-neutral:focus,\n.btn.btn-linkedin.btn-neutral:active {\n\tcolor: #00669c !important;\n}\n.btn.btn-dribbble {\n\tbackground-color: #ea4c89;\n\tcolor: #ffffff;\n}\n.btn.btn-dribbble:focus,\n.btn.btn-dribbble:active,\n.btn.btn-dribbble:hover {\n\tbackground-color: #ed679b !important;\n\tcolor: #ffffff !important;\n}\n.btn.btn-dribbble.btn-simple {\n\tcolor: #ea4c89;\n\tbackground-color: transparent;\n\tbox-shadow: none;\n\tborder-color: #ea4c89;\n}\n.btn.btn-dribbble.btn-simple:hover,\n.btn.btn-dribbble.btn-simple:focus,\n.btn.btn-dribbble.btn-simple:active {\n\tcolor: #ed679b;\n\tborder-color: #ed679b;\n}\n.btn.btn-dribbble.btn-neutral {\n\tcolor: #ea4c89;\n\tbackground-color: #ffffff;\n}\n.btn.btn-dribbble.btn-neutral:hover,\n.btn.btn-dribbble.btn-neutral:focus,\n.btn.btn-dribbble.btn-neutral:active {\n\tcolor: #ed679b !important;\n}\n.btn.btn-github {\n\tbackground-color: #333333;\n\tcolor: #ffffff;\n}\n.btn.btn-github:focus,\n.btn.btn-github:active,\n.btn.btn-github:hover {\n\tbackground-color: #424242 !important;\n\tcolor: #ffffff !important;\n}\n.btn.btn-github.btn-simple {\n\tcolor: #333333;\n\tbackground-color: transparent;\n\tbox-shadow: none;\n\tborder-color: #333333;\n}\n.btn.btn-github.btn-simple:hover,\n.btn.btn-github.btn-simple:focus,\n.btn.btn-github.btn-simple:active {\n\tcolor: #424242;\n\tborder-color: #424242;\n}\n.btn.btn-github.btn-neutral {\n\tcolor: #333333;\n\tbackground-color: #ffffff;\n}\n.btn.btn-github.btn-neutral:hover,\n.btn.btn-github.btn-neutral:focus,\n.btn.btn-github.btn-neutral:active {\n\tcolor: #424242 !important;\n}\n.btn.btn-youtube {\n\tbackground-color: #e52d27;\n\tcolor: #ffffff;\n}\n.btn.btn-youtube:focus,\n.btn.btn-youtube:active,\n.btn.btn-youtube:hover {\n\tbackground-color: #e84842 !important;\n\tcolor: #ffffff !important;\n}\n.btn.btn-youtube.btn-simple {\n\tcolor: #e52d27;\n\tbackground-color: transparent;\n\tbox-shadow: none;\n\tborder-color: #e52d27;\n}\n.btn.btn-youtube.btn-simple:hover,\n.btn.btn-youtube.btn-simple:focus,\n.btn.btn-youtube.btn-simple:active {\n\tcolor: #e84842;\n\tborder-color: #e84842;\n}\n.btn.btn-youtube.btn-neutral {\n\tcolor: #e52d27;\n\tbackground-color: #ffffff;\n}\n.btn.btn-youtube.btn-neutral:hover,\n.btn.btn-youtube.btn-neutral:focus,\n.btn.btn-youtube.btn-neutral:active {\n\tcolor: #e84842 !important;\n}\n.btn.btn-instagram {\n\tbackground-color: #125688;\n\tcolor: #ffffff;\n}\n.btn.btn-instagram:focus,\n.btn.btn-instagram:active,\n.btn.btn-instagram:hover {\n\tbackground-color: #1667a3 !important;\n\tcolor: #ffffff !important;\n}\n.btn.btn-instagram.btn-simple {\n\tcolor: #125688;\n\tbackground-color: transparent;\n\tbox-shadow: none;\n\tborder-color: #125688;\n}\n.btn.btn-instagram.btn-simple:hover,\n.btn.btn-instagram.btn-simple:focus,\n.btn.btn-instagram.btn-simple:active {\n\tcolor: #1667a3;\n\tborder-color: #1667a3;\n}\n.btn.btn-instagram.btn-neutral {\n\tcolor: #125688;\n\tbackground-color: #ffffff;\n}\n.btn.btn-instagram.btn-neutral:hover,\n.btn.btn-instagram.btn-neutral:focus,\n.btn.btn-instagram.btn-neutral:active {\n\tcolor: #1667a3 !important;\n}\n.btn.btn-reddit {\n\tbackground-color: #ff4500;\n\tcolor: #ffffff;\n}\n.btn.btn-reddit:focus,\n.btn.btn-reddit:active,\n.btn.btn-reddit:hover {\n\tbackground-color: #ff5b1f !important;\n\tcolor: #ffffff !important;\n}\n.btn.btn-reddit.btn-simple {\n\tcolor: #ff4500;\n\tbackground-color: transparent;\n\tbox-shadow: none;\n\tborder-color: #ff4500;\n}\n.btn.btn-reddit.btn-simple:hover,\n.btn.btn-reddit.btn-simple:focus,\n.btn.btn-reddit.btn-simple:active {\n\tcolor: #ff5b1f;\n\tborder-color: #ff5b1f;\n}\n.btn.btn-reddit.btn-neutral {\n\tcolor: #ff4500;\n\tbackground-color: #ffffff;\n}\n.btn.btn-reddit.btn-neutral:hover,\n.btn.btn-reddit.btn-neutral:focus,\n.btn.btn-reddit.btn-neutral:active {\n\tcolor: #ff5b1f !important;\n}\n.btn.btn-tumblr {\n\tbackground-color: #35465c;\n\tcolor: #ffffff;\n}\n.btn.btn-tumblr:focus,\n.btn.btn-tumblr:active,\n.btn.btn-tumblr:hover {\n\tbackground-color: #40556f !important;\n\tcolor: #ffffff !important;\n}\n.btn.btn-tumblr.btn-simple {\n\tcolor: #35465c;\n\tbackground-color: transparent;\n\tbox-shadow: none;\n\tborder-color: #35465c;\n}\n.btn.btn-tumblr.btn-simple:hover,\n.btn.btn-tumblr.btn-simple:focus,\n.btn.btn-tumblr.btn-simple:active {\n\tcolor: #40556f;\n\tborder-color: #40556f;\n}\n.btn.btn-tumblr.btn-neutral {\n\tcolor: #35465c;\n\tbackground-color: #ffffff;\n}\n.btn.btn-tumblr.btn-neutral:hover,\n.btn.btn-tumblr.btn-neutral:focus,\n.btn.btn-tumblr.btn-neutral:active {\n\tcolor: #40556f !important;\n}\n.btn.btn-behance {\n\tbackground-color: #1769ff;\n\tcolor: #ffffff;\n}\n.btn.btn-behance:focus,\n.btn.btn-behance:active,\n.btn.btn-behance:hover {\n\tbackground-color: #367dff !important;\n\tcolor: #ffffff !important;\n}\n.btn.btn-behance.btn-simple {\n\tcolor: #1769ff;\n\tbackground-color: transparent;\n\tbox-shadow: none;\n\tborder-color: #1769ff;\n}\n.btn.btn-behance.btn-simple:hover,\n.btn.btn-behance.btn-simple:focus,\n.btn.btn-behance.btn-simple:active {\n\tcolor: #367dff;\n\tborder-color: #367dff;\n}\n.btn.btn-behance.btn-neutral {\n\tcolor: #1769ff;\n\tbackground-color: #ffffff;\n}\n.btn.btn-behance.btn-neutral:hover,\n.btn.btn-behance.btn-neutral:focus,\n.btn.btn-behance.btn-neutral:active {\n\tcolor: #367dff !important;\n}\n\n.icon-property,\n.btn-move-right i,\n.btn-move-left i,\n.btn-magnify i,\n.btn-rotate i {\n\t-webkit-transition: all 370ms cubic-bezier(0.34, 1.61, 0.7, 1);\n\t-moz-transition: all 370ms cubic-bezier(0.34, 1.61, 0.7, 1);\n\t-o-transition: all 370ms cubic-bezier(0.34, 1.61, 0.7, 1);\n\t-ms-transition: all 370ms cubic-bezier(0.34, 1.61, 0.7, 1);\n\ttransition: all 370ms cubic-bezier(0.34, 1.61, 0.7, 1);\n\tposition: relative;\n\tdisplay: inline-block;\n}\n\n#animated-buttons .btn i {\n\tposition: relative;\n\ttop: 3px;\n\tmargin-top: -3px;\n}\n\n.btn-rotate:hover i,\n.btn-rotate:focus i {\n\tfilter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);\n\t-webkit-transform: rotate(53deg);\n\t-ms-transform: rotate(53deg);\n\ttransform: rotate(53deg);\n}\n\n.btn-magnify:hover i,\n.btn-magnify:focus i {\n\t-webkit-transform: scale(1.22);\n\t-moz-transform: scale(1.22);\n\t-o-transform: scale(1.22);\n\t-ms-transform: scale(1.22);\n\ttransform: scale(1.22);\n}\n\n.btn-move-left i {\n\tmargin-right: 0;\n}\n.btn-move-left:hover i,\n.btn-move-left:focus i {\n\t-webkit-transform: translate3d(-5px, 0, 0);\n\t-moz-transform: translate3d(-5px, 0, 0);\n\t-o-transform: translate3d(-5px, 0, 0);\n\t-ms-transform: translate3d(-5px, 0, 0);\n\ttransform: translate3d(-5px, 0, 0);\n}\n\n.btn-move-right i {\n\tmargin-right: 0;\n}\n.btn-move-right:hover i,\n.btn-move-right:focus i {\n\t-webkit-transform: translate3d(5px, 0, 0);\n\t-moz-transform: translate3d(5px, 0, 0);\n\t-o-transform: translate3d(5px, 0, 0);\n\t-ms-transform: translate3d(5px, 0, 0);\n\ttransform: translate3d(5px, 0, 0);\n}\n\nbutton,\ninput,\noptgroup,\nselect,\ntextarea {\n\tfont-family: \"Montserrat\", \"Helvetica Neue\", Arial, sans-serif;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n\tfont-weight: 400;\n}\n\na {\n\tcolor: inherit;\n}\na:hover,\na:focus {\n\tcolor: #1c77c3;\n}\n\nh1,\n.h1 {\n\tfont-size: 3em;\n\tline-height: 2.15;\n\tmargin-bottom: 30px;\n}\nh1 small,\n.h1 small {\n\tfont-weight: 600;\n\ttext-transform: uppercase;\n\topacity: 0.8;\n}\n\nh2,\n.h2 {\n\tfont-size: 2.3em;\n\tmargin-bottom: 25px;\n}\n\nh3,\n.h3 {\n\tfont-size: 1.8em;\n\tmargin-bottom: 25px;\n\tline-height: 1.6em;\n}\n\nh4,\n.h4 {\n\tfont-size: 1.6em;\n\tline-height: 1.45em;\n\tmargin-top: 15px;\n\tmargin-bottom: 10px;\n}\nh4 + .category,\nh4.title + .category,\n.h4 + .category,\n.h4.title + .category {\n\tmargin-top: -10px;\n}\n\nh5,\n.h5 {\n\tfont-size: 1.47em;\n\tline-height: 1.3em;\n\tmargin-bottom: 15px;\n}\n\nh6,\n.h6 {\n\tfont-size: 1em;\n\tfont-weight: 600;\n\ttext-transform: uppercase;\n\tline-height: 1.5em;\n}\n\np.description {\n\tfont-size: 1.14em;\n}\n\n.title {\n\tfont-weight: 600;\n}\n.title.title-up {\n\ttext-transform: uppercase;\n}\n.title.title-up a {\n\tcolor: #2c2c2c;\n\ttext-decoration: none;\n}\n.title + .category {\n\tmargin-top: -10px;\n}\n\n.description,\n.card-description,\n.footer-big p,\n.card .footer .stats {\n\tcolor: #292929 !important;\n\tfont-weight: 300;\n}\n\n.category,\n.card-category {\n\ttext-transform: capitalize;\n\tfont-weight: 400;\n\tcolor: inherit;\n\tfont-size: 0.7142em;\n}\n\n.text-primary,\na.text-primary:focus,\na.text-primary:hover {\n\tcolor: #1c77c3 !important;\n}\n\n.text-info,\na.text-info:focus,\na.text-info:hover {\n\tcolor: #39a9db !important;\n}\n\n.text-success,\na.text-success:focus,\na.text-success:hover {\n\tcolor: #28a745 !important;\n}\n\n.text-warning,\na.text-warning:focus,\na.text-warning:hover {\n\tcolor: #ffc759 !important;\n}\n\n.text-danger,\na.text-danger:focus,\na.text-danger:hover {\n\tcolor: #c1292e !important;\n}\n\n.text-gray,\na.text-gray:focus,\na.text-gray:hover {\n\tcolor: #e3e3e3 !important;\n}\n\n.blockquote {\n\tborder-left: none;\n\tborder: 1px solid #65adff;\n\tpadding: 20px;\n\tfont-size: 1.1em;\n\tline-height: 1.8;\n}\n.blockquote small {\n\tcolor: #65adff;\n\tfont-size: 0.8571em;\n\ttext-transform: uppercase;\n}\n.blockquote.blockquote-primary {\n\tborder-color: #1c77c3;\n\tcolor: #1c77c3;\n}\n.blockquote.blockquote-primary small {\n\tcolor: #1c77c3;\n}\n.blockquote.blockquote-danger {\n\tborder-color: #c1292e;\n\tcolor: #c1292e;\n}\n.blockquote.blockquote-danger small {\n\tcolor: #c1292e;\n}\n.blockquote.blockquote-white {\n\tborder-color: rgba(255, 255, 255, 0.8);\n\tcolor: #ffffff;\n}\n.blockquote.blockquote-white small {\n\tcolor: rgba(255, 255, 255, 0.8);\n}\n\n:root {\n\t--base-font-size: 14px;\n}\n\nbody {\n\tcolor: #2c2c2c;\n\tfont-size: var(--base-font-size);\n\tfont-family: \"Montserrat\", \"Helvetica Neue\", Arial, sans-serif;\n\t-moz-osx-font-smoothing: grayscale;\n\t-webkit-font-smoothing: antialiased;\n}\n\n.main {\n\tposition: relative;\n\tbackground: #ffffff;\n}\n\n.btn-surface,\n.nav-pill-bar .nav-item a {\n\tbackground-color: transparent;\n\tcolor: inherit;\n}\n\n.btn-surface:hover,\n.nav-pill-bar .nav-item a:hover {\n\tbackground-color: #efefefd1;\n\tcolor: black;\n\ttext-decoration: none;\n}\n\n.btn-surface.active {\n\tbackground-color: #f7f7f7;\n}\n.btn-surface:focus {\n\tcolor: inherit;\n}\n\n/* Animations */\n.nav-pills .nav-link,\n.navbar,\n.nav-tabs .nav-link,\n.sidebar .nav a,\n.sidebar .nav a i,\n.animation-transition-general,\n.card-collapse .card .card-header a[data-toggle=\"collapse\"] i,\n.sidebar .user .info > a > span,\n.off-canvas-sidebar .user .info > a > span,\n.sidebar .user a,\n.off-canvas-sidebar .user a,\n.sidebar .user .photo,\n.off-canvas-sidebar .user .photo,\n.sidebar .logo a.logo-mini,\n.sidebar .logo a.logo-normal,\n.off-canvas-sidebar,\n.logo-mini,\n.off-canvas-sidebar .logo a.logo-normal,\n.sidebar .nav p,\n.off-canvas-sidebar .nav p,\n.sidebar .navbar-minimize,\n.off-canvas-sidebar .navbar-minimize,\n.sidebar\n\t.sidebar-wrapper\n\t> .nav\n\t[data-toggle=\"collapse\"]\n\t~ div\n\t> ul\n\t> li\n\t> a\n\tspan,\n.sidebar\n\t.sidebar-wrapper\n\t.user\n\t.info\n\t[data-toggle=\"collapse\"]\n\t~ div\n\t> ul\n\t> li\n\t> a\n\tspan,\n.off-canvas-sidebar\n\t.sidebar-wrapper\n\t> .nav\n\t[data-toggle=\"collapse\"]\n\t~ div\n\t> ul\n\t> li\n\t> a\n\tspan,\n.off-canvas-sidebar\n\t.sidebar-wrapper\n\t.user\n\t.info\n\t[data-toggle=\"collapse\"]\n\t~ div\n\t> ul\n\t> li\n\t> a\n\tspan,\n.tag,\n.tag [data-role=\"remove\"],\n.animation-transition-general,\n.sidebar .user .info > a > span,\n.off-canvas-sidebar .user .info > a > span,\n.sidebar .user a,\n.off-canvas-sidebar .user a,\n.sidebar .user .photo,\n.off-canvas-sidebar .user .photo,\n.sidebar .logo a.logo-mini,\n.sidebar .logo a.logo-normal,\n.off-canvas-sidebar .logo a.logo-mini,\n.off-canvas-sidebar .logo a.logo-normal,\n.sidebar .nav p,\n.off-canvas-sidebar .nav p,\n.sidebar .navbar-minimize,\n.off-canvas-sidebar .navbar-minimize {\n\t-webkit-transition: all 300ms ease 0s;\n\t-moz-transition: all 300ms ease 0s;\n\t-o-transition: all 300ms ease 0s;\n\t-ms-transition: all 300ms ease 0s;\n\ttransition: all 300ms ease 0s;\n}\n\n.dropdown-toggle:after,\n.bootstrap-switch-label:before,\n.caret {\n\t-webkit-transition: all 150ms ease 0s;\n\t-moz-transition: all 150ms ease 0s;\n\t-o-transition: all 150ms ease 0s;\n\t-ms-transition: all 150ms ease 0s;\n\ttransition: all 150ms ease 0s;\n}\n\n.dropdown-toggle[aria-expanded=\"true\"]:after,\na[data-toggle=\"collapse\"][aria-expanded=\"true\"] .caret,\n.card-collapse .card a[data-toggle=\"collapse\"][aria-expanded=\"true\"] i,\n.card-collapse .card a[data-toggle=\"collapse\"].expanded i {\n\tfilter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);\n\t-webkit-transform: rotate(180deg);\n\t-ms-transform: rotate(180deg);\n\ttransform: rotate(180deg);\n}\n\n.button-bar {\n\tdisplay: block;\n\tposition: relative;\n\twidth: 22px;\n\theight: 1px;\n\tborder-radius: 1px;\n\tbackground: #ffffff;\n}\n.button-bar + .button-bar {\n\tmargin-top: 7px;\n}\n.button-bar:nth-child(2) {\n\twidth: 17px;\n}\n\n.caret {\n\tdisplay: inline-block;\n\twidth: 0;\n\theight: 0;\n\tmargin-left: 2px;\n\tvertical-align: middle;\n\tborder-top: 4px dashed;\n\tborder-top: 4px solid\\9;\n\tborder-right: 4px solid transparent;\n\tborder-left: 4px solid transparent;\n}\n\n.pull-left {\n\tfloat: left;\n}\n\n.pull-right {\n\tfloat: right;\n}\n\n.offline-doc .navbar.navbar-transparent {\n\tpadding-top: 25px;\n\tborder-bottom: none;\n}\n.offline-doc .navbar.navbar-transparent .navbar-minimize {\n\tdisplay: none;\n}\n.offline-doc .navbar.navbar-transparent .navbar-brand,\n.offline-doc .navbar.navbar-transparent .collapse .navbar-nav .nav-link {\n\tcolor: #ffffff !important;\n}\n.offline-doc .footer {\n\tz-index: 3 !important;\n}\n.offline-doc .page-header .container {\n\tz-index: 3;\n}\n.offline-doc .page-header:after {\n\tbackground-color: rgba(0, 0, 0, 0.5);\n\tcontent: \"\";\n\tdisplay: block;\n\theight: 100%;\n\tleft: 0;\n\tposition: absolute;\n\ttop: 0;\n\twidth: 100%;\n\tz-index: 2;\n}\n\n.fixed-plugin .dropdown-menu li {\n\tpadding: 2px !important;\n}\n\n.badge.badge-default {\n\tborder-color: #65adff;\n\tbackground-color: #65adff;\n}\n.badge.badge-primary {\n\tborder-color: #1c77c3;\n\tbackground-color: #1c77c3;\n}\n.badge.badge-info {\n\tborder-color: #39a9db;\n\tbackground-color: #39a9db;\n}\n.badge.badge-success {\n\tborder-color: #28a745;\n\tbackground-color: #28a745;\n}\n.badge.badge-warning {\n\tborder-color: #ffc759;\n\tbackground-color: #ffc759;\n}\n.badge.badge-danger {\n\tborder-color: #c1292e;\n\tbackground-color: #c1292e;\n}\n.badge.badge-neutral {\n\tborder-color: #ffffff;\n\tbackground-color: #ffffff;\n\tcolor: inherit;\n}\n\n.card-user form .form-group {\n\tmargin-bottom: 20px;\n}\n\n.ct-label.ct-horizontal.ct-end,\n.ct-label.ct-vertical.ct-start {\n\tfont-size: 14px;\n}\n\n.ct-chart.ct-perfect-fourth .ct-chart-pie .ct-label {\n\tfont-size: 14px;\n}\n\n.card .card-footer .footer-line {\n\tpadding-top: 3px;\n}\n.card.bootstrap-table .dropdown-item.active {\n\tbackground-color: #65adff;\n\tcolor: #ffffff;\n}\n.card .team-members .avatar {\n\tmargin-top: 5px;\n}\n.card .team-members .text-right .btn {\n\tmargin-top: 5px;\n}\n\n.btn-group-sm .btn-round {\n\tborder-radius: 30px;\n}\n\n.heart {\n\tcolor: #eb5e28;\n\tanimation: hearthing 1s ease infinite;\n}\n\n@keyframes hearthing {\n\t0% {\n\t\ttransform: scale(0.75);\n\t}\n\t20% {\n\t\ttransform: scale(1);\n\t}\n\t40% {\n\t\ttransform: scale(0.75);\n\t}\n\t60% {\n\t\ttransform: scale(1);\n\t}\n\t80% {\n\t\ttransform: scale(0.75);\n\t}\n\t100% {\n\t\ttransform: scale(0.75);\n\t}\n}\n.datepicker .table-condensed tbody > tr:first-of-type .day {\n\tpadding-top: 5px;\n}\n\n.navbar {\n\tpadding-top: 0.625rem;\n\tpadding-bottom: 0.4rem;\n\tmin-height: 53px;\n\tmargin-bottom: 20px;\n}\n.navbar a {\n\tvertical-align: middle;\n}\n.navbar a:not(.btn):not(.dropdown-item) {\n\tcolor: #ffffff;\n}\n.navbar a.dropdown-item {\n\tcolor: #65adff;\n}\n.navbar.bg-white .input-group .form-control,\n.navbar.bg-white .input-group.no-border .form-control {\n\tcolor: #65adff;\n}\n.navbar.bg-white .input-group .form-control::-moz-placeholder,\n.navbar.bg-white .input-group.no-border .form-control::-moz-placeholder {\n\tcolor: #65adff;\n}\n.navbar.bg-white .input-group .form-control:-ms-input-placeholder,\n.navbar.bg-white .input-group.no-border .form-control:-ms-input-placeholder {\n\tcolor: #65adff;\n}\n.navbar.bg-white .input-group .form-control::-webkit-input-placeholder,\n.navbar.bg-white\n\t.input-group.no-border\n\t.form-control::-webkit-input-placeholder {\n\tcolor: #65adff;\n}\n.navbar.bg-white .input-group-prepend .input-group-text i,\n.navbar.bg-white .input-group-append .input-group-text i {\n\tcolor: #65adff;\n\topacity: 0.5;\n}\n.navbar .form-group,\n.navbar .input-group {\n\tmargin: 0;\n\tmargin-left: -3px;\n\tmargin-right: 5px;\n}\n.navbar .form-group .form-group-addon,\n.navbar .form-group .input-group-prepend .input-group-text,\n.navbar .form-group .input-group-append .input-group-text,\n.navbar .input-group .form-group-addon,\n.navbar .input-group .input-group-prepend .input-group-text,\n.navbar .input-group .input-group-append .input-group-text {\n\tcolor: #65adff;\n}\n.navbar .form-group .form-group-addon i,\n.navbar .form-group .input-group-prepend .input-group-text i,\n.navbar .form-group .input-group-append .input-group-text i,\n.navbar .input-group .form-group-addon i,\n.navbar .input-group .input-group-prepend .input-group-text i,\n.navbar .input-group .input-group-append .input-group-text i {\n\topacity: 1;\n}\n.navbar .form-group.no-border .form-control,\n.navbar .input-group.no-border .form-control {\n\tcolor: #65adff;\n}\n.navbar .form-group.no-border .form-control::-moz-placeholder,\n.navbar .input-group.no-border .form-control::-moz-placeholder {\n\tcolor: #65adff;\n}\n.navbar .form-group.no-border .form-control:-ms-input-placeholder,\n.navbar .input-group.no-border .form-control:-ms-input-placeholder {\n\tcolor: #65adff;\n}\n.navbar .form-group.no-border .form-control::-webkit-input-placeholder,\n.navbar .input-group.no-border .form-control::-webkit-input-placeholder {\n\tcolor: #65adff;\n}\n.navbar p {\n\tdisplay: inline-block;\n\tmargin: 0;\n\tline-height: 0.2em;\n\tfont-size: 1em;\n\tfont-weight: 400;\n}\n.navbar.navbar-absolute {\n\tposition: absolute;\n\twidth: 100%;\n\tpadding-top: 10px;\n\tz-index: 1029;\n\ttop: 0;\n}\n.documentation .navbar.fixed-top {\n\tleft: 0;\n\twidth: initial;\n}\n.navbar .navbar-wrapper {\n\tdisplay: inline-flex;\n\talign-items: center;\n}\n.navbar .navbar-wrapper .navbar-minimize {\n\tpadding-right: 10px;\n}\n.navbar .navbar-wrapper .navbar-minimize .btn {\n\tmargin: 0;\n}\n.navbar .navbar-wrapper .navbar-toggle .navbar-toggler {\n\tpadding-left: 0;\n}\n.navbar .navbar-wrapper .navbar-toggle:hover .navbar-toggler-bar.bar2 {\n\twidth: 22px;\n}\n.navbar .navbar-nav.navbar-logo {\n\tposition: absolute;\n\tleft: 0;\n\tright: 0;\n\tmargin: 0 auto;\n\twidth: 49px;\n\ttop: -4px;\n}\n.navbar .navbar-nav .nav-link.btn {\n\tpadding: 11px 22px;\n}\n.navbar .navbar-nav .nav-link.btn.btn-lg {\n\tpadding: 15px 35px;\n}\n.navbar .navbar-nav .nav-link.btn.btn-sm {\n\tpadding: 5px 15px;\n}\n.navbar .navbar-nav .nav-link {\n\ttext-transform: uppercase;\n\tfont-size: 0.7142em;\n\tpadding: 0.5rem 0.7rem;\n\tline-height: 1.625rem;\n\tmargin-right: 3px;\n}\n.navbar .navbar-nav .nav-link i.fa + p,\n.navbar .navbar-nav .nav-link i.nc-icon + p {\n\tmargin-left: 3px;\n}\n.navbar .navbar-nav .nav-link i.fa,\n.navbar .navbar-nav .nav-link i.nc-icon {\n\tfont-size: 18px;\n\tposition: relative;\n\ttop: 3px;\n\ttext-align: center;\n\twidth: 21px;\n}\n.navbar .navbar-nav .nav-link i.nc-icon {\n\ttop: 4px;\n\tfont-size: 16px;\n}\n.navbar .navbar-nav .nav-link.profile-photo .profile-photo-small {\n\twidth: 27px;\n\theight: 27px;\n}\n.navbar .navbar-nav .nav-link.disabled {\n\topacity: 0.5;\n\tcolor: #ffffff;\n}\n.navbar .navbar-nav .nav-item.active .nav-link:not(.btn),\n.navbar .navbar-nav .nav-item .nav-link:not(.btn):focus,\n.navbar .navbar-nav .nav-item .nav-link:not(.btn):hover,\n.navbar .navbar-nav .nav-item .nav-link:not(.btn):active {\n\tborder-radius: 3px;\n\tcolor: #65adff;\n}\n.navbar .logo-container {\n\twidth: 27px;\n\theight: 27px;\n\toverflow: hidden;\n\tmargin: 0 auto;\n\tborder-radius: 50%;\n\tborder: 1px solid transparent;\n}\n.navbar .navbar-brand {\n\ttext-transform: capitalize;\n\tfont-size: 20px;\n\tpadding-top: 0.5rem;\n\tpadding-bottom: 0.5rem;\n\tline-height: 1.625rem;\n}\n.navbar .navbar-toggler {\n\twidth: 37px;\n\theight: 27px;\n\tvertical-align: middle;\n\toutline: 0;\n\tcursor: pointer;\n}\n.navbar .navbar-toggler .navbar-toggler-bar.navbar-kebab {\n\twidth: 3px;\n\theight: 3px;\n\tborder-radius: 50%;\n\tmargin: 0 auto;\n}\n.navbar .button-dropdown .navbar-toggler-bar:nth-child(2) {\n\twidth: 17px;\n}\n.navbar.navbar-transparent {\n\tbackground-color: transparent !important;\n\tbox-shadow: none;\n\tborder-bottom: 1px solid #ddd;\n}\n.navbar.navbar-transparent a:not(.dropdown-item):not(.btn) {\n\tcolor: #65adff;\n}\n.navbar.navbar-transparent a:not(.dropdown-item):not(.btn).disabled {\n\topacity: 0.5;\n\tcolor: #65adff;\n}\n.navbar.navbar-transparent .button-bar {\n\tbackground: #65adff;\n}\n.navbar.navbar-transparent .nav-item .nav-link:not(.btn) {\n\tcolor: #65adff;\n}\n.navbar.navbar-transparent .nav-item.active .nav-link:not(.btn),\n.navbar.navbar-transparent .nav-item .nav-link:not(.btn):focus,\n.navbar.navbar-transparent .nav-item .nav-link:not(.btn):hover,\n.navbar.navbar-transparent .nav-item .nav-link:not(.btn):focus:hover,\n.navbar.navbar-transparent .nav-item .nav-link:not(.btn):active {\n\tcolor: #1c77c3;\n}\n.navbar.bg-white a:not(.dropdown-item):not(.btn) {\n\tcolor: #65adff;\n}\n.navbar.bg-white a:not(.dropdown-item):not(.btn).disabled {\n\topacity: 0.5;\n\tcolor: #65adff;\n}\n.navbar.bg-white .button-bar {\n\tbackground: #65adff;\n}\n.navbar.bg-white .nav-item.active .nav-link:not(.btn),\n.navbar.bg-white .nav-item .nav-link:not(.btn):focus,\n.navbar.bg-white .nav-item .nav-link:not(.btn):hover,\n.navbar.bg-white .nav-item .nav-link:not(.btn):active {\n\tcolor: #39a9db;\n}\n.navbar.bg-white .logo-container {\n\tborder: 1px solid #65adff;\n}\n.navbar .navbar-collapse .nav-item a {\n\tfont-size: 14px;\n}\n\n.bg-default {\n\tbackground-color: #65adff !important;\n}\n\n.bg-primary {\n\tbackground-color: #1c77c3 !important;\n}\n\n.bg-info {\n\tbackground-color: #39a9db !important;\n}\n\n.bg-success {\n\tbackground-color: #28a745 !important;\n}\n\n.bg-danger {\n\tbackground-color: #c1292e !important;\n}\n\n.bg-warning {\n\tbackground-color: #ffc759 !important;\n}\n\n.bg-white {\n\tbackground-color: #ffffff !important;\n}\n\n.dropdown .dropdown-menu,\n.dropup .dropdown-menu,\n.bootstrap-select .dropdown-menu {\n\tdisplay: block;\n\tmargin-top: 2rem;\n\topacity: 0;\n\tfilter: alpha(opacity=0);\n\t-webkit-box-shadow: 1px 2px 7px 1px rgba(0, 0, 0, 0.125);\n\tbox-shadow: 1px 2px 7px 1px rgba(0, 0, 0, 0.125);\n\tvisibility: hidden;\n\tposition: absolute;\n\ttransition: all 0.3s cubic-bezier(0.215, 0.61, 0.355, 1) 0s,\n\t\topacity 0.3s ease 0s, height 0s linear 0.35s;\n}\n.dropdown .dropdown-menu[x-placement=\"top-start\"],\n.dropup .dropdown-menu[x-placement=\"top-start\"],\n.bootstrap-select .dropdown-menu[x-placement=\"top-start\"] {\n\t-webkit-transform: translate3d(-20px, 0px, 0) !important;\n\t-moz-transform: translate3d(-20px, 0px, 0) !important;\n\t-o-transform: translate3d(-20px, 0px, 0) !important;\n\t-ms-transform: translate3d(-20px, 0px, 0) !important;\n\ttransform: translate3d(-20px, 0px, 0) !important;\n}\n.dropdown .dropdown-menu[x-placement=\"bottom-start\"],\n.dropup .dropdown-menu[x-placement=\"bottom-start\"],\n.bootstrap-select .dropdown-menu[x-placement=\"bottom-start\"] {\n\t-webkit-transform: translate3d(-20px, 0px, 0) !important;\n\t-moz-transform: translate3d(-20px, 0px, 0) !important;\n\t-o-transform: translate3d(-20px, 0px, 0) !important;\n\t-ms-transform: translate3d(-20px, 0px, 0) !important;\n\ttransform: translate3d(-20px, 0px, 0) !important;\n}\n.dropdown.show .dropdown-menu,\n.dropup.show .dropdown-menu,\n.bootstrap-select.show .dropdown-menu {\n\topacity: 1;\n\tfilter: alpha(opacity=100);\n\tvisibility: visible;\n}\n.dropdown.show .dropdown-menu[x-placement=\"top-start\"],\n.dropup.show .dropdown-menu[x-placement=\"top-start\"],\n.bootstrap-select.show .dropdown-menu[x-placement=\"top-start\"] {\n\t-webkit-transform: translate3d(-20px, -50px, 0) !important;\n\t-moz-transform: translate3d(-20px, -50px, 0) !important;\n\t-o-transform: translate3d(-20px, -50px, 0) !important;\n\t-ms-transform: translate3d(-20px, -50px, 0) !important;\n\ttransform: translate3d(-20px, -50px, 0) !important;\n\ttop: auto !important;\n\tbottom: 0 !important;\n}\n.dropdown.show .dropdown-menu[x-placement=\"bottom-start\"],\n.dropup.show .dropdown-menu[x-placement=\"bottom-start\"],\n.bootstrap-select.show .dropdown-menu[x-placement=\"bottom-start\"] {\n\t-webkit-transform: translate3d(-20px, 50px, 0) !important;\n\t-moz-transform: translate3d(-20px, 50px, 0) !important;\n\t-o-transform: translate3d(-20px, 50px, 0) !important;\n\t-ms-transform: translate3d(-20px, 50px, 0) !important;\n\ttransform: translate3d(-20px, 50px, 0) !important;\n\tbottom: auto !important;\n\ttop: 0 !important;\n}\n\n.dropup .dropdown-menu,\n.dropdown-btn .dropdown-menu {\n\t-webkit-transform: translate3d(-20px, 0px, 0) !important;\n\t-moz-transform: translate3d(-20px, 0px, 0) !important;\n\t-o-transform: translate3d(-20px, 0px, 0) !important;\n\t-ms-transform: translate3d(-20px, 0px, 0) !important;\n\ttransform: translate3d(-20px, 0px, 0) !important;\n\ttop: auto !important;\n\tbottom: 0 !important;\n}\n\n.dropup.show .dropdown-menu,\n.dropdown-btn.show .dropdown-menu {\n\topacity: 1;\n\tvisibility: visible;\n}\n.dropup.show .dropdown-menu .dropdown-menu.inner,\n.dropdown-btn.show .dropdown-menu .dropdown-menu.inner {\n\t-webkit-transform: translate3d(0, 0px, 0) !important;\n\t-moz-transform: translate3d(0, 0px, 0) !important;\n\t-o-transform: translate3d(0, 0px, 0) !important;\n\t-ms-transform: translate3d(0, 0px, 0) !important;\n\ttransform: translate3d(0, 0px, 0) !important;\n}\n\n.bootstrap-select.show .dropdown-menu.show[x-placement=\"top-start\"] {\n\t-webkit-transform: translate3d(-20px, -60px, 0) !important;\n\t-moz-transform: translate3d(-20px, -60px, 0) !important;\n\t-o-transform: translate3d(-20px, -60px, 0) !important;\n\t-ms-transform: translate3d(-20px, -60px, 0) !important;\n\ttransform: translate3d(-20px, -60px, 0) !important;\n\ttop: auto !important;\n\tbottom: 0 !important;\n}\n.bootstrap-select.show .dropdown-menu.show li:last-child a:hover {\n\tborder-radius: 0 0 12px 12px;\n}\n\n.bootstrap-select.dropup.show:before {\n\ttop: -1px !important;\n}\n.bootstrap-select.dropup.show:after {\n\ttop: -2px !important;\n}\n\n.dropdown-menu {\n\tbackground-color: #ffffff;\n\tborder: 0 none;\n\tborder-radius: 12px;\n\tmargin-top: 10px;\n\tpadding: 0px;\n}\n.dropdown-menu .divider {\n\tbackground-color: #f1eae0;\n\tmargin: 0px;\n}\n.dropdown-menu .dropdown-header {\n\tcolor: #292929 !important;\n\tfont-size: 0.8571em;\n\tpadding: 10px 15px;\n}\n.dropdown-menu .no-notification {\n\tcolor: #292929 !important;\n\tfont-size: 1.2em;\n\tpadding: 30px 30px;\n\ttext-align: center;\n}\n.dropdown-menu .dropdown-item {\n\tcolor: #292929;\n\tfont-size: 14px;\n\tpadding: 10px;\n\tclear: both;\n\twhite-space: nowrap;\n\twidth: 100%;\n\tdisplay: block;\n}\n.dropdown-menu .dropdown-item img {\n\tmargin-top: -3px;\n}\n.dropdown-menu .dropdown-item:focus {\n\toutline: 0 !important;\n}\n.btn-group.select .dropdown-menu {\n\tmin-width: 100%;\n}\n.dropdown-menu .dropdown-item:first-child {\n\tborder-top-left-radius: 12px;\n\tborder-top-right-radius: 12px;\n}\n.dropdown-menu .dropdown-item:last-child {\n\tborder-bottom-left-radius: 12px;\n\tborder-bottom-right-radius: 12px;\n}\n.select .dropdown-menu .dropdown-item:first-child {\n\tborder-radius: 0;\n\tborder-bottom: 0 none;\n}\n.dropdown-menu .dropdown-item:hover,\n.dropdown-menu .dropdown-item:focus {\n\tcolor: #ffffff !important;\n\topacity: 1;\n\ttext-decoration: none;\n}\n.dropdown-menu .dropdown-item:hover,\n.dropdown-menu .dropdown-item:focus {\n\tbackground-color: #1c77c3;\n}\n.dropdown-menu.dropdown-primary .dropdown-item:hover,\n.dropdown-menu.dropdown-primary .dropdown-item:focus {\n\tbackground-color: #238adf;\n}\n.dropdown-menu.dropdown-info .dropdown-item:hover,\n.dropdown-menu.dropdown-info .dropdown-item:focus {\n\tbackground-color: #57b6e0;\n}\n.dropdown-menu.dropdown-success .dropdown-item:hover,\n.dropdown-menu.dropdown-success .dropdown-item:focus {\n\tbackground-color: #18945a;\n}\n.dropdown-menu.dropdown-warning .dropdown-item:hover,\n.dropdown-menu.dropdown-warning .dropdown-item:focus {\n\tbackground-color: #ffd37d;\n}\n.dropdown-menu.dropdown-danger .dropdown-item:hover,\n.dropdown-menu.dropdown-danger .dropdown-item:focus {\n\tbackground-color: #d5393e;\n}\n\n.dropdown-divider {\n\tmargin: 0 !important;\n}\n\n.btn-group.select.open {\n\toverflow: visible;\n}\n\n.dropdown-menu-right {\n\tright: -2px;\n\tleft: auto;\n}\n\n.navbar-nav .dropdown-menu:before,\n.dropdown .dropdown-menu[x-placement=\"bottom-start\"]:before,\n.dropdown .dropdown-menu[x-placement=\"bottom-end\"]:before,\n.card.card-just-text .dropdown .dropdown-menu:before,\n.card-just-text .dropdown .dropdown-menu:before,\n.dropdown-btn .dropdown-menu:before {\n\tborder-bottom: 11px solid #f1eae0;\n\tborder-left: 11px solid rgba(0, 0, 0, 0);\n\tborder-right: 11px solid rgba(0, 0, 0, 0);\n\tcontent: \"\";\n\tdisplay: inline-block;\n\tposition: absolute;\n\tright: 12px;\n\ttop: -12px;\n}\n\n.navbar-nav .dropdown-menu:after,\n.dropdown .dropdown-menu[x-placement=\"bottom-start\"]:after,\n.dropdown .dropdown-menu[x-placement=\"bottom-end\"]:after,\n.card.card-just-text .dropdown .dropdown-menu:after,\n.card-just-text .dropdown .dropdown-menu:after,\n.dropdown-btn .dropdown-menu:after {\n\tborder-bottom: 11px solid #ffffff;\n\tborder-left: 11px solid rgba(0, 0, 0, 0);\n\tborder-right: 11px solid rgba(0, 0, 0, 0);\n\tcontent: \"\";\n\tdisplay: inline-block;\n\tposition: absolute;\n\tright: 12px;\n\ttop: -11px;\n}\n\n.dropdown .dropdown-menu.dropdown-notification[x-placement=\"top-start\"]:before,\n.dropdown\n\t.dropdown-menu.dropdown-notification[x-placement=\"bottom-start\"]:before {\n\tleft: 30px !important;\n\tright: auto;\n}\n\n.dropdown .dropdown-menu.dropdown-notification[x-placement=\"top-start\"]:after,\n.dropdown\n\t.dropdown-menu.dropdown-notification[x-placement=\"bottom-start\"]:after {\n\tleft: 30px !important;\n\tright: auto;\n}\n\n@media screen and (min-width: 768px) {\n\t.navbar-form {\n\t\tmargin-top: 21px;\n\t\tmargin-bottom: 21px;\n\t\tpadding-left: 5px;\n\t\tpadding-right: 5px;\n\t}\n\n\t.navbar-search-form {\n\t\tdisplay: none;\n\t}\n\n\t.navbar-nav .dropdown-item .dropdown-menu,\n\t.dropdown .dropdown-menu,\n\t.dropdown-btn .dropdown-menu {\n\t\ttransform: translate3d(0px, -40px, 0px);\n\t\ttransition: all 0.3s cubic-bezier(0.215, 0.61, 0.355, 1) 0s,\n\t\t\topacity 0.3s ease 0s, height 0s linear 0.35s;\n\t}\n\n\t.navbar-nav .dropdown-item.show .dropdown-menu,\n\t.dropdown.show .dropdown-menu,\n\t.dropdown-btn.show .dropdown-menu {\n\t\ttransform: translate3d(0px, 0px, 0px);\n\t\tvisibility: visible !important;\n\t}\n\n\t.bootstrap-select .dropdown-menu {\n\t\t-webkit-transition: all 150ms linear;\n\t\t-moz-transition: all 150ms linear;\n\t\t-o-transition: all 150ms linear;\n\t\t-ms-transition: all 150ms linear;\n\t\ttransition: all 150ms linear;\n\t}\n\n\t.bootstrap-datetimepicker-widget {\n\t\tvisibility: visible !important;\n\t}\n\n\t.bootstrap-select .show .dropdown-menu {\n\t\ttransition: all 0.3s cubic-bezier(0.215, 0.61, 0.355, 1) 0s,\n\t\t\topacity 0.3s ease 0s, height 0s linear 0.35s;\n\t\ttransform: translate3d(0px, 0px, 0px);\n\t}\n\n\t.navbar-nav.navbar-right li .dropdown-menu:before,\n\t.navbar-nav.navbar-right li .dropdown-menu:after {\n\t\tleft: auto;\n\t\tright: 12px;\n\t}\n\n\t.footer:not(.footer-big) nav ul li:first-child {\n\t\tmargin-left: 0;\n\t}\n\n\tbody > .navbar-collapse.collapse {\n\t\tdisplay: none !important;\n\t}\n}\n.dropdown-sharing .dropup-item {\n\tcolor: #292929 !important;\n\tfont-size: 14px;\n}\n.dropdown-sharing .dropup-item .social-line {\n\tline-height: 28px;\n\tpadding: 10px 20px 5px 20px !important;\n}\n.dropdown-sharing .dropup-item .social-line [class*=\"icon-\"] {\n\tfont-size: 20px;\n}\n.dropdown-sharing .dropup-item:last-child {\n\tmargin: 0 13px;\n\tdisplay: block;\n}\n.dropdown-sharing .dropup-item .btn {\n\tmargin: 10px;\n}\n.dropdown-sharing .dropup-item:hover .social-line,\n.dropdown-sharing .dropup-item:hover .action-line,\n.dropdown-sharing .dropup-item:focus .social-line,\n.dropdown-sharing .dropup-item:focus .action-line {\n\tbackground-color: #ffffff;\n\tcolor: #292929 !important;\n\topacity: 1;\n\ttext-decoration: none;\n}\n\n.show .dropdown-sharing,\n.show .dropdown-actions {\n\tmargin-bottom: 1px;\n}\n\n.dropdown-actions .dropdown-item {\n\tmargin: -15px 35px;\n}\n.dropdown-actions .dropdown-item .action-line {\n\tpadding: 5px 10px;\n\tline-height: 24px;\n\tfont-weight: bold;\n}\n.dropdown-actions .dropdown-item .action-line [class*=\"icon-\"] {\n\tfont-size: 24px;\n}\n.dropdown-actions .dropdown-item .action-line .col-sm-9 {\n\tline-height: 34px;\n}\n.dropdown-actions .dropdown-item .link-danger {\n\tcolor: #c1292e;\n}\n.dropdown-actions .dropdown-item .link-danger:hover,\n.dropdown-actions .dropdown-item .link-danger:active,\n.dropdown-actions .dropdown-item .link-danger:focus {\n\tcolor: #c1292e;\n}\n.dropdown-actions li:hover a,\n.dropdown-actions li:focus a {\n\tcolor: #292929 !important;\n\topacity: 1;\n\ttext-decoration: none;\n}\n.dropdown-actions .action-line .icon-simple {\n\tmargin-left: -15px;\n}\n\n.dropdown .dropdown-menu[x-placement=\"top-start\"]:before,\n.dropdown .dropdown-menu[x-placement=\"top-end\"]:before,\n.dropup .dropdown-menu:before {\n\tborder-top: 11px solid #dcd9d1;\n\tborder-left: 11px solid transparent;\n\tborder-right: 11px solid transparent;\n\tcontent: \"\";\n\tdisplay: inline-block;\n\tposition: absolute;\n\tright: 12px;\n\tbottom: -12px;\n}\n\n.dropdown .dropdown-menu[x-placement=\"top-start\"]:after,\n.dropdown .dropdown-menu[x-placement=\"top-end\"]:after,\n.dropup .dropdown-menu:after {\n\tborder-top: 11px solid #fff;\n\tborder-left: 11px solid transparent;\n\tborder-right: 11px solid transparent;\n\tcontent: \"\";\n\tdisplay: inline-block;\n\tposition: absolute;\n\tright: 12px;\n\tbottom: -11px;\n}\n\n.dropup .dropdown-toggle:after,\n.dropdown .dropdown-toggle:after {\n\tmargin-left: 0;\n}\n\n.dropdown-notification .dropdown-notification-list .notification-item {\n\tborder-bottom: 1px solid #f1eae0;\n\tfont-size: 16px;\n\tcolor: #66615b;\n}\n.dropdown-notification\n\t.dropdown-notification-list\n\t.notification-item\n\t.notification-text {\n\tpadding-left: 40px;\n\tposition: relative;\n\tmin-width: 330px;\n\tmin-height: 70px;\n\twhite-space: normal;\n}\n.dropdown-notification\n\t.dropdown-notification-list\n\t.notification-item\n\t.notification-text\n\t.label {\n\tdisplay: block;\n\tposition: absolute;\n\ttop: 50%;\n\tmargin-top: -12px;\n\tleft: 7px;\n}\n.dropdown-notification\n\t.dropdown-notification-list\n\t.notification-item\n\t.notification-text\n\t.message {\n\tfont-size: 0.9em;\n\tline-height: 0.7;\n\tmargin-left: 10px;\n}\n.dropdown-notification\n\t.dropdown-notification-list\n\t.notification-item\n\t.notification-text\n\t.time {\n\tcolor: #292929 !important;\n\tfont-size: 0.7em;\n\tmargin-left: 10px;\n}\n.dropdown-notification\n\t.dropdown-notification-list\n\t.notification-item\n\t.read-notification {\n\tfont-size: 12px;\n\topacity: 0;\n\tposition: absolute;\n\tright: 5px;\n\ttop: 50%;\n\tmargin-top: -12px;\n}\n.dropdown-notification .dropdown-notification-list .notification-item:hover {\n\ttext-decoration: none;\n}\n.dropdown-notification\n\t.dropdown-notification-list\n\t.notification-item:hover\n\t.notification-text {\n\tcolor: #66615b;\n\tbackground-color: #f0efeb !important;\n}\n.dropdown-notification\n\t.dropdown-notification-list\n\t.notification-item:hover\n\t.read-notification {\n\topacity: 1 !important;\n}\n.dropdown-notification .dropdown-footer {\n\tbackground-color: #e8e7e3;\n\tborder-radius: 0 0 8px 8px;\n}\n.dropdown-notification .dropdown-footer .dropdown-footer-menu {\n\tlist-style: outside none none;\n\tpadding: 0px 5px;\n}\n.dropdown-notification .dropdown-footer .dropdown-footer-menu li {\n\tdisplay: inline-block;\n\ttext-align: left;\n\tpadding: 0 10px;\n}\n.dropdown-notification .dropdown-footer .dropdown-footer-menu li a {\n\tcolor: #9c9b99;\n\tfont-size: 0.9em;\n\tline-height: 35px;\n}\n\n.alert {\n\tborder: 0;\n\tborder-radius: 3px;\n\tcolor: #ffffff;\n\tpadding-top: 0.9rem;\n\tpadding-bottom: 0.9rem;\n\tposition: relative;\n}\n.alert.alert-success {\n\tbackground-color: #178b54;\n}\n.alert.alert-danger {\n\tbackground-color: #d33036;\n}\n.alert.alert-warning {\n\tbackground-color: #ffd073;\n}\n.alert.alert-info {\n\tbackground-color: #4fb2df;\n}\n.alert.alert-primary {\n\tbackground-color: #1f85d9;\n}\n.alert .close {\n\tcolor: #ffffff;\n\topacity: 0.9;\n\ttext-shadow: none;\n\tline-height: 0;\n\toutline: 0;\n}\n.alert .close i.fa,\n.alert .close i.nc-icon {\n\tfont-size: 14px !important;\n}\n.alert .close:hover,\n.alert .close:focus {\n\topacity: 1;\n}\n.alert span[data-notify=\"icon\"] {\n\tfont-size: 27px;\n\tdisplay: block;\n\tleft: 19px;\n\tposition: absolute;\n\ttop: 50%;\n\tmargin-top: -11px;\n}\n.alert button.close {\n\tposition: absolute;\n\tright: 10px;\n\ttop: 50%;\n\tmargin-top: -13px;\n\twidth: 25px;\n\theight: 25px;\n\tpadding: 3px;\n}\n.alert .close ~ span {\n\tdisplay: block;\n\tmax-width: 89%;\n}\n.alert.alert-with-icon {\n\tpadding-left: 65px;\n}\n\nimg {\n\tmax-width: 100%;\n\tborder-radius: 3px;\n}\n\n.img-raised {\n\tbox-shadow: 0px 10px 25px 0px rgba(0, 0, 0, 0.3);\n}\n\n.table .img-wrapper {\n\twidth: 40px;\n\theight: 40px;\n\tborder-radius: 50%;\n\toverflow: hidden;\n\tmargin: 0 auto;\n}\n.table .img-row {\n\tmax-width: 60px;\n\twidth: 60px;\n}\n.table .form-check {\n\tmargin: 0;\n}\n.table .form-check label .form-check-sign::before,\n.table .form-check label .form-check-sign::after {\n\ttop: -17px;\n\tleft: 4px;\n}\n.table .btn {\n\tmargin: 0;\n}\n.table small,\n.table .small {\n\tfont-weight: 300;\n}\n.card-tasks .card-body .table {\n\tmargin-bottom: 0;\n}\n.card-tasks .card-body .table > thead > tr > th,\n.card-tasks .card-body .table > tbody > tr > th,\n.card-tasks .card-body .table > tfoot > tr > th,\n.card-tasks .card-body .table > thead > tr > td,\n.card-tasks .card-body .table > tbody > tr > td,\n.card-tasks .card-body .table > tfoot > tr > td {\n\tpadding-top: 0;\n\tpadding-bottom: 0;\n}\n.table > thead > tr > th {\n\tfont-size: 14px;\n\tfont-weight: 600;\n\tpadding-bottom: 0;\n\ttext-transform: uppercase;\n\tborder: 0;\n}\n.table .radio,\n.table .checkbox {\n\tmargin-top: 0;\n\tmargin-bottom: 0;\n\tpadding: 0;\n\twidth: 15px;\n}\n.table .radio .icons,\n.table .checkbox .icons {\n\tposition: relative;\n}\n.table .radio label:after,\n.table .radio label:before,\n.table .checkbox label:after,\n.table .checkbox label:before {\n\ttop: -17px;\n\tleft: -3px;\n}\n.table > thead > tr > th,\n.table > tbody > tr > th,\n.table > tfoot > tr > th,\n.table > thead > tr > td,\n.table > tbody > tr > td,\n.table > tfoot > tr > td {\n\tpadding: 12px 7px;\n\tvertical-align: middle;\n}\n.table .th-description {\n\tmax-width: 150px;\n}\n.table .td-price {\n\tfont-size: 26px;\n\tfont-weight: 300;\n\tmargin-top: 5px;\n\tposition: relative;\n\ttop: 4px;\n\ttext-align: right;\n}\n.table .td-total {\n\tfont-weight: 600;\n\tfont-size: 1.57em;\n\tpadding-top: 20px;\n\ttext-align: right;\n}\n.table .td-actions .btn {\n\tmargin: 0px;\n}\n.table > tbody > tr {\n\tposition: relative;\n}\n\n.table-shopping > thead > tr > th {\n\tfont-size: 1em;\n\ttext-transform: uppercase;\n}\n.table-shopping > tbody > tr > td {\n\tfont-size: 1em;\n}\n.table-shopping > tbody > tr > td b {\n\tdisplay: block;\n\tmargin-bottom: 5px;\n}\n.table-shopping .td-name {\n\tfont-weight: 400;\n\tfont-size: 1.5em;\n}\n.table-shopping .td-name small {\n\tcolor: #292929 !important;\n\tfont-size: 0.75em;\n\tfont-weight: 300;\n}\n.table-shopping .td-number {\n\tfont-weight: 300;\n\tfont-size: 1.714em;\n}\n.table-shopping .td-name {\n\tmin-width: 200px;\n}\n.table-shopping .td-number {\n\ttext-align: right;\n\tmin-width: 170px;\n}\n.table-shopping .td-number small {\n\tmargin-right: 3px;\n}\n.table-shopping .img-container {\n\twidth: 120px;\n\tmax-height: 160px;\n\toverflow: hidden;\n\tdisplay: block;\n}\n.table-shopping .img-container img {\n\twidth: 100%;\n}\n\n.table-responsive {\n\toverflow: scroll;\n\tpadding-bottom: 10px;\n}\n\n#tables .table-responsive {\n\tmargin-bottom: 30px;\n}\n\n.table-hover > tbody > tr:hover {\n\tbackground-color: #e1f0ff;\n}\n\n.footer {\n\tmargin-top: 25px;\n\tpadding: 4px 0;\n}\n.footer.footer-default {\n\tbackground-color: #f2f2f2;\n}\n.footer nav {\n\tdisplay: inline-block;\n\tpadding-left: 0;\n}\n.footer ul {\n\tmargin-bottom: 0;\n\tpadding: 0;\n\tlist-style: none;\n}\n.footer ul li {\n\tdisplay: inline-block;\n}\n.footer ul li a {\n\tcolor: inherit;\n\tpadding: 0.5rem;\n\tfont-size: 0.8571em;\n\ttext-transform: uppercase;\n\ttext-decoration: none;\n}\n.footer ul li a:hover {\n\ttext-decoration: none;\n}\n.footer .copyright {\n\tfont-size: 0.8571em;\n\tline-height: 1.8;\n}\n.footer:after {\n\tdisplay: table;\n\tclear: both;\n\tcontent: \" \";\n}\n\n.fixed-plugin {\n\tposition: fixed;\n\tright: 0;\n\twidth: 64px;\n\tbackground: rgba(0, 0, 0, 0.3);\n\tz-index: 1031;\n\tborder-radius: 8px 0 0 8px;\n\ttext-align: center;\n\ttop: 120px;\n}\n.fixed-plugin li > a,\n.fixed-plugin .badge {\n\ttransition: all 0.34s;\n\t-webkit-transition: all 0.34s;\n\t-moz-transition: all 0.34s;\n}\n.fixed-plugin .fa-cog {\n\tcolor: #ffffff;\n\tpadding: 10px;\n\tborder-radius: 0 0 6px 6px;\n\twidth: auto;\n}\n.fixed-plugin .dropdown-menu {\n\tright: 80px;\n\tleft: auto !important;\n\ttop: -52px !important;\n\twidth: 290px;\n\tborder-radius: 10px;\n\tpadding: 0 10px;\n}\n.fixed-plugin .dropdown .dropdown-menu .nc-icon {\n\ttop: 2px;\n\tright: 10px;\n\tfont-size: 14px;\n}\n.fixed-plugin .dropdown-menu:after,\n.fixed-plugin .dropdown-menu:before {\n\tright: 10px;\n\tmargin-left: auto;\n\tleft: auto;\n}\n.fixed-plugin .fa-circle-thin {\n\tcolor: #ffffff;\n}\n.fixed-plugin .active .fa-circle-thin {\n\tcolor: #00bbff;\n}\n.fixed-plugin .dropdown-menu > .active > a,\n.fixed-plugin .dropdown-menu > .active > a:hover,\n.fixed-plugin .dropdown-menu > .active > a:focus {\n\tcolor: #777777;\n\ttext-align: center;\n}\n.fixed-plugin img {\n\tborder-radius: 0;\n\twidth: 100%;\n\theight: 100px;\n\tmargin: 0 auto;\n}\n.fixed-plugin .dropdown-menu li > a:hover,\n.fixed-plugin .dropdown-menu li > a:focus {\n\tbox-shadow: none;\n}\n.fixed-plugin .badge {\n\tborder: 3px solid #ffffff;\n\tborder-radius: 50%;\n\tcursor: pointer;\n\tdisplay: inline-block;\n\theight: 23px;\n\tmargin-right: 5px;\n\tposition: relative;\n\twidth: 23px;\n}\n.fixed-plugin .badge.badge-light {\n\tborder: 1px solid #e3e3e3;\n}\n.fixed-plugin .badge.badge-light.active,\n.fixed-plugin .badge.badge-light:hover {\n\tborder: 3px solid #0bf;\n}\n.fixed-plugin .badge.active,\n.fixed-plugin .badge:hover {\n\tborder-color: #00bbff;\n}\n.fixed-plugin .badge-blue {\n\tbackground-color: #39a9db;\n}\n.fixed-plugin .badge-green {\n\tbackground-color: #28a745;\n}\n.fixed-plugin .badge-orange {\n\tbackground-color: #1c77c3;\n}\n.fixed-plugin .badge-yellow {\n\tbackground-color: #ffc759;\n}\n.fixed-plugin .badge-red {\n\tbackground-color: #c1292e;\n}\n.fixed-plugin h5 {\n\tfont-size: 14px;\n\tmargin: 10px;\n}\n.fixed-plugin .dropdown-menu li {\n\tdisplay: block;\n\tpadding: 15px 2px;\n\twidth: 25%;\n\tfloat: left;\n}\n.fixed-plugin li.adjustments-line,\n.fixed-plugin li.header-title,\n.fixed-plugin li.button-container {\n\twidth: 100%;\n\theight: 35px;\n\tmin-height: inherit;\n}\n.fixed-plugin li.button-container {\n\theight: auto;\n}\n.fixed-plugin li.button-container div {\n\tmargin-bottom: 5px;\n}\n.fixed-plugin #sharrreTitle {\n\ttext-align: center;\n\tpadding: 10px 0;\n\theight: 50px;\n}\n.fixed-plugin li.header-title {\n\theight: 30px;\n\tline-height: 25px;\n\tfont-size: 12px;\n\tfont-weight: 600;\n\ttext-align: center;\n\ttext-transform: uppercase;\n}\n.fixed-plugin .adjustments-line p {\n\tdisplay: inline-block;\n\tmargin-bottom: 0;\n\tfont-size: 1em;\n\tcolor: #3c4858;\n}\n.fixed-plugin .adjustments-line a {\n\tcolor: transparent;\n}\n.fixed-plugin .adjustments-line a .badge-colors {\n\tposition: relative;\n\ttop: -2px;\n}\n.fixed-plugin .adjustments-line a a:hover,\n.fixed-plugin .adjustments-line a a:focus {\n\tcolor: transparent;\n}\n.fixed-plugin .adjustments-line .togglebutton {\n\ttext-align: center;\n}\n.fixed-plugin .adjustments-line .togglebutton .label-switch {\n\tposition: relative;\n\tleft: -10px;\n\tfont-size: 0.7142em;\n\tcolor: #65adff;\n}\n.fixed-plugin .adjustments-line .togglebutton .label-switch.label-right {\n\tleft: 10px;\n}\n.fixed-plugin .adjustments-line .togglebutton .toggle {\n\tmargin-right: 0;\n}\n.fixed-plugin .adjustments-line .dropdown-menu > li.adjustments-line > a {\n\tpadding-right: 0;\n\tpadding-left: 0;\n\tborder-bottom: 1px solid #ddd;\n\tborder-radius: 0;\n\tmargin: 0;\n}\n.fixed-plugin .dropdown-menu > li > a.img-holder {\n\tfont-size: 16px;\n\ttext-align: center;\n\tborder-radius: 10px;\n\tbackground-color: #fff;\n\tborder: 3px solid #fff;\n\tpadding-left: 0;\n\tpadding-right: 0;\n\topacity: 1;\n\tcursor: pointer;\n\tdisplay: block;\n\tmax-height: 100px;\n\toverflow: hidden;\n\tpadding: 0;\n}\n.fixed-plugin .dropdown-menu > li > a.img-holder img {\n\tmargin-top: auto;\n}\n.fixed-plugin .dropdown-menu > li a.switch-trigger:hover,\n.fixed-plugin .dropdown-menu > li > a.switch-trigger:focus {\n\tbackground-color: transparent;\n}\n.fixed-plugin .dropdown-menu > li:hover > a.img-holder,\n.fixed-plugin .dropdown-menu > li:focus > a.img-holder {\n\tborder-color: rgba(0, 187, 255, 0.53);\n}\n.fixed-plugin .dropdown-menu > .active > a.img-holder,\n.fixed-plugin .dropdown-menu > .active > a.img-holder {\n\tborder-color: #00bbff;\n\tbackground-color: #ffffff;\n}\n.fixed-plugin .btn-social {\n\twidth: 50%;\n\tdisplay: block;\n\twidth: 48%;\n\tfloat: left;\n\tfont-weight: 600;\n}\n.fixed-plugin .btn-social i {\n\tmargin-right: 5px;\n}\n.fixed-plugin .btn-social:first-child {\n\tmargin-right: 2%;\n}\n.fixed-plugin .dropdown .dropdown-menu {\n\ttransform-origin: 0 0;\n}\n.fixed-plugin .dropdown .dropdown-menu:before {\n\tborder-bottom: 16px solid rgba(0, 0, 0, 0);\n\tborder-left: 16px solid rgba(0, 0, 0, 0.2);\n\tborder-top: 16px solid rgba(0, 0, 0, 0);\n\tright: -27px;\n\tbottom: 425px;\n}\n.fixed-plugin .dropdown .dropdown-menu:after {\n\tborder-bottom: 16px solid rgba(0, 0, 0, 0);\n\tborder-left: 16px solid #ffffff;\n\tborder-top: 16px solid rgba(0, 0, 0, 0);\n\tright: -26px;\n\tbottom: 425px;\n}\n.fixed-plugin .dropdown .dropdown-menu:before,\n.fixed-plugin .dropdown .dropdown-menu:after {\n\tcontent: \"\";\n\tdisplay: inline-block;\n\tposition: absolute;\n\twidth: 16px;\n\ttransform: translateY(-50px);\n\t-webkit-transform: translateY(-50px);\n\t-moz-transform: translateY(-50px);\n}\n.fixed-plugin .dropdown.show-dropdown .show .dropdown-menu .show {\n\ttransform: translate3d(0, -60px, 0) !important;\n\tbottom: auto !important;\n\ttop: 0 !important;\n}\n.fixed-plugin .bootstrap-switch {\n\tmargin: 0;\n}\n\n.fixed-plugin .show-dropdown .dropdown-menu[x-placement=\"bottom-start\"] {\n\t-webkit-transform: translate3d(0, -100px, 0) !important;\n\t-moz-transform: translate3d(0, -100px, 0) !important;\n\t-o-transform: translate3d(0, -100px, 0) !important;\n\t-ms-transform: translate3d(0, -100px, 0) !important;\n\ttransform: translate3d(0, -100px, 0) !important;\n}\n.fixed-plugin .show-dropdown .dropdown-menu[x-placement=\"bottom-start\"]:before,\n.fixed-plugin .show-dropdown .dropdown-menu[x-placement=\"bottom-start\"]:after {\n\ttop: 100px;\n}\n.fixed-plugin .show-dropdown .dropdown-menu[x-placement=\"top-start\"] {\n\t-webkit-transform: translate3d(0, 100px, 0) !important;\n\t-moz-transform: translate3d(0, 100px, 0) !important;\n\t-o-transform: translate3d(0, 100px, 0) !important;\n\t-ms-transform: translate3d(0, 100px, 0) !important;\n\ttransform: translate3d(0, 100px, 0) !important;\n}\n.fixed-plugin\n\t.show-dropdown.show\n\t.dropdown-menu.show[x-placement=\"bottom-start\"] {\n\t-webkit-transform: translate3d(0, -60px, 0) !important;\n\t-moz-transform: translate3d(0, -60px, 0) !important;\n\t-o-transform: translate3d(0, -60px, 0) !important;\n\t-ms-transform: translate3d(0, -60px, 0) !important;\n\ttransform: translate3d(0, -60px, 0) !important;\n}\n.fixed-plugin .show-dropdown.show .dropdown-menu.show[x-placement=\"top-start\"] {\n\t-webkit-transform: translate3d(0, 470px, 0) !important;\n\t-moz-transform: translate3d(0, 470px, 0) !important;\n\t-o-transform: translate3d(0, 470px, 0) !important;\n\t-ms-transform: translate3d(0, 470px, 0) !important;\n\ttransform: translate3d(0, 470px, 0) !important;\n}\n\n.from-check,\n.form-check-radio {\n\tmargin-bottom: 12px;\n\tposition: relative;\n}\n\n.form-check {\n\tpadding-left: 0;\n\tmargin-bottom: 0.5rem;\n}\n.form-check .form-check-label {\n\tdisplay: inline-block;\n\tposition: relative;\n\tcursor: pointer;\n\tpadding-left: 35px;\n\tline-height: 26px;\n\tmargin-bottom: 0;\n}\n.form-check .form-check-sign::before,\n.form-check .form-check-sign::after {\n\tcontent: \" \";\n\tdisplay: inline-block;\n\tposition: absolute;\n\twidth: 24px;\n\theight: 24px;\n\tleft: 0;\n\tcursor: pointer;\n\tborder-radius: 6px;\n\ttop: 0;\n\tbackground-color: #aaa7a4;\n\t-webkit-transition: opacity 0.3s linear;\n\t-moz-transition: opacity 0.3s linear;\n\t-o-transition: opacity 0.3s linear;\n\t-ms-transition: opacity 0.3s linear;\n\ttransition: opacity 0.3s linear;\n}\n.form-check .form-check-sign::after {\n\tfont-family: \"FontAwesome\";\n\tcontent: \"\\f00c\";\n\ttop: -1px;\n\ttext-align: center;\n\tfont-size: 15px;\n\topacity: 0;\n\tcolor: #fff;\n\tborder: 0;\n\tbackground-color: inherit;\n}\n.form-check.disabled .form-check-label {\n\tcolor: #292929 !important;\n\topacity: 0.5;\n\tcursor: not-allowed;\n}\n\n.form-check input[type=\"checkbox\"]:checked + .form-check-sign::after {\n\topacity: 1;\n}\n\n.form-control input[type=\"checkbox\"]:disabled + .form-check-sign::before,\n.checkbox input[type=\"checkbox\"]:disabled + .form-check-sign::after {\n\tcursor: not-allowed;\n}\n\n.form-check\n\t.form-check-label\n\tinput[type=\"checkbox\"]:disabled\n\t+ .form-check-sign,\n.form-check-radio input[type=\"radio\"]:disabled + .form-check-sign {\n\tpointer-events: none !important;\n}\n\n.form-check-radio {\n\tmargin-left: -3px;\n}\n.form-check-radio .form-check-label {\n\tpadding-left: 2rem;\n}\n.form-check-radio.disabled .form-check-label {\n\tcolor: #292929 !important;\n\topacity: 0.5;\n\tcursor: not-allowed;\n}\n\n.form-check-radio .form-check-sign::before {\n\tfont-family: \"FontAwesome\";\n\tcontent: \"\\f10c\";\n\tfont-size: 22px;\n\t-webkit-font-smoothing: antialiased;\n\t-moz-osx-font-smoothing: grayscale;\n\tdisplay: inline-block;\n\tposition: absolute;\n\topacity: 0.5;\n\tleft: 5px;\n\ttop: -5px;\n}\n\n.form-check-label input[type=\"checkbox\"]:checked + .form-check-sign:before {\n\tbackground-color: #66615b;\n}\n\n.form-check-radio input[type=\"radio\"] + .form-check-sign:after,\n.form-check-radio input[type=\"radio\"] {\n\topacity: 0;\n\t-webkit-transition: opacity 0.3s linear;\n\t-moz-transition: opacity 0.3s linear;\n\t-o-transition: opacity 0.3s linear;\n\t-ms-transition: opacity 0.3s linear;\n\ttransition: opacity 0.3s linear;\n\tcontent: \" \";\n\tdisplay: block;\n}\n\n.form-check-radio input[type=\"radio\"]:checked + .form-check-sign::after {\n\tfont-family: \"FontAwesome\";\n\tcontent: \"\\f192\";\n\ttop: -5px;\n\tposition: absolute;\n\tleft: 5px;\n\topacity: 1;\n\tfont-size: 22px;\n}\n\n.form-check-radio input[type=\"radio\"]:checked + .form-check-sign::after {\n\topacity: 1;\n}\n\n.form-check-radio input[type=\"radio\"]:disabled + .form-check-sign::before,\n.form-check-radio input[type=\"radio\"]:disabled + .form-check-sign::after {\n\tcolor: #292929 !important;\n}\n\n.progress {\n\tbackground-color: #dddddd;\n\tborder-radius: 3px;\n\tbox-shadow: none;\n\theight: 14px;\n}\n\n.progress-thin {\n\theight: 4px;\n}\n\n.progress-bar {\n\tbackground-color: #1c77c3;\n}\n\n.progress-bar-primary {\n\tbackground-color: #1c77c3;\n}\n\n.progress-bar-info {\n\tbackground-color: #39a9db;\n}\n\n.progress-bar-success {\n\tbackground-color: #28a745;\n}\n\n.progress-bar-warning {\n\tbackground-color: #ffc759;\n}\n\n.progress-bar-danger {\n\tbackground-color: #c1292e;\n}\n\n/*           badges             */\n.badge {\n\tpadding: 4px 8px;\n\ttext-transform: uppercase;\n\tfont-size: 0.7142em;\n\tline-height: 12px;\n\tbackground-color: transparent;\n\tborder: 1px solid;\n\ttext-decoration: none;\n\tcolor: #ffffff;\n\tmargin-bottom: 5px;\n}\n.badge:hover,\n.badge:focus {\n\ttext-decoration: none;\n}\n\n.badge-icon {\n\tpadding: 0.4em 0.55em;\n}\n.badge-icon i {\n\tfont-size: 0.8em;\n}\n\n.badge-default {\n\tborder-color: #65adff;\n\tbackground-color: #65adff;\n}\n\n.badge-primary {\n\tborder-color: #1c77c3;\n\tbackground-color: #1c77c3;\n}\n\n.badge-info {\n\tborder-color: #39a9db;\n\tbackground-color: #39a9db;\n}\n\n.badge-success {\n\tborder-color: #28a745;\n\tbackground-color: #28a745;\n}\n\n.badge-warning {\n\tborder-color: #ffc759;\n\tbackground-color: #ffc759;\n}\n\n.badge-danger {\n\tborder-color: #c1292e;\n\tbackground-color: #c1292e;\n}\n\n.badge-neutral {\n\tborder-color: #ffffff;\n\tbackground-color: #ffffff;\n\tcolor: inherit;\n}\n\n.badge-primary[href]:focus,\n.badge-primary[href]:hover {\n\tcolor: #ffffff;\n\tbackground-color: #1a6fb6;\n\tborder-color: #1a6fb6;\n}\n\n.badge-warning[href]:focus,\n.badge-warning[href]:hover {\n\tcolor: #ffffff;\n\tbackground-color: #ffc24a;\n\tborder-color: #ffc24a;\n}\n\n.badge-info[href]:focus,\n.badge-info[href]:hover {\n\tcolor: #ffffff;\n\tbackground-color: #2ca3d9;\n\tborder-color: #2ca3d9;\n}\n\n.badge-danger[href]:focus,\n.badge-danger[href]:hover {\n\tcolor: #ffffff;\n\tbackground-color: #b4262b;\n\tborder-color: #b4262b;\n}\n\n.badge-success[href]:focus,\n.badge-success[href]:hover {\n\tcolor: #ffffff;\n\tbackground-color: #11683f;\n\tborder-color: #11683f;\n}\n\n.badge-default[href]:focus,\n.badge-default[href]:hover {\n\tcolor: #ffffff;\n\tbackground-color: #9ed9d1;\n\tborder-color: #9ed9d1;\n}\n\n.pagination .page-item .page-link {\n\tborder: 0;\n\tborder-radius: 30px !important;\n\ttransition: all 0.3s;\n\tpadding: 0px 11px;\n\tmargin: 0 3px;\n\tmin-width: 30px;\n\ttext-align: center;\n\theight: 30px;\n\tline-height: 30px;\n\tcolor: #2c2c2c;\n\tcursor: pointer;\n\tfont-size: 14px;\n\ttext-transform: uppercase;\n\tbackground: transparent;\n\toutline: none;\n}\n.pagination .page-item .page-link:hover,\n.pagination .page-item .page-link:focus {\n\tcolor: #2c2c2c;\n\tbackground-color: rgba(222, 222, 222, 0.3);\n\tborder: none;\n}\n.pagination .page-item .page-link:focus,\n.pagination .page-item .page-link:active:focus {\n\tbox-shadow: none;\n}\n.pagination .arrow-margin-left,\n.pagination .arrow-margin-right {\n\tposition: absolute;\n}\n.pagination .arrow-margin-right {\n\tright: 0;\n}\n.pagination .arrow-margin-left {\n\tleft: 0;\n}\n.pagination .page-item.active > .page-link {\n\tcolor: #ffffff;\n\tbox-shadow: 0 2px 2px rgba(204, 197, 185, 0.5);\n}\n.pagination .page-item.active > .page-link,\n.pagination .page-item.active > .page-link:focus,\n.pagination .page-item.active > .page-link:hover {\n\tbackground-color: #1c77c3;\n\tborder-color: #1c77c3;\n\tcolor: #ffffff;\n}\n.pagination .page-item.disabled > .page-link {\n\topacity: 0.5;\n}\n.pagination.pagination-info .page-item.active > .page-link,\n.pagination.pagination-info .page-item.active > .page-link:focus,\n.pagination.pagination-info .page-item.active > .page-link:hover {\n\tbackground-color: #39a9db;\n\tborder-color: #39a9db;\n}\n.pagination.pagination-success .page-item.active > .page-link,\n.pagination.pagination-success .page-item.active > .page-link:focus,\n.pagination.pagination-success .page-item.active > .page-link:hover {\n\tbackground-color: #28a745;\n\tborder-color: #28a745;\n}\n.pagination.pagination-primary .page-item.active > .page-link,\n.pagination.pagination-primary .page-item.active > .page-link:focus,\n.pagination.pagination-primary .page-item.active > .page-link:hover {\n\tbackground-color: #1c77c3;\n\tborder-color: #1c77c3;\n}\n.pagination.pagination-warning .page-item.active > .page-link,\n.pagination.pagination-warning .page-item.active > .page-link:focus,\n.pagination.pagination-warning .page-item.active > .page-link:hover {\n\tbackground-color: #ffc759;\n\tborder-color: #ffc759;\n}\n.pagination.pagination-danger .page-item.active > .page-link,\n.pagination.pagination-danger .page-item.active > .page-link:focus,\n.pagination.pagination-danger .page-item.active > .page-link:hover {\n\tbackground-color: #c1292e;\n\tborder-color: #c1292e;\n}\n.pagination.pagination-neutral .page-item > .page-link {\n\tcolor: #ffffff;\n}\n.pagination.pagination-neutral .page-item > .page-link:focus,\n.pagination.pagination-neutral .page-item > .page-link:hover {\n\tbackground-color: rgba(255, 255, 255, 0.2);\n\tcolor: #ffffff;\n}\n.pagination.pagination-neutral .page-item.active > .page-link,\n.pagination.pagination-neutral .page-item.active > .page-link:focus,\n.pagination.pagination-neutral .page-item.active > .page-link:hover {\n\tbackground-color: #ffffff;\n\tborder-color: #ffffff;\n\tcolor: #1c77c3;\n}\n\n.info.info-hover .info-title {\n\ttransition: color 0.4s;\n}\n.info.info-hover:hover .icon {\n\t-webkit-transform: translate3d(0, -0.5rem, 0) !important;\n\t-moz-transform: translate3d(0, -0.5rem, 0) !important;\n\t-o-transform: translate3d(0, -0.5rem, 0) !important;\n\t-ms-transform: translate3d(0, -0.5rem, 0) !important;\n\ttransform: translate3d(0, -0.5rem, 0) !important;\n}\n.info.info-hover:hover .icon.icon-primary.icon-circle {\n\tbox-shadow: 0px 15px 30px 0px rgba(249, 99, 50, 0.3);\n}\n.info.info-hover:hover .icon.icon-info.icon-circle {\n\tbox-shadow: 0px 15px 35px 0px rgba(44, 168, 255, 0.3);\n}\n.info.info-hover:hover .icon.icon-success.icon-circle {\n\tbox-shadow: 0px 15px 35px 0px rgba(24, 206, 15, 0.3);\n}\n.info.info-hover:hover .icon.icon-warning.icon-circle {\n\tbox-shadow: 0px 15px 35px 0px rgba(255, 178, 54, 0.3);\n}\n.info.info-hover:hover .icon.icon-danger.icon-circle {\n\tbox-shadow: 0px 15px 35px 0px rgba(255, 54, 54, 0.3);\n}\n.info.info-hover:hover .icon.icon-info + .info-title {\n\tcolor: #39a9db;\n}\n.info.info-hover:hover .icon.icon-warning + .info-title {\n\tcolor: #ffc759;\n}\n.info.info-hover:hover .icon.icon-danger + .info-title {\n\tcolor: #c1292e;\n}\n.info.info-hover:hover .icon.icon-primary + .info-title {\n\tcolor: #1c77c3;\n}\n.info.info-hover:hover .icon.icon-success + .info-title {\n\tcolor: #28a745;\n}\n.info .icon {\n\tcolor: #65adff;\n\ttransition: transform 0.4s, box-shadow 0.4s;\n}\n.info .icon > i {\n\tfont-size: 2.3em;\n}\n.info .icon.icon-circle {\n\tmax-width: 70px;\n\twidth: 70px;\n\theight: 70px;\n\tmargin: 0 auto;\n\tborder-radius: 50%;\n\tbox-shadow: 0px 9px 35px -6px rgba(0, 0, 0, 0.3);\n\tfont-size: 0.7142em;\n\tbackground-color: #ffffff;\n\tposition: relative;\n}\n.info .icon.icon-circle i {\n\tline-height: 2.6em;\n}\n.info .info-title {\n\tmargin: 15px 0 5px;\n\tpadding: 0 15px;\n\tcolor: #2c2c2c;\n\tfont-weight: 600;\n}\n.info p {\n\tcolor: #65adff;\n\tpadding: 0 15px;\n\tfont-size: 1.1em;\n}\n\n.info-horizontal {\n\ttext-align: left !important;\n}\n.info-horizontal .icon {\n\tfloat: left;\n\tmargin-top: 23px;\n\tmargin-right: 10px;\n}\n.info-horizontal .icon > i {\n\tfont-size: 2em;\n}\n.info-horizontal .icon.icon-circle {\n\twidth: 65px;\n\theight: 65px;\n\tmax-width: 65px;\n\tmargin-top: 8px;\n}\n.info-horizontal .icon.icon-circle i {\n\tdisplay: table;\n\tmargin: 0 auto;\n\tline-height: 3.5;\n\tfont-size: 1.9em;\n}\n.info-horizontal .description {\n\toverflow: hidden;\n}\n\n.icon.icon-primary {\n\tcolor: #1c77c3;\n}\n.icon.icon-primary.icon-circle {\n\tbox-shadow: 0px 9px 30px -6px rgba(28, 119, 195, 0.5);\n}\n.icon.icon-info {\n\tcolor: #39a9db;\n}\n.icon.icon-info.icon-circle {\n\tbox-shadow: 0px 9px 30px -6px rgba(57, 169, 219, 0.5);\n}\n.icon.icon-success {\n\tcolor: #28a745;\n}\n.icon.icon-success.icon-circle {\n\tbox-shadow: 0px 9px 30px -6px rgba(19, 117, 71, 0.5);\n}\n.icon.icon-warning {\n\tcolor: #ffc759;\n}\n.icon.icon-warning.icon-circle {\n\tbox-shadow: 0px 9px 30px -6px rgba(255, 199, 89, 0.5);\n}\n.icon.icon-danger {\n\tcolor: #c1292e;\n}\n.icon.icon-danger.icon-circle {\n\tbox-shadow: 0px 9px 30px -6px rgba(193, 41, 46, 0.5);\n}\n.icon.icon-white {\n\tcolor: #ffffff;\n}\n\n/*             Navigation Pills               */\n.nav-pills .nav-item + .nav-link {\n\tmargin-left: 0;\n}\n.nav-pills .nav-item .nav-link {\n\tborder: none;\n\tborder-radius: 0;\n\tfont-size: 0.8em;\n\tcolor: #ffffff;\n\tpadding: 5px 10px;\n}\n.nav-pills .nav-item.active .nav-link,\n.nav-pills .nav-item.active .nav-link:hover,\n.nav-pills .nav-item.active .nav-link:focus {\n\tbackground-color: #65adff;\n\tcolor: #ffffff;\n\tfont-weight: 600;\n}\n.nav-pills .nav-item .nav-link.active {\n\tbackground-color: #65adff;\n\tcolor: #ffffff;\n\tfont-weight: 600;\n}\n\n.nav-pills-primary {\n\tpadding-bottom: 0;\n\tmargin-bottom: 0.4rem;\n}\n.nav-pills-primary .nav-item .nav-link {\n\tborder: none;\n\tcolor: gray;\n}\n.nav-pills-primary .nav-item .nav-link.active {\n\tborder: none;\n\tbackground: #004e89;\n\tcolor: #ffffff;\n}\n\n.nav-pills-primary-dark {\n\tpadding-top: 1rem;\n\tpadding-bottom: 1rem;\n\tborder-bottom: 1px solid lightgray;\n}\n.nav-pills-primary-dark .nav-item .nav-link {\n\tborder: none;\n\tcolor: gray;\n}\n.nav-pills-primary-dark .nav-item .nav-link.active {\n\tborder: none;\n\tbackground: #004e89;\n\tcolor: #ffffff;\n}\n\n.nav-pills-secondary {\n\tpadding-top: 1rem;\n\tpadding-bottom: 1rem;\n\tborder-bottom: 1px solid lightgray;\n}\n.nav-pills-secondary .nav-item .nav-link {\n\tborder: none;\n\tcolor: gray;\n}\n.nav-pills-secondary .nav-item .nav-link.active {\n\tborder: none;\n\tbackground: #1f84d6;\n\tcolor: #ffffff;\n}\n\n.nav-pills-danger .nav-item .nav-link {\n\tborder: 1px solid #c1292e;\n\tcolor: #c1292e;\n}\n.nav-pills-danger .nav-item .nav-link.active {\n\tborder: 1px solid #c1292e;\n\tbackground: #c1292e;\n\tcolor: #ffffff;\n}\n\n.nav-pills-info .nav-item .nav-link {\n\tborder: 1px solid #39a9db;\n\tcolor: #39a9db;\n}\n.nav-pills-info .nav-item .nav-link.active {\n\tborder: 1px solid #39a9db;\n\tbackground: #39a9db;\n\tcolor: #ffffff;\n}\n\n.nav-pills-success .nav-item .nav-link {\n\tborder: 1px solid #28a745;\n\tcolor: #28a745;\n}\n.nav-pills-success .nav-item .nav-link.active {\n\tborder: 1px solid #28a745;\n\tbackground: #28a745;\n\tcolor: #ffffff;\n}\n\n.nav-pills-warning .nav-item .nav-link {\n\tborder: 1px solid #ffc759;\n\tcolor: #ffc759;\n}\n.nav-pills-warning .nav-item .nav-link.active {\n\tborder: 1px solid #ffc759;\n\tbackground: #ffc759;\n\tcolor: #ffffff;\n}\n\n.page-item:first-child .page-link,\n.page-item:last-child .page-link {\n\tborder-bottom-left-radius: 20px;\n\tborder-top-left-radius: 20px;\n\tborder-bottom-right-radius: 20px;\n\tborder-top-right-radius: 20px;\n}\n\n.nav-pills-default .nav-item.show .nav-link,\n.nav-pills-default .nav-link.active {\n\tbackground-color: #65adff !important;\n}\n\n.nav-pills-primary .nav-item.show .nav-link,\n.nav-pills-primary .nav-link.active {\n\tbackground-color: #1c77c3 !important;\n}\n\n.nav-pills-primary-dark .nav-item.show .nav-link,\n.nav-pills-primary-dark .nav-link.active {\n\tbackground-color: #004e89 !important;\n}\n\n.nav-pills-secondary .nav-item.show .nav-link,\n.nav-pills-secondary .nav-link.active {\n\tbackground-color: #1f84d6 !important;\n}\n\n.nav-pills-info .nav-item.show .nav-link,\n.nav-pills-info .nav-link.active {\n\tbackground-color: #39a9db !important;\n}\n\n.nav-pills-warning .nav-item.show .nav-link,\n.nav-pills-warning .nav-link.active {\n\tbackground-color: #ffc759 !important;\n}\n\n.nav-pills-success .nav-item.show .nav-link,\n.nav-pills-success .nav-link.active {\n\tbackground-color: #28a745 !important;\n}\n\n.nav-pills-danger .nav-item.show .nav-link,\n.nav-pills-danger .nav-link.active {\n\tbackground-color: #c1292e !important;\n}\n\n/*             Navigation Tabs                 */\n.nav-tabs-navigation {\n\ttext-align: center;\n\tborder-bottom: 1px solid #f1eae0;\n\tmargin-bottom: 30px;\n}\n.nav-tabs-navigation .nav > .nav-item > .nav-link {\n\tpadding-bottom: 20px;\n}\n\n.nav-tabs-wrapper {\n\tdisplay: inline-block;\n\tmargin-bottom: -6px;\n\tmargin-left: 1.25%;\n\tmargin-right: 1.25%;\n\tposition: relative;\n\twidth: auto;\n}\n\n.nav-tabs {\n\tborder-bottom: 0 none;\n\tfont-size: 14px;\n\tfont-weight: 400;\n}\n.nav-tabs .nav-item .nav-link {\n\tborder: 0 none;\n\tcolor: #a49e93;\n\tbackground-color: transparent;\n}\n.nav-tabs .nav-item .nav-link:hover {\n\tcolor: #292929 !important;\n}\n.nav-tabs .nav-item .nav-link.active {\n\tcolor: #292929 !important;\n}\n.nav-tabs .nav-item {\n\tcolor: #292929 !important;\n\tposition: relative;\n}\n.nav-tabs .nav-item .nav-link.active,\n.nav-tabs .nav-item .nav-link.active:hover,\n.nav-tabs .nav-item .nav-link.active:focus {\n\tbackground-color: transparent;\n\tborder: 0 none;\n}\n.nav-tabs .nav-item .nav-link.active:after,\n.nav-tabs .nav-item .nav-link.active:hover:after,\n.nav-tabs .nav-item .nav-link.active:focus:after {\n\tborder-bottom: 11px solid #ffffff;\n\tborder-left: 11px solid rgba(0, 0, 0, 0);\n\tborder-right: 11px solid rgba(0, 0, 0, 0);\n\tcontent: \"\";\n\tdisplay: inline-block;\n\tposition: absolute;\n\tright: 40%;\n\tbottom: 5px;\n}\n.nav-tabs .nav-item .nav-link.active:before,\n.nav-tabs .nav-item .nav-link.active:hover:before,\n.nav-tabs .nav-item .nav-link.active:focus:before {\n\tborder-bottom: 11px solid #f1eae0;\n\tborder-left: 11px solid rgba(0, 0, 0, 0);\n\tborder-right: 11px solid rgba(0, 0, 0, 0);\n\tcontent: \"\";\n\tdisplay: inline-block;\n\tposition: absolute;\n\tright: 40%;\n\tbottom: 6px;\n}\n.nav-tabs .nav-item.show .nav-link {\n\tbackground-color: transparent;\n}\n.nav-tabs .dropdown-menu {\n\tmargin-top: -6px;\n\tmargin-left: -46px;\n\tborder-radius: 8px;\n}\n.nav-tabs .dropdown-menu .dropdown-item:hover,\n.nav-tabs .dropdown-menu .dropdown-item.active {\n\tcolor: #ffffff;\n\tbackground-color: #68b3c8;\n}\n.nav-tabs .dropdown-menu :before {\n\tborder-bottom: 11px solid #f1eae0;\n\tborder-left: 11px solid rgba(0, 0, 0, 0);\n\tborder-right: 11px solid rgba(0, 0, 0, 0);\n\tcontent: \"\";\n\tdisplay: inline-block;\n\tposition: absolute;\n\tright: 12px;\n\ttop: -11px;\n}\n.nav-tabs .dropdown-menu :after {\n\tborder-bottom: 11px solid #fffcf5;\n\tborder-left: 11px solid rgba(0, 0, 0, 0);\n\tborder-right: 11px solid rgba(0, 0, 0, 0);\n\tcontent: \"\";\n\tdisplay: inline-block;\n\tposition: absolute;\n\tright: 12px;\n\ttop: -10px;\n}\n\n.profile-content .tab-content .tab-pane {\n\tmin-height: 200px;\n}\n.profile-content .tab-content #tweets,\n.profile-content .tab-content #connections,\n.profile-content .tab-content #media {\n\theight: 100%;\n}\n\n.nav-text,\n.nav-icons {\n\tmargin: 0 0 10px 0;\n}\n.nav-text > li > a,\n.nav-icons > li > a {\n\tdisplay: block;\n\tpadding: 0px 0.7rem;\n\tcolor: #292929 !important;\n\ttext-align: center;\n\topacity: 0.8;\n\tfilter: alpha(opacity=80);\n}\n.nav-text > li > a:hover,\n.nav-text > li > a:focus,\n.nav-icons > li > a:hover,\n.nav-icons > li > a:focus {\n\tbackground-color: transparent;\n\topacity: 1;\n\tfilter: alpha(opacity=100);\n}\n.nav-text > li:first-child a,\n.nav-icons > li:first-child a {\n\tpadding-left: 0;\n}\n.nav-text > li.active a,\n.nav-icons > li.active a {\n\tcolor: #39a9db;\n}\n\n.nav-icons > li {\n\tdisplay: inline-block;\n}\n.nav-icons > li > a {\n\tpadding: 0 10px;\n\tmargin-bottom: 10px;\n}\n.nav-icons > li > a i {\n\tfont-size: 1.714em;\n\tmargin-bottom: 10px;\n\twidth: 1.714em;\n}\n\n.nav-icons.nav-stacked > li {\n\tdisplay: block;\n}\n.nav-icons.nav-stacked > li > a {\n\tmargin-bottom: 20px;\n}\n\n.nav-blue > li.active a {\n\tcolor: #1c77c3;\n}\n\n.nav-azure > li.active a {\n\tcolor: #39a9db;\n}\n\n.nav-green > li.active a {\n\tcolor: #28a745;\n}\n\n.nav-orange > li.active a {\n\tcolor: #ffc759;\n}\n\n.nav-red > li.active a {\n\tcolor: #c1292e;\n}\n\n.nav-text {\n\tmargin: 0 0 10px 0;\n}\n.nav-text > li > a {\n\tfont-size: 1em;\n\ttext-transform: uppercase;\n\tpadding: 3px 0;\n\ttext-align: left;\n\tfont-weight: 600;\n}\n.nav-text > li:first-child > a {\n\tpadding-top: 0;\n}\n.nav-text h4 {\n\tmargin-top: 0;\n}\n\n.nav-text:not(.nav-stacked) > li {\n\tdisplay: inline-block;\n}\n.nav-text:not(.nav-stacked) > li > a {\n\tmargin-right: 15px;\n}\n\n.verical-navs .nav-stacked .nav-link.active:before,\n.verical-navs .nav-stacked .nav-link.active:hover:before,\n.verical-navs .nav-stacked .nav-link.active.show:before {\n\tborder-right: 11px solid #f1eae0;\n\tborder-top: 11px solid transparent;\n\tborder-bottom: 11px solid transparent;\n\tcontent: \"\";\n\tdisplay: inline-block;\n\tposition: absolute;\n\tright: 0;\n\tbottom: 20px;\n}\n\n.verical-navs .nav-stacked .nav-link.active:after,\n.verical-navs .nav-stacked .nav-link.active:hover:after,\n.verical-navs .nav-stacked .nav-link.active.show:after {\n\tborder-right: 11px solid #ffffff;\n\tborder-top: 11px solid transparent;\n\tborder-bottom: 11px solid transparent;\n\tcontent: \"\";\n\tdisplay: inline-block;\n\tposition: absolute;\n\tright: -1px;\n\tbottom: 20px;\n}\n\n#second-tabs {\n\tmargin-left: 20px;\n}\n\n.nav-tabs-navigation.verical-navs {\n\tborder-right: 1px solid #f1eae0;\n\tfont-size: 16px;\n\tpadding: 0 37px;\n\tborder-bottom: none;\n}\n\n.popover {\n\tfont-size: 14px;\n\tbox-shadow: 0px 10px 50px 0px rgba(0, 0, 0, 0.2);\n\tborder: none;\n\tline-height: 1.7;\n\tmax-width: 240px;\n}\n.popover.bs-popover-top .arrow:before,\n.popover.bs-popover-left .arrow:before,\n.popover.bs-popover-right .arrow:before,\n.popover.bs-popover-bottom .arrow:before {\n\tborder-top-color: transparent;\n\tborder-left-color: transparent;\n\tborder-right-color: transparent;\n\tborder-bottom-color: transparent;\n}\n.popover .popover-header {\n\tcolor: rgba(182, 182, 182, 0.6);\n\tfont-size: 14px;\n\ttext-transform: capitalize;\n\tfont-weight: 600;\n\tmargin: 0;\n\tmargin-top: 5px;\n\tborder: none;\n\tbackground-color: transparent;\n}\n.popover:before {\n\tdisplay: none;\n}\n.popover.bs-tether-element-attached-top:after {\n\tborder-bottom-color: #ffffff;\n\ttop: -9px;\n}\n.popover.popover-primary {\n\tbackground-color: #1c77c3;\n}\n.popover.popover-primary .popover-body {\n\tcolor: #ffffff;\n}\n.popover.popover-primary.bs-popover-right .arrow:after {\n\tborder-right-color: #1c77c3;\n}\n.popover.popover-primary.bs-popover-top .arrow:after {\n\tborder-top-color: #1c77c3;\n}\n.popover.popover-primary.bs-popover-bottom .arrow:after {\n\tborder-bottom-color: #1c77c3;\n}\n.popover.popover-primary.bs-popover-left .arrow:after {\n\tborder-left-color: #1c77c3;\n}\n.popover.popover-primary .popover-header {\n\tcolor: #ffffff;\n\topacity: 0.6;\n}\n.popover.popover-info {\n\tbackground-color: #39a9db;\n}\n.popover.popover-info .popover-body {\n\tcolor: #ffffff;\n}\n.popover.popover-info.bs-popover-right .arrow:after {\n\tborder-right-color: #39a9db;\n}\n.popover.popover-info.bs-popover-top .arrow:after {\n\tborder-top-color: #39a9db;\n}\n.popover.popover-info.bs-popover-bottom .arrow:after {\n\tborder-bottom-color: #39a9db;\n}\n.popover.popover-info.bs-popover-left .arrow:after {\n\tborder-left-color: #39a9db;\n}\n.popover.popover-info .popover-header {\n\tcolor: #ffffff;\n\topacity: 0.6;\n}\n.popover.popover-warning {\n\tbackground-color: #ffc759;\n}\n.popover.popover-warning .popover-body {\n\tcolor: #ffffff;\n}\n.popover.popover-warning.bs-popover-right .arrow:after {\n\tborder-right-color: #ffc759;\n}\n.popover.popover-warning.bs-popover-top .arrow:after {\n\tborder-top-color: #ffc759;\n}\n.popover.popover-warning.bs-popover-bottom .arrow:after {\n\tborder-bottom-color: #ffc759;\n}\n.popover.popover-warning.bs-popover-left .arrow:after {\n\tborder-left-color: #ffc759;\n}\n.popover.popover-warning .popover-header {\n\tcolor: #ffffff;\n\topacity: 0.6;\n}\n.popover.popover-danger {\n\tbackground-color: #c1292e;\n}\n.popover.popover-danger .popover-body {\n\tcolor: #ffffff;\n}\n.popover.popover-danger.bs-popover-right .arrow:after {\n\tborder-right-color: #c1292e;\n}\n.popover.popover-danger.bs-popover-top .arrow:after {\n\tborder-top-color: #c1292e;\n}\n.popover.popover-danger.bs-popover-bottom .arrow:after {\n\tborder-bottom-color: #c1292e;\n}\n.popover.popover-danger.bs-popover-left .arrow:after {\n\tborder-left-color: #c1292e;\n}\n.popover.popover-danger .popover-header {\n\tcolor: #ffffff;\n\topacity: 0.6;\n}\n.popover.popover-success {\n\tbackground-color: #28a745;\n}\n.popover.popover-success .popover-body {\n\tcolor: #ffffff;\n}\n.popover.popover-success.bs-popover-right .arrow:after {\n\tborder-right-color: #28a745;\n}\n.popover.popover-success.bs-popover-top .arrow:after {\n\tborder-top-color: #28a745;\n}\n.popover.popover-success.bs-popover-bottom .arrow:after {\n\tborder-bottom-color: #28a745;\n}\n.popover.popover-success.bs-popover-left .arrow:after {\n\tborder-left-color: #28a745;\n}\n.popover.popover-success .popover-header {\n\tcolor: #ffffff;\n\topacity: 0.6;\n}\n\n.tooltip.bs-tooltip-right .arrow:before {\n\tborder-right-color: #ffffff;\n}\n.tooltip.bs-tooltip-top .arrow:before {\n\tborder-top-color: #ffffff;\n}\n.tooltip.bs-tooltip-bottom .arrow:before {\n\tborder-bottom-color: #ffffff;\n}\n.tooltip.bs-tooltip-left .arrow:before {\n\tborder-left-color: #ffffff;\n}\n\n.tooltip-inner {\n\tpadding: 0.5rem 0.7rem;\n\tmin-width: 130px;\n\tbackground-color: #ffffff;\n\tfont-size: 14px;\n\tcolor: inherit;\n\tbox-shadow: 0px 5px 25px 0px rgba(0, 0, 0, 0.2);\n}\n\n.modal-header {\n\tborder-bottom: 1px solid #dddddd;\n\tpadding: 10px;\n\ttext-align: center;\n\tdisplay: block !important;\n}\n.modal-header.no-border-header {\n\tborder-bottom: 0 none !important;\n}\n.modal-header.no-border-header .modal-title {\n\tmargin-top: 20px;\n}\n.modal-header button.close:focus {\n\toutline: none;\n}\n.modal-header .modal-profile {\n\twidth: 70px;\n\theight: 70px;\n\tborder-radius: 50%;\n\ttext-align: center;\n\tline-height: 6.4;\n\tborder: 1px solid rgba(0, 0, 0, 0.3);\n}\n.modal-header .modal-profile i {\n\tfont-size: 30px;\n}\n\n.modal-dialog.modal-sm .modal-header button.close,\n.modal-dialog.modal-register .modal-header button.close {\n\tmargin-top: 0;\n}\n\n.modal-content {\n\tborder: 0 none;\n\tborder-radius: 10px;\n\tbox-shadow: 0 0 15px rgba(0, 0, 0, 0.15), 0 0 1px 1px rgba(0, 0, 0, 0.1);\n}\n.modal-content .modal-header h6 {\n\tmargin-top: 10px;\n}\n\n.modal-dialog {\n\tpadding-top: 60px;\n}\n\n.modal-footer {\n\tborder-top: 1px solid #dddddd;\n\tpadding: 0px;\n}\n.modal-footer.no-border-footer {\n\tborder-top: 0 none;\n}\n\n.modal-footer .left-side,\n.modal-footer .right-side {\n\tdisplay: inline-block;\n\ttext-align: center;\n\twidth: 50%;\n\tpadding: 5px;\n}\n\n.modal-footer .btn-link {\n\tpadding: 20px;\n\twidth: 100%;\n\tmargin: 0;\n}\n\n.modal-footer .divider {\n\tbackground-color: #dddddd;\n\tdisplay: inline-block;\n\theight: 63px;\n\tmargin: 0px -3px;\n\twidth: 1px;\n}\n\n.modal-register .modal-footer {\n\ttext-align: center;\n\tmargin-bottom: 25px;\n\tpadding: 20px 0 15px;\n}\n.modal-register .modal-footer span {\n\twidth: 100%;\n}\n\n.carousel-item-next,\n.carousel-item-prev,\n.carousel-item.active {\n\tdisplay: block;\n}\n\n.carousel .carousel-inner {\n\tbox-shadow: 0px 10px 25px 0px rgba(0, 0, 0, 0.3);\n}\n.carousel .nc-icon {\n\tfont-size: 2em;\n}\n\n.wrapper {\n\tposition: relative;\n\ttop: 0;\n\theight: 100vh;\n}\n.wrapper.wrapper-full-page {\n\tmin-height: 100vh;\n\theight: auto;\n}\n\n.sidebar,\n.off-canvas-sidebar {\n\tposition: fixed;\n\ttop: 0;\n\theight: 100%;\n\tbottom: 0;\n\twidth: 260px;\n\tleft: 0;\n\tz-index: 999;\n}\n.sidebar .sidebar-wrapper,\n.off-canvas-sidebar .sidebar-wrapper {\n\tposition: relative;\n\theight: calc(100vh - 75px);\n\toverflow: auto;\n\twidth: 260px;\n\tz-index: 4;\n\tpadding-bottom: 100px;\n}\n.sidebar .sidebar-wrapper .dropdown .dropdown-backdrop,\n.off-canvas-sidebar .sidebar-wrapper .dropdown .dropdown-backdrop {\n\tdisplay: none !important;\n}\n.sidebar .sidebar-wrapper .navbar-form,\n.off-canvas-sidebar .sidebar-wrapper .navbar-form {\n\tborder: none;\n}\n.sidebar\n\t.sidebar-wrapper\n\t> .nav\n\t[data-toggle=\"collapse\"]\n\t~ div\n\t> ul\n\t> li\n\t> a\n\tspan,\n.sidebar\n\t.sidebar-wrapper\n\t.user\n\t.info\n\t[data-toggle=\"collapse\"]\n\t~ div\n\t> ul\n\t> li\n\t> a\n\tspan,\n.off-canvas-sidebar\n\t.sidebar-wrapper\n\t> .nav\n\t[data-toggle=\"collapse\"]\n\t~ div\n\t> ul\n\t> li\n\t> a\n\tspan,\n.off-canvas-sidebar\n\t.sidebar-wrapper\n\t.user\n\t.info\n\t[data-toggle=\"collapse\"]\n\t~ div\n\t> ul\n\t> li\n\t> a\n\tspan {\n\tdisplay: inline-block;\n}\n.sidebar\n\t.sidebar-wrapper\n\t> .nav\n\t[data-toggle=\"collapse\"]\n\t~ div\n\t> ul\n\t> li\n\t> a\n\t.sidebar-normal,\n.sidebar\n\t.sidebar-wrapper\n\t.user\n\t.info\n\t[data-toggle=\"collapse\"]\n\t~ div\n\t> ul\n\t> li\n\t> a\n\t.sidebar-normal,\n.off-canvas-sidebar\n\t.sidebar-wrapper\n\t> .nav\n\t[data-toggle=\"collapse\"]\n\t~ div\n\t> ul\n\t> li\n\t> a\n\t.sidebar-normal,\n.off-canvas-sidebar\n\t.sidebar-wrapper\n\t.user\n\t.info\n\t[data-toggle=\"collapse\"]\n\t~ div\n\t> ul\n\t> li\n\t> a\n\t.sidebar-normal {\n\tmargin: 0;\n\tposition: relative;\n\ttransform: translateX(0px);\n\topacity: 1;\n\twhite-space: nowrap;\n\tdisplay: block;\n\tline-height: 30px;\n\tz-index: 1;\n}\n.sidebar\n\t.sidebar-wrapper\n\t> .nav\n\t[data-toggle=\"collapse\"]\n\t~ div\n\t> ul\n\t> li\n\t> a\n\t.sidebar-mini-icon,\n.sidebar\n\t.sidebar-wrapper\n\t.user\n\t.info\n\t[data-toggle=\"collapse\"]\n\t~ div\n\t> ul\n\t> li\n\t> a\n\t.sidebar-mini-icon,\n.off-canvas-sidebar\n\t.sidebar-wrapper\n\t> .nav\n\t[data-toggle=\"collapse\"]\n\t~ div\n\t> ul\n\t> li\n\t> a\n\t.sidebar-mini-icon,\n.off-canvas-sidebar\n\t.sidebar-wrapper\n\t.user\n\t.info\n\t[data-toggle=\"collapse\"]\n\t~ div\n\t> ul\n\t> li\n\t> a\n\t.sidebar-mini-icon {\n\ttext-transform: uppercase;\n\twidth: 34px;\n\tmargin-right: 10px;\n\tmargin-left: 0px;\n\tfont-size: 12px;\n\ttext-align: center;\n\tline-height: 30px;\n\tposition: relative;\n\tfloat: left;\n\tz-index: 1;\n\tdisplay: inherit;\n}\n.sidebar\n\t.sidebar-wrapper\n\t> .nav\n\t[data-toggle=\"collapse\"]\n\t~ div\n\t> ul\n\t> li\n\t> a\n\t.sidebar-normal,\n.sidebar\n\t.sidebar-wrapper\n\t.user\n\t.info\n\t[data-toggle=\"collapse\"]\n\t~ div\n\t> ul\n\t> li\n\t> a\n\t.sidebar-normal,\n.off-canvas-sidebar\n\t.sidebar-wrapper\n\t> .nav\n\t[data-toggle=\"collapse\"]\n\t~ div\n\t> ul\n\t> li\n\t> a\n\t.sidebar-normal,\n.off-canvas-sidebar\n\t.sidebar-wrapper\n\t.user\n\t.info\n\t[data-toggle=\"collapse\"]\n\t~ div\n\t> ul\n\t> li\n\t> a\n\t.sidebar-normal {\n\ttext-transform: capitalize;\n}\n.sidebar .sidebar-wrapper > .nav [data-toggle=\"collapse\"] ~ div > ul > li > a i,\n.sidebar\n\t.sidebar-wrapper\n\t.user\n\t.info\n\t[data-toggle=\"collapse\"]\n\t~ div\n\t> ul\n\t> li\n\t> a\n\ti,\n.off-canvas-sidebar\n\t.sidebar-wrapper\n\t> .nav\n\t[data-toggle=\"collapse\"]\n\t~ div\n\t> ul\n\t> li\n\t> a\n\ti,\n.off-canvas-sidebar\n\t.sidebar-wrapper\n\t.user\n\t.info\n\t[data-toggle=\"collapse\"]\n\t~ div\n\t> ul\n\t> li\n\t> a\n\ti {\n\tfont-size: 17px;\n\tline-height: 30px;\n\twidth: 26px;\n}\n.sidebar .navbar-minimize,\n.off-canvas-sidebar .navbar-minimize {\n\tposition: absolute;\n\tright: 20px;\n\ttop: 2px;\n\topacity: 1;\n}\n.sidebar .nav,\n.off-canvas-sidebar .nav {\n\tmargin-top: 20px;\n\tdisplay: block;\n}\n.sidebar .nav .caret,\n.off-canvas-sidebar .nav .caret {\n\ttop: 14px;\n\tposition: absolute;\n\tright: 10px;\n}\n.sidebar .nav li > a + div .nav li > a,\n.off-canvas-sidebar .nav li > a + div .nav li > a {\n\tmargin-top: 7px;\n}\n.sidebar .nav li > a,\n.off-canvas-sidebar .nav li > a {\n\tmargin: 10px 15px 0;\n\tcolor: #ffffff;\n\tdisplay: block;\n\ttext-decoration: none;\n\tposition: relative;\n\ttext-transform: uppercase;\n\tcursor: pointer;\n\tfont-size: 12px;\n\tpadding: 10px 8px;\n\tline-height: 30px;\n\topacity: 0.9;\n}\n.sidebar .nav li .nav > li > a,\n.off-canvas-sidebar .nav li .nav > li > a {\n\tpadding: 5px 8px;\n}\n.sidebar .nav li.active > a,\n.sidebar .nav li.active > a > i,\n.off-canvas-sidebar .nav li.active > a,\n.off-canvas-sidebar .nav li.active > a > i {\n\topacity: 1;\n\tcolor: #f7f7f7 !important;\n}\n.sidebar .nav li:hover:not(.active) > a,\n.sidebar .nav li:focus:not(.active) > a,\n.off-canvas-sidebar .nav li:hover:not(.active) > a,\n.off-canvas-sidebar .nav li:focus:not(.active) > a {\n\topacity: 1;\n}\n.sidebar .nav li.active > a[data-toggle=\"collapse\"] >,\n.off-canvas-sidebar .nav li.active > a[data-toggle=\"collapse\"] > {\n\tbox-shadow: 0 2px 2px rgba(204, 197, 185, 0.5);\n}\n.sidebar .nav li.active > a[data-toggle=\"collapse\"],\n.sidebar .nav li.active > a[data-toggle=\"collapse\"] i,\n.sidebar .nav li.active > a[data-toggle=\"collapse\"] ~ div > ul > li.active i,\n.sidebar .nav li.active > a[data-toggle=\"collapse\"] ~ div > ul > li.active > a,\n.off-canvas-sidebar .nav li.active > a[data-toggle=\"collapse\"],\n.off-canvas-sidebar .nav li.active > a[data-toggle=\"collapse\"] i,\n.off-canvas-sidebar\n\t.nav\n\tli.active\n\t> a[data-toggle=\"collapse\"]\n\t~ div\n\t> ul\n\t> li.active\n\ti,\n.off-canvas-sidebar\n\t.nav\n\tli.active\n\t> a[data-toggle=\"collapse\"]\n\t~ div\n\t> ul\n\t> li.active\n\t> a {\n\tcolor: #f7f7f7 !important;\n}\n.sidebar .nav li.active > a[data-toggle=\"collapse\"] + div .nav .active a,\n.sidebar .nav li.active > a[data-toggle=\"collapse\"] i + div .nav .active a,\n.sidebar\n\t.nav\n\tli.active\n\t> a[data-toggle=\"collapse\"]\n\t~ div\n\t> ul\n\t> li.active\n\ti\n\t+ div\n\t.nav\n\t.active\n\ta,\n.sidebar\n\t.nav\n\tli.active\n\t> a[data-toggle=\"collapse\"]\n\t~ div\n\t> ul\n\t> li.active\n\t> a\n\t+ div\n\t.nav\n\t.active\n\ta,\n.off-canvas-sidebar\n\t.nav\n\tli.active\n\t> a[data-toggle=\"collapse\"]\n\t+ div\n\t.nav\n\t.active\n\ta,\n.off-canvas-sidebar\n\t.nav\n\tli.active\n\t> a[data-toggle=\"collapse\"]\n\ti\n\t+ div\n\t.nav\n\t.active\n\ta,\n.off-canvas-sidebar\n\t.nav\n\tli.active\n\t> a[data-toggle=\"collapse\"]\n\t~ div\n\t> ul\n\t> li.active\n\ti\n\t+ div\n\t.nav\n\t.active\n\ta,\n.off-canvas-sidebar\n\t.nav\n\tli.active\n\t> a[data-toggle=\"collapse\"]\n\t~ div\n\t> ul\n\t> li.active\n\t> a\n\t+ div\n\t.nav\n\t.active\n\ta {\n\tbackground-color: transparent;\n\tbox-shadow: none;\n}\n.sidebar .nav li.active > a[data-toggle=\"collapse\"] + div .nav .active a:after,\n.sidebar\n\t.nav\n\tli.active\n\t> a[data-toggle=\"collapse\"]\n\ti\n\t+ div\n\t.nav\n\t.active\n\ta:after,\n.sidebar\n\t.nav\n\tli.active\n\t> a[data-toggle=\"collapse\"]\n\t~ div\n\t> ul\n\t> li.active\n\ti\n\t+ div\n\t.nav\n\t.active\n\ta:after,\n.sidebar\n\t.nav\n\tli.active\n\t> a[data-toggle=\"collapse\"]\n\t~ div\n\t> ul\n\t> li.active\n\t> a\n\t+ div\n\t.nav\n\t.active\n\ta:after,\n.off-canvas-sidebar\n\t.nav\n\tli.active\n\t> a[data-toggle=\"collapse\"]\n\t+ div\n\t.nav\n\t.active\n\ta:after,\n.off-canvas-sidebar\n\t.nav\n\tli.active\n\t> a[data-toggle=\"collapse\"]\n\ti\n\t+ div\n\t.nav\n\t.active\n\ta:after,\n.off-canvas-sidebar\n\t.nav\n\tli.active\n\t> a[data-toggle=\"collapse\"]\n\t~ div\n\t> ul\n\t> li.active\n\ti\n\t+ div\n\t.nav\n\t.active\n\ta:after,\n.off-canvas-sidebar\n\t.nav\n\tli.active\n\t> a[data-toggle=\"collapse\"]\n\t~ div\n\t> ul\n\t> li.active\n\t> a\n\t+ div\n\t.nav\n\t.active\n\ta:after {\n\tcontent: \"\";\n\tposition: absolute;\n\twidth: calc(100% - 5px);\n\tz-index: 0;\n}\n.sidebar .nav li.active > a[data-toggle=\"collapse\"] ~ div > .nav,\n.off-canvas-sidebar .nav li.active > a[data-toggle=\"collapse\"] ~ div > .nav {\n\tmargin-top: 0;\n}\n.sidebar .nav p,\n.off-canvas-sidebar .nav p {\n\tmargin: 0;\n\tline-height: 30px;\n\tposition: relative;\n\tdisplay: block;\n\theight: auto;\n\twhite-space: nowrap;\n\tfont-weight: 600;\n}\n.sidebar .nav i,\n.off-canvas-sidebar .nav i {\n\tfont-size: 24px;\n\tfloat: left;\n\tmargin-right: 12px;\n\tline-height: 30px;\n\twidth: 34px;\n\ttext-align: center;\n\tcolor: rgba(255, 255, 255, 0.5);\n\tposition: relative;\n}\n.sidebar .nav .collapse .nav,\n.sidebar .nav .collapsing .nav,\n.off-canvas-sidebar .nav .collapse .nav,\n.off-canvas-sidebar .nav .collapsing .nav {\n\tmargin-top: 0;\n\tbackground-color: #1c77c3;\n\tpadding-top: 0.3rem;\n\tpadding-bottom: 0.5rem;\n}\n.sidebar .sidebar-background,\n.off-canvas-sidebar .sidebar-background {\n\tposition: absolute;\n\tz-index: 1;\n\theight: 100%;\n\twidth: 100%;\n\tdisplay: block;\n\ttop: 0;\n\tleft: 0;\n\tbackground-size: cover;\n\tbackground-position: center center;\n}\n.sidebar .sidebar-background:after,\n.off-canvas-sidebar .sidebar-background:after {\n\tposition: absolute;\n\tz-index: 3;\n\twidth: 100%;\n\theight: 100%;\n\tcontent: \"\";\n\tdisplay: block;\n\tbackground: #ffffff;\n\topacity: 1;\n}\n.sidebar .logo,\n.off-canvas-sidebar .logo {\n\tposition: relative;\n\tpadding: 7px 0.7rem;\n\tz-index: 4;\n\tmax-width: 100% !important;\n}\n.sidebar .logo a.logo-mini,\n.off-canvas-sidebar .logo a.logo-mini {\n\topacity: 0;\n\tfloat: left;\n\twidth: 34px;\n\ttext-align: center;\n\tmargin-left: 10px;\n\tmargin-right: 12px;\n}\n.sidebar .logo a.logo-normal,\n.off-canvas-sidebar .logo a.logo-normal {\n\tdisplay: block;\n\topacity: 1;\n\tpadding: 5px 10px 5px 0px;\n\t-webkit-transform: translate3d(0px, 0, 0);\n\t-moz-transform: translate3d(0px, 0, 0);\n\t-o-transform: translate3d(0px, 0, 0);\n\t-ms-transform: translate3d(0px, 0, 0);\n\ttransform: translate3d(0px, 0, 0);\n}\n.sidebar .logo:after,\n.off-canvas-sidebar .logo:after {\n\tcontent: \"\";\n\tposition: absolute;\n\tbottom: 0;\n\tright: 15px;\n\theight: 1px;\n\twidth: calc(100% - 30px);\n\tbackground-color: rgba(255, 255, 255, 0.5);\n}\n.sidebar .logo p,\n.off-canvas-sidebar .logo p {\n\tfloat: left;\n\tfont-size: 20px;\n\tmargin: 10px 10px;\n\tcolor: #ffffff;\n\tline-height: 30px;\n\tfont-family: \"Muli\", \"Helvetica\", Arial, sans-serif;\n}\n.sidebar .logo .simple-text,\n.off-canvas-sidebar .logo .simple-text {\n\ttext-transform: uppercase;\n\tpadding: 0.5rem 0;\n\tdisplay: block;\n\twhite-space: nowrap;\n\tfont-size: 1rem;\n\tcolor: #ffffff;\n\ttext-decoration: none;\n\tfont-weight: 400;\n\tline-height: 30px;\n\toverflow: hidden;\n}\n.sidebar[data-color=\"white\"]:after,\n.off-canvas-sidebar[data-color=\"white\"]:after {\n\tbackground: #ffffff;\n}\n.sidebar[data-color=\"white\"] .nav li a,\n.sidebar[data-color=\"white\"] .nav li a i,\n.sidebar[data-color=\"white\"] .nav li a[data-toggle=\"collapse\"],\n.sidebar[data-color=\"white\"] .nav li a[data-toggle=\"collapse\"] i,\n.sidebar[data-color=\"white\"]\n\t.nav\n\tli\n\ta[data-toggle=\"collapse\"]\n\t~ div\n\t> ul\n\t> li\n\t.sidebar-mini-icon,\n.sidebar[data-color=\"white\"]\n\t.nav\n\tli\n\ta[data-toggle=\"collapse\"]\n\t~ div\n\t> ul\n\t> li\n\t> a,\n.off-canvas-sidebar[data-color=\"white\"] .nav li a,\n.off-canvas-sidebar[data-color=\"white\"] .nav li a i,\n.off-canvas-sidebar[data-color=\"white\"] .nav li a[data-toggle=\"collapse\"],\n.off-canvas-sidebar[data-color=\"white\"] .nav li a[data-toggle=\"collapse\"] i,\n.off-canvas-sidebar[data-color=\"white\"]\n\t.nav\n\tli\n\ta[data-toggle=\"collapse\"]\n\t~ div\n\t> ul\n\t> li\n\t.sidebar-mini-icon,\n.off-canvas-sidebar[data-color=\"white\"]\n\t.nav\n\tli\n\ta[data-toggle=\"collapse\"]\n\t~ div\n\t> ul\n\t> li\n\t> a {\n\tcolor: #65adff;\n\topacity: 0.7;\n}\n.sidebar[data-color=\"white\"] .nav li:hover:not(.active) > a,\n.sidebar[data-color=\"white\"] .nav li:focus:not(.active) > a,\n.off-canvas-sidebar[data-color=\"white\"] .nav li:hover:not(.active) > a,\n.off-canvas-sidebar[data-color=\"white\"] .nav li:focus:not(.active) > a {\n\topacity: 1;\n}\n.sidebar[data-color=\"white\"] .logo .simple-text,\n.off-canvas-sidebar[data-color=\"white\"] .logo .simple-text {\n\tcolor: #65adff;\n}\n.sidebar[data-color=\"white\"] .logo:after,\n.off-canvas-sidebar[data-color=\"white\"] .logo:after {\n\tbackground-color: #65adff;\n\topacity: 0.4;\n}\n.sidebar[data-color=\"white\"] .user .info a span,\n.sidebar[data-color=\"white\"] .user .nav .sidebar-mini-icon,\n.sidebar[data-color=\"white\"] .user .nav .sidebar-normal,\n.off-canvas-sidebar[data-color=\"white\"] .user .info a span,\n.off-canvas-sidebar[data-color=\"white\"] .user .nav .sidebar-mini-icon,\n.off-canvas-sidebar[data-color=\"white\"] .user .nav .sidebar-normal {\n\tcolor: #65adff !important;\n}\n.sidebar[data-color=\"white\"] .user:after,\n.off-canvas-sidebar[data-color=\"white\"] .user:after {\n\tbackground-color: #65adff;\n\topacity: 0.4;\n}\n.sidebar[data-color=\"sidebar\"]:after,\n.off-canvas-sidebar[data-color=\"sidebar\"]:after {\n\tbackground: #004e89;\n}\n.sidebar[data-color=\"sidebar\"] .nav li a,\n.sidebar[data-color=\"sidebar\"] .nav li a i,\n.sidebar[data-color=\"sidebar\"] .nav li a[data-toggle=\"collapse\"],\n.sidebar[data-color=\"sidebar\"] .nav li a[data-toggle=\"collapse\"] i,\n.sidebar[data-color=\"sidebar\"]\n\t.nav\n\tli\n\ta[data-toggle=\"collapse\"]\n\t~ div\n\t> ul\n\t> li\n\t.sidebar-mini-icon,\n.sidebar[data-color=\"sidebar\"]\n\t.nav\n\tli\n\ta[data-toggle=\"collapse\"]\n\t~ div\n\t> ul\n\t> li\n\t> a,\n.off-canvas-sidebar[data-color=\"sidebar\"] .nav li a,\n.off-canvas-sidebar[data-color=\"sidebar\"] .nav li a i,\n.off-canvas-sidebar[data-color=\"sidebar\"] .nav li a[data-toggle=\"collapse\"],\n.off-canvas-sidebar[data-color=\"sidebar\"] .nav li a[data-toggle=\"collapse\"] i,\n.off-canvas-sidebar[data-color=\"sidebar\"]\n\t.nav\n\tli\n\ta[data-toggle=\"collapse\"]\n\t~ div\n\t> ul\n\t> li\n\t.sidebar-mini-icon,\n.off-canvas-sidebar[data-color=\"sidebar\"]\n\t.nav\n\tli\n\ta[data-toggle=\"collapse\"]\n\t~ div\n\t> ul\n\t> li\n\t> a {\n\tcolor: #ffffff;\n\topacity: 0.7;\n}\n.sidebar[data-color=\"sidebar\"] .nav li:hover:not(.active) > a,\n.sidebar[data-color=\"sidebar\"] .nav li:focus:not(.active) > a,\n.off-canvas-sidebar[data-color=\"sidebar\"] .nav li:hover:not(.active) > a,\n.off-canvas-sidebar[data-color=\"sidebar\"] .nav li:focus:not(.active) > a {\n\topacity: 1;\n}\n.sidebar[data-color=\"sidebar\"] .logo .simple-text,\n.off-canvas-sidebar[data-color=\"sidebar\"] .logo .simple-text {\n\tcolor: #ffffff;\n}\n.sidebar[data-color=\"sidebar\"] .logo:after,\n.off-canvas-sidebar[data-color=\"sidebar\"] .logo:after {\n\tbackground-color: #ffffff;\n\topacity: 0.4;\n}\n.sidebar[data-color=\"sidebar\"] .user .info a span,\n.sidebar[data-color=\"sidebar\"] .user .nav .sidebar-mini-icon,\n.sidebar[data-color=\"sidebar\"] .user .nav .sidebar-normal,\n.off-canvas-sidebar[data-color=\"sidebar\"] .user .info a span,\n.off-canvas-sidebar[data-color=\"sidebar\"] .user .nav .sidebar-mini-icon,\n.off-canvas-sidebar[data-color=\"sidebar\"] .user .nav .sidebar-normal {\n\tcolor: #ffffff !important;\n}\n.sidebar[data-color=\"sidebar\"] .user:after,\n.off-canvas-sidebar[data-color=\"sidebar\"] .user:after {\n\tbackground-color: #ffffff;\n\topacity: 0.4;\n}\n.sidebar[data-color=\"brown\"]:after,\n.off-canvas-sidebar[data-color=\"brown\"]:after {\n\tbackground: #65adff;\n}\n.sidebar[data-active-color=\"primary\"] .nav li.active > a,\n.sidebar[data-active-color=\"primary\"] .nav li.active > a i,\n.sidebar[data-active-color=\"primary\"]\n\t.nav\n\tli.active\n\t> a[data-toggle=\"collapse\"],\n.sidebar[data-active-color=\"primary\"]\n\t.nav\n\tli.active\n\t> a[data-toggle=\"collapse\"]\n\ti,\n.sidebar[data-active-color=\"primary\"]\n\t.nav\n\tli.active\n\t> a[data-toggle=\"collapse\"]\n\t~ div\n\t> ul\n\t> li.active\n\t.sidebar-mini-icon,\n.sidebar[data-active-color=\"primary\"]\n\t.nav\n\tli.active\n\t> a[data-toggle=\"collapse\"]\n\t~ div\n\t> ul\n\t> li.active\n\t> a,\n.off-canvas-sidebar[data-active-color=\"primary\"] .nav li.active > a,\n.off-canvas-sidebar[data-active-color=\"primary\"] .nav li.active > a i,\n.off-canvas-sidebar[data-active-color=\"primary\"]\n\t.nav\n\tli.active\n\t> a[data-toggle=\"collapse\"],\n.off-canvas-sidebar[data-active-color=\"primary\"]\n\t.nav\n\tli.active\n\t> a[data-toggle=\"collapse\"]\n\ti,\n.off-canvas-sidebar[data-active-color=\"primary\"]\n\t.nav\n\tli.active\n\t> a[data-toggle=\"collapse\"]\n\t~ div\n\t> ul\n\t> li.active\n\t.sidebar-mini-icon,\n.off-canvas-sidebar[data-active-color=\"primary\"]\n\t.nav\n\tli.active\n\t> a[data-toggle=\"collapse\"]\n\t~ div\n\t> ul\n\t> li.active\n\t> a {\n\tcolor: #1c77c3;\n\topacity: 1;\n}\n.sidebar[data-active-color=\"info\"] .nav li.active > a,\n.sidebar[data-active-color=\"info\"] .nav li.active > a i,\n.sidebar[data-active-color=\"info\"] .nav li.active > a[data-toggle=\"collapse\"],\n.sidebar[data-active-color=\"info\"] .nav li.active > a[data-toggle=\"collapse\"] i,\n.sidebar[data-active-color=\"info\"]\n\t.nav\n\tli.active\n\t> a[data-toggle=\"collapse\"]\n\t~ div\n\t> ul\n\t> li.active\n\t.sidebar-mini-icon,\n.sidebar[data-active-color=\"info\"]\n\t.nav\n\tli.active\n\t> a[data-toggle=\"collapse\"]\n\t~ div\n\t> ul\n\t> li.active\n\t> a,\n.off-canvas-sidebar[data-active-color=\"info\"] .nav li.active > a,\n.off-canvas-sidebar[data-active-color=\"info\"] .nav li.active > a i,\n.off-canvas-sidebar[data-active-color=\"info\"]\n\t.nav\n\tli.active\n\t> a[data-toggle=\"collapse\"],\n.off-canvas-sidebar[data-active-color=\"info\"]\n\t.nav\n\tli.active\n\t> a[data-toggle=\"collapse\"]\n\ti,\n.off-canvas-sidebar[data-active-color=\"info\"]\n\t.nav\n\tli.active\n\t> a[data-toggle=\"collapse\"]\n\t~ div\n\t> ul\n\t> li.active\n\t.sidebar-mini-icon,\n.off-canvas-sidebar[data-active-color=\"info\"]\n\t.nav\n\tli.active\n\t> a[data-toggle=\"collapse\"]\n\t~ div\n\t> ul\n\t> li.active\n\t> a {\n\tcolor: #39a9db;\n\topacity: 1;\n}\n.sidebar[data-active-color=\"success\"] .nav li.active > a,\n.sidebar[data-active-color=\"success\"] .nav li.active > a i,\n.sidebar[data-active-color=\"success\"]\n\t.nav\n\tli.active\n\t> a[data-toggle=\"collapse\"],\n.sidebar[data-active-color=\"success\"]\n\t.nav\n\tli.active\n\t> a[data-toggle=\"collapse\"]\n\ti,\n.sidebar[data-active-color=\"success\"]\n\t.nav\n\tli.active\n\t> a[data-toggle=\"collapse\"]\n\t~ div\n\t> ul\n\t> li.active\n\t.sidebar-mini-icon,\n.sidebar[data-active-color=\"success\"]\n\t.nav\n\tli.active\n\t> a[data-toggle=\"collapse\"]\n\t~ div\n\t> ul\n\t> li.active\n\t> a,\n.off-canvas-sidebar[data-active-color=\"success\"] .nav li.active > a,\n.off-canvas-sidebar[data-active-color=\"success\"] .nav li.active > a i,\n.off-canvas-sidebar[data-active-color=\"success\"]\n\t.nav\n\tli.active\n\t> a[data-toggle=\"collapse\"],\n.off-canvas-sidebar[data-active-color=\"success\"]\n\t.nav\n\tli.active\n\t> a[data-toggle=\"collapse\"]\n\ti,\n.off-canvas-sidebar[data-active-color=\"success\"]\n\t.nav\n\tli.active\n\t> a[data-toggle=\"collapse\"]\n\t~ div\n\t> ul\n\t> li.active\n\t.sidebar-mini-icon,\n.off-canvas-sidebar[data-active-color=\"success\"]\n\t.nav\n\tli.active\n\t> a[data-toggle=\"collapse\"]\n\t~ div\n\t> ul\n\t> li.active\n\t> a {\n\tcolor: #28a745;\n\topacity: 1;\n}\n.sidebar[data-active-color=\"warning\"] .nav li.active > a,\n.sidebar[data-active-color=\"warning\"] .nav li.active > a i,\n.sidebar[data-active-color=\"warning\"]\n\t.nav\n\tli.active\n\t> a[data-toggle=\"collapse\"],\n.sidebar[data-active-color=\"warning\"]\n\t.nav\n\tli.active\n\t> a[data-toggle=\"collapse\"]\n\ti,\n.sidebar[data-active-color=\"warning\"]\n\t.nav\n\tli.active\n\t> a[data-toggle=\"collapse\"]\n\t~ div\n\t> ul\n\t> li.active\n\t.sidebar-mini-icon,\n.sidebar[data-active-color=\"warning\"]\n\t.nav\n\tli.active\n\t> a[data-toggle=\"collapse\"]\n\t~ div\n\t> ul\n\t> li.active\n\t> a,\n.off-canvas-sidebar[data-active-color=\"warning\"] .nav li.active > a,\n.off-canvas-sidebar[data-active-color=\"warning\"] .nav li.active > a i,\n.off-canvas-sidebar[data-active-color=\"warning\"]\n\t.nav\n\tli.active\n\t> a[data-toggle=\"collapse\"],\n.off-canvas-sidebar[data-active-color=\"warning\"]\n\t.nav\n\tli.active\n\t> a[data-toggle=\"collapse\"]\n\ti,\n.off-canvas-sidebar[data-active-color=\"warning\"]\n\t.nav\n\tli.active\n\t> a[data-toggle=\"collapse\"]\n\t~ div\n\t> ul\n\t> li.active\n\t.sidebar-mini-icon,\n.off-canvas-sidebar[data-active-color=\"warning\"]\n\t.nav\n\tli.active\n\t> a[data-toggle=\"collapse\"]\n\t~ div\n\t> ul\n\t> li.active\n\t> a {\n\tcolor: #ffc759;\n\topacity: 1;\n}\n.sidebar[data-active-color=\"danger\"] .nav li.active > a,\n.sidebar[data-active-color=\"danger\"] .nav li.active > a i,\n.sidebar[data-active-color=\"danger\"] .nav li.active > a[data-toggle=\"collapse\"],\n.sidebar[data-active-color=\"danger\"]\n\t.nav\n\tli.active\n\t> a[data-toggle=\"collapse\"]\n\ti,\n.sidebar[data-active-color=\"danger\"]\n\t.nav\n\tli.active\n\t> a[data-toggle=\"collapse\"]\n\t~ div\n\t> ul\n\t> li.active\n\t.sidebar-mini-icon,\n.sidebar[data-active-color=\"danger\"]\n\t.nav\n\tli.active\n\t> a[data-toggle=\"collapse\"]\n\t~ div\n\t> ul\n\t> li.active\n\t> a,\n.off-canvas-sidebar[data-active-color=\"danger\"] .nav li.active > a,\n.off-canvas-sidebar[data-active-color=\"danger\"] .nav li.active > a i,\n.off-canvas-sidebar[data-active-color=\"danger\"]\n\t.nav\n\tli.active\n\t> a[data-toggle=\"collapse\"],\n.off-canvas-sidebar[data-active-color=\"danger\"]\n\t.nav\n\tli.active\n\t> a[data-toggle=\"collapse\"]\n\ti,\n.off-canvas-sidebar[data-active-color=\"danger\"]\n\t.nav\n\tli.active\n\t> a[data-toggle=\"collapse\"]\n\t~ div\n\t> ul\n\t> li.active\n\t.sidebar-mini-icon,\n.off-canvas-sidebar[data-active-color=\"danger\"]\n\t.nav\n\tli.active\n\t> a[data-toggle=\"collapse\"]\n\t~ div\n\t> ul\n\t> li.active\n\t> a {\n\tcolor: #28a745;\n\topacity: 1;\n}\n.sidebar .user,\n.off-canvas-sidebar .user {\n\tpadding-bottom: 20px;\n\tmargin: 20px auto 0;\n\tposition: relative;\n}\n.sidebar .user:after,\n.off-canvas-sidebar .user:after {\n\tcontent: \"\";\n\tposition: absolute;\n\tbottom: 0;\n\tright: 15px;\n\theight: 1px;\n\twidth: calc(100% - 30px);\n\tbackground-color: rgba(255, 255, 255, 0.3);\n}\n.sidebar .user .photo,\n.off-canvas-sidebar .user .photo {\n\twidth: 34px;\n\theight: 34px;\n\toverflow: hidden;\n\tfloat: left;\n\tz-index: 5;\n\tmargin-right: 10px;\n\tborder-radius: 50%;\n\tmargin-left: 23px;\n}\n.sidebar .user .photo img,\n.off-canvas-sidebar .user .photo img {\n\twidth: 100%;\n}\n.sidebar .user a,\n.off-canvas-sidebar .user a {\n\tcolor: #ffffff;\n\ttext-decoration: none;\n\tpadding: 0.5rem 15px;\n\twhite-space: nowrap;\n}\n.sidebar .user .info > a,\n.off-canvas-sidebar .user .info > a {\n\tdisplay: block;\n\tline-height: 18px;\n}\n.sidebar .user .info > a > span,\n.off-canvas-sidebar .user .info > a > span {\n\tdisplay: block;\n\tposition: relative;\n\topacity: 1;\n}\n.sidebar .user .info .caret,\n.off-canvas-sidebar .user .info .caret {\n\tposition: absolute;\n\ttop: 8px;\n\tright: 18px;\n}\n\n.visible-on-sidebar-regular {\n\tdisplay: inline-block !important;\n}\n\n.visible-on-sidebar-mini {\n\tdisplay: none !important;\n}\n\n.off-canvas-sidebar .nav > li > a,\n.off-canvas-sidebar .nav > li > a:hover {\n\tcolor: #ffffff;\n}\n.off-canvas-sidebar .nav > li > a:focus {\n\tbackground: rgba(200, 200, 200, 0.2);\n}\n\n.main-panel {\n\tposition: relative;\n\tfloat: right;\n\twidth: calc(100% - 260px);\n\tbackground-color: #f7f7f7;\n\t-webkit-transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);\n\t-moz-transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);\n\t-o-transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);\n\t-ms-transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);\n\ttransition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);\n}\n.main-panel > .content {\n\tpadding: 0 30px 30px;\n\tmin-height: calc(100vh - 123px);\n\tmargin-top: 93px;\n}\n.main-panel > .navbar {\n\tmargin-bottom: 0;\n}\n.main-panel .header {\n\tmargin-bottom: 50px;\n}\n\n.perfect-scrollbar-on .sidebar,\n.perfect-scrollbar-on .main-panel {\n\theight: 100%;\n\tmax-height: 100%;\n}\n\n@media (min-width: 991px) {\n\t.sidebar,\n\t.main-panel,\n\t.sidebar-wrapper {\n\t\t-webkit-transition-property: top, bottom, width;\n\t\ttransition-property: top, bottom, width;\n\t\t-webkit-transition-duration: 0.2s, 0.2s, 0.35s;\n\t\ttransition-duration: 0.2s, 0.2s, 0.35s;\n\t\t-webkit-transition-timing-function: linear, linear, ease;\n\t\ttransition-timing-function: linear, linear, ease;\n\t\t-webkit-overflow-scrolling: touch;\n\t}\n\n\t.sidebar-mini .visible-on-sidebar-regular {\n\t\tdisplay: none !important;\n\t}\n\t.sidebar-mini .visible-on-sidebar-mini {\n\t\tdisplay: inline-block !important;\n\t}\n\t.sidebar-mini .sidebar,\n\t.sidebar-mini .sidebar .sidebar-wrapper {\n\t\twidth: 80px;\n\t}\n\t.sidebar-mini .main-panel {\n\t\twidth: calc(100% - 80px);\n\t}\n\t.sidebar-mini .sidebar {\n\t\tdisplay: block;\n\t\tz-index: 1030;\n\t}\n\t.sidebar-mini .sidebar .logo a.logo-normal {\n\t\topacity: 1;\n\t\t-webkit-transform: translate3d(-25px, 0, 0);\n\t\t-moz-transform: translate3d(-25px, 0, 0);\n\t\t-o-transform: translate3d(-25px, 0, 0);\n\t\t-ms-transform: translate3d(-25px, 0, 0);\n\t\ttransform: translate3d(-25px, 0, 0);\n\t}\n\t.sidebar-mini .sidebar .logo a.logo-mini {\n\t\topacity: 0;\n\t}\n\t.sidebar-mini\n\t\t.sidebar\n\t\t.sidebar-wrapper\n\t\t> .nav\n\t\t[data-toggle=\"collapse\"]\n\t\t~ div\n\t\t> ul\n\t\t> li\n\t\t> a\n\t\t.sidebar-normal,\n\t.sidebar-mini\n\t\t.sidebar\n\t\t.sidebar-wrapper\n\t\t.user\n\t\t.info\n\t\t[data-toggle=\"collapse\"]\n\t\t~ div\n\t\t> ul\n\t\t> li\n\t\t> a\n\t\t.sidebar-normal,\n\t.sidebar-mini .sidebar .sidebar-wrapper .user .info > a > span,\n\t.sidebar-mini .sidebar .sidebar-wrapper > .nav li > a p {\n\t\t-webkit-transform: translate3d(-25px, 0, 0);\n\t\t-moz-transform: translate3d(-25px, 0, 0);\n\t\t-o-transform: translate3d(-25px, 0, 0);\n\t\t-ms-transform: translate3d(-25px, 0, 0);\n\t\ttransform: translate3d(-25px, 0, 0);\n\t\topacity: 0;\n\t}\n\t.sidebar-mini .sidebar:hover {\n\t\twidth: 260px;\n\t}\n\t.sidebar:hover .logo a.logo-mini {\n\t\topacity: 0;\n\t\t-webkit-transform: translate3d(0, 0, 0);\n\t\t-moz-transform: translate3d(0, 0, 0);\n\t\t-o-transform: translate3d(0, 0, 0);\n\t\t-ms-transform: translate3d(0, 0, 0);\n\t\ttransform: translate3d(0, 0, 0);\n\t}\n\t.sidebar-mini .sidebar:hover .logo a.logo-normal {\n\t\topacity: 1;\n\t\t-webkit-transform: translate3d(0, 0, 0);\n\t\t-moz-transform: translate3d(0, 0, 0);\n\t\t-o-transform: translate3d(0, 0, 0);\n\t\t-ms-transform: translate3d(0, 0, 0);\n\t\ttransform: translate3d(0, 0, 0);\n\t}\n\t.sidebar-mini .sidebar:hover .navbar-minimize {\n\t\topacity: 1;\n\t}\n\t.sidebar-mini .sidebar:hover .sidebar-wrapper {\n\t\twidth: 260px;\n\t}\n\t.sidebar-mini .sidebar:hover .sidebar-wrapper > .nav li > a p,\n\t.sidebar-mini\n\t\t.sidebar:hover\n\t\t.sidebar-wrapper\n\t\t> .nav\n\t\t[data-toggle=\"collapse\"]\n\t\t~ div\n\t\t> ul\n\t\t> li\n\t\t> a\n\t\t.sidebar-normal,\n\t.sidebar-mini\n\t\t.sidebar:hover\n\t\t.sidebar-wrapper\n\t\t.user\n\t\t.info\n\t\t[data-toggle=\"collapse\"]\n\t\t~ div\n\t\t> ul\n\t\t> li\n\t\t> a\n\t\t.sidebar-normal,\n\t.sidebar-mini .sidebar:hover .sidebar-wrapper .user .info > a > span {\n\t\t-webkit-transform: translate3d(0px, 0, 0);\n\t\t-moz-transform: translate3d(0px, 0, 0);\n\t\t-o-transform: translate3d(0px, 0, 0);\n\t\t-ms-transform: translate3d(0px, 0, 0);\n\t\ttransform: translate3d(0px, 0, 0);\n\t\topacity: 0;\n\t}\n}\n.panel-header {\n\theight: 260px;\n\tpadding-top: 80px;\n\tpadding-bottom: 45px;\n\tbackground: #141e30;\n\t/* fallback for old browsers */\n\tbackground: -webkit-gradient(\n\t\tlinear,\n\t\tleft top,\n\t\tright top,\n\t\tfrom(#0c2646),\n\t\tcolor-stop(60%, #204065),\n\t\tto(#2a5788)\n\t);\n\tbackground: linear-gradient(to right, #0c2646 0%, #204065 60%, #2a5788 100%);\n\tposition: relative;\n\toverflow: hidden;\n}\n.panel-header .header .title {\n\tcolor: #ffffff;\n}\n.panel-header .header .category {\n\tmax-width: 600px;\n\tcolor: rgba(255, 255, 255, 0.5);\n\tmargin: 0 auto;\n\tfont-size: 13px;\n}\n.panel-header .header .category a {\n\tcolor: #ffffff;\n}\n\n.panel-header-sm {\n\theight: 135px;\n}\n\n.panel-header-lg {\n\theight: 380px;\n}\n\n.sidebar .logo .simple-text .logo-img {\n\tdisplay: -webkit-inline-box;\n\tdisplay: -ms-inline-flexbox;\n\tdisplay: inline-flex;\n\t-webkit-box-align: center;\n\t-ms-flex-align: center;\n\talign-items: center;\n\t-webkit-box-pack: center;\n\t-ms-flex-pack: center;\n\tjustify-content: center;\n\theight: 34px;\n\twidth: 34px;\n\tborder-radius: 50%;\n\ttext-align: center;\n\toverflow: hidden;\n}\n\n.sidebar[data-color=\"white\"] {\n\tborder-right: 1px solid #ddd;\n}\n\n.card-timeline .timeline {\n\tlist-style: none;\n\tpadding: 20px 0 20px;\n\tposition: relative;\n}\n.card-timeline .timeline:before {\n\ttop: 0;\n\tbottom: 0;\n\tposition: absolute;\n\tcontent: \" \";\n\twidth: 3px;\n\tbackground-color: #dbdbdb;\n\tleft: 50%;\n\tmargin-left: -1.5px;\n}\n.card-timeline .timeline .timeline-footer .btn {\n\tmargin: 0;\n}\n.card-timeline .timeline h6 {\n\tcolor: #292929 !important;\n\tfont-weight: 400;\n\tmargin: 10px 0px 0px;\n}\n.card-timeline .timeline.timeline-simple:before {\n\tleft: 5%;\n}\n.card-timeline .timeline.timeline-simple > li > .timeline-panel {\n\twidth: 86%;\n}\n.card-timeline .timeline.timeline-simple > li > .timeline-badge {\n\tleft: 5%;\n}\n.card-timeline .timeline > li {\n\tmargin-bottom: 20px;\n\tposition: relative;\n}\n.card-timeline .timeline > li:before,\n.card-timeline .timeline > li:after {\n\tcontent: \" \";\n\tdisplay: table;\n}\n.card-timeline .timeline > li:after {\n\tclear: both;\n}\n.card-timeline .timeline > li > .timeline-panel {\n\twidth: 45%;\n\tfloat: left;\n\tpadding: 20px;\n\tborder-radius: 3px;\n\tbox-shadow: 0 2px 2px rgba(204, 197, 185, 0.5);\n\tbackground-color: #ffffff;\n\tcolor: #2c2c2c;\n\tmargin-bottom: 20px;\n\tposition: relative;\n}\n.card-timeline .timeline > li > .timeline-panel:before {\n\tposition: absolute;\n\ttop: 26px;\n\tright: -15px;\n\tdisplay: inline-block;\n\tborder-top: 15px solid transparent;\n\tborder-left: 15px solid #e3e3e3;\n\tborder-right: 0 solid #e3e3e3;\n\tborder-bottom: 15px solid transparent;\n\tcontent: \" \";\n}\n.card-timeline .timeline > li > .timeline-panel:after {\n\tposition: absolute;\n\ttop: 27px;\n\tright: -14px;\n\tdisplay: inline-block;\n\tborder-top: 14px solid transparent;\n\tborder-left: 14px solid #ffffff;\n\tborder-right: 0 solid #ffffff;\n\tborder-bottom: 14px solid transparent;\n\tcontent: \" \";\n}\n.card-timeline .timeline > li > .timeline-badge {\n\tcolor: #ffffff;\n\twidth: 50px;\n\theight: 50px;\n\ttext-align: center;\n\tposition: absolute;\n\ttop: 16px;\n\tleft: 50%;\n\tmargin-left: -25px;\n\tbackground-color: #292929 !important;\n\tz-index: 100;\n\tborder-top-right-radius: 50%;\n\tborder-top-left-radius: 50%;\n\tborder-bottom-right-radius: 50%;\n\tborder-bottom-left-radius: 50%;\n\tborder: 3px solid #f4f3ef;\n}\n.card-timeline .timeline > li > .timeline-badge [class^=\"fa-\"],\n.card-timeline .timeline > li > .timeline-badge [class*=\" fa-\"] {\n\tline-height: inherit;\n}\n.card-timeline .timeline > li > .timeline-badge .nc-icon {\n\tline-height: 2.1;\n\twidth: 25px;\n\ttext-align: center;\n\tfont-size: 21px;\n}\n.card-timeline .timeline > li.timeline-inverted > .timeline-panel {\n\tfloat: right;\n\tbackground-color: #fff;\n}\n.card-timeline .timeline > li.timeline-inverted > .timeline-panel:before {\n\tborder-left-width: 0;\n\tborder-right-width: 15px;\n\tleft: -15px;\n\tright: auto;\n}\n.card-timeline .timeline > li.timeline-inverted > .timeline-panel:after {\n\tborder-left-width: 0;\n\tborder-right-width: 14px;\n\tleft: -14px;\n\tright: auto;\n}\n.card-timeline .timeline-heading {\n\tmargin-bottom: 15px;\n}\n.card-timeline .timeline-badge.primary {\n\tbackground-color: #39a9db !important;\n}\n.card-timeline .timeline-badge.info {\n\tbackground-color: #39a9db !important;\n}\n.card-timeline .timeline-badge.success {\n\tbackground-color: #28a745 !important;\n}\n.card-timeline .timeline-badge.warning {\n\tbackground-color: #ffc759 !important;\n}\n.card-timeline .timeline-badge.danger {\n\tbackground-color: #c1292e !important;\n}\n.card-timeline .timeline-title {\n\tmargin-top: 0;\n\tcolor: inherit;\n}\n.card-timeline .timeline-body > p,\n.card-timeline .timeline-body > ul {\n\tmargin-bottom: 0;\n}\n.card-timeline .timeline-body > p + p {\n\tmargin-top: 5px;\n}\n\n.card {\n\tborder-radius: 8px;\n\tbackground: #ffffff;\n\tbox-shadow: 0 0 6px #acacac;\n\tmargin-bottom: 0px;\n\tposition: relative;\n\tborder: none;\n\t-webkit-transition: transform 300ms cubic-bezier(0.34, 2, 0.6, 1),\n\t\tbox-shadow 200ms ease;\n\t-moz-transition: transform 300ms cubic-bezier(0.34, 2, 0.6, 1),\n\t\tbox-shadow 200ms ease;\n\t-o-transition: transform 300ms cubic-bezier(0.34, 2, 0.6, 1),\n\t\tbox-shadow 200ms ease;\n\t-ms-transition: transform 300ms cubic-bezier(0.34, 2, 0.6, 1),\n\t\tbox-shadow 200ms ease;\n\ttransition: transform 300ms cubic-bezier(0.34, 2, 0.6, 1),\n\t\tbox-shadow 200ms ease;\n}\n\n@media (max-width: 1000px) {\n\t.card {\n\t\tmargin: 0.2em 0;\n\t}\n}\n\n.card .card-body {\n\tpadding: 15px 15px 15px 15px;\n}\n\n.card .card-body.table-full-width {\n\tpadding-left: 0;\n\tpadding-right: 0;\n}\n.card .card-header {\n\tpadding-top: 0.3rem;\n\tpadding-left: 1rem;\n\tpadding-right: 1rem;\n\tborder: 0;\n}\n.card .card-header:not([data-background-color]) {\n\tbackground-color: transparent;\n}\n.card .card-header .card-title {\n\tmargin-top: 0px;\n}\n.card .map {\n\tborder-radius: 3px;\n}\n.card .map.map-big {\n\theight: 400px;\n}\n.card[data-background-color=\"orange\"] {\n\tbackground-color: #1c77c3;\n}\n.card[data-background-color=\"orange\"] .card-header {\n\tbackground-color: #1c77c3;\n}\n.card[data-background-color=\"orange\"] .card-footer .stats {\n\tcolor: #ffffff;\n}\n.card[data-background-color=\"red\"] {\n\tbackground-color: #c1292e;\n}\n.card[data-background-color=\"yellow\"] {\n\tbackground-color: #ffc759;\n}\n.card[data-background-color=\"blue\"] {\n\tbackground-color: #39a9db;\n}\n.card[data-background-color=\"green\"] {\n\tbackground-color: #28a745;\n}\n.card .image {\n\toverflow: hidden;\n\theight: 200px;\n\tposition: relative;\n}\n.card .avatar {\n\twidth: 30px;\n\theight: 30px;\n\toverflow: hidden;\n\tborder-radius: 50%;\n\tmargin-bottom: 15px;\n}\n.card .numbers {\n\tfont-size: 2em;\n}\n.card .big-title {\n\tfont-size: 12px;\n\ttext-align: center;\n\tfont-weight: 500;\n\tpadding-bottom: 15px;\n}\n.card label {\n\tfont-size: 0.8em;\n\tmargin-bottom: 2px;\n\tcolor: #3d3d3d;\n}\n\n@media (max-width: 768px) {\n\t.card label {\n\t\tfont-size: 14px;\n\t}\n}\n\n.card .card-footer {\n\tbackground-color: transparent;\n\tborder: 0;\n}\n.card .card-footer .stats i {\n\tmargin-right: 5px;\n\tposition: relative;\n\ttop: 0px;\n\tcolor: #65adff;\n}\n.card .card-footer .btn {\n\tmargin: 0;\n}\n.card.card-plain {\n\tbackground-color: transparent;\n\tbox-shadow: none;\n\tborder-radius: 0;\n}\n.card.card-plain .card-body {\n\tpadding-left: 25px !important;\n\tpadding-right: 25px !important;\n}\n.card.card-plain img {\n\tborder-radius: 12px;\n}\n\n.card-chart .card-header .card-title {\n\tmargin-top: 10px;\n\tmargin-bottom: 0;\n}\n.card-chart .card-header .card-category {\n\tmargin-bottom: 5px;\n}\n.card-chart .table {\n\tmargin-bottom: 0;\n}\n.card-chart .table td {\n\tborder-top: none;\n\tborder-bottom: 1px solid #e9ecef;\n}\n.card-chart .card-progress {\n\tmargin-top: 30px;\n}\n.card-chart .chart-area {\n\theight: 190px;\n\twidth: calc(100% + 30px);\n\tmargin-left: -15px;\n\tmargin-right: -15px;\n}\n.card-chart .card-footer {\n\tmargin-top: 15px;\n}\n.card-chart .card-footer .stats {\n\tcolor: #292929 !important;\n}\n.card-chart .dropdown {\n\tposition: absolute;\n\tright: 20px;\n\ttop: 20px;\n}\n.card-chart .dropdown .btn {\n\tmargin: 0;\n}\n\n.map {\n\theight: 500px;\n}\n\n.card-user .image {\n\theight: 130px;\n}\n.card-user .image img {\n\tborder-radius: 12px;\n}\n.card-user .author {\n\ttext-align: center;\n\ttext-transform: none;\n\tmargin-top: -77px;\n}\n.card-user .author a + p.description {\n\tmargin-top: -7px;\n}\n.card-user .avatar {\n\twidth: 124px;\n\theight: 124px;\n\tborder: 1px solid #ffffff;\n\tposition: relative;\n}\n.card-user .card-body {\n\tmin-height: 240px;\n}\n.card-user hr {\n\tmargin: 5px 15px 15px;\n}\n.card-user .card-body + .card-footer {\n\tpadding-top: 0;\n}\n.card-user .card-footer h5 {\n\tfont-size: 1.25em;\n\tmargin-bottom: 0;\n}\n.card-user .button-container {\n\tmargin-bottom: 6px;\n\ttext-align: center;\n}\n\n.card-background {\n\tbackground-position: center center;\n\tbackground-size: cover;\n\ttext-align: center;\n}\n.card-background .card-body {\n\tposition: relative;\n\tz-index: 2;\n\tmin-height: 370px;\n\tmax-width: 530px;\n\tmargin: 0 auto;\n\tpadding-top: 60px;\n\tpadding-bottom: 60px;\n}\n.card-background .card-footer {\n\tposition: relative;\n\tz-index: 2;\n}\n.card-background.card-background-product .card-body {\n\tmax-width: 400px;\n}\n.card-background.card-background-product .card-body .card-title {\n\tmargin-top: 30px;\n}\n.card-background .stats {\n\tcolor: #ffffff;\n}\n.card-background .card-footer .stats-link > a {\n\tcolor: #ffffff;\n\tline-height: 1.9;\n}\n.card-background .category,\n.card-background .card-description,\n.card-background small {\n\tcolor: rgba(255, 255, 255, 0.8);\n}\n.card-background .card-title {\n\tcolor: #ffffff;\n\tmargin-top: 130px;\n}\n.card-background:not(.card-pricing) .btn {\n\tmargin-bottom: 0;\n}\n.card-background::after {\n\tposition: absolute;\n\tz-index: 1;\n\twidth: 100%;\n\theight: 100%;\n\tdisplay: block;\n\tleft: 0;\n\ttop: 0;\n\tcontent: \"\";\n\tbackground-color: rgba(0, 0, 0, 0.63);\n\tborder-radius: 6px;\n}\n\n.card-collapse {\n\tpadding-bottom: 10px;\n}\n.card-collapse .card {\n\tmargin-bottom: 0px;\n}\n.card-collapse .card .card-header {\n\tposition: relative;\n\tpadding: 20px 0;\n}\n.card-collapse .card .card-header a[data-toggle=\"collapse\"] {\n\tdisplay: block;\n\tcolor: #444;\n}\n.card-collapse .card .card-header a[data-toggle=\"collapse\"] i {\n\tfloat: right;\n\tposition: relative;\n\tcolor: #f96332;\n\ttop: 3px;\n\tright: 5px;\n}\n.card-collapse .card .card-header:after {\n\tcontent: \"\";\n\tposition: absolute;\n\tbottom: 0;\n\tleft: 0;\n\twidth: 100%;\n\theight: 1px;\n\tbackground-color: #e3e3e3;\n}\n.card-collapse .card .card-body {\n\tpadding: 20px 15px;\n}\n\n.card-contributions .card-description {\n\tmax-width: 350px;\n\tmargin: 0 auto;\n\tmargin-bottom: 20px;\n}\n.card-contributions .card-title {\n\tpadding-top: 35px;\n}\n.card-contributions .card-stats {\n\tdisplay: flex;\n\talign-items: center;\n\tflex-direction: row;\n\tpadding: 11px;\n}\n.card-contributions .card-footer [class*=\"col-\"]:not(:first-child):before {\n\tcontent: \"\";\n\tposition: absolute;\n\tleft: 0;\n\twidth: 1px;\n\theight: 100%;\n\tbackground-color: rgba(0, 0, 0, 0.1);\n}\n.card-contributions .bootstrap-switch {\n\tmargin: 0;\n}\n.card-contributions span {\n\tpadding-left: 15px;\n\ttext-align: left;\n\tmax-width: 125px;\n}\n\n.card .info-area {\n\tpadding: 40px 0 40px;\n\ttext-align: center;\n\tposition: relative;\n\tz-index: 2;\n}\n\n.card-lock .card-header img {\n\twidth: 120px;\n\theight: 120px;\n\tborder-radius: 50%;\n\tmargin-top: -70px;\n}\n\n.card-pricing {\n\ttext-align: center;\n}\n.card-pricing .card-body {\n\tpadding: 15px !important;\n}\n.card-pricing .card-category {\n\tmargin: 10px 0 10px;\n\tcolor: #2c2c2c;\n}\n.card-pricing .card-icon {\n\tpadding: 15px 0 5px;\n\ttransform: translateY(0%);\n\tcolor: #2c2c2c;\n}\n.card-pricing .card-icon.icon-info {\n\tcolor: #39a9db;\n}\n.card-pricing .card-icon.icon-danger {\n\tcolor: #c1292e;\n}\n.card-pricing .card-icon.icon-primary {\n\tcolor: #1c77c3;\n}\n.card-pricing .card-icon.icon-success {\n\tcolor: #28a745;\n}\n.card-pricing .card-icon.icon-warning {\n\tcolor: #ffc759;\n}\n.card-pricing .card-icon i {\n\tfont-size: 40px;\n\twidth: 105px;\n\tborder: 2px solid #ccc;\n\tborder-radius: 50%;\n\theight: 105px;\n\tline-height: 105px;\n}\n.card-pricing .card-title {\n\tmargin-top: 30px !important;\n}\n.card-pricing ul {\n\tlist-style: none;\n\tpadding: 0;\n\tmax-width: 240px;\n\tmargin: 20px auto;\n}\n.card-pricing ul li {\n\tpadding: 5px 0;\n\tlist-style-type: none;\n}\n.card-pricing ul li b {\n\tfont-weight: 600;\n\tcolor: #2c2c2c;\n}\n.card-pricing .btn-neutral {\n\tcolor: #65adff;\n}\n.card-pricing .btn-neutral:hover,\n.card-pricing .btn-neutral :focus {\n\tcolor: #403d39;\n}\n.card-pricing.card-background-image ul li {\n\tcolor: #ffffff;\n\ttext-align: center;\n\tborder-color: rgba(255, 255, 255, 0.3);\n}\n.card-pricing.card-background-image ul li b {\n\tcolor: #ffffff !important;\n}\n.card-pricing.card-background-image .card-description {\n\tcolor: #ffffff !important;\n}\n.card-pricing.card-background-image .card-title small {\n\tcolor: rgba(255, 255, 255, 0.6);\n}\n\n.card-pricing.card-plain .card-category,\n.card-pricing.card-plain .card-title {\n\tcolor: #2c2c2c;\n}\n.card-pricing.card-plain ul li b {\n\tfont-weight: 600;\n\tcolor: #2c2c2c;\n}\n\n.card[data-background=\"image\"] .card-icon i,\n.card[data-background=\"color\"] .card-icon i,\n.card[data-color] .card-icon i {\n\tcolor: #ffffff;\n\tborder: 2px solid rgba(255, 255, 255, 0.3);\n}\n\n.card-profile {\n\tmargin-top: 30px;\n\ttext-align: center;\n}\n.card-profile .card-body .card-title {\n\tmargin-top: 0;\n}\n.card-profile [class*=\"col-\"] .card-description {\n\tmargin-bottom: 0;\n}\n.card-profile [class*=\"col-\"] .card-description + .card-footer {\n\tmargin-top: 8px;\n}\n.card-profile .card-header-avatar {\n\tmax-width: 130px;\n\tmax-height: 130px;\n\tmargin: -60px auto 0;\n}\n.card-profile .card-header-avatar img {\n\tborder-radius: 50% !important;\n}\n.card-profile .card-header-avatar + .card-body {\n\tmargin-top: 15px;\n}\n.card-plain.card-profile .card-header-avatar {\n\tmargin-top: 0;\n}\n.card-profile .card-body .card-avatar {\n\tmargin: 0 auto 30px;\n}\n\n.card-signup .header {\n\tmargin-left: 20px;\n\tmargin-right: 20px;\n\tpadding: 30px 0;\n}\n.card-signup .text-divider {\n\tmargin-top: 30px;\n\tmargin-bottom: 0px;\n\ttext-align: center;\n}\n.card-signup .content {\n\tpadding: 0px 30px;\n}\n.card-signup .form-check {\n\tmargin-top: 20px;\n}\n.card-signup .form-check label {\n\tmargin-left: 7px;\n\tpadding-left: 38px;\n}\n.card-signup .social-line {\n\tmargin-top: 20px;\n\ttext-align: center;\n}\n.card-signup .social-line .btn.btn-icon,\n.card-signup .social-line .btn.btn-icon .btn-icon {\n\tmargin-left: 5px;\n\tmargin-right: 5px;\n\tbox-shadow: 0px 5px 50px 0px rgba(0, 0, 0, 0.2);\n}\n.card-signup .card-footer {\n\tmargin-bottom: 10px;\n\tmargin-top: 24px;\n}\n\n.card-stats-mini.card-background::after {\n\tbackground-image: linear-gradient(to right, #434343 0%, black 100%);\n\topacity: 0.94;\n}\n.card-stats-mini .card-body::after {\n\tclear: both;\n\tcontent: \"\";\n\tdisplay: block;\n}\n.card-stats-mini .card-footer {\n\tborder-top: 1px solid rgba(255, 255, 255, 0.2);\n\tmargin: 0 15px;\n}\n.card-stats-mini.card-background .card-body {\n\tmin-height: auto;\n\tpadding-top: 15px;\n\tpadding-bottom: 15px;\n}\n.card-stats-mini .card-title {\n\tmargin-top: 0;\n\tmargin-bottom: 5px;\n}\n.card-stats-mini .info-area {\n\ttext-align: left;\n\twidth: 40%;\n\tfloat: left;\n\tpadding: 15px 0;\n}\n.card-stats-mini .info-area .icon > i {\n\tfont-size: 2em;\n}\n.card-stats-mini .chart-area {\n\tfloat: left;\n\twidth: 60%;\n}\n.card-stats-mini .stats {\n\ttext-align: left;\n\tcolor: #ffffff;\n}\n\n.card-contributions hr {\n\tmargin: 5px 15px;\n}\n\n.card-stats .card-body {\n\tpadding: 15px 15px 0px;\n}\n.card-stats .card-body .numbers {\n\ttext-align: right;\n\tfont-size: 2em;\n}\n.card-stats .card-body .numbers p {\n\tmargin-bottom: 0;\n}\n.card-stats .card-body .numbers .card-category {\n\t/*color: #292929 !important;*/\n\tfont-size: 16px;\n\tline-height: 1.4em;\n}\n.card-stats .card-footer {\n\tpadding: 0px 15px 5px;\n}\n\n.card-stats .icon-big {\n\tfont-size: 2.5em;\n\tmin-height: 64px;\n}\n.card-stats .icon-big i {\n\tline-height: 59px;\n}\n.card-stats-active .card-footer .btn.btn-sm.btn-link {\n\tbackground-color: inherit;\n}\n\n.card-stats-active {\n\tbackground-color: #1c77c4 !important;\n\tbox-shadow: none !important;\n\ttransition: ease-in-out 0.5s;\n\tcolor: white !important;\n}\n\n.card-stats-active .card-body {\n\tpadding: 15px 15px 0px;\n\tborder-radius: 10px 10px 0 0;\n}\n.card-stats-active .card-footer {\n\tpadding: 0px 15px 5px;\n\tborder-radius: 0 0 10px 10px;\n\tborder: none !important;\n}\n\n.card-stats-active hr {\n\tcolor: #c2e4ff !important;\n}\n.card-stats-active .card-body .numbers {\n\ttext-align: right;\n\tcolor: inherit;\n}\n.card-stats-active .card-body .numbers p {\n\tmargin-bottom: 0;\n}\n.card-stats-active .card-body .numbers .card-category {\n\tcolor: inherit;\n\tfont-size: 14px;\n\tline-height: 1.4em;\n}\n\n.card-stats-active .card-footer .stats {\n\tcolor: #d9f5ff;\n}\n.card-stats-active .card-footer hr {\n\tmargin-top: 10px;\n\tmargin-bottom: 15px;\n}\n.card-stats-active .icon-big {\n\tfont-size: 2.5em;\n}\n.card-stats-active .icon-big i {\n\tline-height: 59px;\n}\n\n.card-stats-active .text-success {\n\tcolor: #fff;\n}\n\n.card-subcategories .card-body {\n\tpadding-bottom: 30px;\n}\n\n.card-testimonial {\n\tmargin-top: 30px;\n\ttext-align: center;\n}\n.card-testimonial .icon {\n\tpadding: 0;\n}\n.card-testimonial .icon i {\n\tfont-size: 30px;\n\tborder: 0;\n\tdisplay: block;\n\tline-height: 100px;\n\tmargin: 0px auto;\n\tmargin-bottom: 0px;\n}\n.card-testimonial .card-body {\n\tpadding: 15px 30px;\n}\n.card-testimonial .card-body .card-description {\n\tfont-style: italic;\n\tfont-size: 16px;\n}\n.card-testimonial .card-body .card-category {\n\tmargin-bottom: 20px;\n}\n.card-testimonial .card-body + .card-footer {\n\tpadding-top: 0;\n\tmargin-top: -20px;\n}\n.card-testimonial .card-avatar {\n\tmargin-top: 0;\n}\n.card-testimonial .card-avatar .img {\n\tborder-radius: 50%;\n\twidth: 100px;\n\theight: 100px;\n}\n.card-testimonial .card-footer .card-title {\n\tcolor: #2c2c2c;\n\ttext-align: center;\n}\n.card-testimonial .card-footer .card-category {\n\tcolor: #292929 !important;\n}\n.card-testimonial .card-footer .card-avatar {\n\tmargin-top: 20px;\n}\n.card-testimonial .card-footer .card-avatar .img {\n\tborder-radius: 50%;\n\twidth: 60px;\n\theight: 60px;\n}\n\n.card-testimonial .card-description + .card-title {\n\tmargin-top: 30px;\n}\n.card-testimonial .card-description + .card-title .card-image .img {\n\tborder-radius: 12px;\n}\n.card-testimonial .card-description + .card-title .card-image .card-title {\n\ttext-align: center;\n}\n\n.card-tasks {\n\ttext-align: left;\n}\n.card-tasks .table tbody td:last-child {\n\tpadding-right: 0;\n\tdisplay: inline-flex;\n}\n.card-tasks .table tbody td:last-child .btn {\n\tpadding: 3px;\n}\n.card-tasks .table tbody td:first-child {\n\tpadding-left: 0;\n}\n.card-tasks .table tbody td {\n\tpadding: 12px 8px !important;\n}\n.card-tasks .table-full-width {\n\tpadding-bottom: 0 !important;\n}\n.card-tasks .card-footer {\n\tpadding-top: 0;\n}\n.card-tasks .table {\n\tmargin-bottom: 0 !important;\n}\n\n.login-page .content .container {\n\tmargin-top: 8vh;\n}\n.login-page .card-login {\n\tborder-radius: 6px;\n\tpadding-bottom: 0.7rem;\n\tbox-shadow: none;\n}\n.login-page .card-login .btn-wd {\n\tmin-width: 180px;\n}\n.login-page .card-login .logo-container {\n\twidth: 65px;\n\tmargin: 0 auto;\n\tmargin-bottom: 55px;\n}\n.login-page .card-login .logo-container img {\n\twidth: 100%;\n}\n.login-page .card-login .input-group:last-child {\n\tmargin-bottom: 1em;\n}\n.login-page .card-login.card-plain .form-control::-moz-placeholder {\n\tcolor: #ebebeb;\n\topacity: 1;\n\tfilter: alpha(opacity=100);\n}\n.login-page .card-login.card-plain .form-control:-moz-placeholder {\n\tcolor: #ebebeb;\n\topacity: 1;\n\tfilter: alpha(opacity=100);\n}\n.login-page .card-login.card-plain .form-control::-webkit-input-placeholder {\n\tcolor: #ebebeb;\n\topacity: 1;\n\tfilter: alpha(opacity=100);\n}\n.login-page .card-login.card-plain .form-control:-ms-input-placeholder {\n\tcolor: #ebebeb;\n\topacity: 1;\n\tfilter: alpha(opacity=100);\n}\n.login-page .card-login.card-plain .form-control {\n\tborder-color: rgba(255, 255, 255, 0.5);\n\tcolor: #ffffff;\n}\n.login-page .card-login.card-plain .form-control:focus {\n\tborder-color: #ffffff;\n\tbackground-color: transparent;\n\tcolor: #ffffff;\n}\n.login-page .card-login.card-plain .has-success:after,\n.login-page .card-login.card-plain .has-danger:after {\n\tcolor: #ffffff;\n}\n.login-page .card-login.card-plain .has-danger .form-control {\n\tbackground-color: transparent;\n}\n.login-page .card-login.card-plain .input-group-prepend .input-group-text,\n.login-page .card-login.card-plain .input-group-append .input-group-text {\n\tbackground-color: transparent;\n\tborder-color: rgba(255, 255, 255, 0.5);\n\tcolor: #ffffff;\n}\n.login-page\n\t.card-login.card-plain\n\t.input-group-focus\n\t.input-group-prepend\n\t.input-group-text,\n.login-page\n\t.card-login.card-plain\n\t.input-group-focus\n\t.input-group-append\n\t.input-group-text {\n\tbackground-color: transparent;\n\tborder-color: #ffffff;\n\tcolor: #ffffff;\n}\n.login-page .card-login.card-plain .form-group.no-border .form-control,\n.login-page .card-login.card-plain .input-group.no-border .form-control {\n\tbackground-color: rgba(255, 255, 255, 0.1);\n\tcolor: #ffffff;\n}\n.login-page .card-login.card-plain .form-group.no-border .form-control:focus,\n.login-page .card-login.card-plain .form-group.no-border .form-control:active,\n.login-page .card-login.card-plain .form-group.no-border .form-control:active,\n.login-page .card-login.card-plain .input-group.no-border .form-control:focus,\n.login-page .card-login.card-plain .input-group.no-border .form-control:active,\n.login-page .card-login.card-plain .input-group.no-border .form-control:active {\n\tbackground-color: rgba(255, 255, 255, 0.2);\n\tcolor: #ffffff;\n}\n.login-page\n\t.card-login.card-plain\n\t.form-group.no-border\n\t.form-control\n\t+ .input-group-prepend\n\t.input-group-text,\n.login-page\n\t.card-login.card-plain\n\t.form-group.no-border\n\t.form-control\n\t+ .input-group-append\n\t.input-group-text,\n.login-page\n\t.card-login.card-plain\n\t.input-group.no-border\n\t.form-control\n\t+ .input-group-prepend\n\t.input-group-text,\n.login-page\n\t.card-login.card-plain\n\t.input-group.no-border\n\t.form-control\n\t+ .input-group-append\n\t.input-group-text {\n\tbackground-color: rgba(255, 255, 255, 0.1);\n}\n.login-page\n\t.card-login.card-plain\n\t.form-group.no-border\n\t.form-control\n\t+ .input-group-prepend\n\t.input-group-text:focus,\n.login-page\n\t.card-login.card-plain\n\t.form-group.no-border\n\t.form-control\n\t+ .input-group-prepend\n\t.input-group-text:active,\n.login-page\n\t.card-login.card-plain\n\t.form-group.no-border\n\t.form-control\n\t+ .input-group-prepend\n\t.input-group-text:active,\n.login-page\n\t.card-login.card-plain\n\t.form-group.no-border\n\t.form-control\n\t+ .input-group-append\n\t.input-group-text:focus,\n.login-page\n\t.card-login.card-plain\n\t.form-group.no-border\n\t.form-control\n\t+ .input-group-append\n\t.input-group-text:active,\n.login-page\n\t.card-login.card-plain\n\t.form-group.no-border\n\t.form-control\n\t+ .input-group-append\n\t.input-group-text:active,\n.login-page\n\t.card-login.card-plain\n\t.input-group.no-border\n\t.form-control\n\t+ .input-group-prepend\n\t.input-group-text:focus,\n.login-page\n\t.card-login.card-plain\n\t.input-group.no-border\n\t.form-control\n\t+ .input-group-prepend\n\t.input-group-text:active,\n.login-page\n\t.card-login.card-plain\n\t.input-group.no-border\n\t.form-control\n\t+ .input-group-prepend\n\t.input-group-text:active,\n.login-page\n\t.card-login.card-plain\n\t.input-group.no-border\n\t.form-control\n\t+ .input-group-append\n\t.input-group-text:focus,\n.login-page\n\t.card-login.card-plain\n\t.input-group.no-border\n\t.form-control\n\t+ .input-group-append\n\t.input-group-text:active,\n.login-page\n\t.card-login.card-plain\n\t.input-group.no-border\n\t.form-control\n\t+ .input-group-append\n\t.input-group-text:active {\n\tbackground-color: rgba(255, 255, 255, 0.2);\n\tcolor: #ffffff;\n}\n.login-page\n\t.card-login.card-plain\n\t.form-group.no-border\n\t.form-control:focus\n\t+ .input-group-prepend\n\t.input-group-text,\n.login-page\n\t.card-login.card-plain\n\t.form-group.no-border\n\t.form-control:focus\n\t+ .input-group-append\n\t.input-group-text,\n.login-page\n\t.card-login.card-plain\n\t.input-group.no-border\n\t.form-control:focus\n\t+ .input-group-prepend\n\t.input-group-text,\n.login-page\n\t.card-login.card-plain\n\t.input-group.no-border\n\t.form-control:focus\n\t+ .input-group-append\n\t.input-group-text {\n\tbackground-color: rgba(255, 255, 255, 0.2);\n\tcolor: #ffffff;\n}\n.login-page\n\t.card-login.card-plain\n\t.form-group.no-border\n\t.input-group-prepend\n\t.input-group-text,\n.login-page\n\t.card-login.card-plain\n\t.form-group.no-border\n\t.input-group-append\n\t.input-group-text,\n.login-page\n\t.card-login.card-plain\n\t.input-group.no-border\n\t.input-group-prepend\n\t.input-group-text,\n.login-page\n\t.card-login.card-plain\n\t.input-group.no-border\n\t.input-group-append\n\t.input-group-text {\n\tbackground-color: rgba(255, 255, 255, 0.1);\n\tborder: none;\n\tcolor: #ffffff;\n}\n.login-page\n\t.card-login.card-plain\n\t.form-group.no-border.input-group-focus\n\t.input-group-prepend\n\t.input-group-text,\n.login-page\n\t.card-login.card-plain\n\t.form-group.no-border.input-group-focus\n\t.input-group-append\n\t.input-group-text,\n.login-page\n\t.card-login.card-plain\n\t.input-group.no-border.input-group-focus\n\t.input-group-prepend\n\t.input-group-text,\n.login-page\n\t.card-login.card-plain\n\t.input-group.no-border.input-group-focus\n\t.input-group-append\n\t.input-group-text {\n\tbackground-color: rgba(255, 255, 255, 0.2);\n\tcolor: #ffffff;\n}\n.login-page .card-login.card-plain .input-group-addon,\n.login-page .card-login.card-plain .form-group.no-border .input-group-addon,\n.login-page .card-login.card-plain .input-group.no-border .input-group-addon {\n\tcolor: rgba(255, 255, 255, 0.8);\n}\n.login-page .link {\n\tfont-size: 10px;\n\tcolor: #ffffff;\n\ttext-decoration: none;\n}\n\n.full-page > .content,\n.full-page > .footer {\n\tposition: relative;\n\tz-index: 4;\n}\n.full-page.section-image {\n\tposition: initial;\n}\n.full-page > .content {\n\tpadding-top: 21vh;\n}\n.full-page .footer {\n\tposition: absolute;\n\twidth: 100%;\n\tbottom: 0;\n}\n.full-page .footer .container {\n\tcolor: #ffffff;\n}\n.full-page .full-page-background {\n\tposition: absolute;\n\tz-index: 1;\n\theight: 100%;\n\twidth: 100%;\n\tdisplay: block;\n\ttop: 0;\n\tleft: 0;\n\tbackground-size: cover;\n\tbackground-position: center center;\n}\n.full-page:after {\n\tposition: absolute;\n\tz-index: 1;\n\twidth: 100%;\n\theight: 100%;\n\tdisplay: block;\n\tleft: 0;\n\ttop: 0;\n\tcontent: \"\";\n\tbackground-color: rgba(255, 255, 255, 0.6);\n}\n.full-page.pricing-page .description {\n\tmargin-bottom: 65px;\n}\n.full-page.register-page .content > .container {\n\tmargin-top: 5vh;\n}\n.full-page.register-page .info-horizontal {\n\tpadding: 0px 0px 20px;\n}\n.full-page.register-page .info-horizontal {\n\ttext-align: left !important;\n}\n.full-page.register-page .info-horizontal .icon {\n\tmargin-top: 0;\n}\n.full-page.register-page .info-horizontal .icon > i {\n\tfont-size: 2em;\n}\n.full-page.register-page .info-horizontal .icon.icon-circle {\n\twidth: 65px;\n\theight: 65px;\n\tmax-width: 65px;\n\tmargin-top: 8px;\n}\n.full-page.register-page .info-horizontal .icon.icon-circle i {\n\tdisplay: table;\n\tmargin: 0 auto;\n\tline-height: 3.5;\n\tfont-size: 1.9em;\n}\n.full-page.register-page .info-horizontal .description {\n\toverflow: hidden;\n}\n.full-page.lock-page .content > .container {\n\tmargin-top: 10vh;\n}\n\n.register-page .navbar .navbar-collapse .nav-item .nav-link,\n.login-page .navbar .navbar-collapse .nav-item .nav-link,\n.lock-page .navbar .navbar-collapse .nav-item .nav-link {\n\ttext-transform: capitalize;\n\tcolor: #ffffff !important;\n}\n.register-page .navbar.navbar-transparent,\n.login-page .navbar.navbar-transparent,\n.lock-page .navbar.navbar-transparent {\n\tborder-bottom: 1px solid transparent;\n\tmargin-top: 25px;\n}\n.register-page .navbar .navbar-brand,\n.login-page .navbar .navbar-brand,\n.lock-page .navbar .navbar-brand {\n\tcolor: #ffffff !important;\n}\n\n@media screen and (max-width: 991px) {\n\t.register-page\n\t\t.navbar.bg-white\n\t\t.navbar-toggler\n\t\t.navbar-toggler-bar.navbar-kebab,\n\t.login-page .navbar.bg-white .navbar-toggler .navbar-toggler-bar.navbar-kebab,\n\t.lock-page .navbar.bg-white .navbar-toggler .navbar-toggler-bar.navbar-kebab {\n\t\tbackground: #65adff !important;\n\t}\n\t.register-page\n\t\t.navbar.bg-white\n\t\t.navbar-collapse\n\t\t.navbar-nav\n\t\t.nav-item\n\t\t.nav-link,\n\t.login-page .navbar.bg-white .navbar-collapse .navbar-nav .nav-item .nav-link,\n\t.lock-page .navbar.bg-white .navbar-collapse .navbar-nav .nav-item .nav-link {\n\t\tcolor: #65adff !important;\n\t}\n\t.register-page .navbar.bg-white .navbar-brand,\n\t.login-page .navbar.bg-white .navbar-brand,\n\t.lock-page .navbar.bg-white .navbar-brand {\n\t\tcolor: #65adff !important;\n\t}\n\t.register-page .navbar.navbar-transparent .navbar-toggle,\n\t.login-page .navbar.navbar-transparent .navbar-toggle,\n\t.lock-page .navbar.navbar-transparent .navbar-toggle {\n\t\tdisplay: none;\n\t}\n\t.register-page\n\t\t.navbar.navbar-transparent\n\t\t.navbar-toggler\n\t\t.navbar-toggler-bar.navbar-kebab,\n\t.login-page\n\t\t.navbar.navbar-transparent\n\t\t.navbar-toggler\n\t\t.navbar-toggler-bar.navbar-kebab,\n\t.lock-page\n\t\t.navbar.navbar-transparent\n\t\t.navbar-toggler\n\t\t.navbar-toggler-bar.navbar-kebab {\n\t\tbackground: #ffffff !important;\n\t}\n}\n.section {\n\tpadding: 70px 0;\n\tposition: relative;\n\tbackground: #ffffff;\n}\n.section .row + .category {\n\tmargin-top: 15px;\n}\n\n.section-navbars {\n\tpadding-bottom: 0;\n}\n\n.section-full-screen {\n\theight: 100vh;\n}\n\n.section-signup {\n\tpadding-top: 20vh;\n}\n\n.parallax-s {\n\toverflow: hidden;\n\theight: 500px;\n\twidth: 100%;\n}\n\n.section-image {\n\tbackground-size: cover;\n\tbackground-position: center center;\n\tposition: relative;\n\twidth: 100%;\n}\n.section-image .title,\n.section-image .card-plain .card-title {\n\tcolor: #ffffff;\n}\n.section-image .nav-pills .nav-link {\n\tbackground-color: #ffffff;\n}\n.section-image .nav-pills .nav-link:hover,\n.section-image .nav-pills .nav-link:focus {\n\tbackground-color: #ffffff;\n}\n.section-image .info-title,\n.section-image .info-area.info-horizontal .icon i,\n.section-image .card-pricing.card-plain ul li {\n\tcolor: #ffffff;\n}\n.section-image .description,\n.section-image .info-area .icon:not(.icon-circle) {\n\tcolor: rgba(255, 255, 255, 0.8);\n}\n.section-image .card:not(.card-plain) .info-title {\n\tcolor: #2c2c2c;\n}\n.section-image .card:not(.card-plain) .info-area p,\n.section-image .card:not(.card-plain) .info-area .icon,\n.section-image .card:not(.card-plain) .description {\n\tcolor: #292929 !important;\n}\n.section-image .footer {\n\tcolor: #ffffff;\n}\n.section-image .card-plain [class*=\"text-\"],\n.section-image .card-plain ul li b {\n\tcolor: #ffffff;\n}\n.section-image .card-plain .category {\n\tcolor: rgba(255, 255, 255, 0.5);\n}\n.section-image:after {\n\tposition: absolute;\n\tz-index: 1;\n\twidth: 100%;\n\theight: 100%;\n\tdisplay: block;\n\tleft: 0;\n\ttop: 0;\n\tcontent: \"\";\n\tbackground-color: rgba(0, 0, 0, 0.7);\n}\n.section-image .container {\n\tz-index: 2;\n\tposition: relative;\n}\n\n.page-header {\n\tmin-height: 100vh;\n\tmax-height: 999px;\n\tpadding: 0;\n\tcolor: #ffffff;\n\tposition: relative;\n}\n.page-header .page-header-image {\n\tposition: absolute;\n\tbackground-size: cover;\n\tbackground-position: center center;\n\twidth: 100%;\n\theight: 100%;\n\tz-index: -1;\n}\n.page-header .content-center {\n\tposition: absolute;\n\ttop: 50%;\n\tleft: 50%;\n\tz-index: 2;\n\t-ms-transform: translate(-50%, -50%);\n\t-webkit-transform: translate(-50%, -50%);\n\ttransform: translate(-50%, -50%);\n\ttext-align: center;\n\tcolor: #ffffff;\n\tpadding: 0 15px;\n\twidth: 100%;\n\tmax-width: 880px;\n}\n.page-header footer {\n\tposition: absolute;\n\tbottom: 0;\n\twidth: 100%;\n}\n.page-header .container {\n\theight: 100%;\n\tz-index: 1;\n}\n.page-header .category,\n.page-header .description {\n\tcolor: rgba(255, 255, 255, 0.8);\n}\n.page-header.page-header-small {\n\tmin-height: 60vh;\n\tmax-height: 440px;\n}\n.page-header.page-header-mini {\n\tmin-height: 40vh;\n\tmax-height: 340px;\n}\n.page-header .title {\n\tmargin-bottom: 15px;\n}\n.page-header .title + h4 {\n\tmargin-top: 10px;\n}\n.page-header:after,\n.page-header:before {\n\tposition: absolute;\n\tz-index: 0;\n\twidth: 100%;\n\theight: 100%;\n\tdisplay: block;\n\tleft: 0;\n\ttop: 0;\n\tcontent: \"\";\n}\n.page-header:before {\n\tbackground-color: rgba(0, 0, 0, 0.3);\n}\n.page-header[filter-color=\"orange\"] {\n\tbackground: rgba(44, 44, 44, 0.2);\n\t/* For browsers that do not support gradients */\n\tbackground: -webkit-linear-gradient(\n\t\t90deg,\n\t\trgba(44, 44, 44, 0.2),\n\t\trgba(224, 23, 3, 0.6)\n\t);\n\t/* For Safari 5.1 to 6.0 */\n\tbackground: -o-linear-gradient(\n\t\t90deg,\n\t\trgba(44, 44, 44, 0.2),\n\t\trgba(224, 23, 3, 0.6)\n\t);\n\t/* For Opera 11.1 to 12.0 */\n\tbackground: -moz-linear-gradient(\n\t\t90deg,\n\t\trgba(44, 44, 44, 0.2),\n\t\trgba(224, 23, 3, 0.6)\n\t);\n\t/* For Firefox 3.6 to 15 */\n\tbackground: linear-gradient(\n\t\t0deg,\n\t\trgba(44, 44, 44, 0.2),\n\t\trgba(224, 23, 3, 0.6)\n\t);\n\t/* Standard syntax */\n}\n\n.clear-filter:after,\n.clear-filter:before {\n\tdisplay: none;\n}\n\n.section-story-overview {\n\tpadding: 50px 0;\n}\n.section-story-overview .image-container {\n\theight: 335px;\n\tposition: relative;\n\tbackground-position: center center;\n\tbackground-size: cover;\n\tbox-shadow: 0px 10px 25px 0px rgba(0, 0, 0, 0.3);\n\tborder-radius: 0.25rem;\n}\n.section-story-overview .image-container + .category {\n\tpadding-top: 15px;\n}\n.section-story-overview .image-container.image-right {\n\tz-index: 2;\n}\n.section-story-overview .image-container.image-right + h3.title {\n\tmargin-top: 120px;\n}\n.section-story-overview .image-container.image-left {\n\tz-index: 1;\n}\n.section-story-overview .image-container img {\n\twidth: 100%;\n\tleft: 0;\n\ttop: 0;\n\theight: auto;\n\tposition: absolute;\n}\n.section-story-overview .image-container:nth-child(2) {\n\tmargin-top: 420px;\n\tmargin-left: -105px;\n}\n.section-story-overview p.blockquote {\n\twidth: 220px;\n\tmin-height: 180px;\n\ttext-align: left;\n\tposition: absolute;\n\ttop: 376px;\n\tright: 155px;\n\tz-index: 0;\n}\n\n.section-nucleo-icons .nucleo-container img {\n\twidth: auto;\n\tleft: 0;\n\ttop: 0;\n\theight: 100%;\n\tposition: absolute;\n}\n.section-nucleo-icons .nucleo-container {\n\theight: 335px;\n\tposition: relative;\n}\n.section-nucleo-icons h5 {\n\tmargin-bottom: 35px;\n}\n.section-nucleo-icons .icons-container {\n\tposition: relative;\n\tmax-width: 450px;\n\theight: 300px;\n\tmax-height: 300px;\n\tmargin: 0 auto;\n}\n.section-nucleo-icons .icons-container i {\n\tfont-size: 34px;\n\tposition: absolute;\n\tleft: 0;\n\ttop: 0;\n}\n.section-nucleo-icons .icons-container i:nth-child(1) {\n\ttop: 5%;\n\tleft: 7%;\n}\n.section-nucleo-icons .icons-container i:nth-child(2) {\n\ttop: 28%;\n\tleft: 24%;\n}\n.section-nucleo-icons .icons-container i:nth-child(3) {\n\ttop: 40%;\n}\n.section-nucleo-icons .icons-container i:nth-child(4) {\n\ttop: 18%;\n\tleft: 62%;\n}\n.section-nucleo-icons .icons-container i:nth-child(5) {\n\ttop: 74%;\n\tleft: 3%;\n}\n.section-nucleo-icons .icons-container i:nth-child(6) {\n\ttop: 36%;\n\tleft: 44%;\n\tfont-size: 65px;\n\tcolor: #f96332;\n\tpadding: 1px;\n}\n.section-nucleo-icons .icons-container i:nth-child(7) {\n\ttop: 59%;\n\tleft: 26%;\n}\n.section-nucleo-icons .icons-container i:nth-child(8) {\n\ttop: 60%;\n\tleft: 69%;\n}\n.section-nucleo-icons .icons-container i:nth-child(9) {\n\ttop: 72%;\n\tleft: 47%;\n}\n.section-nucleo-icons .icons-container i:nth-child(10) {\n\ttop: 88%;\n\tleft: 27%;\n}\n.section-nucleo-icons .icons-container i:nth-child(11) {\n\ttop: 31%;\n\tleft: 80%;\n}\n.section-nucleo-icons .icons-container i:nth-child(12) {\n\ttop: 88%;\n\tleft: 68%;\n}\n.section-nucleo-icons .icons-container i:nth-child(13) {\n\ttop: 5%;\n\tleft: 81%;\n}\n.section-nucleo-icons .icons-container i:nth-child(14) {\n\ttop: 58%;\n\tleft: 90%;\n}\n.section-nucleo-icons .icons-container i:nth-child(15) {\n\ttop: 6%;\n\tleft: 40%;\n}\n\n.section-images {\n\tmax-height: 670px;\n\theight: 670px;\n}\n.section-images .hero-images-container,\n.section-images .hero-images-container-1,\n.section-images .hero-images-container-2 {\n\tmargin-top: -38vh;\n}\n.section-images .hero-images-container {\n\tmax-width: 670px;\n}\n.section-images .hero-images-container-1 {\n\tmax-width: 390px;\n\tposition: absolute;\n\ttop: 55%;\n\tright: 18%;\n}\n.section-images .hero-images-container-2 {\n\tmax-width: 225px;\n\tposition: absolute;\n\ttop: 68%;\n\tright: 12%;\n}\n\n[data-background-color=\"gray\"] {\n\tbackground-color: white;\n}\n\n[data-background-color=\"orange\"] {\n\tbackground-color: #e95e38;\n}\n\n[data-background-color=\"black\"] {\n\tbackground-color: #2c2c2c;\n}\n\n[data-background-color]:not([data-background-color=\"gray\"]) {\n\tcolor: #ffffff;\n}\n[data-background-color]:not([data-background-color=\"gray\"]) .separator-line {\n\tbackground-color: rgba(255, 255, 255, 0.5);\n}\n[data-background-color]:not([data-background-color=\"gray\"])\n\t.footer.footer-white\n\t.footer-brand,\n[data-background-color]:not([data-background-color=\"gray\"])\n\t.footer.footer-white\n\tul\n\tli\n\t> a.nav-link:not(.btn-icon) {\n\tcolor: initial;\n}\n[data-background-color]:not([data-background-color=\"gray\"])\n\t.pagination\n\t.page-item.disabled\n\t> .page-link {\n\tbackground-color: rgba(255, 255, 255, 0.2);\n\tcolor: #ffffff;\n}\n[data-background-color]:not([data-background-color=\"gray\"])\n\t.card:not(.card-plain)\n\t.category,\n[data-background-color]:not([data-background-color=\"gray\"])\n\t.card:not(.card-plain)\n\t.card-description,\n[data-background-color]:not([data-background-color=\"gray\"])\n\t.card:not(.card-plain)\n\t.category,\n[data-background-color]:not([data-background-color=\"gray\"])\n\t.card:not(.card-plain)\n\t.category {\n\tcolor: #292929 !important;\n}\n[data-background-color]:not([data-background-color=\"gray\"])\n\t.card:not(.card-plain)\n\t.card-title,\n[data-background-color]:not([data-background-color=\"gray\"])\n\t.card:not(.card-plain)\n\t.card-title {\n\tcolor: initial;\n}\n[data-background-color]:not([data-background-color=\"gray\"])\n\t.carousel\n\t.carousel-inner {\n\tbox-shadow: none;\n}\n[data-background-color]:not([data-background-color=\"gray\"]) .title,\n[data-background-color]:not([data-background-color=\"gray\"])\n\t.social-description\n\th2,\n[data-background-color]:not([data-background-color=\"gray\"]) p,\n[data-background-color]:not([data-background-color=\"gray\"]) p.blockquote,\n[data-background-color]:not([data-background-color=\"gray\"]) p.blockquote small,\n[data-background-color]:not([data-background-color=\"gray\"]) h1,\n[data-background-color]:not([data-background-color=\"gray\"]) h2,\n[data-background-color]:not([data-background-color=\"gray\"]) h3,\n[data-background-color]:not([data-background-color=\"gray\"]) h4,\n[data-background-color]:not([data-background-color=\"gray\"]) h5,\n[data-background-color]:not([data-background-color=\"gray\"]) h6,\n[data-background-color]:not([data-background-color=\"gray\"])\n\ta:not(.btn):not(.dropdown-item):not(.card-link),\n[data-background-color]:not([data-background-color=\"gray\"]) .icons-container i,\n[data-background-color]:not([data-background-color=\"gray\"]).card-pricing ul li,\n[data-background-color]:not([data-background-color=\"gray\"])\n\t.info.info-horizontal\n\t.icon\n\ti,\n[data-background-color]:not([data-background-color=\"gray\"])\n\t.card-pricing.card-plain\n\tul\n\tli {\n\tcolor: #ffffff;\n}\n[data-background-color]:not([data-background-color=\"gray\"]).card\n\ta:not(.btn):not(.dropdown-item) {\n\tcolor: #ffffff;\n}\n[data-background-color]:not([data-background-color=\"gray\"]).card\n\ta:not(.btn):not(.dropdown-item):hover,\n[data-background-color]:not([data-background-color=\"gray\"]).card\n\ta:not(.btn):not(.dropdown-item):focus {\n\tborder-color: #ffffff;\n}\n[data-background-color]:not([data-background-color=\"gray\"]).footer hr,\n[data-background-color]:not([data-background-color=\"gray\"]).card-pricing\n\t.icon\n\ti,\n[data-background-color]:not([data-background-color=\"gray\"]).card-pricing ul li {\n\tborder-color: rgba(255, 255, 255, 0.2);\n}\n[data-background-color]:not([data-background-color=\"gray\"])\n\t.card-footer\n\t.stats\n\ti,\n[data-background-color]:not([data-background-color=\"gray\"]).card-plain\n\t.category,\n[data-background-color]:not([data-background-color=\"gray\"])\n\t.card-plain\n\t.category,\n[data-background-color]:not([data-background-color=\"gray\"]) .card-header:after {\n\tcolor: rgba(255, 255, 255, 0.5);\n}\n[data-background-color]:not([data-background-color=\"gray\"]).card-pricing\n\tul\n\tli\n\ti,\n[data-background-color]:not([data-background-color=\"gray\"]).card-pricing\n\tul\n\tli\n\tb,\n[data-background-color]:not([data-background-color=\"gray\"])\n\t.card-pricing.card-plain\n\tul\n\tli\n\tb,\n[data-background-color]:not([data-background-color=\"gray\"]) .card-category,\n[data-background-color]:not([data-background-color=\"gray\"]) .author span,\n[data-background-color]:not([data-background-color=\"gray\"])\n\t.card-pricing.card-plain\n\tul\n\tli\n\ti {\n\tcolor: rgba(255, 255, 255, 0.8) !important;\n}\n[data-background-color]:not([data-background-color=\"gray\"]) .separator {\n\tbackground-color: #ffffff;\n}\n[data-background-color]:not([data-background-color=\"gray\"]) .navbar.bg-white p {\n\tcolor: #65adff;\n}\n[data-background-color]:not([data-background-color=\"gray\"]) .description,\n[data-background-color]:not([data-background-color=\"gray\"])\n\t.social-description\n\tp {\n\tcolor: rgba(255, 255, 255, 0.8);\n}\n[data-background-color]:not([data-background-color=\"gray\"]) p.blockquote {\n\tborder-color: rgba(255, 255, 255, 0.2);\n}\n[data-background-color]:not([data-background-color=\"gray\"])\n\t.checkbox\n\tlabel::before,\n[data-background-color]:not([data-background-color=\"gray\"])\n\t.checkbox\n\tlabel::after,\n[data-background-color]:not([data-background-color=\"gray\"])\n\t.radio\n\tlabel::before,\n[data-background-color]:not([data-background-color=\"gray\"])\n\t.radio\n\tlabel::after {\n\tborder-color: rgba(255, 255, 255, 0.2);\n}\n[data-background-color]:not([data-background-color=\"gray\"])\n\t.checkbox\n\tlabel::after,\n[data-background-color]:not([data-background-color=\"gray\"]) .checkbox label,\n[data-background-color]:not([data-background-color=\"gray\"]) .radio label {\n\tcolor: #ffffff;\n}\n[data-background-color]:not([data-background-color=\"gray\"])\n\t.checkbox\n\tinput[type=\"checkbox\"]:disabled\n\t+ label,\n[data-background-color]:not([data-background-color=\"gray\"])\n\t.radio\n\tinput[type=\"radio\"]:disabled\n\t+ label {\n\tcolor: #ffffff;\n}\n[data-background-color]:not([data-background-color=\"gray\"])\n\t.radio\n\tinput[type=\"radio\"]:not(:disabled):hover\n\t+ label::after,\n[data-background-color]:not([data-background-color=\"gray\"])\n\t.radio\n\tinput[type=\"radio\"]:checked\n\t+ label::after {\n\tbackground-color: #ffffff;\n\tborder-color: #ffffff;\n}\n[data-background-color]:not([data-background-color=\"gray\"])\n\t.form-control::-moz-placeholder {\n\tcolor: #ebebeb;\n\topacity: 1;\n\tfilter: alpha(opacity=100);\n}\n[data-background-color]:not([data-background-color=\"gray\"])\n\t.form-control:-moz-placeholder {\n\tcolor: #ebebeb;\n\topacity: 1;\n\tfilter: alpha(opacity=100);\n}\n[data-background-color]:not([data-background-color=\"gray\"])\n\t.form-control::-webkit-input-placeholder {\n\tcolor: #ebebeb;\n\topacity: 1;\n\tfilter: alpha(opacity=100);\n}\n[data-background-color]:not([data-background-color=\"gray\"])\n\t.form-control:-ms-input-placeholder {\n\tcolor: #ebebeb;\n\topacity: 1;\n\tfilter: alpha(opacity=100);\n}\n[data-background-color]:not([data-background-color=\"gray\"]) .form-control {\n\tborder-color: rgba(255, 255, 255, 0.5);\n\tcolor: #ffffff;\n}\n[data-background-color]:not([data-background-color=\"gray\"])\n\t.form-control:focus {\n\tborder-color: #ffffff;\n\tbackground-color: transparent;\n\tcolor: #ffffff;\n}\n[data-background-color]:not([data-background-color=\"gray\"]) .has-success:after,\n[data-background-color]:not([data-background-color=\"gray\"]) .has-danger:after {\n\tcolor: #ffffff;\n}\n[data-background-color]:not([data-background-color=\"gray\"])\n\t.has-danger\n\t.form-control {\n\tbackground-color: transparent;\n}\n[data-background-color]:not([data-background-color=\"gray\"])\n\t.input-group-prepend\n\t.input-group-text,\n[data-background-color]:not([data-background-color=\"gray\"])\n\t.input-group-append\n\t.input-group-text {\n\tbackground-color: transparent;\n\tborder-color: rgba(255, 255, 255, 0.5);\n\tcolor: #ffffff;\n}\n[data-background-color]:not([data-background-color=\"gray\"])\n\t.input-group-focus\n\t.input-group-prepend\n\t.input-group-text,\n[data-background-color]:not([data-background-color=\"gray\"])\n\t.input-group-focus\n\t.input-group-append\n\t.input-group-text {\n\tbackground-color: transparent;\n\tborder-color: #ffffff;\n\tcolor: #ffffff;\n}\n[data-background-color]:not([data-background-color=\"gray\"])\n\t.form-group.no-border\n\t.form-control,\n[data-background-color]:not([data-background-color=\"gray\"])\n\t.input-group.no-border\n\t.form-control {\n\tbackground-color: rgba(255, 255, 255, 0.1);\n\tcolor: #ffffff;\n}\n[data-background-color]:not([data-background-color=\"gray\"])\n\t.form-group.no-border\n\t.form-control:focus,\n[data-background-color]:not([data-background-color=\"gray\"])\n\t.form-group.no-border\n\t.form-control:active,\n[data-background-color]:not([data-background-color=\"gray\"])\n\t.form-group.no-border\n\t.form-control:active,\n[data-background-color]:not([data-background-color=\"gray\"])\n\t.input-group.no-border\n\t.form-control:focus,\n[data-background-color]:not([data-background-color=\"gray\"])\n\t.input-group.no-border\n\t.form-control:active,\n[data-background-color]:not([data-background-color=\"gray\"])\n\t.input-group.no-border\n\t.form-control:active {\n\tbackground-color: rgba(255, 255, 255, 0.2);\n\tcolor: #ffffff;\n}\n[data-background-color]:not([data-background-color=\"gray\"])\n\t.form-group.no-border\n\t.form-control\n\t+ .input-group-prepend\n\t.input-group-text,\n[data-background-color]:not([data-background-color=\"gray\"])\n\t.form-group.no-border\n\t.form-control\n\t+ .input-group-append\n\t.input-group-text,\n[data-background-color]:not([data-background-color=\"gray\"])\n\t.input-group.no-border\n\t.form-control\n\t+ .input-group-prepend\n\t.input-group-text,\n[data-background-color]:not([data-background-color=\"gray\"])\n\t.input-group.no-border\n\t.form-control\n\t+ .input-group-append\n\t.input-group-text {\n\tbackground-color: rgba(255, 255, 255, 0.1);\n}\n[data-background-color]:not([data-background-color=\"gray\"])\n\t.form-group.no-border\n\t.form-control\n\t+ .input-group-prepend\n\t.input-group-text:focus,\n[data-background-color]:not([data-background-color=\"gray\"])\n\t.form-group.no-border\n\t.form-control\n\t+ .input-group-prepend\n\t.input-group-text:active,\n[data-background-color]:not([data-background-color=\"gray\"])\n\t.form-group.no-border\n\t.form-control\n\t+ .input-group-prepend\n\t.input-group-text:active,\n[data-background-color]:not([data-background-color=\"gray\"])\n\t.form-group.no-border\n\t.form-control\n\t+ .input-group-append\n\t.input-group-text:focus,\n[data-background-color]:not([data-background-color=\"gray\"])\n\t.form-group.no-border\n\t.form-control\n\t+ .input-group-append\n\t.input-group-text:active,\n[data-background-color]:not([data-background-color=\"gray\"])\n\t.form-group.no-border\n\t.form-control\n\t+ .input-group-append\n\t.input-group-text:active,\n[data-background-color]:not([data-background-color=\"gray\"])\n\t.input-group.no-border\n\t.form-control\n\t+ .input-group-prepend\n\t.input-group-text:focus,\n[data-background-color]:not([data-background-color=\"gray\"])\n\t.input-group.no-border\n\t.form-control\n\t+ .input-group-prepend\n\t.input-group-text:active,\n[data-background-color]:not([data-background-color=\"gray\"])\n\t.input-group.no-border\n\t.form-control\n\t+ .input-group-prepend\n\t.input-group-text:active,\n[data-background-color]:not([data-background-color=\"gray\"])\n\t.input-group.no-border\n\t.form-control\n\t+ .input-group-append\n\t.input-group-text:focus,\n[data-background-color]:not([data-background-color=\"gray\"])\n\t.input-group.no-border\n\t.form-control\n\t+ .input-group-append\n\t.input-group-text:active,\n[data-background-color]:not([data-background-color=\"gray\"])\n\t.input-group.no-border\n\t.form-control\n\t+ .input-group-append\n\t.input-group-text:active {\n\tbackground-color: rgba(255, 255, 255, 0.2);\n\tcolor: #ffffff;\n}\n[data-background-color]:not([data-background-color=\"gray\"])\n\t.form-group.no-border\n\t.form-control:focus\n\t+ .input-group-prepend\n\t.input-group-text,\n[data-background-color]:not([data-background-color=\"gray\"])\n\t.form-group.no-border\n\t.form-control:focus\n\t+ .input-group-append\n\t.input-group-text,\n[data-background-color]:not([data-background-color=\"gray\"])\n\t.input-group.no-border\n\t.form-control:focus\n\t+ .input-group-prepend\n\t.input-group-text,\n[data-background-color]:not([data-background-color=\"gray\"])\n\t.input-group.no-border\n\t.form-control:focus\n\t+ .input-group-append\n\t.input-group-text {\n\tbackground-color: rgba(255, 255, 255, 0.2);\n\tcolor: #ffffff;\n}\n[data-background-color]:not([data-background-color=\"gray\"])\n\t.form-group.no-border\n\t.input-group-prepend\n\t.input-group-text,\n[data-background-color]:not([data-background-color=\"gray\"])\n\t.form-group.no-border\n\t.input-group-append\n\t.input-group-text,\n[data-background-color]:not([data-background-color=\"gray\"])\n\t.input-group.no-border\n\t.input-group-prepend\n\t.input-group-text,\n[data-background-color]:not([data-background-color=\"gray\"])\n\t.input-group.no-border\n\t.input-group-append\n\t.input-group-text {\n\tbackground-color: rgba(255, 255, 255, 0.1);\n\tborder: none;\n\tcolor: #ffffff;\n}\n[data-background-color]:not([data-background-color=\"gray\"])\n\t.form-group.no-border.input-group-focus\n\t.input-group-prepend\n\t.input-group-text,\n[data-background-color]:not([data-background-color=\"gray\"])\n\t.form-group.no-border.input-group-focus\n\t.input-group-append\n\t.input-group-text,\n[data-background-color]:not([data-background-color=\"gray\"])\n\t.input-group.no-border.input-group-focus\n\t.input-group-prepend\n\t.input-group-text,\n[data-background-color]:not([data-background-color=\"gray\"])\n\t.input-group.no-border.input-group-focus\n\t.input-group-append\n\t.input-group-text {\n\tbackground-color: rgba(255, 255, 255, 0.2);\n\tcolor: #ffffff;\n}\n[data-background-color]:not([data-background-color=\"gray\"]) .input-group-addon,\n[data-background-color]:not([data-background-color=\"gray\"])\n\t.form-group.no-border\n\t.input-group-addon,\n[data-background-color]:not([data-background-color=\"gray\"])\n\t.input-group.no-border\n\t.input-group-addon {\n\tcolor: rgba(255, 255, 255, 0.8);\n}\n[data-background-color]:not([data-background-color=\"gray\"])\n\t.subscribe-line\n\t.form-control {\n\tbackground-color: transparent;\n\tborder: 1px solid #e3e3e3;\n\tcolor: #2c2c2c;\n}\n[data-background-color]:not([data-background-color=\"gray\"])\n\t.subscribe-line\n\t.form-control:last-child {\n\tborder-left: 0 none;\n}\n[data-background-color]:not([data-background-color=\"gray\"])\n\t.subscribe-line\n\t.input-group-addon,\n[data-background-color]:not([data-background-color=\"gray\"])\n\t.subscribe-line\n\t.form-group.no-border\n\t.input-group-addon,\n[data-background-color]:not([data-background-color=\"gray\"])\n\t.subscribe-line\n\t.input-group.no-border\n\t.input-group-addon {\n\tcolor: #555555;\n\tborder: 1px solid #e3e3e3;\n}\n[data-background-color]:not([data-background-color=\"gray\"]) .btn.btn-simple {\n\tbackground-color: transparent;\n\tborder-color: rgba(255, 255, 255, 0.5);\n\tcolor: #ffffff;\n}\n[data-background-color]:not([data-background-color=\"gray\"])\n\t.btn.btn-simple:hover,\n[data-background-color]:not([data-background-color=\"gray\"])\n\t.btn.btn-simple:hover,\n[data-background-color]:not([data-background-color=\"gray\"])\n\t.btn.btn-simple:focus,\n[data-background-color]:not([data-background-color=\"gray\"])\n\t.btn.btn-simple:active {\n\tbackground-color: transparent;\n\tborder-color: #ffffff;\n}\n[data-background-color]:not([data-background-color=\"gray\"])\n\t.nav-tabs\n\t> .nav-item\n\t> .nav-link\n\ti.nc-icon {\n\tcolor: #ffffff;\n}\n[data-background-color]:not([data-background-color=\"gray\"]).section-nucleo-icons\n\t.icons-container\n\ti:nth-child(6) {\n\tcolor: #ffffff;\n}\n\n@media screen and (max-width: 991px) {\n\t.navbar {\n\t\tpadding: 0;\n\t}\n\t.navbar.navbar-absolute {\n\t\tpadding-top: 0;\n\t}\n\t.navbar .navbar-brand {\n\t\tfont-size: 16px;\n\t\tmargin-right: 0;\n\t}\n\n\t.profile-photo .profile-photo-small {\n\t\tmargin-left: -2px;\n\t}\n\n\t.button-dropdown {\n\t\tdisplay: none;\n\t}\n\n\t#minimizeSidebar {\n\t\tdisplay: none;\n\t}\n\n\t.navbar .container-fluid {\n\t\tpadding-right: 15px;\n\t\tpadding-left: 15px;\n\t}\n\t.navbar .navbar-collapse .input-group {\n\t\tmargin: 0;\n\t\tmargin-top: 5px;\n\t}\n\t.navbar .navbar-nav .nav-item:first-child {\n\t\tmargin-top: 10px;\n\t}\n\t.navbar .navbar-nav .nav-item:not(:last-child) {\n\t\tmargin-bottom: 10px;\n\t}\n\t.navbar .dropdown.show .dropdown-menu {\n\t\tdisplay: block;\n\t}\n\t.navbar .dropdown .dropdown-menu {\n\t\tdisplay: none;\n\t}\n\t.navbar .dropdown.show .dropdown-menu,\n\t.navbar .dropdown .dropdown-menu {\n\t\tborder: 0;\n\t\ttransition: none;\n\t\t-webkit-box-shadow: none;\n\t\twidth: auto;\n\t\tmargin: 0px 1rem;\n\t\tmargin-top: 0px;\n\t\tbox-shadow: none;\n\t\tposition: static;\n\t\tpadding-left: 10px;\n\t}\n\t.navbar .dropdown.show .dropdown-menu:before,\n\t.navbar .dropdown .dropdown-menu:before {\n\t\tdisplay: none;\n\t}\n\t.navbar .dropdown-menu .dropdown-item:focus,\n\t.navbar .dropdown-menu .dropdown-item:hover {\n\t\tcolor: #ffffff;\n\t}\n\t.navbar.bg-white .dropdown-menu .dropdown-item:focus,\n\t.navbar.bg-white .dropdown-menu .dropdown-item:hover {\n\t\tcolor: #65adff;\n\t}\n\t.navbar .navbar-toggler-bar {\n\t\tdisplay: block;\n\t\tposition: relative;\n\t\twidth: 22px;\n\t\theight: 1px;\n\t\tborder-radius: 1px;\n\t\tbackground: #65adff;\n\t}\n\t.navbar .navbar-toggler-bar + .navbar-toggler-bar {\n\t\tmargin-top: 7px;\n\t}\n\t.navbar .navbar-toggler-bar + .navbar-toggler-bar.navbar-kebab {\n\t\tmargin-top: 3px;\n\t}\n\t.navbar .navbar-toggler-bar.bar2 {\n\t\twidth: 17px;\n\t\ttransition: width 0.2s linear;\n\t}\n\t.navbar.bg-white:not(.navbar-transparent) .navbar-toggler-bar {\n\t\tbackground-color: #65adff;\n\t}\n\t.navbar .toggled .navbar-toggler-bar {\n\t\twidth: 24px;\n\t}\n\t.navbar .toggled .navbar-toggler-bar + .navbar-toggler-bar {\n\t\tmargin-top: 5px;\n\t}\n\n\t.wrapper {\n\t\t-webkit-transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);\n\t\t-moz-transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);\n\t\t-o-transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);\n\t\t-ms-transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);\n\t\ttransition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);\n\t}\n\n\t.nav-open .main-panel {\n\t\tright: 0;\n\t\t-webkit-transform: translate3d(260px, 0, 0);\n\t\t-moz-transform: translate3d(260px, 0, 0);\n\t\t-o-transform: translate3d(260px, 0, 0);\n\t\t-ms-transform: translate3d(260px, 0, 0);\n\t\ttransform: translate3d(260px, 0, 0);\n\t}\n\t.nav-open .sidebar {\n\t\t-webkit-transform: translate3d(0px, 0, 0);\n\t\t-moz-transform: translate3d(0px, 0, 0);\n\t\t-o-transform: translate3d(0px, 0, 0);\n\t\t-ms-transform: translate3d(0px, 0, 0);\n\t\ttransform: translate3d(0px, 0, 0);\n\t}\n\t.nav-open body {\n\t\tposition: relative;\n\t\toverflow-x: hidden;\n\t}\n\t.nav-open .menu-on-right .main-panel {\n\t\t-webkit-transform: translate3d(-260px, 0, 0);\n\t\t-moz-transform: translate3d(-260px, 0, 0);\n\t\t-o-transform: translate3d(-260px, 0, 0);\n\t\t-ms-transform: translate3d(-260px, 0, 0);\n\t\ttransform: translate3d(-260px, 0, 0);\n\t}\n\t.nav-open .menu-on-right .navbar-collapse,\n\t.nav-open .menu-on-right .sidebar {\n\t\t-webkit-transform: translate3d(0px, 0, 0);\n\t\t-moz-transform: translate3d(0px, 0, 0);\n\t\t-o-transform: translate3d(0px, 0, 0);\n\t\t-ms-transform: translate3d(0px, 0, 0);\n\t\ttransform: translate3d(0px, 0, 0);\n\t}\n\t.nav-open .menu-on-right .navbar-translate {\n\t\t-webkit-transform: translate3d(-300px, 0, 0);\n\t\t-moz-transform: translate3d(-300px, 0, 0);\n\t\t-o-transform: translate3d(-300px, 0, 0);\n\t\t-ms-transform: translate3d(-300px, 0, 0);\n\t\ttransform: translate3d(-300px, 0, 0);\n\t}\n\t.nav-open .menu-on-right #bodyClick {\n\t\tright: 260px;\n\t\tleft: auto;\n\t}\n\n\t.menu-on-right .sidebar {\n\t\tleft: auto;\n\t\tright: 0;\n\t\t-webkit-transform: translate3d(260px, 0, 0);\n\t\t-moz-transform: translate3d(260px, 0, 0);\n\t\t-o-transform: translate3d(260px, 0, 0);\n\t\t-ms-transform: translate3d(260px, 0, 0);\n\t\ttransform: translate3d(260px, 0, 0);\n\t}\n\n\t.bar1,\n\t.bar2,\n\t.bar3 {\n\t\toutline: 1px solid transparent;\n\t}\n\n\t.bar1 {\n\t\ttop: 0px;\n\t\t-webkit-animation: topbar-back 500ms linear 0s;\n\t\t-moz-animation: topbar-back 500ms linear 0s;\n\t\tanimation: topbar-back 500ms 0s;\n\t\t-webkit-animation-fill-mode: forwards;\n\t\t-moz-animation-fill-mode: forwards;\n\t\tanimation-fill-mode: forwards;\n\t}\n\n\t.bar2 {\n\t\topacity: 1;\n\t}\n\n\t.bar3 {\n\t\tbottom: 0px;\n\t\t-webkit-animation: bottombar-back 500ms linear 0s;\n\t\t-moz-animation: bottombar-back 500ms linear 0s;\n\t\tanimation: bottombar-back 500ms 0s;\n\t\t-webkit-animation-fill-mode: forwards;\n\t\t-moz-animation-fill-mode: forwards;\n\t\tanimation-fill-mode: forwards;\n\t}\n\n\t.toggled .bar1 {\n\t\ttop: 6px;\n\t\t-webkit-animation: topbar-x 500ms linear 0s;\n\t\t-moz-animation: topbar-x 500ms linear 0s;\n\t\tanimation: topbar-x 500ms 0s;\n\t\t-webkit-animation-fill-mode: forwards;\n\t\t-moz-animation-fill-mode: forwards;\n\t\tanimation-fill-mode: forwards;\n\t}\n\n\t.toggled .bar2 {\n\t\topacity: 0;\n\t}\n\n\t.toggled .bar3 {\n\t\tbottom: 6px;\n\t\t-webkit-animation: bottombar-x 500ms linear 0s;\n\t\t-moz-animation: bottombar-x 500ms linear 0s;\n\t\tanimation: bottombar-x 500ms 0s;\n\t\t-webkit-animation-fill-mode: forwards;\n\t\t-moz-animation-fill-mode: forwards;\n\t\tanimation-fill-mode: forwards;\n\t}\n\n\t@keyframes topbar-x {\n\t\t0% {\n\t\t\ttop: 0px;\n\t\t\ttransform: rotate(0deg);\n\t\t}\n\t\t45% {\n\t\t\ttop: 6px;\n\t\t\ttransform: rotate(145deg);\n\t\t}\n\t\t75% {\n\t\t\ttransform: rotate(130deg);\n\t\t}\n\t\t100% {\n\t\t\ttransform: rotate(135deg);\n\t\t}\n\t}\n\t@-webkit-keyframes topbar-x {\n\t\t0% {\n\t\t\ttop: 0px;\n\t\t\t-webkit-transform: rotate(0deg);\n\t\t}\n\t\t45% {\n\t\t\ttop: 6px;\n\t\t\t-webkit-transform: rotate(145deg);\n\t\t}\n\t\t75% {\n\t\t\t-webkit-transform: rotate(130deg);\n\t\t}\n\t\t100% {\n\t\t\t-webkit-transform: rotate(135deg);\n\t\t}\n\t}\n\t@-moz-keyframes topbar-x {\n\t\t0% {\n\t\t\ttop: 0px;\n\t\t\t-moz-transform: rotate(0deg);\n\t\t}\n\t\t45% {\n\t\t\ttop: 6px;\n\t\t\t-moz-transform: rotate(145deg);\n\t\t}\n\t\t75% {\n\t\t\t-moz-transform: rotate(130deg);\n\t\t}\n\t\t100% {\n\t\t\t-moz-transform: rotate(135deg);\n\t\t}\n\t}\n\t@keyframes topbar-back {\n\t\t0% {\n\t\t\ttop: 6px;\n\t\t\ttransform: rotate(135deg);\n\t\t}\n\t\t45% {\n\t\t\ttransform: rotate(-10deg);\n\t\t}\n\t\t75% {\n\t\t\ttransform: rotate(5deg);\n\t\t}\n\t\t100% {\n\t\t\ttop: 0px;\n\t\t\ttransform: rotate(0);\n\t\t}\n\t}\n\t@-webkit-keyframes topbar-back {\n\t\t0% {\n\t\t\ttop: 6px;\n\t\t\t-webkit-transform: rotate(135deg);\n\t\t}\n\t\t45% {\n\t\t\t-webkit-transform: rotate(-10deg);\n\t\t}\n\t\t75% {\n\t\t\t-webkit-transform: rotate(5deg);\n\t\t}\n\t\t100% {\n\t\t\ttop: 0px;\n\t\t\t-webkit-transform: rotate(0);\n\t\t}\n\t}\n\t@-moz-keyframes topbar-back {\n\t\t0% {\n\t\t\ttop: 6px;\n\t\t\t-moz-transform: rotate(135deg);\n\t\t}\n\t\t45% {\n\t\t\t-moz-transform: rotate(-10deg);\n\t\t}\n\t\t75% {\n\t\t\t-moz-transform: rotate(5deg);\n\t\t}\n\t\t100% {\n\t\t\ttop: 0px;\n\t\t\t-moz-transform: rotate(0);\n\t\t}\n\t}\n\t@keyframes bottombar-x {\n\t\t0% {\n\t\t\tbottom: 0px;\n\t\t\ttransform: rotate(0deg);\n\t\t}\n\t\t45% {\n\t\t\tbottom: 6px;\n\t\t\ttransform: rotate(-145deg);\n\t\t}\n\t\t75% {\n\t\t\ttransform: rotate(-130deg);\n\t\t}\n\t\t100% {\n\t\t\ttransform: rotate(-135deg);\n\t\t}\n\t}\n\t@-webkit-keyframes bottombar-x {\n\t\t0% {\n\t\t\tbottom: 0px;\n\t\t\t-webkit-transform: rotate(0deg);\n\t\t}\n\t\t45% {\n\t\t\tbottom: 6px;\n\t\t\t-webkit-transform: rotate(-145deg);\n\t\t}\n\t\t75% {\n\t\t\t-webkit-transform: rotate(-130deg);\n\t\t}\n\t\t100% {\n\t\t\t-webkit-transform: rotate(-135deg);\n\t\t}\n\t}\n\t@-moz-keyframes bottombar-x {\n\t\t0% {\n\t\t\tbottom: 0px;\n\t\t\t-moz-transform: rotate(0deg);\n\t\t}\n\t\t45% {\n\t\t\tbottom: 6px;\n\t\t\t-moz-transform: rotate(-145deg);\n\t\t}\n\t\t75% {\n\t\t\t-moz-transform: rotate(-130deg);\n\t\t}\n\t\t100% {\n\t\t\t-moz-transform: rotate(-135deg);\n\t\t}\n\t}\n\t@keyframes bottombar-back {\n\t\t0% {\n\t\t\tbottom: 6px;\n\t\t\ttransform: rotate(-135deg);\n\t\t}\n\t\t45% {\n\t\t\ttransform: rotate(10deg);\n\t\t}\n\t\t75% {\n\t\t\ttransform: rotate(-5deg);\n\t\t}\n\t\t100% {\n\t\t\tbottom: 0px;\n\t\t\ttransform: rotate(0);\n\t\t}\n\t}\n\t@-webkit-keyframes bottombar-back {\n\t\t0% {\n\t\t\tbottom: 6px;\n\t\t\t-webkit-transform: rotate(-135deg);\n\t\t}\n\t\t45% {\n\t\t\t-webkit-transform: rotate(10deg);\n\t\t}\n\t\t75% {\n\t\t\t-webkit-transform: rotate(-5deg);\n\t\t}\n\t\t100% {\n\t\t\tbottom: 0px;\n\t\t\t-webkit-transform: rotate(0);\n\t\t}\n\t}\n\t@-moz-keyframes bottombar-back {\n\t\t0% {\n\t\t\tbottom: 6px;\n\t\t\t-moz-transform: rotate(-135deg);\n\t\t}\n\t\t45% {\n\t\t\t-moz-transform: rotate(10deg);\n\t\t}\n\t\t75% {\n\t\t\t-moz-transform: rotate(-5deg);\n\t\t}\n\t\t100% {\n\t\t\tbottom: 0px;\n\t\t\t-moz-transform: rotate(0);\n\t\t}\n\t}\n\t@-webkit-keyframes fadeIn {\n\t\t0% {\n\t\t\topacity: 0;\n\t\t}\n\t\t100% {\n\t\t\topacity: 1;\n\t\t}\n\t}\n\t@-moz-keyframes fadeIn {\n\t\t0% {\n\t\t\topacity: 0;\n\t\t}\n\t\t100% {\n\t\t\topacity: 1;\n\t\t}\n\t}\n\t@keyframes fadeIn {\n\t\t0% {\n\t\t\topacity: 0;\n\t\t}\n\t\t100% {\n\t\t\topacity: 1;\n\t\t}\n\t}\n\t#bodyClick {\n\t\theight: 100%;\n\t\twidth: 100%;\n\t\tposition: fixed;\n\t\topacity: 1;\n\t\ttop: 0;\n\t\tright: 0;\n\t\tleft: 260px;\n\t\tcontent: \"\";\n\t\tz-index: 9999;\n\t\toverflow-x: hidden;\n\t\tbackground-color: transparent;\n\t\t-webkit-transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);\n\t\t-moz-transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);\n\t\t-o-transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);\n\t\t-ms-transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);\n\t\ttransition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);\n\t}\n\n\t.footer .copyright {\n\t\ttext-align: right;\n\t}\n\n\t.section-nucleo-icons .icons-container {\n\t\tmargin-top: 65px;\n\t}\n\n\t.navbar-nav .nav-link i.fa,\n\t.navbar-nav .nav-link i.nc-icon {\n\t\topacity: 0.5;\n\t}\n\n\t.sidebar,\n\t.bootstrap-navbar {\n\t\tposition: fixed;\n\t\tdisplay: block;\n\t\ttop: 0;\n\t\theight: 100%;\n\t\twidth: 260px;\n\t\tright: auto;\n\t\tleft: 0;\n\t\tz-index: 1032;\n\t\tvisibility: visible;\n\t\toverflow-y: visible;\n\t\tpadding: 0;\n\t\t-webkit-transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);\n\t\t-moz-transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);\n\t\t-o-transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);\n\t\t-ms-transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);\n\t\ttransition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);\n\t\t-webkit-transform: translate3d(-260px, 0, 0);\n\t\t-moz-transform: translate3d(-260px, 0, 0);\n\t\t-o-transform: translate3d(-260px, 0, 0);\n\t\t-ms-transform: translate3d(-260px, 0, 0);\n\t\ttransform: translate3d(-260px, 0, 0);\n\t}\n\n\t.main-panel {\n\t\twidth: 100%;\n\t}\n\n\t.timeline:before {\n\t\tleft: 5% !important;\n\t}\n\t.timeline > li > .timeline-badge {\n\t\tleft: 5% !important;\n\t}\n\t.timeline > li > .timeline-panel {\n\t\tfloat: right !important;\n\t\twidth: 82% !important;\n\t}\n\t.timeline > li > .timeline-panel:before {\n\t\tborder-left-width: 0 !important;\n\t\tborder-right-width: 15px !important;\n\t\tleft: -15px !important;\n\t\tright: auto !important;\n\t}\n\t.timeline > li > .timeline-panel:after {\n\t\tborder-left-width: 0 !important;\n\t\tborder-right-width: 14px !important;\n\t\tleft: -14px !important;\n\t\tright: auto !important;\n\t}\n}\n@media (max-width: 991px) and (min-width: 768px) {\n\t.nav-tabs-navigation.verical-navs {\n\t\tpadding: 0px 2px;\n\t}\n}\n@media screen and (min-width: 768px) {\n\t.footer .footer-nav {\n\t\tpadding-left: 21px;\n\t\tjustify-content: center;\n\t}\n\t.footer .credits {\n\t\tpadding-right: 15px;\n\t}\n}\n@media screen and (min-width: 992px) {\n\t.navbar-collapse {\n\t\tbackground: none !important;\n\t}\n\n\t.navbar .navbar-toggle {\n\t\tdisplay: none;\n\t}\n\n\t.navbar-nav .nav-link.profile-photo {\n\t\tpadding: 0;\n\t\tmargin: 7px 0.7rem;\n\t}\n\n\t.section-nucleo-icons .icons-container {\n\t\tmargin: 0 0 0 auto;\n\t}\n\n\t.dropdown-menu .dropdown-item {\n\t\tcolor: inherit;\n\t}\n\n\t.footer .copyright {\n\t\tfloat: right;\n\t\tpadding-right: 15px;\n\t}\n\n\t.sidebar .sidebar-wrapper li.active > a:not([data-toggle=\"collapse\"]):before,\n\t.sidebar\n\t\t.sidebar-wrapper\n\t\tli.active\n\t\t> [data-toggle=\"collapse\"]\n\t\t+ div\n\t\t.nav\n\t\tli:before {\n\t\tborder-right: 17px solid #dddddd;\n\t\tborder-top: 17px solid transparent;\n\t\tborder-bottom: 17px solid transparent;\n\t\tcontent: \"\";\n\t\tdisplay: inline-block;\n\t\tposition: absolute;\n\t\tright: -16px;\n\t\topacity: 1;\n\t\ttop: 7px;\n\t\ttransition: opacity 150ms ease-in;\n\t}\n\t.sidebar .sidebar-wrapper li.active > a:not([data-toggle=\"collapse\"]):after,\n\t.sidebar\n\t\t.sidebar-wrapper\n\t\tli.active\n\t\t> [data-toggle=\"collapse\"]\n\t\t+ div\n\t\t.nav\n\t\tli:after {\n\t\tborder-right: 17px solid #f4f3ef;\n\t\tborder-top: 17px solid transparent;\n\t\tborder-bottom: 17px solid transparent;\n\t\tcontent: \"\";\n\t\tdisplay: inline-block;\n\t\tposition: absolute;\n\t\tright: -17px;\n\t\topacity: 1;\n\t\ttop: 7px;\n\t\ttransition: opacity 150ms ease-in;\n\t}\n\t.sidebar\n\t\t.sidebar-wrapper\n\t\tli.active\n\t\t> [data-toggle=\"collapse\"]\n\t\t+ div\n\t\t.nav\n\t\tli\n\t\ta:before,\n\t.sidebar\n\t\t.sidebar-wrapper\n\t\tli.active\n\t\t> [data-toggle=\"collapse\"]\n\t\t+ div\n\t\t.nav\n\t\tli\n\t\ta:after {\n\t\ttop: 0;\n\t}\n}\n@media screen and (max-width: 768px) {\n\t.card-stats [class*=\"col-\"] .statistics::after {\n\t\tdisplay: none;\n\t}\n\n\t.main-panel .content {\n\t\tpadding-left: 15px;\n\t\tpadding-right: 15px;\n\t}\n\n\t.footer nav {\n\t\tdisplay: block;\n\t\tmargin-bottom: 5px;\n\t\tfloat: none;\n\t}\n\n\t.landing-page .section-story-overview .image-container:nth-child(2) {\n\t\tmargin-left: 0;\n\t\tmargin-bottom: 30px;\n\t}\n\n\t.card .form-horizontal .col-md-3.col-form-label {\n\t\ttext-align: left;\n\t}\n}\n@media screen and (max-width: 767px) {\n\t.nav-tabs-navigation.verical-navs {\n\t\tpadding: 0 28px;\n\t}\n\n\t.typography-line {\n\t\tpadding-left: 23% !important;\n\t}\n\t.typography-line span {\n\t\twidth: 60px !important;\n\t}\n\n\t.login-page .navbar,\n\t.lock-page .navbar,\n\t.register-page .navbar,\n\t.navbar {\n\t\tpadding: 0 !important;\n\t}\n\n\t.footer .footer-nav,\n\t.footer .credits {\n\t\tmargin: 0 auto !important;\n\t}\n\t.footer .footer-nav {\n\t\tmargin-bottom: 10px !important;\n\t}\n\n\t.register-page .content {\n\t\tpadding-top: 5vh;\n\t}\n\t.register-page .footer {\n\t\tposition: relative;\n\t}\n\t.register-page .info-area.info-horizontal {\n\t\tmargin-top: 0;\n\t}\n}\n@media screen and (max-width: 374px) {\n\t.login-page .content {\n\t\tpadding-top: 10vh;\n\t}\n}\n@media screen and (max-width: 413px) {\n\t.fixed-plugin .dropdown.show-dropdown.show .dropdown-menu.show {\n\t\twidth: 225px !important;\n\t}\n\t.fixed-plugin\n\t\t.dropdown.show-dropdown.show\n\t\t.dropdown-menu.show[x-placement=\"top-start\"] {\n\t\ttransform: translate3d(0, 400px, 0) !important;\n\t}\n\t.fixed-plugin .dropdown.show-dropdown.show .dropdown-menu.show:before,\n\t.fixed-plugin .dropdown.show-dropdown.show .dropdown-menu.show:after {\n\t\tbottom: 360px !important;\n\t}\n}\n@media screen and (max-width: 576px) {\n\t.navbar[class*=\"navbar-toggleable-\"] .container {\n\t\tmargin-left: 0;\n\t\tmargin-right: 0;\n\t}\n\n\t.card-contributions .card-stats {\n\t\tflex-direction: column;\n\t}\n\t.card-contributions .card-stats .bootstrap-switch {\n\t\tmargin-bottom: 15px;\n\t}\n\n\t.footer .copyright {\n\t\ttext-align: center;\n\t}\n\n\t.section-nucleo-icons .icons-container i {\n\t\tfont-size: 30px;\n\t}\n\t.section-nucleo-icons .icons-container i:nth-child(6) {\n\t\tfont-size: 48px;\n\t}\n\n\t.page-header .container h6.category-absolute {\n\t\twidth: 90%;\n\t}\n\n\t.card-timeline .timeline .timeline-panel {\n\t\twidth: 38%;\n\t\tpadding: 15px;\n\t}\n}\n.alert .close {\n\tfont-size: 1.8rem;\n\tfont-weight: 300;\n}\n\n/*           badges             */\n.badge + .badge {\n\tmargin-left: 5px;\n}\n\n.btn i,\n.navbar .navbar-nav > a.btn i {\n\tmargin-right: 3px;\n}\n\n.btn + .btn,\n.btn-group + .btn-group {\n\tmargin-left: 5px;\n}\n\n.card .card-footer .stats i {\n\tmargin-right: 9px;\n}\n.card .card-footer .legend i {\n\tmargin-right: 4px;\n}\n\n.dropup .dropdown-toggle:after,\n.dropdown .dropdown-toggle:after {\n\tmargin-left: 3px;\n}\n\n.login-page .card-login {\n\tborder-radius: 6px;\n\tpadding-bottom: 0.7rem;\n}\n.login-page .card-login .btn-wd {\n\tmin-width: 180px;\n}\n.login-page .card-login .logo-container {\n\twidth: 65px;\n\tmargin: 0 auto;\n\tmargin-bottom: 55px;\n}\n.login-page .card-login .logo-container img {\n\twidth: 100%;\n}\n.login-page .card-login .input-group:last-child {\n\tmargin-bottom: 1em;\n}\n.login-page .card-login.card-plain .form-control::-moz-placeholder {\n\tcolor: #ebebeb;\n\topacity: 1;\n\tfilter: alpha(opacity=100);\n}\n.login-page .card-login.card-plain .form-control:-moz-placeholder {\n\tcolor: #ebebeb;\n\topacity: 1;\n\tfilter: alpha(opacity=100);\n}\n.login-page .card-login.card-plain .form-control::-webkit-input-placeholder {\n\tcolor: #ebebeb;\n\topacity: 1;\n\tfilter: alpha(opacity=100);\n}\n.login-page .card-login.card-plain .form-control:-ms-input-placeholder {\n\tcolor: #ebebeb;\n\topacity: 1;\n\tfilter: alpha(opacity=100);\n}\n.login-page .card-login.card-plain .form-control {\n\tborder-color: rgba(255, 255, 255, 0.5);\n\tcolor: #ffffff;\n}\n.login-page .card-login.card-plain .form-control:focus {\n\tborder-color: #ffffff;\n\tbackground-color: transparent;\n\tcolor: #ffffff;\n}\n.login-page .card-login.card-plain .has-success:after,\n.login-page .card-login.card-plain .has-danger:after {\n\tcolor: #ffffff;\n}\n.login-page .card-login.card-plain .has-danger .form-control {\n\tbackground-color: transparent;\n}\n.login-page .card-login.card-plain .input-group-prepend .input-group-text,\n.login-page .card-login.card-plain .input-group-append .input-group-text {\n\tbackground-color: transparent;\n\tborder-color: rgba(255, 255, 255, 0.5);\n\tcolor: #ffffff;\n}\n.login-page\n\t.card-login.card-plain\n\t.input-group-focus\n\t.input-group-prepend\n\t.input-group-text,\n.login-page\n\t.card-login.card-plain\n\t.input-group-focus\n\t.input-group-append\n\t.input-group-text {\n\tbackground-color: transparent;\n\tborder-color: #ffffff;\n\tcolor: #ffffff;\n}\n.login-page .card-login.card-plain .form-group.no-border .form-control,\n.login-page .card-login.card-plain .input-group.no-border .form-control {\n\tbackground-color: rgba(255, 255, 255, 0.1);\n\tcolor: #ffffff;\n}\n.login-page .card-login.card-plain .form-group.no-border .form-control:focus,\n.login-page .card-login.card-plain .form-group.no-border .form-control:active,\n.login-page .card-login.card-plain .form-group.no-border .form-control:active,\n.login-page .card-login.card-plain .input-group.no-border .form-control:focus,\n.login-page .card-login.card-plain .input-group.no-border .form-control:active,\n.login-page .card-login.card-plain .input-group.no-border .form-control:active {\n\tbackground-color: rgba(255, 255, 255, 0.2);\n\tcolor: #ffffff;\n}\n.login-page\n\t.card-login.card-plain\n\t.form-group.no-border\n\t.form-control\n\t+ .input-group-prepend\n\t.input-group-text,\n.login-page\n\t.card-login.card-plain\n\t.form-group.no-border\n\t.form-control\n\t+ .input-group-append\n\t.input-group-text,\n.login-page\n\t.card-login.card-plain\n\t.input-group.no-border\n\t.form-control\n\t+ .input-group-prepend\n\t.input-group-text,\n.login-page\n\t.card-login.card-plain\n\t.input-group.no-border\n\t.form-control\n\t+ .input-group-append\n\t.input-group-text {\n\tbackground-color: rgba(255, 255, 255, 0.1);\n}\n.login-page\n\t.card-login.card-plain\n\t.form-group.no-border\n\t.form-control\n\t+ .input-group-prepend\n\t.input-group-text:focus,\n.login-page\n\t.card-login.card-plain\n\t.form-group.no-border\n\t.form-control\n\t+ .input-group-prepend\n\t.input-group-text:active,\n.login-page\n\t.card-login.card-plain\n\t.form-group.no-border\n\t.form-control\n\t+ .input-group-prepend\n\t.input-group-text:active,\n.login-page\n\t.card-login.card-plain\n\t.form-group.no-border\n\t.form-control\n\t+ .input-group-append\n\t.input-group-text:focus,\n.login-page\n\t.card-login.card-plain\n\t.form-group.no-border\n\t.form-control\n\t+ .input-group-append\n\t.input-group-text:active,\n.login-page\n\t.card-login.card-plain\n\t.form-group.no-border\n\t.form-control\n\t+ .input-group-append\n\t.input-group-text:active,\n.login-page\n\t.card-login.card-plain\n\t.input-group.no-border\n\t.form-control\n\t+ .input-group-prepend\n\t.input-group-text:focus,\n.login-page\n\t.card-login.card-plain\n\t.input-group.no-border\n\t.form-control\n\t+ .input-group-prepend\n\t.input-group-text:active,\n.login-page\n\t.card-login.card-plain\n\t.input-group.no-border\n\t.form-control\n\t+ .input-group-prepend\n\t.input-group-text:active,\n.login-page\n\t.card-login.card-plain\n\t.input-group.no-border\n\t.form-control\n\t+ .input-group-append\n\t.input-group-text:focus,\n.login-page\n\t.card-login.card-plain\n\t.input-group.no-border\n\t.form-control\n\t+ .input-group-append\n\t.input-group-text:active,\n.login-page\n\t.card-login.card-plain\n\t.input-group.no-border\n\t.form-control\n\t+ .input-group-append\n\t.input-group-text:active {\n\tbackground-color: rgba(255, 255, 255, 0.2);\n\tcolor: #ffffff;\n}\n.login-page\n\t.card-login.card-plain\n\t.form-group.no-border\n\t.form-control:focus\n\t+ .input-group-prepend\n\t.input-group-text,\n.login-page\n\t.card-login.card-plain\n\t.form-group.no-border\n\t.form-control:focus\n\t+ .input-group-append\n\t.input-group-text,\n.login-page\n\t.card-login.card-plain\n\t.input-group.no-border\n\t.form-control:focus\n\t+ .input-group-prepend\n\t.input-group-text,\n.login-page\n\t.card-login.card-plain\n\t.input-group.no-border\n\t.form-control:focus\n\t+ .input-group-append\n\t.input-group-text {\n\tbackground-color: rgba(255, 255, 255, 0.2);\n\tcolor: #ffffff;\n}\n.login-page\n\t.card-login.card-plain\n\t.form-group.no-border\n\t.input-group-prepend\n\t.input-group-text,\n.login-page\n\t.card-login.card-plain\n\t.form-group.no-border\n\t.input-group-append\n\t.input-group-text,\n.login-page\n\t.card-login.card-plain\n\t.input-group.no-border\n\t.input-group-prepend\n\t.input-group-text,\n.login-page\n\t.card-login.card-plain\n\t.input-group.no-border\n\t.input-group-append\n\t.input-group-text {\n\tbackground-color: rgba(255, 255, 255, 0.1);\n\tborder: none;\n\tcolor: #ffffff;\n}\n.login-page\n\t.card-login.card-plain\n\t.form-group.no-border.input-group-focus\n\t.input-group-prepend\n\t.input-group-text,\n.login-page\n\t.card-login.card-plain\n\t.form-group.no-border.input-group-focus\n\t.input-group-append\n\t.input-group-text,\n.login-page\n\t.card-login.card-plain\n\t.input-group.no-border.input-group-focus\n\t.input-group-prepend\n\t.input-group-text,\n.login-page\n\t.card-login.card-plain\n\t.input-group.no-border.input-group-focus\n\t.input-group-append\n\t.input-group-text {\n\tbackground-color: rgba(255, 255, 255, 0.2);\n\tcolor: #ffffff;\n}\n.login-page .card-login.card-plain .input-group-addon,\n.login-page .card-login.card-plain .form-group.no-border .input-group-addon,\n.login-page .card-login.card-plain .input-group.no-border .input-group-addon {\n\tcolor: rgba(255, 255, 255, 0.8);\n}\n.login-page .link {\n\tfont-size: 10px;\n\tcolor: #ffffff;\n\ttext-decoration: none;\n}\n\n.full-page {\n\talign-items: center;\n\tmin-height: 100vh;\n\tpadding: 100px 0 120px;\n}\n.full-page > .footer {\n\tposition: relative;\n\tz-index: 4;\n}\n.full-page .footer {\n\tposition: absolute;\n\twidth: 100%;\n\tbottom: 0;\n}\n.full-page .footer .container {\n\tcolor: #ffffff;\n}\n.full-page .full-page-background {\n\tposition: absolute;\n\tz-index: 1;\n\theight: 100%;\n\twidth: 100%;\n\tdisplay: block;\n\ttop: 0;\n\tleft: 0;\n\tbackground-size: cover;\n\tbackground-position: center center;\n}\n.full-page:after {\n\tposition: absolute;\n\tz-index: 1;\n\twidth: 100%;\n\theight: 100%;\n\tdisplay: block;\n\tleft: 0;\n\ttop: 0;\n\tcontent: \"\";\n\tbackground-color: rgba(0, 0, 0, 0.6);\n}\n.full-page .pricing-page .description {\n\tmargin-bottom: 65px;\n}\n.full-page .register-page > .container {\n\tmargin-top: 5vh;\n}\n.full-page .register-page .info-horizontal {\n\tpadding: 0px 0px 20px;\n}\n.full-page .register-page .info-horizontal {\n\ttext-align: left !important;\n}\n.full-page .register-page .info-horizontal .icon {\n\tmargin-top: 0;\n}\n.full-page .register-page .info-horizontal .icon > i {\n\tfont-size: 2em;\n}\n.full-page .register-page .info-horizontal .icon.icon-circle {\n\twidth: 65px;\n\theight: 65px;\n\tmax-width: 65px;\n\tmargin-top: 8px;\n}\n.full-page .register-page .info-horizontal .icon.icon-circle i {\n\tdisplay: table;\n\tmargin: 0 auto;\n\tline-height: 3.5;\n\tfont-size: 1.9em;\n}\n.full-page .register-page .info-horizontal .description {\n\toverflow: hidden;\n}\n\n.register-page .navbar .navbar-collapse .nav-item .nav-link,\n.login-page .navbar .navbar-collapse .nav-item .nav-link,\n.lock-page .navbar .navbar-collapse .nav-item .nav-link {\n\ttext-transform: capitalize;\n\tcolor: #ffffff !important;\n}\n.register-page .navbar .navbar-collapse .nav-item .nav-link i,\n.login-page .navbar .navbar-collapse .nav-item .nav-link i,\n.lock-page .navbar .navbar-collapse .nav-item .nav-link i {\n\tmargin-right: 4px;\n}\n.register-page .navbar.navbar-transparent,\n.login-page .navbar.navbar-transparent,\n.lock-page .navbar.navbar-transparent {\n\tborder-bottom: 1px solid transparent;\n\tmargin-top: 25px;\n}\n.register-page .navbar .navbar-brand,\n.login-page .navbar .navbar-brand,\n.lock-page .navbar .navbar-brand {\n\tcolor: #ffffff !important;\n}\n\n.register-page,\n.login-page,\n.lock-page {\n\twidth: 100%;\n}\n\n@media screen and (max-width: 991px) {\n\t.register-page\n\t\t.navbar.bg-white\n\t\t.navbar-toggler\n\t\t.navbar-toggler-bar.navbar-kebab,\n\t.login-page .navbar.bg-white .navbar-toggler .navbar-toggler-bar.navbar-kebab,\n\t.lock-page .navbar.bg-white .navbar-toggler .navbar-toggler-bar.navbar-kebab {\n\t\tbackground: #65adff !important;\n\t}\n\t.register-page\n\t\t.navbar.bg-white\n\t\t.navbar-collapse\n\t\t.navbar-nav\n\t\t.nav-item\n\t\t.nav-link,\n\t.login-page .navbar.bg-white .navbar-collapse .navbar-nav .nav-item .nav-link,\n\t.lock-page .navbar.bg-white .navbar-collapse .navbar-nav .nav-item .nav-link {\n\t\tcolor: #65adff !important;\n\t}\n\t.register-page .navbar.bg-white .navbar-brand,\n\t.login-page .navbar.bg-white .navbar-brand,\n\t.lock-page .navbar.bg-white .navbar-brand {\n\t\tcolor: #65adff !important;\n\t}\n\t.register-page .navbar.navbar-transparent .navbar-toggle,\n\t.login-page .navbar.navbar-transparent .navbar-toggle,\n\t.lock-page .navbar.navbar-transparent .navbar-toggle {\n\t\tdisplay: none;\n\t}\n\t.register-page\n\t\t.navbar.navbar-transparent\n\t\t.navbar-toggler\n\t\t.navbar-toggler-bar.navbar-kebab,\n\t.login-page\n\t\t.navbar.navbar-transparent\n\t\t.navbar-toggler\n\t\t.navbar-toggler-bar.navbar-kebab,\n\t.lock-page\n\t\t.navbar.navbar-transparent\n\t\t.navbar-toggler\n\t\t.navbar-toggler-bar.navbar-kebab {\n\t\tbackground: #ffffff !important;\n\t}\n}\n.btn-file {\n\tposition: relative;\n\toverflow: hidden;\n\tvertical-align: middle;\n}\n\n.btn-file > input {\n\tposition: absolute;\n\ttop: 0;\n\tright: 0;\n\twidth: 100%;\n\theight: 100%;\n\tmargin: 0;\n\tfont-size: 23px;\n\tcursor: pointer;\n\tfilter: alpha(opacity=0);\n\topacity: 0;\n\tdirection: ltr;\n}\n\n.fileinput {\n\tdisplay: inline-block;\n\tmargin-bottom: 9px;\n}\n.fileinput input[type=\"file\"] {\n\tdisplay: none;\n}\n\n.fileinput .form-control {\n\tdisplay: inline-block;\n\tpadding-top: 7px;\n\tpadding-bottom: 5px;\n\tmargin-bottom: 0;\n\tvertical-align: middle;\n\tcursor: text;\n}\n\n.fileinput .thumbnail {\n\tdisplay: inline-block;\n\tmargin-bottom: 10px;\n\toverflow: hidden;\n\ttext-align: center;\n\tvertical-align: middle;\n\tmax-width: 250px;\n\tbox-shadow: 0 2px 2px rgba(204, 197, 185, 0.5);\n}\n.fileinput .thumbnail.img-circle {\n\tborder-radius: 50%;\n\tmax-width: 100px;\n}\n\n.fileinput .thumbnail > img {\n\tmax-height: 100%;\n}\n\n.fileinput .btn {\n\tvertical-align: middle;\n}\n\n.fileinput-exists .fileinput-new,\n.fileinput-new .fileinput-exists {\n\tdisplay: none;\n}\n\n.fileinput-inline .fileinput-controls {\n\tdisplay: inline;\n}\n\n.fileinput-filename {\n\tdisplay: inline-block;\n\toverflow: hidden;\n\tvertical-align: middle;\n}\n\n.form-control .fileinput-filename {\n\tvertical-align: bottom;\n}\n\n.fileinput.input-group {\n\tdisplay: table;\n}\n\n.fileinput.input-group > * {\n\tposition: relative;\n\tz-index: 2;\n}\n\n.fileinput.input-group > .btn-file {\n\tz-index: 1;\n}\n\n.fileinput-new.input-group .btn-file,\n.fileinput-new .input-group .btn-file {\n\tborder-radius: 0 4px 4px 0;\n}\n\n.fileinput-new.input-group .btn-file.btn-xs,\n.fileinput-new .input-group .btn-file.btn-xs,\n.fileinput-new.input-group .btn-file.btn-sm,\n.fileinput-new .input-group .btn-file.btn-sm {\n\tborder-radius: 0 3px 3px 0;\n}\n\n.fileinput-new.input-group .btn-file.btn-lg,\n.fileinput-new .input-group .btn-file.btn-lg {\n\tborder-radius: 0 6px 6px 0;\n}\n\n.form-group.has-warning .fileinput .fileinput-preview {\n\tcolor: #ffc759;\n}\n\n.form-group.has-warning .fileinput .thumbnail {\n\tborder-color: #ffc759;\n}\n\n.form-group.has-error .fileinput .fileinput-preview {\n\tcolor: #c1292e;\n}\n\n.form-group.has-error .fileinput .thumbnail {\n\tborder-color: #c1292e;\n}\n\n.form-group.has-success .fileinput .fileinput-preview {\n\tcolor: #28a745;\n}\n\n.form-group.has-success .fileinput .thumbnail {\n\tborder-color: #28a745;\n}\n\n.input-group-addon:not(:first-child) {\n\tborder-left: 0;\n}\n\n.thumbnail {\n\tborder: 0 none;\n\tborder-radius: 3px;\n\tpadding: 0;\n}\n\n.picture-container {\n\tposition: relative;\n\tcursor: pointer;\n\ttext-align: center;\n}\n\n.picture {\n\twidth: 106px;\n\theight: 106px;\n\tbackground-color: #999999;\n\tborder: 1px solid #e3e3e3;\n\tcolor: #ffffff;\n\tborder-radius: 50%;\n\tmargin: 5px auto;\n\toverflow: hidden;\n\ttransition: all 0.2s;\n\t-webkit-transition: all 0.2s;\n}\n.picture:hover {\n\tborder-color: #2ca8ff;\n}\n\n.picture input[type=\"file\"] {\n\tcursor: pointer;\n\tdisplay: block;\n\theight: 100%;\n\tleft: 0;\n\topacity: 0 !important;\n\tposition: absolute;\n\ttop: 0;\n\twidth: 100%;\n}\n\n.picture-src {\n\twidth: 100%;\n}\n\n.fixed-plugin {\n\tposition: fixed;\n\tright: 0;\n\twidth: 64px;\n\tbackground: rgba(0, 0, 0, 0.3);\n\tz-index: 1031;\n\tborder-radius: 8px 0 0 8px;\n\ttext-align: center;\n\ttop: 120px;\n}\n.fixed-plugin li > a,\n.fixed-plugin .badge {\n\ttransition: all 0.34s;\n\t-webkit-transition: all 0.34s;\n\t-moz-transition: all 0.34s;\n}\n.fixed-plugin .fa-cog {\n\tcolor: #ffffff;\n\tpadding: 10px;\n\tborder-radius: 0 0 6px 6px;\n\twidth: auto;\n}\n.fixed-plugin .dropdown-menu {\n\tright: 80px;\n\tleft: auto !important;\n\ttop: -52px !important;\n\twidth: 290px;\n\tborder-radius: 10px;\n\tpadding: 0 10px;\n}\n.fixed-plugin .dropdown .dropdown-menu .nc-icon {\n\ttop: 2px;\n\tright: 10px;\n\tfont-size: 14px;\n}\n.fixed-plugin .dropdown-menu:after,\n.fixed-plugin .dropdown-menu:before {\n\tright: 10px;\n\tmargin-left: auto;\n\tleft: auto;\n}\n.fixed-plugin .fa-circle-thin {\n\tcolor: #ffffff;\n}\n.fixed-plugin .active .fa-circle-thin {\n\tcolor: #00bbff;\n}\n.fixed-plugin .dropdown-menu > .active > a,\n.fixed-plugin .dropdown-menu > .active > a:hover,\n.fixed-plugin .dropdown-menu > .active > a:focus {\n\tcolor: #777777;\n\ttext-align: center;\n}\n.fixed-plugin img {\n\tborder-radius: 0;\n\twidth: 100%;\n\theight: 100px;\n\tmargin: 0 auto;\n}\n.fixed-plugin .dropdown-menu li > a:hover,\n.fixed-plugin .dropdown-menu li > a:focus {\n\tbox-shadow: none;\n}\n.fixed-plugin .badge {\n\tborder: 3px solid #ffffff;\n\tborder-radius: 50%;\n\tcursor: pointer;\n\tdisplay: inline-block;\n\theight: 23px;\n\tmargin-right: 5px;\n\tposition: relative;\n\twidth: 23px;\n}\n.fixed-plugin .badge.badge-light {\n\tborder-color: #f5f5f5;\n\tbackground-color: #f5f5f5;\n\tborder: 3px solid #ffffff;\n}\n.fixed-plugin .badge.badge-dark {\n\tborder-color: #2c2c2c;\n\tbackground-color: #2c2c2c;\n\tborder: 3px solid #ffffff;\n}\n.fixed-plugin .badge.active,\n.fixed-plugin .badge:hover {\n\tborder-color: #00bbff;\n}\n.fixed-plugin .badge-blue {\n\tbackground-color: #39a9db;\n}\n.fixed-plugin .badge-green {\n\tbackground-color: #28a745;\n}\n.fixed-plugin .badge-orange {\n\tbackground-color: #1c77c3;\n}\n.fixed-plugin .badge-yellow {\n\tbackground-color: #ffc759;\n}\n.fixed-plugin .badge-red {\n\tbackground-color: #c1292e;\n}\n.fixed-plugin h5 {\n\tfont-size: 14px;\n\tmargin: 10px;\n}\n.fixed-plugin .dropdown-menu li {\n\tdisplay: block;\n\tpadding: 15px 2px;\n\twidth: 25%;\n\tfloat: left;\n}\n.fixed-plugin li.adjustments-line,\n.fixed-plugin li.header-title,\n.fixed-plugin li.button-container {\n\twidth: 100%;\n\theight: 35px;\n\tmin-height: inherit;\n}\n.fixed-plugin li.button-container {\n\theight: auto;\n}\n.fixed-plugin li.button-container div {\n\tmargin-bottom: 5px;\n}\n.fixed-plugin #sharrreTitle {\n\ttext-align: center;\n\tpadding: 10px 0;\n\theight: 50px;\n}\n.fixed-plugin li.header-title {\n\theight: 30px;\n\tline-height: 25px;\n\tfont-size: 12px;\n\tfont-weight: 600;\n\ttext-align: center;\n\ttext-transform: uppercase;\n}\n.fixed-plugin .adjustments-line p {\n\tdisplay: inline-block;\n\tmargin-bottom: 0;\n\tfont-size: 1em;\n\tcolor: #3c4858;\n}\n.fixed-plugin .adjustments-line a {\n\tcolor: transparent;\n}\n.fixed-plugin .adjustments-line a .badge-colors {\n\tposition: relative;\n\ttop: -2px;\n}\n.fixed-plugin .adjustments-line a a:hover,\n.fixed-plugin .adjustments-line a a:focus {\n\tcolor: transparent;\n}\n.fixed-plugin .adjustments-line .togglebutton {\n\ttext-align: center;\n}\n.fixed-plugin .adjustments-line .togglebutton .label-switch {\n\tposition: relative;\n\tleft: -10px;\n\tfont-size: 0.7142em;\n\tcolor: #65adff;\n}\n.fixed-plugin .adjustments-line .togglebutton .label-switch.label-right {\n\tleft: 10px;\n}\n.fixed-plugin .adjustments-line .togglebutton .toggle {\n\tmargin-right: 0;\n}\n.fixed-plugin .adjustments-line .dropdown-menu > li.adjustments-line > a {\n\tpadding-right: 0;\n\tpadding-left: 0;\n\tborder-bottom: 1px solid #ddd;\n\tborder-radius: 0;\n\tmargin: 0;\n}\n.fixed-plugin .dropdown-menu > li > a.img-holder {\n\tfont-size: 16px;\n\ttext-align: center;\n\tborder-radius: 10px;\n\tbackground-color: #fff;\n\tborder: 3px solid #fff;\n\tpadding-left: 0;\n\tpadding-right: 0;\n\topacity: 1;\n\tcursor: pointer;\n\tdisplay: block;\n\tmax-height: 100px;\n\toverflow: hidden;\n\tpadding: 0;\n}\n.fixed-plugin .dropdown-menu > li > a.img-holder img {\n\tmargin-top: auto;\n}\n.fixed-plugin .dropdown-menu > li a.switch-trigger:hover,\n.fixed-plugin .dropdown-menu > li > a.switch-trigger:focus {\n\tbackground-color: transparent;\n}\n.fixed-plugin .dropdown-menu > li:hover > a.img-holder,\n.fixed-plugin .dropdown-menu > li:focus > a.img-holder {\n\tborder-color: rgba(0, 187, 255, 0.53);\n}\n.fixed-plugin .dropdown-menu > .active > a.img-holder,\n.fixed-plugin .dropdown-menu > .active > a.img-holder {\n\tborder-color: #00bbff;\n\tbackground-color: #ffffff;\n}\n.fixed-plugin .btn-social {\n\twidth: 50%;\n\tdisplay: block;\n\twidth: 48%;\n\tfloat: left;\n\tfont-weight: 600;\n}\n.fixed-plugin .btn-social i {\n\tmargin-right: 5px;\n}\n.fixed-plugin .btn-social:first-child {\n\tmargin-right: 2%;\n}\n.fixed-plugin .dropdown .dropdown-menu {\n\ttransform-origin: 0 0;\n}\n.fixed-plugin .dropdown .dropdown-menu:before {\n\tborder-bottom: 16px solid rgba(0, 0, 0, 0);\n\tborder-left: 16px solid rgba(0, 0, 0, 0.2);\n\tborder-top: 16px solid rgba(0, 0, 0, 0);\n\tright: -27px;\n\tbottom: 425px;\n}\n.fixed-plugin .dropdown .dropdown-menu:after {\n\tborder-bottom: 16px solid rgba(0, 0, 0, 0);\n\tborder-left: 16px solid #ffffff;\n\tborder-top: 16px solid rgba(0, 0, 0, 0);\n\tright: -26px;\n\tbottom: 425px;\n}\n.fixed-plugin .dropdown .dropdown-menu:before,\n.fixed-plugin .dropdown .dropdown-menu:after {\n\tcontent: \"\";\n\tdisplay: inline-block;\n\tposition: absolute;\n\twidth: 16px;\n\ttransform: translateY(-50px);\n\t-webkit-transform: translateY(-50px);\n\t-moz-transform: translateY(-50px);\n}\n.fixed-plugin .dropdown.show-dropdown .show .dropdown-menu .show {\n\ttransform: translate3d(0, -60px, 0) !important;\n\tbottom: auto !important;\n\ttop: 0 !important;\n}\n.fixed-plugin .bootstrap-switch {\n\tmargin: 0;\n}\n\n.fixed-plugin .show-dropdown .dropdown-menu[x-placement=\"bottom-start\"] {\n\t-webkit-transform: translate3d(0, -100px, 0) !important;\n\t-moz-transform: translate3d(0, -100px, 0) !important;\n\t-o-transform: translate3d(0, -100px, 0) !important;\n\t-ms-transform: translate3d(0, -100px, 0) !important;\n\ttransform: translate3d(0, -100px, 0) !important;\n}\n.fixed-plugin .show-dropdown .dropdown-menu[x-placement=\"bottom-start\"]:before,\n.fixed-plugin .show-dropdown .dropdown-menu[x-placement=\"bottom-start\"]:after {\n\ttop: 100px;\n}\n.fixed-plugin .show-dropdown .dropdown-menu[x-placement=\"top-start\"] {\n\t-webkit-transform: translate3d(0, 100px, 0) !important;\n\t-moz-transform: translate3d(0, 100px, 0) !important;\n\t-o-transform: translate3d(0, 100px, 0) !important;\n\t-ms-transform: translate3d(0, 100px, 0) !important;\n\ttransform: translate3d(0, 100px, 0) !important;\n}\n.fixed-plugin\n\t.show-dropdown.show\n\t.dropdown-menu.show[x-placement=\"bottom-start\"] {\n\t-webkit-transform: translate3d(0, -60px, 0) !important;\n\t-moz-transform: translate3d(0, -60px, 0) !important;\n\t-o-transform: translate3d(0, -60px, 0) !important;\n\t-ms-transform: translate3d(0, -60px, 0) !important;\n\ttransform: translate3d(0, -60px, 0) !important;\n}\n.fixed-plugin .show-dropdown.show .dropdown-menu.show[x-placement=\"top-start\"] {\n\t-webkit-transform: translate3d(0, 470px, 0) !important;\n\t-moz-transform: translate3d(0, 470px, 0) !important;\n\t-o-transform: translate3d(0, 470px, 0) !important;\n\t-ms-transform: translate3d(0, 470px, 0) !important;\n\ttransform: translate3d(0, 470px, 0) !important;\n}\n\n.form-group input[type=\"file\"] {\n\topacity: 1;\n\tposition: unset;\n\ttop: 0;\n\tright: 0;\n\tbottom: 0;\n\tleft: 0;\n\twidth: 100%;\n\tz-index: unset;\n}\n\n.modal-footer .left-side,\n.modal-footer .right-side {\n\tdisplay: flex;\n\tflex: 1;\n\ttext-align: center;\n\twidth: unset;\n\tpadding: 5px;\n}\n\n.navbar .navbar-nav .nav-link i.fa + p,\n.navbar .navbar-nav .nav-link i.nc-icon + p {\n\tmargin-left: 7px;\n}\n\n/*--------------------------------\n\nnucleo-icons Web Font - built using nucleoapp.com\nLicense - nucleoapp.com/license/\n\n-------------------------------- */\n@font-face {\n\tfont-family: \"nucleo-icons\";\n\tsrc: url(\"~assets/fonts/nucleo-icons.eot\");\n\tsrc: url(\"~assets/fonts/nucleo-icons.eot\") format(\"embedded-opentype\"),\n\t\turl(\"~assets/fonts/nucleo-icons.woff2\") format(\"woff2\"),\n\t\turl(\"~assets/fonts/nucleo-icons.woff\") format(\"woff\"),\n\t\turl(\"~assets/fonts/nucleo-icons.ttf\") format(\"truetype\");\n\tfont-weight: normal;\n\tfont-style: normal;\n}\n/* all icon font classes list here */\n/*             Navigation Pills               */\n.nav-pills .nav-item + .nav-link {\n\tmargin-left: 0;\n}\n.nav-pills .nav-item.active .nav-link,\n.nav-pills .nav-item.active .nav-link:hover,\n.nav-pills .nav-item.active .nav-link:focus {\n\tbackground-color: #65adff;\n\tcolor: #ffffff;\n}\n.nav-pills.flex-column .nav-item .nav-link {\n\tborder-radius: 30px !important;\n\tmargin-bottom: 15px;\n}\n.nav-pills .nav-item .nav-link.active {\n\tbackground-color: #65adff;\n\tcolor: #ffffff;\n}\n\n.nav-pills-primary .nav-item .nav-link {\n\tborder: 1px solid #1c77c3;\n\tcolor: #1c77c3;\n}\n.nav-pills-primary .nav-item .nav-link.active {\n\tborder: 1px solid #1c77c3;\n\tbackground: #1c77c3;\n\tcolor: #ffffff;\n}\n\n.nav-pills-danger .nav-item .nav-link {\n\tborder: 1px solid #c1292e;\n\tcolor: #c1292e;\n}\n.nav-pills-danger .nav-item .nav-link.active {\n\tborder: 1px solid #c1292e;\n\tbackground: #c1292e;\n\tcolor: #ffffff;\n}\n\n.nav-pills-info .nav-item .nav-link {\n\tborder: 1px solid #39a9db;\n\tcolor: #39a9db;\n}\n.nav-pills-info .nav-item .nav-link.active {\n\tborder: 1px solid #39a9db;\n\tbackground: #39a9db;\n\tcolor: #ffffff;\n}\n\n.nav-pills-success .nav-item .nav-link {\n\tborder: 1px solid #28a745;\n\tcolor: #28a745;\n}\n.nav-pills-success .nav-item .nav-link.active {\n\tborder: 1px solid #28a745;\n\tbackground: #28a745;\n\tcolor: #ffffff;\n}\n\n.nav-pills-warning .nav-item .nav-link {\n\tborder: 1px solid #ffc759;\n\tcolor: #ffc759;\n}\n.nav-pills-warning .nav-item .nav-link.active {\n\tborder: 1px solid #ffc759;\n\tbackground: #ffc759;\n\tcolor: #ffffff;\n}\n\n.page-item:first-child .page-link,\n.page-item:last-child .page-link {\n\tborder-bottom-left-radius: 20px;\n\tborder-top-left-radius: 20px;\n\tborder-bottom-right-radius: 20px;\n\tborder-top-right-radius: 20px;\n}\n\n.nav-pills-default .nav-item.show .nav-link,\n.nav-pills-default .nav-link.active {\n\tbackground-color: #65adff !important;\n}\n\n.nav-pills-primary .nav-item.show .nav-link,\n.nav-pills-primary .nav-link.active {\n\tbackground-color: #1c77c3 !important;\n}\n\n.nav-pills-info .nav-item.show .nav-link,\n.nav-pills-info .nav-link.active {\n\tbackground-color: #39a9db !important;\n}\n\n.nav-pills-warning .nav-item.show .nav-link,\n.nav-pills-warning .nav-link.active {\n\tbackground-color: #ffc759 !important;\n}\n\n.nav-pills-success .nav-item.show .nav-link,\n.nav-pills-success .nav-link.active {\n\tbackground-color: #28a745 !important;\n}\n\n.nav-pills-danger .nav-item.show .nav-link,\n.nav-pills-danger .nav-link.active {\n\tbackground-color: #c1292e !important;\n}\n\n@media screen and (max-width: 991px) {\n\t.navbar {\n\t\tpadding: 0;\n\t}\n\t.navbar.navbar-absolute {\n\t\tpadding-top: 0;\n\t}\n\t.navbar .navbar-brand {\n\t\tfont-size: 16px;\n\t\tmargin-right: 0;\n\t}\n\n\t.profile-photo .profile-photo-small {\n\t\tmargin-left: -2px;\n\t}\n\n\t.button-dropdown {\n\t\tdisplay: none;\n\t}\n\n\t#minimizeSidebar {\n\t\tdisplay: none;\n\t}\n\n\t.navbar .container-fluid {\n\t\tpadding-right: 15px;\n\t\tpadding-left: 15px;\n\t}\n\t.navbar .navbar-collapse .input-group {\n\t\tmargin: 0;\n\t\tmargin-top: 5px;\n\t}\n\t.navbar .navbar-nav .nav-item:first-child {\n\t\tmargin-top: 10px;\n\t}\n\t.navbar .navbar-nav .nav-item:not(:last-child) {\n\t\tmargin-bottom: 10px;\n\t}\n\t.navbar .dropdown.show .dropdown-menu {\n\t\tdisplay: block !important;\n\t\ttransform: translate3d(0px, 0px, 0px) !important;\n\t}\n\t.navbar .dropdown .dropdown-menu {\n\t\tdisplay: none;\n\t}\n\t.navbar .dropdown.show .dropdown-menu,\n\t.navbar .dropdown .dropdown-menu {\n\t\tborder: 0;\n\t\ttransition: none;\n\t\t-webkit-box-shadow: none;\n\t\twidth: auto;\n\t\tmargin: 0px 1rem;\n\t\tmargin-top: 0px;\n\t\tbox-shadow: none;\n\t\tposition: static !important;\n\t\tpadding-left: 10px;\n\t}\n\t.navbar .dropdown.show .dropdown-menu:before,\n\t.navbar .dropdown .dropdown-menu:before {\n\t\tdisplay: none;\n\t}\n\t.navbar .dropdown-menu .dropdown-item:focus,\n\t.navbar .dropdown-menu .dropdown-item:hover {\n\t\tcolor: #ffffff;\n\t}\n\t.navbar.bg-white .dropdown-menu .dropdown-item:focus,\n\t.navbar.bg-white .dropdown-menu .dropdown-item:hover {\n\t\tcolor: #65adff;\n\t}\n\t.navbar .navbar-toggler-bar {\n\t\tdisplay: block;\n\t\tposition: relative;\n\t\twidth: 22px;\n\t\theight: 1px;\n\t\tborder-radius: 1px;\n\t\tbackground: #65adff;\n\t}\n\t.navbar .navbar-toggler-bar + .navbar-toggler-bar {\n\t\tmargin-top: 7px;\n\t}\n\t.navbar .navbar-toggler-bar + .navbar-toggler-bar.navbar-kebab {\n\t\tmargin-top: 3px;\n\t}\n\t.navbar .navbar-toggler-bar.bar2 {\n\t\twidth: 17px;\n\t\ttransition: width 0.2s linear;\n\t}\n\t.navbar.bg-white:not(.navbar-transparent) .navbar-toggler-bar {\n\t\tbackground-color: #65adff;\n\t}\n\t.navbar .toggled .navbar-toggler-bar {\n\t\twidth: 24px;\n\t}\n\t.navbar .toggled .navbar-toggler-bar + .navbar-toggler-bar {\n\t\tmargin-top: 5px;\n\t}\n\n\t.wrapper {\n\t\t-webkit-transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);\n\t\t-moz-transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);\n\t\t-o-transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);\n\t\t-ms-transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);\n\t\ttransition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);\n\t}\n\n\t.nav-open .main-panel {\n\t\tright: 0;\n\t\t-webkit-transform: translate3d(260px, 0, 0);\n\t\t-moz-transform: translate3d(260px, 0, 0);\n\t\t-o-transform: translate3d(260px, 0, 0);\n\t\t-ms-transform: translate3d(260px, 0, 0);\n\t\ttransform: translate3d(260px, 0, 0);\n\t}\n\t.nav-open .sidebar {\n\t\t-webkit-transform: translate3d(0px, 0, 0);\n\t\t-moz-transform: translate3d(0px, 0, 0);\n\t\t-o-transform: translate3d(0px, 0, 0);\n\t\t-ms-transform: translate3d(0px, 0, 0);\n\t\ttransform: translate3d(0px, 0, 0);\n\t}\n\t.nav-open body {\n\t\tposition: relative;\n\t\toverflow-x: hidden;\n\t}\n\t.nav-open .menu-on-right .main-panel {\n\t\t-webkit-transform: translate3d(-260px, 0, 0);\n\t\t-moz-transform: translate3d(-260px, 0, 0);\n\t\t-o-transform: translate3d(-260px, 0, 0);\n\t\t-ms-transform: translate3d(-260px, 0, 0);\n\t\ttransform: translate3d(-260px, 0, 0);\n\t}\n\t.nav-open .menu-on-right .navbar-collapse,\n\t.nav-open .menu-on-right .sidebar {\n\t\t-webkit-transform: translate3d(0px, 0, 0);\n\t\t-moz-transform: translate3d(0px, 0, 0);\n\t\t-o-transform: translate3d(0px, 0, 0);\n\t\t-ms-transform: translate3d(0px, 0, 0);\n\t\ttransform: translate3d(0px, 0, 0);\n\t}\n\t.nav-open .menu-on-right .navbar-translate {\n\t\t-webkit-transform: translate3d(-300px, 0, 0);\n\t\t-moz-transform: translate3d(-300px, 0, 0);\n\t\t-o-transform: translate3d(-300px, 0, 0);\n\t\t-ms-transform: translate3d(-300px, 0, 0);\n\t\ttransform: translate3d(-300px, 0, 0);\n\t}\n\t.nav-open .menu-on-right #bodyClick {\n\t\tleft: auto;\n\t}\n\n\t.menu-on-right .sidebar {\n\t\tleft: auto;\n\t\tright: 0;\n\t\t-webkit-transform: translate3d(260px, 0, 0);\n\t\t-moz-transform: translate3d(260px, 0, 0);\n\t\t-o-transform: translate3d(260px, 0, 0);\n\t\t-ms-transform: translate3d(260px, 0, 0);\n\t\ttransform: translate3d(260px, 0, 0);\n\t}\n\n\t.bar1,\n\t.bar2,\n\t.bar3 {\n\t\toutline: 1px solid transparent;\n\t}\n\n\t.bar1 {\n\t\ttop: 0px;\n\t\t-webkit-animation: topbar-back 500ms linear 0s;\n\t\t-moz-animation: topbar-back 500ms linear 0s;\n\t\tanimation: topbar-back 500ms 0s;\n\t\t-webkit-animation-fill-mode: forwards;\n\t\t-moz-animation-fill-mode: forwards;\n\t\tanimation-fill-mode: forwards;\n\t}\n\n\t.bar2 {\n\t\topacity: 1;\n\t}\n\n\t.bar3 {\n\t\tbottom: 0px;\n\t\t-webkit-animation: bottombar-back 500ms linear 0s;\n\t\t-moz-animation: bottombar-back 500ms linear 0s;\n\t\tanimation: bottombar-back 500ms 0s;\n\t\t-webkit-animation-fill-mode: forwards;\n\t\t-moz-animation-fill-mode: forwards;\n\t\tanimation-fill-mode: forwards;\n\t}\n\n\t.toggled .bar1 {\n\t\ttop: 6px;\n\t\t-webkit-animation: topbar-x 500ms linear 0s;\n\t\t-moz-animation: topbar-x 500ms linear 0s;\n\t\tanimation: topbar-x 500ms 0s;\n\t\t-webkit-animation-fill-mode: forwards;\n\t\t-moz-animation-fill-mode: forwards;\n\t\tanimation-fill-mode: forwards;\n\t}\n\n\t.toggled .bar2 {\n\t\topacity: 0;\n\t}\n\n\t.toggled .bar3 {\n\t\tbottom: 6px;\n\t\t-webkit-animation: bottombar-x 500ms linear 0s;\n\t\t-moz-animation: bottombar-x 500ms linear 0s;\n\t\tanimation: bottombar-x 500ms 0s;\n\t\t-webkit-animation-fill-mode: forwards;\n\t\t-moz-animation-fill-mode: forwards;\n\t\tanimation-fill-mode: forwards;\n\t}\n\n\t@keyframes topbar-x {\n\t\t0% {\n\t\t\ttop: 0px;\n\t\t\ttransform: rotate(0deg);\n\t\t}\n\t\t45% {\n\t\t\ttop: 6px;\n\t\t\ttransform: rotate(145deg);\n\t\t}\n\t\t75% {\n\t\t\ttransform: rotate(130deg);\n\t\t}\n\t\t100% {\n\t\t\ttransform: rotate(135deg);\n\t\t}\n\t}\n\t@-webkit-keyframes topbar-x {\n\t\t0% {\n\t\t\ttop: 0px;\n\t\t\t-webkit-transform: rotate(0deg);\n\t\t}\n\t\t45% {\n\t\t\ttop: 6px;\n\t\t\t-webkit-transform: rotate(145deg);\n\t\t}\n\t\t75% {\n\t\t\t-webkit-transform: rotate(130deg);\n\t\t}\n\t\t100% {\n\t\t\t-webkit-transform: rotate(135deg);\n\t\t}\n\t}\n\t@-moz-keyframes topbar-x {\n\t\t0% {\n\t\t\ttop: 0px;\n\t\t\t-moz-transform: rotate(0deg);\n\t\t}\n\t\t45% {\n\t\t\ttop: 6px;\n\t\t\t-moz-transform: rotate(145deg);\n\t\t}\n\t\t75% {\n\t\t\t-moz-transform: rotate(130deg);\n\t\t}\n\t\t100% {\n\t\t\t-moz-transform: rotate(135deg);\n\t\t}\n\t}\n\t@keyframes topbar-back {\n\t\t0% {\n\t\t\ttop: 6px;\n\t\t\ttransform: rotate(135deg);\n\t\t}\n\t\t45% {\n\t\t\ttransform: rotate(-10deg);\n\t\t}\n\t\t75% {\n\t\t\ttransform: rotate(5deg);\n\t\t}\n\t\t100% {\n\t\t\ttop: 0px;\n\t\t\ttransform: rotate(0);\n\t\t}\n\t}\n\t@-webkit-keyframes topbar-back {\n\t\t0% {\n\t\t\ttop: 6px;\n\t\t\t-webkit-transform: rotate(135deg);\n\t\t}\n\t\t45% {\n\t\t\t-webkit-transform: rotate(-10deg);\n\t\t}\n\t\t75% {\n\t\t\t-webkit-transform: rotate(5deg);\n\t\t}\n\t\t100% {\n\t\t\ttop: 0px;\n\t\t\t-webkit-transform: rotate(0);\n\t\t}\n\t}\n\t@-moz-keyframes topbar-back {\n\t\t0% {\n\t\t\ttop: 6px;\n\t\t\t-moz-transform: rotate(135deg);\n\t\t}\n\t\t45% {\n\t\t\t-moz-transform: rotate(-10deg);\n\t\t}\n\t\t75% {\n\t\t\t-moz-transform: rotate(5deg);\n\t\t}\n\t\t100% {\n\t\t\ttop: 0px;\n\t\t\t-moz-transform: rotate(0);\n\t\t}\n\t}\n\t@keyframes bottombar-x {\n\t\t0% {\n\t\t\tbottom: 0px;\n\t\t\ttransform: rotate(0deg);\n\t\t}\n\t\t45% {\n\t\t\tbottom: 6px;\n\t\t\ttransform: rotate(-145deg);\n\t\t}\n\t\t75% {\n\t\t\ttransform: rotate(-130deg);\n\t\t}\n\t\t100% {\n\t\t\ttransform: rotate(-135deg);\n\t\t}\n\t}\n\t@-webkit-keyframes bottombar-x {\n\t\t0% {\n\t\t\tbottom: 0px;\n\t\t\t-webkit-transform: rotate(0deg);\n\t\t}\n\t\t45% {\n\t\t\tbottom: 6px;\n\t\t\t-webkit-transform: rotate(-145deg);\n\t\t}\n\t\t75% {\n\t\t\t-webkit-transform: rotate(-130deg);\n\t\t}\n\t\t100% {\n\t\t\t-webkit-transform: rotate(-135deg);\n\t\t}\n\t}\n\t@-moz-keyframes bottombar-x {\n\t\t0% {\n\t\t\tbottom: 0px;\n\t\t\t-moz-transform: rotate(0deg);\n\t\t}\n\t\t45% {\n\t\t\tbottom: 6px;\n\t\t\t-moz-transform: rotate(-145deg);\n\t\t}\n\t\t75% {\n\t\t\t-moz-transform: rotate(-130deg);\n\t\t}\n\t\t100% {\n\t\t\t-moz-transform: rotate(-135deg);\n\t\t}\n\t}\n\t@keyframes bottombar-back {\n\t\t0% {\n\t\t\tbottom: 6px;\n\t\t\ttransform: rotate(-135deg);\n\t\t}\n\t\t45% {\n\t\t\ttransform: rotate(10deg);\n\t\t}\n\t\t75% {\n\t\t\ttransform: rotate(-5deg);\n\t\t}\n\t\t100% {\n\t\t\tbottom: 0px;\n\t\t\ttransform: rotate(0);\n\t\t}\n\t}\n\t@-webkit-keyframes bottombar-back {\n\t\t0% {\n\t\t\tbottom: 6px;\n\t\t\t-webkit-transform: rotate(-135deg);\n\t\t}\n\t\t45% {\n\t\t\t-webkit-transform: rotate(10deg);\n\t\t}\n\t\t75% {\n\t\t\t-webkit-transform: rotate(-5deg);\n\t\t}\n\t\t100% {\n\t\t\tbottom: 0px;\n\t\t\t-webkit-transform: rotate(0);\n\t\t}\n\t}\n\t@-moz-keyframes bottombar-back {\n\t\t0% {\n\t\t\tbottom: 6px;\n\t\t\t-moz-transform: rotate(-135deg);\n\t\t}\n\t\t45% {\n\t\t\t-moz-transform: rotate(10deg);\n\t\t}\n\t\t75% {\n\t\t\t-moz-transform: rotate(-5deg);\n\t\t}\n\t\t100% {\n\t\t\tbottom: 0px;\n\t\t\t-moz-transform: rotate(0);\n\t\t}\n\t}\n\t@-webkit-keyframes fadeIn {\n\t\t0% {\n\t\t\topacity: 0;\n\t\t}\n\t\t100% {\n\t\t\topacity: 1;\n\t\t}\n\t}\n\t@-moz-keyframes fadeIn {\n\t\t0% {\n\t\t\topacity: 0;\n\t\t}\n\t\t100% {\n\t\t\topacity: 1;\n\t\t}\n\t}\n\t@keyframes fadeIn {\n\t\t0% {\n\t\t\topacity: 0;\n\t\t}\n\t\t100% {\n\t\t\topacity: 1;\n\t\t}\n\t}\n\t#bodyClick {\n\t\theight: 100%;\n\t\twidth: 100%;\n\t\tposition: fixed;\n\t\topacity: 1;\n\t\ttop: 0;\n\t\tright: 0;\n\t\tcontent: \"\";\n\t\tz-index: 9999;\n\t\toverflow-x: hidden;\n\t\tbackground-color: transparent;\n\t\t-webkit-transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);\n\t\t-moz-transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);\n\t\t-o-transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);\n\t\t-ms-transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);\n\t\ttransition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);\n\t}\n\n\t.footer .copyright {\n\t\ttext-align: right;\n\t}\n\n\t.section-nucleo-icons .icons-container {\n\t\tmargin-top: 65px;\n\t}\n\n\t.navbar-nav .nav-link i.fa,\n\t.navbar-nav .nav-link i.nc-icon {\n\t\topacity: 0.5;\n\t}\n\n\t.sidebar,\n\t.bootstrap-navbar {\n\t\tposition: fixed;\n\t\tdisplay: block;\n\t\ttop: 0;\n\t\theight: 100%;\n\t\twidth: 260px;\n\t\tright: auto;\n\t\tleft: 0;\n\t\tz-index: 1032;\n\t\tvisibility: visible;\n\t\toverflow-y: visible;\n\t\tpadding: 0;\n\t\t-webkit-transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);\n\t\t-moz-transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);\n\t\t-o-transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);\n\t\t-ms-transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);\n\t\ttransition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);\n\t\t-webkit-transform: translate3d(-260px, 0, 0);\n\t\t-moz-transform: translate3d(-260px, 0, 0);\n\t\t-o-transform: translate3d(-260px, 0, 0);\n\t\t-ms-transform: translate3d(-260px, 0, 0);\n\t\ttransform: translate3d(-260px, 0, 0);\n\t}\n\n\t.main-panel {\n\t\twidth: 100%;\n\t}\n\n\t.timeline:before {\n\t\tleft: 5% !important;\n\t}\n\t.timeline > li > .timeline-badge {\n\t\tleft: 5% !important;\n\t}\n\t.timeline > li > .timeline-panel {\n\t\tfloat: right !important;\n\t\twidth: 82% !important;\n\t}\n\t.timeline > li > .timeline-panel:before {\n\t\tborder-left-width: 0 !important;\n\t\tborder-right-width: 15px !important;\n\t\tleft: -15px !important;\n\t\tright: auto !important;\n\t}\n\t.timeline > li > .timeline-panel:after {\n\t\tborder-left-width: 0 !important;\n\t\tborder-right-width: 14px !important;\n\t\tleft: -14px !important;\n\t\tright: auto !important;\n\t}\n\n\t.fixed-plugin {\n\t\twidth: 54px;\n\t}\n\t.fixed-plugin .dropdown-menu {\n\t\tmax-width: 230px;\n\t\tright: 80px;\n\t}\n}\n@media (max-width: 991px) and (min-width: 768px) {\n\t.nav-tabs-navigation.verical-navs {\n\t\tpadding: 0px 2px;\n\t}\n}\n@media screen and (min-width: 768px) {\n\t.footer .footer-nav {\n\t\tpadding-left: 21px;\n\t}\n\t.footer .credits {\n\t\tpadding-right: 15px;\n\t}\n}\n@media screen and (min-width: 992px) {\n\t.navbar-collapse {\n\t\tbackground: none !important;\n\t}\n\n\t.navbar .navbar-toggle {\n\t\tdisplay: none;\n\t}\n\n\t.navbar-nav .nav-link.profile-photo {\n\t\tpadding: 0;\n\t\tmargin: 7px 0.7rem;\n\t}\n\n\t.section-nucleo-icons .icons-container {\n\t\tmargin: 0 0 0 auto;\n\t}\n\n\t.dropdown-menu .dropdown-item {\n\t\tcolor: inherit;\n\t}\n\n\t.footer .copyright {\n\t\tfloat: right;\n\t\tpadding-right: 15px;\n\t}\n\n\t.sidebar\n\t\t.sidebar-wrapper\n\t\tli\n\t\t> [data-toggle=\"collapse\"]\n\t\t+ div\n\t\t.nav\n\t\tli.active\n\t\ta:before {\n\t\ttop: -2px;\n\t}\n\t.sidebar\n\t\t.sidebar-wrapper\n\t\tli\n\t\t> [data-toggle=\"collapse\"]\n\t\t+ div\n\t\t.nav\n\t\tli.active\n\t\ta:after {\n\t\ttop: -1px;\n\t}\n\t.sidebar\n\t\t.sidebar-wrapper\n\t\tli.active\n\t\t> [data-toggle=\"collapse\"]\n\t\t+ div\n\t\t.nav\n\t\tli:before,\n\t.sidebar\n\t\t.sidebar-wrapper\n\t\tli.active\n\t\t> [data-toggle=\"collapse\"]\n\t\t+ div\n\t\t.nav\n\t\tli:after {\n\t\tdisplay: none !important;\n\t}\n\t.sidebar .sidebar-wrapper li.active > a:not([data-toggle=\"collapse\"]):before {\n\t\tborder-right: 18px solid #dddddd;\n\t\tborder-top: 18px solid transparent;\n\t\tborder-bottom: 18px solid transparent;\n\t\tcontent: \"\";\n\t\tdisplay: inline-block;\n\t\tposition: absolute;\n\t\tright: -15px;\n\t\topacity: 1;\n\t\ttop: 6px;\n\t\ttransition: opacity 150ms ease-in;\n\t}\n\t.sidebar .sidebar-wrapper li.active > a:not([data-toggle=\"collapse\"]):after {\n\t\tborder-right: 17px solid #f4f3ef;\n\t\tborder-top: 17px solid transparent;\n\t\tborder-bottom: 17px solid transparent;\n\t\tcontent: \"\";\n\t\tdisplay: inline-block;\n\t\tposition: absolute;\n\t\tright: -15px;\n\t\topacity: 1;\n\t\ttop: 7px;\n\t\ttransition: opacity 150ms ease-in;\n\t}\n}\n@media screen and (max-width: 768px) {\n\t.card-stats [class*=\"col-\"] .statistics::after {\n\t\tdisplay: none;\n\t}\n\n\t.main-panel .content {\n\t\tpadding-left: 15px;\n\t\tpadding-right: 15px;\n\t}\n\n\t.footer nav {\n\t\tdisplay: block;\n\t\tmargin-bottom: 5px;\n\t\tfloat: none;\n\t}\n\n\t.landing-page .section-story-overview .image-container:nth-child(2) {\n\t\tmargin-left: 0;\n\t\tmargin-bottom: 30px;\n\t}\n\n\t.card .form-horizontal .col-md-3.col-form-label {\n\t\ttext-align: left;\n\t}\n}\n@media screen and (max-width: 767px) {\n\t.typography-line {\n\t\tpadding-left: 23% !important;\n\t}\n\t.typography-line span {\n\t\twidth: 60px !important;\n\t}\n\n\t.login-page .navbar,\n\t.lock-page .navbar,\n\t.register-page .navbar {\n\t\tpadding: 0.5rem 1rem;\n\t}\n\n\t.footer .footer-nav,\n\t.footer .credits {\n\t\tmargin: 0 auto !important;\n\t}\n\t.footer .footer-nav {\n\t\tmargin-bottom: 10px !important;\n\t}\n\n\t.register-page .content {\n\t\tpadding-top: 5vh;\n\t}\n\t.register-page .footer {\n\t\tposition: relative;\n\t}\n\t.register-page .info-area.info-horizontal {\n\t\tmargin-top: 0;\n\t}\n}\n@media screen and (max-width: 413px) {\n\t.fixed-plugin .dropdown.show-dropdown.show .dropdown-menu.show {\n\t\twidth: 225px !important;\n\t}\n\t.fixed-plugin\n\t\t.dropdown.show-dropdown.show\n\t\t.dropdown-menu.show[x-placement=\"top-start\"] {\n\t\ttransform: translate3d(0, 400px, 0) !important;\n\t}\n\t.fixed-plugin .dropdown.show-dropdown.show .dropdown-menu.show:before,\n\t.fixed-plugin .dropdown.show-dropdown.show .dropdown-menu.show:after {\n\t\tbottom: 360px !important;\n\t}\n}\n@media screen and (max-width: 576px) {\n\t.navbar[class*=\"navbar-toggleable-\"] .container {\n\t\tmargin-left: 0;\n\t\tmargin-right: 0;\n\t}\n\n\t.card-contributions .card-stats {\n\t\tflex-direction: column;\n\t}\n\t.card-contributions .card-stats .bootstrap-switch {\n\t\tmargin-bottom: 15px;\n\t}\n\n\t.footer .copyright {\n\t\ttext-align: center;\n\t}\n\n\t.section-nucleo-icons .icons-container i {\n\t\tfont-size: 30px;\n\t}\n\t.section-nucleo-icons .icons-container i:nth-child(6) {\n\t\tfont-size: 48px;\n\t}\n\n\t.page-header .container h6.category-absolute {\n\t\twidth: 90%;\n\t}\n\n\t.card-timeline .timeline .timeline-panel {\n\t\twidth: 38%;\n\t\tpadding: 15px;\n\t}\n}\n.wrapper {\n\tposition: relative;\n\ttop: 0;\n\theight: 100vh;\n\toverflow-x: hidden;\n}\n.wrapper.wrapper-full-page {\n\tmin-height: 100vh;\n\theight: auto;\n}\n\n.sidebar,\n.off-canvas-sidebar {\n\tposition: fixed;\n\ttop: 0;\n\theight: 100%;\n\tbottom: 0;\n\twidth: 260px;\n\tleft: 0;\n\tz-index: 999;\n}\n.sidebar .sidebar-wrapper,\n.off-canvas-sidebar .sidebar-wrapper {\n\tposition: relative;\n\theight: calc(100vh - 75px);\n\toverflow: auto;\n\twidth: 260px;\n\tz-index: 4;\n\tpadding-bottom: 100px;\n}\n.sidebar .sidebar-wrapper .dropdown .dropdown-backdrop,\n.off-canvas-sidebar .sidebar-wrapper .dropdown .dropdown-backdrop {\n\tdisplay: none !important;\n}\n.sidebar .sidebar-wrapper .navbar-form,\n.off-canvas-sidebar .sidebar-wrapper .navbar-form {\n\tborder: none;\n}\n.sidebar\n\t.sidebar-wrapper\n\t> .nav\n\t[data-toggle=\"collapse\"]\n\t~ div\n\t> ul\n\t> li\n\t> a\n\tspan,\n.sidebar\n\t.sidebar-wrapper\n\t.user\n\t.info\n\t[data-toggle=\"collapse\"]\n\t~ div\n\t> ul\n\t> li\n\t> a\n\tspan,\n.off-canvas-sidebar\n\t.sidebar-wrapper\n\t> .nav\n\t[data-toggle=\"collapse\"]\n\t~ div\n\t> ul\n\t> li\n\t> a\n\tspan,\n.off-canvas-sidebar\n\t.sidebar-wrapper\n\t.user\n\t.info\n\t[data-toggle=\"collapse\"]\n\t~ div\n\t> ul\n\t> li\n\t> a\n\tspan {\n\tdisplay: inline-block;\n}\n.sidebar\n\t.sidebar-wrapper\n\t> .nav\n\t[data-toggle=\"collapse\"]\n\t~ div\n\t> ul\n\t> li\n\t> a\n\t.sidebar-normal,\n.sidebar\n\t.sidebar-wrapper\n\t.user\n\t.info\n\t[data-toggle=\"collapse\"]\n\t~ div\n\t> ul\n\t> li\n\t> a\n\t.sidebar-normal,\n.off-canvas-sidebar\n\t.sidebar-wrapper\n\t> .nav\n\t[data-toggle=\"collapse\"]\n\t~ div\n\t> ul\n\t> li\n\t> a\n\t.sidebar-normal,\n.off-canvas-sidebar\n\t.sidebar-wrapper\n\t.user\n\t.info\n\t[data-toggle=\"collapse\"]\n\t~ div\n\t> ul\n\t> li\n\t> a\n\t.sidebar-normal {\n\tmargin: 0;\n\tposition: relative;\n\ttransform: translateX(0px);\n\topacity: 1;\n\twhite-space: nowrap;\n\tdisplay: block;\n\tline-height: 20px;\n\tz-index: 1;\n}\n.sidebar\n\t.sidebar-wrapper\n\t> .nav\n\t[data-toggle=\"collapse\"]\n\t~ div\n\t> ul\n\t> li\n\t> a\n\t.sidebar-mini-icon,\n.sidebar\n\t.sidebar-wrapper\n\t.user\n\t.info\n\t[data-toggle=\"collapse\"]\n\t~ div\n\t> ul\n\t> li\n\t> a\n\t.sidebar-mini-icon,\n.off-canvas-sidebar\n\t.sidebar-wrapper\n\t> .nav\n\t[data-toggle=\"collapse\"]\n\t~ div\n\t> ul\n\t> li\n\t> a\n\t.sidebar-mini-icon,\n.off-canvas-sidebar\n\t.sidebar-wrapper\n\t.user\n\t.info\n\t[data-toggle=\"collapse\"]\n\t~ div\n\t> ul\n\t> li\n\t> a\n\t.sidebar-mini-icon {\n\ttext-transform: uppercase;\n\twidth: 34px;\n\tmargin-right: 10px;\n\tmargin-left: 0px;\n\tfont-size: 12px;\n\ttext-align: center;\n\tline-height: 20px;\n\tposition: relative;\n\tfloat: left;\n\tz-index: 1;\n\tdisplay: inherit;\n\tcolor: rgba(255, 255, 255, 0.5);\n}\n.sidebar\n\t.sidebar-wrapper\n\t> .nav\n\t[data-toggle=\"collapse\"]\n\t~ div\n\t> ul\n\t> li\n\t> a\n\t.sidebar-normal,\n.sidebar\n\t.sidebar-wrapper\n\t.user\n\t.info\n\t[data-toggle=\"collapse\"]\n\t~ div\n\t> ul\n\t> li\n\t> a\n\t.sidebar-normal,\n.off-canvas-sidebar\n\t.sidebar-wrapper\n\t> .nav\n\t[data-toggle=\"collapse\"]\n\t~ div\n\t> ul\n\t> li\n\t> a\n\t.sidebar-normal,\n.off-canvas-sidebar\n\t.sidebar-wrapper\n\t.user\n\t.info\n\t[data-toggle=\"collapse\"]\n\t~ div\n\t> ul\n\t> li\n\t> a\n\t.sidebar-normal {\n\ttext-transform: capitalize;\n}\n.sidebar .sidebar-wrapper > .nav [data-toggle=\"collapse\"] ~ div > ul > li > a i,\n.sidebar\n\t.sidebar-wrapper\n\t.user\n\t.info\n\t[data-toggle=\"collapse\"]\n\t~ div\n\t> ul\n\t> li\n\t> a\n\ti,\n.off-canvas-sidebar\n\t.sidebar-wrapper\n\t> .nav\n\t[data-toggle=\"collapse\"]\n\t~ div\n\t> ul\n\t> li\n\t> a\n\ti,\n.off-canvas-sidebar\n\t.sidebar-wrapper\n\t.user\n\t.info\n\t[data-toggle=\"collapse\"]\n\t~ div\n\t> ul\n\t> li\n\t> a\n\ti {\n\tfont-size: 17px;\n\tline-height: 20px;\n\twidth: 26px;\n}\n.sidebar .navbar-minimize,\n.off-canvas-sidebar .navbar-minimize {\n\tposition: absolute;\n\tright: 20px;\n\ttop: 2px;\n\topacity: 1;\n}\n.sidebar .logo-tim,\n.off-canvas-sidebar .logo-tim {\n\tborder-radius: 50%;\n\tborder: 1px solid #333;\n\tdisplay: block;\n\theight: 61px;\n\twidth: 61px;\n\tfloat: left;\n\toverflow: hidden;\n}\n.sidebar .logo-tim img,\n.off-canvas-sidebar .logo-tim img {\n\twidth: 60px;\n\theight: 60px;\n}\n.sidebar .nav,\n.off-canvas-sidebar .nav {\n\tmargin-top: 20px;\n\tdisplay: block;\n}\n.sidebar .nav .caret,\n.off-canvas-sidebar .nav .caret {\n\ttop: 14px;\n\tposition: absolute;\n\tright: 10px;\n}\n.sidebar .nav li > a + div .nav li > a,\n.off-canvas-sidebar .nav li > a + div .nav li > a {\n\tmargin-top: 7px;\n}\n.sidebar .nav li > a,\n.off-canvas-sidebar .nav li > a {\n\tmargin: 10px 15px 0;\n\tcolor: #ffffff;\n\tdisplay: block;\n\ttext-decoration: none;\n\tposition: relative;\n\ttext-transform: uppercase;\n\tcursor: pointer;\n\tfont-size: 12px;\n\tpadding: 10px 8px;\n\tline-height: 30px;\n\topacity: 0.7;\n}\n.sidebar .nav li .nav > li > a,\n.off-canvas-sidebar .nav li .nav > li > a {\n\tpadding: 5px 8px;\n}\n.sidebar .nav li.active > a,\n.sidebar .nav li.active > a > i,\n.off-canvas-sidebar .nav li.active > a,\n.off-canvas-sidebar .nav li.active > a > i {\n\topacity: 1;\n}\n.sidebar .nav li:hover:not(.active) > a,\n.sidebar .nav li:focus:not(.active) > a,\n.off-canvas-sidebar .nav li:hover:not(.active) > a,\n.off-canvas-sidebar .nav li:focus:not(.active) > a {\n\topacity: 1;\n}\n.sidebar .nav li.active > a[data-toggle=\"collapse\"] >,\n.off-canvas-sidebar .nav li.active > a[data-toggle=\"collapse\"] > {\n\tbackground-color: transparent;\n\tbox-shadow: 0 2px 2px rgba(204, 197, 185, 0.5);\n}\n.sidebar .nav li.active > a[data-toggle=\"collapse\"],\n.sidebar .nav li.active > a[data-toggle=\"collapse\"] i,\n.sidebar .nav li.active > a[data-toggle=\"collapse\"] ~ div > ul > li.active i,\n.sidebar .nav li.active > a[data-toggle=\"collapse\"] ~ div > ul > li.active > a,\n.off-canvas-sidebar .nav li.active > a[data-toggle=\"collapse\"],\n.off-canvas-sidebar .nav li.active > a[data-toggle=\"collapse\"] i,\n.off-canvas-sidebar\n\t.nav\n\tli.active\n\t> a[data-toggle=\"collapse\"]\n\t~ div\n\t> ul\n\t> li.active\n\ti,\n.off-canvas-sidebar\n\t.nav\n\tli.active\n\t> a[data-toggle=\"collapse\"]\n\t~ div\n\t> ul\n\t> li.active\n\t> a {\n\tcolor: #c1292e;\n}\n.sidebar .nav li.active > a[data-toggle=\"collapse\"] + div .nav .active a,\n.sidebar .nav li.active > a[data-toggle=\"collapse\"] i + div .nav .active a,\n.sidebar\n\t.nav\n\tli.active\n\t> a[data-toggle=\"collapse\"]\n\t~ div\n\t> ul\n\t> li.active\n\ti\n\t+ div\n\t.nav\n\t.active\n\ta,\n.sidebar\n\t.nav\n\tli.active\n\t> a[data-toggle=\"collapse\"]\n\t~ div\n\t> ul\n\t> li.active\n\t> a\n\t+ div\n\t.nav\n\t.active\n\ta,\n.off-canvas-sidebar\n\t.nav\n\tli.active\n\t> a[data-toggle=\"collapse\"]\n\t+ div\n\t.nav\n\t.active\n\ta,\n.off-canvas-sidebar\n\t.nav\n\tli.active\n\t> a[data-toggle=\"collapse\"]\n\ti\n\t+ div\n\t.nav\n\t.active\n\ta,\n.off-canvas-sidebar\n\t.nav\n\tli.active\n\t> a[data-toggle=\"collapse\"]\n\t~ div\n\t> ul\n\t> li.active\n\ti\n\t+ div\n\t.nav\n\t.active\n\ta,\n.off-canvas-sidebar\n\t.nav\n\tli.active\n\t> a[data-toggle=\"collapse\"]\n\t~ div\n\t> ul\n\t> li.active\n\t> a\n\t+ div\n\t.nav\n\t.active\n\ta {\n\tbackground-color: transparent;\n\tbox-shadow: none;\n}\n.sidebar .nav li.active > a[data-toggle=\"collapse\"] + div .nav .active a:after,\n.sidebar\n\t.nav\n\tli.active\n\t> a[data-toggle=\"collapse\"]\n\ti\n\t+ div\n\t.nav\n\t.active\n\ta:after,\n.sidebar\n\t.nav\n\tli.active\n\t> a[data-toggle=\"collapse\"]\n\t~ div\n\t> ul\n\t> li.active\n\ti\n\t+ div\n\t.nav\n\t.active\n\ta:after,\n.sidebar\n\t.nav\n\tli.active\n\t> a[data-toggle=\"collapse\"]\n\t~ div\n\t> ul\n\t> li.active\n\t> a\n\t+ div\n\t.nav\n\t.active\n\ta:after,\n.off-canvas-sidebar\n\t.nav\n\tli.active\n\t> a[data-toggle=\"collapse\"]\n\t+ div\n\t.nav\n\t.active\n\ta:after,\n.off-canvas-sidebar\n\t.nav\n\tli.active\n\t> a[data-toggle=\"collapse\"]\n\ti\n\t+ div\n\t.nav\n\t.active\n\ta:after,\n.off-canvas-sidebar\n\t.nav\n\tli.active\n\t> a[data-toggle=\"collapse\"]\n\t~ div\n\t> ul\n\t> li.active\n\ti\n\t+ div\n\t.nav\n\t.active\n\ta:after,\n.off-canvas-sidebar\n\t.nav\n\tli.active\n\t> a[data-toggle=\"collapse\"]\n\t~ div\n\t> ul\n\t> li.active\n\t> a\n\t+ div\n\t.nav\n\t.active\n\ta:after {\n\tcontent: \"\";\n\tposition: absolute;\n\twidth: calc(100% - 5px);\n\tz-index: 0;\n}\n.sidebar .nav li.active > a[data-toggle=\"collapse\"] ~ div > .nav,\n.off-canvas-sidebar .nav li.active > a[data-toggle=\"collapse\"] ~ div > .nav {\n\tmargin-top: 0;\n}\n.sidebar .nav p,\n.off-canvas-sidebar .nav p {\n\tmargin: 0;\n\tline-height: 30px;\n\tposition: relative;\n\tdisplay: block;\n\theight: auto;\n\twhite-space: nowrap;\n\tfont-weight: 600;\n}\n.sidebar .nav i,\n.off-canvas-sidebar .nav i {\n\tfont-size: 24px;\n\tfloat: left;\n\tmargin-right: 12px;\n\tline-height: 30px;\n\twidth: 34px;\n\ttext-align: center;\n\tcolor: rgba(255, 255, 255, 0.5);\n\tposition: relative;\n}\n.sidebar .sidebar-background,\n.off-canvas-sidebar .sidebar-background {\n\tposition: absolute;\n\tz-index: 1;\n\theight: 100%;\n\twidth: 100%;\n\tdisplay: block;\n\ttop: 0;\n\tleft: 0;\n\tbackground-size: cover;\n\tbackground-position: center center;\n}\n.sidebar .sidebar-background:after,\n.off-canvas-sidebar .sidebar-background:after {\n\tposition: absolute;\n\tz-index: 3;\n\twidth: 100%;\n\theight: 100%;\n\tcontent: \"\";\n\tdisplay: block;\n\tbackground: #ffffff;\n\topacity: 1;\n}\n.sidebar .logo,\n.off-canvas-sidebar .logo {\n\tposition: relative;\n\tpadding: 7px 0.7rem;\n\tz-index: 4;\n}\n.sidebar .logo a.logo-mini,\n.off-canvas-sidebar .logo a.logo-mini {\n\topacity: 0;\n\tfloat: left;\n\twidth: 50px;\n\ttext-align: center;\n\tmargin-left: 12px;\n\tmargin-right: 12px;\n}\n.sidebar .logo a.logo-normal,\n.off-canvas-sidebar .logo a.logo-normal {\n\tdisplay: block;\n\topacity: 1;\n\tpadding: 11px 0 8px;\n\t-webkit-transform: translate3d(0px, 0, 0);\n\t-moz-transform: translate3d(0px, 0, 0);\n\t-o-transform: translate3d(0px, 0, 0);\n\t-ms-transform: translate3d(0px, 0, 0);\n\ttransform: translate3d(0px, 0, 0);\n}\n.sidebar .logo:after,\n.off-canvas-sidebar .logo:after {\n\tcontent: \"\";\n\tposition: absolute;\n\tbottom: 0;\n\tright: 15px;\n\theight: 1px;\n\twidth: calc(100% - 30px);\n\tbackground-color: rgba(255, 255, 255, 0.5);\n}\n.sidebar .logo p,\n.off-canvas-sidebar .logo p {\n\tfloat: left;\n\tfont-size: 20px;\n\tmargin: 10px 10px;\n\tcolor: #ffffff;\n\tline-height: 20px;\n\tfont-family: \"Muli\", \"Helvetica\", Arial, sans-serif;\n}\n.sidebar .logo .simple-text,\n.off-canvas-sidebar .logo .simple-text {\n\ttext-transform: uppercase;\n\tpadding: 0.5rem 0;\n\tdisplay: block;\n\twhite-space: nowrap;\n\tfont-size: 1rem;\n\tcolor: #ffffff;\n\ttext-decoration: none;\n\tfont-weight: 400;\n\tline-height: 30px;\n\toverflow: hidden;\n}\n.sidebar .logo-tim,\n.off-canvas-sidebar .logo-tim {\n\tborder-radius: 50%;\n\tborder: 1px solid #333;\n\tdisplay: block;\n\theight: 61px;\n\twidth: 61px;\n\tfloat: left;\n\toverflow: hidden;\n}\n.sidebar .logo-tim img,\n.off-canvas-sidebar .logo-tim img {\n\twidth: 60px;\n\theight: 60px;\n}\n.sidebar:before,\n.sidebar:after,\n.off-canvas-sidebar:before,\n.off-canvas-sidebar:after {\n\tdisplay: block;\n\tcontent: \"\";\n\topacity: 1;\n\tposition: absolute;\n\twidth: 100%;\n\theight: 100%;\n\ttop: 0;\n\tleft: 0;\n}\n.sidebar:after,\n.off-canvas-sidebar:after {\n\tbackground: #65adff;\n\tbackground: -webkit-linear-gradient(#65adff 0%, #000 80%);\n\tbackground: -o-linear-gradient(#65adff 0%, #000 80%);\n\tbackground: -moz-linear-gradient(#65adff 0%, #000 80%);\n\tbackground: linear-gradient(#65adff 0%, #000 80%);\n\tz-index: 3;\n}\n.sidebar[data-color=\"white\"]:after,\n.off-canvas-sidebar[data-color=\"white\"]:after {\n\tbackground: #ffffff;\n}\n.sidebar[data-color=\"white\"] .nav li a,\n.sidebar[data-color=\"white\"] .nav li a i,\n.sidebar[data-color=\"white\"] .nav li a[data-toggle=\"collapse\"],\n.sidebar[data-color=\"white\"] .nav li a[data-toggle=\"collapse\"] i,\n.sidebar[data-color=\"white\"]\n\t.nav\n\tli\n\ta[data-toggle=\"collapse\"]\n\t~ div\n\t> ul\n\t> li\n\t.sidebar-mini-icon,\n.sidebar[data-color=\"white\"]\n\t.nav\n\tli\n\ta[data-toggle=\"collapse\"]\n\t~ div\n\t> ul\n\t> li\n\t> a,\n.off-canvas-sidebar[data-color=\"white\"] .nav li a,\n.off-canvas-sidebar[data-color=\"white\"] .nav li a i,\n.off-canvas-sidebar[data-color=\"white\"] .nav li a[data-toggle=\"collapse\"],\n.off-canvas-sidebar[data-color=\"white\"] .nav li a[data-toggle=\"collapse\"] i,\n.off-canvas-sidebar[data-color=\"white\"]\n\t.nav\n\tli\n\ta[data-toggle=\"collapse\"]\n\t~ div\n\t> ul\n\t> li\n\t.sidebar-mini-icon,\n.off-canvas-sidebar[data-color=\"white\"]\n\t.nav\n\tli\n\ta[data-toggle=\"collapse\"]\n\t~ div\n\t> ul\n\t> li\n\t> a {\n\tcolor: #65adff;\n\topacity: 0.7;\n}\n.sidebar[data-color=\"white\"] .nav li:hover:not(.active) > a,\n.sidebar[data-color=\"white\"] .nav li:focus:not(.active) > a,\n.off-canvas-sidebar[data-color=\"white\"] .nav li:hover:not(.active) > a,\n.off-canvas-sidebar[data-color=\"white\"] .nav li:focus:not(.active) > a {\n\topacity: 1;\n}\n.sidebar[data-color=\"white\"] .logo .simple-text,\n.off-canvas-sidebar[data-color=\"white\"] .logo .simple-text {\n\tcolor: #65adff;\n}\n.sidebar[data-color=\"white\"] .logo:after,\n.off-canvas-sidebar[data-color=\"white\"] .logo:after {\n\tbackground-color: #65adff;\n\topacity: 0.4;\n}\n.sidebar[data-color=\"white\"] .user .info a span,\n.sidebar[data-color=\"white\"] .user .nav .sidebar-mini-icon,\n.sidebar[data-color=\"white\"] .user .nav .sidebar-normal,\n.off-canvas-sidebar[data-color=\"white\"] .user .info a span,\n.off-canvas-sidebar[data-color=\"white\"] .user .nav .sidebar-mini-icon,\n.off-canvas-sidebar[data-color=\"white\"] .user .nav .sidebar-normal {\n\tcolor: #65adff !important;\n}\n.sidebar[data-color=\"white\"] .user:after,\n.off-canvas-sidebar[data-color=\"white\"] .user:after {\n\tbackground-color: #65adff;\n\topacity: 0.4;\n}\n.sidebar[data-color=\"brown\"]:after,\n.off-canvas-sidebar[data-color=\"brown\"]:after {\n\tbackground: #65adff;\n}\n.sidebar[data-active-color=\"primary\"] .nav li.active > a,\n.sidebar[data-active-color=\"primary\"] .nav li.active > a i,\n.sidebar[data-active-color=\"primary\"]\n\t.nav\n\tli.active\n\t> a[data-toggle=\"collapse\"],\n.sidebar[data-active-color=\"primary\"]\n\t.nav\n\tli.active\n\t> a[data-toggle=\"collapse\"]\n\ti,\n.sidebar[data-active-color=\"primary\"]\n\t.nav\n\tli.active\n\t> a[data-toggle=\"collapse\"]\n\t~ div\n\t> ul\n\t> li.active\n\t.sidebar-mini-icon,\n.sidebar[data-active-color=\"primary\"]\n\t.nav\n\tli.active\n\t> a[data-toggle=\"collapse\"]\n\t~ div\n\t> ul\n\t> li.active\n\t> a,\n.off-canvas-sidebar[data-active-color=\"primary\"] .nav li.active > a,\n.off-canvas-sidebar[data-active-color=\"primary\"] .nav li.active > a i,\n.off-canvas-sidebar[data-active-color=\"primary\"]\n\t.nav\n\tli.active\n\t> a[data-toggle=\"collapse\"],\n.off-canvas-sidebar[data-active-color=\"primary\"]\n\t.nav\n\tli.active\n\t> a[data-toggle=\"collapse\"]\n\ti,\n.off-canvas-sidebar[data-active-color=\"primary\"]\n\t.nav\n\tli.active\n\t> a[data-toggle=\"collapse\"]\n\t~ div\n\t> ul\n\t> li.active\n\t.sidebar-mini-icon,\n.off-canvas-sidebar[data-active-color=\"primary\"]\n\t.nav\n\tli.active\n\t> a[data-toggle=\"collapse\"]\n\t~ div\n\t> ul\n\t> li.active\n\t> a {\n\tcolor: #1c77c3;\n\topacity: 1;\n}\n.sidebar[data-active-color=\"info\"] .nav li.active > a,\n.sidebar[data-active-color=\"info\"] .nav li.active > a i,\n.sidebar[data-active-color=\"info\"] .nav li.active > a[data-toggle=\"collapse\"],\n.sidebar[data-active-color=\"info\"] .nav li.active > a[data-toggle=\"collapse\"] i,\n.sidebar[data-active-color=\"info\"]\n\t.nav\n\tli.active\n\t> a[data-toggle=\"collapse\"]\n\t~ div\n\t> ul\n\t> li.active\n\t.sidebar-mini-icon,\n.sidebar[data-active-color=\"info\"]\n\t.nav\n\tli.active\n\t> a[data-toggle=\"collapse\"]\n\t~ div\n\t> ul\n\t> li.active\n\t> a,\n.off-canvas-sidebar[data-active-color=\"info\"] .nav li.active > a,\n.off-canvas-sidebar[data-active-color=\"info\"] .nav li.active > a i,\n.off-canvas-sidebar[data-active-color=\"info\"]\n\t.nav\n\tli.active\n\t> a[data-toggle=\"collapse\"],\n.off-canvas-sidebar[data-active-color=\"info\"]\n\t.nav\n\tli.active\n\t> a[data-toggle=\"collapse\"]\n\ti,\n.off-canvas-sidebar[data-active-color=\"info\"]\n\t.nav\n\tli.active\n\t> a[data-toggle=\"collapse\"]\n\t~ div\n\t> ul\n\t> li.active\n\t.sidebar-mini-icon,\n.off-canvas-sidebar[data-active-color=\"info\"]\n\t.nav\n\tli.active\n\t> a[data-toggle=\"collapse\"]\n\t~ div\n\t> ul\n\t> li.active\n\t> a {\n\tcolor: #39a9db;\n\topacity: 1;\n}\n.sidebar[data-active-color=\"success\"] .nav li.active > a,\n.sidebar[data-active-color=\"success\"] .nav li.active > a i,\n.sidebar[data-active-color=\"success\"]\n\t.nav\n\tli.active\n\t> a[data-toggle=\"collapse\"],\n.sidebar[data-active-color=\"success\"]\n\t.nav\n\tli.active\n\t> a[data-toggle=\"collapse\"]\n\ti,\n.sidebar[data-active-color=\"success\"]\n\t.nav\n\tli.active\n\t> a[data-toggle=\"collapse\"]\n\t~ div\n\t> ul\n\t> li.active\n\t.sidebar-mini-icon,\n.sidebar[data-active-color=\"success\"]\n\t.nav\n\tli.active\n\t> a[data-toggle=\"collapse\"]\n\t~ div\n\t> ul\n\t> li.active\n\t> a,\n.off-canvas-sidebar[data-active-color=\"success\"] .nav li.active > a,\n.off-canvas-sidebar[data-active-color=\"success\"] .nav li.active > a i,\n.off-canvas-sidebar[data-active-color=\"success\"]\n\t.nav\n\tli.active\n\t> a[data-toggle=\"collapse\"],\n.off-canvas-sidebar[data-active-color=\"success\"]\n\t.nav\n\tli.active\n\t> a[data-toggle=\"collapse\"]\n\ti,\n.off-canvas-sidebar[data-active-color=\"success\"]\n\t.nav\n\tli.active\n\t> a[data-toggle=\"collapse\"]\n\t~ div\n\t> ul\n\t> li.active\n\t.sidebar-mini-icon,\n.off-canvas-sidebar[data-active-color=\"success\"]\n\t.nav\n\tli.active\n\t> a[data-toggle=\"collapse\"]\n\t~ div\n\t> ul\n\t> li.active\n\t> a {\n\tcolor: #28a745;\n\topacity: 1;\n}\n.sidebar[data-active-color=\"warning\"] .nav li.active > a,\n.sidebar[data-active-color=\"warning\"] .nav li.active > a i,\n.sidebar[data-active-color=\"warning\"]\n\t.nav\n\tli.active\n\t> a[data-toggle=\"collapse\"],\n.sidebar[data-active-color=\"warning\"]\n\t.nav\n\tli.active\n\t> a[data-toggle=\"collapse\"]\n\ti,\n.sidebar[data-active-color=\"warning\"]\n\t.nav\n\tli.active\n\t> a[data-toggle=\"collapse\"]\n\t~ div\n\t> ul\n\t> li.active\n\t.sidebar-mini-icon,\n.sidebar[data-active-color=\"warning\"]\n\t.nav\n\tli.active\n\t> a[data-toggle=\"collapse\"]\n\t~ div\n\t> ul\n\t> li.active\n\t> a,\n.off-canvas-sidebar[data-active-color=\"warning\"] .nav li.active > a,\n.off-canvas-sidebar[data-active-color=\"warning\"] .nav li.active > a i,\n.off-canvas-sidebar[data-active-color=\"warning\"]\n\t.nav\n\tli.active\n\t> a[data-toggle=\"collapse\"],\n.off-canvas-sidebar[data-active-color=\"warning\"]\n\t.nav\n\tli.active\n\t> a[data-toggle=\"collapse\"]\n\ti,\n.off-canvas-sidebar[data-active-color=\"warning\"]\n\t.nav\n\tli.active\n\t> a[data-toggle=\"collapse\"]\n\t~ div\n\t> ul\n\t> li.active\n\t.sidebar-mini-icon,\n.off-canvas-sidebar[data-active-color=\"warning\"]\n\t.nav\n\tli.active\n\t> a[data-toggle=\"collapse\"]\n\t~ div\n\t> ul\n\t> li.active\n\t> a {\n\tcolor: #ffc759;\n\topacity: 1;\n}\n.sidebar[data-active-color=\"danger\"] .nav li.active > a,\n.sidebar[data-active-color=\"danger\"] .nav li.active > a i,\n.sidebar[data-active-color=\"danger\"] .nav li.active > a[data-toggle=\"collapse\"],\n.sidebar[data-active-color=\"danger\"]\n\t.nav\n\tli.active\n\t> a[data-toggle=\"collapse\"]\n\ti,\n.sidebar[data-active-color=\"danger\"]\n\t.nav\n\tli.active\n\t> a[data-toggle=\"collapse\"]\n\t~ div\n\t> ul\n\t> li.active\n\t.sidebar-mini-icon,\n.sidebar[data-active-color=\"danger\"]\n\t.nav\n\tli.active\n\t> a[data-toggle=\"collapse\"]\n\t~ div\n\t> ul\n\t> li.active\n\t> a,\n.off-canvas-sidebar[data-active-color=\"danger\"] .nav li.active > a,\n.off-canvas-sidebar[data-active-color=\"danger\"] .nav li.active > a i,\n.off-canvas-sidebar[data-active-color=\"danger\"]\n\t.nav\n\tli.active\n\t> a[data-toggle=\"collapse\"],\n.off-canvas-sidebar[data-active-color=\"danger\"]\n\t.nav\n\tli.active\n\t> a[data-toggle=\"collapse\"]\n\ti,\n.off-canvas-sidebar[data-active-color=\"danger\"]\n\t.nav\n\tli.active\n\t> a[data-toggle=\"collapse\"]\n\t~ div\n\t> ul\n\t> li.active\n\t.sidebar-mini-icon,\n.off-canvas-sidebar[data-active-color=\"danger\"]\n\t.nav\n\tli.active\n\t> a[data-toggle=\"collapse\"]\n\t~ div\n\t> ul\n\t> li.active\n\t> a {\n\tcolor: #c1292e;\n\topacity: 1;\n}\n.sidebar .user,\n.off-canvas-sidebar .user {\n\tpadding-bottom: 20px;\n\tmargin: 20px auto 0;\n\tposition: relative;\n}\n.sidebar .user:after,\n.off-canvas-sidebar .user:after {\n\tcontent: \"\";\n\tposition: absolute;\n\tbottom: 0;\n\tright: 15px;\n\theight: 1px;\n\twidth: calc(100% - 30px);\n\tbackground-color: rgba(255, 255, 255, 0.3);\n}\n.sidebar .user .photo,\n.off-canvas-sidebar .user .photo {\n\twidth: 34px;\n\theight: 34px;\n\toverflow: hidden;\n\tfloat: left;\n\tz-index: 5;\n\tmargin-right: 12px;\n\tborder-radius: 50%;\n\tmargin-left: 23px;\n}\n.sidebar .user .photo img,\n.off-canvas-sidebar .user .photo img {\n\twidth: 100%;\n}\n.sidebar .user a,\n.off-canvas-sidebar .user a {\n\tcolor: #ffffff;\n\ttext-decoration: none;\n\tpadding: 0.5rem 15px;\n\twhite-space: nowrap;\n}\n.sidebar .user .info > a,\n.off-canvas-sidebar .user .info > a {\n\tdisplay: block;\n\tline-height: 18px;\n}\n.sidebar .user .info > a > span,\n.off-canvas-sidebar .user .info > a > span {\n\tdisplay: block;\n\tposition: relative;\n\topacity: 1;\n}\n.sidebar .user .info .caret,\n.off-canvas-sidebar .user .info .caret {\n\tposition: absolute;\n\ttop: 8px;\n\tright: 18px;\n}\n\n.visible-on-sidebar-regular {\n\tdisplay: inline-block !important;\n}\n\n.visible-on-sidebar-mini {\n\tdisplay: none !important;\n}\n\n.off-canvas-sidebar .nav > li > a,\n.off-canvas-sidebar .nav > li > a:hover {\n\tcolor: #ffffff;\n}\n.off-canvas-sidebar .nav > li > a:focus {\n\tbackground: rgba(200, 200, 200, 0.2);\n}\n\n.main-panel {\n\tposition: relative;\n\tfloat: right;\n\tbackground-color: #f7f7f7;\n\t-webkit-transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);\n\t-moz-transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);\n\t-o-transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);\n\t-ms-transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);\n\ttransition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);\n}\n.main-panel > .content {\n\tpadding: 0 30px 30px;\n\tmin-height: calc(100vh - 123px);\n\tmargin-top: 93px;\n}\n.main-panel > .map-content {\n\tmin-height: calc(100vh - 123px);\n\tmargin-top: 63px;\n}\n.main-panel > .navbar {\n\tmargin-bottom: 0;\n}\n.main-panel .header {\n\tmargin-bottom: 50px;\n}\n\n.perfect-scrollbar-on .sidebar,\n.perfect-scrollbar-on .main-panel {\n\theight: 100%;\n\tmax-height: 100%;\n}\n\n@media (min-width: 991px) {\n\t.sidebar,\n\t.main-panel,\n\t.sidebar-wrapper {\n\t\t-webkit-transition-property: top, bottom, width;\n\t\ttransition-property: top, bottom, width;\n\t\t-webkit-transition-duration: 0.2s, 0.2s, 0.35s;\n\t\ttransition-duration: 0.2s, 0.2s, 0.35s;\n\t\t-webkit-transition-timing-function: linear, linear, ease;\n\t\ttransition-timing-function: linear, linear, ease;\n\t\t-webkit-overflow-scrolling: touch;\n\t}\n\n\t.sidebar-mini .visible-on-sidebar-regular {\n\t\tdisplay: none !important;\n\t}\n\t.sidebar-mini .visible-on-sidebar-mini {\n\t\tdisplay: inline-block !important;\n\t}\n\t.sidebar-mini .sidebar,\n\t.sidebar-mini .sidebar .sidebar-wrapper {\n\t\twidth: 80px;\n\t}\n\t.sidebar-mini .main-panel {\n\t\twidth: calc(100% - 80px);\n\t}\n\t.sidebar-mini .sidebar {\n\t\tdisplay: block;\n\t\tz-index: 1030;\n\t}\n\t.sidebar-mini .sidebar .logo a.logo-normal {\n\t\topacity: 0;\n\t\t-webkit-transform: translate3d(-25px, 0, 0);\n\t\t-moz-transform: translate3d(-25px, 0, 0);\n\t\t-o-transform: translate3d(-25px, 0, 0);\n\t\t-ms-transform: translate3d(-25px, 0, 0);\n\t\ttransform: translate3d(-25px, 0, 0);\n\t}\n\t.sidebar-mini .sidebar .logo a.logo-mini {\n\t\topacity: 1;\n\t}\n\t.sidebar-mini\n\t\t.sidebar\n\t\t.sidebar-wrapper\n\t\t> .nav\n\t\t[data-toggle=\"collapse\"]\n\t\t~ div\n\t\t> ul\n\t\t> li\n\t\t> a\n\t\t.sidebar-normal,\n\t.sidebar-mini\n\t\t.sidebar\n\t\t.sidebar-wrapper\n\t\t.user\n\t\t.info\n\t\t[data-toggle=\"collapse\"]\n\t\t~ div\n\t\t> ul\n\t\t> li\n\t\t> a\n\t\t.sidebar-normal,\n\t.sidebar-mini .sidebar .sidebar-wrapper .user .info > a > span,\n\t.sidebar-mini .sidebar .sidebar-wrapper > .nav li > a p {\n\t\t-webkit-transform: translate3d(-25px, 0, 0);\n\t\t-moz-transform: translate3d(-25px, 0, 0);\n\t\t-o-transform: translate3d(-25px, 0, 0);\n\t\t-ms-transform: translate3d(-25px, 0, 0);\n\t\ttransform: translate3d(-25px, 0, 0);\n\t\topacity: 0;\n\t}\n\t.sidebar-mini .sidebar:hover {\n\t\twidth: 260px;\n\t}\n\t.sidebar-mini .sidebar:hover .logo a.logo-normal {\n\t\topacity: 1;\n\t\t-webkit-transform: translate3d(0, 0, 0);\n\t\t-moz-transform: translate3d(0, 0, 0);\n\t\t-o-transform: translate3d(0, 0, 0);\n\t\t-ms-transform: translate3d(0, 0, 0);\n\t\ttransform: translate3d(0, 0, 0);\n\t}\n\t.sidebar-mini .sidebar:hover .navbar-minimize {\n\t\topacity: 1;\n\t}\n\t.sidebar-mini .sidebar:hover .sidebar-wrapper {\n\t\twidth: 260px;\n\t}\n\t.sidebar-mini .sidebar:hover .sidebar-wrapper > .nav li > a p,\n\t.sidebar-mini\n\t\t.sidebar:hover\n\t\t.sidebar-wrapper\n\t\t> .nav\n\t\t[data-toggle=\"collapse\"]\n\t\t~ div\n\t\t> ul\n\t\t> li\n\t\t> a\n\t\t.sidebar-normal,\n\t.sidebar-mini\n\t\t.sidebar:hover\n\t\t.sidebar-wrapper\n\t\t.user\n\t\t.info\n\t\t[data-toggle=\"collapse\"]\n\t\t~ div\n\t\t> ul\n\t\t> li\n\t\t> a\n\t\t.sidebar-normal,\n\t.sidebar-mini .sidebar:hover .sidebar-wrapper .user .info > a > span {\n\t\t-webkit-transform: translate3d(0px, 0, 0);\n\t\t-moz-transform: translate3d(0px, 0, 0);\n\t\t-o-transform: translate3d(0px, 0, 0);\n\t\t-ms-transform: translate3d(0px, 0, 0);\n\t\ttransform: translate3d(0px, 0, 0);\n\t\topacity: 1;\n\t}\n}\n.panel-header {\n\theight: 260px;\n\tpadding-top: 80px;\n\tpadding-bottom: 45px;\n\tbackground: #141e30;\n\t/* fallback for old browsers */\n\tbackground: -webkit-gradient(\n\t\tlinear,\n\t\tleft top,\n\t\tright top,\n\t\tfrom(#0c2646),\n\t\tcolor-stop(60%, #204065),\n\t\tto(#2a5788)\n\t);\n\tbackground: linear-gradient(to right, #0c2646 0%, #204065 60%, #2a5788 100%);\n\tposition: relative;\n\toverflow: hidden;\n}\n.panel-header .header .title {\n\tcolor: #ffffff;\n}\n.panel-header .header .category {\n\tmax-width: 600px;\n\tcolor: rgba(255, 255, 255, 0.5);\n\tmargin: 0 auto;\n\tfont-size: 13px;\n}\n.panel-header .header .category a {\n\tcolor: #ffffff;\n}\n\n.panel-header-sm {\n\theight: 135px;\n}\n\n.panel-header-lg {\n\theight: 380px;\n}\n\n.sidebar .logo .simple-text .logo-img {\n\tdisplay: -webkit-inline-box;\n\tdisplay: -ms-inline-flexbox;\n\tdisplay: inline-flex;\n\t-webkit-box-align: center;\n\t-ms-flex-align: center;\n\talign-items: center;\n\t-webkit-box-pack: center;\n\t-ms-flex-pack: center;\n\tjustify-content: center;\n\theight: 34px;\n\twidth: 34px;\n\tbackground: #ffffff;\n\tborder-radius: 50%;\n\ttext-align: center;\n\toverflow: hidden;\n}\n.sidebar .logo .simple-text .logo-img img {\n\twidth: 51%;\n\tvertical-align: unset;\n\theight: 51%;\n}\n\n.sidebar[data-color=\"white\"] {\n\tborder-right: 1px solid #ddd;\n}\n\n/*             Navigation Tabs                 */\n.nav-tabs-navigation {\n\ttext-align: center;\n\tborder-bottom: 1px solid #f1eae0;\n\tmargin-bottom: 30px;\n}\n.nav-tabs-navigation .nav > .nav-item > .nav-link {\n\tpadding-bottom: 20px;\n}\n\n.nav-tabs-wrapper {\n\tdisplay: inline-block;\n\tmargin-bottom: -6px;\n\tposition: relative;\n\twidth: 100%;\n\tmargin-left: auto;\n\tmargin-right: auto;\n}\n\n.nav-tabs {\n\tjustify-content: center;\n\tborder-bottom: 0 none;\n\tfont-size: 14px;\n\tfont-weight: 400;\n}\n.nav-tabs .nav-item .nav-link {\n\tborder: 0 none;\n\tcolor: #a49e93;\n\tbackground-color: transparent;\n}\n.nav-tabs .nav-item .nav-link:hover {\n\tcolor: #292929 !important;\n}\n.nav-tabs .nav-item .nav-link.active {\n\tcolor: #292929 !important;\n}\n.nav-tabs .nav-item {\n\tcolor: #292929 !important;\n\tposition: relative;\n}\n.nav-tabs .nav-item .nav-link.active,\n.nav-tabs .nav-item .nav-link.active:hover,\n.nav-tabs .nav-item .nav-link.active:focus {\n\tbackground-color: transparent;\n\tborder: 0 none;\n}\n.nav-tabs .nav-item .nav-link.active:after,\n.nav-tabs .nav-item .nav-link.active:hover:after,\n.nav-tabs .nav-item .nav-link.active:focus:after {\n\tborder-bottom: 11px solid #ffffff;\n\tborder-left: 11px solid rgba(0, 0, 0, 0);\n\tborder-right: 11px solid rgba(0, 0, 0, 0);\n\tcontent: \"\";\n\tdisplay: inline-block;\n\tposition: absolute;\n\tright: 40%;\n\tbottom: 5px;\n}\n.nav-tabs .nav-item .nav-link.active:before,\n.nav-tabs .nav-item .nav-link.active:hover:before,\n.nav-tabs .nav-item .nav-link.active:focus:before {\n\tborder-bottom: 11px solid #f1eae0;\n\tborder-left: 11px solid rgba(0, 0, 0, 0);\n\tborder-right: 11px solid rgba(0, 0, 0, 0);\n\tcontent: \"\";\n\tdisplay: inline-block;\n\tposition: absolute;\n\tright: 40%;\n\tbottom: 6px;\n}\n.nav-tabs .nav-item.show .nav-link {\n\tbackground-color: transparent;\n}\n.nav-tabs .dropdown-menu {\n\tmargin-top: -6px;\n\tmargin-left: -46px;\n\tborder-radius: 8px;\n}\n.nav-tabs .dropdown-menu .dropdown-item:hover,\n.nav-tabs .dropdown-menu .dropdown-item.active {\n\tcolor: #ffffff;\n\tbackground-color: #68b3c8;\n}\n.nav-tabs .dropdown-menu :before {\n\tborder-bottom: 11px solid #f1eae0;\n\tborder-left: 11px solid rgba(0, 0, 0, 0);\n\tborder-right: 11px solid rgba(0, 0, 0, 0);\n\tcontent: \"\";\n\tdisplay: inline-block;\n\tposition: absolute;\n\tright: 12px;\n\ttop: -11px;\n}\n.nav-tabs .dropdown-menu :after {\n\tborder-bottom: 11px solid #fffcf5;\n\tborder-left: 11px solid rgba(0, 0, 0, 0);\n\tborder-right: 11px solid rgba(0, 0, 0, 0);\n\tcontent: \"\";\n\tdisplay: inline-block;\n\tposition: absolute;\n\tright: 12px;\n\ttop: -10px;\n}\n\n.profile-content .tab-content .tab-pane {\n\tmin-height: 200px;\n}\n.profile-content .tab-content #tweets,\n.profile-content .tab-content #connections,\n.profile-content .tab-content #media {\n\theight: 100%;\n}\n\n.nav-text,\n.nav-icons {\n\tmargin: 0 0 10px 0;\n}\n.nav-text > li > a,\n.nav-icons > li > a {\n\tdisplay: block;\n\tpadding: 0px 0.7rem;\n\tcolor: #292929 !important;\n\ttext-align: center;\n\topacity: 0.8;\n\tfilter: alpha(opacity=80);\n}\n.nav-text > li > a:hover,\n.nav-text > li > a:focus,\n.nav-icons > li > a:hover,\n.nav-icons > li > a:focus {\n\tbackground-color: transparent;\n\topacity: 1;\n\tfilter: alpha(opacity=100);\n}\n.nav-text > li:first-child a,\n.nav-icons > li:first-child a {\n\tpadding-left: 0;\n}\n.nav-text > li.active a,\n.nav-icons > li.active a {\n\tcolor: #39a9db;\n}\n\n.nav-icons > li {\n\tdisplay: inline-block;\n}\n.nav-icons > li > a {\n\tpadding: 0 10px;\n\tmargin-bottom: 10px;\n}\n.nav-icons > li > a i {\n\tfont-size: 1.714em;\n\tmargin-bottom: 10px;\n\twidth: 1.714em;\n}\n\n.nav-icons.nav-stacked > li {\n\tdisplay: block;\n}\n.nav-icons.nav-stacked > li > a {\n\tmargin-bottom: 20px;\n}\n\n.nav-blue > li.active a {\n\tcolor: #1c77c3;\n}\n\n.nav-azure > li.active a {\n\tcolor: #39a9db;\n}\n\n.nav-green > li.active a {\n\tcolor: #28a745;\n}\n\n.nav-orange > li.active a {\n\tcolor: #ffc759;\n}\n\n.nav-red > li.active a {\n\tcolor: #c1292e;\n}\n\n.nav-text {\n\tmargin: 0 0 10px 0;\n}\n.nav-text > li > a {\n\tfont-size: 1em;\n\ttext-transform: uppercase;\n\tpadding: 3px 0;\n\ttext-align: left;\n\tfont-weight: 600;\n}\n.nav-text > li:first-child > a {\n\tpadding-top: 0;\n}\n.nav-text h4 {\n\tmargin-top: 0;\n}\n\n.nav-text:not(.nav-stacked) > li {\n\tdisplay: inline-block;\n}\n.nav-text:not(.nav-stacked) > li > a {\n\tmargin-right: 15px;\n}\n\n.verical-navs .nav-stacked .nav-link.active:before,\n.verical-navs .nav-stacked .nav-link.active:hover:before,\n.verical-navs .nav-stacked .nav-link.active:focus:before,\n.verical-navs .nav-stacked .nav-link.active.show:before {\n\tborder-right: 11px solid #f1eae0;\n\tborder-top: 11px solid transparent;\n\tborder-bottom: 11px solid transparent;\n\tcontent: \"\";\n\tdisplay: inline-block;\n\tposition: absolute;\n\tright: 0;\n\tbottom: 20px;\n}\n\n.verical-navs .nav-stacked .nav-link.active:after,\n.verical-navs .nav-stacked .nav-link.active:hover:after,\n.verical-navs .nav-stacked .nav-link.active:focus:after,\n.verical-navs .nav-stacked .nav-link.active.show:after {\n\tborder-right: 11px solid #ffffff;\n\tborder-top: 11px solid transparent;\n\tborder-bottom: 11px solid transparent;\n\tcontent: \"\";\n\tdisplay: inline-block;\n\tposition: absolute;\n\tright: -1px;\n\tbottom: 20px;\n}\n\n#second-tabs {\n\tmargin-left: 20px;\n}\n\n.nav-tabs-navigation.verical-navs {\n\tborder-right: 1px solid #f1eae0;\n\tfont-size: 16px;\n\tborder-bottom: none;\n}\n\n.card-timeline .timeline h6 i {\n\tmargin-right: 4px;\n}\n\n/*! nouislider - 11.1.0 - 2018-04-02 11:18:13 */\n/* Functional styling;\n* These styles are required for noUiSlider to function.\n* You don't need to change these rules to apply your design.\n*/\n/*\n\nThis file was modified by Creative-Tim\n\n*/\n.noUi-target,\n.noUi-target * {\n\t-webkit-touch-callout: none;\n\t-webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n\t-webkit-user-select: none;\n\t-ms-touch-action: none;\n\ttouch-action: none;\n\t-ms-user-select: none;\n\t-moz-user-select: none;\n\tuser-select: none;\n\t-moz-box-sizing: border-box;\n\tbox-sizing: border-box;\n}\n\n.noUi-target {\n\tposition: relative;\n\tdirection: ltr;\n}\n\n.noUi-base,\n.noUi-connects {\n\twidth: 100%;\n\theight: 100%;\n\tposition: relative;\n\tz-index: 1;\n}\n\n/* Wrapper for all connect elements.\n*/\n.noUi-connects {\n\toverflow: hidden;\n\tz-index: 0;\n}\n\n.noUi-connect,\n.noUi-origin {\n\twill-change: transform;\n\tposition: absolute;\n\tz-index: 1;\n\ttop: 0;\n\tleft: 0;\n\theight: 100%;\n\twidth: 100%;\n\t-ms-transform-origin: 0 0;\n\t-webkit-transform-origin: 0 0;\n\ttransform-origin: 0 0;\n}\n\n/* Offset direction\n*/\nhtml:not([dir=\"rtl\"]) .noUi-horizontal .noUi-origin {\n\tleft: auto;\n\tright: 0;\n}\n\n/* Give origins 0 height/width so they don't interfere with clicking the\n* connect elements.\n*/\n.noUi-vertical .noUi-origin {\n\twidth: 0;\n}\n\n.noUi-horizontal .noUi-origin {\n\theight: 0;\n}\n\n.noUi-handle {\n\tposition: absolute;\n}\n\n.noUi-state-tap .noUi-connect,\n.noUi-state-tap .noUi-origin {\n\t-webkit-transition: transform 0.3s;\n\ttransition: transform 0.3s;\n}\n\n.noUi-state-drag * {\n\tcursor: inherit !important;\n}\n\n/* Slider size and handle placement;\n*/\n.noUi-horizontal {\n\theight: 8px;\n}\n\n.noUi-horizontal .noUi-handle {\n\tbackground: #fff;\n\tbackground: linear-gradient(180deg, #fff 0, #f1f1f2);\n\tfilter: progid:DXImageTransform.Microsoft.gradient(startColorstr=\"$white-color\",endColorstr=\"#f1f1f2\",GradientType=0);\n\tborder-radius: 50%;\n\tbox-shadow: inset 0 1px 1px #fff, 0 1px 2px rgba(0, 0, 0, 0.4);\n\theight: 15px;\n\twidth: 15px;\n\tcursor: pointer;\n\tmargin-left: -10px;\n\tmargin-top: -4px;\n}\n\n.noUi-vertical {\n\twidth: 8px;\n}\n\n.noUi-vertical .noUi-handle {\n\tbackground: #fff;\n\tbackground: linear-gradient(180deg, #fff 0, #f1f1f2);\n\tfilter: progid:DXImageTransform.Microsoft.gradient(startColorstr=\"$white-color\",endColorstr=\"#f1f1f2\",GradientType=0);\n\tborder-radius: 50%;\n\tbox-shadow: inset 0 1px 1px #fff, 0 1px 2px rgba(0, 0, 0, 0.4);\n\tcursor: pointer;\n\twidth: 15px;\n\theight: 15px;\n\tleft: -4px;\n\ttop: -10px;\n}\n\nhtml:not([dir=\"rtl\"]) .noUi-horizontal .noUi-handle {\n\tright: -5px;\n\tleft: auto;\n}\n\n/* Styling;\n* Giving the connect element a border radius causes issues with using transform: scale\n*/\n.noUi-target {\n\tbackground-color: rgba(182, 182, 182, 0.3);\n\tborder-radius: 3px;\n}\n\n.noUi-connects {\n\tborder-radius: 3px;\n}\n\n.noUi-connect {\n\tbackground: #888;\n\tborder-radius: 3px;\n\t-webkit-transition: background 450ms;\n\ttransition: background 450ms;\n}\n\n/* Handles and cursors;\n*/\n.noUi-draggable {\n\tcursor: ew-resize;\n}\n\n.noUi-vertical .noUi-draggable {\n\tcursor: ns-resize;\n}\n\n.noUi-handle {\n\tborder-radius: 3px;\n\tbackground: #fff;\n\tcursor: default;\n\tbox-shadow: inset 0 0 1px #fff, inset 0 1px 7px #ebebeb, 0 3px 6px -3px #bbb;\n\t-webkit-transition: 300ms ease 0s;\n\t-moz-transition: 300ms ease 0s;\n\t-ms-transition: 300ms ease 0s;\n\ttransition: 300ms ease 0s;\n}\n.noUi-handle:focus {\n\toutline: none;\n}\n\n.noUi-active {\n\tbox-shadow: inset 0 0 1px #fff, inset 0 1px 7px #ddd, 0 3px 6px -3px #bbb;\n}\n\n/* Disabled state;\n*/\n[disabled] .noUi-connect {\n\tbackground: #b8b8b8;\n}\n\n[disabled].noUi-target,\n[disabled].noUi-handle,\n[disabled] .noUi-handle {\n\tcursor: not-allowed;\n}\n\n/* Base;\n*\n*/\n.noUi-pips,\n.noUi-pips * {\n\t-moz-box-sizing: border-box;\n\tbox-sizing: border-box;\n}\n\n.noUi-pips {\n\tposition: absolute;\n\tcolor: #999;\n}\n\n/* Values;\n*\n*/\n.noUi-value {\n\tposition: absolute;\n\twhite-space: nowrap;\n\ttext-align: center;\n}\n\n.noUi-value-sub {\n\tcolor: #ccc;\n\tfont-size: 10px;\n}\n\n/* Markings;\n*\n*/\n.noUi-marker {\n\tposition: absolute;\n\tbackground: #ccc;\n}\n\n.noUi-marker-sub {\n\tbackground: #aaa;\n}\n\n.noUi-marker-large {\n\tbackground: #aaa;\n}\n\n/* Horizontal layout;\n*\n*/\n.noUi-pips-horizontal {\n\tpadding: 10px 0;\n\theight: 80px;\n\ttop: 100%;\n\tleft: 0;\n\twidth: 100%;\n}\n\n.noUi-value-horizontal {\n\t-webkit-transform: translate(-50%, 50%);\n\ttransform: translate(-50%, 50%);\n}\n\n.noUi-rtl .noUi-value-horizontal {\n\t-webkit-transform: translate(50%, 50%);\n\ttransform: translate(50%, 50%);\n}\n\n.noUi-marker-horizontal.noUi-marker {\n\tmargin-left: -1px;\n\twidth: 2px;\n\theight: 5px;\n}\n\n.noUi-marker-horizontal.noUi-marker-sub {\n\theight: 10px;\n}\n\n.noUi-marker-horizontal.noUi-marker-large {\n\theight: 15px;\n}\n\n/* Vertical layout;\n*\n*/\n.noUi-pips-vertical {\n\tpadding: 0 10px;\n\theight: 100%;\n\ttop: 0;\n\tleft: 100%;\n}\n\n.noUi-value-vertical {\n\t-webkit-transform: translate(0, -50%);\n\ttransform: translate(0, -50%, 0);\n\tpadding-left: 25px;\n}\n\n.noUi-rtl .noUi-value-vertical {\n\t-webkit-transform: translate(0, 50%);\n\ttransform: translate(0, 50%);\n}\n\n.noUi-marker-vertical.noUi-marker {\n\twidth: 5px;\n\theight: 2px;\n\tmargin-top: -1px;\n}\n\n.noUi-marker-vertical.noUi-marker-sub {\n\twidth: 10px;\n}\n\n.noUi-marker-vertical.noUi-marker-large {\n\twidth: 15px;\n}\n\n.noUi-tooltip {\n\tdisplay: block;\n\tposition: absolute;\n\tborder: 1px solid #d9d9d9;\n\tborder-radius: 3px;\n\tbackground: #fff;\n\tcolor: #000;\n\tpadding: 5px;\n\ttext-align: center;\n\twhite-space: nowrap;\n}\n\n.noUi-horizontal .noUi-tooltip {\n\t-webkit-transform: translate(-50%, 0);\n\ttransform: translate(-50%, 0);\n\tleft: 50%;\n\tbottom: 120%;\n}\n\n.noUi-vertical .noUi-tooltip {\n\t-webkit-transform: translate(0, -50%);\n\ttransform: translate(0, -50%);\n\ttop: 50%;\n\tright: 120%;\n}\n\n.slider.slider-neutral .noUi-connect,\n.slider.slider-neutral.noUi-connect {\n\tbackground-color: #ffffff;\n}\n.slider.slider-neutral.noUi-target {\n\tbackground-color: rgba(255, 255, 255, 0.3);\n}\n.slider.slider-neutral .noUi-handle {\n\tbackground-color: #ffffff;\n}\n.slider.slider-primary .noUi-connect,\n.slider.slider-primary.noUi-connect {\n\tbackground-color: #1c77c3;\n}\n.slider.slider-info .noUi-connect,\n.slider.slider-info.noUi-connect {\n\tbackground-color: #39a9db;\n}\n.slider.slider-success .noUi-connect,\n.slider.slider-success.noUi-connect {\n\tbackground-color: #28a745;\n}\n.slider.slider-warning .noUi-connect,\n.slider.slider-warning.noUi-connect {\n\tbackground-color: #ffc759;\n}\n.slider.slider-danger .noUi-connect,\n.slider.slider-danger.noUi-connect {\n\tbackground-color: #c1292e;\n}\n\n.rbc-btn {\n\tcolor: inherit;\n\tfont: inherit;\n\tmargin: 0;\n}\n\nbutton.rbc-btn {\n\toverflow: visible;\n\ttext-transform: none;\n\tcursor: pointer;\n}\n\nbutton[disabled].rbc-btn {\n\tcursor: not-allowed;\n}\n\nbutton.rbc-input::-moz-focus-inner {\n\tborder: 0;\n\tpadding: 0;\n}\n\n.rbc-calendar {\n\tbox-sizing: border-box;\n\theight: 100%;\n\tdisplay: -webkit-flex;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-flex-direction: column;\n\t-ms-flex-direction: column;\n\tflex-direction: column;\n\t-webkit-align-items: stretch;\n\t-ms-flex-align: stretch;\n\talign-items: stretch;\n}\n\n.rbc-calendar *,\n.rbc-calendar *:before,\n.rbc-calendar *:after {\n\tbox-sizing: inherit;\n}\n\n.rbc-abs-full,\n.rbc-row-bg {\n\toverflow: hidden;\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\tright: 0;\n\tbottom: 0;\n}\n\n.rbc-ellipsis,\n.rbc-event-label,\n.rbc-row-segment .rbc-event-content,\n.rbc-show-more {\n\tdisplay: block;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\twhite-space: nowrap;\n}\n\n.rbc-rtl {\n\tdirection: rtl;\n}\n\n.rbc-off-range {\n\tcolor: #333333;\n\topacity: 0.3;\n}\n\n.rbc-header {\n\toverflow: hidden;\n\t-webkit-flex: 1 0 0%;\n\t-ms-flex: 1 0 0%;\n\tflex: 1 0 0%;\n\ttext-overflow: ellipsis;\n\twhite-space: nowrap;\n\tpadding: 0 3px;\n\ttext-align: right;\n\tvertical-align: middle;\n\tfont-weight: bold;\n\tfont-size: 1em;\n\tmin-height: 0;\n\tborder-bottom: 1px solid #ddd;\n\tcolor: #999999;\n}\n.rbc-header:last-child span {\n\tpadding-right: 15px;\n}\n\n.rbc-header > a,\n.rbc-header > a:active,\n.rbc-header > a:visited {\n\tcolor: inherit;\n\ttext-decoration: none;\n}\n\n.rbc-row-content {\n\tposition: relative;\n\t-moz-user-select: none;\n\t-ms-user-select: none;\n\tuser-select: none;\n\t-webkit-user-select: none;\n\tz-index: 4;\n\tmin-height: 153px;\n}\n\n.rbc-toolbar {\n\tdisplay: -webkit-flex;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-align-items: center;\n\t-ms-flex-align: center;\n\talign-items: center;\n\tmargin-bottom: 10px;\n\tfont-size: 16px;\n\tpadding-top: 20px;\n\tpadding-left: 20px;\n\tpadding-right: 20px;\n}\n\n.rbc-toolbar .rbc-toolbar-label {\n\t-webkit-flex-grow: 1;\n\t-ms-flex-positive: 1;\n\tflex-grow: 1;\n\tpadding: 0 10px;\n\ttext-align: center;\n\tfont-family: inherit;\n\tline-height: 1.5em;\n\tcolor: inherit;\n\tfont-weight: 500;\n\tmargin: 0;\n\tfont-size: 2.5em;\n}\n\n.rbc-toolbar button {\n\tbackground-color: #65adff;\n\tcolor: #ffffff;\n\tborder-width: 2px;\n\tfont-weight: 400;\n\tfont-size: 14px;\n\tline-height: 20px;\n\tmargin: 5px 1px;\n\tborder: none;\n\tmargin: 10px 1px;\n\tborder-radius: 30px;\n\tpadding: 6px 12px;\n\tcursor: pointer;\n\ttransition: all 0.2s ease-in-out;\n\toutline: none;\n}\n.rbc-toolbar button:hover,\n.rbc-toolbar button:focus,\n.rbc-toolbar button:active,\n.rbc-toolbar button.active,\n.rbc-toolbar button:active:focus,\n.rbc-toolbar button:active:hover,\n.rbc-toolbar button.active:focus,\n.rbc-toolbar button.active:hover,\n.show > .rbc-toolbar button.dropdown-toggle,\n.show > .rbc-toolbar button.dropdown-toggle:focus,\n.show > .rbc-toolbar button.dropdown-toggle:hover {\n\tbackground-color: #403d39 !important;\n\tcolor: #ffffff !important;\n\tbox-shadow: none !important;\n}\n.rbc-toolbar button:not([data-action]):hover {\n\tbox-shadow: none;\n}\n.rbc-toolbar button.disabled,\n.rbc-toolbar button.disabled:hover,\n.rbc-toolbar button.disabled:focus,\n.rbc-toolbar button.disabled.focus,\n.rbc-toolbar button.disabled:active,\n.rbc-toolbar button.disabled.active,\n.rbc-toolbar button:disabled,\n.rbc-toolbar button:disabled:hover,\n.rbc-toolbar button:disabled:focus,\n.rbc-toolbar button:disabled.focus,\n.rbc-toolbar button:disabled:active,\n.rbc-toolbar button:disabled.active,\n.rbc-toolbar button[disabled],\n.rbc-toolbar button[disabled]:hover,\n.rbc-toolbar button[disabled]:focus,\n.rbc-toolbar button[disabled].focus,\n.rbc-toolbar button[disabled]:active,\n.rbc-toolbar button[disabled].active,\nfieldset[disabled] .rbc-toolbar button,\nfieldset[disabled] .rbc-toolbar button:hover,\nfieldset[disabled] .rbc-toolbar button:focus,\nfieldset[disabled] .rbc-toolbar button.focus,\nfieldset[disabled] .rbc-toolbar button:active,\nfieldset[disabled] .rbc-toolbar button.active {\n\tbackground-color: #65adff;\n\tborder-color: #65adff;\n}\n.rbc-toolbar button.btn-simple {\n\tcolor: #65adff;\n\tborder-color: #65adff;\n}\n.rbc-toolbar button.btn-simple:hover,\n.rbc-toolbar button.btn-simple:focus,\n.rbc-toolbar button.btn-simple:active {\n\tbackground-color: transparent;\n\tcolor: #403d39;\n\tborder-color: #403d39;\n\tbox-shadow: none;\n}\n.rbc-toolbar button.btn-link {\n\tcolor: #65adff;\n}\n.rbc-toolbar button.btn-link:hover,\n.rbc-toolbar button.btn-link:focus,\n.rbc-toolbar button.btn-link:active,\n.rbc-toolbar button.btn-link:active:focus {\n\tbackground-color: transparent;\n\tcolor: #403d39;\n\ttext-decoration: none;\n\tbox-shadow: none;\n}\n\n.rbc-toolbar button:focus {\n\toutline: none;\n}\n\n.rbc-btn-group {\n\tdisplay: inline-block;\n}\n\n.rbc-btn-group button {\n\tmargin: 0 0 0 2px;\n\tborder-radius: 30px;\n}\n\n@media screen and (max-width: 526px) {\n\t.rbc-btn-group button {\n\t\tmargin: 2px !important;\n\t}\n}\n.rbc-btn-group button + button {\n\tmargin: 0 0 0 2px;\n\tborder-radius: 30px;\n}\n\n.rbc-btn-group + .rbc-btn-group,\n.rbc-btn-group + button {\n\tmargin-left: 10px;\n}\n\n.rbc-slot-selecting .rbc-event {\n\tcursor: inherit;\n\tpointer-events: none;\n}\n\n.rbc-event.rbc-selected {\n\tbackground-color: #265985;\n}\n\n.rbc-event-label {\n\tfont-size: 80%;\n}\n\n.rbc-event-overlaps {\n\tbox-shadow: -1px 1px 5px 0px rgba(51, 51, 51, 0.5);\n}\n\n.rbc-event-continues-prior {\n\tborder-top-left-radius: 0;\n\tborder-bottom-left-radius: 0;\n}\n\n.rbc-event-continues-after {\n\tborder-top-right-radius: 0;\n\tborder-bottom-right-radius: 0;\n}\n\n.rbc-event-continues-earlier {\n\tborder-top-left-radius: 0;\n\tborder-top-right-radius: 0;\n}\n\n.rbc-event-continues-later {\n\tborder-bottom-left-radius: 0;\n\tborder-bottom-right-radius: 0;\n}\n\n.rbc-event-continues-day-after {\n\tborder-bottom-left-radius: 0;\n\tborder-bottom-right-radius: 0;\n}\n\n.rbc-event-continues-day-prior {\n\tborder-top-left-radius: 0;\n\tborder-top-right-radius: 0;\n}\n\n.rbc-row {\n\tdisplay: -webkit-flex;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-flex-direction: row;\n\t-ms-flex-direction: row;\n\tflex-direction: row;\n}\n\n.rbc-row-segment {\n\tpadding: 2px 6px 1px;\n}\n\n.rbc-selected-cell {\n\tbackground-color: rgba(0, 0, 0, 0.1);\n}\n\n.rbc-show-more {\n\tbackground-color: rgba(255, 255, 255, 0.3);\n\tz-index: 4;\n\tfont-weight: bold;\n\tfont-size: 85%;\n\theight: auto;\n\tline-height: normal;\n\twhite-space: nowrap;\n}\n\n.rbc-month-view {\n\tposition: relative;\n\tborder: 1px solid #ddd;\n\tdisplay: -webkit-flex;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-flex-direction: column;\n\t-ms-flex-direction: column;\n\tflex-direction: column;\n\t-webkit-flex: 1 0 0;\n\t-ms-flex: 1 0 0px;\n\tflex: 1 0 0;\n\twidth: 100%;\n\t-moz-user-select: none;\n\t-ms-user-select: none;\n\tuser-select: none;\n\t-webkit-user-select: none;\n\theight: 100%;\n\tborder-left: none;\n\tborder-right: none;\n}\n\n.rbc-month-view {\n\tborder-top: none;\n}\n\n.rbc-month-header {\n\tdisplay: -webkit-flex;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-flex-direction: row;\n\t-ms-flex-direction: row;\n\tflex-direction: row;\n}\n\n.rbc-month-row {\n\tdisplay: -webkit-flex;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\tposition: relative;\n\t-webkit-flex-direction: column;\n\t-ms-flex-direction: column;\n\tflex-direction: column;\n\t-webkit-flex: 1 0 0;\n\t-ms-flex: 1 0 0px;\n\tflex: 1 0 0;\n\t-ms-flex-preferred-size: 0px;\n\toverflow: hidden;\n\theight: 100%;\n}\n\n.rbc-month-row + .rbc-month-row {\n\tborder-top: 1px solid #ddd;\n}\n\n.rbc-date-cell {\n\tflex: 1 1;\n\tmin-width: 0;\n\tpadding-left: 5px;\n\ttext-align: left;\n}\n\n.rbc-date-cell.rbc-now {\n\tfont-weight: bold;\n}\n\n.rbc-date-cell > a,\n.rbc-date-cell > a:active,\n.rbc-date-cell > a:visited {\n\tcolor: inherit;\n\ttext-decoration: none;\n}\n\n.rbc-row-bg {\n\tdisplay: -webkit-flex;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-flex-direction: row;\n\t-ms-flex-direction: row;\n\tflex-direction: row;\n\t-webkit-flex: 1 0 0;\n\t-ms-flex: 1 0 0px;\n\tflex: 1 0 0;\n\toverflow: hidden;\n}\n\n.rbc-day-bg {\n\t-webkit-flex: 1 0 0%;\n\t-ms-flex: 1 0 0%;\n\tflex: 1 0 0%;\n}\n\n.rbc-day-bg + .rbc-day-bg {\n\tborder-left: 1px solid #ddd;\n}\n\n.rbc-rtl .rbc-day-bg + .rbc-day-bg {\n\tborder-left-width: 0;\n\tborder-right: 1px solid #ddd;\n}\n\n.rbc-overlay {\n\tposition: absolute;\n\tz-index: 5;\n\tborder: 1px solid #e5e5e5;\n\tbackground-color: #fff;\n\tbox-shadow: 0 5px 15px rgba(0, 0, 0, 0.25);\n\tpadding: 10px;\n}\n\n.rbc-overlay > * + * {\n\tmargin-top: 1px;\n}\n\n.rbc-overlay-header {\n\tborder-bottom: 1px solid #e5e5e5;\n\tmargin: -10px -10px 5px -10px;\n\tpadding: 2px 10px;\n}\n\n.rbc-agenda-view {\n\tdisplay: -webkit-flex;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-flex-direction: column;\n\t-ms-flex-direction: column;\n\tflex-direction: column;\n\t-webkit-flex: 1 0 0;\n\t-ms-flex: 1 0 0px;\n\tflex: 1 0 0;\n\toverflow: auto;\n}\n\n.rbc-agenda-view table.rbc-agenda-table {\n\twidth: 100%;\n\tborder: 1px solid #ddd;\n\tborder-spacing: 0;\n\tborder-collapse: collapse;\n}\n\n.rbc-agenda-view table.rbc-agenda-table tbody > tr > td {\n\tpadding: 5px 10px;\n\tvertical-align: top;\n}\n\n.rbc-agenda-view table.rbc-agenda-table .rbc-agenda-time-cell {\n\tpadding-left: 15px;\n\tpadding-right: 15px;\n\ttext-transform: lowercase;\n}\n\n.rbc-agenda-view table.rbc-agenda-table tbody > tr > td + td {\n\tborder-left: 1px solid #ddd;\n}\n\n.rbc-rtl .rbc-agenda-view table.rbc-agenda-table tbody > tr > td + td {\n\tborder-left-width: 0;\n\tborder-right: 1px solid #ddd;\n}\n\n.rbc-agenda-view table.rbc-agenda-table tbody > tr + tr {\n\tborder-top: 1px solid #ddd;\n}\n\n.rbc-agenda-view table.rbc-agenda-table thead > tr > th {\n\tpadding: 3px 5px;\n\ttext-align: left;\n\tborder-bottom: 1px solid #ddd;\n}\n\n.rbc-rtl .rbc-agenda-view table.rbc-agenda-table thead > tr > th {\n\ttext-align: right;\n}\n\n.rbc-agenda-time-cell {\n\ttext-transform: lowercase;\n}\n\n.rbc-agenda-time-cell .rbc-continues-after:after {\n\tcontent: \" »\";\n}\n\n.rbc-agenda-time-cell .rbc-continues-prior:before {\n\tcontent: \"« \";\n}\n\n.rbc-agenda-date-cell,\n.rbc-agenda-time-cell {\n\twhite-space: nowrap;\n}\n\n.rbc-agenda-event-cell {\n\twidth: 100%;\n}\n\n.rbc-time-column {\n\tdisplay: -webkit-flex;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-flex-direction: column;\n\t-ms-flex-direction: column;\n\tflex-direction: column;\n\tmin-height: 100%;\n}\n\n.rbc-time-column .rbc-timeslot-group {\n\t-webkit-flex: 1;\n\t-ms-flex: 1;\n\tflex: 1;\n}\n\n.rbc-timeslot-group {\n\tborder-bottom: 1px solid #ddd;\n\tmin-height: 40px;\n\tdisplay: -webkit-flex;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-flex-flow: column nowrap;\n\t-ms-flex-flow: column nowrap;\n\tflex-flow: column nowrap;\n}\n\n.rbc-time-gutter,\n.rbc-header-gutter {\n\t-webkit-flex: none;\n\t-ms-flex: none;\n\tflex: none;\n}\n\n.rbc-label {\n\tpadding: 0 5px;\n}\n\n.rbc-day-slot {\n\tposition: relative;\n}\n\n.rbc-day-slot .rbc-events-container {\n\tbottom: 0;\n\tleft: 0;\n\tposition: absolute;\n\tright: 10px;\n\ttop: 0;\n}\n\n.rbc-day-slot .rbc-events-container.rbc-is-rtl {\n\tleft: 10px;\n\tright: 0;\n}\n\n.rbc-day-slot .rbc-event {\n\tdisplay: -webkit-flex;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\tmax-height: 100%;\n\tmin-height: 20px;\n\t-webkit-flex-flow: column wrap;\n\t-ms-flex-flow: column wrap;\n\tflex-flow: column wrap;\n\t-webkit-align-items: flex-start;\n\t-ms-flex-align: start;\n\talign-items: flex-start;\n\toverflow: hidden;\n\tposition: absolute;\n}\n\n.rbc-day-slot .rbc-event-label {\n\t-webkit-flex: none;\n\t-ms-flex: none;\n\tflex: none;\n\tpadding-right: 5px;\n\twidth: auto;\n\tfont-weight: bold;\n\t-webkit-box-sizing: content-box;\n\t-moz-box-sizing: content-box;\n\tbox-sizing: content-box;\n\tcolor: #fff;\n\twhite-space: nowrap;\n}\n\n.rbc-day-slot .rbc-event-content {\n\twidth: 100%;\n\t-webkit-flex: 1 1 0;\n\t-ms-flex: 1 1 0px;\n\tflex: 1 1 0;\n\tword-wrap: break-word;\n\tline-height: 1;\n\theight: 100%;\n\tmin-height: 1em;\n}\n\n.rbc-day-slot .rbc-time-slot + .rbc-time-slot {\n\tborder-top: 1px dotted #ddd;\n}\n\n.rbc-time-slot {\n\t-webkit-flex: 1 0 0;\n\t-ms-flex: 1 0 0px;\n\tflex: 1 0 0;\n}\n\n.rbc-time-slot.rbc-now {\n\tfont-weight: bold;\n}\n\n.rbc-day-header {\n\ttext-align: center;\n}\n\n.rbc-slot-selection {\n\tz-index: 10;\n\tposition: absolute;\n\tbackground-color: rgba(0, 0, 0, 0.5);\n\tcolor: white;\n\tfont-size: 75%;\n\twidth: 100%;\n\tpadding: 3px;\n}\n\n.rbc-slot-selecting {\n\tcursor: move;\n}\n\n.rbc-time-view {\n\tdisplay: -webkit-flex;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-flex-direction: column;\n\t-ms-flex-direction: column;\n\tflex-direction: column;\n\t-webkit-flex: 1;\n\t-ms-flex: 1;\n\tflex: 1;\n\twidth: 100%;\n\tborder: 1px solid #ddd;\n\tmin-height: 0;\n\tborder-left: none;\n\tborder-right: none;\n\tborder-top: none;\n}\n\n.rbc-time-view .rbc-time-gutter {\n\twhite-space: nowrap;\n}\n\n.rbc-time-view .rbc-allday-cell {\n\tbox-sizing: content-box;\n\twidth: 100%;\n\tposition: relative;\n}\n\n.rbc-time-view .rbc-allday-events {\n\tposition: relative;\n\tz-index: 4;\n}\n\n.rbc-time-view .rbc-row {\n\tbox-sizing: border-box;\n\tmin-height: 20px;\n}\n\n.rbc-time-header {\n\tdisplay: -webkit-flex;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-flex: 0 0 auto;\n\t-ms-flex: 0 0 auto;\n\tflex: 0 0 auto;\n\t-webkit-flex-direction: row;\n\t-ms-flex-direction: row;\n\tflex-direction: row;\n}\n\n.rbc-time-header.rbc-overflowing {\n\tborder-right: 1px solid #ddd;\n}\n\n.rbc-rtl .rbc-time-header.rbc-overflowing {\n\tborder-right-width: 0;\n\tborder-left: 1px solid #ddd;\n}\n\n.rbc-time-header > .rbc-row:first-child {\n\tborder-bottom: 1px solid #ddd;\n}\n\n.rbc-time-header > .rbc-row.rbc-row-resource {\n\tborder-bottom: 1px solid #ddd;\n}\n\n.rbc-time-header-content {\n\t-webkit-flex: 1;\n\t-ms-flex: 1;\n\tflex: 1;\n\tmin-width: 0;\n\t-webkit-flex-direction: column;\n\t-ms-flex-direction: column;\n\tflex-direction: column;\n\tborder-left: 1px solid #ddd;\n}\n\n.rbc-rtl .rbc-time-header-content {\n\tborder-left-width: 0;\n\tborder-right: 1px solid #ddd;\n}\n\n.rbc-time-content {\n\tdisplay: -webkit-flex;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-flex: 1 0 0%;\n\t-ms-flex: 1 0 0%;\n\tflex: 1 0 0%;\n\t-webkit-align-items: flex-start;\n\t-ms-flex-align: start;\n\talign-items: flex-start;\n\twidth: 100%;\n\tborder-top: 2px solid #ddd;\n\toverflow-y: auto;\n\tposition: relative;\n}\n\n.rbc-time-content > .rbc-time-gutter {\n\t-webkit-flex: none;\n\t-ms-flex: none;\n\tflex: none;\n}\n\n.rbc-time-content > * + * > * {\n\tborder-left: 1px solid #ddd;\n}\n\n.rbc-rtl .rbc-time-content > * + * > * {\n\tborder-left-width: 0;\n\tborder-right: 1px solid #ddd;\n}\n\n.rbc-time-content > .rbc-day-slot {\n\twidth: 100%;\n\t-moz-user-select: none;\n\t-ms-user-select: none;\n\tuser-select: none;\n\t-webkit-user-select: none;\n}\n\n.rbc-current-time-indicator {\n\tposition: absolute;\n\tz-index: 3;\n\theight: 1px;\n\tbackground-color: #74ad31;\n\tpointer-events: none;\n}\n\n.rbc-event {\n\twidth: 100%;\n\tposition: relative;\n\t/* for resize handle and other inner positioning */\n\tdisplay: block;\n\t/* make the <a> tag block */\n\tfont-size: 0.85em;\n\tborder-radius: 2px;\n\tpadding: 0;\n\tbackground-color: rgba(28, 119, 195, 0.2);\n\t/* default BACKGROUND color */\n\tfont-weight: normal;\n\t/* undo jqui's ui-widget-header bold */\n\ttext-align: left;\n\tborder: none;\n\tpadding-bottom: 1px;\n\tline-height: 1.2;\n}\n.rbc-event.event-azure {\n\tbackground-color: rgba(57, 169, 219, 0.2);\n}\n.rbc-event.event-green {\n\tbackground-color: rgba(19, 117, 71, 0.2);\n}\n.rbc-event.event-orange {\n\tbackground-color: rgba(255, 199, 89, 0.2);\n}\n.rbc-event.event-red {\n\tbackground-color: rgba(193, 41, 46, 0.2);\n}\n.rbc-event .rbc-event-content {\n\tposition: relative;\n\tz-index: 2;\n\twhite-space: nowrap;\n\toverflow: hidden;\n\tcolor: inherit;\n\tpadding: 0 5px;\n}\n\n.rbc-day-slot .rbc-event {\n\tdisplay: block !important;\n\theight: unset !important;\n\tmax-height: unset !important;\n}\n\n.rbc-today {\n\tbackground-color: #f5f5f5;\n}\n\n@media screen and (max-width: 1373px) {\n\t.rbc-toolbar {\n\t\tdisplay: block;\n\t}\n\t.rbc-toolbar .rbc-btn-group {\n\t\tdisplay: block;\n\t\ttext-align: center;\n\t}\n\t.rbc-toolbar .rbc-toolbar-label {\n\t\tdisplay: block;\n\t\tflex-grow: unset;\n\t\tpadding: 0;\n\t}\n}\n.sweet-alert:focus {\n\toutline: none;\n}\n\n.sweet-alert {\n\tmargin: auto !important;\n}\n\n.bootstrap-switch {\n\tdisplay: inline-block;\n\tdirection: ltr;\n\tcursor: pointer;\n\tborder-radius: 30px;\n\tborder: 0;\n\tposition: relative;\n\ttext-align: left;\n\toverflow: hidden;\n\tmargin-bottom: 5px;\n\tline-height: 8px;\n\twidth: 61px !important;\n\theight: 26px;\n\toutline: none;\n\tz-index: 0;\n\tmargin-right: 1px;\n\t-webkit-user-select: none;\n\t-moz-user-select: none;\n\t-ms-user-select: none;\n\tuser-select: none;\n\tvertical-align: middle;\n\t-webkit-transition: border-color ease-in-out 0.15s,\n\t\tbox-shadow ease-in-out 0.15s;\n\ttransition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;\n}\n\n.bootstrap-switch .bootstrap-switch-container {\n\tdisplay: inline-flex;\n\ttop: 0;\n\theight: 26px;\n\tborder-radius: 4px;\n\t-webkit-transform: translate3d(0, 0, 0);\n\ttransform: translate3d(0, 0, 0);\n\twidth: 100px !important;\n}\n\n.bootstrap-switch .bootstrap-switch-handle-on,\n.bootstrap-switch .bootstrap-switch-handle-off,\n.bootstrap-switch .bootstrap-switch-label {\n\t-webkit-box-sizing: border-box;\n\t-moz-box-sizing: border-box;\n\tbox-sizing: border-box;\n\tcursor: pointer;\n\tdisplay: inline-block !important;\n\theight: 100%;\n\tcolor: #fff;\n\tpadding: 6px 10px;\n\tfont-size: 11px;\n\ttext-indent: -5px;\n\tline-height: 15px;\n\t-webkit-transition: 0.25s ease-out;\n\ttransition: 0.25s ease-out;\n}\n.bootstrap-switch .bootstrap-switch-handle-on i,\n.bootstrap-switch .bootstrap-switch-handle-off i,\n.bootstrap-switch .bootstrap-switch-label i {\n\tfont-size: 12px;\n\tline-height: 14px;\n}\n\n.bootstrap-switch .bootstrap-switch-handle-on,\n.bootstrap-switch .bootstrap-switch-handle-off {\n\ttext-align: center;\n\tz-index: 1;\n\tfloat: left;\n\twidth: 50% !important;\n\tbackground-color: #66615b;\n}\n\n.bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-primary,\n.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-primary {\n\tcolor: #fff;\n\tbackground: #7a9e9f;\n}\n\n.bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-info,\n.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-info {\n\tcolor: #fff;\n\tbackground: #68b3c8;\n}\n\n.bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-success,\n.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-success {\n\tcolor: #fff;\n\tbackground: #7ac29a;\n}\n\n.bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-warning,\n.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-warning {\n\tbackground: #f3bb45;\n\tcolor: #fff;\n}\n\n.bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-danger,\n.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-danger {\n\tcolor: #fff;\n\tbackground: #eb5e28;\n}\n\n.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-default {\n\tcolor: #fff;\n\tbackground: #cfcfca;\n}\n\n.bootstrap-switch .bootstrap-switch-label {\n\ttext-align: center;\n\tz-index: 100;\n\tcolor: #333333;\n\tbackground: #ffffff;\n\twidth: 22px !important;\n\theight: 22px;\n\tmargin: 2px -11px;\n\tborder-radius: 12px;\n\tposition: relative;\n\tfloat: left;\n\tpadding: 0;\n\tbackground-color: #ffffff;\n\tbox-shadow: 0 1px 1px #ffffff inset, 0 1px 1px rgba(0, 0, 0, 0.25);\n}\n\n.bootstrap-switch .bootstrap-switch-handle-on {\n\tborder-bottom-left-radius: 3px;\n\tborder-top-left-radius: 3px;\n}\n\n.bootstrap-switch .bootstrap-switch-handle-off {\n\ttext-indent: 6px;\n}\n\n.bootstrap-switch input[type=\"radio\"],\n.bootstrap-switch input[type=\"checkbox\"] {\n\tposition: absolute !important;\n\ttop: 0;\n\tleft: 0;\n\topacity: 0;\n\tfilter: alpha(opacity=0);\n\tz-index: -1;\n}\n\n.bootstrap-switch input[type=\"radio\"].form-control,\n.bootstrap-switch input[type=\"checkbox\"].form-control {\n\theight: auto;\n}\n\n.bootstrap-switch.bootstrap-switch-mini .bootstrap-switch-handle-on,\n.bootstrap-switch.bootstrap-switch-mini .bootstrap-switch-handle-off,\n.bootstrap-switch.bootstrap-switch-mini .bootstrap-switch-label {\n\tpadding: 1px 5px;\n\tfont-size: 12px;\n\tline-height: 1.5;\n}\n\n.bootstrap-switch.bootstrap-switch-small .bootstrap-switch-handle-on,\n.bootstrap-switch.bootstrap-switch-small .bootstrap-switch-handle-off,\n.bootstrap-switch.bootstrap-switch-small .bootstrap-switch-label {\n\tpadding: 5px 10px;\n\tfont-size: 12px;\n\tline-height: 1.5;\n}\n\n.bootstrap-switch.bootstrap-switch-large .bootstrap-switch-handle-on,\n.bootstrap-switch.bootstrap-switch-large .bootstrap-switch-handle-off,\n.bootstrap-switch.bootstrap-switch-large .bootstrap-switch-label {\n\tpadding: 6px 16px;\n\tfont-size: 18px;\n\tline-height: 1.33;\n}\n\n.bootstrap-switch.bootstrap-switch-disabled,\n.bootstrap-switch.bootstrap-switch-readonly,\n.bootstrap-switch.bootstrap-switch-indeterminate {\n\tcursor: default !important;\n}\n\n.bootstrap-switch.bootstrap-switch-disabled .bootstrap-switch-handle-on,\n.bootstrap-switch.bootstrap-switch-readonly .bootstrap-switch-handle-on,\n.bootstrap-switch.bootstrap-switch-indeterminate .bootstrap-switch-handle-on,\n.bootstrap-switch.bootstrap-switch-disabled .bootstrap-switch-handle-off,\n.bootstrap-switch.bootstrap-switch-readonly .bootstrap-switch-handle-off,\n.bootstrap-switch.bootstrap-switch-indeterminate .bootstrap-switch-handle-off,\n.bootstrap-switch.bootstrap-switch-disabled .bootstrap-switch-label,\n.bootstrap-switch.bootstrap-switch-readonly .bootstrap-switch-label,\n.bootstrap-switch.bootstrap-switch-indeterminate .bootstrap-switch-label {\n\topacity: 0.5;\n\tfilter: alpha(opacity=50);\n\tcursor: default !important;\n}\n\n.bootstrap-switch.bootstrap-switch-animate .bootstrap-switch-container {\n\t-webkit-transition: margin-left 0.5s;\n\ttransition: margin-left 0.5s;\n}\n\n.bootstrap-switch.bootstrap-switch-inverse .bootstrap-switch-handle-on {\n\tborder-bottom-left-radius: 0;\n\tborder-top-left-radius: 0;\n\tborder-bottom-right-radius: 3px;\n\tborder-top-right-radius: 3px;\n}\n\n.bootstrap-switch.bootstrap-switch-inverse .bootstrap-switch-handle-off {\n\tborder-bottom-right-radius: 0;\n\tborder-top-right-radius: 0;\n\tborder-bottom-left-radius: 3px;\n\tborder-top-left-radius: 3px;\n}\n\n.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-container {\n\tmargin-left: -2px !important;\n}\n\n.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-container {\n\tmargin-left: -37px !important;\n}\n\n.bootstrap-switch.bootstrap-switch-on:hover .bootstrap-switch-label {\n\twidth: 26px !important;\n\tmargin: 2px -15px;\n}\n\n.bootstrap-switch.bootstrap-switch-off:hover .bootstrap-switch-label {\n\twidth: 26px !important;\n\tmargin: 2px -15px -13px -11px;\n}\n\n.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-handle-off {\n\tbackground-color: #66615b;\n}\n\n.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-handle-on {\n\tbackground-color: #cfcfca;\n}\n\n.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-danger {\n\tbackground-color: #eb5e28;\n}\n\n.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-warning {\n\tbackground-color: #f3bb45;\n}\n\n.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-success {\n\tbackground-color: #7ac29a;\n}\n\n.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-primary {\n\tbackground-color: #7a9e9f;\n}\n\n.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-info {\n\tbackground-color: #68b3c8;\n}\n\n.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-default {\n\tbackground-color: #66615b;\n}\n\n.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-danger,\n.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-primary,\n.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-info,\n.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-warning,\n.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-success {\n\tbackground-color: #cfcfca;\n}\n\n.bootstrap-switch.wrapper {\n\tmin-height: auto;\n\theight: auto;\n}\n\n.card-wizard {\n\tmin-height: 410px;\n\tbox-shadow: 0 2px 2px rgba(204, 197, 185, 0.5);\n\topacity: 0;\n\t-webkit-transition: all 300ms linear;\n\t-moz-transition: all 300ms linear;\n\t-o-transition: all 300ms linear;\n\t-ms-transition: all 300ms linear;\n\ttransition: all 300ms linear;\n}\n.card-wizard[data-color=\"primary\"] .moving-tab {\n\tcolor: #1c77c3;\n}\n.card-wizard[data-color=\"primary\"] .picture:hover {\n\tborder-color: #1c77c3;\n}\n.card-wizard[data-color=\"primary\"] .choice:hover .icon,\n.card-wizard[data-color=\"primary\"] .choice.active .icon {\n\tborder-color: #1c77c3;\n\tcolor: #1c77c3;\n}\n.card-wizard[data-color=\"primary\"]\n\t.checkbox\n\tinput[type=\"checkbox\"]:checked\n\t+ .checkbox-material\n\t.check {\n\tbackground-color: #1c77c3;\n}\n.card-wizard[data-color=\"primary\"] .radio input[type=\"radio\"]:checked ~ .check {\n\tbackground-color: #1c77c3;\n}\n.card-wizard[data-color=\"primary\"]\n\t.radio\n\tinput[type=\"radio\"]:checked\n\t~ .circle {\n\tborder-color: #1c77c3;\n}\n.card-wizard[data-color=\"white\"] .moving-tab {\n\tcolor: #ffffff;\n}\n.card-wizard[data-color=\"white\"] .picture:hover {\n\tborder-color: #ffffff;\n}\n.card-wizard[data-color=\"white\"] .choice:hover .icon,\n.card-wizard[data-color=\"white\"] .choice.active .icon {\n\tborder-color: #ffffff;\n\tcolor: #ffffff;\n}\n.card-wizard[data-color=\"white\"]\n\t.checkbox\n\tinput[type=\"checkbox\"]:checked\n\t+ .checkbox-material\n\t.check {\n\tbackground-color: #ffffff;\n}\n.card-wizard[data-color=\"white\"] .radio input[type=\"radio\"]:checked ~ .check {\n\tbackground-color: #ffffff;\n}\n.card-wizard[data-color=\"white\"] .radio input[type=\"radio\"]:checked ~ .circle {\n\tborder-color: #ffffff;\n}\n.card-wizard[data-color=\"green\"] .moving-tab {\n\tcolor: #28a745;\n}\n.card-wizard[data-color=\"green\"] .picture:hover {\n\tborder-color: #28a745;\n}\n.card-wizard[data-color=\"green\"] .choice:hover .icon,\n.card-wizard[data-color=\"green\"] .choice.active .icon {\n\tborder-color: #28a745;\n\tcolor: #28a745;\n}\n.card-wizard[data-color=\"green\"]\n\t.checkbox\n\tinput[type=\"checkbox\"]:checked\n\t+ .checkbox-material\n\t.check {\n\tbackground-color: #28a745;\n}\n.card-wizard[data-color=\"green\"] .radio input[type=\"radio\"]:checked ~ .check {\n\tbackground-color: #28a745;\n}\n.card-wizard[data-color=\"green\"] .radio input[type=\"radio\"]:checked ~ .circle {\n\tborder-color: #28a745;\n}\n.card-wizard[data-color=\"blue\"] .moving-tab {\n\tcolor: #39a9db;\n}\n.card-wizard[data-color=\"blue\"] .picture:hover {\n\tborder-color: #39a9db;\n}\n.card-wizard[data-color=\"blue\"] .choice:hover .icon,\n.card-wizard[data-color=\"blue\"] .choice.active .icon {\n\tborder-color: #39a9db;\n\tcolor: #39a9db;\n}\n.card-wizard[data-color=\"blue\"]\n\t.checkbox\n\tinput[type=\"checkbox\"]:checked\n\t+ .checkbox-material\n\t.check {\n\tbackground-color: #39a9db;\n}\n.card-wizard[data-color=\"blue\"] .radio input[type=\"radio\"]:checked ~ .check {\n\tbackground-color: #39a9db;\n}\n.card-wizard[data-color=\"blue\"] .radio input[type=\"radio\"]:checked ~ .circle {\n\tborder-color: #39a9db;\n}\n.card-wizard[data-color=\"orange\"] .moving-tab {\n\tcolor: #ffc759;\n}\n.card-wizard[data-color=\"orange\"] .picture:hover {\n\tborder-color: #ffc759;\n}\n.card-wizard[data-color=\"orange\"] .choice:hover .icon,\n.card-wizard[data-color=\"orange\"] .choice.active .icon {\n\tborder-color: #ffc759;\n\tcolor: #ffc759;\n}\n.card-wizard[data-color=\"orange\"]\n\t.checkbox\n\tinput[type=\"checkbox\"]:checked\n\t+ .checkbox-material\n\t.check {\n\tbackground-color: #ffc759;\n}\n.card-wizard[data-color=\"orange\"] .radio input[type=\"radio\"]:checked ~ .check {\n\tbackground-color: #ffc759;\n}\n.card-wizard[data-color=\"orange\"] .radio input[type=\"radio\"]:checked ~ .circle {\n\tborder-color: #ffc759;\n}\n.card-wizard[data-color=\"red\"] .moving-tab {\n\tcolor: #c1292e;\n}\n.card-wizard[data-color=\"red\"] .picture:hover {\n\tborder-color: #c1292e;\n}\n.card-wizard[data-color=\"red\"] .choice:hover .icon,\n.card-wizard[data-color=\"red\"] .choice.active .icon {\n\tborder-color: #c1292e;\n\tcolor: #c1292e;\n}\n.card-wizard[data-color=\"red\"]\n\t.checkbox\n\tinput[type=\"checkbox\"]:checked\n\t+ .checkbox-material\n\t.check {\n\tbackground-color: #c1292e;\n}\n.card-wizard[data-color=\"red\"] .radio input[type=\"radio\"]:checked ~ .check {\n\tbackground-color: #c1292e;\n}\n.card-wizard[data-color=\"red\"] .radio input[type=\"radio\"]:checked ~ .circle {\n\tborder-color: #c1292e;\n}\n.card-wizard.active {\n\topacity: 1;\n}\n.card-wizard .card-header {\n\tpadding: 15px 0 !important;\n\tpadding-bottom: 40px;\n\tbackground-color: transparent;\n}\n.card-wizard .card-header .card-title {\n\tcolor: #252422;\n}\n.card-wizard .card-header .card-title + .description {\n\tcolor: #292929 !important;\n}\n.card-wizard .nav-pills .nav-item .nav-link {\n\tpadding: 12px;\n}\n.card-wizard .nav-pills .nav-item .nav-link,\n.card-wizard .nav-pills .nav-item .nav-link.active,\n.card-wizard .nav-pills .nav-item .nav-link:hover,\n.card-wizard .nav-pills .nav-item .nav-link:focus,\n.card-wizard .nav-pills .nav-item .nav-link.active:focus,\n.card-wizard .nav-pills .nav-item .nav-link.active:hover {\n\tbackground-color: transparent;\n\tbox-shadow: none;\n}\n.card-wizard .picture-container {\n\tposition: relative;\n\tcursor: pointer;\n\ttext-align: center;\n}\n.card-wizard .wizard-navigation {\n\tposition: relative;\n}\n.card-wizard .wizard-navigation .nav-link {\n\tdisplay: flex;\n\talign-items: center;\n\t-ms-flex-pack: center;\n\tjustify-content: center;\n}\n.card-wizard .wizard-navigation .nav-link i,\n.card-wizard .moving-tab i {\n\tdisplay: inline-block;\n\tfont-size: 19px;\n\tline-height: initial;\n\tmargin-right: 6px;\n\tpadding: 0;\n\tvertical-align: bottom;\n}\n.card-wizard .moving-tab i {\n\tmargin-right: 9px;\n}\n.card-wizard .picture {\n\twidth: 106px;\n\theight: 106px;\n\tbackground-color: #999999;\n\tborder: 1px solid #e3e3e3;\n\tcolor: #ffffff;\n\tborder-radius: 50%;\n\tmargin: 5px auto;\n\toverflow: hidden;\n\ttransition: all 0.2s;\n\t-webkit-transition: all 0.2s;\n}\n.card-wizard .picture:hover {\n\tborder-color: #2ca8ff;\n}\n.card-wizard .moving-tab {\n\tposition: absolute;\n\ttext-align: center;\n\tpadding: 12px;\n\tfont-size: 12px;\n\ttext-transform: uppercase;\n\t-webkit-font-smoothing: subpixel-antialiased;\n\ttop: 0px;\n\tleft: 0px;\n\tbackground-color: #65adff;\n\tbox-shadow: 0 2px 2px rgba(204, 197, 185, 0.5);\n\tcolor: #ffffff !important;\n\tcursor: pointer;\n\tfont-weight: 500;\n}\n.card-wizard .picture input[type=\"file\"] {\n\tcursor: pointer;\n\tdisplay: block;\n\theight: 100%;\n\tleft: 0;\n\topacity: 0 !important;\n\tposition: absolute;\n\ttop: 0;\n\twidth: 100%;\n}\n.card-wizard .picture-src {\n\twidth: 100%;\n}\n.card-wizard .tab-content {\n\tmin-height: 355px;\n\tpadding: 20px 0;\n}\n.card-wizard .wizard-footer {\n\tpadding: 0 15px;\n}\n.card-wizard .wizard-footer .checkbox {\n\tmargin-top: 16px;\n}\n.card-wizard .disabled {\n\tdisplay: none;\n}\n.card-wizard .wizard-header {\n\ttext-align: center;\n\tpadding: 25px 0 35px;\n}\n.card-wizard .wizard-header h5 {\n\tmargin: 5px 0 0;\n}\n.card-wizard .nav-pills > li {\n\ttext-align: center;\n}\n.card-wizard .btn {\n\ttext-transform: uppercase;\n}\n.card-wizard .info-text {\n\ttext-align: center;\n\tfont-weight: 300;\n\tmargin: 10px 0 30px;\n}\n.card-wizard .choice {\n\ttext-align: center;\n\tcursor: pointer;\n\tmargin-top: 20px;\n}\n.card-wizard .choice[disabled] {\n\tpointer-events: none;\n\tcursor: not-allowed;\n\topacity: 0.5;\n}\n.card-wizard .choice .icon {\n\ttext-align: center;\n\tvertical-align: middle;\n\theight: 116px;\n\twidth: 116px;\n\tborder-radius: 50%;\n\tcolor: #65adff;\n\tmargin: 0 auto 20px;\n\tborder: 1px solid #e3e3e3;\n\ttransition: all 0.2s;\n\t-webkit-transition: all 0.2s;\n}\n.card-wizard .choice i {\n\tfont-size: 30px;\n\tline-height: 116px;\n\tposition: absolute;\n\tleft: 0;\n\tright: 0;\n}\n.card-wizard .choice:hover .icon,\n.card-wizard .choice.active .icon {\n\tborder-color: #2ca8ff;\n}\n.card-wizard .choice input[type=\"radio\"],\n.card-wizard .choice input[type=\"checkbox\"] {\n\tposition: absolute;\n\tleft: -10000px;\n\tz-index: -1;\n}\n.card-wizard .btn-finish {\n\tdisplay: none;\n}\n.card-wizard .card-title + .description {\n\tfont-size: 17px;\n\tmargin-bottom: 32px;\n}\n.card-wizard .wizard-title {\n\tmargin: 0;\n}\n.card-wizard .nav-pills {\n\tbackground-color: #292929 !important;\n}\n.card-wizard .nav-pills > li + li {\n\tmargin-left: 0;\n}\n.card-wizard .nav-pills > li > a {\n\tborder: 0 !important;\n\tborder-radius: 0;\n\tline-height: 18px;\n\ttext-transform: uppercase;\n\tfont-size: 12px;\n\tfont-weight: 500;\n\tmin-width: 100px;\n\ttext-align: center;\n\tcolor: #ffffff !important;\n}\n.card-wizard .nav-pills > li.active > a,\n.card-wizard .nav-pills > li.active > a:hover,\n.card-wizard .nav-pills > li.active > a:focus,\n.card-wizard .nav-pills > li > a:hover,\n.card-wizard .nav-pills > li > a:focus {\n\tbackground-color: inherit;\n\tbox-shadow: none;\n}\n.card-wizard .nav-pills > li i {\n\tdisplay: block;\n\tfont-size: 30px;\n\tpadding: 15px 0;\n}\n.card-wizard .form-group.select-wizard {\n\tmargin-top: 15px;\n}\n.card-wizard .dropdown.show .dropdown-menu,\n.card-wizard .dropup.show .dropdown-menu {\n\t-webkit-transform: translate3d(0, 0px, 0) !important;\n\t-moz-transform: translate3d(0, 0px, 0) !important;\n\t-o-transform: translate3d(0, 0px, 0) !important;\n\t-ms-transform: translate3d(0, 0px, 0) !important;\n\ttransform: translate3d(0, 0px, 0) !important;\n}\n\n/*!\n* https://github.com/YouCanBookMe/react-datetime\n*/\n.rdt {\n\tposition: relative;\n}\n.rdt .rdtPicker {\n\t-webkit-transition: all 150ms linear;\n\t-moz-transition: all 150ms linear;\n\t-o-transition: all 150ms linear;\n\t-ms-transition: all 150ms linear;\n\ttransition: all 150ms linear;\n\tmargin-top: -20px;\n\tvisibility: hidden;\n\tdisplay: block;\n\topacity: 0;\n}\n.rdt.rdtOpen .rdtPicker {\n\topacity: 1;\n\tvisibility: visible;\n\tmargin-top: 0;\n}\n\n.rdtPicker {\n\tdisplay: none;\n\tposition: absolute;\n\twidth: 260px;\n\tpadding: 4px;\n\tmargin-top: 1px;\n\tz-index: 99999 !important;\n\tbackground: #fff;\n\tborder-radius: 0.125rem;\n\tbox-shadow: 0px 10px 50px 0px rgba(0, 0, 0, 0.2);\n\t-webkit-background-clip: padding-box;\n\tbackground-clip: padding-box;\n\tmin-width: 160px;\n}\n.rdtPicker:before {\n\tdisplay: inline-block;\n\tposition: absolute;\n\twidth: 0;\n\theight: 0;\n\tvertical-align: middle;\n\tcontent: \"\";\n\ttop: -5px;\n\tleft: 10px;\n\tright: auto;\n\tcolor: #ffffff;\n\tborder-bottom: 0.4em solid;\n\tborder-right: 0.4em solid transparent;\n\tborder-left: 0.4em solid transparent;\n}\n.rdtPicker:after {\n\tborder-bottom: 0.4em solid #ffffff;\n\tborder-right: 0.4em solid transparent;\n\tborder-left: 0.4em solid transparent;\n\tcontent: \"\";\n\tdisplay: inline-block;\n\tposition: absolute;\n\ttop: -5px;\n\tleft: 10px;\n}\n\n.rdtPicker {\n\tdisplay: block;\n\ttop: 40px;\n}\n\n.rdtStatic .rdtPicker {\n\tbox-shadow: none;\n\tposition: static;\n}\n\n.rdtPicker .rdtTimeToggle {\n\ttext-align: center;\n\tpadding: 5px;\n\tborder-radius: 4px;\n}\n\n.rdtPicker table {\n\twidth: 100%;\n\tmargin: 0;\n\tborder-color: #ffffff !important;\n}\n\n.rdtPicker td,\n.rdtPicker th {\n\ttext-align: center;\n\tpadding: 1px;\n}\n\n.rdtPicker td {\n\tcursor: pointer;\n}\n\n.rdtDay {\n\theight: 30px;\n\tline-height: 33px;\n\twidth: 30px;\n\ttext-align: center;\n\tpadding: 0px;\n\tborder-radius: 50%;\n}\n.rdtDay.rdtToday.rdtActive,\n.rdtDay.rdtActive,\n.rdtDay.rdtActive:hover {\n\tbackground-color: #1c77c3 !important;\n\tcolor: #ffffff;\n}\n\n.rdtDays tr .dow {\n\ttext-align: center;\n\tborder-bottom: 1px solid #e3e3e3;\n\tfont-size: 12px;\n\ttext-transform: uppercase;\n\tfont-weight: inherit;\n\tpadding-bottom: 5px;\n\tpadding-top: 10px;\n}\n.rdtDays tr .rdtOld,\n.rdtDays tr .rdtNew {\n\tcolor: #dddddd;\n}\n\n.rdtPicker td.rdtDay:hover,\n.rdtPicker td.rdtHour:hover,\n.rdtPicker td.rdtMinute:hover,\n.rdtPicker td.rdtSecond:hover,\n.rdtPicker .rdtTimeToggle:hover {\n\tbackground: #eeeeee;\n\tcursor: pointer;\n}\n\n.rdtPicker td.rdtToday {\n\tposition: relative;\n}\n\n.rdtPicker td.rdtActive.rdtToday:before {\n\tborder-bottom-color: #fff;\n}\n\n.rdtPicker td.rdtDisabled,\n.rdtPicker td.rdtDisabled:hover {\n\tbackground: none;\n\tcolor: #999999;\n\tcursor: not-allowed;\n}\n\n.rdtPicker td span.rdtOld {\n\tcolor: #999999;\n}\n\n.rdtPicker td span.rdtDisabled,\n.rdtPicker td span.rdtDisabled:hover {\n\tbackground: none;\n\tcolor: #999999;\n\tcursor: not-allowed;\n}\n\n.rdtPicker .dow {\n\twidth: 14.2857%;\n\tborder-bottom: none;\n}\n\n.rdtPicker th.rdtSwitch {\n\twidth: 50px;\n\tpadding: 5px;\n\tborder-radius: 4px;\n}\n\n.rdtPicker th.rdtNext,\n.rdtPicker th.rdtPrev {\n\tfont-size: 21px;\n\tvertical-align: top;\n\tborder-radius: 50%;\n\tline-height: 33px;\n}\n\n.rdtPicker .dow,\n.rdtPicker th.rdtSwitch,\n.rdtPicker th.rdtNext,\n.rdtPicker th.rdtPrev,\n.rdtPicker .rdtTimeToggle {\n\tcolor: #1c77c3;\n}\n\n.rdtPrev span,\n.rdtNext span {\n\tdisplay: block;\n\t-webkit-touch-callout: none;\n\t/* iOS Safari */\n\t-webkit-user-select: none;\n\t/* Chrome/Safari/Opera */\n\t-khtml-user-select: none;\n\t/* Konqueror */\n\t-moz-user-select: none;\n\t/* Firefox */\n\t-ms-user-select: none;\n\t/* Internet Explorer/Edge */\n\tuser-select: none;\n}\n\n.rdtPicker th.rdtDisabled,\n.rdtPicker th.rdtDisabled:hover {\n\tbackground: none;\n\tcolor: #999999;\n\tcursor: not-allowed;\n}\n\n.rdtPicker thead tr:first-child th {\n\tcursor: pointer;\n}\n\n.rdtPicker thead tr:first-child th:hover {\n\tbackground: #eeeeee;\n}\n\n.rdtPicker button {\n\tborder: none;\n\tbackground: none;\n\tcursor: pointer;\n}\n\n.rdtPicker button:hover {\n\tbackground-color: #eee;\n}\n\n.rdtPicker thead button {\n\twidth: 100%;\n\theight: 100%;\n}\n\ntd.rdtMonth,\ntd.rdtYear {\n\theight: 50px;\n\twidth: 25%;\n\tcursor: pointer;\n}\n\ntd.rdtMonth:hover,\ntd.rdtYear:hover {\n\tbackground: #eee;\n}\n\n.rdtCounters {\n\tdisplay: inline-block;\n}\n\n.rdtCounters > div {\n\tfloat: left;\n\twidth: 40px;\n\tfont-weight: inherit;\n\tmargin: 3px;\n\tborder-radius: 50%;\n}\n.rdtCounters .rdtCounterSeparator {\n\twidth: 0;\n\tborder: 1px solid transparent;\n}\n\n.rdtCounter {\n\theight: 100px;\n}\n\n.rdtCounter {\n\twidth: 40px;\n}\n.rdtCounter .rdtCount {\n\tpadding: 7px;\n\theight: 40px;\n\tborder: 1px solid transparent;\n}\n\n.rdtCounters .rdtCounter:last-child .rdtCount {\n\tcolor: #1c77c3;\n\tborder-radius: 50%;\n\tborder: 1px solid #1c77c3;\n}\n\n.rdtCounterSeparator {\n\tpadding: 7px;\n\tline-height: 100px;\n}\n\n.rdtCounter .rdtBtn {\n\tline-height: 40px;\n\tcursor: pointer;\n\tdisplay: block;\n\tborder-radius: 50%;\n\tcolor: #dddddd;\n\t-webkit-transition: all 60ms ease-in;\n\t-moz-transition: all 60ms ease-in;\n\t-o-transition: all 60ms ease-in;\n\t-ms-transition: all 60ms ease-in;\n\ttransition: all 60ms ease-in;\n\t-webkit-touch-callout: none;\n\t/* iOS Safari */\n\t-webkit-user-select: none;\n\t/* Chrome/Safari/Opera */\n\t-khtml-user-select: none;\n\t/* Konqueror */\n\t-moz-user-select: none;\n\t/* Firefox */\n\t-ms-user-select: none;\n\t/* Internet Explorer/Edge */\n\tuser-select: none;\n}\n\n.rdtCounter .rdtBtn:hover {\n\tbackground: #eee;\n\tcolor: #797979;\n}\n\n.rdtCounter .rdtCount {\n\tfont-size: inherit;\n\tline-height: 25px;\n}\n\n.rdtMilli {\n\tvertical-align: middle;\n\tpadding-left: 8px;\n\twidth: 48px;\n}\n\n.rdtMilli input {\n\twidth: 100%;\n\tfont-size: inherit;\n\tmargin-top: 37px;\n}\n\n.rdtMonths,\n.rdtYears {\n\tpadding-bottom: 10px;\n}\n.rdtMonths .rdtMonth,\n.rdtMonths .rdtYear,\n.rdtYears .rdtMonth,\n.rdtYears .rdtYear {\n\tdisplay: inline-block;\n\twidth: 56px;\n\theight: 56px;\n\tline-height: 56px;\n\tmargin: 3px 3px;\n\tcursor: pointer;\n\tborder-radius: 50%;\n\ttext-align: center;\n}\n.rdtMonths .rdtMonth.rdtActive,\n.rdtMonths .rdtYear.rdtActive,\n.rdtYears .rdtMonth.rdtActive,\n.rdtYears .rdtYear.rdtActive {\n\tbackground-color: #1c77c3 !important;\n\tcolor: #ffffff;\n}\n\nsvg {\n\ttouch-action: none;\n}\n\n.jvectormap-container {\n\twidth: 100%;\n\theight: 100%;\n\tposition: relative;\n\toverflow: hidden;\n\ttouch-action: none;\n}\n\n.jvectormap-tip {\n\tposition: absolute;\n\tdisplay: none;\n\tborder: solid 1px #cdcdcd;\n\tborder-radius: 3px;\n\tbackground: #292929 !important;\n\tcolor: white;\n\tfont-family: sans-serif, Verdana;\n\tfont-size: smaller;\n\tpadding: 3px;\n}\n\n.jvectormap-zoomin,\n.jvectormap-zoomout,\n.jvectormap-goback {\n\tposition: absolute;\n\tleft: 10px;\n\tborder-radius: 3px;\n\tbackground: #292929 !important;\n\tpadding: 3px;\n\tcolor: white;\n\tcursor: pointer;\n\tline-height: 10px;\n\ttext-align: center;\n\tbox-sizing: content-box;\n}\n\n.jvectormap-zoomin,\n.jvectormap-zoomout {\n\twidth: 10px;\n\theight: 10px;\n}\n\n.jvectormap-zoomin {\n\ttop: 10px;\n}\n\n.jvectormap-zoomout {\n\ttop: 30px;\n}\n\n.jvectormap-goback {\n\tbottom: 10px;\n\tz-index: 1000;\n\tpadding: 6px;\n}\n\n.jvectormap-spinner {\n\tposition: absolute;\n\tleft: 0;\n\ttop: 0;\n\tright: 0;\n\tbottom: 0;\n\tbackground: center no-repeat\n\t\turl(data:image/gif;base64,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);\n}\n\n.jvectormap-legend-title {\n\tfont-weight: bold;\n\tfont-size: 14px;\n\ttext-align: center;\n}\n\n.jvectormap-legend-cnt {\n\tposition: absolute;\n}\n\n.jvectormap-legend-cnt-h {\n\tbottom: 0;\n\tright: 0;\n}\n\n.jvectormap-legend-cnt-v {\n\ttop: 0;\n\tright: 0;\n}\n\n.jvectormap-legend {\n\tbackground: black;\n\tcolor: white;\n\tborder-radius: 3px;\n}\n\n.jvectormap-legend-cnt-h .jvectormap-legend {\n\tfloat: left;\n\tmargin: 0 10px 10px 0;\n\tpadding: 3px 3px 1px 3px;\n}\n\n.jvectormap-legend-cnt-h .jvectormap-legend .jvectormap-legend-tick {\n\tfloat: left;\n}\n\n.jvectormap-legend-cnt-v .jvectormap-legend {\n\tmargin: 10px 10px 0 0;\n\tpadding: 3px;\n}\n\n.jvectormap-legend-cnt-h .jvectormap-legend-tick {\n\twidth: 40px;\n}\n\n.jvectormap-legend-cnt-h .jvectormap-legend-tick-sample {\n\theight: 15px;\n}\n\n.jvectormap-legend-cnt-v .jvectormap-legend-tick-sample {\n\theight: 20px;\n\twidth: 20px;\n\tdisplay: inline-block;\n\tvertical-align: middle;\n}\n\n.jvectormap-legend-tick-text {\n\tfont-size: 12px;\n}\n\n.jvectormap-legend-cnt-h .jvectormap-legend-tick-text {\n\ttext-align: center;\n}\n\n.jvectormap-legend-cnt-v .jvectormap-legend-tick-text {\n\tdisplay: inline-block;\n\tvertical-align: middle;\n\tline-height: 20px;\n\tpadding-left: 3px;\n}\n\n/**\n* React Select v1.0.0-rc.10\n* ============\n* Created by Jed Watson and Joss Mackison for KeystoneJS, https://www.keystonejs.com/\n* https://twitter.com/jedwatson https://twitter.com/jossmackison https://twitter.com/keystonejs\n* MIT License: https://github.com/JedWatson/react-select\n*/\n/*\nThis file was modified entirely by DealerClick for React-Select v2.0.0\n*/\n.react-select .react-select__menu {\n\ttop: 105%;\n\tmax-width: 94%;\n\twidth: 94%;\n\tright: 3%;\n\tborder-radius: 12px;\n\tborder: 0;\n\tbox-shadow: 1px 2px 7px 1px rgba(0, 0, 0, 0.125);\n\ttransition: all 0.3s cubic-bezier(0.215, 0.61, 0.355, 1) 0s,\n\t\topacity 0.3s ease 0s, height 0s linear 0.35s;\n\tbackground-color: #ffffff;\n\tbox-sizing: border-box;\n\tmax-height: 200px;\n\tposition: absolute;\n\tz-index: 2;\n\t-webkit-overflow-scrolling: touch;\n\tpadding-bottom: 10px;\n\tmargin-bottom: unset;\n\tmargin-top: unset;\n}\n.react-select .react-select__menu:before {\n\tborder-bottom: 11px solid #f1eae0;\n\ttop: -11px;\n\tborder-left: 11px solid transparent;\n\tborder-right: 11px solid transparent;\n\tcontent: \"\";\n\tdisplay: inline-block;\n\tposition: absolute;\n\tright: 15px;\n}\n.react-select .react-select__menu:after {\n\ttop: -10px;\n\tborder-bottom: 11px solid #fffcf5;\n\tborder-left: 11px solid transparent;\n\tborder-right: 11px solid transparent;\n\tcontent: \"\";\n\tdisplay: inline-block;\n\tposition: absolute;\n\tright: 15px;\n}\n.react-select .react-select__menu-list {\n\tmax-height: 198px;\n\toverflow-y: auto;\n\tpadding-bottom: unset;\n\tpadding-top: unset;\n\tposition: relative;\n}\n.react-select .react-select__option {\n\tfont-size: 0.8571em;\n\tpadding-top: 0.6rem;\n\tpadding-bottom: 0.6rem;\n\tmargin-top: 5px;\n\t-webkit-transition: all 150ms linear;\n\t-moz-transition: all 150ms linear;\n\t-o-transition: all 150ms linear;\n\t-ms-transition: all 150ms linear;\n\ttransition: all 150ms linear;\n\tpadding-left: 1.5rem;\n\tpadding-right: 1.5rem;\n\tdisplay: block;\n\toutline: none;\n\tcolor: #292b2c;\n}\n.react-select .react-select__menu .react-select__option,\n.react-select .react-select__menu .react-select__option:active {\n\tbackground-color: transparent;\n}\n.react-select\n\t.react-select__menu\n\t.react-select__option.react-select__option--is-selected,\n.react-select\n\t.react-select__menu\n\t.react-select__option.react-select__option--is-selected:active,\n.react-select\n\t.react-select__menu\n\t.react-select__option.react-select__option--is-selected.react-select__option--is-focused,\n.react-select\n\t.react-select__menu\n\t.react-select__option.react-select__option--is-selected.react-select__option--is-focused:active {\n\tbackground-color: #dddddd;\n}\n.react-select\n\t.react-select__menu\n\t.react-select__option.react-select__option--is-focused,\n.react-select\n\t.react-select__menu\n\t.react-select__option.react-select__option--is-focused:active {\n\tbackground-color: #f5f5f5;\n}\n.react-select\n\t.react-select__menu\n\t.react-select__option.react-select__option--is-disabled,\n.react-select\n\t.react-select__menu\n\t.react-select__option.react-select__option--is-disabled:active {\n\tcolor: #cccccc;\n\tcursor: default;\n}\n.react-select .react-select__control {\n\tborder-radius: 4px;\n\tmin-height: 40px;\n\theight: 40px;\n\tbox-sizing: border-box;\n\tborder-collapse: separate;\n\tdisplay: table;\n\twidth: 100%;\n}\n.react-select .react-select__control,\n.react-select .react-select__control:hover {\n\tborder: 1px solid #e3e3e3;\n\tbox-shadow: none;\n\tbackground-color: transparent;\n}\n.react-select\n\t.react-select__control.react-select__control--is-focused\n\t.react-select__dropdown-indicator:after {\n\ttransform: rotate(180deg);\n\ttop: -4px;\n}\n.react-select .react-select__control.react-select__control--is-focused,\n.react-select .react-select__control.react-select__control--is-focused:hover {\n\tborder: 1px solid #1c77c3;\n\tbox-shadow: none;\n}\n.react-select\n\t.react-select__control\n\t.react-select__value-container--has-value\n\t.react-select__multi-value {\n\tdisplay: inline-flex;\n\tborder-radius: 4px;\n\tbackground-color: transparent;\n}\n.react-select\n\t.react-select__control\n\t.react-select__value-container--has-value\n\t.react-select__multi-value\n\t+ div:not(.react-select__multi-value) {\n\tdisplay: inline-flex;\n}\n.react-select\n\t.react-select__control\n\t.react-select__value-container--has-value\n\t.react-select__multi-value\n\t.react-select__multi-value__label {\n\tfont-size: 0.9em;\n}\n.react-select\n\t.react-select__control\n\t.react-select__value-container--has-value\n\t.react-select__single-value {\n\ttop: 48%;\n\tcolor: #2c2c2c;\n}\n.react-select .react-select__control .react-select__placeholder {\n\tcolor: #292929 !important;\n\tline-height: normal;\n\tfont-size: 0.8571em;\n\ttop: 48%;\n}\n.react-select .react-select__control .react-select__value-container,\n.react-select .react-select__control .react-select__indicators {\n\tdisplay: table-cell;\n}\n.react-select .react-select__control .react-select__indicators {\n\twidth: 60px;\n\tpadding-right: 10px;\n\talign-items: flex-end;\n\tvertical-align: middle;\n\ttext-align: right;\n}\n.react-select\n\t.react-select__control\n\t.react-select__indicators\n\t.react-select__indicator-separator {\n\tdisplay: none;\n}\n.react-select\n\t.react-select__control\n\t.react-select__indicators\n\t.react-select__indicator {\n\tpadding: 0;\n\tdisplay: inline-block;\n}\n.react-select\n\t.react-select__control\n\t.react-select__indicators\n\t.react-select__dropdown-indicator:after {\n\ttransition: all 150ms ease 0s;\n\tborder-color: #999 transparent transparent;\n\tborder-style: solid;\n\tborder-width: 5px 5px 2.5px;\n\tdisplay: inline-block;\n\theight: 0;\n\twidth: 0;\n\tposition: relative;\n\tcontent: \"\";\n}\n.react-select\n\t.react-select__control\n\t.react-select__indicators\n\t.react-select__dropdown-indicator:hover:after {\n\tborder-top-color: #666666;\n}\n.react-select\n\t.react-select__control\n\t.react-select__indicators\n\t.react-select__dropdown-indicator\n\t> * {\n\tdisplay: none;\n}\n.react-select\n\t.react-select__control\n\t.react-select__indicators\n\t.react-select__clear-indicator:before {\n\tcontent: \"×\";\n\tdisplay: inline-block;\n\tfont-size: 18px;\n\tline-height: 1;\n\ttop: 2px;\n\tposition: relative;\n\tmargin-right: 3px;\n}\n.react-select\n\t.react-select__control\n\t.react-select__indicators\n\t.react-select__clear-indicator\n\t> * {\n\tdisplay: none;\n}\n.react-select.primary .react-select__control.react-select__control--is-focused,\n.react-select.primary\n\t.react-select__control.react-select__control--is-focused:hover {\n\tborder-color: #1c77c3;\n}\n.react-select.primary\n\t.react-select__control\n\t.react-select__value-container--has-value\n\t.react-select__single-value,\n.react-select.primary\n\t.react-select__control\n\t.react-select__value-container--has-value\n\t.react-select__multi-value__label {\n\tcolor: #1c77c3;\n}\n.react-select.primary .react-select__multi-value {\n\tborder: 1px solid #1c77c3;\n}\n.react-select.primary\n\t.react-select__multi-value\n\t.react-select__multi-value__remove {\n\tcolor: rgba(249, 99, 50, 0.3);\n\tborder-left: 1px solid rgba(249, 99, 50, 0.3);\n}\n.react-select.primary\n\t.react-select__multi-value\n\t.react-select__multi-value__remove:hover {\n\tcolor: #1c77c3;\n\tbackground-color: transparent;\n}\n.react-select.success .react-select__control.react-select__control--is-focused,\n.react-select.success\n\t.react-select__control.react-select__control--is-focused:hover {\n\tborder-color: #28a745;\n}\n.react-select.success\n\t.react-select__control\n\t.react-select__value-container--has-value\n\t.react-select__single-value,\n.react-select.success\n\t.react-select__control\n\t.react-select__value-container--has-value\n\t.react-select__multi-value__label {\n\tcolor: #28a745;\n}\n.react-select.success .react-select__multi-value {\n\tborder: 1px solid #28a745;\n}\n.react-select.success\n\t.react-select__multi-value\n\t.react-select__multi-value__remove {\n\tcolor: rgba(24, 206, 15, 0.3);\n\tborder-left: 1px solid rgba(24, 206, 15, 0.3);\n}\n.react-select.success\n\t.react-select__multi-value\n\t.react-select__multi-value__remove:hover {\n\tcolor: #28a745;\n\tbackground-color: transparent;\n}\n.react-select.info .react-select__control.react-select__control--is-focused,\n.react-select.info\n\t.react-select__control.react-select__control--is-focused:hover {\n\tborder-color: #39a9db;\n}\n.react-select.info\n\t.react-select__control\n\t.react-select__value-container--has-value\n\t.react-select__single-value,\n.react-select.info\n\t.react-select__control\n\t.react-select__value-container--has-value\n\t.react-select__multi-value__label {\n\tcolor: #39a9db;\n}\n.react-select.info .react-select__multi-value {\n\tborder: 1px solid #39a9db;\n}\n.react-select.info\n\t.react-select__multi-value\n\t.react-select__multi-value__remove {\n\tcolor: rgba(44, 168, 255, 0.3);\n\tborder-left: 1px solid rgba(44, 168, 255, 0.3);\n}\n.react-select.info\n\t.react-select__multi-value\n\t.react-select__multi-value__remove:hover {\n\tcolor: #39a9db;\n\tbackground-color: transparent;\n}\n.react-select.warning .react-select__control.react-select__control--is-focused,\n.react-select.warning\n\t.react-select__control.react-select__control--is-focused:hover {\n\tborder-color: #ffc759;\n}\n.react-select.warning\n\t.react-select__control\n\t.react-select__value-container--has-value\n\t.react-select__single-value,\n.react-select.warning\n\t.react-select__control\n\t.react-select__value-container--has-value\n\t.react-select__multi-value__label {\n\tcolor: #ffc759;\n}\n.react-select.warning .react-select__multi-value {\n\tborder: 1px solid #ffc759;\n}\n.react-select.warning\n\t.react-select__multi-value\n\t.react-select__multi-value__remove {\n\tcolor: rgba(255, 178, 54, 0.3);\n\tborder-left: 1px solid rgba(255, 178, 54, 0.3);\n}\n.react-select.warning\n\t.react-select__multi-value\n\t.react-select__multi-value__remove:hover {\n\tcolor: #ffc759;\n\tbackground-color: transparent;\n}\n.react-select.danger .react-select__control.react-select__control--is-focused,\n.react-select.danger\n\t.react-select__control.react-select__control--is-focused:hover {\n\tborder-color: #c1292e;\n}\n.react-select.danger\n\t.react-select__control\n\t.react-select__value-container--has-value\n\t.react-select__single-value,\n.react-select.danger\n\t.react-select__control\n\t.react-select__value-container--has-value\n\t.react-select__multi-value__label {\n\tcolor: #c1292e;\n}\n.react-select.danger .react-select__multi-value {\n\tborder: 1px solid #c1292e;\n}\n.react-select.danger\n\t.react-select__multi-value\n\t.react-select__multi-value__remove {\n\tcolor: rgba(255, 54, 54, 0.3);\n\tborder-left: 1px solid rgba(255, 54, 54, 0.3);\n}\n.react-select.danger\n\t.react-select__multi-value\n\t.react-select__multi-value__remove:hover {\n\tcolor: #c1292e;\n\tbackground-color: transparent;\n}\n.react-select .react-select__multi-value {\n\tborder: 1px solid #292929 !important;\n}\n.react-select .react-select__multi-value .react-select__multi-value__remove {\n\tposition: relative;\n\tcolor: rgba(222, 222, 222, 0.8);\n\tborder-left: 1px solid rgba(222, 222, 222, 0.8);\n}\n.react-select\n\t.react-select__multi-value\n\t.react-select__multi-value__remove:hover {\n\tcolor: #292929 !important;\n\tbackground-color: transparent;\n}\n.react-select.react-select--is-disabled\n\t.react-select__multi-value--is-disabled\n\t.react-select__multi-value__remove {\n\tdisplay: none;\n}\n.react-select.react-select--is-disabled\n\t.react-select__multi-value--is-disabled.react-select__multi-value {\n\tbackground-color: #fcfcfc;\n\tborder: 1px solid #e3e3e3;\n}\n.react-select.react-select--is-disabled .react-select__control--is-disabled {\n\tbackground-color: #f9f9f9;\n}\n\n.ReactTable {\n\tposition: relative;\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-orient: vertical;\n\t-webkit-box-direction: normal;\n\t-ms-flex-direction: column;\n\tflex-direction: column;\n\tbackground-color: transparent;\n\toverflow-x: auto;\n}\n.ReactTable.primary-pagination .-pagination .-btn {\n\tbackground-color: #1c77c3;\n\tcolor: #ffffff;\n}\n.ReactTable.primary-pagination .-pagination .-btn:hover,\n.ReactTable.primary-pagination .-pagination .-btn:focus,\n.ReactTable.primary-pagination .-pagination .-btn:active,\n.ReactTable.primary-pagination .-pagination .-btn.active,\n.ReactTable.primary-pagination .-pagination .-btn:active:focus,\n.ReactTable.primary-pagination .-pagination .-btn:active:hover,\n.ReactTable.primary-pagination .-pagination .-btn.active:focus,\n.ReactTable.primary-pagination .-pagination .-btn.active:hover,\n.show > .ReactTable.primary-pagination .-pagination .-btn.dropdown-toggle,\n.show > .ReactTable.primary-pagination .-pagination .-btn.dropdown-toggle:focus,\n.show\n\t> .ReactTable.primary-pagination\n\t.-pagination\n\t.-btn.dropdown-toggle:hover {\n\tbackground-color: #165c96 !important;\n\tcolor: #ffffff !important;\n\tbox-shadow: none !important;\n}\n.ReactTable.primary-pagination .-pagination .-btn:not([data-action]):hover {\n\tbox-shadow: none;\n}\n.ReactTable.primary-pagination .-pagination .-btn.disabled,\n.ReactTable.primary-pagination .-pagination .-btn.disabled:hover,\n.ReactTable.primary-pagination .-pagination .-btn.disabled:focus,\n.ReactTable.primary-pagination .-pagination .-btn.disabled.focus,\n.ReactTable.primary-pagination .-pagination .-btn.disabled:active,\n.ReactTable.primary-pagination .-pagination .-btn.disabled.active,\n.ReactTable.primary-pagination .-pagination .-btn:disabled,\n.ReactTable.primary-pagination .-pagination .-btn:disabled:hover,\n.ReactTable.primary-pagination .-pagination .-btn:disabled:focus,\n.ReactTable.primary-pagination .-pagination .-btn:disabled.focus,\n.ReactTable.primary-pagination .-pagination .-btn:disabled:active,\n.ReactTable.primary-pagination .-pagination .-btn:disabled.active,\n.ReactTable.primary-pagination .-pagination .-btn[disabled],\n.ReactTable.primary-pagination .-pagination .-btn[disabled]:hover,\n.ReactTable.primary-pagination .-pagination .-btn[disabled]:focus,\n.ReactTable.primary-pagination .-pagination .-btn[disabled].focus,\n.ReactTable.primary-pagination .-pagination .-btn[disabled]:active,\n.ReactTable.primary-pagination .-pagination .-btn[disabled].active,\nfieldset[disabled] .ReactTable.primary-pagination .-pagination .-btn,\nfieldset[disabled] .ReactTable.primary-pagination .-pagination .-btn:hover,\nfieldset[disabled] .ReactTable.primary-pagination .-pagination .-btn:focus,\nfieldset[disabled] .ReactTable.primary-pagination .-pagination .-btn.focus,\nfieldset[disabled] .ReactTable.primary-pagination .-pagination .-btn:active,\nfieldset[disabled] .ReactTable.primary-pagination .-pagination .-btn.active {\n\tbackground-color: #1c77c3;\n\tborder-color: #1c77c3;\n}\n.ReactTable.primary-pagination .-pagination .-btn.btn-simple {\n\tcolor: #1c77c3;\n\tborder-color: #1c77c3;\n}\n.ReactTable.primary-pagination .-pagination .-btn.btn-simple:hover,\n.ReactTable.primary-pagination .-pagination .-btn.btn-simple:focus,\n.ReactTable.primary-pagination .-pagination .-btn.btn-simple:active {\n\tbackground-color: transparent;\n\tcolor: #165c96;\n\tborder-color: #165c96;\n\tbox-shadow: none;\n}\n.ReactTable.primary-pagination .-pagination .-btn.btn-link {\n\tcolor: #1c77c3;\n}\n.ReactTable.primary-pagination .-pagination .-btn.btn-link:hover,\n.ReactTable.primary-pagination .-pagination .-btn.btn-link:focus,\n.ReactTable.primary-pagination .-pagination .-btn.btn-link:active,\n.ReactTable.primary-pagination .-pagination .-btn.btn-link:active:focus {\n\tbackground-color: transparent;\n\tcolor: #165c96;\n\ttext-decoration: none;\n\tbox-shadow: none;\n}\n.ReactTable.primary-pagination .-pagination .-btn:disabled {\n\topacity: 0.5;\n\tfilter: alpha(opacity=50);\n\tpointer-events: none;\n\tcursor: not-allowed;\n}\n.ReactTable.info-pagination .-pagination .-btn {\n\tbackground-color: #39a9db;\n\tcolor: #ffffff;\n}\n.ReactTable.info-pagination .-pagination .-btn:hover,\n.ReactTable.info-pagination .-pagination .-btn:focus,\n.ReactTable.info-pagination .-pagination .-btn:active,\n.ReactTable.info-pagination .-pagination .-btn.active,\n.ReactTable.info-pagination .-pagination .-btn:active:focus,\n.ReactTable.info-pagination .-pagination .-btn:active:hover,\n.ReactTable.info-pagination .-pagination .-btn.active:focus,\n.ReactTable.info-pagination .-pagination .-btn.active:hover,\n.show > .ReactTable.info-pagination .-pagination .-btn.dropdown-toggle,\n.show > .ReactTable.info-pagination .-pagination .-btn.dropdown-toggle:focus,\n.show > .ReactTable.info-pagination .-pagination .-btn.dropdown-toggle:hover {\n\tbackground-color: #238ebe !important;\n\tcolor: #ffffff !important;\n\tbox-shadow: none !important;\n}\n.ReactTable.info-pagination .-pagination .-btn:not([data-action]):hover {\n\tbox-shadow: none;\n}\n.ReactTable.info-pagination .-pagination .-btn.disabled,\n.ReactTable.info-pagination .-pagination .-btn.disabled:hover,\n.ReactTable.info-pagination .-pagination .-btn.disabled:focus,\n.ReactTable.info-pagination .-pagination .-btn.disabled.focus,\n.ReactTable.info-pagination .-pagination .-btn.disabled:active,\n.ReactTable.info-pagination .-pagination .-btn.disabled.active,\n.ReactTable.info-pagination .-pagination .-btn:disabled,\n.ReactTable.info-pagination .-pagination .-btn:disabled:hover,\n.ReactTable.info-pagination .-pagination .-btn:disabled:focus,\n.ReactTable.info-pagination .-pagination .-btn:disabled.focus,\n.ReactTable.info-pagination .-pagination .-btn:disabled:active,\n.ReactTable.info-pagination .-pagination .-btn:disabled.active,\n.ReactTable.info-pagination .-pagination .-btn[disabled],\n.ReactTable.info-pagination .-pagination .-btn[disabled]:hover,\n.ReactTable.info-pagination .-pagination .-btn[disabled]:focus,\n.ReactTable.info-pagination .-pagination .-btn[disabled].focus,\n.ReactTable.info-pagination .-pagination .-btn[disabled]:active,\n.ReactTable.info-pagination .-pagination .-btn[disabled].active,\nfieldset[disabled] .ReactTable.info-pagination .-pagination .-btn,\nfieldset[disabled] .ReactTable.info-pagination .-pagination .-btn:hover,\nfieldset[disabled] .ReactTable.info-pagination .-pagination .-btn:focus,\nfieldset[disabled] .ReactTable.info-pagination .-pagination .-btn.focus,\nfieldset[disabled] .ReactTable.info-pagination .-pagination .-btn:active,\nfieldset[disabled] .ReactTable.info-pagination .-pagination .-btn.active {\n\tbackground-color: #39a9db;\n\tborder-color: #39a9db;\n}\n.ReactTable.info-pagination .-pagination .-btn.btn-simple {\n\tcolor: #39a9db;\n\tborder-color: #39a9db;\n}\n.ReactTable.info-pagination .-pagination .-btn.btn-simple:hover,\n.ReactTable.info-pagination .-pagination .-btn.btn-simple:focus,\n.ReactTable.info-pagination .-pagination .-btn.btn-simple:active {\n\tbackground-color: transparent;\n\tcolor: #238ebe;\n\tborder-color: #238ebe;\n\tbox-shadow: none;\n}\n.ReactTable.info-pagination .-pagination .-btn.btn-link {\n\tcolor: #39a9db;\n}\n.ReactTable.info-pagination .-pagination .-btn.btn-link:hover,\n.ReactTable.info-pagination .-pagination .-btn.btn-link:focus,\n.ReactTable.info-pagination .-pagination .-btn.btn-link:active,\n.ReactTable.info-pagination .-pagination .-btn.btn-link:active:focus {\n\tbackground-color: transparent;\n\tcolor: #238ebe;\n\ttext-decoration: none;\n\tbox-shadow: none;\n}\n.ReactTable.info-pagination .-pagination .-btn:disabled {\n\topacity: 0.5;\n\tfilter: alpha(opacity=50);\n\tpointer-events: none;\n\tcursor: not-allowed;\n}\n.ReactTable.success-pagination .-pagination .-btn {\n\tbackground-color: #28a745;\n\tcolor: #ffffff;\n}\n.ReactTable.success-pagination .-pagination .-btn:hover,\n.ReactTable.success-pagination .-pagination .-btn:focus,\n.ReactTable.success-pagination .-pagination .-btn:active,\n.ReactTable.success-pagination .-pagination .-btn.active,\n.ReactTable.success-pagination .-pagination .-btn:active:focus,\n.ReactTable.success-pagination .-pagination .-btn:active:hover,\n.ReactTable.success-pagination .-pagination .-btn.active:focus,\n.ReactTable.success-pagination .-pagination .-btn.active:hover,\n.show > .ReactTable.success-pagination .-pagination .-btn.dropdown-toggle,\n.show > .ReactTable.success-pagination .-pagination .-btn.dropdown-toggle:focus,\n.show\n\t> .ReactTable.success-pagination\n\t.-pagination\n\t.-btn.dropdown-toggle:hover {\n\tbackground-color: #0c492c !important;\n\tcolor: #ffffff !important;\n\tbox-shadow: none !important;\n}\n.ReactTable.success-pagination .-pagination .-btn:not([data-action]):hover {\n\tbox-shadow: none;\n}\n.ReactTable.success-pagination .-pagination .-btn.disabled,\n.ReactTable.success-pagination .-pagination .-btn.disabled:hover,\n.ReactTable.success-pagination .-pagination .-btn.disabled:focus,\n.ReactTable.success-pagination .-pagination .-btn.disabled.focus,\n.ReactTable.success-pagination .-pagination .-btn.disabled:active,\n.ReactTable.success-pagination .-pagination .-btn.disabled.active,\n.ReactTable.success-pagination .-pagination .-btn:disabled,\n.ReactTable.success-pagination .-pagination .-btn:disabled:hover,\n.ReactTable.success-pagination .-pagination .-btn:disabled:focus,\n.ReactTable.success-pagination .-pagination .-btn:disabled.focus,\n.ReactTable.success-pagination .-pagination .-btn:disabled:active,\n.ReactTable.success-pagination .-pagination .-btn:disabled.active,\n.ReactTable.success-pagination .-pagination .-btn[disabled],\n.ReactTable.success-pagination .-pagination .-btn[disabled]:hover,\n.ReactTable.success-pagination .-pagination .-btn[disabled]:focus,\n.ReactTable.success-pagination .-pagination .-btn[disabled].focus,\n.ReactTable.success-pagination .-pagination .-btn[disabled]:active,\n.ReactTable.success-pagination .-pagination .-btn[disabled].active,\nfieldset[disabled] .ReactTable.success-pagination .-pagination .-btn,\nfieldset[disabled] .ReactTable.success-pagination .-pagination .-btn:hover,\nfieldset[disabled] .ReactTable.success-pagination .-pagination .-btn:focus,\nfieldset[disabled] .ReactTable.success-pagination .-pagination .-btn.focus,\nfieldset[disabled] .ReactTable.success-pagination .-pagination .-btn:active,\nfieldset[disabled] .ReactTable.success-pagination .-pagination .-btn.active {\n\tbackground-color: #28a745;\n\tborder-color: #28a745;\n}\n.ReactTable.success-pagination .-pagination .-btn.btn-simple {\n\tcolor: #28a745;\n\tborder-color: #28a745;\n}\n.ReactTable.success-pagination .-pagination .-btn.btn-simple:hover,\n.ReactTable.success-pagination .-pagination .-btn.btn-simple:focus,\n.ReactTable.success-pagination .-pagination .-btn.btn-simple:active {\n\tbackground-color: transparent;\n\tcolor: #0c492c;\n\tborder-color: #0c492c;\n\tbox-shadow: none;\n}\n.ReactTable.success-pagination .-pagination .-btn.btn-link {\n\tcolor: #28a745;\n}\n.ReactTable.success-pagination .-pagination .-btn.btn-link:hover,\n.ReactTable.success-pagination .-pagination .-btn.btn-link:focus,\n.ReactTable.success-pagination .-pagination .-btn.btn-link:active,\n.ReactTable.success-pagination .-pagination .-btn.btn-link:active:focus {\n\tbackground-color: transparent;\n\tcolor: #0c492c;\n\ttext-decoration: none;\n\tbox-shadow: none;\n}\n.ReactTable.success-pagination .-pagination .-btn:disabled {\n\topacity: 0.5;\n\tfilter: alpha(opacity=50);\n\tpointer-events: none;\n\tcursor: not-allowed;\n}\n.ReactTable.warning-pagination .-pagination .-btn {\n\tbackground-color: #ffc759;\n\tcolor: #ffffff;\n}\n.ReactTable.warning-pagination .-pagination .-btn:hover,\n.ReactTable.warning-pagination .-pagination .-btn:focus,\n.ReactTable.warning-pagination .-pagination .-btn:active,\n.ReactTable.warning-pagination .-pagination .-btn.active,\n.ReactTable.warning-pagination .-pagination .-btn:active:focus,\n.ReactTable.warning-pagination .-pagination .-btn:active:hover,\n.ReactTable.warning-pagination .-pagination .-btn.active:focus,\n.ReactTable.warning-pagination .-pagination .-btn.active:hover,\n.show > .ReactTable.warning-pagination .-pagination .-btn.dropdown-toggle,\n.show > .ReactTable.warning-pagination .-pagination .-btn.dropdown-toggle:focus,\n.show\n\t> .ReactTable.warning-pagination\n\t.-pagination\n\t.-btn.dropdown-toggle:hover {\n\tbackground-color: #ffb626 !important;\n\tcolor: #ffffff !important;\n\tbox-shadow: none !important;\n}\n.ReactTable.warning-pagination .-pagination .-btn:not([data-action]):hover {\n\tbox-shadow: none;\n}\n.ReactTable.warning-pagination .-pagination .-btn.disabled,\n.ReactTable.warning-pagination .-pagination .-btn.disabled:hover,\n.ReactTable.warning-pagination .-pagination .-btn.disabled:focus,\n.ReactTable.warning-pagination .-pagination .-btn.disabled.focus,\n.ReactTable.warning-pagination .-pagination .-btn.disabled:active,\n.ReactTable.warning-pagination .-pagination .-btn.disabled.active,\n.ReactTable.warning-pagination .-pagination .-btn:disabled,\n.ReactTable.warning-pagination .-pagination .-btn:disabled:hover,\n.ReactTable.warning-pagination .-pagination .-btn:disabled:focus,\n.ReactTable.warning-pagination .-pagination .-btn:disabled.focus,\n.ReactTable.warning-pagination .-pagination .-btn:disabled:active,\n.ReactTable.warning-pagination .-pagination .-btn:disabled.active,\n.ReactTable.warning-pagination .-pagination .-btn[disabled],\n.ReactTable.warning-pagination .-pagination .-btn[disabled]:hover,\n.ReactTable.warning-pagination .-pagination .-btn[disabled]:focus,\n.ReactTable.warning-pagination .-pagination .-btn[disabled].focus,\n.ReactTable.warning-pagination .-pagination .-btn[disabled]:active,\n.ReactTable.warning-pagination .-pagination .-btn[disabled].active,\nfieldset[disabled] .ReactTable.warning-pagination .-pagination .-btn,\nfieldset[disabled] .ReactTable.warning-pagination .-pagination .-btn:hover,\nfieldset[disabled] .ReactTable.warning-pagination .-pagination .-btn:focus,\nfieldset[disabled] .ReactTable.warning-pagination .-pagination .-btn.focus,\nfieldset[disabled] .ReactTable.warning-pagination .-pagination .-btn:active,\nfieldset[disabled] .ReactTable.warning-pagination .-pagination .-btn.active {\n\tbackground-color: #ffc759;\n\tborder-color: #ffc759;\n}\n.ReactTable.warning-pagination .-pagination .-btn.btn-simple {\n\tcolor: #ffc759;\n\tborder-color: #ffc759;\n}\n.ReactTable.warning-pagination .-pagination .-btn.btn-simple:hover,\n.ReactTable.warning-pagination .-pagination .-btn.btn-simple:focus,\n.ReactTable.warning-pagination .-pagination .-btn.btn-simple:active {\n\tbackground-color: transparent;\n\tcolor: #ffb626;\n\tborder-color: #ffb626;\n\tbox-shadow: none;\n}\n.ReactTable.warning-pagination .-pagination .-btn.btn-link {\n\tcolor: #ffc759;\n}\n.ReactTable.warning-pagination .-pagination .-btn.btn-link:hover,\n.ReactTable.warning-pagination .-pagination .-btn.btn-link:focus,\n.ReactTable.warning-pagination .-pagination .-btn.btn-link:active,\n.ReactTable.warning-pagination .-pagination .-btn.btn-link:active:focus {\n\tbackground-color: transparent;\n\tcolor: #ffb626;\n\ttext-decoration: none;\n\tbox-shadow: none;\n}\n.ReactTable.warning-pagination .-pagination .-btn:disabled {\n\topacity: 0.5;\n\tfilter: alpha(opacity=50);\n\tpointer-events: none;\n\tcursor: not-allowed;\n}\n.ReactTable.danger-pagination .-pagination .-btn {\n\tbackground-color: #c1292e;\n\tcolor: #ffffff;\n}\n.ReactTable.danger-pagination .-pagination .-btn:hover,\n.ReactTable.danger-pagination .-pagination .-btn:focus,\n.ReactTable.danger-pagination .-pagination .-btn:active,\n.ReactTable.danger-pagination .-pagination .-btn.active,\n.ReactTable.danger-pagination .-pagination .-btn:active:focus,\n.ReactTable.danger-pagination .-pagination .-btn:active:hover,\n.ReactTable.danger-pagination .-pagination .-btn.active:focus,\n.ReactTable.danger-pagination .-pagination .-btn.active:hover,\n.show > .ReactTable.danger-pagination .-pagination .-btn.dropdown-toggle,\n.show > .ReactTable.danger-pagination .-pagination .-btn.dropdown-toggle:focus,\n.show > .ReactTable.danger-pagination .-pagination .-btn.dropdown-toggle:hover {\n\tbackground-color: #9f2226 !important;\n\tcolor: #ffffff !important;\n\tbox-shadow: none !important;\n}\n.ReactTable.danger-pagination .-pagination .-btn:not([data-action]):hover {\n\tbox-shadow: none;\n}\n.ReactTable.danger-pagination .-pagination .-btn.disabled,\n.ReactTable.danger-pagination .-pagination .-btn.disabled:hover,\n.ReactTable.danger-pagination .-pagination .-btn.disabled:focus,\n.ReactTable.danger-pagination .-pagination .-btn.disabled.focus,\n.ReactTable.danger-pagination .-pagination .-btn.disabled:active,\n.ReactTable.danger-pagination .-pagination .-btn.disabled.active,\n.ReactTable.danger-pagination .-pagination .-btn:disabled,\n.ReactTable.danger-pagination .-pagination .-btn:disabled:hover,\n.ReactTable.danger-pagination .-pagination .-btn:disabled:focus,\n.ReactTable.danger-pagination .-pagination .-btn:disabled.focus,\n.ReactTable.danger-pagination .-pagination .-btn:disabled:active,\n.ReactTable.danger-pagination .-pagination .-btn:disabled.active,\n.ReactTable.danger-pagination .-pagination .-btn[disabled],\n.ReactTable.danger-pagination .-pagination .-btn[disabled]:hover,\n.ReactTable.danger-pagination .-pagination .-btn[disabled]:focus,\n.ReactTable.danger-pagination .-pagination .-btn[disabled].focus,\n.ReactTable.danger-pagination .-pagination .-btn[disabled]:active,\n.ReactTable.danger-pagination .-pagination .-btn[disabled].active,\nfieldset[disabled] .ReactTable.danger-pagination .-pagination .-btn,\nfieldset[disabled] .ReactTable.danger-pagination .-pagination .-btn:hover,\nfieldset[disabled] .ReactTable.danger-pagination .-pagination .-btn:focus,\nfieldset[disabled] .ReactTable.danger-pagination .-pagination .-btn.focus,\nfieldset[disabled] .ReactTable.danger-pagination .-pagination .-btn:active,\nfieldset[disabled] .ReactTable.danger-pagination .-pagination .-btn.active {\n\tbackground-color: #c1292e;\n\tborder-color: #c1292e;\n}\n.ReactTable.danger-pagination .-pagination .-btn.btn-simple {\n\tcolor: #c1292e;\n\tborder-color: #c1292e;\n}\n.ReactTable.danger-pagination .-pagination .-btn.btn-simple:hover,\n.ReactTable.danger-pagination .-pagination .-btn.btn-simple:focus,\n.ReactTable.danger-pagination .-pagination .-btn.btn-simple:active {\n\tbackground-color: transparent;\n\tcolor: #9f2226;\n\tborder-color: #9f2226;\n\tbox-shadow: none;\n}\n.ReactTable.danger-pagination .-pagination .-btn.btn-link {\n\tcolor: #c1292e;\n}\n.ReactTable.danger-pagination .-pagination .-btn.btn-link:hover,\n.ReactTable.danger-pagination .-pagination .-btn.btn-link:focus,\n.ReactTable.danger-pagination .-pagination .-btn.btn-link:active,\n.ReactTable.danger-pagination .-pagination .-btn.btn-link:active:focus {\n\tbackground-color: transparent;\n\tcolor: #9f2226;\n\ttext-decoration: none;\n\tbox-shadow: none;\n}\n.ReactTable.danger-pagination .-pagination .-btn:disabled {\n\topacity: 0.5;\n\tfilter: alpha(opacity=50);\n\tpointer-events: none;\n\tcursor: not-allowed;\n}\n\n.ReactTable .actions-right {\n\ttext-align: right;\n\tdisplay: flex;\n\tjustify-content: flex-end;\n}\n.ReactTable .actions-left {\n\ttext-align: left;\n}\n.ReactTable .actions-center {\n\ttext-align: center;\n}\n\n.ReactTable * {\n\tbox-sizing: border-box;\n}\n\n.ReactTable .rt-table {\n\t-webkit-box-flex: 1;\n\t-ms-flex: auto 1;\n\tflex: auto 1;\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\t-webkit-box-orient: vertical;\n\t-webkit-box-direction: normal;\n\t-ms-flex-direction: column;\n\tflex-direction: column;\n\t-webkit-box-align: stretch;\n\t-ms-flex-align: stretch;\n\talign-items: stretch;\n\twidth: 100%;\n\tborder-collapse: collapse;\n\toverflow: visible;\n}\n\n.ReactTable .rt-thead {\n\t-webkit-box-flex: 1;\n\t-ms-flex: 1 0 auto;\n\tflex: 1 0 auto;\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-orient: vertical;\n\t-webkit-box-direction: normal;\n\t-ms-flex-direction: column;\n\tflex-direction: column;\n\t-webkit-user-select: none;\n\t-moz-user-select: none;\n\t-ms-user-select: none;\n\tuser-select: none;\n}\n\n.ReactTable .rt-thead.-headerGroups {\n\tbackground: rgba(0, 0, 0, 0.03);\n\tborder-bottom: 1px solid rgba(0, 0, 0, 0.05);\n}\n\n.ReactTable .rt-thead.-filters input,\n.ReactTable .rt-thead.-filters select {\n\tborder: 1px solid #e3e3e3;\n\tborder-radius: 4px;\n\tcolor: #565656;\n\tfont-weight: 400;\n\theight: 28px;\n\tbackground-color: inherit;\n\tpadding-left: 0.8em;\n}\n.ReactTable .rt-thead.-filters input:focus,\n.ReactTable .rt-thead.-filters select:focus {\n\toutline: none;\n\tborder: 1px solid #aaa;\n\tcolor: #333;\n}\n\n.ReactTable .rt-thead .rt-th:last-child {\n\ttext-align: right;\n}\n\n.ReactTable .rt-thead .rt-th.-cursor-pointer > div:first-of-type:after {\n\topacity: 0.6;\n\tcontent: \"\\f0dc\";\n\tposition: relative;\n\tdisplay: inline-block;\n\tbottom: 0px;\n\tright: -7px;\n\tfont-family: \"FontAwesome\";\n}\n\n.ReactTable\n\t.rt-thead\n\t.rt-th.-cursor-pointer.-sort-desc\n\t> div:first-of-type:after {\n\tcontent: \"\\f0dd\";\n\ttop: -3px;\n\tposition: relative;\n\tdisplay: inline-block;\n\tbottom: 0px;\n\tright: -7px;\n\tfont-family: \"FontAwesome\";\n\topacity: 1;\n}\n\n.ReactTable\n\t.rt-thead\n\t.rt-th.-cursor-pointer.-sort-asc\n\t> div:first-of-type:after {\n\tcontent: \"\\f0de\";\n\ttop: 3px;\n\tposition: relative;\n\tdisplay: inline-block;\n\tbottom: 0px;\n\tright: -7px;\n\tfont-family: \"FontAwesome\";\n\topacity: 1;\n}\n\n.ReactTable .rt-thead .rt-th,\n.ReactTable .rt-thead .rt-td {\n\tfont-size: 1.063rem;\n\ttext-align: left;\n\tfont-weight: 300;\n\tline-height: 2.5em !important;\n\tpadding: 5px 5px;\n\tline-height: normal;\n\tposition: relative;\n\ttransition: box-shadow 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);\n\tbox-shadow: inset 0 0 0 0 transparent;\n}\n\n.ReactTable .rt-thead .rt-th.-cursor-pointer,\n.ReactTable .rt-thead .rt-td.-cursor-pointer {\n\tcursor: pointer;\n}\n\n.ReactTable .rt-thead .rt-th.-check-box,\n.ReactTable .rt-thead .rt-td.-check-box {\n\tmax-width: 40px;\n}\n\n.ReactTable .rt-thead .rt-th:last-child,\n.ReactTable .rt-thead .rt-td:last-child {\n\tborder-right: 0;\n}\n\n.ReactTable .rt-thead .rt-resizable-header {\n\toverflow: visible;\n}\n\n.ReactTable .rt-thead .rt-resizable-header:last-child {\n\toverflow: hidden;\n}\n\n.ReactTable .rt-thead .rt-resizable-header-content {\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n}\n.ReactTable .rt-thead .rt-resizable-header-content:focus {\n\toutline: none;\n}\n\n.ReactTable .rt-thead .rt-header-pivot {\n\tborder-right-color: #f7f7f7;\n}\n\n.ReactTable .rt-thead .rt-header-pivot:after,\n.ReactTable .rt-thead .rt-header-pivot:before {\n\tleft: 100%;\n\ttop: 50%;\n\tborder: solid transparent;\n\tcontent: \" \";\n\theight: 0;\n\twidth: 0;\n\tposition: absolute;\n\tpointer-events: none;\n}\n\n.ReactTable .rt-thead .rt-header-pivot:after {\n\tborder-color: rgba(255, 255, 255, 0);\n\tborder-left-color: #fff;\n\tborder-width: 8px;\n\tmargin-top: -8px;\n}\n\n.ReactTable .rt-thead .rt-header-pivot:before {\n\tborder-color: rgba(102, 102, 102, 0);\n\tborder-left-color: #f7f7f7;\n\tborder-width: 10px;\n\tmargin-top: -10px;\n}\n\n.ReactTable .rt-tbody {\n\t-webkit-box-flex: 99999;\n\t-ms-flex: 99999 1 auto;\n\tflex: 99999 1 auto;\n\twidth: auto;\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-orient: vertical;\n\t-webkit-box-direction: normal;\n\t-ms-flex-direction: column;\n\tflex-direction: column;\n\toverflow: visible;\n}\n\n@media screen and (max-width: 767px) {\n\t.ReactTable .rt-tbody {\n\t\twidth: fit-content;\n\t}\n}\n\n.ReactTable .rt-tbody .rt-tr-group:last-child {\n\tborder-bottom: 0;\n}\n\n.ReactTable .rt-tbody .rt-td:last-child {\n\tborder-right: 0;\n}\n\n.ReactTable .rt-tbody .rt-expandable {\n\tcursor: pointer;\n}\n\n.ReactTable .rt-tr-group {\n\t-webkit-box-flex: 1;\n\t-ms-flex: 1 0 auto;\n\tflex: 1 0 auto;\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-orient: vertical;\n\t-webkit-box-direction: normal;\n\t-ms-flex-direction: column;\n\tflex-direction: column;\n\t-webkit-box-align: stretch;\n\t-ms-flex-align: stretch;\n\talign-items: stretch;\n}\n\n.ReactTable .rt-tr {\n\t-webkit-box-flex: 1;\n\t-ms-flex: 1 0 auto;\n\tflex: 1 0 auto;\n\tdisplay: -webkit-inline-box;\n\tdisplay: -ms-inline-flexbox;\n\tdisplay: inline-flex;\n}\n\n.ReactTable .rt-th,\n.ReactTable .rt-td {\n\t-webkit-box-flex: 1;\n\t-ms-flex: 1 0 0px;\n\tflex: 1 0 0;\n\twhite-space: nowrap;\n\ttext-overflow: ellipsis;\n\tpadding: 12px 7px;\n\toverflow: hidden;\n\ttransition: 0.3s ease;\n\ttransition-property: width, min-width, padding, opacity;\n\tline-height: 2;\n}\n\n.ReactTable .rt-th.-hidden,\n.ReactTable .rt-td.-hidden {\n\twidth: 0 !important;\n\tmin-width: 0 !important;\n\tpadding: 0 !important;\n\tborder: 0 !important;\n\topacity: 0 !important;\n}\n\n.ReactTable .rt-expander {\n\tdisplay: inline-block;\n\tposition: relative;\n\tmargin: 0;\n\tcolor: transparent;\n\tmargin: 0 10px;\n}\n\n.ReactTable .rt-expander:after {\n\tcontent: \"\";\n\tposition: absolute;\n\twidth: 0;\n\theight: 0;\n\ttop: 50%;\n\tleft: 50%;\n\t-webkit-transform: translate(-50%, -50%) rotate(-90deg);\n\ttransform: translate(-50%, -50%) rotate(-90deg);\n\tborder-left: 5.04px solid transparent;\n\tborder-right: 5.04px solid transparent;\n\tborder-top: 7px solid rgba(0, 0, 0, 0.8);\n\ttransition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);\n\tcursor: pointer;\n}\n\n.ReactTable .rt-expander.-open:after {\n\t-webkit-transform: translate(-50%, -50%) rotate(0);\n\ttransform: translate(-50%, -50%) rotate(0);\n}\n\n.ReactTable .rt-resizer {\n\tdisplay: inline-block;\n\tposition: absolute;\n\twidth: 36px;\n\ttop: 0;\n\tbottom: 0;\n\tright: -18px;\n\tcursor: col-resize;\n\tz-index: 10;\n}\n\n.ReactTable .rt-tfoot {\n\t-webkit-box-flex: 1;\n\t-ms-flex: 1 0 auto;\n\tflex: 1 0 auto;\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-orient: vertical;\n\t-webkit-box-direction: normal;\n\t-ms-flex-direction: column;\n\tflex-direction: column;\n\tbox-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.15);\n}\n\n.ReactTable .rt-tfoot .rt-td {\n\tborder-right: 1px solid rgba(0, 0, 0, 0.05);\n}\n\n.ReactTable .rt-tfoot .rt-td:last-child {\n\tborder-right: 0;\n}\n\n.ReactTable.-striped .rt-tr.-odd {\n\tbackground: rgba(0, 0, 0, 0.03);\n}\n\n.ReactTable.-highlight .rt-tbody .rt-tr:not(.-padRow):hover {\n\tbackground: rgba(214, 214, 214, 0.4);\n}\n\n.ReactTable .-pagination {\n\tz-index: 1;\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-pack: justify;\n\t-ms-flex-pack: justify;\n\tjustify-content: space-between;\n\t-webkit-box-align: stretch;\n\t-ms-flex-align: stretch;\n\talign-items: stretch;\n\t-ms-flex-wrap: wrap;\n\tflex-wrap: wrap;\n\tpadding: 3px;\n}\n\n.ReactTable .-pagination input,\n.ReactTable .-pagination select {\n\tborder: 1px solid #e3e3e3;\n\tborder-radius: 4px;\n\tcolor: #565656;\n\tfont-weight: 400;\n\theight: 28px;\n\tbackground-color: inherit;\n\ttext-align: center;\n}\n.ReactTable .-pagination input:focus,\n.ReactTable .-pagination select:focus {\n\toutline: none;\n\tborder: 1px solid #aaa;\n\tcolor: #333;\n}\n\n.ReactTable .-pagination .-btn {\n\t-webkit-appearance: none;\n\t-moz-appearance: none;\n\tappearance: none;\n\tdisplay: block;\n\twidth: 100%;\n\theight: 100%;\n\tborder: 0;\n\tborder-radius: 3px;\n\tpadding: 6px;\n\tfont-size: 0.6em;\n\tfont-weight: 600;\n\tcolor: #444;\n\ttransition: all 0.1s ease;\n\tcursor: pointer;\n\toutline: none;\n}\n\n.ReactTable .-pagination .-btn[disabled] {\n\topacity: 0.6;\n\tcursor: not-allowed;\n}\n\n.ReactTable .-pagination .-btn i {\n\tfont-size: 28px;\n}\n\n.ReactTable .-pagination .-btn:not([disabled]):hover {\n\tbackground: rgba(0, 0, 0, 0.3);\n\tcolor: #fff;\n}\n\n.ReactTable .-pagination .-previous,\n.ReactTable .-pagination .-next {\n\t-webkit-box-flex: 1;\n\t-ms-flex: 1;\n\tflex: 1;\n\ttext-align: center;\n}\n\n.ReactTable .-pagination .-center {\n\t-webkit-box-flex: 1.5;\n\t-ms-flex: 1.5;\n\tflex: 1.5;\n\ttext-align: center;\n\tmargin-bottom: 0;\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-orient: horizontal;\n\t-webkit-box-direction: normal;\n\t-ms-flex-direction: row;\n\tflex-direction: row;\n\t-ms-flex-wrap: wrap;\n\tflex-wrap: wrap;\n\t-webkit-box-align: center;\n\t-ms-flex-align: center;\n\talign-items: center;\n\t-ms-flex-pack: distribute;\n\tjustify-content: space-around;\n}\n\n.ReactTable .-pagination .-pageInfo {\n\tdisplay: inline-block;\n\tmargin: 3px 10px;\n\twhite-space: nowrap;\n}\n\n.ReactTable .-pagination .-pageJump {\n\tdisplay: inline-block;\n}\n\n.ReactTable .-pagination .-pageSizeOptions {\n\tmargin: 3px 10px;\n}\n\n.ReactTable .rt-noData {\n\tdisplay: block;\n\tposition: absolute;\n\tleft: 50%;\n\ttop: 50%;\n\t-webkit-transform: translate(-50%, -50%);\n\ttransform: translate(-50%, -50%);\n\tbackground: rgba(255, 255, 255, 0.8);\n\ttransition: all 0.3s ease;\n\tz-index: 1;\n\tpointer-events: none;\n\tpadding: 20px;\n\tcolor: rgba(0, 0, 0, 0.5);\n}\n\n.ReactTable .-loading {\n\tdisplay: block;\n\tposition: absolute;\n\tleft: 0;\n\tright: 0;\n\ttop: 0;\n\tbottom: 0;\n\tbackground: rgba(255, 255, 255, 0.8);\n\ttransition: all 0.3s ease;\n\tz-index: -1;\n\topacity: 0;\n\tpointer-events: none;\n}\n\n.ReactTable .-loading > div {\n\tposition: absolute;\n\tdisplay: block;\n\ttext-align: center;\n\twidth: 100%;\n\ttop: 50%;\n\tleft: 0;\n\tfont-size: 15px;\n\tcolor: rgba(0, 0, 0, 0.6);\n\t-webkit-transform: translateY(-52%);\n\ttransform: translateY(-52%);\n\ttransition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);\n}\n\n.ReactTable .-loading.-active {\n\topacity: 1;\n\tz-index: 2;\n\tpointer-events: all;\n}\n\n.ReactTable .-loading.-active > div {\n\t-webkit-transform: translateY(50%);\n\ttransform: translateY(50%);\n}\n\n.ReactTable .rt-resizing .rt-th,\n.ReactTable .rt-resizing .rt-td {\n\ttransition: none !important;\n\tcursor: col-resize;\n\t-webkit-user-select: none;\n\t-moz-user-select: none;\n\t-ms-user-select: none;\n\tuser-select: none;\n}\n\n.ReactTable .rt-thead .rt-th:focus {\n\toutline: none;\n}\n\n.ReactTable .rt-thead .rt-th {\n\tfont-size: 14px;\n\tfont-weight: 600;\n\ttext-transform: uppercase;\n\tborder: 0;\n}\n\n.ReactTable .rt-table {\n\tborder: 1px solid #dee2e6;\n}\n\n.ReactTable .rt-table .rt-td {\n\tborder-top: 1px solid #dee2e6;\n\tborder-right: 1px solid #dee2e6;\n\ttext-align: center;\n}\n\n.ReactTable .rt-table .rt-td.-check-box {\n\tmax-width: 40px;\n}\n\n.ReactTable .btn.btn-icon {\n\tmargin: 0 3px;\n\tpadding: 5px 8px;\n}\n\n.react-tagsinput {\n\tdisplay: inline-block;\n\tpadding: 4px 6px;\n\tmax-width: 100%;\n\tline-height: 22px;\n}\n\n.react-tagsinput-tag {\n\ttransition: all 0.17s linear;\n\tcursor: pointer;\n\tmargin: 5px 3px 5px 0;\n\tposition: relative;\n\tpadding: 4px 8px 3px 0.8em;\n\tborder-radius: 12px;\n\tcolor: #fff;\n\tfont-size: 0.75em;\n\tfont-weight: 500;\n\tdisplay: inline-block;\n\tline-height: 1.5em;\n\ttext-transform: uppercase;\n\tborder: 1px solid;\n}\n\n.react-tagsinput-remove {\n\tcursor: pointer;\n\tfont-weight: bold;\n}\n\n.react-tagsinput-tag a::before {\n\tfont-family: \"nucleo-icons\";\n\tcontent: \"\\ea4f\";\n\tpadding: 0px 2px;\n}\n\n.react-tagsinput-tag a {\n\tcursor: pointer;\n\tposition: absolute;\n\ttop: 3px;\n\tright: 0px;\n\topacity: 0;\n\tbackground-color: transparent;\n}\n\n.react-tagsinput-input {\n\tbackground: transparent;\n\tborder: 0;\n\tcolor: #777;\n\tfont-family: sans-serif;\n\tfont-size: 13px;\n\tfont-weight: 400;\n\tmargin-bottom: 6px;\n\tmargin-top: 1px;\n\toutline: none;\n\tpadding: 5px;\n\twidth: 80px;\n}\n\n.react-tagsinput .react-tagsinput-tag {\n\t-webkit-transition: all 300ms ease 0s;\n\t-moz-transition: all 300ms ease 0s;\n\t-o-transition: all 300ms ease 0s;\n\t-ms-transition: all 300ms ease 0s;\n\ttransition: all 300ms ease 0s;\n\tborder-color: #65adff;\n\tbackground-color: #65adff;\n}\n.react-tagsinput .react-tagsinput-tag:hover {\n\tpadding-right: 22px;\n}\n.react-tagsinput .react-tagsinput-tag:hover a {\n\topacity: 1;\n\tpadding-right: 4px;\n}\n.react-tagsinput .react-tagsinput-tag.primary {\n\tborder-color: #1c77c3;\n\tbackground-color: #1c77c3;\n}\n.react-tagsinput .react-tagsinput-tag.info {\n\tborder-color: #39a9db;\n\tbackground-color: #39a9db;\n}\n.react-tagsinput .react-tagsinput-tag.success {\n\tborder-color: #28a745;\n\tbackground-color: #28a745;\n}\n.react-tagsinput .react-tagsinput-tag.warning {\n\tborder-color: #ffc759;\n\tbackground-color: #ffc759;\n}\n.react-tagsinput .react-tagsinput-tag.danger {\n\tborder-color: #c1292e;\n\tbackground-color: #c1292e;\n}\n.react-tagsinput .react-tagsinput-tag.neutral {\n\tborder-color: #ffffff;\n\tbackground-color: #ffffff;\n\tcolor: inherit;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
